/*! For license information please see _main.js.LICENSE.txt */
(() => {
    var t = {
        422: t => {
            var e = /^(?:submit|button|image|reset|file)$/i,
                i = /^(?:input|select|textarea|keygen)/i,
                r = /(\[[^\[\]]*\])/g;

            function n(t, e, i) {
                if (0 === e.length) return t = i;
                var r = e.shift(),
                    a = r.match(/^\[(.+?)\]$/);
                if ("[]" === r) return t = t || [], Array.isArray(t) ? t.push(n(null, e, i)) : (t._values = t._values || [], t._values.push(n(null, e, i))), t;
                if (a) {
                    var s = a[1],
                        o = +s;
                    isNaN(o) ? (t = t || {})[s] = n(t[s], e, i) : (t = t || [])[o] = n(t[o], e, i)
                } else t[r] = n(t[r], e, i);
                return t
            }

            function a(t, e, i) {
                if (e.match(r)) {
                    n(t, function (t) {
                        var e = [],
                            i = new RegExp(r),
                            n = /^([^\[\]]*)/.exec(t);
                        for (n[1] && e.push(n[1]); null !== (n = i.exec(t));) e.push(n[1]);
                        return e
                    }(e), i)
                } else {
                    var a = t[e];
                    a ? (Array.isArray(a) || (t[e] = [a]), t[e].push(i)) : t[e] = i
                }
                return t
            }

            function s(t, e, i) {
                return i = i.replace(/(\r)?\n/g, "\r\n"), i = (i = encodeURIComponent(i)).replace(/%20/g, "+"), t + (t ? "&" : "") + encodeURIComponent(e) + "=" + i
            }
            t.exports = function (t, r) {
                "object" != typeof r ? r = {
                    hash: !!r
                } : void 0 === r.hash && (r.hash = !0);
                for (var n = r.hash ? {} : "", o = r.serializer || (r.hash ? a : s), l = t && t.elements ? t.elements : [], c = Object.create(null), u = 0; u < l.length; ++u) {
                    var h = l[u];
                    if ((r.disabled || !h.disabled) && h.name && (i.test(h.nodeName) && !e.test(h.type))) {
                        var d = h.name,
                            p = h.value;
                        if ("checkbox" !== h.type && "radio" !== h.type || h.checked || (p = void 0), r.empty) {
                            if ("checkbox" !== h.type || h.checked || (p = ""), "radio" === h.type && (c[h.name] || h.checked ? h.checked && (c[h.name] = !0) : c[h.name] = !1), null == p && "radio" == h.type) continue
                        } else if (!p) continue;
                        if ("select-multiple" !== h.type) n = o(n, d, p);
                        else {
                            p = [];
                            for (var f = h.options, m = !1, g = 0; g < f.length; ++g) {
                                var v = f[g],
                                    y = r.empty && !v.value,
                                    b = v.value || y;
                                v.selected && b && (m = !0, n = r.hash && "[]" !== d.slice(d.length - 2) ? o(n, d + "[]", v.value) : o(n, d, v.value))
                            } !m && r.empty && (n = o(n, d, ""))
                        }
                    }
                }
                if (r.empty)
                    for (var d in c) c[d] || (n = o(n, d, ""));
                return n
            }
        },
        234: function (t, e, i) {
            "undefined" != typeof navigator && (t.exports = function () {
                "use strict";
                var t = "http://www.w3.org/2000/svg",
                    r = "",
                    n = !1,
                    a = -999999,
                    s = function (t) {
                        n = !!t
                    },
                    o = function () {
                        return n
                    },
                    l = function (t) {
                        r = t
                    },
                    c = function () {
                        return r
                    };

                function u(t) {
                    return document.createElement(t)
                }

                function h(t, e) {
                    var i, r, n = t.length;
                    for (i = 0; i < n; i += 1)
                        for (var a in r = t[i].prototype) Object.prototype.hasOwnProperty.call(r, a) && (e.prototype[a] = r[a])
                }

                function d(t, e) {
                    return Object.getOwnPropertyDescriptor(t, e)
                }

                function p(t) {
                    function e() { }
                    return e.prototype = t, e
                }
                var f = function () {
                    function t(t) {
                        this.audios = [], this.audioFactory = t, this._volume = 1, this._isMuted = !1
                    }
                    return t.prototype = {
                        addAudio: function (t) {
                            this.audios.push(t)
                        },
                        pause: function () {
                            var t, e = this.audios.length;
                            for (t = 0; t < e; t += 1) this.audios[t].pause()
                        },
                        resume: function () {
                            var t, e = this.audios.length;
                            for (t = 0; t < e; t += 1) this.audios[t].resume()
                        },
                        setRate: function (t) {
                            var e, i = this.audios.length;
                            for (e = 0; e < i; e += 1) this.audios[e].setRate(t)
                        },
                        createAudio: function (t) {
                            return this.audioFactory ? this.audioFactory(t) : window.Howl ? new window.Howl({
                                src: [t]
                            }) : {
                                isPlaying: !1,
                                play: function () {
                                    this.isPlaying = !0
                                },
                                seek: function () {
                                    this.isPlaying = !1
                                },
                                playing: function () { },
                                rate: function () { },
                                setVolume: function () { }
                            }
                        },
                        setAudioFactory: function (t) {
                            this.audioFactory = t
                        },
                        setVolume: function (t) {
                            this._volume = t, this._updateVolume()
                        },
                        mute: function () {
                            this._isMuted = !0, this._updateVolume()
                        },
                        unmute: function () {
                            this._isMuted = !1, this._updateVolume()
                        },
                        getVolume: function () {
                            return this._volume
                        },
                        _updateVolume: function () {
                            var t, e = this.audios.length;
                            for (t = 0; t < e; t += 1) this.audios[t].volume(this._volume * (this._isMuted ? 0 : 1))
                        }
                    },
                        function () {
                            return new t
                        }
                }(),
                    m = function () {
                        function t(t, e) {
                            var i, r = 0,
                                n = [];
                            switch (t) {
                                case "int16":
                                case "uint8c":
                                    i = 1;
                                    break;
                                default:
                                    i = 1.1
                            }
                            for (r = 0; r < e; r += 1) n.push(i);
                            return n
                        }

                        function e(e, i) {
                            return "float32" === e ? new Float32Array(i) : "int16" === e ? new Int16Array(i) : "uint8c" === e ? new Uint8ClampedArray(i) : t(e, i)
                        }
                        return "function" == typeof Uint8ClampedArray && "function" == typeof Float32Array ? e : t
                    }();

                function g(t) {
                    return Array.apply(null, {
                        length: t
                    })
                }

                function v(t) {
                    return v = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
                        return typeof t
                    } : function (t) {
                        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t
                    }, v(t)
                }
                var y = !0,
                    b = null,
                    _ = "",
                    w = /^((?!chrome|android).)*safari/i.test(navigator.userAgent),
                    A = Math.pow,
                    S = Math.sqrt,
                    k = Math.floor,
                    x = (Math.max, Math.min),
                    T = {};
                (function () {
                    var t, e = ["abs", "acos", "acosh", "asin", "asinh", "atan", "atanh", "atan2", "ceil", "cbrt", "expm1", "clz32", "cos", "cosh", "exp", "floor", "fround", "hypot", "imul", "log", "log1p", "log2", "log10", "max", "min", "pow", "random", "round", "sign", "sin", "sinh", "sqrt", "tan", "tanh", "trunc", "E", "LN10", "LN2", "LOG10E", "LOG2E", "PI", "SQRT1_2", "SQRT2"],
                        i = e.length;
                    for (t = 0; t < i; t += 1) T[e[t]] = Math[e[t]]
                })(), T.random = Math.random, T.abs = function (t) {
                    if ("object" === v(t) && t.length) {
                        var e, i = g(t.length),
                            r = t.length;
                        for (e = 0; e < r; e += 1) i[e] = Math.abs(t[e]);
                        return i
                    }
                    return Math.abs(t)
                };
                var E = 150,
                    M = Math.PI / 180,
                    C = .5519;

                function P(t) { }

                function D(t, e, i, r) {
                    this.type = t, this.currentTime = e, this.totalTime = i, this.direction = r < 0 ? -1 : 1
                }

                function L(t, e) {
                    this.type = t, this.direction = e < 0 ? -1 : 1
                }

                function O(t, e, i, r) {
                    this.type = t, this.currentLoop = i, this.totalLoops = e, this.direction = r < 0 ? -1 : 1
                }

                function I(t, e, i) {
                    this.type = t, this.firstFrame = e, this.totalFrames = i
                }

                function R(t, e) {
                    this.type = t, this.target = e
                }

                function F(t, e) {
                    this.type = "renderFrameError", this.nativeError = t, this.currentTime = e
                }

                function N(t) {
                    this.type = "configError", this.nativeError = t
                }
                var B, z = (B = 0, function () {
                    return _ + "__lottie_element_" + (B += 1)
                });

                function q(t, e, i) {
                    var r, n, a, s, o, l, c, u;
                    switch (l = i * (1 - e), c = i * (1 - (o = 6 * t - (s = Math.floor(6 * t))) * e), u = i * (1 - (1 - o) * e), s % 6) {
                        case 0:
                            r = i, n = u, a = l;
                            break;
                        case 1:
                            r = c, n = i, a = l;
                            break;
                        case 2:
                            r = l, n = i, a = u;
                            break;
                        case 3:
                            r = l, n = c, a = i;
                            break;
                        case 4:
                            r = u, n = l, a = i;
                            break;
                        case 5:
                            r = i, n = l, a = c
                    }
                    return [r, n, a]
                }

                function V(t, e, i) {
                    var r, n = Math.max(t, e, i),
                        a = Math.min(t, e, i),
                        s = n - a,
                        o = 0 === n ? 0 : s / n,
                        l = n / 255;
                    switch (n) {
                        case a:
                            r = 0;
                            break;
                        case t:
                            r = e - i + s * (e < i ? 6 : 0), r /= 6 * s;
                            break;
                        case e:
                            r = i - t + 2 * s, r /= 6 * s;
                            break;
                        case i:
                            r = t - e + 4 * s, r /= 6 * s
                    }
                    return [r, o, l]
                }

                function Y(t, e) {
                    var i = V(255 * t[0], 255 * t[1], 255 * t[2]);
                    return i[1] += e, i[1] > 1 ? i[1] = 1 : i[1] <= 0 && (i[1] = 0), q(i[0], i[1], i[2])
                }

                function j(t, e) {
                    var i = V(255 * t[0], 255 * t[1], 255 * t[2]);
                    return i[2] += e, i[2] > 1 ? i[2] = 1 : i[2] < 0 && (i[2] = 0), q(i[0], i[1], i[2])
                }

                function G(t, e) {
                    var i = V(255 * t[0], 255 * t[1], 255 * t[2]);
                    return i[0] += e / 360, i[0] > 1 ? i[0] -= 1 : i[0] < 0 && (i[0] += 1), q(i[0], i[1], i[2])
                } ! function () {
                    var t, e, i = [];
                    for (t = 0; t < 256; t += 1) e = t.toString(16), i[t] = 1 === e.length ? "0" + e : e
                }();
                var H = function (t) {
                    y = !!t
                },
                    W = function () {
                        return y
                    },
                    Z = function (t) {
                        b = t
                    },
                    $ = function () {
                        return b
                    },
                    U = function (t) {
                        E = t
                    },
                    X = function () {
                        return E
                    },
                    K = function (t) {
                        _ = t
                    };

                function J(e) {
                    return document.createElementNS(t, e)
                }

                function Q(t) {
                    return Q = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
                        return typeof t
                    } : function (t) {
                        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t
                    }, Q(t)
                }
                var tt = function () {
                    var t, e, i = 1,
                        r = [],
                        n = {
                            onmessage: function () { },
                            postMessage: function (e) {
                                t({
                                    data: e
                                })
                            }
                        },
                        a = {
                            postMessage: function (t) {
                                n.onmessage({
                                    data: t
                                })
                            }
                        };

                    function s(e) {
                        if (window.Worker && window.Blob && o()) {
                            var i = new Blob(["var _workerSelf = self; self.onmessage = ", e.toString()], {
                                type: "text/javascript"
                            }),
                                r = URL.createObjectURL(i);
                            return new Worker(r)
                        }
                        return t = e, n
                    }

                    function l() {
                        e || (e = s((function (t) {
                            function e() {
                                function t(e, i) {
                                    var s, o, l, c, u, h, d = e.length;
                                    for (o = 0; o < d; o += 1)
                                        if ("ks" in (s = e[o]) && !s.completed) {
                                            if (s.completed = !0, s.tt && (e[o - 1].td = s.tt), s.hasMask) {
                                                var p = s.masksProperties;
                                                for (c = p.length, l = 0; l < c; l += 1)
                                                    if (p[l].pt.k.i) a(p[l].pt.k);
                                                    else
                                                        for (h = p[l].pt.k.length, u = 0; u < h; u += 1) p[l].pt.k[u].s && a(p[l].pt.k[u].s[0]), p[l].pt.k[u].e && a(p[l].pt.k[u].e[0])
                                            }
                                            0 === s.ty ? (s.layers = r(s.refId, i), t(s.layers, i)) : 4 === s.ty ? n(s.shapes) : 5 === s.ty && f(s)
                                        }
                                }

                                function e(e, i) {
                                    if (e) {
                                        var n = 0,
                                            a = e.length;
                                        for (n = 0; n < a; n += 1) 1 === e[n].t && (e[n].data.layers = r(e[n].data.refId, i), t(e[n].data.layers, i))
                                    }
                                }

                                function i(t, e) {
                                    for (var i = 0, r = e.length; i < r;) {
                                        if (e[i].id === t) return e[i];
                                        i += 1
                                    }
                                    return null
                                }

                                function r(t, e) {
                                    var r = i(t, e);
                                    return r ? r.layers.__used ? JSON.parse(JSON.stringify(r.layers)) : (r.layers.__used = !0, r.layers) : null
                                }

                                function n(t) {
                                    var e, i, r;
                                    for (e = t.length - 1; e >= 0; e -= 1)
                                        if ("sh" === t[e].ty)
                                            if (t[e].ks.k.i) a(t[e].ks.k);
                                            else
                                                for (r = t[e].ks.k.length, i = 0; i < r; i += 1) t[e].ks.k[i].s && a(t[e].ks.k[i].s[0]), t[e].ks.k[i].e && a(t[e].ks.k[i].e[0]);
                                        else "gr" === t[e].ty && n(t[e].it)
                                }

                                function a(t) {
                                    var e, i = t.i.length;
                                    for (e = 0; e < i; e += 1) t.i[e][0] += t.v[e][0], t.i[e][1] += t.v[e][1], t.o[e][0] += t.v[e][0], t.o[e][1] += t.v[e][1]
                                }

                                function s(t, e) {
                                    var i = e ? e.split(".") : [100, 100, 100];
                                    return t[0] > i[0] || !(i[0] > t[0]) && (t[1] > i[1] || !(i[1] > t[1]) && (t[2] > i[2] || !(i[2] > t[2]) && null))
                                }
                                var o, l = function () {
                                    var t = [4, 4, 14];

                                    function e(t) {
                                        var e = t.t.d;
                                        t.t.d = {
                                            k: [{
                                                s: e,
                                                t: 0
                                            }]
                                        }
                                    }

                                    function i(t) {
                                        var i, r = t.length;
                                        for (i = 0; i < r; i += 1) 5 === t[i].ty && e(t[i])
                                    }
                                    return function (e) {
                                        if (s(t, e.v) && (i(e.layers), e.assets)) {
                                            var r, n = e.assets.length;
                                            for (r = 0; r < n; r += 1) e.assets[r].layers && i(e.assets[r].layers)
                                        }
                                    }
                                }(),
                                    c = (o = [4, 7, 99], function (t) {
                                        if (t.chars && !s(o, t.v)) {
                                            var e, i = t.chars.length;
                                            for (e = 0; e < i; e += 1) {
                                                var r = t.chars[e];
                                                r.data && r.data.shapes && (n(r.data.shapes), r.data.ip = 0, r.data.op = 99999, r.data.st = 0, r.data.sr = 1, r.data.ks = {
                                                    p: {
                                                        k: [0, 0],
                                                        a: 0
                                                    },
                                                    s: {
                                                        k: [100, 100],
                                                        a: 0
                                                    },
                                                    a: {
                                                        k: [0, 0],
                                                        a: 0
                                                    },
                                                    r: {
                                                        k: 0,
                                                        a: 0
                                                    },
                                                    o: {
                                                        k: 100,
                                                        a: 0
                                                    }
                                                }, t.chars[e].t || (r.data.shapes.push({
                                                    ty: "no"
                                                }), r.data.shapes[0].it.push({
                                                    p: {
                                                        k: [0, 0],
                                                        a: 0
                                                    },
                                                    s: {
                                                        k: [100, 100],
                                                        a: 0
                                                    },
                                                    a: {
                                                        k: [0, 0],
                                                        a: 0
                                                    },
                                                    r: {
                                                        k: 0,
                                                        a: 0
                                                    },
                                                    o: {
                                                        k: 100,
                                                        a: 0
                                                    },
                                                    sk: {
                                                        k: 0,
                                                        a: 0
                                                    },
                                                    sa: {
                                                        k: 0,
                                                        a: 0
                                                    },
                                                    ty: "tr"
                                                })))
                                            }
                                        }
                                    }),
                                    u = function () {
                                        var t = [5, 7, 15];

                                        function e(t) {
                                            var e = t.t.p;
                                            "number" == typeof e.a && (e.a = {
                                                a: 0,
                                                k: e.a
                                            }), "number" == typeof e.p && (e.p = {
                                                a: 0,
                                                k: e.p
                                            }), "number" == typeof e.r && (e.r = {
                                                a: 0,
                                                k: e.r
                                            })
                                        }

                                        function i(t) {
                                            var i, r = t.length;
                                            for (i = 0; i < r; i += 1) 5 === t[i].ty && e(t[i])
                                        }
                                        return function (e) {
                                            if (s(t, e.v) && (i(e.layers), e.assets)) {
                                                var r, n = e.assets.length;
                                                for (r = 0; r < n; r += 1) e.assets[r].layers && i(e.assets[r].layers)
                                            }
                                        }
                                    }(),
                                    h = function () {
                                        var t = [4, 1, 9];

                                        function e(t) {
                                            var i, r, n, a = t.length;
                                            for (i = 0; i < a; i += 1)
                                                if ("gr" === t[i].ty) e(t[i].it);
                                                else if ("fl" === t[i].ty || "st" === t[i].ty)
                                                    if (t[i].c.k && t[i].c.k[0].i)
                                                        for (n = t[i].c.k.length, r = 0; r < n; r += 1) t[i].c.k[r].s && (t[i].c.k[r].s[0] /= 255, t[i].c.k[r].s[1] /= 255, t[i].c.k[r].s[2] /= 255, t[i].c.k[r].s[3] /= 255), t[i].c.k[r].e && (t[i].c.k[r].e[0] /= 255, t[i].c.k[r].e[1] /= 255, t[i].c.k[r].e[2] /= 255, t[i].c.k[r].e[3] /= 255);
                                                    else t[i].c.k[0] /= 255, t[i].c.k[1] /= 255, t[i].c.k[2] /= 255, t[i].c.k[3] /= 255
                                        }

                                        function i(t) {
                                            var i, r = t.length;
                                            for (i = 0; i < r; i += 1) 4 === t[i].ty && e(t[i].shapes)
                                        }
                                        return function (e) {
                                            if (s(t, e.v) && (i(e.layers), e.assets)) {
                                                var r, n = e.assets.length;
                                                for (r = 0; r < n; r += 1) e.assets[r].layers && i(e.assets[r].layers)
                                            }
                                        }
                                    }(),
                                    d = function () {
                                        var t = [4, 4, 18];

                                        function e(t) {
                                            var i, r, n;
                                            for (i = t.length - 1; i >= 0; i -= 1)
                                                if ("sh" === t[i].ty)
                                                    if (t[i].ks.k.i) t[i].ks.k.c = t[i].closed;
                                                    else
                                                        for (n = t[i].ks.k.length, r = 0; r < n; r += 1) t[i].ks.k[r].s && (t[i].ks.k[r].s[0].c = t[i].closed), t[i].ks.k[r].e && (t[i].ks.k[r].e[0].c = t[i].closed);
                                                else "gr" === t[i].ty && e(t[i].it)
                                        }

                                        function i(t) {
                                            var i, r, n, a, s, o, l = t.length;
                                            for (r = 0; r < l; r += 1) {
                                                if ((i = t[r]).hasMask) {
                                                    var c = i.masksProperties;
                                                    for (a = c.length, n = 0; n < a; n += 1)
                                                        if (c[n].pt.k.i) c[n].pt.k.c = c[n].cl;
                                                        else
                                                            for (o = c[n].pt.k.length, s = 0; s < o; s += 1) c[n].pt.k[s].s && (c[n].pt.k[s].s[0].c = c[n].cl), c[n].pt.k[s].e && (c[n].pt.k[s].e[0].c = c[n].cl)
                                                }
                                                4 === i.ty && e(i.shapes)
                                            }
                                        }
                                        return function (e) {
                                            if (s(t, e.v) && (i(e.layers), e.assets)) {
                                                var r, n = e.assets.length;
                                                for (r = 0; r < n; r += 1) e.assets[r].layers && i(e.assets[r].layers)
                                            }
                                        }
                                    }();

                                function p(i) {
                                    i.__complete || (h(i), l(i), c(i), u(i), d(i), t(i.layers, i.assets), e(i.chars, i.assets), i.__complete = !0)
                                }

                                function f(t) {
                                    0 === t.t.a.length && t.t.p
                                }
                                var m = {};
                                return m.completeData = p, m.checkColors = h, m.checkChars = c, m.checkPathProperties = u, m.checkShapes = d, m.completeLayers = t, m
                            }
                            if (a.dataManager || (a.dataManager = e()), a.assetLoader || (a.assetLoader = function () {
                                function t(t) {
                                    var e = t.getResponseHeader("content-type");
                                    return e && "json" === t.responseType && -1 !== e.indexOf("json") || t.response && "object" === Q(t.response) ? t.response : t.response && "string" == typeof t.response ? JSON.parse(t.response) : t.responseText ? JSON.parse(t.responseText) : null
                                }

                                function e(e, i, r, n) {
                                    var a, s = new XMLHttpRequest;
                                    try {
                                        s.responseType = "json"
                                    } catch (t) { }
                                    s.onreadystatechange = function () {
                                        if (4 === s.readyState)
                                            if (200 === s.status) a = t(s), r(a);
                                            else try {
                                                a = t(s), r(a)
                                            } catch (t) {
                                                n && n(t)
                                            }
                                    };
                                    try {
                                        s.open("GET", e, !0)
                                    } catch (t) {
                                        s.open("GET", i + "/" + e, !0)
                                    }
                                    s.send()
                                }
                                return {
                                    load: e
                                }
                            }()), "loadAnimation" === t.data.type) a.assetLoader.load(t.data.path, t.data.fullPath, (function (e) {
                                a.dataManager.completeData(e), a.postMessage({
                                    id: t.data.id,
                                    payload: e,
                                    status: "success"
                                })
                            }), (function () {
                                a.postMessage({
                                    id: t.data.id,
                                    status: "error"
                                })
                            }));
                            else if ("complete" === t.data.type) {
                                var i = t.data.animation;
                                a.dataManager.completeData(i), a.postMessage({
                                    id: t.data.id,
                                    payload: i,
                                    status: "success"
                                })
                            } else "loadData" === t.data.type && a.assetLoader.load(t.data.path, t.data.fullPath, (function (e) {
                                a.postMessage({
                                    id: t.data.id,
                                    payload: e,
                                    status: "success"
                                })
                            }), (function () {
                                a.postMessage({
                                    id: t.data.id,
                                    status: "error"
                                })
                            }))
                        })), e.onmessage = function (t) {
                            var e = t.data,
                                i = e.id,
                                n = r[i];
                            r[i] = null, "success" === e.status ? n.onComplete(e.payload) : n.onError && n.onError()
                        })
                    }

                    function c(t, e) {
                        var n = "processId_" + (i += 1);
                        return r[n] = {
                            onComplete: t,
                            onError: e
                        }, n
                    }

                    function u(t, i, r) {
                        l();
                        var n = c(i, r);
                        e.postMessage({
                            type: "loadAnimation",
                            path: t,
                            fullPath: window.location.origin + window.location.pathname,
                            id: n
                        })
                    }

                    function h(t, i, r) {
                        l();
                        var n = c(i, r);
                        e.postMessage({
                            type: "loadData",
                            path: t,
                            fullPath: window.location.origin + window.location.pathname,
                            id: n
                        })
                    }

                    function d(t, i, r) {
                        l();
                        var n = c(i, r);
                        e.postMessage({
                            type: "complete",
                            animation: t,
                            id: n
                        })
                    }
                    return {
                        loadAnimation: u,
                        loadData: h,
                        completeAnimation: d
                    }
                }(),
                    et = function () {
                        var t = function () {
                            var t = u("canvas");
                            t.width = 1, t.height = 1;
                            var e = t.getContext("2d");
                            return e.fillStyle = "rgba(0,0,0,0)", e.fillRect(0, 0, 1, 1), t
                        }();

                        function e() {
                            this.loadedAssets += 1, this.loadedAssets === this.totalImages && this.loadedFootagesCount === this.totalFootages && this.imagesLoadedCb && this.imagesLoadedCb(null)
                        }

                        function i() {
                            this.loadedFootagesCount += 1, this.loadedAssets === this.totalImages && this.loadedFootagesCount === this.totalFootages && this.imagesLoadedCb && this.imagesLoadedCb(null)
                        }

                        function r(t, e, i) {
                            var r = "";
                            if (t.e) r = t.p;
                            else if (e) {
                                var n = t.p; - 1 !== n.indexOf("images/") && (n = n.split("/")[1]), r = e + n
                            } else r = i, r += t.u ? t.u : "", r += t.p;
                            return r
                        }

                        function n(t) {
                            var e = 0,
                                i = setInterval(function () {
                                    (t.getBBox().width || e > 500) && (this._imageLoaded(), clearInterval(i)), e += 1
                                }.bind(this), 50)
                        }

                        function a(e) {
                            var i = r(e, this.assetsPath, this.path),
                                n = J("image");
                            w ? this.testImageLoaded(n) : n.addEventListener("load", this._imageLoaded, !1), n.addEventListener("error", function () {
                                a.img = t, this._imageLoaded()
                            }.bind(this), !1), n.setAttributeNS("http://www.w3.org/1999/xlink", "href", i), this._elementHelper.append ? this._elementHelper.append(n) : this._elementHelper.appendChild(n);
                            var a = {
                                img: n,
                                assetData: e
                            };
                            return a
                        }

                        function s(e) {
                            var i = r(e, this.assetsPath, this.path),
                                n = u("img");
                            n.crossOrigin = "anonymous", n.addEventListener("load", this._imageLoaded, !1), n.addEventListener("error", function () {
                                a.img = t, this._imageLoaded()
                            }.bind(this), !1), n.src = i;
                            var a = {
                                img: n,
                                assetData: e
                            };
                            return a
                        }

                        function o(t) {
                            var e = {
                                assetData: t
                            },
                                i = r(t, this.assetsPath, this.path);
                            return tt.loadData(i, function (t) {
                                e.img = t, this._footageLoaded()
                            }.bind(this), function () {
                                e.img = {}, this._footageLoaded()
                            }.bind(this)), e
                        }

                        function l(t, e) {
                            var i;
                            this.imagesLoadedCb = e;
                            var r = t.length;
                            for (i = 0; i < r; i += 1) t[i].layers || (t[i].t && "seq" !== t[i].t ? 3 === t[i].t && (this.totalFootages += 1, this.images.push(this.createFootageData(t[i]))) : (this.totalImages += 1, this.images.push(this._createImageData(t[i]))))
                        }

                        function c(t) {
                            this.path = t || ""
                        }

                        function h(t) {
                            this.assetsPath = t || ""
                        }

                        function d(t) {
                            for (var e = 0, i = this.images.length; e < i;) {
                                if (this.images[e].assetData === t) return this.images[e].img;
                                e += 1
                            }
                            return null
                        }

                        function p() {
                            this.imagesLoadedCb = null, this.images.length = 0
                        }

                        function f() {
                            return this.totalImages === this.loadedAssets
                        }

                        function m() {
                            return this.totalFootages === this.loadedFootagesCount
                        }

                        function g(t, e) {
                            "svg" === t ? (this._elementHelper = e, this._createImageData = this.createImageData.bind(this)) : this._createImageData = this.createImgData.bind(this)
                        }

                        function v() {
                            this._imageLoaded = e.bind(this), this._footageLoaded = i.bind(this), this.testImageLoaded = n.bind(this), this.createFootageData = o.bind(this), this.assetsPath = "", this.path = "", this.totalImages = 0, this.totalFootages = 0, this.loadedAssets = 0, this.loadedFootagesCount = 0, this.imagesLoadedCb = null, this.images = []
                        }
                        return v.prototype = {
                            loadAssets: l,
                            setAssetsPath: h,
                            setPath: c,
                            loadedImages: f,
                            loadedFootages: m,
                            destroy: p,
                            getAsset: d,
                            createImgData: s,
                            createImageData: a,
                            imageLoaded: e,
                            footageLoaded: i,
                            setCacheType: g
                        }, v
                    }();

                function it() { }
                it.prototype = {
                    triggerEvent: function (t, e) {
                        if (this._cbs[t])
                            for (var i = this._cbs[t], r = 0; r < i.length; r += 1) i[r](e)
                    },
                    addEventListener: function (t, e) {
                        return this._cbs[t] || (this._cbs[t] = []), this._cbs[t].push(e),
                            function () {
                                this.removeEventListener(t, e)
                            }.bind(this)
                    },
                    removeEventListener: function (t, e) {
                        if (e) {
                            if (this._cbs[t]) {
                                for (var i = 0, r = this._cbs[t].length; i < r;) this._cbs[t][i] === e && (this._cbs[t].splice(i, 1), i -= 1, r -= 1), i += 1;
                                this._cbs[t].length || (this._cbs[t] = null)
                            }
                        } else this._cbs[t] = null
                    }
                };
                var rt = function () {
                    function t(t) {
                        for (var e, i = t.split("\r\n"), r = {}, n = 0, a = 0; a < i.length; a += 1) 2 === (e = i[a].split(":")).length && (r[e[0]] = e[1].trim(), n += 1);
                        if (0 === n) throw new Error;
                        return r
                    }
                    return function (e) {
                        for (var i = [], r = 0; r < e.length; r += 1) {
                            var n = e[r],
                                a = {
                                    time: n.tm,
                                    duration: n.dr
                                };
                            try {
                                a.payload = JSON.parse(e[r].cm)
                            } catch (i) {
                                try {
                                    a.payload = t(e[r].cm)
                                } catch (t) {
                                    a.payload = {
                                        name: e[r].cm
                                    }
                                }
                            }
                            i.push(a)
                        }
                        return i
                    }
                }(),
                    nt = function () {
                        function t(t) {
                            this.compositions.push(t)
                        }
                        return function () {
                            function e(t) {
                                for (var e = 0, i = this.compositions.length; e < i;) {
                                    if (this.compositions[e].data && this.compositions[e].data.nm === t) return this.compositions[e].prepareFrame && this.compositions[e].data.xt && this.compositions[e].prepareFrame(this.currentFrame), this.compositions[e].compInterface;
                                    e += 1
                                }
                                return null
                            }
                            return e.compositions = [], e.currentFrame = 0, e.registerComposition = t, e
                        }
                    }(),
                    at = {},
                    st = function (t, e) {
                        at[t] = e
                    };

                function ot(t) {
                    return at[t]
                }

                function lt(t) {
                    return lt = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
                        return typeof t
                    } : function (t) {
                        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t
                    }, lt(t)
                }
                var ct = function () {
                    this._cbs = [], this.name = "", this.path = "", this.isLoaded = !1, this.currentFrame = 0, this.currentRawFrame = 0, this.firstFrame = 0, this.totalFrames = 0, this.frameRate = 0, this.frameMult = 0, this.playSpeed = 1, this.playDirection = 1, this.playCount = 0, this.animationData = {}, this.assets = [], this.isPaused = !0, this.autoplay = !1, this.loop = !0, this.renderer = null, this.animationID = z(), this.assetsPath = "", this.timeCompleted = 0, this.segmentPos = 0, this.isSubframeEnabled = W(), this.segments = [], this._idle = !0, this._completedLoop = !1, this.projectInterface = nt(), this.imagePreloader = new et, this.audioController = f(), this.markers = [], this.configAnimation = this.configAnimation.bind(this), this.onSetupError = this.onSetupError.bind(this), this.onSegmentComplete = this.onSegmentComplete.bind(this), this.drawnFrameEvent = new D("drawnFrame", 0, 0, 0)
                };
                h([it], ct), ct.prototype.setParams = function (t) {
                    (t.wrapper || t.container) && (this.wrapper = t.wrapper || t.container);
                    var e = "svg";
                    t.animType ? e = t.animType : t.renderer && (e = t.renderer);
                    var i = ot(e);
                    this.renderer = new i(this, t.rendererSettings), this.imagePreloader.setCacheType(e, this.renderer.globalData.defs), this.renderer.setProjectInterface(this.projectInterface), this.animType = e, "" === t.loop || null === t.loop || void 0 === t.loop || !0 === t.loop ? this.loop = !0 : !1 === t.loop ? this.loop = !1 : this.loop = parseInt(t.loop, 10), this.autoplay = !("autoplay" in t) || t.autoplay, this.name = t.name ? t.name : "", this.autoloadSegments = !Object.prototype.hasOwnProperty.call(t, "autoloadSegments") || t.autoloadSegments, this.assetsPath = t.assetsPath, this.initialSegment = t.initialSegment, t.audioFactory && this.audioController.setAudioFactory(t.audioFactory), t.animationData ? this.setupAnimation(t.animationData) : t.path && (-1 !== t.path.lastIndexOf("\\") ? this.path = t.path.substr(0, t.path.lastIndexOf("\\") + 1) : this.path = t.path.substr(0, t.path.lastIndexOf("/") + 1), this.fileName = t.path.substr(t.path.lastIndexOf("/") + 1), this.fileName = this.fileName.substr(0, this.fileName.lastIndexOf(".json")), tt.loadAnimation(t.path, this.configAnimation, this.onSetupError))
                }, ct.prototype.onSetupError = function () {
                    this.trigger("data_failed")
                }, ct.prototype.setupAnimation = function (t) {
                    tt.completeAnimation(t, this.configAnimation)
                }, ct.prototype.setData = function (t, e) {
                    e && "object" !== lt(e) && (e = JSON.parse(e));
                    var i = {
                        wrapper: t,
                        animationData: e
                    },
                        r = t.attributes;
                    i.path = r.getNamedItem("data-animation-path") ? r.getNamedItem("data-animation-path").value : r.getNamedItem("data-bm-path") ? r.getNamedItem("data-bm-path").value : r.getNamedItem("bm-path") ? r.getNamedItem("bm-path").value : "", i.animType = r.getNamedItem("data-anim-type") ? r.getNamedItem("data-anim-type").value : r.getNamedItem("data-bm-type") ? r.getNamedItem("data-bm-type").value : r.getNamedItem("bm-type") ? r.getNamedItem("bm-type").value : r.getNamedItem("data-bm-renderer") ? r.getNamedItem("data-bm-renderer").value : r.getNamedItem("bm-renderer") ? r.getNamedItem("bm-renderer").value : "canvas";
                    var n = r.getNamedItem("data-anim-loop") ? r.getNamedItem("data-anim-loop").value : r.getNamedItem("data-bm-loop") ? r.getNamedItem("data-bm-loop").value : r.getNamedItem("bm-loop") ? r.getNamedItem("bm-loop").value : "";
                    "false" === n ? i.loop = !1 : "true" === n ? i.loop = !0 : "" !== n && (i.loop = parseInt(n, 10));
                    var a = r.getNamedItem("data-anim-autoplay") ? r.getNamedItem("data-anim-autoplay").value : r.getNamedItem("data-bm-autoplay") ? r.getNamedItem("data-bm-autoplay").value : !r.getNamedItem("bm-autoplay") || r.getNamedItem("bm-autoplay").value;
                    i.autoplay = "false" !== a, i.name = r.getNamedItem("data-name") ? r.getNamedItem("data-name").value : r.getNamedItem("data-bm-name") ? r.getNamedItem("data-bm-name").value : r.getNamedItem("bm-name") ? r.getNamedItem("bm-name").value : "", "false" === (r.getNamedItem("data-anim-prerender") ? r.getNamedItem("data-anim-prerender").value : r.getNamedItem("data-bm-prerender") ? r.getNamedItem("data-bm-prerender").value : r.getNamedItem("bm-prerender") ? r.getNamedItem("bm-prerender").value : "") && (i.prerender = !1), this.setParams(i)
                }, ct.prototype.includeLayers = function (t) {
                    t.op > this.animationData.op && (this.animationData.op = t.op, this.totalFrames = Math.floor(t.op - this.animationData.ip));
                    var e, i, r = this.animationData.layers,
                        n = r.length,
                        a = t.layers,
                        s = a.length;
                    for (i = 0; i < s; i += 1)
                        for (e = 0; e < n;) {
                            if (r[e].id === a[i].id) {
                                r[e] = a[i];
                                break
                            }
                            e += 1
                        }
                    if ((t.chars || t.fonts) && (this.renderer.globalData.fontManager.addChars(t.chars), this.renderer.globalData.fontManager.addFonts(t.fonts, this.renderer.globalData.defs)), t.assets)
                        for (n = t.assets.length, e = 0; e < n; e += 1) this.animationData.assets.push(t.assets[e]);
                    this.animationData.__complete = !1, tt.completeAnimation(this.animationData, this.onSegmentComplete)
                }, ct.prototype.onSegmentComplete = function (t) {
                    this.animationData = t;
                    var e = $();
                    e && e.initExpressions(this), this.loadNextSegment()
                }, ct.prototype.loadNextSegment = function () {
                    var t = this.animationData.segments;
                    if (!t || 0 === t.length || !this.autoloadSegments) return this.trigger("data_ready"), void (this.timeCompleted = this.totalFrames);
                    var e = t.shift();
                    this.timeCompleted = e.time * this.frameRate;
                    var i = this.path + this.fileName + "_" + this.segmentPos + ".json";
                    this.segmentPos += 1, tt.loadData(i, this.includeLayers.bind(this), function () {
                        this.trigger("data_failed")
                    }.bind(this))
                }, ct.prototype.loadSegments = function () {
                    this.animationData.segments || (this.timeCompleted = this.totalFrames), this.loadNextSegment()
                }, ct.prototype.imagesLoaded = function () {
                    this.trigger("loaded_images"), this.checkLoaded()
                }, ct.prototype.preloadImages = function () {
                    this.imagePreloader.setAssetsPath(this.assetsPath), this.imagePreloader.setPath(this.path), this.imagePreloader.loadAssets(this.animationData.assets, this.imagesLoaded.bind(this))
                }, ct.prototype.configAnimation = function (t) {
                    if (this.renderer) try {
                        this.animationData = t, this.initialSegment ? (this.totalFrames = Math.floor(this.initialSegment[1] - this.initialSegment[0]), this.firstFrame = Math.round(this.initialSegment[0])) : (this.totalFrames = Math.floor(this.animationData.op - this.animationData.ip), this.firstFrame = Math.round(this.animationData.ip)), this.renderer.configAnimation(t), t.assets || (t.assets = []), this.assets = this.animationData.assets, this.frameRate = this.animationData.fr, this.frameMult = this.animationData.fr / 1e3, this.renderer.searchExtraCompositions(t.assets), this.markers = rt(t.markers || []), this.trigger("config_ready"), this.preloadImages(), this.loadSegments(), this.updaFrameModifier(), this.waitForFontsLoaded(), this.isPaused && this.audioController.pause()
                    } catch (t) {
                        this.triggerConfigError(t)
                    }
                }, ct.prototype.waitForFontsLoaded = function () {
                    this.renderer && (this.renderer.globalData.fontManager.isLoaded ? this.checkLoaded() : setTimeout(this.waitForFontsLoaded.bind(this), 20))
                }, ct.prototype.checkLoaded = function () {
                    if (!this.isLoaded && this.renderer.globalData.fontManager.isLoaded && (this.imagePreloader.loadedImages() || "canvas" !== this.renderer.rendererType) && this.imagePreloader.loadedFootages()) {
                        this.isLoaded = !0;
                        var t = $();
                        t && t.initExpressions(this), this.renderer.initItems(), setTimeout(function () {
                            this.trigger("DOMLoaded")
                        }.bind(this), 0), this.gotoFrame(), this.autoplay && this.play()
                    }
                }, ct.prototype.resize = function () {
                    this.renderer.updateContainerSize()
                }, ct.prototype.setSubframe = function (t) {
                    this.isSubframeEnabled = !!t
                }, ct.prototype.gotoFrame = function () {
                    this.currentFrame = this.isSubframeEnabled ? this.currentRawFrame : ~~this.currentRawFrame, this.timeCompleted !== this.totalFrames && this.currentFrame > this.timeCompleted && (this.currentFrame = this.timeCompleted), this.trigger("enterFrame"), this.renderFrame(), this.trigger("drawnFrame")
                }, ct.prototype.renderFrame = function () {
                    if (!1 !== this.isLoaded && this.renderer) try {
                        this.renderer.renderFrame(this.currentFrame + this.firstFrame)
                    } catch (t) {
                        this.triggerRenderFrameError(t)
                    }
                }, ct.prototype.play = function (t) {
                    t && this.name !== t || !0 === this.isPaused && (this.isPaused = !1, this.trigger("_pause"), this.audioController.resume(), this._idle && (this._idle = !1, this.trigger("_active")))
                }, ct.prototype.pause = function (t) {
                    t && this.name !== t || !1 === this.isPaused && (this.isPaused = !0, this.trigger("_play"), this._idle = !0, this.trigger("_idle"), this.audioController.pause())
                }, ct.prototype.togglePause = function (t) {
                    t && this.name !== t || (!0 === this.isPaused ? this.play() : this.pause())
                }, ct.prototype.stop = function (t) {
                    t && this.name !== t || (this.pause(), this.playCount = 0, this._completedLoop = !1, this.setCurrentRawFrameValue(0))
                }, ct.prototype.getMarkerData = function (t) {
                    for (var e, i = 0; i < this.markers.length; i += 1)
                        if ((e = this.markers[i]).payload && e.payload.name === t) return e;
                    return null
                }, ct.prototype.goToAndStop = function (t, e, i) {
                    if (!i || this.name === i) {
                        var r = Number(t);
                        if (isNaN(r)) {
                            var n = this.getMarkerData(t);
                            n && this.goToAndStop(n.time, !0)
                        } else e ? this.setCurrentRawFrameValue(t) : this.setCurrentRawFrameValue(t * this.frameModifier);
                        this.pause()
                    }
                }, ct.prototype.goToAndPlay = function (t, e, i) {
                    if (!i || this.name === i) {
                        var r = Number(t);
                        if (isNaN(r)) {
                            var n = this.getMarkerData(t);
                            n && (n.duration ? this.playSegments([n.time, n.time + n.duration], !0) : this.goToAndStop(n.time, !0))
                        } else this.goToAndStop(r, e, i);
                        this.play()
                    }
                }, ct.prototype.advanceTime = function (t) {
                    if (!0 !== this.isPaused && !1 !== this.isLoaded) {
                        var e = this.currentRawFrame + t * this.frameModifier,
                            i = !1;
                        e >= this.totalFrames - 1 && this.frameModifier > 0 ? this.loop && this.playCount !== this.loop ? e >= this.totalFrames ? (this.playCount += 1, this.checkSegments(e % this.totalFrames) || (this.setCurrentRawFrameValue(e % this.totalFrames), this._completedLoop = !0, this.trigger("loopComplete"))) : this.setCurrentRawFrameValue(e) : this.checkSegments(e > this.totalFrames ? e % this.totalFrames : 0) || (i = !0, e = this.totalFrames - 1) : e < 0 ? this.checkSegments(e % this.totalFrames) || (!this.loop || this.playCount-- <= 0 && !0 !== this.loop ? (i = !0, e = 0) : (this.setCurrentRawFrameValue(this.totalFrames + e % this.totalFrames), this._completedLoop ? this.trigger("loopComplete") : this._completedLoop = !0)) : this.setCurrentRawFrameValue(e), i && (this.setCurrentRawFrameValue(e), this.pause(), this.trigger("complete"))
                    }
                }, ct.prototype.adjustSegment = function (t, e) {
                    this.playCount = 0, t[1] < t[0] ? (this.frameModifier > 0 && (this.playSpeed < 0 ? this.setSpeed(-this.playSpeed) : this.setDirection(-1)), this.totalFrames = t[0] - t[1], this.timeCompleted = this.totalFrames, this.firstFrame = t[1], this.setCurrentRawFrameValue(this.totalFrames - .001 - e)) : t[1] > t[0] && (this.frameModifier < 0 && (this.playSpeed < 0 ? this.setSpeed(-this.playSpeed) : this.setDirection(1)), this.totalFrames = t[1] - t[0], this.timeCompleted = this.totalFrames, this.firstFrame = t[0], this.setCurrentRawFrameValue(.001 + e)), this.trigger("segmentStart")
                }, ct.prototype.setSegment = function (t, e) {
                    var i = -1;
                    this.isPaused && (this.currentRawFrame + this.firstFrame < t ? i = t : this.currentRawFrame + this.firstFrame > e && (i = e - t)), this.firstFrame = t, this.totalFrames = e - t, this.timeCompleted = this.totalFrames, -1 !== i && this.goToAndStop(i, !0)
                }, ct.prototype.playSegments = function (t, e) {
                    if (e && (this.segments.length = 0), "object" === lt(t[0])) {
                        var i, r = t.length;
                        for (i = 0; i < r; i += 1) this.segments.push(t[i])
                    } else this.segments.push(t);
                    this.segments.length && e && this.adjustSegment(this.segments.shift(), 0), this.isPaused && this.play()
                }, ct.prototype.resetSegments = function (t) {
                    this.segments.length = 0, this.segments.push([this.animationData.ip, this.animationData.op]), t && this.checkSegments(0)
                }, ct.prototype.checkSegments = function (t) {
                    return !!this.segments.length && (this.adjustSegment(this.segments.shift(), t), !0)
                }, ct.prototype.destroy = function (t) {
                    t && this.name !== t || !this.renderer || (this.renderer.destroy(), this.imagePreloader.destroy(), this.trigger("destroy"), this._cbs = null, this.onEnterFrame = null, this.onLoopComplete = null, this.onComplete = null, this.onSegmentStart = null, this.onDestroy = null, this.renderer = null, this.renderer = null, this.imagePreloader = null, this.projectInterface = null)
                }, ct.prototype.setCurrentRawFrameValue = function (t) {
                    this.currentRawFrame = t, this.gotoFrame()
                }, ct.prototype.setSpeed = function (t) {
                    this.playSpeed = t, this.updaFrameModifier()
                }, ct.prototype.setDirection = function (t) {
                    this.playDirection = t < 0 ? -1 : 1, this.updaFrameModifier()
                }, ct.prototype.setVolume = function (t, e) {
                    e && this.name !== e || this.audioController.setVolume(t)
                }, ct.prototype.getVolume = function () {
                    return this.audioController.getVolume()
                }, ct.prototype.mute = function (t) {
                    t && this.name !== t || this.audioController.mute()
                }, ct.prototype.unmute = function (t) {
                    t && this.name !== t || this.audioController.unmute()
                }, ct.prototype.updaFrameModifier = function () {
                    this.frameModifier = this.frameMult * this.playSpeed * this.playDirection, this.audioController.setRate(this.playSpeed * this.playDirection)
                }, ct.prototype.getPath = function () {
                    return this.path
                }, ct.prototype.getAssetsPath = function (t) {
                    var e = "";
                    if (t.e) e = t.p;
                    else if (this.assetsPath) {
                        var i = t.p; - 1 !== i.indexOf("images/") && (i = i.split("/")[1]), e = this.assetsPath + i
                    } else e = this.path, e += t.u ? t.u : "", e += t.p;
                    return e
                }, ct.prototype.getAssetData = function (t) {
                    for (var e = 0, i = this.assets.length; e < i;) {
                        if (t === this.assets[e].id) return this.assets[e];
                        e += 1
                    }
                    return null
                }, ct.prototype.hide = function () {
                    this.renderer.hide()
                }, ct.prototype.show = function () {
                    this.renderer.show()
                }, ct.prototype.getDuration = function (t) {
                    return t ? this.totalFrames : this.totalFrames / this.frameRate
                }, ct.prototype.updateDocumentData = function (t, e, i) {
                    try {
                        this.renderer.getElementByPath(t).updateDocumentData(e, i)
                    } catch (t) { }
                }, ct.prototype.trigger = function (t) {
                    if (this._cbs && this._cbs[t]) switch (t) {
                        case "enterFrame":
                            this.triggerEvent(t, new D(t, this.currentFrame, this.totalFrames, this.frameModifier));
                            break;
                        case "drawnFrame":
                            this.drawnFrameEvent.currentTime = this.currentFrame, this.drawnFrameEvent.totalTime = this.totalFrames, this.drawnFrameEvent.direction = this.frameModifier, this.triggerEvent(t, this.drawnFrameEvent);
                            break;
                        case "loopComplete":
                            this.triggerEvent(t, new O(t, this.loop, this.playCount, this.frameMult));
                            break;
                        case "complete":
                            this.triggerEvent(t, new L(t, this.frameMult));
                            break;
                        case "segmentStart":
                            this.triggerEvent(t, new I(t, this.firstFrame, this.totalFrames));
                            break;
                        case "destroy":
                            this.triggerEvent(t, new R(t, this));
                            break;
                        default:
                            this.triggerEvent(t)
                    }
                    "enterFrame" === t && this.onEnterFrame && this.onEnterFrame.call(this, new D(t, this.currentFrame, this.totalFrames, this.frameMult)), "loopComplete" === t && this.onLoopComplete && this.onLoopComplete.call(this, new O(t, this.loop, this.playCount, this.frameMult)), "complete" === t && this.onComplete && this.onComplete.call(this, new L(t, this.frameMult)), "segmentStart" === t && this.onSegmentStart && this.onSegmentStart.call(this, new I(t, this.firstFrame, this.totalFrames)), "destroy" === t && this.onDestroy && this.onDestroy.call(this, new R(t, this))
                }, ct.prototype.triggerRenderFrameError = function (t) {
                    var e = new F(t, this.currentFrame);
                    this.triggerEvent("error", e), this.onError && this.onError.call(this, e)
                }, ct.prototype.triggerConfigError = function (t) {
                    var e = new N(t, this.currentFrame);
                    this.triggerEvent("error", e), this.onError && this.onError.call(this, e)
                };
                var ut = function () {
                    var t = {},
                        e = [],
                        i = 0,
                        r = 0,
                        n = 0,
                        a = !0,
                        s = !1;

                    function o(t) {
                        for (var i = 0, n = t.target; i < r;) e[i].animation === n && (e.splice(i, 1), i -= 1, r -= 1, n.isPaused || d()), i += 1
                    }

                    function l(t, i) {
                        if (!t) return null;
                        for (var n = 0; n < r;) {
                            if (e[n].elem === t && null !== e[n].elem) return e[n].animation;
                            n += 1
                        }
                        var a = new ct;
                        return p(a, t), a.setData(t, i), a
                    }

                    function c() {
                        var t, i = e.length,
                            r = [];
                        for (t = 0; t < i; t += 1) r.push(e[t].animation);
                        return r
                    }

                    function h() {
                        n += 1, E()
                    }

                    function d() {
                        n -= 1
                    }

                    function p(t, i) {
                        t.addEventListener("destroy", o), t.addEventListener("_active", h), t.addEventListener("_idle", d), e.push({
                            elem: i,
                            animation: t
                        }), r += 1
                    }

                    function f(t) {
                        var e = new ct;
                        return p(e, null), e.setParams(t), e
                    }

                    function m(t, i) {
                        var n;
                        for (n = 0; n < r; n += 1) e[n].animation.setSpeed(t, i)
                    }

                    function g(t, i) {
                        var n;
                        for (n = 0; n < r; n += 1) e[n].animation.setDirection(t, i)
                    }

                    function v(t) {
                        var i;
                        for (i = 0; i < r; i += 1) e[i].animation.play(t)
                    }

                    function y(t) {
                        var o, l = t - i;
                        for (o = 0; o < r; o += 1) e[o].animation.advanceTime(l);
                        i = t, n && !s ? window.requestAnimationFrame(y) : a = !0
                    }

                    function b(t) {
                        i = t, window.requestAnimationFrame(y)
                    }

                    function _(t) {
                        var i;
                        for (i = 0; i < r; i += 1) e[i].animation.pause(t)
                    }

                    function w(t, i, n) {
                        var a;
                        for (a = 0; a < r; a += 1) e[a].animation.goToAndStop(t, i, n)
                    }

                    function A(t) {
                        var i;
                        for (i = 0; i < r; i += 1) e[i].animation.stop(t)
                    }

                    function S(t) {
                        var i;
                        for (i = 0; i < r; i += 1) e[i].animation.togglePause(t)
                    }

                    function k(t) {
                        var i;
                        for (i = r - 1; i >= 0; i -= 1) e[i].animation.destroy(t)
                    }

                    function x(t, e, i) {
                        var r, n = [].concat([].slice.call(document.getElementsByClassName("lottie")), [].slice.call(document.getElementsByClassName("bodymovin"))),
                            a = n.length;
                        for (r = 0; r < a; r += 1) i && n[r].setAttribute("data-bm-type", i), l(n[r], t);
                        if (e && 0 === a) {
                            i || (i = "svg");
                            var s = document.getElementsByTagName("body")[0];
                            s.innerText = "";
                            var o = u("div");
                            o.style.width = "100%", o.style.height = "100%", o.setAttribute("data-bm-type", i), s.appendChild(o), l(o, t)
                        }
                    }

                    function T() {
                        var t;
                        for (t = 0; t < r; t += 1) e[t].animation.resize()
                    }

                    function E() {
                        !s && n && a && (window.requestAnimationFrame(b), a = !1)
                    }

                    function M() {
                        s = !0
                    }

                    function C() {
                        s = !1, E()
                    }

                    function P(t, i) {
                        var n;
                        for (n = 0; n < r; n += 1) e[n].animation.setVolume(t, i)
                    }

                    function D(t) {
                        var i;
                        for (i = 0; i < r; i += 1) e[i].animation.mute(t)
                    }

                    function L(t) {
                        var i;
                        for (i = 0; i < r; i += 1) e[i].animation.unmute(t)
                    }
                    return t.registerAnimation = l, t.loadAnimation = f, t.setSpeed = m, t.setDirection = g, t.play = v, t.pause = _, t.stop = A, t.togglePause = S, t.searchAnimations = x, t.resize = T, t.goToAndStop = w, t.destroy = k, t.freeze = M, t.unfreeze = C, t.setVolume = P, t.mute = D, t.unmute = L, t.getRegisteredAnimations = c, t
                }(),
                    ht = function () {
                        var t = {};
                        t.getBezierEasing = i;
                        var e = {};

                        function i(t, i, r, n, a) {
                            var s = a || ("bez_" + t + "_" + i + "_" + r + "_" + n).replace(/\./g, "p");
                            if (e[s]) return e[s];
                            var o = new v([t, i, r, n]);
                            return e[s] = o, o
                        }
                        var r = 4,
                            n = .001,
                            a = 1e-7,
                            s = 10,
                            o = 11,
                            l = 1 / (o - 1),
                            c = "function" == typeof Float32Array;

                        function u(t, e) {
                            return 1 - 3 * e + 3 * t
                        }

                        function h(t, e) {
                            return 3 * e - 6 * t
                        }

                        function d(t) {
                            return 3 * t
                        }

                        function p(t, e, i) {
                            return ((u(e, i) * t + h(e, i)) * t + d(e)) * t
                        }

                        function f(t, e, i) {
                            return 3 * u(e, i) * t * t + 2 * h(e, i) * t + d(e)
                        }

                        function m(t, e, i, r, n) {
                            var o, l, c = 0;
                            do {
                                (o = p(l = e + (i - e) / 2, r, n) - t) > 0 ? i = l : e = l
                            } while (Math.abs(o) > a && ++c < s);
                            return l
                        }

                        function g(t, e, i, n) {
                            for (var a = 0; a < r; ++a) {
                                var s = f(e, i, n);
                                if (0 === s) return e;
                                e -= (p(e, i, n) - t) / s
                            }
                            return e
                        }

                        function v(t) {
                            this._p = t, this._mSampleValues = c ? new Float32Array(o) : new Array(o), this._precomputed = !1, this.get = this.get.bind(this)
                        }
                        return v.prototype = {
                            get: function (t) {
                                var e = this._p[0],
                                    i = this._p[1],
                                    r = this._p[2],
                                    n = this._p[3];
                                return this._precomputed || this._precompute(), e === i && r === n ? t : 0 === t ? 0 : 1 === t ? 1 : p(this._getTForX(t), i, n)
                            },
                            _precompute: function () {
                                var t = this._p[0],
                                    e = this._p[1],
                                    i = this._p[2],
                                    r = this._p[3];
                                this._precomputed = !0, t === e && i === r || this._calcSampleValues()
                            },
                            _calcSampleValues: function () {
                                for (var t = this._p[0], e = this._p[2], i = 0; i < o; ++i) this._mSampleValues[i] = p(i * l, t, e)
                            },
                            _getTForX: function (t) {
                                for (var e = this._p[0], i = this._p[2], r = this._mSampleValues, a = 0, s = 1, c = o - 1; s !== c && r[s] <= t; ++s) a += l;
                                var u = a + (t - r[--s]) / (r[s + 1] - r[s]) * l,
                                    h = f(u, e, i);
                                return h >= n ? g(t, u, e, i) : 0 === h ? u : m(t, a, a + l, e, i)
                            }
                        }, t
                    }(),
                    dt = function () {
                        function t(t) {
                            return t.concat(g(t.length))
                        }
                        return {
                            double: t
                        }
                    }(),
                    pt = function (t, e, i) {
                        var r = 0,
                            n = t,
                            a = g(n);

                        function s() {
                            return r ? a[r -= 1] : e()
                        }

                        function o(t) {
                            r === n && (a = dt.double(a), n *= 2), i && i(t), a[r] = t, r += 1
                        }
                        return {
                            newElement: s,
                            release: o
                        }
                    },
                    ft = function () {
                        function t() {
                            return {
                                addedLength: 0,
                                percents: m("float32", X()),
                                lengths: m("float32", X())
                            }
                        }
                        return pt(8, t)
                    }(),
                    mt = function () {
                        function t() {
                            return {
                                lengths: [],
                                totalLength: 0
                            }
                        }

                        function e(t) {
                            var e, i = t.lengths.length;
                            for (e = 0; e < i; e += 1) ft.release(t.lengths[e]);
                            t.lengths.length = 0
                        }
                        return pt(8, t, e)
                    }();

                function gt() {
                    var t = Math;

                    function e(t, e, i, r, n, a) {
                        var s = t * r + e * n + i * a - n * r - a * t - i * e;
                        return s > -.001 && s < .001
                    }

                    function i(i, r, n, a, s, o, l, c, u) {
                        if (0 === n && 0 === o && 0 === u) return e(i, r, a, s, l, c);
                        var h, d = t.sqrt(t.pow(a - i, 2) + t.pow(s - r, 2) + t.pow(o - n, 2)),
                            p = t.sqrt(t.pow(l - i, 2) + t.pow(c - r, 2) + t.pow(u - n, 2)),
                            f = t.sqrt(t.pow(l - a, 2) + t.pow(c - s, 2) + t.pow(u - o, 2));
                        return (h = d > p ? d > f ? d - p - f : f - p - d : f > p ? f - p - d : p - d - f) > -1e-4 && h < 1e-4
                    }
                    var r = function (t, e, i, r) {
                        var n, a, s, o, l, c, u = X(),
                            h = 0,
                            d = [],
                            p = [],
                            f = ft.newElement();
                        for (s = i.length, n = 0; n < u; n += 1) {
                            for (l = n / (u - 1), c = 0, a = 0; a < s; a += 1) o = A(1 - l, 3) * t[a] + 3 * A(1 - l, 2) * l * i[a] + 3 * (1 - l) * A(l, 2) * r[a] + A(l, 3) * e[a], d[a] = o, null !== p[a] && (c += A(d[a] - p[a], 2)), p[a] = d[a];
                            c && (h += c = S(c)), f.percents[n] = l, f.lengths[n] = h
                        }
                        return f.addedLength = h, f
                    };

                    function n(t) {
                        var e, i = mt.newElement(),
                            n = t.c,
                            a = t.v,
                            s = t.o,
                            o = t.i,
                            l = t._length,
                            c = i.lengths,
                            u = 0;
                        for (e = 0; e < l - 1; e += 1) c[e] = r(a[e], a[e + 1], s[e], o[e + 1]), u += c[e].addedLength;
                        return n && l && (c[e] = r(a[e], a[0], s[e], o[0]), u += c[e].addedLength), i.totalLength = u, i
                    }

                    function a(t) {
                        this.segmentLength = 0, this.points = new Array(t)
                    }

                    function s(t, e) {
                        this.partialLength = t, this.point = e
                    }
                    var o, l = (o = {}, function (t, i, r, n) {
                        var l = (t[0] + "_" + t[1] + "_" + i[0] + "_" + i[1] + "_" + r[0] + "_" + r[1] + "_" + n[0] + "_" + n[1]).replace(/\./g, "p");
                        if (!o[l]) {
                            var c, u, h, d, p, f, m, v = X(),
                                y = 0,
                                b = null;
                            2 === t.length && (t[0] !== i[0] || t[1] !== i[1]) && e(t[0], t[1], i[0], i[1], t[0] + r[0], t[1] + r[1]) && e(t[0], t[1], i[0], i[1], i[0] + n[0], i[1] + n[1]) && (v = 2);
                            var _ = new a(v);
                            for (h = r.length, c = 0; c < v; c += 1) {
                                for (m = g(h), p = c / (v - 1), f = 0, u = 0; u < h; u += 1) d = A(1 - p, 3) * t[u] + 3 * A(1 - p, 2) * p * (t[u] + r[u]) + 3 * (1 - p) * A(p, 2) * (i[u] + n[u]) + A(p, 3) * i[u], m[u] = d, null !== b && (f += A(m[u] - b[u], 2));
                                y += f = S(f), _.points[c] = new s(f, m), b = m
                            }
                            _.segmentLength = y, o[l] = _
                        }
                        return o[l]
                    });

                    function c(t, e) {
                        var i = e.percents,
                            r = e.lengths,
                            n = i.length,
                            a = k((n - 1) * t),
                            s = t * e.addedLength,
                            o = 0;
                        if (a === n - 1 || 0 === a || s === r[a]) return i[a];
                        for (var l = r[a] > s ? -1 : 1, c = !0; c;)
                            if (r[a] <= s && r[a + 1] > s ? (o = (s - r[a]) / (r[a + 1] - r[a]), c = !1) : a += l, a < 0 || a >= n - 1) {
                                if (a === n - 1) return i[a];
                                c = !1
                            } return i[a] + (i[a + 1] - i[a]) * o
                    }

                    function u(e, i, r, n, a, s) {
                        var o = c(a, s),
                            l = 1 - o;
                        return [t.round(1e3 * (l * l * l * e[0] + (o * l * l + l * o * l + l * l * o) * r[0] + (o * o * l + l * o * o + o * l * o) * n[0] + o * o * o * i[0])) / 1e3, t.round(1e3 * (l * l * l * e[1] + (o * l * l + l * o * l + l * l * o) * r[1] + (o * o * l + l * o * o + o * l * o) * n[1] + o * o * o * i[1])) / 1e3]
                    }
                    var h = m("float32", 8);

                    function d(e, i, r, n, a, s, o) {
                        a < 0 ? a = 0 : a > 1 && (a = 1);
                        var l, u = c(a, o),
                            d = c(s = s > 1 ? 1 : s, o),
                            p = e.length,
                            f = 1 - u,
                            m = 1 - d,
                            g = f * f * f,
                            v = u * f * f * 3,
                            y = u * u * f * 3,
                            b = u * u * u,
                            _ = f * f * m,
                            w = u * f * m + f * u * m + f * f * d,
                            A = u * u * m + f * u * d + u * f * d,
                            S = u * u * d,
                            k = f * m * m,
                            x = u * m * m + f * d * m + f * m * d,
                            T = u * d * m + f * d * d + u * m * d,
                            E = u * d * d,
                            M = m * m * m,
                            C = d * m * m + m * d * m + m * m * d,
                            P = d * d * m + m * d * d + d * m * d,
                            D = d * d * d;
                        for (l = 0; l < p; l += 1) h[4 * l] = t.round(1e3 * (g * e[l] + v * r[l] + y * n[l] + b * i[l])) / 1e3, h[4 * l + 1] = t.round(1e3 * (_ * e[l] + w * r[l] + A * n[l] + S * i[l])) / 1e3, h[4 * l + 2] = t.round(1e3 * (k * e[l] + x * r[l] + T * n[l] + E * i[l])) / 1e3, h[4 * l + 3] = t.round(1e3 * (M * e[l] + C * r[l] + P * n[l] + D * i[l])) / 1e3;
                        return h
                    }
                    return {
                        getSegmentsLength: n,
                        getNewSegment: d,
                        getPointInSegment: u,
                        buildBezierData: l,
                        pointOnLine2D: e,
                        pointOnLine3D: i
                    }
                }
                var vt = gt(),
                    yt = function () {
                        var t = a,
                            e = Math.abs;

                        function i(t, e) {
                            var i, a = this.offsetTime;
                            "multidimensional" === this.propType && (i = m("float32", this.pv.length));
                            for (var o, l, c, u, h, d, p, f, g, v = e.lastIndex, y = v, b = this.keyframes.length - 1, _ = !0; _;) {
                                if (o = this.keyframes[y], l = this.keyframes[y + 1], y === b - 1 && t >= l.t - a) {
                                    o.h && (o = l), v = 0;
                                    break
                                }
                                if (l.t - a > t) {
                                    v = y;
                                    break
                                }
                                y < b - 1 ? y += 1 : (v = 0, _ = !1)
                            }
                            c = this.keyframesMetadata[y] || {};
                            var w, A = l.t - a,
                                S = o.t - a;
                            if (o.to) {
                                c.bezierData || (c.bezierData = vt.buildBezierData(o.s, l.s || o.e, o.to, o.ti));
                                var k = c.bezierData;
                                if (t >= A || t < S) {
                                    var x = t >= A ? k.points.length - 1 : 0;
                                    for (h = k.points[x].point.length, u = 0; u < h; u += 1) i[u] = k.points[x].point[u]
                                } else {
                                    c.__fnct ? g = c.__fnct : (g = ht.getBezierEasing(o.o.x, o.o.y, o.i.x, o.i.y, o.n).get, c.__fnct = g), d = g((t - S) / (A - S));
                                    var T, E = k.segmentLength * d,
                                        M = e.lastFrame < t && e._lastKeyframeIndex === y ? e._lastAddedLength : 0;
                                    for (f = e.lastFrame < t && e._lastKeyframeIndex === y ? e._lastPoint : 0, _ = !0, p = k.points.length; _;) {
                                        if (M += k.points[f].partialLength, 0 === E || 0 === d || f === k.points.length - 1) {
                                            for (h = k.points[f].point.length, u = 0; u < h; u += 1) i[u] = k.points[f].point[u];
                                            break
                                        }
                                        if (E >= M && E < M + k.points[f + 1].partialLength) {
                                            for (T = (E - M) / k.points[f + 1].partialLength, h = k.points[f].point.length, u = 0; u < h; u += 1) i[u] = k.points[f].point[u] + (k.points[f + 1].point[u] - k.points[f].point[u]) * T;
                                            break
                                        }
                                        f < p - 1 ? f += 1 : _ = !1
                                    }
                                    e._lastPoint = f, e._lastAddedLength = M - k.points[f].partialLength, e._lastKeyframeIndex = y
                                }
                            } else {
                                var C, P, D, L, O;
                                if (b = o.s.length, w = l.s || o.e, this.sh && 1 !== o.h) t >= A ? (i[0] = w[0], i[1] = w[1], i[2] = w[2]) : t <= S ? (i[0] = o.s[0], i[1] = o.s[1], i[2] = o.s[2]) : n(i, r(s(o.s), s(w), (t - S) / (A - S)));
                                else
                                    for (y = 0; y < b; y += 1) 1 !== o.h && (t >= A ? d = 1 : t < S ? d = 0 : (o.o.x.constructor === Array ? (c.__fnct || (c.__fnct = []), c.__fnct[y] ? g = c.__fnct[y] : (C = void 0 === o.o.x[y] ? o.o.x[0] : o.o.x[y], P = void 0 === o.o.y[y] ? o.o.y[0] : o.o.y[y], D = void 0 === o.i.x[y] ? o.i.x[0] : o.i.x[y], L = void 0 === o.i.y[y] ? o.i.y[0] : o.i.y[y], g = ht.getBezierEasing(C, P, D, L).get, c.__fnct[y] = g)) : c.__fnct ? g = c.__fnct : (C = o.o.x, P = o.o.y, D = o.i.x, L = o.i.y, g = ht.getBezierEasing(C, P, D, L).get, o.keyframeMetadata = g), d = g((t - S) / (A - S)))), w = l.s || o.e, O = 1 === o.h ? o.s[y] : o.s[y] + (w[y] - o.s[y]) * d, "multidimensional" === this.propType ? i[y] = O : i = O
                            }
                            return e.lastIndex = v, i
                        }

                        function r(t, e, i) {
                            var r, n, a, s, o, l = [],
                                c = t[0],
                                u = t[1],
                                h = t[2],
                                d = t[3],
                                p = e[0],
                                f = e[1],
                                m = e[2],
                                g = e[3];
                            return (n = c * p + u * f + h * m + d * g) < 0 && (n = -n, p = -p, f = -f, m = -m, g = -g), 1 - n > 1e-6 ? (r = Math.acos(n), a = Math.sin(r), s = Math.sin((1 - i) * r) / a, o = Math.sin(i * r) / a) : (s = 1 - i, o = i), l[0] = s * c + o * p, l[1] = s * u + o * f, l[2] = s * h + o * m, l[3] = s * d + o * g, l
                        }

                        function n(t, e) {
                            var i = e[0],
                                r = e[1],
                                n = e[2],
                                a = e[3],
                                s = Math.atan2(2 * r * a - 2 * i * n, 1 - 2 * r * r - 2 * n * n),
                                o = Math.asin(2 * i * r + 2 * n * a),
                                l = Math.atan2(2 * i * a - 2 * r * n, 1 - 2 * i * i - 2 * n * n);
                            t[0] = s / M, t[1] = o / M, t[2] = l / M
                        }

                        function s(t) {
                            var e = t[0] * M,
                                i = t[1] * M,
                                r = t[2] * M,
                                n = Math.cos(e / 2),
                                a = Math.cos(i / 2),
                                s = Math.cos(r / 2),
                                o = Math.sin(e / 2),
                                l = Math.sin(i / 2),
                                c = Math.sin(r / 2);
                            return [o * l * s + n * a * c, o * a * s + n * l * c, n * l * s - o * a * c, n * a * s - o * l * c]
                        }

                        function o() {
                            var e = this.comp.renderedFrame - this.offsetTime,
                                i = this.keyframes[0].t - this.offsetTime,
                                r = this.keyframes[this.keyframes.length - 1].t - this.offsetTime;
                            if (!(e === this._caching.lastFrame || this._caching.lastFrame !== t && (this._caching.lastFrame >= r && e >= r || this._caching.lastFrame < i && e < i))) {
                                this._caching.lastFrame >= e && (this._caching._lastKeyframeIndex = -1, this._caching.lastIndex = 0);
                                var n = this.interpolateValue(e, this._caching);
                                this.pv = n
                            }
                            return this._caching.lastFrame = e, this.pv
                        }

                        function l(t) {
                            var i;
                            if ("unidimensional" === this.propType) i = t * this.mult, e(this.v - i) > 1e-5 && (this.v = i, this._mdf = !0);
                            else
                                for (var r = 0, n = this.v.length; r < n;) i = t[r] * this.mult, e(this.v[r] - i) > 1e-5 && (this.v[r] = i, this._mdf = !0), r += 1
                        }

                        function c() {
                            if (this.elem.globalData.frameId !== this.frameId && this.effectsSequence.length)
                                if (this.lock) this.setVValue(this.pv);
                                else {
                                    var t;
                                    this.lock = !0, this._mdf = this._isFirstFrame;
                                    var e = this.effectsSequence.length,
                                        i = this.kf ? this.pv : this.data.k;
                                    for (t = 0; t < e; t += 1) i = this.effectsSequence[t](i);
                                    this.setVValue(i), this._isFirstFrame = !1, this.lock = !1, this.frameId = this.elem.globalData.frameId
                                }
                        }

                        function u(t) {
                            this.effectsSequence.push(t), this.container.addDynamicProperty(this)
                        }

                        function h(t, e, i, r) {
                            this.propType = "unidimensional", this.mult = i || 1, this.data = e, this.v = i ? e.k * i : e.k, this.pv = e.k, this._mdf = !1, this.elem = t, this.container = r, this.comp = t.comp, this.k = !1, this.kf = !1, this.vel = 0, this.effectsSequence = [], this._isFirstFrame = !0, this.getValue = c, this.setVValue = l, this.addEffect = u
                        }

                        function d(t, e, i, r) {
                            var n;
                            this.propType = "multidimensional", this.mult = i || 1, this.data = e, this._mdf = !1, this.elem = t, this.container = r, this.comp = t.comp, this.k = !1, this.kf = !1, this.frameId = -1;
                            var a = e.k.length;
                            for (this.v = m("float32", a), this.pv = m("float32", a), this.vel = m("float32", a), n = 0; n < a; n += 1) this.v[n] = e.k[n] * this.mult, this.pv[n] = e.k[n];
                            this._isFirstFrame = !0, this.effectsSequence = [], this.getValue = c, this.setVValue = l, this.addEffect = u
                        }

                        function p(e, r, n, a) {
                            this.propType = "unidimensional", this.keyframes = r.k, this.keyframesMetadata = [], this.offsetTime = e.data.st, this.frameId = -1, this._caching = {
                                lastFrame: t,
                                lastIndex: 0,
                                value: 0,
                                _lastKeyframeIndex: -1
                            }, this.k = !0, this.kf = !0, this.data = r, this.mult = n || 1, this.elem = e, this.container = a, this.comp = e.comp, this.v = t, this.pv = t, this._isFirstFrame = !0, this.getValue = c, this.setVValue = l, this.interpolateValue = i, this.effectsSequence = [o.bind(this)], this.addEffect = u
                        }

                        function f(e, r, n, a) {
                            var s;
                            this.propType = "multidimensional";
                            var h, d, p, f, g = r.k.length;
                            for (s = 0; s < g - 1; s += 1) r.k[s].to && r.k[s].s && r.k[s + 1] && r.k[s + 1].s && (h = r.k[s].s, d = r.k[s + 1].s, p = r.k[s].to, f = r.k[s].ti, (2 === h.length && (h[0] !== d[0] || h[1] !== d[1]) && vt.pointOnLine2D(h[0], h[1], d[0], d[1], h[0] + p[0], h[1] + p[1]) && vt.pointOnLine2D(h[0], h[1], d[0], d[1], d[0] + f[0], d[1] + f[1]) || 3 === h.length && (h[0] !== d[0] || h[1] !== d[1] || h[2] !== d[2]) && vt.pointOnLine3D(h[0], h[1], h[2], d[0], d[1], d[2], h[0] + p[0], h[1] + p[1], h[2] + p[2]) && vt.pointOnLine3D(h[0], h[1], h[2], d[0], d[1], d[2], d[0] + f[0], d[1] + f[1], d[2] + f[2])) && (r.k[s].to = null, r.k[s].ti = null), h[0] === d[0] && h[1] === d[1] && 0 === p[0] && 0 === p[1] && 0 === f[0] && 0 === f[1] && (2 === h.length || h[2] === d[2] && 0 === p[2] && 0 === f[2]) && (r.k[s].to = null, r.k[s].ti = null));
                            this.effectsSequence = [o.bind(this)], this.data = r, this.keyframes = r.k, this.keyframesMetadata = [], this.offsetTime = e.data.st, this.k = !0, this.kf = !0, this._isFirstFrame = !0, this.mult = n || 1, this.elem = e, this.container = a, this.comp = e.comp, this.getValue = c, this.setVValue = l, this.interpolateValue = i, this.frameId = -1;
                            var v = r.k[0].s.length;
                            for (this.v = m("float32", v), this.pv = m("float32", v), s = 0; s < v; s += 1) this.v[s] = t, this.pv[s] = t;
                            this._caching = {
                                lastFrame: t,
                                lastIndex: 0,
                                value: m("float32", v)
                            }, this.addEffect = u
                        }

                        function g(t, e, i, r, n) {
                            var a;
                            if (e.k.length)
                                if ("number" == typeof e.k[0]) a = new d(t, e, r, n);
                                else switch (i) {
                                    case 0:
                                        a = new p(t, e, r, n);
                                        break;
                                    case 1:
                                        a = new f(t, e, r, n)
                                } else a = new h(t, e, r, n);
                            return a.effectsSequence.length && n.addDynamicProperty(a), a
                        }
                        return {
                            getProp: g
                        }
                    }();

                function bt() { }
                bt.prototype = {
                    addDynamicProperty: function (t) {
                        -1 === this.dynamicProperties.indexOf(t) && (this.dynamicProperties.push(t), this.container.addDynamicProperty(this), this._isAnimated = !0)
                    },
                    iterateDynamicProperties: function () {
                        var t;
                        this._mdf = !1;
                        var e = this.dynamicProperties.length;
                        for (t = 0; t < e; t += 1) this.dynamicProperties[t].getValue(), this.dynamicProperties[t]._mdf && (this._mdf = !0)
                    },
                    initDynamicPropertyContainer: function (t) {
                        this.container = t, this.dynamicProperties = [], this._mdf = !1, this._isAnimated = !1
                    }
                };
                var _t = function () {
                    function t() {
                        return m("float32", 2)
                    }
                    return pt(8, t)
                }();

                function wt() {
                    this.c = !1, this._length = 0, this._maxLength = 8, this.v = g(this._maxLength), this.o = g(this._maxLength), this.i = g(this._maxLength)
                }
                wt.prototype.setPathData = function (t, e) {
                    this.c = t, this.setLength(e);
                    for (var i = 0; i < e;) this.v[i] = _t.newElement(), this.o[i] = _t.newElement(), this.i[i] = _t.newElement(), i += 1
                }, wt.prototype.setLength = function (t) {
                    for (; this._maxLength < t;) this.doubleArrayLength();
                    this._length = t
                }, wt.prototype.doubleArrayLength = function () {
                    this.v = this.v.concat(g(this._maxLength)), this.i = this.i.concat(g(this._maxLength)), this.o = this.o.concat(g(this._maxLength)), this._maxLength *= 2
                }, wt.prototype.setXYAt = function (t, e, i, r, n) {
                    var a;
                    switch (this._length = Math.max(this._length, r + 1), this._length >= this._maxLength && this.doubleArrayLength(), i) {
                        case "v":
                            a = this.v;
                            break;
                        case "i":
                            a = this.i;
                            break;
                        case "o":
                            a = this.o;
                            break;
                        default:
                            a = []
                    }(!a[r] || a[r] && !n) && (a[r] = _t.newElement()), a[r][0] = t, a[r][1] = e
                }, wt.prototype.setTripleAt = function (t, e, i, r, n, a, s, o) {
                    this.setXYAt(t, e, "v", s, o), this.setXYAt(i, r, "o", s, o), this.setXYAt(n, a, "i", s, o)
                }, wt.prototype.reverse = function () {
                    var t = new wt;
                    t.setPathData(this.c, this._length);
                    var e = this.v,
                        i = this.o,
                        r = this.i,
                        n = 0;
                    this.c && (t.setTripleAt(e[0][0], e[0][1], r[0][0], r[0][1], i[0][0], i[0][1], 0, !1), n = 1);
                    var a, s = this._length - 1,
                        o = this._length;
                    for (a = n; a < o; a += 1) t.setTripleAt(e[s][0], e[s][1], r[s][0], r[s][1], i[s][0], i[s][1], a, !1), s -= 1;
                    return t
                };
                var At = function () {
                    function t() {
                        return new wt
                    }

                    function e(t) {
                        var e, i = t._length;
                        for (e = 0; e < i; e += 1) _t.release(t.v[e]), _t.release(t.i[e]), _t.release(t.o[e]), t.v[e] = null, t.i[e] = null, t.o[e] = null;
                        t._length = 0, t.c = !1
                    }

                    function i(t) {
                        var e, i = r.newElement(),
                            n = void 0 === t._length ? t.v.length : t._length;
                        for (i.setLength(n), i.c = t.c, e = 0; e < n; e += 1) i.setTripleAt(t.v[e][0], t.v[e][1], t.o[e][0], t.o[e][1], t.i[e][0], t.i[e][1], e);
                        return i
                    }
                    var r = pt(4, t, e);
                    return r.clone = i, r
                }();

                function St() {
                    this._length = 0, this._maxLength = 4, this.shapes = g(this._maxLength)
                }
                St.prototype.addShape = function (t) {
                    this._length === this._maxLength && (this.shapes = this.shapes.concat(g(this._maxLength)), this._maxLength *= 2), this.shapes[this._length] = t, this._length += 1
                }, St.prototype.releaseShapes = function () {
                    var t;
                    for (t = 0; t < this._length; t += 1) At.release(this.shapes[t]);
                    this._length = 0
                };
                var kt = function () {
                    var t = {
                        newShapeCollection: n,
                        release: a
                    },
                        e = 0,
                        i = 4,
                        r = g(i);

                    function n() {
                        return e ? r[e -= 1] : new St
                    }

                    function a(t) {
                        var n, a = t._length;
                        for (n = 0; n < a; n += 1) At.release(t.shapes[n]);
                        t._length = 0, e === i && (r = dt.double(r), i *= 2), r[e] = t, e += 1
                    }
                    return t
                }(),
                    xt = function () {
                        var t = -999999;

                        function e(t, e, i) {
                            var r, n, a, s, o, l, c, u, h, d = i.lastIndex,
                                p = this.keyframes;
                            if (t < p[0].t - this.offsetTime) r = p[0].s[0], a = !0, d = 0;
                            else if (t >= p[p.length - 1].t - this.offsetTime) r = p[p.length - 1].s ? p[p.length - 1].s[0] : p[p.length - 2].e[0], a = !0;
                            else {
                                for (var f, m, g, v = d, y = p.length - 1, b = !0; b && (f = p[v], !((m = p[v + 1]).t - this.offsetTime > t));) v < y - 1 ? v += 1 : b = !1;
                                if (g = this.keyframesMetadata[v] || {}, d = v, !(a = 1 === f.h)) {
                                    if (t >= m.t - this.offsetTime) u = 1;
                                    else if (t < f.t - this.offsetTime) u = 0;
                                    else {
                                        var _;
                                        g.__fnct ? _ = g.__fnct : (_ = ht.getBezierEasing(f.o.x, f.o.y, f.i.x, f.i.y).get, g.__fnct = _), u = _((t - (f.t - this.offsetTime)) / (m.t - this.offsetTime - (f.t - this.offsetTime)))
                                    }
                                    n = m.s ? m.s[0] : f.e[0]
                                }
                                r = f.s[0]
                            }
                            for (l = e._length, c = r.i[0].length, i.lastIndex = d, s = 0; s < l; s += 1)
                                for (o = 0; o < c; o += 1) h = a ? r.i[s][o] : r.i[s][o] + (n.i[s][o] - r.i[s][o]) * u, e.i[s][o] = h, h = a ? r.o[s][o] : r.o[s][o] + (n.o[s][o] - r.o[s][o]) * u, e.o[s][o] = h, h = a ? r.v[s][o] : r.v[s][o] + (n.v[s][o] - r.v[s][o]) * u, e.v[s][o] = h
                        }

                        function i() {
                            var e = this.comp.renderedFrame - this.offsetTime,
                                i = this.keyframes[0].t - this.offsetTime,
                                r = this.keyframes[this.keyframes.length - 1].t - this.offsetTime,
                                n = this._caching.lastFrame;
                            return n !== t && (n < i && e < i || n > r && e > r) || (this._caching.lastIndex = n < e ? this._caching.lastIndex : 0, this.interpolateShape(e, this.pv, this._caching)), this._caching.lastFrame = e, this.pv
                        }

                        function r() {
                            this.paths = this.localShapeCollection
                        }

                        function n(t, e) {
                            if (t._length !== e._length || t.c !== e.c) return !1;
                            var i, r = t._length;
                            for (i = 0; i < r; i += 1)
                                if (t.v[i][0] !== e.v[i][0] || t.v[i][1] !== e.v[i][1] || t.o[i][0] !== e.o[i][0] || t.o[i][1] !== e.o[i][1] || t.i[i][0] !== e.i[i][0] || t.i[i][1] !== e.i[i][1]) return !1;
                            return !0
                        }

                        function a(t) {
                            n(this.v, t) || (this.v = At.clone(t), this.localShapeCollection.releaseShapes(), this.localShapeCollection.addShape(this.v), this._mdf = !0, this.paths = this.localShapeCollection)
                        }

                        function s() {
                            if (this.elem.globalData.frameId !== this.frameId)
                                if (this.effectsSequence.length)
                                    if (this.lock) this.setVValue(this.pv);
                                    else {
                                        var t, e;
                                        this.lock = !0, this._mdf = !1, t = this.kf ? this.pv : this.data.ks ? this.data.ks.k : this.data.pt.k;
                                        var i = this.effectsSequence.length;
                                        for (e = 0; e < i; e += 1) t = this.effectsSequence[e](t);
                                        this.setVValue(t), this.lock = !1, this.frameId = this.elem.globalData.frameId
                                    }
                                else this._mdf = !1
                        }

                        function o(t, e, i) {
                            this.propType = "shape", this.comp = t.comp, this.container = t, this.elem = t, this.data = e, this.k = !1, this.kf = !1, this._mdf = !1;
                            var n = 3 === i ? e.pt.k : e.ks.k;
                            this.v = At.clone(n), this.pv = At.clone(this.v), this.localShapeCollection = kt.newShapeCollection(), this.paths = this.localShapeCollection, this.paths.addShape(this.v), this.reset = r, this.effectsSequence = []
                        }

                        function l(t) {
                            this.effectsSequence.push(t), this.container.addDynamicProperty(this)
                        }

                        function c(e, n, a) {
                            this.propType = "shape", this.comp = e.comp, this.elem = e, this.container = e, this.offsetTime = e.data.st, this.keyframes = 3 === a ? n.pt.k : n.ks.k, this.keyframesMetadata = [], this.k = !0, this.kf = !0;
                            var s = this.keyframes[0].s[0].i.length;
                            this.v = At.newElement(), this.v.setPathData(this.keyframes[0].s[0].c, s), this.pv = At.clone(this.v), this.localShapeCollection = kt.newShapeCollection(), this.paths = this.localShapeCollection, this.paths.addShape(this.v), this.lastFrame = t, this.reset = r, this._caching = {
                                lastFrame: t,
                                lastIndex: 0
                            }, this.effectsSequence = [i.bind(this)]
                        }
                        o.prototype.interpolateShape = e, o.prototype.getValue = s, o.prototype.setVValue = a, o.prototype.addEffect = l, c.prototype.getValue = s, c.prototype.interpolateShape = e, c.prototype.setVValue = a, c.prototype.addEffect = l;
                        var u = function () {
                            var t = C;

                            function e(t, e) {
                                this.v = At.newElement(), this.v.setPathData(!0, 4), this.localShapeCollection = kt.newShapeCollection(), this.paths = this.localShapeCollection, this.localShapeCollection.addShape(this.v), this.d = e.d, this.elem = t, this.comp = t.comp, this.frameId = -1, this.initDynamicPropertyContainer(t), this.p = yt.getProp(t, e.p, 1, 0, this), this.s = yt.getProp(t, e.s, 1, 0, this), this.dynamicProperties.length ? this.k = !0 : (this.k = !1, this.convertEllToPath())
                            }
                            return e.prototype = {
                                reset: r,
                                getValue: function () {
                                    this.elem.globalData.frameId !== this.frameId && (this.frameId = this.elem.globalData.frameId, this.iterateDynamicProperties(), this._mdf && this.convertEllToPath())
                                },
                                convertEllToPath: function () {
                                    var e = this.p.v[0],
                                        i = this.p.v[1],
                                        r = this.s.v[0] / 2,
                                        n = this.s.v[1] / 2,
                                        a = 3 !== this.d,
                                        s = this.v;
                                    s.v[0][0] = e, s.v[0][1] = i - n, s.v[1][0] = a ? e + r : e - r, s.v[1][1] = i, s.v[2][0] = e, s.v[2][1] = i + n, s.v[3][0] = a ? e - r : e + r, s.v[3][1] = i, s.i[0][0] = a ? e - r * t : e + r * t, s.i[0][1] = i - n, s.i[1][0] = a ? e + r : e - r, s.i[1][1] = i - n * t, s.i[2][0] = a ? e + r * t : e - r * t, s.i[2][1] = i + n, s.i[3][0] = a ? e - r : e + r, s.i[3][1] = i + n * t, s.o[0][0] = a ? e + r * t : e - r * t, s.o[0][1] = i - n, s.o[1][0] = a ? e + r : e - r, s.o[1][1] = i + n * t, s.o[2][0] = a ? e - r * t : e + r * t, s.o[2][1] = i + n, s.o[3][0] = a ? e - r : e + r, s.o[3][1] = i - n * t
                                }
                            }, h([bt], e), e
                        }(),
                            d = function () {
                                function t(t, e) {
                                    this.v = At.newElement(), this.v.setPathData(!0, 0), this.elem = t, this.comp = t.comp, this.data = e, this.frameId = -1, this.d = e.d, this.initDynamicPropertyContainer(t), 1 === e.sy ? (this.ir = yt.getProp(t, e.ir, 0, 0, this), this.is = yt.getProp(t, e.is, 0, .01, this), this.convertToPath = this.convertStarToPath) : this.convertToPath = this.convertPolygonToPath, this.pt = yt.getProp(t, e.pt, 0, 0, this), this.p = yt.getProp(t, e.p, 1, 0, this), this.r = yt.getProp(t, e.r, 0, M, this), this.or = yt.getProp(t, e.or, 0, 0, this), this.os = yt.getProp(t, e.os, 0, .01, this), this.localShapeCollection = kt.newShapeCollection(), this.localShapeCollection.addShape(this.v), this.paths = this.localShapeCollection, this.dynamicProperties.length ? this.k = !0 : (this.k = !1, this.convertToPath())
                                }
                                return t.prototype = {
                                    reset: r,
                                    getValue: function () {
                                        this.elem.globalData.frameId !== this.frameId && (this.frameId = this.elem.globalData.frameId, this.iterateDynamicProperties(), this._mdf && this.convertToPath())
                                    },
                                    convertStarToPath: function () {
                                        var t, e, i, r, n = 2 * Math.floor(this.pt.v),
                                            a = 2 * Math.PI / n,
                                            s = !0,
                                            o = this.or.v,
                                            l = this.ir.v,
                                            c = this.os.v,
                                            u = this.is.v,
                                            h = 2 * Math.PI * o / (2 * n),
                                            d = 2 * Math.PI * l / (2 * n),
                                            p = -Math.PI / 2;
                                        p += this.r.v;
                                        var f = 3 === this.data.d ? -1 : 1;
                                        for (this.v._length = 0, t = 0; t < n; t += 1) {
                                            i = s ? c : u, r = s ? h : d;
                                            var m = (e = s ? o : l) * Math.cos(p),
                                                g = e * Math.sin(p),
                                                v = 0 === m && 0 === g ? 0 : g / Math.sqrt(m * m + g * g),
                                                y = 0 === m && 0 === g ? 0 : -m / Math.sqrt(m * m + g * g);
                                            m += +this.p.v[0], g += +this.p.v[1], this.v.setTripleAt(m, g, m - v * r * i * f, g - y * r * i * f, m + v * r * i * f, g + y * r * i * f, t, !0), s = !s, p += a * f
                                        }
                                    },
                                    convertPolygonToPath: function () {
                                        var t, e = Math.floor(this.pt.v),
                                            i = 2 * Math.PI / e,
                                            r = this.or.v,
                                            n = this.os.v,
                                            a = 2 * Math.PI * r / (4 * e),
                                            s = .5 * -Math.PI,
                                            o = 3 === this.data.d ? -1 : 1;
                                        for (s += this.r.v, this.v._length = 0, t = 0; t < e; t += 1) {
                                            var l = r * Math.cos(s),
                                                c = r * Math.sin(s),
                                                u = 0 === l && 0 === c ? 0 : c / Math.sqrt(l * l + c * c),
                                                h = 0 === l && 0 === c ? 0 : -l / Math.sqrt(l * l + c * c);
                                            l += +this.p.v[0], c += +this.p.v[1], this.v.setTripleAt(l, c, l - u * a * n * o, c - h * a * n * o, l + u * a * n * o, c + h * a * n * o, t, !0), s += i * o
                                        }
                                        this.paths.length = 0, this.paths[0] = this.v
                                    }
                                }, h([bt], t), t
                            }(),
                            p = function () {
                                function t(t, e) {
                                    this.v = At.newElement(), this.v.c = !0, this.localShapeCollection = kt.newShapeCollection(), this.localShapeCollection.addShape(this.v), this.paths = this.localShapeCollection, this.elem = t, this.comp = t.comp, this.frameId = -1, this.d = e.d, this.initDynamicPropertyContainer(t), this.p = yt.getProp(t, e.p, 1, 0, this), this.s = yt.getProp(t, e.s, 1, 0, this), this.r = yt.getProp(t, e.r, 0, 0, this), this.dynamicProperties.length ? this.k = !0 : (this.k = !1, this.convertRectToPath())
                                }
                                return t.prototype = {
                                    convertRectToPath: function () {
                                        var t = this.p.v[0],
                                            e = this.p.v[1],
                                            i = this.s.v[0] / 2,
                                            r = this.s.v[1] / 2,
                                            n = x(i, r, this.r.v),
                                            a = n * (1 - C);
                                        this.v._length = 0, 2 === this.d || 1 === this.d ? (this.v.setTripleAt(t + i, e - r + n, t + i, e - r + n, t + i, e - r + a, 0, !0), this.v.setTripleAt(t + i, e + r - n, t + i, e + r - a, t + i, e + r - n, 1, !0), 0 !== n ? (this.v.setTripleAt(t + i - n, e + r, t + i - n, e + r, t + i - a, e + r, 2, !0), this.v.setTripleAt(t - i + n, e + r, t - i + a, e + r, t - i + n, e + r, 3, !0), this.v.setTripleAt(t - i, e + r - n, t - i, e + r - n, t - i, e + r - a, 4, !0), this.v.setTripleAt(t - i, e - r + n, t - i, e - r + a, t - i, e - r + n, 5, !0), this.v.setTripleAt(t - i + n, e - r, t - i + n, e - r, t - i + a, e - r, 6, !0), this.v.setTripleAt(t + i - n, e - r, t + i - a, e - r, t + i - n, e - r, 7, !0)) : (this.v.setTripleAt(t - i, e + r, t - i + a, e + r, t - i, e + r, 2), this.v.setTripleAt(t - i, e - r, t - i, e - r + a, t - i, e - r, 3))) : (this.v.setTripleAt(t + i, e - r + n, t + i, e - r + a, t + i, e - r + n, 0, !0), 0 !== n ? (this.v.setTripleAt(t + i - n, e - r, t + i - n, e - r, t + i - a, e - r, 1, !0), this.v.setTripleAt(t - i + n, e - r, t - i + a, e - r, t - i + n, e - r, 2, !0), this.v.setTripleAt(t - i, e - r + n, t - i, e - r + n, t - i, e - r + a, 3, !0), this.v.setTripleAt(t - i, e + r - n, t - i, e + r - a, t - i, e + r - n, 4, !0), this.v.setTripleAt(t - i + n, e + r, t - i + n, e + r, t - i + a, e + r, 5, !0), this.v.setTripleAt(t + i - n, e + r, t + i - a, e + r, t + i - n, e + r, 6, !0), this.v.setTripleAt(t + i, e + r - n, t + i, e + r - n, t + i, e + r - a, 7, !0)) : (this.v.setTripleAt(t - i, e - r, t - i + a, e - r, t - i, e - r, 1, !0), this.v.setTripleAt(t - i, e + r, t - i, e + r - a, t - i, e + r, 2, !0), this.v.setTripleAt(t + i, e + r, t + i - a, e + r, t + i, e + r, 3, !0)))
                                    },
                                    getValue: function () {
                                        this.elem.globalData.frameId !== this.frameId && (this.frameId = this.elem.globalData.frameId, this.iterateDynamicProperties(), this._mdf && this.convertRectToPath())
                                    },
                                    reset: r
                                }, h([bt], t), t
                            }();

                        function f(t, e, i) {
                            var r;
                            return 3 === i || 4 === i ? r = (3 === i ? e.pt : e.ks).k.length ? new c(t, e, i) : new o(t, e, i) : 5 === i ? r = new p(t, e) : 6 === i ? r = new u(t, e) : 7 === i && (r = new d(t, e)), r.k && t.addDynamicProperty(r), r
                        }

                        function m() {
                            return o
                        }

                        function g() {
                            return c
                        }
                        var v = {};
                        return v.getShapeProp = f, v.getConstructorFunction = m, v.getKeyframedConstructorFunction = g, v
                    }(),
                    Tt = function () {
                        var t = Math.cos,
                            e = Math.sin,
                            i = Math.tan,
                            r = Math.round;

                        function n() {
                            return this.props[0] = 1, this.props[1] = 0, this.props[2] = 0, this.props[3] = 0, this.props[4] = 0, this.props[5] = 1, this.props[6] = 0, this.props[7] = 0, this.props[8] = 0, this.props[9] = 0, this.props[10] = 1, this.props[11] = 0, this.props[12] = 0, this.props[13] = 0, this.props[14] = 0, this.props[15] = 1, this
                        }

                        function a(i) {
                            if (0 === i) return this;
                            var r = t(i),
                                n = e(i);
                            return this._t(r, -n, 0, 0, n, r, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1)
                        }

                        function s(i) {
                            if (0 === i) return this;
                            var r = t(i),
                                n = e(i);
                            return this._t(1, 0, 0, 0, 0, r, -n, 0, 0, n, r, 0, 0, 0, 0, 1)
                        }

                        function o(i) {
                            if (0 === i) return this;
                            var r = t(i),
                                n = e(i);
                            return this._t(r, 0, n, 0, 0, 1, 0, 0, -n, 0, r, 0, 0, 0, 0, 1)
                        }

                        function l(i) {
                            if (0 === i) return this;
                            var r = t(i),
                                n = e(i);
                            return this._t(r, -n, 0, 0, n, r, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1)
                        }

                        function c(t, e) {
                            return this._t(1, e, t, 1, 0, 0)
                        }

                        function u(t, e) {
                            return this.shear(i(t), i(e))
                        }

                        function h(r, n) {
                            var a = t(n),
                                s = e(n);
                            return this._t(a, s, 0, 0, -s, a, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1)._t(1, 0, 0, 0, i(r), 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1)._t(a, -s, 0, 0, s, a, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1)
                        }

                        function d(t, e, i) {
                            return i || 0 === i || (i = 1), 1 === t && 1 === e && 1 === i ? this : this._t(t, 0, 0, 0, 0, e, 0, 0, 0, 0, i, 0, 0, 0, 0, 1)
                        }

                        function p(t, e, i, r, n, a, s, o, l, c, u, h, d, p, f, m) {
                            return this.props[0] = t, this.props[1] = e, this.props[2] = i, this.props[3] = r, this.props[4] = n, this.props[5] = a, this.props[6] = s, this.props[7] = o, this.props[8] = l, this.props[9] = c, this.props[10] = u, this.props[11] = h, this.props[12] = d, this.props[13] = p, this.props[14] = f, this.props[15] = m, this
                        }

                        function f(t, e, i) {
                            return i = i || 0, 0 !== t || 0 !== e || 0 !== i ? this._t(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, t, e, i, 1) : this
                        }

                        function g(t, e, i, r, n, a, s, o, l, c, u, h, d, p, f, m) {
                            var g = this.props;
                            if (1 === t && 0 === e && 0 === i && 0 === r && 0 === n && 1 === a && 0 === s && 0 === o && 0 === l && 0 === c && 1 === u && 0 === h) return g[12] = g[12] * t + g[15] * d, g[13] = g[13] * a + g[15] * p, g[14] = g[14] * u + g[15] * f, g[15] *= m, this._identityCalculated = !1, this;
                            var v = g[0],
                                y = g[1],
                                b = g[2],
                                _ = g[3],
                                w = g[4],
                                A = g[5],
                                S = g[6],
                                k = g[7],
                                x = g[8],
                                T = g[9],
                                E = g[10],
                                M = g[11],
                                C = g[12],
                                P = g[13],
                                D = g[14],
                                L = g[15];
                            return g[0] = v * t + y * n + b * l + _ * d, g[1] = v * e + y * a + b * c + _ * p, g[2] = v * i + y * s + b * u + _ * f, g[3] = v * r + y * o + b * h + _ * m, g[4] = w * t + A * n + S * l + k * d, g[5] = w * e + A * a + S * c + k * p, g[6] = w * i + A * s + S * u + k * f, g[7] = w * r + A * o + S * h + k * m, g[8] = x * t + T * n + E * l + M * d, g[9] = x * e + T * a + E * c + M * p, g[10] = x * i + T * s + E * u + M * f, g[11] = x * r + T * o + E * h + M * m, g[12] = C * t + P * n + D * l + L * d, g[13] = C * e + P * a + D * c + L * p, g[14] = C * i + P * s + D * u + L * f, g[15] = C * r + P * o + D * h + L * m, this._identityCalculated = !1, this
                        }

                        function v() {
                            return this._identityCalculated || (this._identity = !(1 !== this.props[0] || 0 !== this.props[1] || 0 !== this.props[2] || 0 !== this.props[3] || 0 !== this.props[4] || 1 !== this.props[5] || 0 !== this.props[6] || 0 !== this.props[7] || 0 !== this.props[8] || 0 !== this.props[9] || 1 !== this.props[10] || 0 !== this.props[11] || 0 !== this.props[12] || 0 !== this.props[13] || 0 !== this.props[14] || 1 !== this.props[15]), this._identityCalculated = !0), this._identity
                        }

                        function y(t) {
                            for (var e = 0; e < 16;) {
                                if (t.props[e] !== this.props[e]) return !1;
                                e += 1
                            }
                            return !0
                        }

                        function b(t) {
                            var e;
                            for (e = 0; e < 16; e += 1) t.props[e] = this.props[e];
                            return t
                        }

                        function _(t) {
                            var e;
                            for (e = 0; e < 16; e += 1) this.props[e] = t[e]
                        }

                        function w(t, e, i) {
                            return {
                                x: t * this.props[0] + e * this.props[4] + i * this.props[8] + this.props[12],
                                y: t * this.props[1] + e * this.props[5] + i * this.props[9] + this.props[13],
                                z: t * this.props[2] + e * this.props[6] + i * this.props[10] + this.props[14]
                            }
                        }

                        function A(t, e, i) {
                            return t * this.props[0] + e * this.props[4] + i * this.props[8] + this.props[12]
                        }

                        function S(t, e, i) {
                            return t * this.props[1] + e * this.props[5] + i * this.props[9] + this.props[13]
                        }

                        function k(t, e, i) {
                            return t * this.props[2] + e * this.props[6] + i * this.props[10] + this.props[14]
                        }

                        function x() {
                            var t = this.props[0] * this.props[5] - this.props[1] * this.props[4],
                                e = this.props[5] / t,
                                i = -this.props[1] / t,
                                r = -this.props[4] / t,
                                n = this.props[0] / t,
                                a = (this.props[4] * this.props[13] - this.props[5] * this.props[12]) / t,
                                s = -(this.props[0] * this.props[13] - this.props[1] * this.props[12]) / t,
                                o = new Tt;
                            return o.props[0] = e, o.props[1] = i, o.props[4] = r, o.props[5] = n, o.props[12] = a, o.props[13] = s, o
                        }

                        function T(t) {
                            return this.getInverseMatrix().applyToPointArray(t[0], t[1], t[2] || 0)
                        }

                        function E(t) {
                            var e, i = t.length,
                                r = [];
                            for (e = 0; e < i; e += 1) r[e] = T(t[e]);
                            return r
                        }

                        function M(t, e, i) {
                            var r = m("float32", 6);
                            if (this.isIdentity()) r[0] = t[0], r[1] = t[1], r[2] = e[0], r[3] = e[1], r[4] = i[0], r[5] = i[1];
                            else {
                                var n = this.props[0],
                                    a = this.props[1],
                                    s = this.props[4],
                                    o = this.props[5],
                                    l = this.props[12],
                                    c = this.props[13];
                                r[0] = t[0] * n + t[1] * s + l, r[1] = t[0] * a + t[1] * o + c, r[2] = e[0] * n + e[1] * s + l, r[3] = e[0] * a + e[1] * o + c, r[4] = i[0] * n + i[1] * s + l, r[5] = i[0] * a + i[1] * o + c
                            }
                            return r
                        }

                        function C(t, e, i) {
                            return this.isIdentity() ? [t, e, i] : [t * this.props[0] + e * this.props[4] + i * this.props[8] + this.props[12], t * this.props[1] + e * this.props[5] + i * this.props[9] + this.props[13], t * this.props[2] + e * this.props[6] + i * this.props[10] + this.props[14]]
                        }

                        function P(t, e) {
                            if (this.isIdentity()) return t + "," + e;
                            var i = this.props;
                            return Math.round(100 * (t * i[0] + e * i[4] + i[12])) / 100 + "," + Math.round(100 * (t * i[1] + e * i[5] + i[13])) / 100
                        }

                        function D() {
                            for (var t = 0, e = this.props, i = "matrix3d(", n = 1e4; t < 16;) i += r(e[t] * n) / n, i += 15 === t ? ")" : ",", t += 1;
                            return i
                        }

                        function L(t) {
                            var e = 1e4;
                            return t < 1e-6 && t > 0 || t > -1e-6 && t < 0 ? r(t * e) / e : t
                        }

                        function O() {
                            var t = this.props;
                            return "matrix(" + L(t[0]) + "," + L(t[1]) + "," + L(t[4]) + "," + L(t[5]) + "," + L(t[12]) + "," + L(t[13]) + ")"
                        }
                        return function () {
                            this.reset = n, this.rotate = a, this.rotateX = s, this.rotateY = o, this.rotateZ = l, this.skew = u, this.skewFromAxis = h, this.shear = c, this.scale = d, this.setTransform = p, this.translate = f, this.transform = g, this.applyToPoint = w, this.applyToX = A, this.applyToY = S, this.applyToZ = k, this.applyToPointArray = C, this.applyToTriplePoints = M, this.applyToPointStringified = P, this.toCSS = D, this.to2dCSS = O, this.clone = b, this.cloneFromProps = _, this.equals = y, this.inversePoints = E, this.inversePoint = T, this.getInverseMatrix = x, this._t = this.transform, this.isIdentity = v, this._identity = !0, this._identityCalculated = !1, this.props = m("float32", 16), this.reset()
                        }
                    }();

                function Et(t) {
                    return Et = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
                        return typeof t
                    } : function (t) {
                        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t
                    }, Et(t)
                }
                var Mt = {},
                    Ct = "__[STANDALONE]__",
                    Pt = "__[ANIMATIONDATA]__",
                    Dt = "";

                function Lt(t) {
                    l(t)
                }

                function Ot() {
                    !0 === Ct ? ut.searchAnimations(Pt, Ct, Dt) : ut.searchAnimations()
                }

                function It(t) {
                    H(t)
                }

                function Rt(t) {
                    K(t)
                }

                function Ft(t) {
                    return !0 === Ct && (t.animationData = JSON.parse(Pt)), ut.loadAnimation(t)
                }

                function Nt(t) {
                    if ("string" == typeof t) switch (t) {
                        case "high":
                            U(200);
                            break;
                        default:
                        case "medium":
                            U(50);
                            break;
                        case "low":
                            U(10)
                    } else !isNaN(t) && t > 1 && U(t);
                    X() >= 50 ? P(!1) : P(!0)
                }

                function Bt() {
                    return "undefined" != typeof navigator
                }

                function zt(t, e) {
                    "expressions" === t && Z(e)
                }

                function qt(t) {
                    switch (t) {
                        case "propertyFactory":
                            return yt;
                        case "shapePropertyFactory":
                            return xt;
                        case "matrix":
                            return Tt;
                        default:
                            return null
                    }
                }

                function Vt() {
                    "complete" === document.readyState && (clearInterval(Wt), Ot())
                }

                function Yt(t) {
                    for (var e = jt.split("&"), i = 0; i < e.length; i += 1) {
                        var r = e[i].split("=");
                        if (decodeURIComponent(r[0]) == t) return decodeURIComponent(r[1])
                    }
                    return null
                }
                Mt.play = ut.play, Mt.pause = ut.pause, Mt.setLocationHref = Lt, Mt.togglePause = ut.togglePause, Mt.setSpeed = ut.setSpeed, Mt.setDirection = ut.setDirection, Mt.stop = ut.stop, Mt.searchAnimations = Ot, Mt.registerAnimation = ut.registerAnimation, Mt.loadAnimation = Ft, Mt.setSubframeRendering = It, Mt.resize = ut.resize, Mt.goToAndStop = ut.goToAndStop, Mt.destroy = ut.destroy, Mt.setQuality = Nt, Mt.inBrowser = Bt, Mt.installPlugin = zt, Mt.freeze = ut.freeze, Mt.unfreeze = ut.unfreeze, Mt.setVolume = ut.setVolume, Mt.mute = ut.mute, Mt.unmute = ut.unmute, Mt.getRegisteredAnimations = ut.getRegisteredAnimations, Mt.useWebWorker = s, Mt.setIDPrefix = Rt, Mt.__getFactory = qt, Mt.version = "5.9.6";
                var jt = "";
                if (Ct) {
                    var Gt = document.getElementsByTagName("script"),
                        Ht = Gt[Gt.length - 1] || {
                            src: ""
                        };
                    jt = Ht.src ? Ht.src.replace(/^[^\?]+\??/, "") : "", Dt = Yt("renderer")
                }
                var Wt = setInterval(Vt, 100);
                try {
                    "object" !== Et(e) && i.amdO
                } catch (t) { }
                var Zt = function () {
                    var t = {},
                        e = {};

                    function i(t, i) {
                        e[t] || (e[t] = i)
                    }

                    function r(t, i, r) {
                        return new e[t](i, r)
                    }
                    return t.registerModifier = i, t.getModifier = r, t
                }();

                function $t() { }

                function Ut() { }

                function Xt() { }
                $t.prototype.initModifierProperties = function () { }, $t.prototype.addShapeToModifier = function () { }, $t.prototype.addShape = function (t) {
                    if (!this.closed) {
                        t.sh.container.addDynamicProperty(t.sh);
                        var e = {
                            shape: t.sh,
                            data: t,
                            localShapeCollection: kt.newShapeCollection()
                        };
                        this.shapes.push(e), this.addShapeToModifier(e), this._isAnimated && t.setAsAnimated()
                    }
                }, $t.prototype.init = function (t, e) {
                    this.shapes = [], this.elem = t, this.initDynamicPropertyContainer(t), this.initModifierProperties(t, e), this.frameId = a, this.closed = !1, this.k = !1, this.dynamicProperties.length ? this.k = !0 : this.getValue(!0)
                }, $t.prototype.processKeys = function () {
                    this.elem.globalData.frameId !== this.frameId && (this.frameId = this.elem.globalData.frameId, this.iterateDynamicProperties())
                }, h([bt], $t), h([$t], Ut), Ut.prototype.initModifierProperties = function (t, e) {
                    this.s = yt.getProp(t, e.s, 0, .01, this), this.e = yt.getProp(t, e.e, 0, .01, this), this.o = yt.getProp(t, e.o, 0, 0, this), this.sValue = 0, this.eValue = 0, this.getValue = this.processKeys, this.m = e.m, this._isAnimated = !!this.s.effectsSequence.length || !!this.e.effectsSequence.length || !!this.o.effectsSequence.length
                }, Ut.prototype.addShapeToModifier = function (t) {
                    t.pathsData = []
                }, Ut.prototype.calculateShapeEdges = function (t, e, i, r, n) {
                    var a = [];
                    e <= 1 ? a.push({
                        s: t,
                        e
                    }) : t >= 1 ? a.push({
                        s: t - 1,
                        e: e - 1
                    }) : (a.push({
                        s: t,
                        e: 1
                    }), a.push({
                        s: 0,
                        e: e - 1
                    }));
                    var s, o, l = [],
                        c = a.length;
                    for (s = 0; s < c; s += 1) {
                        var u, h;
                        (o = a[s]).e * n < r || o.s * n > r + i || (u = o.s * n <= r ? 0 : (o.s * n - r) / i, h = o.e * n >= r + i ? 1 : (o.e * n - r) / i, l.push([u, h]))
                    }
                    return l.length || l.push([0, 0]), l
                }, Ut.prototype.releasePathsData = function (t) {
                    var e, i = t.length;
                    for (e = 0; e < i; e += 1) mt.release(t[e]);
                    return t.length = 0, t
                }, Ut.prototype.processShapes = function (t) {
                    var e, i, r, n;
                    if (this._mdf || t) {
                        var a = this.o.v % 360 / 360;
                        if (a < 0 && (a += 1), (e = this.s.v > 1 ? 1 + a : this.s.v < 0 ? 0 + a : this.s.v + a) > (i = this.e.v > 1 ? 1 + a : this.e.v < 0 ? 0 + a : this.e.v + a)) {
                            var s = e;
                            e = i, i = s
                        }
                        e = 1e-4 * Math.round(1e4 * e), i = 1e-4 * Math.round(1e4 * i), this.sValue = e, this.eValue = i
                    } else e = this.sValue, i = this.eValue;
                    var o, l, c, u, h, d = this.shapes.length,
                        p = 0;
                    if (i === e)
                        for (n = 0; n < d; n += 1) this.shapes[n].localShapeCollection.releaseShapes(), this.shapes[n].shape._mdf = !0, this.shapes[n].shape.paths = this.shapes[n].localShapeCollection, this._mdf && (this.shapes[n].pathsData.length = 0);
                    else if (1 === i && 0 === e || 0 === i && 1 === e) {
                        if (this._mdf)
                            for (n = 0; n < d; n += 1) this.shapes[n].pathsData.length = 0, this.shapes[n].shape._mdf = !0
                    } else {
                        var f, m, g = [];
                        for (n = 0; n < d; n += 1)
                            if ((f = this.shapes[n]).shape._mdf || this._mdf || t || 2 === this.m) {
                                if (l = (r = f.shape.paths)._length, h = 0, !f.shape._mdf && f.pathsData.length) h = f.totalShapeLength;
                                else {
                                    for (c = this.releasePathsData(f.pathsData), o = 0; o < l; o += 1) u = vt.getSegmentsLength(r.shapes[o]), c.push(u), h += u.totalLength;
                                    f.totalShapeLength = h, f.pathsData = c
                                }
                                p += h, f.shape._mdf = !0
                            } else f.shape.paths = f.localShapeCollection;
                        var v, y = e,
                            b = i,
                            _ = 0;
                        for (n = d - 1; n >= 0; n -= 1)
                            if ((f = this.shapes[n]).shape._mdf) {
                                for ((m = f.localShapeCollection).releaseShapes(), 2 === this.m && d > 1 ? (v = this.calculateShapeEdges(e, i, f.totalShapeLength, _, p), _ += f.totalShapeLength) : v = [
                                    [y, b]
                                ], l = v.length, o = 0; o < l; o += 1) {
                                    y = v[o][0], b = v[o][1], g.length = 0, b <= 1 ? g.push({
                                        s: f.totalShapeLength * y,
                                        e: f.totalShapeLength * b
                                    }) : y >= 1 ? g.push({
                                        s: f.totalShapeLength * (y - 1),
                                        e: f.totalShapeLength * (b - 1)
                                    }) : (g.push({
                                        s: f.totalShapeLength * y,
                                        e: f.totalShapeLength
                                    }), g.push({
                                        s: 0,
                                        e: f.totalShapeLength * (b - 1)
                                    }));
                                    var w = this.addShapes(f, g[0]);
                                    if (g[0].s !== g[0].e) {
                                        if (g.length > 1)
                                            if (f.shape.paths.shapes[f.shape.paths._length - 1].c) {
                                                var A = w.pop();
                                                this.addPaths(w, m), w = this.addShapes(f, g[1], A)
                                            } else this.addPaths(w, m), w = this.addShapes(f, g[1]);
                                        this.addPaths(w, m)
                                    }
                                }
                                f.shape.paths = m
                            }
                    }
                }, Ut.prototype.addPaths = function (t, e) {
                    var i, r = t.length;
                    for (i = 0; i < r; i += 1) e.addShape(t[i])
                }, Ut.prototype.addSegment = function (t, e, i, r, n, a, s) {
                    n.setXYAt(e[0], e[1], "o", a), n.setXYAt(i[0], i[1], "i", a + 1), s && n.setXYAt(t[0], t[1], "v", a), n.setXYAt(r[0], r[1], "v", a + 1)
                }, Ut.prototype.addSegmentFromArray = function (t, e, i, r) {
                    e.setXYAt(t[1], t[5], "o", i), e.setXYAt(t[2], t[6], "i", i + 1), r && e.setXYAt(t[0], t[4], "v", i), e.setXYAt(t[3], t[7], "v", i + 1)
                }, Ut.prototype.addShapes = function (t, e, i) {
                    var r, n, a, s, o, l, c, u, h = t.pathsData,
                        d = t.shape.paths.shapes,
                        p = t.shape.paths._length,
                        f = 0,
                        m = [],
                        g = !0;
                    for (i ? (o = i._length, u = i._length) : (i = At.newElement(), o = 0, u = 0), m.push(i), r = 0; r < p; r += 1) {
                        for (l = h[r].lengths, i.c = d[r].c, a = d[r].c ? l.length : l.length + 1, n = 1; n < a; n += 1)
                            if (f + (s = l[n - 1]).addedLength < e.s) f += s.addedLength, i.c = !1;
                            else {
                                if (f > e.e) {
                                    i.c = !1;
                                    break
                                }
                                e.s <= f && e.e >= f + s.addedLength ? (this.addSegment(d[r].v[n - 1], d[r].o[n - 1], d[r].i[n], d[r].v[n], i, o, g), g = !1) : (c = vt.getNewSegment(d[r].v[n - 1], d[r].v[n], d[r].o[n - 1], d[r].i[n], (e.s - f) / s.addedLength, (e.e - f) / s.addedLength, l[n - 1]), this.addSegmentFromArray(c, i, o, g), g = !1, i.c = !1), f += s.addedLength, o += 1
                            } if (d[r].c && l.length) {
                                if (s = l[n - 1], f <= e.e) {
                                    var v = l[n - 1].addedLength;
                                    e.s <= f && e.e >= f + v ? (this.addSegment(d[r].v[n - 1], d[r].o[n - 1], d[r].i[0], d[r].v[0], i, o, g), g = !1) : (c = vt.getNewSegment(d[r].v[n - 1], d[r].v[0], d[r].o[n - 1], d[r].i[0], (e.s - f) / v, (e.e - f) / v, l[n - 1]), this.addSegmentFromArray(c, i, o, g), g = !1, i.c = !1)
                                } else i.c = !1;
                                f += s.addedLength, o += 1
                            }
                        if (i._length && (i.setXYAt(i.v[u][0], i.v[u][1], "i", u), i.setXYAt(i.v[i._length - 1][0], i.v[i._length - 1][1], "o", i._length - 1)), f > e.e) break;
                        r < p - 1 && (i = At.newElement(), g = !0, m.push(i), o = 0)
                    }
                    return m
                }, h([$t], Xt), Xt.prototype.initModifierProperties = function (t, e) {
                    this.getValue = this.processKeys, this.amount = yt.getProp(t, e.a, 0, null, this), this._isAnimated = !!this.amount.effectsSequence.length
                }, Xt.prototype.processPath = function (t, e) {
                    var i = e / 100,
                        r = [0, 0],
                        n = t._length,
                        a = 0;
                    for (a = 0; a < n; a += 1) r[0] += t.v[a][0], r[1] += t.v[a][1];
                    r[0] /= n, r[1] /= n;
                    var s, o, l, c, u, h, d = At.newElement();
                    for (d.c = t.c, a = 0; a < n; a += 1) s = t.v[a][0] + (r[0] - t.v[a][0]) * i, o = t.v[a][1] + (r[1] - t.v[a][1]) * i, l = t.o[a][0] + (r[0] - t.o[a][0]) * -i, c = t.o[a][1] + (r[1] - t.o[a][1]) * -i, u = t.i[a][0] + (r[0] - t.i[a][0]) * -i, h = t.i[a][1] + (r[1] - t.i[a][1]) * -i, d.setTripleAt(s, o, l, c, u, h, a);
                    return d
                }, Xt.prototype.processShapes = function (t) {
                    var e, i, r, n, a, s, o = this.shapes.length,
                        l = this.amount.v;
                    if (0 !== l)
                        for (i = 0; i < o; i += 1) {
                            if (s = (a = this.shapes[i]).localShapeCollection, a.shape._mdf || this._mdf || t)
                                for (s.releaseShapes(), a.shape._mdf = !0, e = a.shape.paths.shapes, n = a.shape.paths._length, r = 0; r < n; r += 1) s.addShape(this.processPath(e[r], l));
                            a.shape.paths = a.localShapeCollection
                        }
                    this.dynamicProperties.length || (this._mdf = !1)
                };
                var Kt = function () {
                    var t = [0, 0];

                    function e(t) {
                        var e = this._mdf;
                        this.iterateDynamicProperties(), this._mdf = this._mdf || e, this.a && t.translate(-this.a.v[0], -this.a.v[1], this.a.v[2]), this.s && t.scale(this.s.v[0], this.s.v[1], this.s.v[2]), this.sk && t.skewFromAxis(-this.sk.v, this.sa.v), this.r ? t.rotate(-this.r.v) : t.rotateZ(-this.rz.v).rotateY(this.ry.v).rotateX(this.rx.v).rotateZ(-this.or.v[2]).rotateY(this.or.v[1]).rotateX(this.or.v[0]), this.data.p.s ? this.data.p.z ? t.translate(this.px.v, this.py.v, -this.pz.v) : t.translate(this.px.v, this.py.v, 0) : t.translate(this.p.v[0], this.p.v[1], -this.p.v[2])
                    }

                    function i(e) {
                        if (this.elem.globalData.frameId !== this.frameId) {
                            if (this._isDirty && (this.precalculateMatrix(), this._isDirty = !1), this.iterateDynamicProperties(), this._mdf || e) {
                                var i;
                                if (this.v.cloneFromProps(this.pre.props), this.appliedTransformations < 1 && this.v.translate(-this.a.v[0], -this.a.v[1], this.a.v[2]), this.appliedTransformations < 2 && this.v.scale(this.s.v[0], this.s.v[1], this.s.v[2]), this.sk && this.appliedTransformations < 3 && this.v.skewFromAxis(-this.sk.v, this.sa.v), this.r && this.appliedTransformations < 4 ? this.v.rotate(-this.r.v) : !this.r && this.appliedTransformations < 4 && this.v.rotateZ(-this.rz.v).rotateY(this.ry.v).rotateX(this.rx.v).rotateZ(-this.or.v[2]).rotateY(this.or.v[1]).rotateX(this.or.v[0]), this.autoOriented) {
                                    var r, n;
                                    if (i = this.elem.globalData.frameRate, this.p && this.p.keyframes && this.p.getValueAtTime) this.p._caching.lastFrame + this.p.offsetTime <= this.p.keyframes[0].t ? (r = this.p.getValueAtTime((this.p.keyframes[0].t + .01) / i, 0), n = this.p.getValueAtTime(this.p.keyframes[0].t / i, 0)) : this.p._caching.lastFrame + this.p.offsetTime >= this.p.keyframes[this.p.keyframes.length - 1].t ? (r = this.p.getValueAtTime(this.p.keyframes[this.p.keyframes.length - 1].t / i, 0), n = this.p.getValueAtTime((this.p.keyframes[this.p.keyframes.length - 1].t - .05) / i, 0)) : (r = this.p.pv, n = this.p.getValueAtTime((this.p._caching.lastFrame + this.p.offsetTime - .01) / i, this.p.offsetTime));
                                    else if (this.px && this.px.keyframes && this.py.keyframes && this.px.getValueAtTime && this.py.getValueAtTime) {
                                        r = [], n = [];
                                        var a = this.px,
                                            s = this.py;
                                        a._caching.lastFrame + a.offsetTime <= a.keyframes[0].t ? (r[0] = a.getValueAtTime((a.keyframes[0].t + .01) / i, 0), r[1] = s.getValueAtTime((s.keyframes[0].t + .01) / i, 0), n[0] = a.getValueAtTime(a.keyframes[0].t / i, 0), n[1] = s.getValueAtTime(s.keyframes[0].t / i, 0)) : a._caching.lastFrame + a.offsetTime >= a.keyframes[a.keyframes.length - 1].t ? (r[0] = a.getValueAtTime(a.keyframes[a.keyframes.length - 1].t / i, 0), r[1] = s.getValueAtTime(s.keyframes[s.keyframes.length - 1].t / i, 0), n[0] = a.getValueAtTime((a.keyframes[a.keyframes.length - 1].t - .01) / i, 0), n[1] = s.getValueAtTime((s.keyframes[s.keyframes.length - 1].t - .01) / i, 0)) : (r = [a.pv, s.pv], n[0] = a.getValueAtTime((a._caching.lastFrame + a.offsetTime - .01) / i, a.offsetTime), n[1] = s.getValueAtTime((s._caching.lastFrame + s.offsetTime - .01) / i, s.offsetTime))
                                    } else r = n = t;
                                    this.v.rotate(-Math.atan2(r[1] - n[1], r[0] - n[0]))
                                }
                                this.data.p && this.data.p.s ? this.data.p.z ? this.v.translate(this.px.v, this.py.v, -this.pz.v) : this.v.translate(this.px.v, this.py.v, 0) : this.v.translate(this.p.v[0], this.p.v[1], -this.p.v[2])
                            }
                            this.frameId = this.elem.globalData.frameId
                        }
                    }

                    function r() {
                        if (!this.a.k && (this.pre.translate(-this.a.v[0], -this.a.v[1], this.a.v[2]), this.appliedTransformations = 1, !this.s.effectsSequence.length)) {
                            if (this.pre.scale(this.s.v[0], this.s.v[1], this.s.v[2]), this.appliedTransformations = 2, this.sk) {
                                if (this.sk.effectsSequence.length || this.sa.effectsSequence.length) return;
                                this.pre.skewFromAxis(-this.sk.v, this.sa.v), this.appliedTransformations = 3
                            }
                            this.r ? this.r.effectsSequence.length || (this.pre.rotate(-this.r.v), this.appliedTransformations = 4) : this.rz.effectsSequence.length || this.ry.effectsSequence.length || this.rx.effectsSequence.length || this.or.effectsSequence.length || (this.pre.rotateZ(-this.rz.v).rotateY(this.ry.v).rotateX(this.rx.v).rotateZ(-this.or.v[2]).rotateY(this.or.v[1]).rotateX(this.or.v[0]), this.appliedTransformations = 4)
                        }
                    }

                    function n() { }

                    function a(t) {
                        this._addDynamicProperty(t), this.elem.addDynamicProperty(t), this._isDirty = !0
                    }

                    function s(t, e, i) {
                        if (this.elem = t, this.frameId = -1, this.propType = "transform", this.data = e, this.v = new Tt, this.pre = new Tt, this.appliedTransformations = 0, this.initDynamicPropertyContainer(i || t), e.p && e.p.s ? (this.px = yt.getProp(t, e.p.x, 0, 0, this), this.py = yt.getProp(t, e.p.y, 0, 0, this), e.p.z && (this.pz = yt.getProp(t, e.p.z, 0, 0, this))) : this.p = yt.getProp(t, e.p || {
                            k: [0, 0, 0]
                        }, 1, 0, this), e.rx) {
                            if (this.rx = yt.getProp(t, e.rx, 0, M, this), this.ry = yt.getProp(t, e.ry, 0, M, this), this.rz = yt.getProp(t, e.rz, 0, M, this), e.or.k[0].ti) {
                                var r, n = e.or.k.length;
                                for (r = 0; r < n; r += 1) e.or.k[r].to = null, e.or.k[r].ti = null
                            }
                            this.or = yt.getProp(t, e.or, 1, M, this), this.or.sh = !0
                        } else this.r = yt.getProp(t, e.r || {
                            k: 0
                        }, 0, M, this);
                        e.sk && (this.sk = yt.getProp(t, e.sk, 0, M, this), this.sa = yt.getProp(t, e.sa, 0, M, this)), this.a = yt.getProp(t, e.a || {
                            k: [0, 0, 0]
                        }, 1, 0, this), this.s = yt.getProp(t, e.s || {
                            k: [100, 100, 100]
                        }, 1, .01, this), e.o ? this.o = yt.getProp(t, e.o, 0, .01, t) : this.o = {
                            _mdf: !1,
                            v: 1
                        }, this._isDirty = !0, this.dynamicProperties.length || this.getValue(!0)
                    }

                    function o(t, e, i) {
                        return new s(t, e, i)
                    }
                    return s.prototype = {
                        applyToMatrix: e,
                        getValue: i,
                        precalculateMatrix: r,
                        autoOrient: n
                    }, h([bt], s), s.prototype.addDynamicProperty = a, s.prototype._addDynamicProperty = bt.prototype.addDynamicProperty, {
                        getTransformProperty: o
                    }
                }();

                function Jt() { }

                function Qt() { }

                function te(t) {
                    for (var e = t.fStyle ? t.fStyle.split(" ") : [], i = "normal", r = "normal", n = e.length, a = 0; a < n; a += 1) switch (e[a].toLowerCase()) {
                        case "italic":
                            r = "italic";
                            break;
                        case "bold":
                            i = "700";
                            break;
                        case "black":
                            i = "900";
                            break;
                        case "medium":
                            i = "500";
                            break;
                        case "regular":
                        case "normal":
                            i = "400";
                            break;
                        case "light":
                        case "thin":
                            i = "200"
                    }
                    return {
                        style: r,
                        weight: t.fWeight || i
                    }
                }
                h([$t], Jt), Jt.prototype.initModifierProperties = function (t, e) {
                    this.getValue = this.processKeys, this.c = yt.getProp(t, e.c, 0, null, this), this.o = yt.getProp(t, e.o, 0, null, this), this.tr = Kt.getTransformProperty(t, e.tr, this), this.so = yt.getProp(t, e.tr.so, 0, .01, this), this.eo = yt.getProp(t, e.tr.eo, 0, .01, this), this.data = e, this.dynamicProperties.length || this.getValue(!0), this._isAnimated = !!this.dynamicProperties.length, this.pMatrix = new Tt, this.rMatrix = new Tt, this.sMatrix = new Tt, this.tMatrix = new Tt, this.matrix = new Tt
                }, Jt.prototype.applyTransforms = function (t, e, i, r, n, a) {
                    var s = a ? -1 : 1,
                        o = r.s.v[0] + (1 - r.s.v[0]) * (1 - n),
                        l = r.s.v[1] + (1 - r.s.v[1]) * (1 - n);
                    t.translate(r.p.v[0] * s * n, r.p.v[1] * s * n, r.p.v[2]), e.translate(-r.a.v[0], -r.a.v[1], r.a.v[2]), e.rotate(-r.r.v * s * n), e.translate(r.a.v[0], r.a.v[1], r.a.v[2]), i.translate(-r.a.v[0], -r.a.v[1], r.a.v[2]), i.scale(a ? 1 / o : o, a ? 1 / l : l), i.translate(r.a.v[0], r.a.v[1], r.a.v[2])
                }, Jt.prototype.init = function (t, e, i, r) {
                    for (this.elem = t, this.arr = e, this.pos = i, this.elemsData = r, this._currentCopies = 0, this._elements = [], this._groups = [], this.frameId = -1, this.initDynamicPropertyContainer(t), this.initModifierProperties(t, e[i]); i > 0;) i -= 1, this._elements.unshift(e[i]);
                    this.dynamicProperties.length ? this.k = !0 : this.getValue(!0)
                }, Jt.prototype.resetElements = function (t) {
                    var e, i = t.length;
                    for (e = 0; e < i; e += 1) t[e]._processed = !1, "gr" === t[e].ty && this.resetElements(t[e].it)
                }, Jt.prototype.cloneElements = function (t) {
                    var e = JSON.parse(JSON.stringify(t));
                    return this.resetElements(e), e
                }, Jt.prototype.changeGroupRender = function (t, e) {
                    var i, r = t.length;
                    for (i = 0; i < r; i += 1) t[i]._render = e, "gr" === t[i].ty && this.changeGroupRender(t[i].it, e)
                }, Jt.prototype.processShapes = function (t) {
                    var e, i, r, n, a, s = !1;
                    if (this._mdf || t) {
                        var o, l = Math.ceil(this.c.v);
                        if (this._groups.length < l) {
                            for (; this._groups.length < l;) {
                                var c = {
                                    it: this.cloneElements(this._elements),
                                    ty: "gr"
                                };
                                c.it.push({
                                    a: {
                                        a: 0,
                                        ix: 1,
                                        k: [0, 0]
                                    },
                                    nm: "Transform",
                                    o: {
                                        a: 0,
                                        ix: 7,
                                        k: 100
                                    },
                                    p: {
                                        a: 0,
                                        ix: 2,
                                        k: [0, 0]
                                    },
                                    r: {
                                        a: 1,
                                        ix: 6,
                                        k: [{
                                            s: 0,
                                            e: 0,
                                            t: 0
                                        }, {
                                            s: 0,
                                            e: 0,
                                            t: 1
                                        }]
                                    },
                                    s: {
                                        a: 0,
                                        ix: 3,
                                        k: [100, 100]
                                    },
                                    sa: {
                                        a: 0,
                                        ix: 5,
                                        k: 0
                                    },
                                    sk: {
                                        a: 0,
                                        ix: 4,
                                        k: 0
                                    },
                                    ty: "tr"
                                }), this.arr.splice(0, 0, c), this._groups.splice(0, 0, c), this._currentCopies += 1
                            }
                            this.elem.reloadShapes(), s = !0
                        }
                        for (a = 0, r = 0; r <= this._groups.length - 1; r += 1) {
                            if (o = a < l, this._groups[r]._render = o, this.changeGroupRender(this._groups[r].it, o), !o) {
                                var u = this.elemsData[r].it,
                                    h = u[u.length - 1];
                                0 !== h.transform.op.v ? (h.transform.op._mdf = !0, h.transform.op.v = 0) : h.transform.op._mdf = !1
                            }
                            a += 1
                        }
                        this._currentCopies = l;
                        var d = this.o.v,
                            p = d % 1,
                            f = d > 0 ? Math.floor(d) : Math.ceil(d),
                            m = this.pMatrix.props,
                            g = this.rMatrix.props,
                            v = this.sMatrix.props;
                        this.pMatrix.reset(), this.rMatrix.reset(), this.sMatrix.reset(), this.tMatrix.reset(), this.matrix.reset();
                        var y, b, _ = 0;
                        if (d > 0) {
                            for (; _ < f;) this.applyTransforms(this.pMatrix, this.rMatrix, this.sMatrix, this.tr, 1, !1), _ += 1;
                            p && (this.applyTransforms(this.pMatrix, this.rMatrix, this.sMatrix, this.tr, p, !1), _ += p)
                        } else if (d < 0) {
                            for (; _ > f;) this.applyTransforms(this.pMatrix, this.rMatrix, this.sMatrix, this.tr, 1, !0), _ -= 1;
                            p && (this.applyTransforms(this.pMatrix, this.rMatrix, this.sMatrix, this.tr, -p, !0), _ -= p)
                        }
                        for (r = 1 === this.data.m ? 0 : this._currentCopies - 1, n = 1 === this.data.m ? 1 : -1, a = this._currentCopies; a;) {
                            if (b = (i = (e = this.elemsData[r].it)[e.length - 1].transform.mProps.v.props).length, e[e.length - 1].transform.mProps._mdf = !0, e[e.length - 1].transform.op._mdf = !0, e[e.length - 1].transform.op.v = 1 === this._currentCopies ? this.so.v : this.so.v + (this.eo.v - this.so.v) * (r / (this._currentCopies - 1)), 0 !== _) {
                                for ((0 !== r && 1 === n || r !== this._currentCopies - 1 && -1 === n) && this.applyTransforms(this.pMatrix, this.rMatrix, this.sMatrix, this.tr, 1, !1), this.matrix.transform(g[0], g[1], g[2], g[3], g[4], g[5], g[6], g[7], g[8], g[9], g[10], g[11], g[12], g[13], g[14], g[15]), this.matrix.transform(v[0], v[1], v[2], v[3], v[4], v[5], v[6], v[7], v[8], v[9], v[10], v[11], v[12], v[13], v[14], v[15]), this.matrix.transform(m[0], m[1], m[2], m[3], m[4], m[5], m[6], m[7], m[8], m[9], m[10], m[11], m[12], m[13], m[14], m[15]), y = 0; y < b; y += 1) i[y] = this.matrix.props[y];
                                this.matrix.reset()
                            } else
                                for (this.matrix.reset(), y = 0; y < b; y += 1) i[y] = this.matrix.props[y];
                            _ += 1, a -= 1, r += n
                        }
                    } else
                        for (a = this._currentCopies, r = 0, n = 1; a;) i = (e = this.elemsData[r].it)[e.length - 1].transform.mProps.v.props, e[e.length - 1].transform.mProps._mdf = !1, e[e.length - 1].transform.op._mdf = !1, a -= 1, r += n;
                    return s
                }, Jt.prototype.addShape = function () { }, h([$t], Qt), Qt.prototype.initModifierProperties = function (t, e) {
                    this.getValue = this.processKeys, this.rd = yt.getProp(t, e.r, 0, null, this), this._isAnimated = !!this.rd.effectsSequence.length
                }, Qt.prototype.processPath = function (t, e) {
                    var i, r = At.newElement();
                    r.c = t.c;
                    var n, a, s, o, l, c, u, h, d, p, f, m, g = t._length,
                        v = 0;
                    for (i = 0; i < g; i += 1) n = t.v[i], s = t.o[i], a = t.i[i], n[0] === s[0] && n[1] === s[1] && n[0] === a[0] && n[1] === a[1] ? 0 !== i && i !== g - 1 || t.c ? (o = 0 === i ? t.v[g - 1] : t.v[i - 1], c = (l = Math.sqrt(Math.pow(n[0] - o[0], 2) + Math.pow(n[1] - o[1], 2))) ? Math.min(l / 2, e) / l : 0, u = f = n[0] + (o[0] - n[0]) * c, h = m = n[1] - (n[1] - o[1]) * c, d = u - (u - n[0]) * C, p = h - (h - n[1]) * C, r.setTripleAt(u, h, d, p, f, m, v), v += 1, o = i === g - 1 ? t.v[0] : t.v[i + 1], c = (l = Math.sqrt(Math.pow(n[0] - o[0], 2) + Math.pow(n[1] - o[1], 2))) ? Math.min(l / 2, e) / l : 0, u = d = n[0] + (o[0] - n[0]) * c, h = p = n[1] + (o[1] - n[1]) * c, f = u - (u - n[0]) * C, m = h - (h - n[1]) * C, r.setTripleAt(u, h, d, p, f, m, v), v += 1) : (r.setTripleAt(n[0], n[1], s[0], s[1], a[0], a[1], v), v += 1) : (r.setTripleAt(t.v[i][0], t.v[i][1], t.o[i][0], t.o[i][1], t.i[i][0], t.i[i][1], v), v += 1);
                    return r
                }, Qt.prototype.processShapes = function (t) {
                    var e, i, r, n, a, s, o = this.shapes.length,
                        l = this.rd.v;
                    if (0 !== l)
                        for (i = 0; i < o; i += 1) {
                            if (s = (a = this.shapes[i]).localShapeCollection, a.shape._mdf || this._mdf || t)
                                for (s.releaseShapes(), a.shape._mdf = !0, e = a.shape.paths.shapes, n = a.shape.paths._length, r = 0; r < n; r += 1) s.addShape(this.processPath(e[r], l));
                            a.shape.paths = a.localShapeCollection
                        }
                    this.dynamicProperties.length || (this._mdf = !1)
                };
                var ee = function () {
                    var t = 5e3,
                        e = {
                            w: 0,
                            size: 0,
                            shapes: [],
                            data: {
                                shapes: []
                            }
                        },
                        i = [];
                    i = i.concat([2304, 2305, 2306, 2307, 2362, 2363, 2364, 2364, 2366, 2367, 2368, 2369, 2370, 2371, 2372, 2373, 2374, 2375, 2376, 2377, 2378, 2379, 2380, 2381, 2382, 2383, 2387, 2388, 2389, 2390, 2391, 2402, 2403]);
                    var r = ["d83cdffb", "d83cdffc", "d83cdffd", "d83cdffe", "d83cdfff"],
                        n = [65039, 8205];

                    function a(t) {
                        var e, i = t.split(","),
                            r = i.length,
                            n = [];
                        for (e = 0; e < r; e += 1) "sans-serif" !== i[e] && "monospace" !== i[e] && n.push(i[e]);
                        return n.join(",")
                    }

                    function s(t, e) {
                        var i = u("span");
                        i.setAttribute("aria-hidden", !0), i.style.fontFamily = e;
                        var r = u("span");
                        r.innerText = "giItT1WQy@!-/#", i.style.position = "absolute", i.style.left = "-10000px", i.style.top = "-10000px", i.style.fontSize = "300px", i.style.fontVariant = "normal", i.style.fontStyle = "normal", i.style.fontWeight = "normal", i.style.letterSpacing = "0", i.appendChild(r), document.body.appendChild(i);
                        var n = r.offsetWidth;
                        return r.style.fontFamily = a(t) + ", " + e, {
                            node: r,
                            w: n,
                            parent: i
                        }
                    }

                    function o() {
                        var e, i, r, n = this.fonts.length,
                            a = n;
                        for (e = 0; e < n; e += 1) this.fonts[e].loaded ? a -= 1 : "n" === this.fonts[e].fOrigin || 0 === this.fonts[e].origin ? this.fonts[e].loaded = !0 : (i = this.fonts[e].monoCase.node, r = this.fonts[e].monoCase.w, i.offsetWidth !== r ? (a -= 1, this.fonts[e].loaded = !0) : (i = this.fonts[e].sansCase.node, r = this.fonts[e].sansCase.w, i.offsetWidth !== r && (a -= 1, this.fonts[e].loaded = !0)), this.fonts[e].loaded && (this.fonts[e].sansCase.parent.parentNode.removeChild(this.fonts[e].sansCase.parent), this.fonts[e].monoCase.parent.parentNode.removeChild(this.fonts[e].monoCase.parent)));
                        0 !== a && Date.now() - this.initTime < t ? setTimeout(this.checkLoadedFontsBinded, 20) : setTimeout(this.setIsLoadedBinded, 10)
                    }

                    function l(t, e) {
                        var i, r = document.body && e ? "svg" : "canvas",
                            n = te(t);
                        if ("svg" === r) {
                            var a = J("text");
                            a.style.fontSize = "100px", a.setAttribute("font-family", t.fFamily), a.setAttribute("font-style", n.style), a.setAttribute("font-weight", n.weight), a.textContent = "1", t.fClass ? (a.style.fontFamily = "inherit", a.setAttribute("class", t.fClass)) : a.style.fontFamily = t.fFamily, e.appendChild(a), i = a
                        } else {
                            var s = new OffscreenCanvas(500, 500).getContext("2d");
                            s.font = n.style + " " + n.weight + " 100px " + t.fFamily, i = s
                        }

                        function o(t) {
                            return "svg" === r ? (i.textContent = t, i.getComputedTextLength()) : i.measureText(t).width
                        }
                        return {
                            measureText: o
                        }
                    }

                    function c(t, e) {
                        if (t) {
                            if (this.chars) return this.isLoaded = !0, void (this.fonts = t.list);
                            if (!document.body) return this.isLoaded = !0, t.list.forEach((function (t) {
                                t.helper = l(t), t.cache = {}
                            })), void (this.fonts = t.list);
                            var i, r = t.list,
                                n = r.length,
                                a = n;
                            for (i = 0; i < n; i += 1) {
                                var o, c, h = !0;
                                if (r[i].loaded = !1, r[i].monoCase = s(r[i].fFamily, "monospace"), r[i].sansCase = s(r[i].fFamily, "sans-serif"), r[i].fPath) {
                                    if ("p" === r[i].fOrigin || 3 === r[i].origin) {
                                        if ((o = document.querySelectorAll('style[f-forigin="p"][f-family="' + r[i].fFamily + '"], style[f-origin="3"][f-family="' + r[i].fFamily + '"]')).length > 0 && (h = !1), h) {
                                            var d = u("style");
                                            d.setAttribute("f-forigin", r[i].fOrigin), d.setAttribute("f-origin", r[i].origin), d.setAttribute("f-family", r[i].fFamily), d.type = "text/css", d.innerText = "@font-face {font-family: " + r[i].fFamily + "; font-style: normal; src: url('" + r[i].fPath + "');}", e.appendChild(d)
                                        }
                                    } else if ("g" === r[i].fOrigin || 1 === r[i].origin) {
                                        for (o = document.querySelectorAll('link[f-forigin="g"], link[f-origin="1"]'), c = 0; c < o.length; c += 1) - 1 !== o[c].href.indexOf(r[i].fPath) && (h = !1);
                                        if (h) {
                                            var p = u("link");
                                            p.setAttribute("f-forigin", r[i].fOrigin), p.setAttribute("f-origin", r[i].origin), p.type = "text/css", p.rel = "stylesheet", p.href = r[i].fPath, document.body.appendChild(p)
                                        }
                                    } else if ("t" === r[i].fOrigin || 2 === r[i].origin) {
                                        for (o = document.querySelectorAll('script[f-forigin="t"], script[f-origin="2"]'), c = 0; c < o.length; c += 1) r[i].fPath === o[c].src && (h = !1);
                                        if (h) {
                                            var f = u("link");
                                            f.setAttribute("f-forigin", r[i].fOrigin), f.setAttribute("f-origin", r[i].origin), f.setAttribute("rel", "stylesheet"), f.setAttribute("href", r[i].fPath), e.appendChild(f)
                                        }
                                    }
                                } else r[i].loaded = !0, a -= 1;
                                r[i].helper = l(r[i], e), r[i].cache = {}, this.fonts.push(r[i])
                            }
                            0 === a ? this.isLoaded = !0 : setTimeout(this.checkLoadedFonts.bind(this), 100)
                        } else this.isLoaded = !0
                    }

                    function h(t) {
                        if (t) {
                            var e;
                            this.chars || (this.chars = []);
                            var i, r, n = t.length,
                                a = this.chars.length;
                            for (e = 0; e < n; e += 1) {
                                for (i = 0, r = !1; i < a;) this.chars[i].style === t[e].style && this.chars[i].fFamily === t[e].fFamily && this.chars[i].ch === t[e].ch && (r = !0), i += 1;
                                r || (this.chars.push(t[e]), a += 1)
                            }
                        }
                    }

                    function d(t, i, r) {
                        for (var n = 0, a = this.chars.length; n < a;) {
                            if (this.chars[n].ch === t && this.chars[n].style === i && this.chars[n].fFamily === r) return this.chars[n];
                            n += 1
                        }
                        return ("string" == typeof t && 13 !== t.charCodeAt(0) || !t) && console && console.warn && !this._warned && (this._warned = !0, console.warn("Missing character from exported characters list: ", t, i, r)), e
                    }

                    function p(t, e, i) {
                        var r = this.getFontByName(e),
                            n = t.charCodeAt(0);
                        if (!r.cache[n + 1]) {
                            var a = r.helper;
                            if (" " === t) {
                                var s = a.measureText("|" + t + "|"),
                                    o = a.measureText("||");
                                r.cache[n + 1] = (s - o) / 100
                            } else r.cache[n + 1] = a.measureText(t) / 100
                        }
                        return r.cache[n + 1] * i
                    }

                    function f(t) {
                        for (var e = 0, i = this.fonts.length; e < i;) {
                            if (this.fonts[e].fName === t) return this.fonts[e];
                            e += 1
                        }
                        return this.fonts[0]
                    }

                    function m(t, e) {
                        var i = t.toString(16) + e.toString(16);
                        return -1 !== r.indexOf(i)
                    }

                    function g(t, e) {
                        return e ? t === n[0] && e === n[1] : t === n[1]
                    }

                    function v(t) {
                        return -1 !== i.indexOf(t)
                    }

                    function y() {
                        this.isLoaded = !0
                    }
                    var b = function () {
                        this.fonts = [], this.chars = null, this.typekitLoaded = 0, this.isLoaded = !1, this._warned = !1, this.initTime = Date.now(), this.setIsLoadedBinded = this.setIsLoaded.bind(this), this.checkLoadedFontsBinded = this.checkLoadedFonts.bind(this)
                    };
                    b.isModifier = m, b.isZeroWidthJoiner = g, b.isCombinedCharacter = v;
                    var _ = {
                        addChars: h,
                        addFonts: c,
                        getCharData: d,
                        getFontByName: f,
                        measureText: p,
                        checkLoadedFonts: o,
                        setIsLoaded: y
                    };
                    return b.prototype = _, b
                }();

                function ie() { }
                ie.prototype = {
                    initRenderable: function () {
                        this.isInRange = !1, this.hidden = !1, this.isTransparent = !1, this.renderableComponents = []
                    },
                    addRenderableComponent: function (t) {
                        -1 === this.renderableComponents.indexOf(t) && this.renderableComponents.push(t)
                    },
                    removeRenderableComponent: function (t) {
                        -1 !== this.renderableComponents.indexOf(t) && this.renderableComponents.splice(this.renderableComponents.indexOf(t), 1)
                    },
                    prepareRenderableFrame: function (t) {
                        this.checkLayerLimits(t)
                    },
                    checkTransparency: function () {
                        this.finalTransform.mProp.o.v <= 0 ? !this.isTransparent && this.globalData.renderConfig.hideOnTransparent && (this.isTransparent = !0, this.hide()) : this.isTransparent && (this.isTransparent = !1, this.show())
                    },
                    checkLayerLimits: function (t) {
                        this.data.ip - this.data.st <= t && this.data.op - this.data.st > t ? !0 !== this.isInRange && (this.globalData._mdf = !0, this._mdf = !0, this.isInRange = !0, this.show()) : !1 !== this.isInRange && (this.globalData._mdf = !0, this.isInRange = !1, this.hide())
                    },
                    renderRenderable: function () {
                        var t, e = this.renderableComponents.length;
                        for (t = 0; t < e; t += 1) this.renderableComponents[t].renderFrame(this._isFirstFrame)
                    },
                    sourceRectAtTime: function () {
                        return {
                            top: 0,
                            left: 0,
                            width: 100,
                            height: 100
                        }
                    },
                    getLayerSize: function () {
                        return 5 === this.data.ty ? {
                            w: this.data.textData.width,
                            h: this.data.textData.height
                        } : {
                            w: this.data.width,
                            h: this.data.height
                        }
                    }
                };
                var re, ne = function () {
                    function t(t, e) {
                        this._mask = t, this._data = e
                    }
                    return Object.defineProperty(t.prototype, "maskPath", {
                        get: function () {
                            return this._mask.prop.k && this._mask.prop.getValue(), this._mask.prop
                        }
                    }), Object.defineProperty(t.prototype, "maskOpacity", {
                        get: function () {
                            return this._mask.op.k && this._mask.op.getValue(), 100 * this._mask.op.v
                        }
                    }),
                        function (e) {
                            var i, r = g(e.viewData.length),
                                n = e.viewData.length;
                            for (i = 0; i < n; i += 1) r[i] = new t(e.viewData[i], e.masksProperties[i]);
                            return function (t) {
                                for (i = 0; i < n;) {
                                    if (e.masksProperties[i].nm === t) return r[i];
                                    i += 1
                                }
                                return null
                            }
                        }
                }(),
                    ae = function () {
                        var t = {
                            pv: 0,
                            v: 0,
                            mult: 1
                        },
                            e = {
                                pv: [0, 0, 0],
                                v: [0, 0, 0],
                                mult: 1
                            };

                        function i(t, e, i) {
                            Object.defineProperty(t, "velocity", {
                                get: function () {
                                    return e.getVelocityAtTime(e.comp.currentFrame)
                                }
                            }), t.numKeys = e.keyframes ? e.keyframes.length : 0, t.key = function (r) {
                                if (!t.numKeys) return 0;
                                var n = "";
                                n = "s" in e.keyframes[r - 1] ? e.keyframes[r - 1].s : "e" in e.keyframes[r - 2] ? e.keyframes[r - 2].e : e.keyframes[r - 2].s;
                                var a = "unidimensional" === i ? new Number(n) : Object.assign({}, n);
                                return a.time = e.keyframes[r - 1].t / e.elem.comp.globalData.frameRate, a.value = "unidimensional" === i ? n[0] : n, a
                            }, t.valueAtTime = e.getValueAtTime, t.speedAtTime = e.getSpeedAtTime, t.velocityAtTime = e.getVelocityAtTime, t.propertyGroup = e.propertyGroup
                        }

                        function r(e) {
                            e && "pv" in e || (e = t);
                            var r = 1 / e.mult,
                                n = e.pv * r,
                                a = new Number(n);
                            return a.value = n, i(a, e, "unidimensional"),
                                function () {
                                    return e.k && e.getValue(), n = e.v * r, a.value !== n && ((a = new Number(n)).value = n, i(a, e, "unidimensional")), a
                                }
                        }

                        function n(t) {
                            t && "pv" in t || (t = e);
                            var r = 1 / t.mult,
                                n = t.data && t.data.l || t.pv.length,
                                a = m("float32", n),
                                s = m("float32", n);
                            return a.value = s, i(a, t, "multidimensional"),
                                function () {
                                    t.k && t.getValue();
                                    for (var e = 0; e < n; e += 1) s[e] = t.v[e] * r, a[e] = s[e];
                                    return a
                                }
                        }

                        function a() {
                            return t
                        }
                        return function (t) {
                            return t ? "unidimensional" === t.propType ? r(t) : n(t) : a
                        }
                    }(),
                    se = function (t) {
                        function e(t) {
                            switch (t) {
                                case "scale":
                                case "Scale":
                                case "ADBE Scale":
                                case 6:
                                    return e.scale;
                                case "rotation":
                                case "Rotation":
                                case "ADBE Rotation":
                                case "ADBE Rotate Z":
                                case 10:
                                    return e.rotation;
                                case "ADBE Rotate X":
                                    return e.xRotation;
                                case "ADBE Rotate Y":
                                    return e.yRotation;
                                case "position":
                                case "Position":
                                case "ADBE Position":
                                case 2:
                                    return e.position;
                                case "ADBE Position_0":
                                    return e.xPosition;
                                case "ADBE Position_1":
                                    return e.yPosition;
                                case "ADBE Position_2":
                                    return e.zPosition;
                                case "anchorPoint":
                                case "AnchorPoint":
                                case "Anchor Point":
                                case "ADBE AnchorPoint":
                                case 1:
                                    return e.anchorPoint;
                                case "opacity":
                                case "Opacity":
                                case 11:
                                    return e.opacity;
                                default:
                                    return null
                            }
                        }
                        var i, r, n, a;
                        return Object.defineProperty(e, "rotation", {
                            get: ae(t.r || t.rz)
                        }), Object.defineProperty(e, "zRotation", {
                            get: ae(t.rz || t.r)
                        }), Object.defineProperty(e, "xRotation", {
                            get: ae(t.rx)
                        }), Object.defineProperty(e, "yRotation", {
                            get: ae(t.ry)
                        }), Object.defineProperty(e, "scale", {
                            get: ae(t.s)
                        }), t.p ? a = ae(t.p) : (i = ae(t.px), r = ae(t.py), t.pz && (n = ae(t.pz))), Object.defineProperty(e, "position", {
                            get: function () {
                                return t.p ? a() : [i(), r(), n ? n() : 0]
                            }
                        }), Object.defineProperty(e, "xPosition", {
                            get: ae(t.px)
                        }), Object.defineProperty(e, "yPosition", {
                            get: ae(t.py)
                        }), Object.defineProperty(e, "zPosition", {
                            get: ae(t.pz)
                        }), Object.defineProperty(e, "anchorPoint", {
                            get: ae(t.a)
                        }), Object.defineProperty(e, "opacity", {
                            get: ae(t.o)
                        }), Object.defineProperty(e, "skew", {
                            get: ae(t.sk)
                        }), Object.defineProperty(e, "skewAxis", {
                            get: ae(t.sa)
                        }), Object.defineProperty(e, "orientation", {
                            get: ae(t.or)
                        }), e
                    },
                    oe = function () {
                        function t(t) {
                            var e = new Tt;
                            return void 0 !== t ? this._elem.finalTransform.mProp.getValueAtTime(t).clone(e) : this._elem.finalTransform.mProp.applyToMatrix(e), e
                        }

                        function e(t, e) {
                            var i = this.getMatrix(e);
                            return i.props[12] = 0, i.props[13] = 0, i.props[14] = 0, this.applyPoint(i, t)
                        }

                        function i(t, e) {
                            var i = this.getMatrix(e);
                            return this.applyPoint(i, t)
                        }

                        function r(t, e) {
                            var i = this.getMatrix(e);
                            return i.props[12] = 0, i.props[13] = 0, i.props[14] = 0, this.invertPoint(i, t)
                        }

                        function n(t, e) {
                            var i = this.getMatrix(e);
                            return this.invertPoint(i, t)
                        }

                        function a(t, e) {
                            if (this._elem.hierarchy && this._elem.hierarchy.length) {
                                var i, r = this._elem.hierarchy.length;
                                for (i = 0; i < r; i += 1) this._elem.hierarchy[i].finalTransform.mProp.applyToMatrix(t)
                            }
                            return t.applyToPointArray(e[0], e[1], e[2] || 0)
                        }

                        function s(t, e) {
                            if (this._elem.hierarchy && this._elem.hierarchy.length) {
                                var i, r = this._elem.hierarchy.length;
                                for (i = 0; i < r; i += 1) this._elem.hierarchy[i].finalTransform.mProp.applyToMatrix(t)
                            }
                            return t.inversePoint(e)
                        }

                        function o(t) {
                            var e = new Tt;
                            if (e.reset(), this._elem.finalTransform.mProp.applyToMatrix(e), this._elem.hierarchy && this._elem.hierarchy.length) {
                                var i, r = this._elem.hierarchy.length;
                                for (i = 0; i < r; i += 1) this._elem.hierarchy[i].finalTransform.mProp.applyToMatrix(e);
                                return e.inversePoint(t)
                            }
                            return e.inversePoint(t)
                        }

                        function l() {
                            return [1, 1, 1, 1]
                        }
                        return function (c) {
                            var u;

                            function h(t) {
                                f.mask = new ne(t, c)
                            }

                            function p(t) {
                                f.effect = t
                            }

                            function f(t) {
                                switch (t) {
                                    case "ADBE Root Vectors Group":
                                    case "Contents":
                                    case 2:
                                        return f.shapeInterface;
                                    case 1:
                                    case 6:
                                    case "Transform":
                                    case "transform":
                                    case "ADBE Transform Group":
                                        return u;
                                    case 4:
                                    case "ADBE Effect Parade":
                                    case "effects":
                                    case "Effects":
                                        return f.effect;
                                    case "ADBE Text Properties":
                                        return f.textInterface;
                                    default:
                                        return null
                                }
                            }
                            f.getMatrix = t, f.invertPoint = s, f.applyPoint = a, f.toWorld = i, f.toWorldVec = e, f.fromWorld = n, f.fromWorldVec = r, f.toComp = i, f.fromComp = o, f.sampleImage = l, f.sourceRectAtTime = c.sourceRectAtTime.bind(c), f._elem = c;
                            var m = d(u = se(c.finalTransform.mProp), "anchorPoint");
                            return Object.defineProperties(f, {
                                hasParent: {
                                    get: function () {
                                        return c.hierarchy.length
                                    }
                                },
                                parent: {
                                    get: function () {
                                        return c.hierarchy[0].layerInterface
                                    }
                                },
                                rotation: d(u, "rotation"),
                                scale: d(u, "scale"),
                                position: d(u, "position"),
                                opacity: d(u, "opacity"),
                                anchorPoint: m,
                                anchor_point: m,
                                transform: {
                                    get: function () {
                                        return u
                                    }
                                },
                                active: {
                                    get: function () {
                                        return c.isInRange
                                    }
                                }
                            }), f.startTime = c.data.st, f.index = c.data.ind, f.source = c.data.refId, f.height = 0 === c.data.ty ? c.data.h : 100, f.width = 0 === c.data.ty ? c.data.w : 100, f.inPoint = c.data.ip / c.comp.globalData.frameRate, f.outPoint = c.data.op / c.comp.globalData.frameRate, f._name = c.data.nm, f.registerMaskInterface = h, f.registerEffectsInterface = p, f
                        }
                    }(),
                    le = function (t, e) {
                        return function (i) {
                            return (i = void 0 === i ? 1 : i) <= 0 ? t : e(i - 1)
                        }
                    },
                    ce = function (t, e) {
                        var i = {
                            _name: t
                        };

                        function r(t) {
                            return (t = void 0 === t ? 1 : t) <= 0 ? i : e(t - 1)
                        }
                        return r
                    },
                    ue = function () {
                        function t(t, i) {
                            if (t.effectsManager) {
                                var r, n = [],
                                    a = t.data.ef,
                                    s = t.effectsManager.effectElements.length;
                                for (r = 0; r < s; r += 1) n.push(e(a[r], t.effectsManager.effectElements[r], i, t));
                                var o = t.data.ef || [],
                                    l = function (t) {
                                        for (r = 0, s = o.length; r < s;) {
                                            if (t === o[r].nm || t === o[r].mn || t === o[r].ix) return n[r];
                                            r += 1
                                        }
                                        return null
                                    };
                                return Object.defineProperty(l, "numProperties", {
                                    get: function () {
                                        return o.length
                                    }
                                }), l
                            }
                            return null
                        }

                        function e(t, r, n, a) {
                            function s(e) {
                                for (var i = t.ef, r = 0, n = i.length; r < n;) {
                                    if (e === i[r].nm || e === i[r].mn || e === i[r].ix) return 5 === i[r].ty ? c[r] : c[r]();
                                    r += 1
                                }
                                throw new Error
                            }
                            var o, l = le(s, n),
                                c = [],
                                u = t.ef.length;
                            for (o = 0; o < u; o += 1) 5 === t.ef[o].ty ? c.push(e(t.ef[o], r.effectElements[o], r.effectElements[o].propertyGroup, a)) : c.push(i(r.effectElements[o], t.ef[o].ty, a, l));
                            return "ADBE Color Control" === t.mn && Object.defineProperty(s, "color", {
                                get: function () {
                                    return c[0]()
                                }
                            }), Object.defineProperties(s, {
                                numProperties: {
                                    get: function () {
                                        return t.np
                                    }
                                },
                                _name: {
                                    value: t.nm
                                },
                                propertyGroup: {
                                    value: l
                                }
                            }), s.enabled = 0 !== t.en, s.active = s.enabled, s
                        }

                        function i(t, e, i, r) {
                            var n = ae(t.p);

                            function a() {
                                return 10 === e ? i.comp.compInterface(t.p.v) : n()
                            }
                            return t.p.setGroupProperty && t.p.setGroupProperty(ce("", r)), a
                        }
                        return {
                            createEffectsInterface: t
                        }
                    }(),
                    he = function (t) {
                        function e(e) {
                            for (var i = 0, r = t.layers.length; i < r;) {
                                if (t.layers[i].nm === e || t.layers[i].ind === e) return t.elements[i].layerInterface;
                                i += 1
                            }
                            return null
                        }
                        return Object.defineProperty(e, "_name", {
                            value: t.data.nm
                        }), e.layer = e, e.pixelAspect = 1, e.height = t.data.h || t.globalData.compSize.h, e.width = t.data.w || t.globalData.compSize.w, e.pixelAspect = 1, e.frameDuration = 1 / t.globalData.frameRate, e.displayStartTime = 0, e.numLayers = t.layers.length, e
                    },
                    de = function (t, e, i) {
                        var r = e.sh;

                        function n(t) {
                            return "Shape" === t || "shape" === t || "Path" === t || "path" === t || "ADBE Vector Shape" === t || 2 === t ? n.path : null
                        }
                        var a = le(n, i);
                        return r.setGroupProperty(ce("Path", a)), Object.defineProperties(n, {
                            path: {
                                get: function () {
                                    return r.k && r.getValue(), r
                                }
                            },
                            shape: {
                                get: function () {
                                    return r.k && r.getValue(), r
                                }
                            },
                            _name: {
                                value: t.nm
                            },
                            ix: {
                                value: t.ix
                            },
                            propertyIndex: {
                                value: t.ix
                            },
                            mn: {
                                value: t.mn
                            },
                            propertyGroup: {
                                value: i
                            }
                        }), n
                    },
                    pe = function () {
                        function t(t, e, l) {
                            var f, m = [],
                                g = t ? t.length : 0;
                            for (f = 0; f < g; f += 1) "gr" === t[f].ty ? m.push(i(t[f], e[f], l)) : "fl" === t[f].ty ? m.push(r(t[f], e[f], l)) : "st" === t[f].ty ? m.push(s(t[f], e[f], l)) : "tm" === t[f].ty ? m.push(o(t[f], e[f], l)) : "tr" === t[f].ty || ("el" === t[f].ty ? m.push(c(t[f], e[f], l)) : "sr" === t[f].ty ? m.push(u(t[f], e[f], l)) : "sh" === t[f].ty ? m.push(de(t[f], e[f], l)) : "rc" === t[f].ty ? m.push(h(t[f], e[f], l)) : "rd" === t[f].ty ? m.push(d(t[f], e[f], l)) : "rp" === t[f].ty ? m.push(p(t[f], e[f], l)) : "gf" === t[f].ty ? m.push(n(t[f], e[f], l)) : m.push(a(t[f], e[f], l)));
                            return m
                        }

                        function e(e, i, r) {
                            var n, a = function (t) {
                                for (var e = 0, i = n.length; e < i;) {
                                    if (n[e]._name === t || n[e].mn === t || n[e].propertyIndex === t || n[e].ix === t || n[e].ind === t) return n[e];
                                    e += 1
                                }
                                return "number" == typeof t ? n[t - 1] : null
                            };
                            a.propertyGroup = le(a, r), n = t(e.it, i.it, a.propertyGroup), a.numProperties = n.length;
                            var s = l(e.it[e.it.length - 1], i.it[i.it.length - 1], a.propertyGroup);
                            return a.transform = s, a.propertyIndex = e.cix, a._name = e.nm, a
                        }

                        function i(t, i, r) {
                            var n = function (t) {
                                switch (t) {
                                    case "ADBE Vectors Group":
                                    case "Contents":
                                    case 2:
                                        return n.content;
                                    default:
                                        return n.transform
                                }
                            };
                            n.propertyGroup = le(n, r);
                            var a = e(t, i, n.propertyGroup),
                                s = l(t.it[t.it.length - 1], i.it[i.it.length - 1], n.propertyGroup);
                            return n.content = a, n.transform = s, Object.defineProperty(n, "_name", {
                                get: function () {
                                    return t.nm
                                }
                            }), n.numProperties = t.np, n.propertyIndex = t.ix, n.nm = t.nm, n.mn = t.mn, n
                        }

                        function r(t, e, i) {
                            function r(t) {
                                return "Color" === t || "color" === t ? r.color : "Opacity" === t || "opacity" === t ? r.opacity : null
                            }
                            return Object.defineProperties(r, {
                                color: {
                                    get: ae(e.c)
                                },
                                opacity: {
                                    get: ae(e.o)
                                },
                                _name: {
                                    value: t.nm
                                },
                                mn: {
                                    value: t.mn
                                }
                            }), e.c.setGroupProperty(ce("Color", i)), e.o.setGroupProperty(ce("Opacity", i)), r
                        }

                        function n(t, e, i) {
                            function r(t) {
                                return "Start Point" === t || "start point" === t ? r.startPoint : "End Point" === t || "end point" === t ? r.endPoint : "Opacity" === t || "opacity" === t ? r.opacity : null
                            }
                            return Object.defineProperties(r, {
                                startPoint: {
                                    get: ae(e.s)
                                },
                                endPoint: {
                                    get: ae(e.e)
                                },
                                opacity: {
                                    get: ae(e.o)
                                },
                                type: {
                                    get: function () {
                                        return "a"
                                    }
                                },
                                _name: {
                                    value: t.nm
                                },
                                mn: {
                                    value: t.mn
                                }
                            }), e.s.setGroupProperty(ce("Start Point", i)), e.e.setGroupProperty(ce("End Point", i)), e.o.setGroupProperty(ce("Opacity", i)), r
                        }

                        function a() {
                            function t() {
                                return null
                            }
                            return t
                        }

                        function s(t, e, i) {
                            var r, n = le(c, i),
                                a = le(l, n);

                            function s(i) {
                                Object.defineProperty(l, t.d[i].nm, {
                                    get: ae(e.d.dataProps[i].p)
                                })
                            }
                            var o = t.d ? t.d.length : 0,
                                l = {};
                            for (r = 0; r < o; r += 1) s(r), e.d.dataProps[r].p.setGroupProperty(a);

                            function c(t) {
                                return "Color" === t || "color" === t ? c.color : "Opacity" === t || "opacity" === t ? c.opacity : "Stroke Width" === t || "stroke width" === t ? c.strokeWidth : null
                            }
                            return Object.defineProperties(c, {
                                color: {
                                    get: ae(e.c)
                                },
                                opacity: {
                                    get: ae(e.o)
                                },
                                strokeWidth: {
                                    get: ae(e.w)
                                },
                                dash: {
                                    get: function () {
                                        return l
                                    }
                                },
                                _name: {
                                    value: t.nm
                                },
                                mn: {
                                    value: t.mn
                                }
                            }), e.c.setGroupProperty(ce("Color", n)), e.o.setGroupProperty(ce("Opacity", n)), e.w.setGroupProperty(ce("Stroke Width", n)), c
                        }

                        function o(t, e, i) {
                            function r(e) {
                                return e === t.e.ix || "End" === e || "end" === e ? r.end : e === t.s.ix ? r.start : e === t.o.ix ? r.offset : null
                            }
                            var n = le(r, i);
                            return r.propertyIndex = t.ix, e.s.setGroupProperty(ce("Start", n)), e.e.setGroupProperty(ce("End", n)), e.o.setGroupProperty(ce("Offset", n)), r.propertyIndex = t.ix, r.propertyGroup = i, Object.defineProperties(r, {
                                start: {
                                    get: ae(e.s)
                                },
                                end: {
                                    get: ae(e.e)
                                },
                                offset: {
                                    get: ae(e.o)
                                },
                                _name: {
                                    value: t.nm
                                }
                            }), r.mn = t.mn, r
                        }

                        function l(t, e, i) {
                            function r(e) {
                                return t.a.ix === e || "Anchor Point" === e ? r.anchorPoint : t.o.ix === e || "Opacity" === e ? r.opacity : t.p.ix === e || "Position" === e ? r.position : t.r.ix === e || "Rotation" === e || "ADBE Vector Rotation" === e ? r.rotation : t.s.ix === e || "Scale" === e ? r.scale : t.sk && t.sk.ix === e || "Skew" === e ? r.skew : t.sa && t.sa.ix === e || "Skew Axis" === e ? r.skewAxis : null
                            }
                            var n = le(r, i);
                            return e.transform.mProps.o.setGroupProperty(ce("Opacity", n)), e.transform.mProps.p.setGroupProperty(ce("Position", n)), e.transform.mProps.a.setGroupProperty(ce("Anchor Point", n)), e.transform.mProps.s.setGroupProperty(ce("Scale", n)), e.transform.mProps.r.setGroupProperty(ce("Rotation", n)), e.transform.mProps.sk && (e.transform.mProps.sk.setGroupProperty(ce("Skew", n)), e.transform.mProps.sa.setGroupProperty(ce("Skew Angle", n))), e.transform.op.setGroupProperty(ce("Opacity", n)), Object.defineProperties(r, {
                                opacity: {
                                    get: ae(e.transform.mProps.o)
                                },
                                position: {
                                    get: ae(e.transform.mProps.p)
                                },
                                anchorPoint: {
                                    get: ae(e.transform.mProps.a)
                                },
                                scale: {
                                    get: ae(e.transform.mProps.s)
                                },
                                rotation: {
                                    get: ae(e.transform.mProps.r)
                                },
                                skew: {
                                    get: ae(e.transform.mProps.sk)
                                },
                                skewAxis: {
                                    get: ae(e.transform.mProps.sa)
                                },
                                _name: {
                                    value: t.nm
                                }
                            }), r.ty = "tr", r.mn = t.mn, r.propertyGroup = i, r
                        }

                        function c(t, e, i) {
                            function r(e) {
                                return t.p.ix === e ? r.position : t.s.ix === e ? r.size : null
                            }
                            var n = le(r, i);
                            r.propertyIndex = t.ix;
                            var a = "tm" === e.sh.ty ? e.sh.prop : e.sh;
                            return a.s.setGroupProperty(ce("Size", n)), a.p.setGroupProperty(ce("Position", n)), Object.defineProperties(r, {
                                size: {
                                    get: ae(a.s)
                                },
                                position: {
                                    get: ae(a.p)
                                },
                                _name: {
                                    value: t.nm
                                }
                            }), r.mn = t.mn, r
                        }

                        function u(t, e, i) {
                            function r(e) {
                                return t.p.ix === e ? r.position : t.r.ix === e ? r.rotation : t.pt.ix === e ? r.points : t.or.ix === e || "ADBE Vector Star Outer Radius" === e ? r.outerRadius : t.os.ix === e ? r.outerRoundness : !t.ir || t.ir.ix !== e && "ADBE Vector Star Inner Radius" !== e ? t.is && t.is.ix === e ? r.innerRoundness : null : r.innerRadius
                            }
                            var n = le(r, i),
                                a = "tm" === e.sh.ty ? e.sh.prop : e.sh;
                            return r.propertyIndex = t.ix, a.or.setGroupProperty(ce("Outer Radius", n)), a.os.setGroupProperty(ce("Outer Roundness", n)), a.pt.setGroupProperty(ce("Points", n)), a.p.setGroupProperty(ce("Position", n)), a.r.setGroupProperty(ce("Rotation", n)), t.ir && (a.ir.setGroupProperty(ce("Inner Radius", n)), a.is.setGroupProperty(ce("Inner Roundness", n))), Object.defineProperties(r, {
                                position: {
                                    get: ae(a.p)
                                },
                                rotation: {
                                    get: ae(a.r)
                                },
                                points: {
                                    get: ae(a.pt)
                                },
                                outerRadius: {
                                    get: ae(a.or)
                                },
                                outerRoundness: {
                                    get: ae(a.os)
                                },
                                innerRadius: {
                                    get: ae(a.ir)
                                },
                                innerRoundness: {
                                    get: ae(a.is)
                                },
                                _name: {
                                    value: t.nm
                                }
                            }), r.mn = t.mn, r
                        }

                        function h(t, e, i) {
                            function r(e) {
                                return t.p.ix === e ? r.position : t.r.ix === e ? r.roundness : t.s.ix === e || "Size" === e || "ADBE Vector Rect Size" === e ? r.size : null
                            }
                            var n = le(r, i),
                                a = "tm" === e.sh.ty ? e.sh.prop : e.sh;
                            return r.propertyIndex = t.ix, a.p.setGroupProperty(ce("Position", n)), a.s.setGroupProperty(ce("Size", n)), a.r.setGroupProperty(ce("Rotation", n)), Object.defineProperties(r, {
                                position: {
                                    get: ae(a.p)
                                },
                                roundness: {
                                    get: ae(a.r)
                                },
                                size: {
                                    get: ae(a.s)
                                },
                                _name: {
                                    value: t.nm
                                }
                            }), r.mn = t.mn, r
                        }

                        function d(t, e, i) {
                            function r(e) {
                                return t.r.ix === e || "Round Corners 1" === e ? r.radius : null
                            }
                            var n = le(r, i),
                                a = e;
                            return r.propertyIndex = t.ix, a.rd.setGroupProperty(ce("Radius", n)), Object.defineProperties(r, {
                                radius: {
                                    get: ae(a.rd)
                                },
                                _name: {
                                    value: t.nm
                                }
                            }), r.mn = t.mn, r
                        }

                        function p(t, e, i) {
                            function r(e) {
                                return t.c.ix === e || "Copies" === e ? r.copies : t.o.ix === e || "Offset" === e ? r.offset : null
                            }
                            var n = le(r, i),
                                a = e;
                            return r.propertyIndex = t.ix, a.c.setGroupProperty(ce("Copies", n)), a.o.setGroupProperty(ce("Offset", n)), Object.defineProperties(r, {
                                copies: {
                                    get: ae(a.c)
                                },
                                offset: {
                                    get: ae(a.o)
                                },
                                _name: {
                                    value: t.nm
                                }
                            }), r.mn = t.mn, r
                        }
                        return function (e, i, r) {
                            var n;

                            function a(t) {
                                if ("number" == typeof t) return 0 === (t = void 0 === t ? 1 : t) ? r : n[t - 1];
                                for (var e = 0, i = n.length; e < i;) {
                                    if (n[e]._name === t) return n[e];
                                    e += 1
                                }
                                return null
                            }

                            function s() {
                                return r
                            }
                            return a.propertyGroup = le(a, s), n = t(e, i, a.propertyGroup), a.numProperties = n.length, a._name = "Contents", a
                        }
                    }(),
                    fe = function (t) {
                        var e, i;

                        function r(t) {
                            return "ADBE Text Document" === t ? r.sourceText : null
                        }
                        return Object.defineProperty(r, "sourceText", {
                            get: function () {
                                t.textProperty.getValue();
                                var r = t.textProperty.currentData.t;
                                return r !== e && (t.textProperty.currentData.t = e, (i = new String(r)).value = r || new String(r)), i
                            }
                        }), r
                    },
                    me = (re = {
                        0: "source-over",
                        1: "multiply",
                        2: "screen",
                        3: "overlay",
                        4: "darken",
                        5: "lighten",
                        6: "color-dodge",
                        7: "color-burn",
                        8: "hard-light",
                        9: "soft-light",
                        10: "difference",
                        11: "exclusion",
                        12: "hue",
                        13: "saturation",
                        14: "color",
                        15: "luminosity"
                    }, function (t) {
                        return re[t] || ""
                    });

                function ge(t, e, i) {
                    this.p = yt.getProp(e, t.v, 0, 0, i)
                }

                function ve(t, e, i) {
                    this.p = yt.getProp(e, t.v, 0, 0, i)
                }

                function ye(t, e, i) {
                    this.p = yt.getProp(e, t.v, 1, 0, i)
                }

                function be(t, e, i) {
                    this.p = yt.getProp(e, t.v, 1, 0, i)
                }

                function _e(t, e, i) {
                    this.p = yt.getProp(e, t.v, 0, 0, i)
                }

                function we(t, e, i) {
                    this.p = yt.getProp(e, t.v, 0, 0, i)
                }

                function Ae(t, e, i) {
                    this.p = yt.getProp(e, t.v, 0, 0, i)
                }

                function Se() {
                    this.p = {}
                }

                function ke(t, e) {
                    var i, r = t.ef || [];
                    this.effectElements = [];
                    var n, a = r.length;
                    for (i = 0; i < a; i += 1) n = new xe(r[i], e), this.effectElements.push(n)
                }

                function xe(t, e) {
                    this.init(t, e)
                }

                function Te() { }

                function Ee() { }

                function Me(t) {
                    return Me = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
                        return typeof t
                    } : function (t) {
                        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t
                    }, Me(t)
                }
                h([bt], xe), xe.prototype.getValue = xe.prototype.iterateDynamicProperties, xe.prototype.init = function (t, e) {
                    var i;
                    this.data = t, this.effectElements = [], this.initDynamicPropertyContainer(e);
                    var r, n = this.data.ef.length,
                        a = this.data.ef;
                    for (i = 0; i < n; i += 1) {
                        switch (r = null, a[i].ty) {
                            case 0:
                                r = new ge(a[i], e, this);
                                break;
                            case 1:
                                r = new ve(a[i], e, this);
                                break;
                            case 2:
                                r = new ye(a[i], e, this);
                                break;
                            case 3:
                                r = new be(a[i], e, this);
                                break;
                            case 4:
                            case 7:
                                r = new Ae(a[i], e, this);
                                break;
                            case 10:
                                r = new _e(a[i], e, this);
                                break;
                            case 11:
                                r = new we(a[i], e, this);
                                break;
                            case 5:
                                r = new ke(a[i], e, this);
                                break;
                            default:
                                r = new Se(a[i], e, this)
                        }
                        r && this.effectElements.push(r)
                    }
                }, Te.prototype = {
                    checkMasks: function () {
                        if (!this.data.hasMask) return !1;
                        for (var t = 0, e = this.data.masksProperties.length; t < e;) {
                            if ("n" !== this.data.masksProperties[t].mode && !1 !== this.data.masksProperties[t].cl) return !0;
                            t += 1
                        }
                        return !1
                    },
                    initExpressions: function () {
                        this.layerInterface = oe(this), this.data.hasMask && this.maskManager && this.layerInterface.registerMaskInterface(this.maskManager);
                        var t = ue.createEffectsInterface(this, this.layerInterface);
                        this.layerInterface.registerEffectsInterface(t), 0 === this.data.ty || this.data.xt ? this.compInterface = he(this) : 4 === this.data.ty ? (this.layerInterface.shapeInterface = pe(this.shapesData, this.itemsData, this.layerInterface), this.layerInterface.content = this.layerInterface.shapeInterface) : 5 === this.data.ty && (this.layerInterface.textInterface = fe(this), this.layerInterface.text = this.layerInterface.textInterface)
                    },
                    setBlendMode: function () {
                        var t = me(this.data.bm);
                        (this.baseElement || this.layerElement).style["mix-blend-mode"] = t
                    },
                    initBaseData: function (t, e, i) {
                        this.globalData = e, this.comp = i, this.data = t, this.layerId = z(), this.data.sr || (this.data.sr = 1), this.effectsManager = new ke(this.data, this, this.dynamicProperties)
                    },
                    getType: function () {
                        return this.type
                    },
                    sourceRectAtTime: function () { }
                }, Ee.prototype = {
                    initFrame: function () {
                        this._isFirstFrame = !1, this.dynamicProperties = [], this._mdf = !1
                    },
                    prepareProperties: function (t, e) {
                        var i, r = this.dynamicProperties.length;
                        for (i = 0; i < r; i += 1)(e || this._isParent && "transform" === this.dynamicProperties[i].propType) && (this.dynamicProperties[i].getValue(), this.dynamicProperties[i]._mdf && (this.globalData._mdf = !0, this._mdf = !0))
                    },
                    addDynamicProperty: function (t) {
                        -1 === this.dynamicProperties.indexOf(t) && this.dynamicProperties.push(t)
                    }
                };
                var Ce, Pe, De = (Ce = function (t) {
                    var e = "",
                        i = t.getFootageData();

                    function r() {
                        return e = "", i = t.getFootageData(), n
                    }

                    function n(t) {
                        if (i[t]) return e = t, "object" === Me(i = i[t]) ? n : i;
                        var r = t.indexOf(e);
                        if (-1 !== r) {
                            var a = parseInt(t.substr(r + e.length), 10);
                            return "object" === Me(i = i[a]) ? n : i
                        }
                        return ""
                    }
                    return r
                }, Pe = function (t) {
                    function e(t) {
                        return "Outline" === t ? e.outlineInterface() : null
                    }
                    return e._name = "Outline", e.outlineInterface = Ce(t), e
                }, function (t) {
                    function e(t) {
                        return "Data" === t ? e.dataInterface : null
                    }
                    return e._name = "Data", e.dataInterface = Pe(t), e
                });

                function Le(t, e, i) {
                    this.initFrame(), this.initRenderable(), this.assetData = e.getAssetData(t.refId), this.footageData = e.imageLoader.getAsset(this.assetData), this.initBaseData(t, e, i)
                }

                function Oe(t, e, i) {
                    this.initFrame(), this.initRenderable(), this.assetData = e.getAssetData(t.refId), this.initBaseData(t, e, i), this._isPlaying = !1, this._canPlay = !1;
                    var r = this.globalData.getAssetsPath(this.assetData);
                    this.audio = this.globalData.audioController.createAudio(r), this._currentTime = 0, this.globalData.audioController.addAudio(this), this._volumeMultiplier = 1, this._volume = 1, this._previousVolume = null, this.tm = t.tm ? yt.getProp(this, t.tm, 0, e.frameRate, this) : {
                        _placeholder: !0
                    }, this.lv = yt.getProp(this, t.au && t.au.lv ? t.au.lv : {
                        k: [100]
                    }, 1, .01, this)
                }

                function Ie() { }

                function Re() { }

                function Fe(t, e, i) {
                    this.data = t, this.element = e, this.globalData = i, this.storedData = [], this.masksProperties = this.data.masksProperties || [], this.maskElement = null;
                    var r, n, a = this.globalData.defs,
                        s = this.masksProperties ? this.masksProperties.length : 0;
                    this.viewData = g(s), this.solidPath = "";
                    var o, l, u, h, d, p, f = this.masksProperties,
                        m = 0,
                        v = [],
                        y = z(),
                        b = "clipPath",
                        _ = "clip-path";
                    for (r = 0; r < s; r += 1)
                        if (("a" !== f[r].mode && "n" !== f[r].mode || f[r].inv || 100 !== f[r].o.k || f[r].o.x) && (b = "mask", _ = "mask"), "s" !== f[r].mode && "i" !== f[r].mode || 0 !== m ? u = null : ((u = J("rect")).setAttribute("fill", "#ffffff"), u.setAttribute("width", this.element.comp.data.w || 0), u.setAttribute("height", this.element.comp.data.h || 0), v.push(u)), n = J("path"), "n" === f[r].mode) this.viewData[r] = {
                            op: yt.getProp(this.element, f[r].o, 0, .01, this.element),
                            prop: xt.getShapeProp(this.element, f[r], 3),
                            elem: n,
                            lastPath: ""
                        }, a.appendChild(n);
                        else {
                            var w;
                            if (m += 1, n.setAttribute("fill", "s" === f[r].mode ? "#000000" : "#ffffff"), n.setAttribute("clip-rule", "nonzero"), 0 !== f[r].x.k ? (b = "mask", _ = "mask", p = yt.getProp(this.element, f[r].x, 0, null, this.element), w = z(), (h = J("filter")).setAttribute("id", w), (d = J("feMorphology")).setAttribute("operator", "erode"), d.setAttribute("in", "SourceGraphic"), d.setAttribute("radius", "0"), h.appendChild(d), a.appendChild(h), n.setAttribute("stroke", "s" === f[r].mode ? "#000000" : "#ffffff")) : (d = null, p = null), this.storedData[r] = {
                                elem: n,
                                x: p,
                                expan: d,
                                lastPath: "",
                                lastOperator: "",
                                filterId: w,
                                lastRadius: 0
                            }, "i" === f[r].mode) {
                                l = v.length;
                                var A = J("g");
                                for (o = 0; o < l; o += 1) A.appendChild(v[o]);
                                var S = J("mask");
                                S.setAttribute("mask-type", "alpha"), S.setAttribute("id", y + "_" + m), S.appendChild(n), a.appendChild(S), A.setAttribute("mask", "url(" + c() + "#" + y + "_" + m + ")"), v.length = 0, v.push(A)
                            } else v.push(n);
                            f[r].inv && !this.solidPath && (this.solidPath = this.createLayerSolidPath()), this.viewData[r] = {
                                elem: n,
                                lastPath: "",
                                op: yt.getProp(this.element, f[r].o, 0, .01, this.element),
                                prop: xt.getShapeProp(this.element, f[r], 3),
                                invRect: u
                            }, this.viewData[r].prop.k || this.drawPath(f[r], this.viewData[r].prop.v, this.viewData[r])
                        } for (this.maskElement = J(b), s = v.length, r = 0; r < s; r += 1) this.maskElement.appendChild(v[r]);
                    m > 0 && (this.maskElement.setAttribute("id", y), this.element.maskedElement.setAttribute(_, "url(" + c() + "#" + y + ")"), a.appendChild(this.maskElement)), this.viewData.length && this.element.addRenderableComponent(this)
                }
                Le.prototype.prepareFrame = function () { }, h([ie, Te, Ee], Le), Le.prototype.getBaseElement = function () {
                    return null
                }, Le.prototype.renderFrame = function () { }, Le.prototype.destroy = function () { }, Le.prototype.initExpressions = function () {
                    this.layerInterface = De(this)
                }, Le.prototype.getFootageData = function () {
                    return this.footageData
                }, Oe.prototype.prepareFrame = function (t) {
                    if (this.prepareRenderableFrame(t, !0), this.prepareProperties(t, !0), this.tm._placeholder) this._currentTime = t / this.data.sr;
                    else {
                        var e = this.tm.v;
                        this._currentTime = e
                    }
                    this._volume = this.lv.v[0];
                    var i = this._volume * this._volumeMultiplier;
                    this._previousVolume !== i && (this._previousVolume = i, this.audio.volume(i))
                }, h([ie, Te, Ee], Oe), Oe.prototype.renderFrame = function () {
                    this.isInRange && this._canPlay && (this._isPlaying ? (!this.audio.playing() || Math.abs(this._currentTime / this.globalData.frameRate - this.audio.seek()) > .1) && this.audio.seek(this._currentTime / this.globalData.frameRate) : (this.audio.play(), this.audio.seek(this._currentTime / this.globalData.frameRate), this._isPlaying = !0))
                }, Oe.prototype.show = function () { }, Oe.prototype.hide = function () {
                    this.audio.pause(), this._isPlaying = !1
                }, Oe.prototype.pause = function () {
                    this.audio.pause(), this._isPlaying = !1, this._canPlay = !1
                }, Oe.prototype.resume = function () {
                    this._canPlay = !0
                }, Oe.prototype.setRate = function (t) {
                    this.audio.rate(t)
                }, Oe.prototype.volume = function (t) {
                    this._volumeMultiplier = t, this._previousVolume = t * this._volume, this.audio.volume(this._previousVolume)
                }, Oe.prototype.getBaseElement = function () {
                    return null
                }, Oe.prototype.destroy = function () { }, Oe.prototype.sourceRectAtTime = function () { }, Oe.prototype.initExpressions = function () { }, Ie.prototype.checkLayers = function (t) {
                    var e, i, r = this.layers.length;
                    for (this.completeLayers = !0, e = r - 1; e >= 0; e -= 1) this.elements[e] || (i = this.layers[e]).ip - i.st <= t - this.layers[e].st && i.op - i.st > t - this.layers[e].st && this.buildItem(e), this.completeLayers = !!this.elements[e] && this.completeLayers;
                    this.checkPendingElements()
                }, Ie.prototype.createItem = function (t) {
                    switch (t.ty) {
                        case 2:
                            return this.createImage(t);
                        case 0:
                            return this.createComp(t);
                        case 1:
                            return this.createSolid(t);
                        case 3:
                        default:
                            return this.createNull(t);
                        case 4:
                            return this.createShape(t);
                        case 5:
                            return this.createText(t);
                        case 6:
                            return this.createAudio(t);
                        case 13:
                            return this.createCamera(t);
                        case 15:
                            return this.createFootage(t)
                    }
                }, Ie.prototype.createCamera = function () {
                    throw new Error("You're using a 3d camera. Try the html renderer.")
                }, Ie.prototype.createAudio = function (t) {
                    return new Oe(t, this.globalData, this)
                }, Ie.prototype.createFootage = function (t) {
                    return new Le(t, this.globalData, this)
                }, Ie.prototype.buildAllItems = function () {
                    var t, e = this.layers.length;
                    for (t = 0; t < e; t += 1) this.buildItem(t);
                    this.checkPendingElements()
                }, Ie.prototype.includeLayers = function (t) {
                    var e;
                    this.completeLayers = !1;
                    var i, r = t.length,
                        n = this.layers.length;
                    for (e = 0; e < r; e += 1)
                        for (i = 0; i < n;) {
                            if (this.layers[i].id === t[e].id) {
                                this.layers[i] = t[e];
                                break
                            }
                            i += 1
                        }
                }, Ie.prototype.setProjectInterface = function (t) {
                    this.globalData.projectInterface = t
                }, Ie.prototype.initItems = function () {
                    this.globalData.progressiveLoad || this.buildAllItems()
                }, Ie.prototype.buildElementParenting = function (t, e, i) {
                    for (var r = this.elements, n = this.layers, a = 0, s = n.length; a < s;) n[a].ind == e && (r[a] && !0 !== r[a] ? (i.push(r[a]), r[a].setAsParent(), void 0 !== n[a].parent ? this.buildElementParenting(t, n[a].parent, i) : t.setHierarchy(i)) : (this.buildItem(a), this.addPendingElement(t))), a += 1
                }, Ie.prototype.addPendingElement = function (t) {
                    this.pendingElements.push(t)
                }, Ie.prototype.searchExtraCompositions = function (t) {
                    var e, i = t.length;
                    for (e = 0; e < i; e += 1)
                        if (t[e].xt) {
                            var r = this.createComp(t[e]);
                            r.initExpressions(), this.globalData.projectInterface.registerComposition(r)
                        }
                }, Ie.prototype.getElementByPath = function (t) {
                    var e, i = t.shift();
                    if ("number" == typeof i) e = this.elements[i];
                    else {
                        var r, n = this.elements.length;
                        for (r = 0; r < n; r += 1)
                            if (this.elements[r].data.nm === i) {
                                e = this.elements[r];
                                break
                            }
                    }
                    return 0 === t.length ? e : e.getElementByPath(t)
                }, Ie.prototype.setupGlobalData = function (t, e) {
                    this.globalData.fontManager = new ee, this.globalData.fontManager.addChars(t.chars), this.globalData.fontManager.addFonts(t.fonts, e), this.globalData.getAssetData = this.animationItem.getAssetData.bind(this.animationItem), this.globalData.getAssetsPath = this.animationItem.getAssetsPath.bind(this.animationItem), this.globalData.imageLoader = this.animationItem.imagePreloader, this.globalData.audioController = this.animationItem.audioController, this.globalData.frameId = 0, this.globalData.frameRate = t.fr, this.globalData.nm = t.nm, this.globalData.compSize = {
                        w: t.w,
                        h: t.h
                    }
                }, Re.prototype = {
                    initTransform: function () {
                        this.finalTransform = {
                            mProp: this.data.ks ? Kt.getTransformProperty(this, this.data.ks, this) : {
                                o: 0
                            },
                            _matMdf: !1,
                            _opMdf: !1,
                            mat: new Tt
                        }, this.data.ao && (this.finalTransform.mProp.autoOriented = !0), this.data.ty
                    },
                    renderTransform: function () {
                        if (this.finalTransform._opMdf = this.finalTransform.mProp.o._mdf || this._isFirstFrame, this.finalTransform._matMdf = this.finalTransform.mProp._mdf || this._isFirstFrame, this.hierarchy) {
                            var t, e = this.finalTransform.mat,
                                i = 0,
                                r = this.hierarchy.length;
                            if (!this.finalTransform._matMdf)
                                for (; i < r;) {
                                    if (this.hierarchy[i].finalTransform.mProp._mdf) {
                                        this.finalTransform._matMdf = !0;
                                        break
                                    }
                                    i += 1
                                }
                            if (this.finalTransform._matMdf)
                                for (t = this.finalTransform.mProp.v.props, e.cloneFromProps(t), i = 0; i < r; i += 1) t = this.hierarchy[i].finalTransform.mProp.v.props, e.transform(t[0], t[1], t[2], t[3], t[4], t[5], t[6], t[7], t[8], t[9], t[10], t[11], t[12], t[13], t[14], t[15])
                        }
                    },
                    globalToLocal: function (t) {
                        var e = [];
                        e.push(this.finalTransform);
                        for (var i, r = !0, n = this.comp; r;) n.finalTransform ? (n.data.hasMask && e.splice(0, 0, n.finalTransform), n = n.comp) : r = !1;
                        var a, s = e.length;
                        for (i = 0; i < s; i += 1) a = e[i].mat.applyToPointArray(0, 0, 0), t = [t[0] - a[0], t[1] - a[1], 0];
                        return t
                    },
                    mHelper: new Tt
                }, Fe.prototype.getMaskProperty = function (t) {
                    return this.viewData[t].prop
                }, Fe.prototype.renderFrame = function (t) {
                    var e, i = this.element.finalTransform.mat,
                        r = this.masksProperties.length;
                    for (e = 0; e < r; e += 1)
                        if ((this.viewData[e].prop._mdf || t) && this.drawPath(this.masksProperties[e], this.viewData[e].prop.v, this.viewData[e]), (this.viewData[e].op._mdf || t) && this.viewData[e].elem.setAttribute("fill-opacity", this.viewData[e].op.v), "n" !== this.masksProperties[e].mode && (this.viewData[e].invRect && (this.element.finalTransform.mProp._mdf || t) && this.viewData[e].invRect.setAttribute("transform", i.getInverseMatrix().to2dCSS()), this.storedData[e].x && (this.storedData[e].x._mdf || t))) {
                            var n = this.storedData[e].expan;
                            this.storedData[e].x.v < 0 ? ("erode" !== this.storedData[e].lastOperator && (this.storedData[e].lastOperator = "erode", this.storedData[e].elem.setAttribute("filter", "url(" + c() + "#" + this.storedData[e].filterId + ")")), n.setAttribute("radius", -this.storedData[e].x.v)) : ("dilate" !== this.storedData[e].lastOperator && (this.storedData[e].lastOperator = "dilate", this.storedData[e].elem.setAttribute("filter", null)), this.storedData[e].elem.setAttribute("stroke-width", 2 * this.storedData[e].x.v))
                        }
                }, Fe.prototype.getMaskelement = function () {
                    return this.maskElement
                }, Fe.prototype.createLayerSolidPath = function () {
                    var t = "M0,0 ";
                    return t += " h" + this.globalData.compSize.w, t += " v" + this.globalData.compSize.h, t += " h-" + this.globalData.compSize.w, t += " v-" + this.globalData.compSize.h + " "
                }, Fe.prototype.drawPath = function (t, e, i) {
                    var r, n, a = " M" + e.v[0][0] + "," + e.v[0][1];
                    for (n = e._length, r = 1; r < n; r += 1) a += " C" + e.o[r - 1][0] + "," + e.o[r - 1][1] + " " + e.i[r][0] + "," + e.i[r][1] + " " + e.v[r][0] + "," + e.v[r][1];
                    if (e.c && n > 1 && (a += " C" + e.o[r - 1][0] + "," + e.o[r - 1][1] + " " + e.i[0][0] + "," + e.i[0][1] + " " + e.v[0][0] + "," + e.v[0][1]), i.lastPath !== a) {
                        var s = "";
                        i.elem && (e.c && (s = t.inv ? this.solidPath + a : a), i.elem.setAttribute("d", s)), i.lastPath = a
                    }
                }, Fe.prototype.destroy = function () {
                    this.element = null, this.globalData = null, this.maskElement = null, this.data = null, this.masksProperties = null
                };
                var Ne, Be = function () {
                    var t = {};

                    function e(t, e) {
                        var i = J("filter");
                        return i.setAttribute("id", t), !0 !== e && (i.setAttribute("filterUnits", "objectBoundingBox"), i.setAttribute("x", "0%"), i.setAttribute("y", "0%"), i.setAttribute("width", "100%"), i.setAttribute("height", "100%")), i
                    }

                    function i() {
                        var t = J("feColorMatrix");
                        return t.setAttribute("type", "matrix"), t.setAttribute("color-interpolation-filters", "sRGB"), t.setAttribute("values", "0 0 0 1 0  0 0 0 1 0  0 0 0 1 0  0 0 0 1 1"), t
                    }
                    return t.createFilter = e, t.createAlphaToLuminanceFilter = i, t
                }(),
                    ze = (Ne = {
                        maskType: !0
                    }, (/MSIE 10/i.test(navigator.userAgent) || /MSIE 9/i.test(navigator.userAgent) || /rv:11.0/i.test(navigator.userAgent) || /Edge\/\d./i.test(navigator.userAgent)) && (Ne.maskType = !1), Ne),
                    qe = {},
                    Ve = "filter_result_";

                function Ye(t) {
                    var e, i, r = "SourceGraphic",
                        n = t.data.ef ? t.data.ef.length : 0,
                        a = z(),
                        s = Be.createFilter(a, !0),
                        o = 0;
                    for (this.filters = [], e = 0; e < n; e += 1) {
                        i = null;
                        var l = t.data.ef[e].ty;
                        qe[l] && (i = new (0, qe[l].effect)(s, t.effectsManager.effectElements[e], t, Ve + o, r), r = Ve + o, qe[l].countsAsEffect && (o += 1)), i && this.filters.push(i)
                    }
                    o && (t.globalData.defs.appendChild(s), t.layerElement.setAttribute("filter", "url(" + c() + "#" + a + ")")), this.filters.length && t.addRenderableComponent(this)
                }

                function je() { }

                function Ge() { }

                function He() { }

                function We(t, e, i) {
                    this.assetData = e.getAssetData(t.refId), this.initElement(t, e, i), this.sourceRect = {
                        top: 0,
                        left: 0,
                        width: this.assetData.w,
                        height: this.assetData.h
                    }
                }

                function Ze(t, e) {
                    this.elem = t, this.pos = e
                }

                function $e() { }
                Ye.prototype.renderFrame = function (t) {
                    var e, i = this.filters.length;
                    for (e = 0; e < i; e += 1) this.filters[e].renderFrame(t)
                }, je.prototype = {
                    initRendererElement: function () {
                        this.layerElement = J("g")
                    },
                    createContainerElements: function () {
                        this.matteElement = J("g"), this.transformedElement = this.layerElement, this.maskedElement = this.layerElement, this._sizeChanged = !1;
                        var t, e, i, r = null;
                        if (this.data.td) {
                            if (3 == this.data.td || 1 == this.data.td) {
                                var n = J("mask");
                                n.setAttribute("id", this.layerId), n.setAttribute("mask-type", 3 == this.data.td ? "luminance" : "alpha"), n.appendChild(this.layerElement), r = n, this.globalData.defs.appendChild(n), ze.maskType || 1 != this.data.td || (n.setAttribute("mask-type", "luminance"), t = z(), e = Be.createFilter(t), this.globalData.defs.appendChild(e), e.appendChild(Be.createAlphaToLuminanceFilter()), (i = J("g")).appendChild(this.layerElement), r = i, n.appendChild(i), i.setAttribute("filter", "url(" + c() + "#" + t + ")"))
                            } else if (2 == this.data.td) {
                                var a = J("mask");
                                a.setAttribute("id", this.layerId), a.setAttribute("mask-type", "alpha");
                                var s = J("g");
                                a.appendChild(s), t = z(), e = Be.createFilter(t);
                                var o = J("feComponentTransfer");
                                o.setAttribute("in", "SourceGraphic"), e.appendChild(o);
                                var l = J("feFuncA");
                                l.setAttribute("type", "table"), l.setAttribute("tableValues", "1.0 0.0"), o.appendChild(l), this.globalData.defs.appendChild(e);
                                var u = J("rect");
                                u.setAttribute("width", this.comp.data.w), u.setAttribute("height", this.comp.data.h), u.setAttribute("x", "0"), u.setAttribute("y", "0"), u.setAttribute("fill", "#ffffff"), u.setAttribute("opacity", "0"), s.setAttribute("filter", "url(" + c() + "#" + t + ")"), s.appendChild(u), s.appendChild(this.layerElement), r = s, ze.maskType || (a.setAttribute("mask-type", "luminance"), e.appendChild(Be.createAlphaToLuminanceFilter()), i = J("g"), s.appendChild(u), i.appendChild(this.layerElement), r = i, s.appendChild(i)), this.globalData.defs.appendChild(a)
                            }
                        } else this.data.tt ? (this.matteElement.appendChild(this.layerElement), r = this.matteElement, this.baseElement = this.matteElement) : this.baseElement = this.layerElement;
                        if (this.data.ln && this.layerElement.setAttribute("id", this.data.ln), this.data.cl && this.layerElement.setAttribute("class", this.data.cl), 0 === this.data.ty && !this.data.hd) {
                            var h = J("clipPath"),
                                d = J("path");
                            d.setAttribute("d", "M0,0 L" + this.data.w + ",0 L" + this.data.w + "," + this.data.h + " L0," + this.data.h + "z");
                            var p = z();
                            if (h.setAttribute("id", p), h.appendChild(d), this.globalData.defs.appendChild(h), this.checkMasks()) {
                                var f = J("g");
                                f.setAttribute("clip-path", "url(" + c() + "#" + p + ")"), f.appendChild(this.layerElement), this.transformedElement = f, r ? r.appendChild(this.transformedElement) : this.baseElement = this.transformedElement
                            } else this.layerElement.setAttribute("clip-path", "url(" + c() + "#" + p + ")")
                        }
                        0 !== this.data.bm && this.setBlendMode()
                    },
                    renderElement: function () {
                        this.finalTransform._matMdf && this.transformedElement.setAttribute("transform", this.finalTransform.mat.to2dCSS()), this.finalTransform._opMdf && this.transformedElement.setAttribute("opacity", this.finalTransform.mProp.o.v)
                    },
                    destroyBaseElement: function () {
                        this.layerElement = null, this.matteElement = null, this.maskManager.destroy()
                    },
                    getBaseElement: function () {
                        return this.data.hd ? null : this.baseElement
                    },
                    createRenderableComponents: function () {
                        this.maskManager = new Fe(this.data, this, this.globalData), this.renderableEffectsManager = new Ye(this)
                    },
                    setMatte: function (t) {
                        this.matteElement && this.matteElement.setAttribute("mask", "url(" + c() + "#" + t + ")")
                    }
                }, Ge.prototype = {
                    initHierarchy: function () {
                        this.hierarchy = [], this._isParent = !1, this.checkParenting()
                    },
                    setHierarchy: function (t) {
                        this.hierarchy = t
                    },
                    setAsParent: function () {
                        this._isParent = !0
                    },
                    checkParenting: function () {
                        void 0 !== this.data.parent && this.comp.buildElementParenting(this, this.data.parent, [])
                    }
                }, h([ie, p({
                    initElement: function (t, e, i) {
                        this.initFrame(), this.initBaseData(t, e, i), this.initTransform(t, e, i), this.initHierarchy(), this.initRenderable(), this.initRendererElement(), this.createContainerElements(), this.createRenderableComponents(), this.createContent(), this.hide()
                    },
                    hide: function () {
                        this.hidden || this.isInRange && !this.isTransparent || ((this.baseElement || this.layerElement).style.display = "none", this.hidden = !0)
                    },
                    show: function () {
                        this.isInRange && !this.isTransparent && (this.data.hd || ((this.baseElement || this.layerElement).style.display = "block"), this.hidden = !1, this._isFirstFrame = !0)
                    },
                    renderFrame: function () {
                        this.data.hd || this.hidden || (this.renderTransform(), this.renderRenderable(), this.renderElement(), this.renderInnerContent(), this._isFirstFrame && (this._isFirstFrame = !1))
                    },
                    renderInnerContent: function () { },
                    prepareFrame: function (t) {
                        this._mdf = !1, this.prepareRenderableFrame(t), this.prepareProperties(t, this.isInRange), this.checkTransparency()
                    },
                    destroy: function () {
                        this.innerElem = null, this.destroyBaseElement()
                    }
                })], He), h([Te, Re, je, Ge, Ee, He], We), We.prototype.createContent = function () {
                    var t = this.globalData.getAssetsPath(this.assetData);
                    this.innerElem = J("image"), this.innerElem.setAttribute("width", this.assetData.w + "px"), this.innerElem.setAttribute("height", this.assetData.h + "px"), this.innerElem.setAttribute("preserveAspectRatio", this.assetData.pr || this.globalData.renderConfig.imagePreserveAspectRatio), this.innerElem.setAttributeNS("http://www.w3.org/1999/xlink", "href", t), this.layerElement.appendChild(this.innerElem)
                }, We.prototype.sourceRectAtTime = function () {
                    return this.sourceRect
                }, $e.prototype = {
                    addShapeToModifiers: function (t) {
                        var e, i = this.shapeModifiers.length;
                        for (e = 0; e < i; e += 1) this.shapeModifiers[e].addShape(t)
                    },
                    isShapeInAnimatedModifiers: function (t) {
                        for (var e = 0, i = this.shapeModifiers.length; e < i;)
                            if (this.shapeModifiers[e].isAnimatedWithShape(t)) return !0;
                        return !1
                    },
                    renderModifiers: function () {
                        if (this.shapeModifiers.length) {
                            var t, e = this.shapes.length;
                            for (t = 0; t < e; t += 1) this.shapes[t].sh.reset();
                            for (t = (e = this.shapeModifiers.length) - 1; t >= 0 && !this.shapeModifiers[t].processShapes(this._isFirstFrame); t -= 1);
                        }
                    },
                    searchProcessedElement: function (t) {
                        for (var e = this.processedElements, i = 0, r = e.length; i < r;) {
                            if (e[i].elem === t) return e[i].pos;
                            i += 1
                        }
                        return 0
                    },
                    addProcessedElement: function (t, e) {
                        for (var i = this.processedElements, r = i.length; r;)
                            if (i[r -= 1].elem === t) return void (i[r].pos = e);
                        i.push(new Ze(t, e))
                    },
                    prepareFrame: function (t) {
                        this.prepareRenderableFrame(t), this.prepareProperties(t, this.isInRange)
                    }
                };
                var Ue = {
                    1: "butt",
                    2: "round",
                    3: "square"
                },
                    Xe = {
                        1: "miter",
                        2: "round",
                        3: "bevel"
                    };

                function Ke(t, e, i) {
                    this.caches = [], this.styles = [], this.transformers = t, this.lStr = "", this.sh = i, this.lvl = e, this._isAnimated = !!i.k;
                    for (var r = 0, n = t.length; r < n;) {
                        if (t[r].mProps.dynamicProperties.length) {
                            this._isAnimated = !0;
                            break
                        }
                        r += 1
                    }
                }

                function Je(t, e) {
                    this.data = t, this.type = t.ty, this.d = "", this.lvl = e, this._mdf = !1, this.closed = !0 === t.hd, this.pElem = J("path"), this.msElem = null
                }

                function Qe(t, e, i, r) {
                    var n;
                    this.elem = t, this.frameId = -1, this.dataProps = g(e.length), this.renderer = i, this.k = !1, this.dashStr = "", this.dashArray = m("float32", e.length ? e.length - 1 : 0), this.dashoffset = m("float32", 1), this.initDynamicPropertyContainer(r);
                    var a, s = e.length || 0;
                    for (n = 0; n < s; n += 1) a = yt.getProp(t, e[n].v, 0, 0, this), this.k = a.k || this.k, this.dataProps[n] = {
                        n: e[n].n,
                        p: a
                    };
                    this.k || this.getValue(!0), this._isAnimated = this.k
                }

                function ti(t, e, i) {
                    this.initDynamicPropertyContainer(t), this.getValue = this.iterateDynamicProperties, this.o = yt.getProp(t, e.o, 0, .01, this), this.w = yt.getProp(t, e.w, 0, null, this), this.d = new Qe(t, e.d || {}, "svg", this), this.c = yt.getProp(t, e.c, 1, 255, this), this.style = i, this._isAnimated = !!this._isAnimated
                }

                function ei(t, e, i) {
                    this.initDynamicPropertyContainer(t), this.getValue = this.iterateDynamicProperties, this.o = yt.getProp(t, e.o, 0, .01, this), this.c = yt.getProp(t, e.c, 1, 255, this), this.style = i
                }

                function ii(t, e, i) {
                    this.initDynamicPropertyContainer(t), this.getValue = this.iterateDynamicProperties, this.style = i
                }

                function ri(t, e, i) {
                    this.data = e, this.c = m("uint8c", 4 * e.p);
                    var r = e.k.k[0].s ? e.k.k[0].s.length - 4 * e.p : e.k.k.length - 4 * e.p;
                    this.o = m("float32", r), this._cmdf = !1, this._omdf = !1, this._collapsable = this.checkCollapsable(), this._hasOpacity = r, this.initDynamicPropertyContainer(i), this.prop = yt.getProp(t, e.k, 1, null, this), this.k = this.prop.k, this.getValue(!0)
                }

                function ni(t, e, i) {
                    this.initDynamicPropertyContainer(t), this.getValue = this.iterateDynamicProperties, this.initGradientData(t, e, i)
                }

                function ai(t, e, i) {
                    this.initDynamicPropertyContainer(t), this.getValue = this.iterateDynamicProperties, this.w = yt.getProp(t, e.w, 0, null, this), this.d = new Qe(t, e.d || {}, "svg", this), this.initGradientData(t, e, i), this._isAnimated = !!this._isAnimated
                }

                function si() {
                    this.it = [], this.prevViewData = [], this.gr = J("g")
                }

                function oi(t, e, i) {
                    this.transform = {
                        mProps: t,
                        op: e,
                        container: i
                    }, this.elements = [], this._isAnimated = this.transform.mProps.dynamicProperties.length || this.transform.op.effectsSequence.length
                }
                Ke.prototype.setAsAnimated = function () {
                    this._isAnimated = !0
                }, Je.prototype.reset = function () {
                    this.d = "", this._mdf = !1
                }, Qe.prototype.getValue = function (t) {
                    if ((this.elem.globalData.frameId !== this.frameId || t) && (this.frameId = this.elem.globalData.frameId, this.iterateDynamicProperties(), this._mdf = this._mdf || t, this._mdf)) {
                        var e = 0,
                            i = this.dataProps.length;
                        for ("svg" === this.renderer && (this.dashStr = ""), e = 0; e < i; e += 1) "o" !== this.dataProps[e].n ? "svg" === this.renderer ? this.dashStr += " " + this.dataProps[e].p.v : this.dashArray[e] = this.dataProps[e].p.v : this.dashoffset[0] = this.dataProps[e].p.v
                    }
                }, h([bt], Qe), h([bt], ti), h([bt], ei), h([bt], ii), ri.prototype.comparePoints = function (t, e) {
                    for (var i = 0, r = this.o.length / 2; i < r;) {
                        if (Math.abs(t[4 * i] - t[4 * e + 2 * i]) > .01) return !1;
                        i += 1
                    }
                    return !0
                }, ri.prototype.checkCollapsable = function () {
                    if (this.o.length / 2 != this.c.length / 4) return !1;
                    if (this.data.k.k[0].s)
                        for (var t = 0, e = this.data.k.k.length; t < e;) {
                            if (!this.comparePoints(this.data.k.k[t].s, this.data.p)) return !1;
                            t += 1
                        } else if (!this.comparePoints(this.data.k.k, this.data.p)) return !1;
                    return !0
                }, ri.prototype.getValue = function (t) {
                    if (this.prop.getValue(), this._mdf = !1, this._cmdf = !1, this._omdf = !1, this.prop._mdf || t) {
                        var e, i, r, n = 4 * this.data.p;
                        for (e = 0; e < n; e += 1) i = e % 4 == 0 ? 100 : 255, r = Math.round(this.prop.v[e] * i), this.c[e] !== r && (this.c[e] = r, this._cmdf = !t);
                        if (this.o.length)
                            for (n = this.prop.v.length, e = 4 * this.data.p; e < n; e += 1) i = e % 2 == 0 ? 100 : 1, r = e % 2 == 0 ? Math.round(100 * this.prop.v[e]) : this.prop.v[e], this.o[e - 4 * this.data.p] !== r && (this.o[e - 4 * this.data.p] = r, this._omdf = !t);
                        this._mdf = !t
                    }
                }, h([bt], ri), ni.prototype.initGradientData = function (t, e, i) {
                    this.o = yt.getProp(t, e.o, 0, .01, this), this.s = yt.getProp(t, e.s, 1, null, this), this.e = yt.getProp(t, e.e, 1, null, this), this.h = yt.getProp(t, e.h || {
                        k: 0
                    }, 0, .01, this), this.a = yt.getProp(t, e.a || {
                        k: 0
                    }, 0, M, this), this.g = new ri(t, e.g, this), this.style = i, this.stops = [], this.setGradientData(i.pElem, e), this.setGradientOpacity(e, i), this._isAnimated = !!this._isAnimated
                }, ni.prototype.setGradientData = function (t, e) {
                    var i = z(),
                        r = J(1 === e.t ? "linearGradient" : "radialGradient");
                    r.setAttribute("id", i), r.setAttribute("spreadMethod", "pad"), r.setAttribute("gradientUnits", "userSpaceOnUse");
                    var n, a, s, o = [];
                    for (s = 4 * e.g.p, a = 0; a < s; a += 4) n = J("stop"), r.appendChild(n), o.push(n);
                    t.setAttribute("gf" === e.ty ? "fill" : "stroke", "url(" + c() + "#" + i + ")"), this.gf = r, this.cst = o
                }, ni.prototype.setGradientOpacity = function (t, e) {
                    if (this.g._hasOpacity && !this.g._collapsable) {
                        var i, r, n, a = J("mask"),
                            s = J("path");
                        a.appendChild(s);
                        var o = z(),
                            l = z();
                        a.setAttribute("id", l);
                        var u = J(1 === t.t ? "linearGradient" : "radialGradient");
                        u.setAttribute("id", o), u.setAttribute("spreadMethod", "pad"), u.setAttribute("gradientUnits", "userSpaceOnUse"), n = t.g.k.k[0].s ? t.g.k.k[0].s.length : t.g.k.k.length;
                        var h = this.stops;
                        for (r = 4 * t.g.p; r < n; r += 2)(i = J("stop")).setAttribute("stop-color", "rgb(255,255,255)"), u.appendChild(i), h.push(i);
                        s.setAttribute("gf" === t.ty ? "fill" : "stroke", "url(" + c() + "#" + o + ")"), "gs" === t.ty && (s.setAttribute("stroke-linecap", Ue[t.lc || 2]), s.setAttribute("stroke-linejoin", Xe[t.lj || 2]), 1 === t.lj && s.setAttribute("stroke-miterlimit", t.ml)), this.of = u, this.ms = a, this.ost = h, this.maskId = l, e.msElem = s
                    }
                }, h([bt], ni), h([ni, bt], ai);
                var li = function (t, e, i, r) {
                    if (0 === e) return "";
                    var n, a = t.o,
                        s = t.i,
                        o = t.v,
                        l = " M" + r.applyToPointStringified(o[0][0], o[0][1]);
                    for (n = 1; n < e; n += 1) l += " C" + r.applyToPointStringified(a[n - 1][0], a[n - 1][1]) + " " + r.applyToPointStringified(s[n][0], s[n][1]) + " " + r.applyToPointStringified(o[n][0], o[n][1]);
                    return i && e && (l += " C" + r.applyToPointStringified(a[n - 1][0], a[n - 1][1]) + " " + r.applyToPointStringified(s[0][0], s[0][1]) + " " + r.applyToPointStringified(o[0][0], o[0][1]), l += "z"), l
                },
                    ci = function () {
                        var t = new Tt,
                            e = new Tt;

                        function i(t) {
                            switch (t.ty) {
                                case "fl":
                                    return s;
                                case "gf":
                                    return l;
                                case "gs":
                                    return o;
                                case "st":
                                    return c;
                                case "sh":
                                case "el":
                                case "rc":
                                case "sr":
                                    return a;
                                case "tr":
                                    return r;
                                case "no":
                                    return n;
                                default:
                                    return null
                            }
                        }

                        function r(t, e, i) {
                            (i || e.transform.op._mdf) && e.transform.container.setAttribute("opacity", e.transform.op.v), (i || e.transform.mProps._mdf) && e.transform.container.setAttribute("transform", e.transform.mProps.v.to2dCSS())
                        }

                        function n() { }

                        function a(i, r, n) {
                            var a, s, o, l, c, u, h, d, p, f, m, g = r.styles.length,
                                v = r.lvl;
                            for (u = 0; u < g; u += 1) {
                                if (l = r.sh._mdf || n, r.styles[u].lvl < v) {
                                    for (d = e.reset(), f = v - r.styles[u].lvl, m = r.transformers.length - 1; !l && f > 0;) l = r.transformers[m].mProps._mdf || l, f -= 1, m -= 1;
                                    if (l)
                                        for (f = v - r.styles[u].lvl, m = r.transformers.length - 1; f > 0;) p = r.transformers[m].mProps.v.props, d.transform(p[0], p[1], p[2], p[3], p[4], p[5], p[6], p[7], p[8], p[9], p[10], p[11], p[12], p[13], p[14], p[15]), f -= 1, m -= 1
                                } else d = t;
                                if (s = (h = r.sh.paths)._length, l) {
                                    for (o = "", a = 0; a < s; a += 1)(c = h.shapes[a]) && c._length && (o += li(c, c._length, c.c, d));
                                    r.caches[u] = o
                                } else o = r.caches[u];
                                r.styles[u].d += !0 === i.hd ? "" : o, r.styles[u]._mdf = l || r.styles[u]._mdf
                            }
                        }

                        function s(t, e, i) {
                            var r = e.style;
                            (e.c._mdf || i) && r.pElem.setAttribute("fill", "rgb(" + k(e.c.v[0]) + "," + k(e.c.v[1]) + "," + k(e.c.v[2]) + ")"), (e.o._mdf || i) && r.pElem.setAttribute("fill-opacity", e.o.v)
                        }

                        function o(t, e, i) {
                            l(t, e, i), c(t, e, i)
                        }

                        function l(t, e, i) {
                            var r, n, a, s, o, l = e.gf,
                                c = e.g._hasOpacity,
                                u = e.s.v,
                                h = e.e.v;
                            if (e.o._mdf || i) {
                                var d = "gf" === t.ty ? "fill-opacity" : "stroke-opacity";
                                e.style.pElem.setAttribute(d, e.o.v)
                            }
                            if (e.s._mdf || i) {
                                var p = 1 === t.t ? "x1" : "cx",
                                    f = "x1" === p ? "y1" : "cy";
                                l.setAttribute(p, u[0]), l.setAttribute(f, u[1]), c && !e.g._collapsable && (e.of.setAttribute(p, u[0]), e.of.setAttribute(f, u[1]))
                            }
                            if (e.g._cmdf || i) {
                                r = e.cst;
                                var m = e.g.c;
                                for (a = r.length, n = 0; n < a; n += 1)(s = r[n]).setAttribute("offset", m[4 * n] + "%"), s.setAttribute("stop-color", "rgb(" + m[4 * n + 1] + "," + m[4 * n + 2] + "," + m[4 * n + 3] + ")")
                            }
                            if (c && (e.g._omdf || i)) {
                                var g = e.g.o;
                                for (a = (r = e.g._collapsable ? e.cst : e.ost).length, n = 0; n < a; n += 1) s = r[n], e.g._collapsable || s.setAttribute("offset", g[2 * n] + "%"), s.setAttribute("stop-opacity", g[2 * n + 1])
                            }
                            if (1 === t.t) (e.e._mdf || i) && (l.setAttribute("x2", h[0]), l.setAttribute("y2", h[1]), c && !e.g._collapsable && (e.of.setAttribute("x2", h[0]), e.of.setAttribute("y2", h[1])));
                            else if ((e.s._mdf || e.e._mdf || i) && (o = Math.sqrt(Math.pow(u[0] - h[0], 2) + Math.pow(u[1] - h[1], 2)), l.setAttribute("r", o), c && !e.g._collapsable && e.of.setAttribute("r", o)), e.e._mdf || e.h._mdf || e.a._mdf || i) {
                                o || (o = Math.sqrt(Math.pow(u[0] - h[0], 2) + Math.pow(u[1] - h[1], 2)));
                                var v = Math.atan2(h[1] - u[1], h[0] - u[0]),
                                    y = e.h.v;
                                y >= 1 ? y = .99 : y <= -1 && (y = -.99);
                                var b = o * y,
                                    _ = Math.cos(v + e.a.v) * b + u[0],
                                    w = Math.sin(v + e.a.v) * b + u[1];
                                l.setAttribute("fx", _), l.setAttribute("fy", w), c && !e.g._collapsable && (e.of.setAttribute("fx", _), e.of.setAttribute("fy", w))
                            }
                        }

                        function c(t, e, i) {
                            var r = e.style,
                                n = e.d;
                            n && (n._mdf || i) && n.dashStr && (r.pElem.setAttribute("stroke-dasharray", n.dashStr), r.pElem.setAttribute("stroke-dashoffset", n.dashoffset[0])), e.c && (e.c._mdf || i) && r.pElem.setAttribute("stroke", "rgb(" + k(e.c.v[0]) + "," + k(e.c.v[1]) + "," + k(e.c.v[2]) + ")"), (e.o._mdf || i) && r.pElem.setAttribute("stroke-opacity", e.o.v), (e.w._mdf || i) && (r.pElem.setAttribute("stroke-width", e.w.v), r.msElem && r.msElem.setAttribute("stroke-width", e.w.v))
                        }
                        return {
                            createRenderFunction: i
                        }
                    }();

                function ui(t, e, i) {
                    this.shapes = [], this.shapesData = t.shapes, this.stylesList = [], this.shapeModifiers = [], this.itemsData = [], this.processedElements = [], this.animatedContents = [], this.initElement(t, e, i), this.prevViewData = []
                }

                function hi(t, e, i, r, n, a) {
                    this.o = t, this.sw = e, this.sc = i, this.fc = r, this.m = n, this.p = a, this._mdf = {
                        o: !0,
                        sw: !!e,
                        sc: !!i,
                        fc: !!r,
                        m: !0,
                        p: !0
                    }
                }

                function di(t, e) {
                    this._frameId = a, this.pv = "", this.v = "", this.kf = !1, this._isFirstFrame = !0, this._mdf = !1, this.data = e, this.elem = t, this.comp = this.elem.comp, this.keysIndex = 0, this.canResize = !1, this.minimumFontSize = 1, this.effectsSequence = [], this.currentData = {
                        ascent: 0,
                        boxWidth: this.defaultBoxWidth,
                        f: "",
                        fStyle: "",
                        fWeight: "",
                        fc: "",
                        j: "",
                        justifyOffset: "",
                        l: [],
                        lh: 0,
                        lineWidths: [],
                        ls: "",
                        of: "",
                        s: "",
                        sc: "",
                        sw: 0,
                        t: 0,
                        tr: 0,
                        sz: 0,
                        ps: null,
                        fillColorAnim: !1,
                        strokeColorAnim: !1,
                        strokeWidthAnim: !1,
                        yOffset: 0,
                        finalSize: 0,
                        finalText: [],
                        finalLineHeight: 0,
                        __complete: !1
                    }, this.copyData(this.currentData, this.data.d.k[0].s), this.searchProperty() || this.completeTextData(this.currentData)
                }
                h([Te, Re, je, $e, Ge, Ee, He], ui), ui.prototype.initSecondaryElement = function () { }, ui.prototype.identityMatrix = new Tt, ui.prototype.buildExpressionInterface = function () { }, ui.prototype.createContent = function () {
                    this.searchShapes(this.shapesData, this.itemsData, this.prevViewData, this.layerElement, 0, [], !0), this.filterUniqueShapes()
                }, ui.prototype.filterUniqueShapes = function () {
                    var t, e, i, r, n = this.shapes.length,
                        a = this.stylesList.length,
                        s = [],
                        o = !1;
                    for (i = 0; i < a; i += 1) {
                        for (r = this.stylesList[i], o = !1, s.length = 0, t = 0; t < n; t += 1) - 1 !== (e = this.shapes[t]).styles.indexOf(r) && (s.push(e), o = e._isAnimated || o);
                        s.length > 1 && o && this.setShapesAsAnimated(s)
                    }
                }, ui.prototype.setShapesAsAnimated = function (t) {
                    var e, i = t.length;
                    for (e = 0; e < i; e += 1) t[e].setAsAnimated()
                }, ui.prototype.createStyleElement = function (t, e) {
                    var i, r = new Je(t, e),
                        n = r.pElem;
                    return "st" === t.ty ? i = new ti(this, t, r) : "fl" === t.ty ? i = new ei(this, t, r) : "gf" === t.ty || "gs" === t.ty ? (i = new ("gf" === t.ty ? ni : ai)(this, t, r), this.globalData.defs.appendChild(i.gf), i.maskId && (this.globalData.defs.appendChild(i.ms), this.globalData.defs.appendChild(i.of), n.setAttribute("mask", "url(" + c() + "#" + i.maskId + ")"))) : "no" === t.ty && (i = new ii(this, t, r)), "st" !== t.ty && "gs" !== t.ty || (n.setAttribute("stroke-linecap", Ue[t.lc || 2]), n.setAttribute("stroke-linejoin", Xe[t.lj || 2]), n.setAttribute("fill-opacity", "0"), 1 === t.lj && n.setAttribute("stroke-miterlimit", t.ml)), 2 === t.r && n.setAttribute("fill-rule", "evenodd"), t.ln && n.setAttribute("id", t.ln), t.cl && n.setAttribute("class", t.cl), t.bm && (n.style["mix-blend-mode"] = me(t.bm)), this.stylesList.push(r), this.addToAnimatedContents(t, i), i
                }, ui.prototype.createGroupElement = function (t) {
                    var e = new si;
                    return t.ln && e.gr.setAttribute("id", t.ln), t.cl && e.gr.setAttribute("class", t.cl), t.bm && (e.gr.style["mix-blend-mode"] = me(t.bm)), e
                }, ui.prototype.createTransformElement = function (t, e) {
                    var i = Kt.getTransformProperty(this, t, this),
                        r = new oi(i, i.o, e);
                    return this.addToAnimatedContents(t, r), r
                }, ui.prototype.createShapeElement = function (t, e, i) {
                    var r = 4;
                    "rc" === t.ty ? r = 5 : "el" === t.ty ? r = 6 : "sr" === t.ty && (r = 7);
                    var n = new Ke(e, i, xt.getShapeProp(this, t, r, this));
                    return this.shapes.push(n), this.addShapeToModifiers(n), this.addToAnimatedContents(t, n), n
                }, ui.prototype.addToAnimatedContents = function (t, e) {
                    for (var i = 0, r = this.animatedContents.length; i < r;) {
                        if (this.animatedContents[i].element === e) return;
                        i += 1
                    }
                    this.animatedContents.push({
                        fn: ci.createRenderFunction(t),
                        element: e,
                        data: t
                    })
                }, ui.prototype.setElementStyles = function (t) {
                    var e, i = t.styles,
                        r = this.stylesList.length;
                    for (e = 0; e < r; e += 1) this.stylesList[e].closed || i.push(this.stylesList[e])
                }, ui.prototype.reloadShapes = function () {
                    var t;
                    this._isFirstFrame = !0;
                    var e = this.itemsData.length;
                    for (t = 0; t < e; t += 1) this.prevViewData[t] = this.itemsData[t];
                    for (this.searchShapes(this.shapesData, this.itemsData, this.prevViewData, this.layerElement, 0, [], !0), this.filterUniqueShapes(), e = this.dynamicProperties.length, t = 0; t < e; t += 1) this.dynamicProperties[t].getValue();
                    this.renderModifiers()
                }, ui.prototype.searchShapes = function (t, e, i, r, n, a, s) {
                    var o, l, c, u, h, d, p = [].concat(a),
                        f = t.length - 1,
                        m = [],
                        g = [];
                    for (o = f; o >= 0; o -= 1) {
                        if ((d = this.searchProcessedElement(t[o])) ? e[o] = i[d - 1] : t[o]._render = s, "fl" === t[o].ty || "st" === t[o].ty || "gf" === t[o].ty || "gs" === t[o].ty || "no" === t[o].ty) d ? e[o].style.closed = !1 : e[o] = this.createStyleElement(t[o], n), t[o]._render && e[o].style.pElem.parentNode !== r && r.appendChild(e[o].style.pElem), m.push(e[o].style);
                        else if ("gr" === t[o].ty) {
                            if (d)
                                for (c = e[o].it.length, l = 0; l < c; l += 1) e[o].prevViewData[l] = e[o].it[l];
                            else e[o] = this.createGroupElement(t[o]);
                            this.searchShapes(t[o].it, e[o].it, e[o].prevViewData, e[o].gr, n + 1, p, s), t[o]._render && e[o].gr.parentNode !== r && r.appendChild(e[o].gr)
                        } else "tr" === t[o].ty ? (d || (e[o] = this.createTransformElement(t[o], r)), u = e[o].transform, p.push(u)) : "sh" === t[o].ty || "rc" === t[o].ty || "el" === t[o].ty || "sr" === t[o].ty ? (d || (e[o] = this.createShapeElement(t[o], p, n)), this.setElementStyles(e[o])) : "tm" === t[o].ty || "rd" === t[o].ty || "ms" === t[o].ty || "pb" === t[o].ty ? (d ? (h = e[o]).closed = !1 : ((h = Zt.getModifier(t[o].ty)).init(this, t[o]), e[o] = h, this.shapeModifiers.push(h)), g.push(h)) : "rp" === t[o].ty && (d ? (h = e[o]).closed = !0 : (h = Zt.getModifier(t[o].ty), e[o] = h, h.init(this, t, o, e), this.shapeModifiers.push(h), s = !1), g.push(h));
                        this.addProcessedElement(t[o], o + 1)
                    }
                    for (f = m.length, o = 0; o < f; o += 1) m[o].closed = !0;
                    for (f = g.length, o = 0; o < f; o += 1) g[o].closed = !0
                }, ui.prototype.renderInnerContent = function () {
                    var t;
                    this.renderModifiers();
                    var e = this.stylesList.length;
                    for (t = 0; t < e; t += 1) this.stylesList[t].reset();
                    for (this.renderShape(), t = 0; t < e; t += 1)(this.stylesList[t]._mdf || this._isFirstFrame) && (this.stylesList[t].msElem && (this.stylesList[t].msElem.setAttribute("d", this.stylesList[t].d), this.stylesList[t].d = "M0 0" + this.stylesList[t].d), this.stylesList[t].pElem.setAttribute("d", this.stylesList[t].d || "M0 0"))
                }, ui.prototype.renderShape = function () {
                    var t, e, i = this.animatedContents.length;
                    for (t = 0; t < i; t += 1) e = this.animatedContents[t], (this._isFirstFrame || e.element._isAnimated) && !0 !== e.data && e.fn(e.data, e.element, this._isFirstFrame)
                }, ui.prototype.destroy = function () {
                    this.destroyBaseElement(), this.shapesData = null, this.itemsData = null
                }, hi.prototype.update = function (t, e, i, r, n, a) {
                    this._mdf.o = !1, this._mdf.sw = !1, this._mdf.sc = !1, this._mdf.fc = !1, this._mdf.m = !1, this._mdf.p = !1;
                    var s = !1;
                    return this.o !== t && (this.o = t, this._mdf.o = !0, s = !0), this.sw !== e && (this.sw = e, this._mdf.sw = !0, s = !0), this.sc !== i && (this.sc = i, this._mdf.sc = !0, s = !0), this.fc !== r && (this.fc = r, this._mdf.fc = !0, s = !0), this.m !== n && (this.m = n, this._mdf.m = !0, s = !0), !a.length || this.p[0] === a[0] && this.p[1] === a[1] && this.p[4] === a[4] && this.p[5] === a[5] && this.p[12] === a[12] && this.p[13] === a[13] || (this.p = a, this._mdf.p = !0, s = !0), s
                }, di.prototype.defaultBoxWidth = [0, 0], di.prototype.copyData = function (t, e) {
                    for (var i in e) Object.prototype.hasOwnProperty.call(e, i) && (t[i] = e[i]);
                    return t
                }, di.prototype.setCurrentData = function (t) {
                    t.__complete || this.completeTextData(t), this.currentData = t, this.currentData.boxWidth = this.currentData.boxWidth || this.defaultBoxWidth, this._mdf = !0
                }, di.prototype.searchProperty = function () {
                    return this.searchKeyframes()
                }, di.prototype.searchKeyframes = function () {
                    return this.kf = this.data.d.k.length > 1, this.kf && this.addEffect(this.getKeyframeValue.bind(this)), this.kf
                }, di.prototype.addEffect = function (t) {
                    this.effectsSequence.push(t), this.elem.addDynamicProperty(this)
                }, di.prototype.getValue = function (t) {
                    if (this.elem.globalData.frameId !== this.frameId && this.effectsSequence.length || t) {
                        this.currentData.t = this.data.d.k[this.keysIndex].s.t;
                        var e = this.currentData,
                            i = this.keysIndex;
                        if (this.lock) this.setCurrentData(this.currentData);
                        else {
                            var r;
                            this.lock = !0, this._mdf = !1;
                            var n = this.effectsSequence.length,
                                a = t || this.data.d.k[this.keysIndex].s;
                            for (r = 0; r < n; r += 1) a = i !== this.keysIndex ? this.effectsSequence[r](a, a.t) : this.effectsSequence[r](this.currentData, a.t);
                            e !== a && this.setCurrentData(a), this.v = this.currentData, this.pv = this.v, this.lock = !1, this.frameId = this.elem.globalData.frameId
                        }
                    }
                }, di.prototype.getKeyframeValue = function () {
                    for (var t = this.data.d.k, e = this.elem.comp.renderedFrame, i = 0, r = t.length; i <= r - 1 && !(i === r - 1 || t[i + 1].t > e);) i += 1;
                    return this.keysIndex !== i && (this.keysIndex = i), this.data.d.k[this.keysIndex].s
                }, di.prototype.buildFinalText = function (t) {
                    for (var e, i, r = [], n = 0, a = t.length, s = !1; n < a;) e = t.charCodeAt(n), ee.isCombinedCharacter(e) ? r[r.length - 1] += t.charAt(n) : e >= 55296 && e <= 56319 ? (i = t.charCodeAt(n + 1)) >= 56320 && i <= 57343 ? (s || ee.isModifier(e, i) ? (r[r.length - 1] += t.substr(n, 2), s = !1) : r.push(t.substr(n, 2)), n += 1) : r.push(t.charAt(n)) : e > 56319 ? (i = t.charCodeAt(n + 1), ee.isZeroWidthJoiner(e, i) ? (s = !0, r[r.length - 1] += t.substr(n, 2), n += 1) : r.push(t.charAt(n))) : ee.isZeroWidthJoiner(e) ? (r[r.length - 1] += t.charAt(n), s = !0) : r.push(t.charAt(n)), n += 1;
                    return r
                }, di.prototype.completeTextData = function (t) {
                    t.__complete = !0;
                    var e, i, r, n, a, s, o, l = this.elem.globalData.fontManager,
                        c = this.data,
                        u = [],
                        h = 0,
                        d = c.m.g,
                        p = 0,
                        f = 0,
                        m = 0,
                        g = [],
                        v = 0,
                        y = 0,
                        b = l.getFontByName(t.f),
                        _ = 0,
                        w = te(b);
                    t.fWeight = w.weight, t.fStyle = w.style, t.finalSize = t.s, t.finalText = this.buildFinalText(t.t), i = t.finalText.length, t.finalLineHeight = t.lh;
                    var A, S = t.tr / 1e3 * t.finalSize;
                    if (t.sz)
                        for (var k, x, T = !0, E = t.sz[0], M = t.sz[1]; T;) {
                            k = 0, v = 0, i = (x = this.buildFinalText(t.t)).length, S = t.tr / 1e3 * t.finalSize;
                            var C = -1;
                            for (e = 0; e < i; e += 1) A = x[e].charCodeAt(0), r = !1, " " === x[e] ? C = e : 13 !== A && 3 !== A || (v = 0, r = !0, k += t.finalLineHeight || 1.2 * t.finalSize), l.chars ? (o = l.getCharData(x[e], b.fStyle, b.fFamily), _ = r ? 0 : o.w * t.finalSize / 100) : _ = l.measureText(x[e], t.f, t.finalSize), v + _ > E && " " !== x[e] ? (-1 === C ? i += 1 : e = C, k += t.finalLineHeight || 1.2 * t.finalSize, x.splice(e, C === e ? 1 : 0, "\r"), C = -1, v = 0) : (v += _, v += S);
                            k += b.ascent * t.finalSize / 100, this.canResize && t.finalSize > this.minimumFontSize && M < k ? (t.finalSize -= 1, t.finalLineHeight = t.finalSize * t.lh / t.s) : (t.finalText = x, i = t.finalText.length, T = !1)
                        }
                    v = -S, _ = 0;
                    var P, D = 0;
                    for (e = 0; e < i; e += 1)
                        if (r = !1, 13 === (A = (P = t.finalText[e]).charCodeAt(0)) || 3 === A ? (D = 0, g.push(v), y = v > y ? v : y, v = -2 * S, n = "", r = !0, m += 1) : n = P, l.chars ? (o = l.getCharData(P, b.fStyle, l.getFontByName(t.f).fFamily), _ = r ? 0 : o.w * t.finalSize / 100) : _ = l.measureText(n, t.f, t.finalSize), " " === P ? D += _ + S : (v += _ + S + D, D = 0), u.push({
                            l: _,
                            an: _,
                            add: p,
                            n: r,
                            anIndexes: [],
                            val: n,
                            line: m,
                            animatorJustifyOffset: 0
                        }), 2 == d) {
                            if (p += _, "" === n || " " === n || e === i - 1) {
                                for ("" !== n && " " !== n || (p -= _); f <= e;) u[f].an = p, u[f].ind = h, u[f].extra = _, f += 1;
                                h += 1, p = 0
                            }
                        } else if (3 == d) {
                            if (p += _, "" === n || e === i - 1) {
                                for ("" === n && (p -= _); f <= e;) u[f].an = p, u[f].ind = h, u[f].extra = _, f += 1;
                                p = 0, h += 1
                            }
                        } else u[h].ind = h, u[h].extra = 0, h += 1;
                    if (t.l = u, y = v > y ? v : y, g.push(v), t.sz) t.boxWidth = t.sz[0], t.justifyOffset = 0;
                    else switch (t.boxWidth = y, t.j) {
                        case 1:
                            t.justifyOffset = -t.boxWidth;
                            break;
                        case 2:
                            t.justifyOffset = -t.boxWidth / 2;
                            break;
                        default:
                            t.justifyOffset = 0
                    }
                    t.lineWidths = g;
                    var L, O, I, R, F = c.a;
                    s = F.length;
                    var N = [];
                    for (a = 0; a < s; a += 1) {
                        for ((L = F[a]).a.sc && (t.strokeColorAnim = !0), L.a.sw && (t.strokeWidthAnim = !0), (L.a.fc || L.a.fh || L.a.fs || L.a.fb) && (t.fillColorAnim = !0), R = 0, I = L.s.b, e = 0; e < i; e += 1)(O = u[e]).anIndexes[a] = R, (1 == I && "" !== O.val || 2 == I && "" !== O.val && " " !== O.val || 3 == I && (O.n || " " == O.val || e == i - 1) || 4 == I && (O.n || e == i - 1)) && (1 === L.s.rn && N.push(R), R += 1);
                        c.a[a].s.totalChars = R;
                        var B, z = -1;
                        if (1 === L.s.rn)
                            for (e = 0; e < i; e += 1) z != (O = u[e]).anIndexes[a] && (z = O.anIndexes[a], B = N.splice(Math.floor(Math.random() * N.length), 1)[0]), O.anIndexes[a] = B
                    }
                    t.yOffset = t.finalLineHeight || 1.2 * t.finalSize, t.ls = t.ls || 0, t.ascent = b.ascent * t.finalSize / 100
                }, di.prototype.updateDocumentData = function (t, e) {
                    e = void 0 === e ? this.keysIndex : e;
                    var i = this.copyData({}, this.data.d.k[e].s);
                    i = this.copyData(i, t), this.data.d.k[e].s = i, this.recalculate(e), this.elem.addDynamicProperty(this)
                }, di.prototype.recalculate = function (t) {
                    var e = this.data.d.k[t].s;
                    e.__complete = !1, this.keysIndex = 0, this._isFirstFrame = !0, this.getValue(e)
                }, di.prototype.canResizeFont = function (t) {
                    this.canResize = t, this.recalculate(this.keysIndex), this.elem.addDynamicProperty(this)
                }, di.prototype.setMinimumFontSize = function (t) {
                    this.minimumFontSize = Math.floor(t) || 1, this.recalculate(this.keysIndex), this.elem.addDynamicProperty(this)
                };
                var pi = function () {
                    var t = Math.max,
                        e = Math.min,
                        i = Math.floor;

                    function r(t, e) {
                        this._currentTextLength = -1, this.k = !1, this.data = e, this.elem = t, this.comp = t.comp, this.finalS = 0, this.finalE = 0, this.initDynamicPropertyContainer(t), this.s = yt.getProp(t, e.s || {
                            k: 0
                        }, 0, 0, this), this.e = "e" in e ? yt.getProp(t, e.e, 0, 0, this) : {
                            v: 100
                        }, this.o = yt.getProp(t, e.o || {
                            k: 0
                        }, 0, 0, this), this.xe = yt.getProp(t, e.xe || {
                            k: 0
                        }, 0, 0, this), this.ne = yt.getProp(t, e.ne || {
                            k: 0
                        }, 0, 0, this), this.sm = yt.getProp(t, e.sm || {
                            k: 100
                        }, 0, 0, this), this.a = yt.getProp(t, e.a, 0, .01, this), this.dynamicProperties.length || this.getValue()
                    }

                    function n(t, e, i) {
                        return new r(t, e, i)
                    }
                    return r.prototype = {
                        getMult: function (r) {
                            this._currentTextLength !== this.elem.textProperty.currentData.l.length && this.getValue();
                            var n = 0,
                                a = 0,
                                s = 1,
                                o = 1;
                            this.ne.v > 0 ? n = this.ne.v / 100 : a = -this.ne.v / 100, this.xe.v > 0 ? s = 1 - this.xe.v / 100 : o = 1 + this.xe.v / 100;
                            var l = ht.getBezierEasing(n, a, s, o).get,
                                c = 0,
                                u = this.finalS,
                                h = this.finalE,
                                d = this.data.sh;
                            if (2 === d) c = l(c = h === u ? r >= h ? 1 : 0 : t(0, e(.5 / (h - u) + (r - u) / (h - u), 1)));
                            else if (3 === d) c = l(c = h === u ? r >= h ? 0 : 1 : 1 - t(0, e(.5 / (h - u) + (r - u) / (h - u), 1)));
                            else if (4 === d) h === u ? c = 0 : (c = t(0, e(.5 / (h - u) + (r - u) / (h - u), 1))) < .5 ? c *= 2 : c = 1 - 2 * (c - .5), c = l(c);
                            else if (5 === d) {
                                if (h === u) c = 0;
                                else {
                                    var p = h - u,
                                        f = -p / 2 + (r = e(t(0, r + .5 - u), h - u)),
                                        m = p / 2;
                                    c = Math.sqrt(1 - f * f / (m * m))
                                }
                                c = l(c)
                            } else 6 === d ? (h === u ? c = 0 : (r = e(t(0, r + .5 - u), h - u), c = (1 + Math.cos(Math.PI + 2 * Math.PI * r / (h - u))) / 2), c = l(c)) : (r >= i(u) && (c = t(0, e(r - u < 0 ? e(h, 1) - (u - r) : h - r, 1))), c = l(c));
                            if (100 !== this.sm.v) {
                                var g = .01 * this.sm.v;
                                0 === g && (g = 1e-8);
                                var v = .5 - .5 * g;
                                c < v ? c = 0 : (c = (c - v) / g) > 1 && (c = 1)
                            }
                            return c * this.a.v
                        },
                        getValue: function (t) {
                            this.iterateDynamicProperties(), this._mdf = t || this._mdf, this._currentTextLength = this.elem.textProperty.currentData.l.length || 0, t && 2 === this.data.r && (this.e.v = this._currentTextLength);
                            var e = 2 === this.data.r ? 1 : 100 / this.data.totalChars,
                                i = this.o.v / e,
                                r = this.s.v / e + i,
                                n = this.e.v / e + i;
                            if (r > n) {
                                var a = r;
                                r = n, n = a
                            }
                            this.finalS = r, this.finalE = n
                        }
                    }, h([bt], r), {
                        getTextSelectorProp: n
                    }
                }();

                function fi(t, e, i) {
                    var r = {
                        propType: !1
                    },
                        n = yt.getProp,
                        a = e.a;
                    this.a = {
                        r: a.r ? n(t, a.r, 0, M, i) : r,
                        rx: a.rx ? n(t, a.rx, 0, M, i) : r,
                        ry: a.ry ? n(t, a.ry, 0, M, i) : r,
                        sk: a.sk ? n(t, a.sk, 0, M, i) : r,
                        sa: a.sa ? n(t, a.sa, 0, M, i) : r,
                        s: a.s ? n(t, a.s, 1, .01, i) : r,
                        a: a.a ? n(t, a.a, 1, 0, i) : r,
                        o: a.o ? n(t, a.o, 0, .01, i) : r,
                        p: a.p ? n(t, a.p, 1, 0, i) : r,
                        sw: a.sw ? n(t, a.sw, 0, 0, i) : r,
                        sc: a.sc ? n(t, a.sc, 1, 0, i) : r,
                        fc: a.fc ? n(t, a.fc, 1, 0, i) : r,
                        fh: a.fh ? n(t, a.fh, 0, 0, i) : r,
                        fs: a.fs ? n(t, a.fs, 0, .01, i) : r,
                        fb: a.fb ? n(t, a.fb, 0, .01, i) : r,
                        t: a.t ? n(t, a.t, 0, 0, i) : r
                    }, this.s = pi.getTextSelectorProp(t, e.s, i), this.s.t = e.s.t
                }

                function mi(t, e, i) {
                    this._isFirstFrame = !0, this._hasMaskedPath = !1, this._frameId = -1, this._textData = t, this._renderType = e, this._elem = i, this._animatorsData = g(this._textData.a.length), this._pathData = {}, this._moreOptions = {
                        alignment: {}
                    }, this.renderedLetters = [], this.lettersChangedFlag = !1, this.initDynamicPropertyContainer(i)
                }

                function gi() { }
                mi.prototype.searchProperties = function () {
                    var t, e, i = this._textData.a.length,
                        r = yt.getProp;
                    for (t = 0; t < i; t += 1) e = this._textData.a[t], this._animatorsData[t] = new fi(this._elem, e, this);
                    this._textData.p && "m" in this._textData.p ? (this._pathData = {
                        a: r(this._elem, this._textData.p.a, 0, 0, this),
                        f: r(this._elem, this._textData.p.f, 0, 0, this),
                        l: r(this._elem, this._textData.p.l, 0, 0, this),
                        r: r(this._elem, this._textData.p.r, 0, 0, this),
                        p: r(this._elem, this._textData.p.p, 0, 0, this),
                        m: this._elem.maskManager.getMaskProperty(this._textData.p.m)
                    }, this._hasMaskedPath = !0) : this._hasMaskedPath = !1, this._moreOptions.alignment = r(this._elem, this._textData.m.a, 1, 0, this)
                }, mi.prototype.getMeasures = function (t, e) {
                    if (this.lettersChangedFlag = e, this._mdf || this._isFirstFrame || e || this._hasMaskedPath && this._pathData.m._mdf) {
                        this._isFirstFrame = !1;
                        var i, r, n, a, s, o, l, c, u, h, d, p, f, m, g, v, y, b, _, w = this._moreOptions.alignment.v,
                            A = this._animatorsData,
                            S = this._textData,
                            k = this.mHelper,
                            x = this._renderType,
                            T = this.renderedLetters.length,
                            E = t.l;
                        if (this._hasMaskedPath) {
                            if (_ = this._pathData.m, !this._pathData.n || this._pathData._mdf) {
                                var M, C = _.v;
                                for (this._pathData.r.v && (C = C.reverse()), s = {
                                    tLength: 0,
                                    segments: []
                                }, a = C._length - 1, v = 0, n = 0; n < a; n += 1) M = vt.buildBezierData(C.v[n], C.v[n + 1], [C.o[n][0] - C.v[n][0], C.o[n][1] - C.v[n][1]], [C.i[n + 1][0] - C.v[n + 1][0], C.i[n + 1][1] - C.v[n + 1][1]]), s.tLength += M.segmentLength, s.segments.push(M), v += M.segmentLength;
                                n = a, _.v.c && (M = vt.buildBezierData(C.v[n], C.v[0], [C.o[n][0] - C.v[n][0], C.o[n][1] - C.v[n][1]], [C.i[0][0] - C.v[0][0], C.i[0][1] - C.v[0][1]]), s.tLength += M.segmentLength, s.segments.push(M), v += M.segmentLength), this._pathData.pi = s
                            }
                            if (s = this._pathData.pi, o = this._pathData.f.v, d = 0, h = 1, c = 0, u = !0, m = s.segments, o < 0 && _.v.c)
                                for (s.tLength < Math.abs(o) && (o = -Math.abs(o) % s.tLength), h = (f = m[d = m.length - 1].points).length - 1; o < 0;) o += f[h].partialLength, (h -= 1) < 0 && (h = (f = m[d -= 1].points).length - 1);
                            p = (f = m[d].points)[h - 1], g = (l = f[h]).partialLength
                        }
                        a = E.length, i = 0, r = 0;
                        var P, D, L, O, I, R = 1.2 * t.finalSize * .714,
                            F = !0;
                        L = A.length;
                        var N, B, z, q, V, H, W, Z, $, U, X, K, J = -1,
                            Q = o,
                            tt = d,
                            et = h,
                            it = -1,
                            rt = "",
                            nt = this.defaultPropsArray;
                        if (2 === t.j || 1 === t.j) {
                            var at = 0,
                                st = 0,
                                ot = 2 === t.j ? -.5 : -1,
                                lt = 0,
                                ct = !0;
                            for (n = 0; n < a; n += 1)
                                if (E[n].n) {
                                    for (at && (at += st); lt < n;) E[lt].animatorJustifyOffset = at, lt += 1;
                                    at = 0, ct = !0
                                } else {
                                    for (D = 0; D < L; D += 1)(P = A[D].a).t.propType && (ct && 2 === t.j && (st += P.t.v * ot), (I = A[D].s.getMult(E[n].anIndexes[D], S.a[D].s.totalChars)).length ? at += P.t.v * I[0] * ot : at += P.t.v * I * ot);
                                    ct = !1
                                } for (at && (at += st); lt < n;) E[lt].animatorJustifyOffset = at, lt += 1
                        }
                        for (n = 0; n < a; n += 1) {
                            if (k.reset(), q = 1, E[n].n) i = 0, r += t.yOffset, r += F ? 1 : 0, o = Q, F = !1, this._hasMaskedPath && (h = et, p = (f = m[d = tt].points)[h - 1], g = (l = f[h]).partialLength, c = 0), rt = "", X = "", $ = "", K = "", nt = this.defaultPropsArray;
                            else {
                                if (this._hasMaskedPath) {
                                    if (it !== E[n].line) {
                                        switch (t.j) {
                                            case 1:
                                                o += v - t.lineWidths[E[n].line];
                                                break;
                                            case 2:
                                                o += (v - t.lineWidths[E[n].line]) / 2
                                        }
                                        it = E[n].line
                                    }
                                    J !== E[n].ind && (E[J] && (o += E[J].extra), o += E[n].an / 2, J = E[n].ind), o += w[0] * E[n].an * .005;
                                    var ut = 0;
                                    for (D = 0; D < L; D += 1)(P = A[D].a).p.propType && ((I = A[D].s.getMult(E[n].anIndexes[D], S.a[D].s.totalChars)).length ? ut += P.p.v[0] * I[0] : ut += P.p.v[0] * I), P.a.propType && ((I = A[D].s.getMult(E[n].anIndexes[D], S.a[D].s.totalChars)).length ? ut += P.a.v[0] * I[0] : ut += P.a.v[0] * I);
                                    for (u = !0, this._pathData.a.v && (o = .5 * E[0].an + (v - this._pathData.f.v - .5 * E[0].an - .5 * E[E.length - 1].an) * J / (a - 1), o += this._pathData.f.v); u;) c + g >= o + ut || !f ? (y = (o + ut - c) / l.partialLength, B = p.point[0] + (l.point[0] - p.point[0]) * y, z = p.point[1] + (l.point[1] - p.point[1]) * y, k.translate(-w[0] * E[n].an * .005, -w[1] * R * .01), u = !1) : f && (c += l.partialLength, (h += 1) >= f.length && (h = 0, m[d += 1] ? f = m[d].points : _.v.c ? (h = 0, f = m[d = 0].points) : (c -= l.partialLength, f = null)), f && (p = l, g = (l = f[h]).partialLength));
                                    N = E[n].an / 2 - E[n].add, k.translate(-N, 0, 0)
                                } else N = E[n].an / 2 - E[n].add, k.translate(-N, 0, 0), k.translate(-w[0] * E[n].an * .005, -w[1] * R * .01, 0);
                                for (D = 0; D < L; D += 1)(P = A[D].a).t.propType && (I = A[D].s.getMult(E[n].anIndexes[D], S.a[D].s.totalChars), 0 === i && 0 === t.j || (this._hasMaskedPath ? I.length ? o += P.t.v * I[0] : o += P.t.v * I : I.length ? i += P.t.v * I[0] : i += P.t.v * I));
                                for (t.strokeWidthAnim && (H = t.sw || 0), t.strokeColorAnim && (V = t.sc ? [t.sc[0], t.sc[1], t.sc[2]] : [0, 0, 0]), t.fillColorAnim && t.fc && (W = [t.fc[0], t.fc[1], t.fc[2]]), D = 0; D < L; D += 1)(P = A[D].a).a.propType && ((I = A[D].s.getMult(E[n].anIndexes[D], S.a[D].s.totalChars)).length ? k.translate(-P.a.v[0] * I[0], -P.a.v[1] * I[1], P.a.v[2] * I[2]) : k.translate(-P.a.v[0] * I, -P.a.v[1] * I, P.a.v[2] * I));
                                for (D = 0; D < L; D += 1)(P = A[D].a).s.propType && ((I = A[D].s.getMult(E[n].anIndexes[D], S.a[D].s.totalChars)).length ? k.scale(1 + (P.s.v[0] - 1) * I[0], 1 + (P.s.v[1] - 1) * I[1], 1) : k.scale(1 + (P.s.v[0] - 1) * I, 1 + (P.s.v[1] - 1) * I, 1));
                                for (D = 0; D < L; D += 1) {
                                    if (P = A[D].a, I = A[D].s.getMult(E[n].anIndexes[D], S.a[D].s.totalChars), P.sk.propType && (I.length ? k.skewFromAxis(-P.sk.v * I[0], P.sa.v * I[1]) : k.skewFromAxis(-P.sk.v * I, P.sa.v * I)), P.r.propType && (I.length ? k.rotateZ(-P.r.v * I[2]) : k.rotateZ(-P.r.v * I)), P.ry.propType && (I.length ? k.rotateY(P.ry.v * I[1]) : k.rotateY(P.ry.v * I)), P.rx.propType && (I.length ? k.rotateX(P.rx.v * I[0]) : k.rotateX(P.rx.v * I)), P.o.propType && (I.length ? q += (P.o.v * I[0] - q) * I[0] : q += (P.o.v * I - q) * I), t.strokeWidthAnim && P.sw.propType && (I.length ? H += P.sw.v * I[0] : H += P.sw.v * I), t.strokeColorAnim && P.sc.propType)
                                        for (Z = 0; Z < 3; Z += 1) I.length ? V[Z] += (P.sc.v[Z] - V[Z]) * I[0] : V[Z] += (P.sc.v[Z] - V[Z]) * I;
                                    if (t.fillColorAnim && t.fc) {
                                        if (P.fc.propType)
                                            for (Z = 0; Z < 3; Z += 1) I.length ? W[Z] += (P.fc.v[Z] - W[Z]) * I[0] : W[Z] += (P.fc.v[Z] - W[Z]) * I;
                                        P.fh.propType && (W = I.length ? G(W, P.fh.v * I[0]) : G(W, P.fh.v * I)), P.fs.propType && (W = I.length ? Y(W, P.fs.v * I[0]) : Y(W, P.fs.v * I)), P.fb.propType && (W = I.length ? j(W, P.fb.v * I[0]) : j(W, P.fb.v * I))
                                    }
                                }
                                for (D = 0; D < L; D += 1)(P = A[D].a).p.propType && (I = A[D].s.getMult(E[n].anIndexes[D], S.a[D].s.totalChars), this._hasMaskedPath ? I.length ? k.translate(0, P.p.v[1] * I[0], -P.p.v[2] * I[1]) : k.translate(0, P.p.v[1] * I, -P.p.v[2] * I) : I.length ? k.translate(P.p.v[0] * I[0], P.p.v[1] * I[1], -P.p.v[2] * I[2]) : k.translate(P.p.v[0] * I, P.p.v[1] * I, -P.p.v[2] * I));
                                if (t.strokeWidthAnim && ($ = H < 0 ? 0 : H), t.strokeColorAnim && (U = "rgb(" + Math.round(255 * V[0]) + "," + Math.round(255 * V[1]) + "," + Math.round(255 * V[2]) + ")"), t.fillColorAnim && t.fc && (X = "rgb(" + Math.round(255 * W[0]) + "," + Math.round(255 * W[1]) + "," + Math.round(255 * W[2]) + ")"), this._hasMaskedPath) {
                                    if (k.translate(0, -t.ls), k.translate(0, w[1] * R * .01 + r, 0), this._pathData.p.v) {
                                        b = (l.point[1] - p.point[1]) / (l.point[0] - p.point[0]);
                                        var ht = 180 * Math.atan(b) / Math.PI;
                                        l.point[0] < p.point[0] && (ht += 180), k.rotate(-ht * Math.PI / 180)
                                    }
                                    k.translate(B, z, 0), o -= w[0] * E[n].an * .005, E[n + 1] && J !== E[n + 1].ind && (o += E[n].an / 2, o += .001 * t.tr * t.finalSize)
                                } else {
                                    switch (k.translate(i, r, 0), t.ps && k.translate(t.ps[0], t.ps[1] + t.ascent, 0), t.j) {
                                        case 1:
                                            k.translate(E[n].animatorJustifyOffset + t.justifyOffset + (t.boxWidth - t.lineWidths[E[n].line]), 0, 0);
                                            break;
                                        case 2:
                                            k.translate(E[n].animatorJustifyOffset + t.justifyOffset + (t.boxWidth - t.lineWidths[E[n].line]) / 2, 0, 0)
                                    }
                                    k.translate(0, -t.ls), k.translate(N, 0, 0), k.translate(w[0] * E[n].an * .005, w[1] * R * .01, 0), i += E[n].l + .001 * t.tr * t.finalSize
                                }
                                "html" === x ? rt = k.toCSS() : "svg" === x ? rt = k.to2dCSS() : nt = [k.props[0], k.props[1], k.props[2], k.props[3], k.props[4], k.props[5], k.props[6], k.props[7], k.props[8], k.props[9], k.props[10], k.props[11], k.props[12], k.props[13], k.props[14], k.props[15]], K = q
                            }
                            T <= n ? (O = new hi(K, $, U, X, rt, nt), this.renderedLetters.push(O), T += 1, this.lettersChangedFlag = !0) : (O = this.renderedLetters[n], this.lettersChangedFlag = O.update(K, $, U, X, rt, nt) || this.lettersChangedFlag)
                        }
                    }
                }, mi.prototype.getValue = function () {
                    this._elem.globalData.frameId !== this._frameId && (this._frameId = this._elem.globalData.frameId, this.iterateDynamicProperties())
                }, mi.prototype.mHelper = new Tt, mi.prototype.defaultPropsArray = [], h([bt], mi), gi.prototype.initElement = function (t, e, i) {
                    this.lettersChangedFlag = !0, this.initFrame(), this.initBaseData(t, e, i), this.textProperty = new di(this, t.t, this.dynamicProperties), this.textAnimator = new mi(t.t, this.renderType, this), this.initTransform(t, e, i), this.initHierarchy(), this.initRenderable(), this.initRendererElement(), this.createContainerElements(), this.createRenderableComponents(), this.createContent(), this.hide(), this.textAnimator.searchProperties(this.dynamicProperties)
                }, gi.prototype.prepareFrame = function (t) {
                    this._mdf = !1, this.prepareRenderableFrame(t), this.prepareProperties(t, this.isInRange), (this.textProperty._mdf || this.textProperty._isFirstFrame) && (this.buildNewText(), this.textProperty._isFirstFrame = !1, this.textProperty._mdf = !1)
                }, gi.prototype.createPathShape = function (t, e) {
                    var i, r, n = e.length,
                        a = "";
                    for (i = 0; i < n; i += 1) "sh" === e[i].ty && (r = e[i].ks.k, a += li(r, r.i.length, !0, t));
                    return a
                }, gi.prototype.updateDocumentData = function (t, e) {
                    this.textProperty.updateDocumentData(t, e)
                }, gi.prototype.canResizeFont = function (t) {
                    this.textProperty.canResizeFont(t)
                }, gi.prototype.setMinimumFontSize = function (t) {
                    this.textProperty.setMinimumFontSize(t)
                }, gi.prototype.applyTextPropertiesToMatrix = function (t, e, i, r, n) {
                    switch (t.ps && e.translate(t.ps[0], t.ps[1] + t.ascent, 0), e.translate(0, -t.ls, 0), t.j) {
                        case 1:
                            e.translate(t.justifyOffset + (t.boxWidth - t.lineWidths[i]), 0, 0);
                            break;
                        case 2:
                            e.translate(t.justifyOffset + (t.boxWidth - t.lineWidths[i]) / 2, 0, 0)
                    }
                    e.translate(r, n, 0)
                }, gi.prototype.buildColor = function (t) {
                    return "rgb(" + Math.round(255 * t[0]) + "," + Math.round(255 * t[1]) + "," + Math.round(255 * t[2]) + ")"
                }, gi.prototype.emptyProp = new hi, gi.prototype.destroy = function () { };
                var vi = {
                    shapes: []
                };

                function yi(t, e, i) {
                    this.textSpans = [], this.renderType = "svg", this.initElement(t, e, i)
                }

                function bi(t, e, i) {
                    this.initElement(t, e, i)
                }

                function _i(t, e, i) {
                    this.initFrame(), this.initBaseData(t, e, i), this.initFrame(), this.initTransform(t, e, i), this.initHierarchy()
                }

                function wi() { }

                function Ai() { }

                function Si(t, e, i) {
                    this.layers = t.layers, this.supports3d = !0, this.completeLayers = !1, this.pendingElements = [], this.elements = this.layers ? g(this.layers.length) : [], this.initElement(t, e, i), this.tm = t.tm ? yt.getProp(this, t.tm, 0, e.frameRate, this) : {
                        _placeholder: !0
                    }
                }

                function ki(t, e) {
                    this.animationItem = t, this.layers = null, this.renderedFrame = -1, this.svgElement = J("svg");
                    var i = "";
                    if (e && e.title) {
                        var r = J("title"),
                            n = z();
                        r.setAttribute("id", n), r.textContent = e.title, this.svgElement.appendChild(r), i += n
                    }
                    if (e && e.description) {
                        var a = J("desc"),
                            s = z();
                        a.setAttribute("id", s), a.textContent = e.description, this.svgElement.appendChild(a), i += " " + s
                    }
                    i && this.svgElement.setAttribute("aria-labelledby", i);
                    var o = J("defs");
                    this.svgElement.appendChild(o);
                    var l = J("g");
                    this.svgElement.appendChild(l), this.layerElement = l, this.renderConfig = {
                        preserveAspectRatio: e && e.preserveAspectRatio || "xMidYMid meet",
                        imagePreserveAspectRatio: e && e.imagePreserveAspectRatio || "xMidYMid slice",
                        contentVisibility: e && e.contentVisibility || "visible",
                        progressiveLoad: e && e.progressiveLoad || !1,
                        hideOnTransparent: !(e && !1 === e.hideOnTransparent),
                        viewBoxOnly: e && e.viewBoxOnly || !1,
                        viewBoxSize: e && e.viewBoxSize || !1,
                        className: e && e.className || "",
                        id: e && e.id || "",
                        focusable: e && e.focusable,
                        filterSize: {
                            width: e && e.filterSize && e.filterSize.width || "100%",
                            height: e && e.filterSize && e.filterSize.height || "100%",
                            x: e && e.filterSize && e.filterSize.x || "0%",
                            y: e && e.filterSize && e.filterSize.y || "0%"
                        },
                        width: e && e.width,
                        height: e && e.height
                    }, this.globalData = {
                        _mdf: !1,
                        frameNum: -1,
                        defs: o,
                        renderConfig: this.renderConfig
                    }, this.elements = [], this.pendingElements = [], this.destroyed = !1, this.rendererType = "svg"
                }
                return h([Te, Re, je, Ge, Ee, He, gi], yi), yi.prototype.createContent = function () {
                    this.data.singleShape && !this.globalData.fontManager.chars && (this.textContainer = J("text"))
                }, yi.prototype.buildTextContents = function (t) {
                    for (var e = 0, i = t.length, r = [], n = ""; e < i;) t[e] === String.fromCharCode(13) || t[e] === String.fromCharCode(3) ? (r.push(n), n = "") : n += t[e], e += 1;
                    return r.push(n), r
                }, yi.prototype.buildShapeData = function (t, e) {
                    if (t.shapes && t.shapes.length) {
                        var i = t.shapes[0];
                        if (i.it) {
                            var r = i.it[i.it.length - 1];
                            r.s && (r.s.k[0] = e, r.s.k[1] = e)
                        }
                    }
                    return t
                }, yi.prototype.buildNewText = function () {
                    var t, e;
                    this.addDynamicProperty(this);
                    var i = this.textProperty.currentData;
                    this.renderedLetters = g(i ? i.l.length : 0), i.fc ? this.layerElement.setAttribute("fill", this.buildColor(i.fc)) : this.layerElement.setAttribute("fill", "rgba(0,0,0,0)"), i.sc && (this.layerElement.setAttribute("stroke", this.buildColor(i.sc)), this.layerElement.setAttribute("stroke-width", i.sw)), this.layerElement.setAttribute("font-size", i.finalSize);
                    var r = this.globalData.fontManager.getFontByName(i.f);
                    if (r.fClass) this.layerElement.setAttribute("class", r.fClass);
                    else {
                        this.layerElement.setAttribute("font-family", r.fFamily);
                        var n = i.fWeight,
                            a = i.fStyle;
                        this.layerElement.setAttribute("font-style", a), this.layerElement.setAttribute("font-weight", n)
                    }
                    this.layerElement.setAttribute("aria-label", i.t);
                    var s, o = i.l || [],
                        l = !!this.globalData.fontManager.chars;
                    e = o.length;
                    var c = this.mHelper,
                        u = "",
                        h = this.data.singleShape,
                        d = 0,
                        p = 0,
                        f = !0,
                        m = .001 * i.tr * i.finalSize;
                    if (!h || l || i.sz) {
                        var v, y = this.textSpans.length;
                        for (t = 0; t < e; t += 1) {
                            if (this.textSpans[t] || (this.textSpans[t] = {
                                span: null,
                                childSpan: null,
                                glyph: null
                            }), !l || !h || 0 === t) {
                                if (s = y > t ? this.textSpans[t].span : J(l ? "g" : "text"), y <= t) {
                                    if (s.setAttribute("stroke-linecap", "butt"), s.setAttribute("stroke-linejoin", "round"), s.setAttribute("stroke-miterlimit", "4"), this.textSpans[t].span = s, l) {
                                        var b = J("g");
                                        s.appendChild(b), this.textSpans[t].childSpan = b
                                    }
                                    this.textSpans[t].span = s, this.layerElement.appendChild(s)
                                }
                                s.style.display = "inherit"
                            }
                            if (c.reset(), h && (o[t].n && (d = -m, p += i.yOffset, p += f ? 1 : 0, f = !1), this.applyTextPropertiesToMatrix(i, c, o[t].line, d, p), d += o[t].l || 0, d += m), l) {
                                var _;
                                if (1 === (v = this.globalData.fontManager.getCharData(i.finalText[t], r.fStyle, this.globalData.fontManager.getFontByName(i.f).fFamily)).t) _ = new Si(v.data, this.globalData, this);
                                else {
                                    var w = vi;
                                    v.data && v.data.shapes && (w = this.buildShapeData(v.data, i.finalSize)), _ = new ui(w, this.globalData, this)
                                }
                                if (this.textSpans[t].glyph) {
                                    var A = this.textSpans[t].glyph;
                                    this.textSpans[t].childSpan.removeChild(A.layerElement), A.destroy()
                                }
                                this.textSpans[t].glyph = _, _._debug = !0, _.prepareFrame(0), _.renderFrame(), this.textSpans[t].childSpan.appendChild(_.layerElement), 1 === v.t && this.textSpans[t].childSpan.setAttribute("transform", "scale(" + i.finalSize / 100 + "," + i.finalSize / 100 + ")")
                            } else h && s.setAttribute("transform", "translate(" + c.props[12] + "," + c.props[13] + ")"), s.textContent = o[t].val, s.setAttributeNS("http://www.w3.org/XML/1998/namespace", "xml:space", "preserve")
                        }
                        h && s && s.setAttribute("d", u)
                    } else {
                        var S = this.textContainer,
                            k = "start";
                        switch (i.j) {
                            case 1:
                                k = "end";
                                break;
                            case 2:
                                k = "middle";
                                break;
                            default:
                                k = "start"
                        }
                        S.setAttribute("text-anchor", k), S.setAttribute("letter-spacing", m);
                        var x = this.buildTextContents(i.finalText);
                        for (e = x.length, p = i.ps ? i.ps[1] + i.ascent : 0, t = 0; t < e; t += 1)(s = this.textSpans[t].span || J("tspan")).textContent = x[t], s.setAttribute("x", 0), s.setAttribute("y", p), s.style.display = "inherit", S.appendChild(s), this.textSpans[t] || (this.textSpans[t] = {
                            span: null,
                            glyph: null
                        }), this.textSpans[t].span = s, p += i.finalLineHeight;
                        this.layerElement.appendChild(S)
                    }
                    for (; t < this.textSpans.length;) this.textSpans[t].span.style.display = "none", t += 1;
                    this._sizeChanged = !0
                }, yi.prototype.sourceRectAtTime = function () {
                    if (this.prepareFrame(this.comp.renderedFrame - this.data.st), this.renderInnerContent(), this._sizeChanged) {
                        this._sizeChanged = !1;
                        var t = this.layerElement.getBBox();
                        this.bbox = {
                            top: t.y,
                            left: t.x,
                            width: t.width,
                            height: t.height
                        }
                    }
                    return this.bbox
                }, yi.prototype.getValue = function () {
                    var t, e, i = this.textSpans.length;
                    for (this.renderedFrame = this.comp.renderedFrame, t = 0; t < i; t += 1)(e = this.textSpans[t].glyph) && (e.prepareFrame(this.comp.renderedFrame - this.data.st), e._mdf && (this._mdf = !0))
                }, yi.prototype.renderInnerContent = function () {
                    if ((!this.data.singleShape || this._mdf) && (this.textAnimator.getMeasures(this.textProperty.currentData, this.lettersChangedFlag), this.lettersChangedFlag || this.textAnimator.lettersChangedFlag)) {
                        var t, e;
                        this._sizeChanged = !0;
                        var i, r, n, a = this.textAnimator.renderedLetters,
                            s = this.textProperty.currentData.l;
                        for (e = s.length, t = 0; t < e; t += 1) s[t].n || (i = a[t], r = this.textSpans[t].span, (n = this.textSpans[t].glyph) && n.renderFrame(), i._mdf.m && r.setAttribute("transform", i.m), i._mdf.o && r.setAttribute("opacity", i.o), i._mdf.sw && r.setAttribute("stroke-width", i.sw), i._mdf.sc && r.setAttribute("stroke", i.sc), i._mdf.fc && r.setAttribute("fill", i.fc))
                    }
                }, h([We], bi), bi.prototype.createContent = function () {
                    var t = J("rect");
                    t.setAttribute("width", this.data.sw), t.setAttribute("height", this.data.sh), t.setAttribute("fill", this.data.sc), this.layerElement.appendChild(t)
                }, _i.prototype.prepareFrame = function (t) {
                    this.prepareProperties(t, !0)
                }, _i.prototype.renderFrame = function () { }, _i.prototype.getBaseElement = function () {
                    return null
                }, _i.prototype.destroy = function () { }, _i.prototype.sourceRectAtTime = function () { }, _i.prototype.hide = function () { }, h([Te, Re, Ge, Ee], _i), h([Ie], wi), wi.prototype.createNull = function (t) {
                    return new _i(t, this.globalData, this)
                }, wi.prototype.createShape = function (t) {
                    return new ui(t, this.globalData, this)
                }, wi.prototype.createText = function (t) {
                    return new yi(t, this.globalData, this)
                }, wi.prototype.createImage = function (t) {
                    return new We(t, this.globalData, this)
                }, wi.prototype.createSolid = function (t) {
                    return new bi(t, this.globalData, this)
                }, wi.prototype.configAnimation = function (t) {
                    this.svgElement.setAttribute("xmlns", "http://www.w3.org/2000/svg"), this.renderConfig.viewBoxSize ? this.svgElement.setAttribute("viewBox", this.renderConfig.viewBoxSize) : this.svgElement.setAttribute("viewBox", "0 0 " + t.w + " " + t.h), this.renderConfig.viewBoxOnly || (this.svgElement.setAttribute("width", t.w), this.svgElement.setAttribute("height", t.h), this.svgElement.style.width = "100%", this.svgElement.style.height = "100%", this.svgElement.style.transform = "translate3d(0,0,0)", this.svgElement.style.contentVisibility = this.renderConfig.contentVisibility), this.renderConfig.width && this.svgElement.setAttribute("width", this.renderConfig.width), this.renderConfig.height && this.svgElement.setAttribute("height", this.renderConfig.height), this.renderConfig.className && this.svgElement.setAttribute("class", this.renderConfig.className), this.renderConfig.id && this.svgElement.setAttribute("id", this.renderConfig.id), void 0 !== this.renderConfig.focusable && this.svgElement.setAttribute("focusable", this.renderConfig.focusable), this.svgElement.setAttribute("preserveAspectRatio", this.renderConfig.preserveAspectRatio), this.animationItem.wrapper.appendChild(this.svgElement);
                    var e = this.globalData.defs;
                    this.setupGlobalData(t, e), this.globalData.progressiveLoad = this.renderConfig.progressiveLoad, this.data = t;
                    var i = J("clipPath"),
                        r = J("rect");
                    r.setAttribute("width", t.w), r.setAttribute("height", t.h), r.setAttribute("x", 0), r.setAttribute("y", 0);
                    var n = z();
                    i.setAttribute("id", n), i.appendChild(r), this.layerElement.setAttribute("clip-path", "url(" + c() + "#" + n + ")"), e.appendChild(i), this.layers = t.layers, this.elements = g(t.layers.length)
                }, wi.prototype.destroy = function () {
                    var t;
                    this.animationItem.wrapper && (this.animationItem.wrapper.innerText = ""), this.layerElement = null, this.globalData.defs = null;
                    var e = this.layers ? this.layers.length : 0;
                    for (t = 0; t < e; t += 1) this.elements[t] && this.elements[t].destroy();
                    this.elements.length = 0, this.destroyed = !0, this.animationItem = null
                }, wi.prototype.updateContainerSize = function () { }, wi.prototype.buildItem = function (t) {
                    var e = this.elements;
                    if (!e[t] && 99 !== this.layers[t].ty) {
                        e[t] = !0;
                        var i = this.createItem(this.layers[t]);
                        e[t] = i, $() && (0 === this.layers[t].ty && this.globalData.projectInterface.registerComposition(i), i.initExpressions()), this.appendElementInPos(i, t), this.layers[t].tt && (this.elements[t - 1] && !0 !== this.elements[t - 1] ? i.setMatte(e[t - 1].layerId) : (this.buildItem(t - 1), this.addPendingElement(i)))
                    }
                }, wi.prototype.checkPendingElements = function () {
                    for (; this.pendingElements.length;) {
                        var t = this.pendingElements.pop();
                        if (t.checkParenting(), t.data.tt)
                            for (var e = 0, i = this.elements.length; e < i;) {
                                if (this.elements[e] === t) {
                                    t.setMatte(this.elements[e - 1].layerId);
                                    break
                                }
                                e += 1
                            }
                    }
                }, wi.prototype.renderFrame = function (t) {
                    if (this.renderedFrame !== t && !this.destroyed) {
                        var e;
                        null === t ? t = this.renderedFrame : this.renderedFrame = t, this.globalData.frameNum = t, this.globalData.frameId += 1, this.globalData.projectInterface.currentFrame = t, this.globalData._mdf = !1;
                        var i = this.layers.length;
                        for (this.completeLayers || this.checkLayers(t), e = i - 1; e >= 0; e -= 1)(this.completeLayers || this.elements[e]) && this.elements[e].prepareFrame(t - this.layers[e].st);
                        if (this.globalData._mdf)
                            for (e = 0; e < i; e += 1)(this.completeLayers || this.elements[e]) && this.elements[e].renderFrame()
                    }
                }, wi.prototype.appendElementInPos = function (t, e) {
                    var i = t.getBaseElement();
                    if (i) {
                        for (var r, n = 0; n < e;) this.elements[n] && !0 !== this.elements[n] && this.elements[n].getBaseElement() && (r = this.elements[n].getBaseElement()), n += 1;
                        r ? this.layerElement.insertBefore(i, r) : this.layerElement.appendChild(i)
                    }
                }, wi.prototype.hide = function () {
                    this.layerElement.style.display = "none"
                }, wi.prototype.show = function () {
                    this.layerElement.style.display = "block"
                }, h([Te, Re, Ge, Ee, He], Ai), Ai.prototype.initElement = function (t, e, i) {
                    this.initFrame(), this.initBaseData(t, e, i), this.initTransform(t, e, i), this.initRenderable(), this.initHierarchy(), this.initRendererElement(), this.createContainerElements(), this.createRenderableComponents(), !this.data.xt && e.progressiveLoad || this.buildAllItems(), this.hide()
                }, Ai.prototype.prepareFrame = function (t) {
                    if (this._mdf = !1, this.prepareRenderableFrame(t), this.prepareProperties(t, this.isInRange), this.isInRange || this.data.xt) {
                        if (this.tm._placeholder) this.renderedFrame = t / this.data.sr;
                        else {
                            var e = this.tm.v;
                            e === this.data.op && (e = this.data.op - 1), this.renderedFrame = e
                        }
                        var i, r = this.elements.length;
                        for (this.completeLayers || this.checkLayers(this.renderedFrame), i = r - 1; i >= 0; i -= 1)(this.completeLayers || this.elements[i]) && (this.elements[i].prepareFrame(this.renderedFrame - this.layers[i].st), this.elements[i]._mdf && (this._mdf = !0))
                    }
                }, Ai.prototype.renderInnerContent = function () {
                    var t, e = this.layers.length;
                    for (t = 0; t < e; t += 1)(this.completeLayers || this.elements[t]) && this.elements[t].renderFrame()
                }, Ai.prototype.setElements = function (t) {
                    this.elements = t
                }, Ai.prototype.getElements = function () {
                    return this.elements
                }, Ai.prototype.destroyElements = function () {
                    var t, e = this.layers.length;
                    for (t = 0; t < e; t += 1) this.elements[t] && this.elements[t].destroy()
                }, Ai.prototype.destroy = function () {
                    this.destroyElements(), this.destroyBaseElement()
                }, h([wi, Ai, je], Si), Si.prototype.createComp = function (t) {
                    return new Si(t, this.globalData, this)
                }, h([wi], ki), ki.prototype.createComp = function (t) {
                    return new Si(t, this.globalData, this)
                }, st("svg", ki), Zt.registerModifier("tm", Ut), Zt.registerModifier("pb", Xt), Zt.registerModifier("rp", Jt), Zt.registerModifier("rd", Qt), Mt
            }())
        },
        8: (t, e, i) => {
            (t.exports = i(177)).tz.load(i(544))
        },
        177: function (t, e, i) {
            var r, n, a;
            ! function (s, o) {
                "use strict";
                t.exports ? t.exports = o(i(381)) : (n = [i(381)], void 0 === (a = "function" == typeof (r = o) ? r.apply(e, n) : r) || (t.exports = a))
            }(0, (function (t) {
                "use strict";
                void 0 === t.version && t.default && (t = t.default);
                var e, i = {},
                    r = {},
                    n = {},
                    a = {},
                    s = {};
                t && "string" == typeof t.version || C("Moment Timezone requires Moment.js. See https://momentjs.com/timezone/docs/#/use-it/browser/");
                var o = t.version.split("."),
                    l = +o[0],
                    c = +o[1];

                function u(t) {
                    return t > 96 ? t - 87 : t > 64 ? t - 29 : t - 48
                }

                function h(t) {
                    var e = 0,
                        i = t.split("."),
                        r = i[0],
                        n = i[1] || "",
                        a = 1,
                        s = 0,
                        o = 1;
                    for (45 === t.charCodeAt(0) && (e = 1, o = -1); e < r.length; e++) s = 60 * s + u(r.charCodeAt(e));
                    for (e = 0; e < n.length; e++) a /= 60, s += u(n.charCodeAt(e)) * a;
                    return s * o
                }

                function d(t) {
                    for (var e = 0; e < t.length; e++) t[e] = h(t[e])
                }

                function p(t, e) {
                    var i, r = [];
                    for (i = 0; i < e.length; i++) r[i] = t[e[i]];
                    return r
                }

                function f(t) {
                    var e = t.split("|"),
                        i = e[2].split(" "),
                        r = e[3].split(""),
                        n = e[4].split(" ");
                    return d(i), d(r), d(n),
                        function (t, e) {
                            for (var i = 0; i < e; i++) t[i] = Math.round((t[i - 1] || 0) + 6e4 * t[i]);
                            t[e - 1] = 1 / 0
                        }(n, r.length), {
                        name: e[0],
                        abbrs: p(e[1].split(" "), r),
                        offsets: p(i, r),
                        untils: n,
                        population: 0 | e[5]
                    }
                }

                function m(t) {
                    t && this._set(f(t))
                }

                function g(t, e) {
                    this.name = t, this.zones = e
                }

                function v(t) {
                    var e = t.toTimeString(),
                        i = e.match(/\([a-z ]+\)/i);
                    "GMT" === (i = i && i[0] ? (i = i[0].match(/[A-Z]/g)) ? i.join("") : void 0 : (i = e.match(/[A-Z]{3,5}/g)) ? i[0] : void 0) && (i = void 0), this.at = +t, this.abbr = i, this.offset = t.getTimezoneOffset()
                }

                function y(t) {
                    this.zone = t, this.offsetScore = 0, this.abbrScore = 0
                }

                function b(t, e) {
                    for (var i, r; r = 6e4 * ((e.at - t.at) / 12e4 | 0);)(i = new v(new Date(t.at + r))).offset === t.offset ? t = i : e = i;
                    return t
                }

                function _(t, e) {
                    return t.offsetScore !== e.offsetScore ? t.offsetScore - e.offsetScore : t.abbrScore !== e.abbrScore ? t.abbrScore - e.abbrScore : t.zone.population !== e.zone.population ? e.zone.population - t.zone.population : e.zone.name.localeCompare(t.zone.name)
                }

                function w(t, e) {
                    var i, r;
                    for (d(e), i = 0; i < e.length; i++) r = e[i], s[r] = s[r] || {}, s[r][t] = !0
                }

                function A(t) {
                    var e, i, r, n = t.length,
                        o = {},
                        l = [];
                    for (e = 0; e < n; e++)
                        for (i in r = s[t[e].offset] || {}) r.hasOwnProperty(i) && (o[i] = !0);
                    for (e in o) o.hasOwnProperty(e) && l.push(a[e]);
                    return l
                }

                function S() {
                    try {
                        var t = Intl.DateTimeFormat().resolvedOptions().timeZone;
                        if (t && t.length > 3) {
                            var e = a[k(t)];
                            if (e) return e;
                            C("Moment Timezone found " + t + " from the Intl api, but did not have that data loaded.")
                        }
                    } catch (t) { }
                    var i, r, n, s = function () {
                        var t, e, i, r = (new Date).getFullYear() - 2,
                            n = new v(new Date(r, 0, 1)),
                            a = [n];
                        for (i = 1; i < 48; i++)(e = new v(new Date(r, i, 1))).offset !== n.offset && (t = b(n, e), a.push(t), a.push(new v(new Date(t.at + 6e4)))), n = e;
                        for (i = 0; i < 4; i++) a.push(new v(new Date(r + i, 0, 1))), a.push(new v(new Date(r + i, 6, 1)));
                        return a
                    }(),
                        o = s.length,
                        l = A(s),
                        c = [];
                    for (r = 0; r < l.length; r++) {
                        for (i = new y(T(l[r]), o), n = 0; n < o; n++) i.scoreOffsetAt(s[n]);
                        c.push(i)
                    }
                    return c.sort(_), c.length > 0 ? c[0].zone.name : void 0
                }

                function k(t) {
                    return (t || "").toLowerCase().replace(/\//g, "_")
                }

                function x(t) {
                    var e, r, n, s;
                    for ("string" == typeof t && (t = [t]), e = 0; e < t.length; e++) s = k(r = (n = t[e].split("|"))[0]), i[s] = t[e], a[s] = r, w(s, n[2].split(" "))
                }

                function T(t, e) {
                    t = k(t);
                    var n, s = i[t];
                    return s instanceof m ? s : "string" == typeof s ? (s = new m(s), i[t] = s, s) : r[t] && e !== T && (n = T(r[t], T)) ? ((s = i[t] = new m)._set(n), s.name = a[t], s) : null
                }

                function E(t) {
                    var e, i, n, s;
                    for ("string" == typeof t && (t = [t]), e = 0; e < t.length; e++) n = k((i = t[e].split("|"))[0]), s = k(i[1]), r[n] = s, a[n] = i[0], r[s] = n, a[s] = i[1]
                }

                function M(t) {
                    var e = "X" === t._f || "x" === t._f;
                    return !(!t._a || void 0 !== t._tzm || e)
                }

                function C(t) {
                    "undefined" != typeof console && "function" == typeof console.error && console.error(t)
                }

                function P(e) {
                    var i = Array.prototype.slice.call(arguments, 0, -1),
                        r = arguments[arguments.length - 1],
                        n = T(r),
                        a = t.utc.apply(null, i);
                    return n && !t.isMoment(e) && M(a) && a.add(n.parse(a), "minutes"), a.tz(r), a
                } (l < 2 || 2 === l && c < 6) && C("Moment Timezone requires Moment.js >= 2.6.0. You are using Moment.js " + t.version + ". See momentjs.com"), m.prototype = {
                    _set: function (t) {
                        this.name = t.name, this.abbrs = t.abbrs, this.untils = t.untils, this.offsets = t.offsets, this.population = t.population
                    },
                    _index: function (t) {
                        var e, i = +t,
                            r = this.untils;
                        for (e = 0; e < r.length; e++)
                            if (i < r[e]) return e
                    },
                    countries: function () {
                        var t = this.name;
                        return Object.keys(n).filter((function (e) {
                            return -1 !== n[e].zones.indexOf(t)
                        }))
                    },
                    parse: function (t) {
                        var e, i, r, n, a = +t,
                            s = this.offsets,
                            o = this.untils,
                            l = o.length - 1;
                        for (n = 0; n < l; n++)
                            if (e = s[n], i = s[n + 1], r = s[n ? n - 1 : n], e < i && P.moveAmbiguousForward ? e = i : e > r && P.moveInvalidForward && (e = r), a < o[n] - 6e4 * e) return s[n];
                        return s[l]
                    },
                    abbr: function (t) {
                        return this.abbrs[this._index(t)]
                    },
                    offset: function (t) {
                        return C("zone.offset has been deprecated in favor of zone.utcOffset"), this.offsets[this._index(t)]
                    },
                    utcOffset: function (t) {
                        return this.offsets[this._index(t)]
                    }
                }, y.prototype.scoreOffsetAt = function (t) {
                    this.offsetScore += Math.abs(this.zone.utcOffset(t.at) - t.offset), this.zone.abbr(t.at).replace(/[^A-Z]/g, "") !== t.abbr && this.abbrScore++
                }, P.version = "0.5.41", P.dataVersion = "", P._zones = i, P._links = r, P._names = a, P._countries = n, P.add = x, P.link = E, P.load = function (t) {
                    x(t.zones), E(t.links),
                        function (t) {
                            var e, i, r, a;
                            if (t && t.length)
                                for (e = 0; e < t.length; e++) i = (a = t[e].split("|"))[0].toUpperCase(), r = a[1].split(" "), n[i] = new g(i, r)
                        }(t.countries), P.dataVersion = t.version
                }, P.zone = T, P.zoneExists = function t(e) {
                    return t.didShowError || (t.didShowError = !0, C("moment.tz.zoneExists('" + e + "') has been deprecated in favor of !moment.tz.zone('" + e + "')")), !!T(e)
                }, P.guess = function (t) {
                    return e && !t || (e = S()), e
                }, P.names = function () {
                    var t, e = [];
                    for (t in a) a.hasOwnProperty(t) && (i[t] || i[r[t]]) && a[t] && e.push(a[t]);
                    return e.sort()
                }, P.Zone = m, P.unpack = f, P.unpackBase60 = h, P.needsOffset = M, P.moveInvalidForward = !0, P.moveAmbiguousForward = !1, P.countries = function () {
                    return Object.keys(n)
                }, P.zonesForCountry = function (t, e) {
                    var i;
                    if (i = (i = t).toUpperCase(), !(t = n[i] || null)) return null;
                    var r = t.zones.sort();
                    return e ? r.map((function (t) {
                        return {
                            name: t,
                            offset: T(t).utcOffset(new Date)
                        }
                    })) : r
                };
                var D, L = t.fn;

                function O(t) {
                    return function () {
                        return this._z ? this._z.abbr(this) : t.call(this)
                    }
                }

                function I(t) {
                    return function () {
                        return this._z = null, t.apply(this, arguments)
                    }
                }
                t.tz = P, t.defaultZone = null, t.updateOffset = function (e, i) {
                    var r, n = t.defaultZone;
                    if (void 0 === e._z && (n && M(e) && !e._isUTC && (e._d = t.utc(e._a)._d, e.utc().add(n.parse(e), "minutes")), e._z = n), e._z)
                        if (r = e._z.utcOffset(e), Math.abs(r) < 16 && (r /= 60), void 0 !== e.utcOffset) {
                            var a = e._z;
                            e.utcOffset(-r, i), e._z = a
                        } else e.zone(r, i)
                }, L.tz = function (e, i) {
                    if (e) {
                        if ("string" != typeof e) throw new Error("Time zone name must be a string, got " + e + " [" + typeof e + "]");
                        return this._z = T(e), this._z ? t.updateOffset(this, i) : C("Moment Timezone has no data for " + e + ". See http://momentjs.com/timezone/docs/#/data-loading/."), this
                    }
                    if (this._z) return this._z.name
                }, L.zoneName = O(L.zoneName), L.zoneAbbr = O(L.zoneAbbr), L.utc = I(L.utc), L.local = I(L.local), L.utcOffset = (D = L.utcOffset, function () {
                    return arguments.length > 0 && (this._z = null), D.apply(this, arguments)
                }), t.tz.setDefault = function (e) {
                    return (l < 2 || 2 === l && c < 9) && C("Moment Timezone setDefault() requires Moment.js >= 2.9.0. You are using Moment.js " + t.version + "."), t.defaultZone = e ? T(e) : null, t
                };
                var R = t.momentProperties;
                return "[object Array]" === Object.prototype.toString.call(R) ? (R.push("_z"), R.push("_a")) : R && (R._z = null), t
            }))
        },
        381: function (t, e, i) {
            (t = i.nmd(t)).exports = function () {
                "use strict";
                var e, i;

                function r() {
                    return e.apply(null, arguments)
                }

                function n(t) {
                    e = t
                }

                function a(t) {
                    return t instanceof Array || "[object Array]" === Object.prototype.toString.call(t)
                }

                function s(t) {
                    return null != t && "[object Object]" === Object.prototype.toString.call(t)
                }

                function o(t, e) {
                    return Object.prototype.hasOwnProperty.call(t, e)
                }

                function l(t) {
                    if (Object.getOwnPropertyNames) return 0 === Object.getOwnPropertyNames(t).length;
                    var e;
                    for (e in t)
                        if (o(t, e)) return !1;
                    return !0
                }

                function c(t) {
                    return void 0 === t
                }

                function u(t) {
                    return "number" == typeof t || "[object Number]" === Object.prototype.toString.call(t)
                }

                function h(t) {
                    return t instanceof Date || "[object Date]" === Object.prototype.toString.call(t)
                }

                function d(t, e) {
                    var i, r = [],
                        n = t.length;
                    for (i = 0; i < n; ++i) r.push(e(t[i], i));
                    return r
                }

                function p(t, e) {
                    for (var i in e) o(e, i) && (t[i] = e[i]);
                    return o(e, "toString") && (t.toString = e.toString), o(e, "valueOf") && (t.valueOf = e.valueOf), t
                }

                function f(t, e, i, r) {
                    return Zi(t, e, i, r, !0).utc()
                }

                function m() {
                    return {
                        empty: !1,
                        unusedTokens: [],
                        unusedInput: [],
                        overflow: -2,
                        charsLeftOver: 0,
                        nullInput: !1,
                        invalidEra: null,
                        invalidMonth: null,
                        invalidFormat: !1,
                        userInvalidated: !1,
                        iso: !1,
                        parsedDateParts: [],
                        era: null,
                        meridiem: null,
                        rfc2822: !1,
                        weekdayMismatch: !1
                    }
                }

                function g(t) {
                    return null == t._pf && (t._pf = m()), t._pf
                }

                function v(t) {
                    if (null == t._isValid) {
                        var e = g(t),
                            r = i.call(e.parsedDateParts, (function (t) {
                                return null != t
                            })),
                            n = !isNaN(t._d.getTime()) && e.overflow < 0 && !e.empty && !e.invalidEra && !e.invalidMonth && !e.invalidWeekday && !e.weekdayMismatch && !e.nullInput && !e.invalidFormat && !e.userInvalidated && (!e.meridiem || e.meridiem && r);
                        if (t._strict && (n = n && 0 === e.charsLeftOver && 0 === e.unusedTokens.length && void 0 === e.bigHour), null != Object.isFrozen && Object.isFrozen(t)) return n;
                        t._isValid = n
                    }
                    return t._isValid
                }

                function y(t) {
                    var e = f(NaN);
                    return null != t ? p(g(e), t) : g(e).userInvalidated = !0, e
                }
                i = Array.prototype.some ? Array.prototype.some : function (t) {
                    var e, i = Object(this),
                        r = i.length >>> 0;
                    for (e = 0; e < r; e++)
                        if (e in i && t.call(this, i[e], e, i)) return !0;
                    return !1
                };
                var b = r.momentProperties = [],
                    _ = !1;

                function w(t, e) {
                    var i, r, n, a = b.length;
                    if (c(e._isAMomentObject) || (t._isAMomentObject = e._isAMomentObject), c(e._i) || (t._i = e._i), c(e._f) || (t._f = e._f), c(e._l) || (t._l = e._l), c(e._strict) || (t._strict = e._strict), c(e._tzm) || (t._tzm = e._tzm), c(e._isUTC) || (t._isUTC = e._isUTC), c(e._offset) || (t._offset = e._offset), c(e._pf) || (t._pf = g(e)), c(e._locale) || (t._locale = e._locale), a > 0)
                        for (i = 0; i < a; i++) c(n = e[r = b[i]]) || (t[r] = n);
                    return t
                }

                function A(t) {
                    w(this, t), this._d = new Date(null != t._d ? t._d.getTime() : NaN), this.isValid() || (this._d = new Date(NaN)), !1 === _ && (_ = !0, r.updateOffset(this), _ = !1)
                }

                function S(t) {
                    return t instanceof A || null != t && null != t._isAMomentObject
                }

                function k(t) {
                    !1 === r.suppressDeprecationWarnings && "undefined" != typeof console && console.warn && console.warn("Deprecation warning: " + t)
                }

                function x(t, e) {
                    var i = !0;
                    return p((function () {
                        if (null != r.deprecationHandler && r.deprecationHandler(null, t), i) {
                            var n, a, s, l = [],
                                c = arguments.length;
                            for (a = 0; a < c; a++) {
                                if (n = "", "object" == typeof arguments[a]) {
                                    for (s in n += "\n[" + a + "] ", arguments[0]) o(arguments[0], s) && (n += s + ": " + arguments[0][s] + ", ");
                                    n = n.slice(0, -2)
                                } else n = arguments[a];
                                l.push(n)
                            }
                            k(t + "\nArguments: " + Array.prototype.slice.call(l).join("") + "\n" + (new Error).stack), i = !1
                        }
                        return e.apply(this, arguments)
                    }), e)
                }
                var T, E = {};

                function M(t, e) {
                    null != r.deprecationHandler && r.deprecationHandler(t, e), E[t] || (k(e), E[t] = !0)
                }

                function C(t) {
                    return "undefined" != typeof Function && t instanceof Function || "[object Function]" === Object.prototype.toString.call(t)
                }

                function P(t) {
                    var e, i;
                    for (i in t) o(t, i) && (C(e = t[i]) ? this[i] = e : this["_" + i] = e);
                    this._config = t, this._dayOfMonthOrdinalParseLenient = new RegExp((this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) + "|" + /\d{1,2}/.source)
                }

                function D(t, e) {
                    var i, r = p({}, t);
                    for (i in e) o(e, i) && (s(t[i]) && s(e[i]) ? (r[i] = {}, p(r[i], t[i]), p(r[i], e[i])) : null != e[i] ? r[i] = e[i] : delete r[i]);
                    for (i in t) o(t, i) && !o(e, i) && s(t[i]) && (r[i] = p({}, r[i]));
                    return r
                }

                function L(t) {
                    null != t && this.set(t)
                }
                r.suppressDeprecationWarnings = !1, r.deprecationHandler = null, T = Object.keys ? Object.keys : function (t) {
                    var e, i = [];
                    for (e in t) o(t, e) && i.push(e);
                    return i
                };
                var O = {
                    sameDay: "[Today at] LT",
                    nextDay: "[Tomorrow at] LT",
                    nextWeek: "dddd [at] LT",
                    lastDay: "[Yesterday at] LT",
                    lastWeek: "[Last] dddd [at] LT",
                    sameElse: "L"
                };

                function I(t, e, i) {
                    var r = this._calendar[t] || this._calendar.sameElse;
                    return C(r) ? r.call(e, i) : r
                }

                function R(t, e, i) {
                    var r = "" + Math.abs(t),
                        n = e - r.length;
                    return (t >= 0 ? i ? "+" : "" : "-") + Math.pow(10, Math.max(0, n)).toString().substr(1) + r
                }
                var F = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|N{1,5}|YYYYYY|YYYYY|YYYY|YY|y{2,4}|yo?|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g,
                    N = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g,
                    B = {},
                    z = {};

                function q(t, e, i, r) {
                    var n = r;
                    "string" == typeof r && (n = function () {
                        return this[r]()
                    }), t && (z[t] = n), e && (z[e[0]] = function () {
                        return R(n.apply(this, arguments), e[1], e[2])
                    }), i && (z[i] = function () {
                        return this.localeData().ordinal(n.apply(this, arguments), t)
                    })
                }

                function V(t) {
                    return t.match(/\[[\s\S]/) ? t.replace(/^\[|\]$/g, "") : t.replace(/\\/g, "")
                }

                function Y(t) {
                    var e, i, r = t.match(F);
                    for (e = 0, i = r.length; e < i; e++) z[r[e]] ? r[e] = z[r[e]] : r[e] = V(r[e]);
                    return function (e) {
                        var n, a = "";
                        for (n = 0; n < i; n++) a += C(r[n]) ? r[n].call(e, t) : r[n];
                        return a
                    }
                }

                function j(t, e) {
                    return t.isValid() ? (e = G(e, t.localeData()), B[e] = B[e] || Y(e), B[e](t)) : t.localeData().invalidDate()
                }

                function G(t, e) {
                    var i = 5;

                    function r(t) {
                        return e.longDateFormat(t) || t
                    }
                    for (N.lastIndex = 0; i >= 0 && N.test(t);) t = t.replace(N, r), N.lastIndex = 0, i -= 1;
                    return t
                }
                var H = {
                    LTS: "h:mm:ss A",
                    LT: "h:mm A",
                    L: "MM/DD/YYYY",
                    LL: "MMMM D, YYYY",
                    LLL: "MMMM D, YYYY h:mm A",
                    LLLL: "dddd, MMMM D, YYYY h:mm A"
                };

                function W(t) {
                    var e = this._longDateFormat[t],
                        i = this._longDateFormat[t.toUpperCase()];
                    return e || !i ? e : (this._longDateFormat[t] = i.match(F).map((function (t) {
                        return "MMMM" === t || "MM" === t || "DD" === t || "dddd" === t ? t.slice(1) : t
                    })).join(""), this._longDateFormat[t])
                }
                var Z = "Invalid date";

                function $() {
                    return this._invalidDate
                }
                var U = "%d",
                    X = /\d{1,2}/;

                function K(t) {
                    return this._ordinal.replace("%d", t)
                }
                var J = {
                    future: "in %s",
                    past: "%s ago",
                    s: "a few seconds",
                    ss: "%d seconds",
                    m: "a minute",
                    mm: "%d minutes",
                    h: "an hour",
                    hh: "%d hours",
                    d: "a day",
                    dd: "%d days",
                    w: "a week",
                    ww: "%d weeks",
                    M: "a month",
                    MM: "%d months",
                    y: "a year",
                    yy: "%d years"
                };

                function Q(t, e, i, r) {
                    var n = this._relativeTime[i];
                    return C(n) ? n(t, e, i, r) : n.replace(/%d/i, t)
                }

                function tt(t, e) {
                    var i = this._relativeTime[t > 0 ? "future" : "past"];
                    return C(i) ? i(e) : i.replace(/%s/i, e)
                }
                var et = {};

                function it(t, e) {
                    var i = t.toLowerCase();
                    et[i] = et[i + "s"] = et[e] = t
                }

                function rt(t) {
                    return "string" == typeof t ? et[t] || et[t.toLowerCase()] : void 0
                }

                function nt(t) {
                    var e, i, r = {};
                    for (i in t) o(t, i) && (e = rt(i)) && (r[e] = t[i]);
                    return r
                }
                var at = {};

                function st(t, e) {
                    at[t] = e
                }

                function ot(t) {
                    var e, i = [];
                    for (e in t) o(t, e) && i.push({
                        unit: e,
                        priority: at[e]
                    });
                    return i.sort((function (t, e) {
                        return t.priority - e.priority
                    })), i
                }

                function lt(t) {
                    return t % 4 == 0 && t % 100 != 0 || t % 400 == 0
                }

                function ct(t) {
                    return t < 0 ? Math.ceil(t) || 0 : Math.floor(t)
                }

                function ut(t) {
                    var e = +t,
                        i = 0;
                    return 0 !== e && isFinite(e) && (i = ct(e)), i
                }

                function ht(t, e) {
                    return function (i) {
                        return null != i ? (pt(this, t, i), r.updateOffset(this, e), this) : dt(this, t)
                    }
                }

                function dt(t, e) {
                    return t.isValid() ? t._d["get" + (t._isUTC ? "UTC" : "") + e]() : NaN
                }

                function pt(t, e, i) {
                    t.isValid() && !isNaN(i) && ("FullYear" === e && lt(t.year()) && 1 === t.month() && 29 === t.date() ? (i = ut(i), t._d["set" + (t._isUTC ? "UTC" : "") + e](i, t.month(), Qt(i, t.month()))) : t._d["set" + (t._isUTC ? "UTC" : "") + e](i))
                }

                function ft(t) {
                    return C(this[t = rt(t)]) ? this[t]() : this
                }

                function mt(t, e) {
                    if ("object" == typeof t) {
                        var i, r = ot(t = nt(t)),
                            n = r.length;
                        for (i = 0; i < n; i++) this[r[i].unit](t[r[i].unit])
                    } else if (C(this[t = rt(t)])) return this[t](e);
                    return this
                }
                var gt, vt = /\d/,
                    yt = /\d\d/,
                    bt = /\d{3}/,
                    _t = /\d{4}/,
                    wt = /[+-]?\d{6}/,
                    At = /\d\d?/,
                    St = /\d\d\d\d?/,
                    kt = /\d\d\d\d\d\d?/,
                    xt = /\d{1,3}/,
                    Tt = /\d{1,4}/,
                    Et = /[+-]?\d{1,6}/,
                    Mt = /\d+/,
                    Ct = /[+-]?\d+/,
                    Pt = /Z|[+-]\d\d:?\d\d/gi,
                    Dt = /Z|[+-]\d\d(?::?\d\d)?/gi,
                    Lt = /[+-]?\d+(\.\d{1,3})?/,
                    Ot = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i;

                function It(t, e, i) {
                    gt[t] = C(e) ? e : function (t, r) {
                        return t && i ? i : e
                    }
                }

                function Rt(t, e) {
                    return o(gt, t) ? gt[t](e._strict, e._locale) : new RegExp(Ft(t))
                }

                function Ft(t) {
                    return Nt(t.replace("\\", "").replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, (function (t, e, i, r, n) {
                        return e || i || r || n
                    })))
                }

                function Nt(t) {
                    return t.replace(/[-\/\\^$*+?.()|[\]{}]/g, "\\$&")
                }
                gt = {};
                var Bt = {};

                function zt(t, e) {
                    var i, r, n = e;
                    for ("string" == typeof t && (t = [t]), u(e) && (n = function (t, i) {
                        i[e] = ut(t)
                    }), r = t.length, i = 0; i < r; i++) Bt[t[i]] = n
                }

                function qt(t, e) {
                    zt(t, (function (t, i, r, n) {
                        r._w = r._w || {}, e(t, r._w, r, n)
                    }))
                }

                function Vt(t, e, i) {
                    null != e && o(Bt, t) && Bt[t](e, i._a, i, t)
                }
                var Yt, jt = 0,
                    Gt = 1,
                    Ht = 2,
                    Wt = 3,
                    Zt = 4,
                    $t = 5,
                    Ut = 6,
                    Xt = 7,
                    Kt = 8;

                function Jt(t, e) {
                    return (t % e + e) % e
                }

                function Qt(t, e) {
                    if (isNaN(t) || isNaN(e)) return NaN;
                    var i = Jt(e, 12);
                    return t += (e - i) / 12, 1 === i ? lt(t) ? 29 : 28 : 31 - i % 7 % 2
                }
                Yt = Array.prototype.indexOf ? Array.prototype.indexOf : function (t) {
                    var e;
                    for (e = 0; e < this.length; ++e)
                        if (this[e] === t) return e;
                    return -1
                }, q("M", ["MM", 2], "Mo", (function () {
                    return this.month() + 1
                })), q("MMM", 0, 0, (function (t) {
                    return this.localeData().monthsShort(this, t)
                })), q("MMMM", 0, 0, (function (t) {
                    return this.localeData().months(this, t)
                })), it("month", "M"), st("month", 8), It("M", At), It("MM", At, yt), It("MMM", (function (t, e) {
                    return e.monthsShortRegex(t)
                })), It("MMMM", (function (t, e) {
                    return e.monthsRegex(t)
                })), zt(["M", "MM"], (function (t, e) {
                    e[Gt] = ut(t) - 1
                })), zt(["MMM", "MMMM"], (function (t, e, i, r) {
                    var n = i._locale.monthsParse(t, r, i._strict);
                    null != n ? e[Gt] = n : g(i).invalidMonth = t
                }));
                var te = "January_February_March_April_May_June_July_August_September_October_November_December".split("_"),
                    ee = "Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec".split("_"),
                    ie = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/,
                    re = Ot,
                    ne = Ot;

                function ae(t, e) {
                    return t ? a(this._months) ? this._months[t.month()] : this._months[(this._months.isFormat || ie).test(e) ? "format" : "standalone"][t.month()] : a(this._months) ? this._months : this._months.standalone
                }

                function se(t, e) {
                    return t ? a(this._monthsShort) ? this._monthsShort[t.month()] : this._monthsShort[ie.test(e) ? "format" : "standalone"][t.month()] : a(this._monthsShort) ? this._monthsShort : this._monthsShort.standalone
                }

                function oe(t, e, i) {
                    var r, n, a, s = t.toLocaleLowerCase();
                    if (!this._monthsParse)
                        for (this._monthsParse = [], this._longMonthsParse = [], this._shortMonthsParse = [], r = 0; r < 12; ++r) a = f([2e3, r]), this._shortMonthsParse[r] = this.monthsShort(a, "").toLocaleLowerCase(), this._longMonthsParse[r] = this.months(a, "").toLocaleLowerCase();
                    return i ? "MMM" === e ? -1 !== (n = Yt.call(this._shortMonthsParse, s)) ? n : null : -1 !== (n = Yt.call(this._longMonthsParse, s)) ? n : null : "MMM" === e ? -1 !== (n = Yt.call(this._shortMonthsParse, s)) || -1 !== (n = Yt.call(this._longMonthsParse, s)) ? n : null : -1 !== (n = Yt.call(this._longMonthsParse, s)) || -1 !== (n = Yt.call(this._shortMonthsParse, s)) ? n : null
                }

                function le(t, e, i) {
                    var r, n, a;
                    if (this._monthsParseExact) return oe.call(this, t, e, i);
                    for (this._monthsParse || (this._monthsParse = [], this._longMonthsParse = [], this._shortMonthsParse = []), r = 0; r < 12; r++) {
                        if (n = f([2e3, r]), i && !this._longMonthsParse[r] && (this._longMonthsParse[r] = new RegExp("^" + this.months(n, "").replace(".", "") + "$", "i"), this._shortMonthsParse[r] = new RegExp("^" + this.monthsShort(n, "").replace(".", "") + "$", "i")), i || this._monthsParse[r] || (a = "^" + this.months(n, "") + "|^" + this.monthsShort(n, ""), this._monthsParse[r] = new RegExp(a.replace(".", ""), "i")), i && "MMMM" === e && this._longMonthsParse[r].test(t)) return r;
                        if (i && "MMM" === e && this._shortMonthsParse[r].test(t)) return r;
                        if (!i && this._monthsParse[r].test(t)) return r
                    }
                }

                function ce(t, e) {
                    var i;
                    if (!t.isValid()) return t;
                    if ("string" == typeof e)
                        if (/^\d+$/.test(e)) e = ut(e);
                        else if (!u(e = t.localeData().monthsParse(e))) return t;
                    return i = Math.min(t.date(), Qt(t.year(), e)), t._d["set" + (t._isUTC ? "UTC" : "") + "Month"](e, i), t
                }

                function ue(t) {
                    return null != t ? (ce(this, t), r.updateOffset(this, !0), this) : dt(this, "Month")
                }

                function he() {
                    return Qt(this.year(), this.month())
                }

                function de(t) {
                    return this._monthsParseExact ? (o(this, "_monthsRegex") || fe.call(this), t ? this._monthsShortStrictRegex : this._monthsShortRegex) : (o(this, "_monthsShortRegex") || (this._monthsShortRegex = re), this._monthsShortStrictRegex && t ? this._monthsShortStrictRegex : this._monthsShortRegex)
                }

                function pe(t) {
                    return this._monthsParseExact ? (o(this, "_monthsRegex") || fe.call(this), t ? this._monthsStrictRegex : this._monthsRegex) : (o(this, "_monthsRegex") || (this._monthsRegex = ne), this._monthsStrictRegex && t ? this._monthsStrictRegex : this._monthsRegex)
                }

                function fe() {
                    function t(t, e) {
                        return e.length - t.length
                    }
                    var e, i, r = [],
                        n = [],
                        a = [];
                    for (e = 0; e < 12; e++) i = f([2e3, e]), r.push(this.monthsShort(i, "")), n.push(this.months(i, "")), a.push(this.months(i, "")), a.push(this.monthsShort(i, ""));
                    for (r.sort(t), n.sort(t), a.sort(t), e = 0; e < 12; e++) r[e] = Nt(r[e]), n[e] = Nt(n[e]);
                    for (e = 0; e < 24; e++) a[e] = Nt(a[e]);
                    this._monthsRegex = new RegExp("^(" + a.join("|") + ")", "i"), this._monthsShortRegex = this._monthsRegex, this._monthsStrictRegex = new RegExp("^(" + n.join("|") + ")", "i"), this._monthsShortStrictRegex = new RegExp("^(" + r.join("|") + ")", "i")
                }

                function me(t) {
                    return lt(t) ? 366 : 365
                }
                q("Y", 0, 0, (function () {
                    var t = this.year();
                    return t <= 9999 ? R(t, 4) : "+" + t
                })), q(0, ["YY", 2], 0, (function () {
                    return this.year() % 100
                })), q(0, ["YYYY", 4], 0, "year"), q(0, ["YYYYY", 5], 0, "year"), q(0, ["YYYYYY", 6, !0], 0, "year"), it("year", "y"), st("year", 1), It("Y", Ct), It("YY", At, yt), It("YYYY", Tt, _t), It("YYYYY", Et, wt), It("YYYYYY", Et, wt), zt(["YYYYY", "YYYYYY"], jt), zt("YYYY", (function (t, e) {
                    e[jt] = 2 === t.length ? r.parseTwoDigitYear(t) : ut(t)
                })), zt("YY", (function (t, e) {
                    e[jt] = r.parseTwoDigitYear(t)
                })), zt("Y", (function (t, e) {
                    e[jt] = parseInt(t, 10)
                })), r.parseTwoDigitYear = function (t) {
                    return ut(t) + (ut(t) > 68 ? 1900 : 2e3)
                };
                var ge = ht("FullYear", !0);

                function ve() {
                    return lt(this.year())
                }

                function ye(t, e, i, r, n, a, s) {
                    var o;
                    return t < 100 && t >= 0 ? (o = new Date(t + 400, e, i, r, n, a, s), isFinite(o.getFullYear()) && o.setFullYear(t)) : o = new Date(t, e, i, r, n, a, s), o
                }

                function be(t) {
                    var e, i;
                    return t < 100 && t >= 0 ? ((i = Array.prototype.slice.call(arguments))[0] = t + 400, e = new Date(Date.UTC.apply(null, i)), isFinite(e.getUTCFullYear()) && e.setUTCFullYear(t)) : e = new Date(Date.UTC.apply(null, arguments)), e
                }

                function _e(t, e, i) {
                    var r = 7 + e - i;
                    return -(7 + be(t, 0, r).getUTCDay() - e) % 7 + r - 1
                }

                function we(t, e, i, r, n) {
                    var a, s, o = 1 + 7 * (e - 1) + (7 + i - r) % 7 + _e(t, r, n);
                    return o <= 0 ? s = me(a = t - 1) + o : o > me(t) ? (a = t + 1, s = o - me(t)) : (a = t, s = o), {
                        year: a,
                        dayOfYear: s
                    }
                }

                function Ae(t, e, i) {
                    var r, n, a = _e(t.year(), e, i),
                        s = Math.floor((t.dayOfYear() - a - 1) / 7) + 1;
                    return s < 1 ? r = s + Se(n = t.year() - 1, e, i) : s > Se(t.year(), e, i) ? (r = s - Se(t.year(), e, i), n = t.year() + 1) : (n = t.year(), r = s), {
                        week: r,
                        year: n
                    }
                }

                function Se(t, e, i) {
                    var r = _e(t, e, i),
                        n = _e(t + 1, e, i);
                    return (me(t) - r + n) / 7
                }

                function ke(t) {
                    return Ae(t, this._week.dow, this._week.doy).week
                }
                q("w", ["ww", 2], "wo", "week"), q("W", ["WW", 2], "Wo", "isoWeek"), it("week", "w"), it("isoWeek", "W"), st("week", 5), st("isoWeek", 5), It("w", At), It("ww", At, yt), It("W", At), It("WW", At, yt), qt(["w", "ww", "W", "WW"], (function (t, e, i, r) {
                    e[r.substr(0, 1)] = ut(t)
                }));
                var xe = {
                    dow: 0,
                    doy: 6
                };

                function Te() {
                    return this._week.dow
                }

                function Ee() {
                    return this._week.doy
                }

                function Me(t) {
                    var e = this.localeData().week(this);
                    return null == t ? e : this.add(7 * (t - e), "d")
                }

                function Ce(t) {
                    var e = Ae(this, 1, 4).week;
                    return null == t ? e : this.add(7 * (t - e), "d")
                }

                function Pe(t, e) {
                    return "string" != typeof t ? t : isNaN(t) ? "number" == typeof (t = e.weekdaysParse(t)) ? t : null : parseInt(t, 10)
                }

                function De(t, e) {
                    return "string" == typeof t ? e.weekdaysParse(t) % 7 || 7 : isNaN(t) ? null : t
                }

                function Le(t, e) {
                    return t.slice(e, 7).concat(t.slice(0, e))
                }
                q("d", 0, "do", "day"), q("dd", 0, 0, (function (t) {
                    return this.localeData().weekdaysMin(this, t)
                })), q("ddd", 0, 0, (function (t) {
                    return this.localeData().weekdaysShort(this, t)
                })), q("dddd", 0, 0, (function (t) {
                    return this.localeData().weekdays(this, t)
                })), q("e", 0, 0, "weekday"), q("E", 0, 0, "isoWeekday"), it("day", "d"), it("weekday", "e"), it("isoWeekday", "E"), st("day", 11), st("weekday", 11), st("isoWeekday", 11), It("d", At), It("e", At), It("E", At), It("dd", (function (t, e) {
                    return e.weekdaysMinRegex(t)
                })), It("ddd", (function (t, e) {
                    return e.weekdaysShortRegex(t)
                })), It("dddd", (function (t, e) {
                    return e.weekdaysRegex(t)
                })), qt(["dd", "ddd", "dddd"], (function (t, e, i, r) {
                    var n = i._locale.weekdaysParse(t, r, i._strict);
                    null != n ? e.d = n : g(i).invalidWeekday = t
                })), qt(["d", "e", "E"], (function (t, e, i, r) {
                    e[r] = ut(t)
                }));
                var Oe = "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),
                    Ie = "Sun_Mon_Tue_Wed_Thu_Fri_Sat".split("_"),
                    Re = "Su_Mo_Tu_We_Th_Fr_Sa".split("_"),
                    Fe = Ot,
                    Ne = Ot,
                    Be = Ot;

                function ze(t, e) {
                    var i = a(this._weekdays) ? this._weekdays : this._weekdays[t && !0 !== t && this._weekdays.isFormat.test(e) ? "format" : "standalone"];
                    return !0 === t ? Le(i, this._week.dow) : t ? i[t.day()] : i
                }

                function qe(t) {
                    return !0 === t ? Le(this._weekdaysShort, this._week.dow) : t ? this._weekdaysShort[t.day()] : this._weekdaysShort
                }

                function Ve(t) {
                    return !0 === t ? Le(this._weekdaysMin, this._week.dow) : t ? this._weekdaysMin[t.day()] : this._weekdaysMin
                }

                function Ye(t, e, i) {
                    var r, n, a, s = t.toLocaleLowerCase();
                    if (!this._weekdaysParse)
                        for (this._weekdaysParse = [], this._shortWeekdaysParse = [], this._minWeekdaysParse = [], r = 0; r < 7; ++r) a = f([2e3, 1]).day(r), this._minWeekdaysParse[r] = this.weekdaysMin(a, "").toLocaleLowerCase(), this._shortWeekdaysParse[r] = this.weekdaysShort(a, "").toLocaleLowerCase(), this._weekdaysParse[r] = this.weekdays(a, "").toLocaleLowerCase();
                    return i ? "dddd" === e ? -1 !== (n = Yt.call(this._weekdaysParse, s)) ? n : null : "ddd" === e ? -1 !== (n = Yt.call(this._shortWeekdaysParse, s)) ? n : null : -1 !== (n = Yt.call(this._minWeekdaysParse, s)) ? n : null : "dddd" === e ? -1 !== (n = Yt.call(this._weekdaysParse, s)) || -1 !== (n = Yt.call(this._shortWeekdaysParse, s)) || -1 !== (n = Yt.call(this._minWeekdaysParse, s)) ? n : null : "ddd" === e ? -1 !== (n = Yt.call(this._shortWeekdaysParse, s)) || -1 !== (n = Yt.call(this._weekdaysParse, s)) || -1 !== (n = Yt.call(this._minWeekdaysParse, s)) ? n : null : -1 !== (n = Yt.call(this._minWeekdaysParse, s)) || -1 !== (n = Yt.call(this._weekdaysParse, s)) || -1 !== (n = Yt.call(this._shortWeekdaysParse, s)) ? n : null
                }

                function je(t, e, i) {
                    var r, n, a;
                    if (this._weekdaysParseExact) return Ye.call(this, t, e, i);
                    for (this._weekdaysParse || (this._weekdaysParse = [], this._minWeekdaysParse = [], this._shortWeekdaysParse = [], this._fullWeekdaysParse = []), r = 0; r < 7; r++) {
                        if (n = f([2e3, 1]).day(r), i && !this._fullWeekdaysParse[r] && (this._fullWeekdaysParse[r] = new RegExp("^" + this.weekdays(n, "").replace(".", "\\.?") + "$", "i"), this._shortWeekdaysParse[r] = new RegExp("^" + this.weekdaysShort(n, "").replace(".", "\\.?") + "$", "i"), this._minWeekdaysParse[r] = new RegExp("^" + this.weekdaysMin(n, "").replace(".", "\\.?") + "$", "i")), this._weekdaysParse[r] || (a = "^" + this.weekdays(n, "") + "|^" + this.weekdaysShort(n, "") + "|^" + this.weekdaysMin(n, ""), this._weekdaysParse[r] = new RegExp(a.replace(".", ""), "i")), i && "dddd" === e && this._fullWeekdaysParse[r].test(t)) return r;
                        if (i && "ddd" === e && this._shortWeekdaysParse[r].test(t)) return r;
                        if (i && "dd" === e && this._minWeekdaysParse[r].test(t)) return r;
                        if (!i && this._weekdaysParse[r].test(t)) return r
                    }
                }

                function Ge(t) {
                    if (!this.isValid()) return null != t ? this : NaN;
                    var e = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
                    return null != t ? (t = Pe(t, this.localeData()), this.add(t - e, "d")) : e
                }

                function He(t) {
                    if (!this.isValid()) return null != t ? this : NaN;
                    var e = (this.day() + 7 - this.localeData()._week.dow) % 7;
                    return null == t ? e : this.add(t - e, "d")
                }

                function We(t) {
                    if (!this.isValid()) return null != t ? this : NaN;
                    if (null != t) {
                        var e = De(t, this.localeData());
                        return this.day(this.day() % 7 ? e : e - 7)
                    }
                    return this.day() || 7
                }

                function Ze(t) {
                    return this._weekdaysParseExact ? (o(this, "_weekdaysRegex") || Xe.call(this), t ? this._weekdaysStrictRegex : this._weekdaysRegex) : (o(this, "_weekdaysRegex") || (this._weekdaysRegex = Fe), this._weekdaysStrictRegex && t ? this._weekdaysStrictRegex : this._weekdaysRegex)
                }

                function $e(t) {
                    return this._weekdaysParseExact ? (o(this, "_weekdaysRegex") || Xe.call(this), t ? this._weekdaysShortStrictRegex : this._weekdaysShortRegex) : (o(this, "_weekdaysShortRegex") || (this._weekdaysShortRegex = Ne), this._weekdaysShortStrictRegex && t ? this._weekdaysShortStrictRegex : this._weekdaysShortRegex)
                }

                function Ue(t) {
                    return this._weekdaysParseExact ? (o(this, "_weekdaysRegex") || Xe.call(this), t ? this._weekdaysMinStrictRegex : this._weekdaysMinRegex) : (o(this, "_weekdaysMinRegex") || (this._weekdaysMinRegex = Be), this._weekdaysMinStrictRegex && t ? this._weekdaysMinStrictRegex : this._weekdaysMinRegex)
                }

                function Xe() {
                    function t(t, e) {
                        return e.length - t.length
                    }
                    var e, i, r, n, a, s = [],
                        o = [],
                        l = [],
                        c = [];
                    for (e = 0; e < 7; e++) i = f([2e3, 1]).day(e), r = Nt(this.weekdaysMin(i, "")), n = Nt(this.weekdaysShort(i, "")), a = Nt(this.weekdays(i, "")), s.push(r), o.push(n), l.push(a), c.push(r), c.push(n), c.push(a);
                    s.sort(t), o.sort(t), l.sort(t), c.sort(t), this._weekdaysRegex = new RegExp("^(" + c.join("|") + ")", "i"), this._weekdaysShortRegex = this._weekdaysRegex, this._weekdaysMinRegex = this._weekdaysRegex, this._weekdaysStrictRegex = new RegExp("^(" + l.join("|") + ")", "i"), this._weekdaysShortStrictRegex = new RegExp("^(" + o.join("|") + ")", "i"), this._weekdaysMinStrictRegex = new RegExp("^(" + s.join("|") + ")", "i")
                }

                function Ke() {
                    return this.hours() % 12 || 12
                }

                function Je() {
                    return this.hours() || 24
                }

                function Qe(t, e) {
                    q(t, 0, 0, (function () {
                        return this.localeData().meridiem(this.hours(), this.minutes(), e)
                    }))
                }

                function ti(t, e) {
                    return e._meridiemParse
                }

                function ei(t) {
                    return "p" === (t + "").toLowerCase().charAt(0)
                }
                q("H", ["HH", 2], 0, "hour"), q("h", ["hh", 2], 0, Ke), q("k", ["kk", 2], 0, Je), q("hmm", 0, 0, (function () {
                    return "" + Ke.apply(this) + R(this.minutes(), 2)
                })), q("hmmss", 0, 0, (function () {
                    return "" + Ke.apply(this) + R(this.minutes(), 2) + R(this.seconds(), 2)
                })), q("Hmm", 0, 0, (function () {
                    return "" + this.hours() + R(this.minutes(), 2)
                })), q("Hmmss", 0, 0, (function () {
                    return "" + this.hours() + R(this.minutes(), 2) + R(this.seconds(), 2)
                })), Qe("a", !0), Qe("A", !1), it("hour", "h"), st("hour", 13), It("a", ti), It("A", ti), It("H", At), It("h", At), It("k", At), It("HH", At, yt), It("hh", At, yt), It("kk", At, yt), It("hmm", St), It("hmmss", kt), It("Hmm", St), It("Hmmss", kt), zt(["H", "HH"], Wt), zt(["k", "kk"], (function (t, e, i) {
                    var r = ut(t);
                    e[Wt] = 24 === r ? 0 : r
                })), zt(["a", "A"], (function (t, e, i) {
                    i._isPm = i._locale.isPM(t), i._meridiem = t
                })), zt(["h", "hh"], (function (t, e, i) {
                    e[Wt] = ut(t), g(i).bigHour = !0
                })), zt("hmm", (function (t, e, i) {
                    var r = t.length - 2;
                    e[Wt] = ut(t.substr(0, r)), e[Zt] = ut(t.substr(r)), g(i).bigHour = !0
                })), zt("hmmss", (function (t, e, i) {
                    var r = t.length - 4,
                        n = t.length - 2;
                    e[Wt] = ut(t.substr(0, r)), e[Zt] = ut(t.substr(r, 2)), e[$t] = ut(t.substr(n)), g(i).bigHour = !0
                })), zt("Hmm", (function (t, e, i) {
                    var r = t.length - 2;
                    e[Wt] = ut(t.substr(0, r)), e[Zt] = ut(t.substr(r))
                })), zt("Hmmss", (function (t, e, i) {
                    var r = t.length - 4,
                        n = t.length - 2;
                    e[Wt] = ut(t.substr(0, r)), e[Zt] = ut(t.substr(r, 2)), e[$t] = ut(t.substr(n))
                }));
                var ii = /[ap]\.?m?\.?/i,
                    ri = ht("Hours", !0);

                function ni(t, e, i) {
                    return t > 11 ? i ? "pm" : "PM" : i ? "am" : "AM"
                }
                var ai, si = {
                    calendar: O,
                    longDateFormat: H,
                    invalidDate: Z,
                    ordinal: U,
                    dayOfMonthOrdinalParse: X,
                    relativeTime: J,
                    months: te,
                    monthsShort: ee,
                    week: xe,
                    weekdays: Oe,
                    weekdaysMin: Re,
                    weekdaysShort: Ie,
                    meridiemParse: ii
                },
                    oi = {},
                    li = {};

                function ci(t, e) {
                    var i, r = Math.min(t.length, e.length);
                    for (i = 0; i < r; i += 1)
                        if (t[i] !== e[i]) return i;
                    return r
                }

                function ui(t) {
                    return t ? t.toLowerCase().replace("_", "-") : t
                }

                function hi(t) {
                    for (var e, i, r, n, a = 0; a < t.length;) {
                        for (e = (n = ui(t[a]).split("-")).length, i = (i = ui(t[a + 1])) ? i.split("-") : null; e > 0;) {
                            if (r = pi(n.slice(0, e).join("-"))) return r;
                            if (i && i.length >= e && ci(n, i) >= e - 1) break;
                            e--
                        }
                        a++
                    }
                    return ai
                }

                function di(t) {
                    return null != t.match("^[^/\\\\]*$")
                }

                function pi(e) {
                    var i = null;
                    if (void 0 === oi[e] && t && t.exports && di(e)) try {
                        i = ai._abbr, Object(function () {
                            var t = new Error("Cannot find module 'undefined'");
                            throw t.code = "MODULE_NOT_FOUND", t
                        }()), fi(i)
                    } catch (t) {
                        oi[e] = null
                    }
                    return oi[e]
                }

                function fi(t, e) {
                    var i;
                    return t && ((i = c(e) ? vi(t) : mi(t, e)) ? ai = i : "undefined" != typeof console && console.warn && console.warn("Locale " + t + " not found. Did you forget to load it?")), ai._abbr
                }

                function mi(t, e) {
                    if (null !== e) {
                        var i, r = si;
                        if (e.abbr = t, null != oi[t]) M("defineLocaleOverride", "use moment.updateLocale(localeName, config) to change an existing locale. moment.defineLocale(localeName, config) should only be used for creating a new locale See http://momentjs.com/guides/#/warnings/define-locale/ for more info."), r = oi[t]._config;
                        else if (null != e.parentLocale)
                            if (null != oi[e.parentLocale]) r = oi[e.parentLocale]._config;
                            else {
                                if (null == (i = pi(e.parentLocale))) return li[e.parentLocale] || (li[e.parentLocale] = []), li[e.parentLocale].push({
                                    name: t,
                                    config: e
                                }), null;
                                r = i._config
                            } return oi[t] = new L(D(r, e)), li[t] && li[t].forEach((function (t) {
                                mi(t.name, t.config)
                            })), fi(t), oi[t]
                    }
                    return delete oi[t], null
                }

                function gi(t, e) {
                    if (null != e) {
                        var i, r, n = si;
                        null != oi[t] && null != oi[t].parentLocale ? oi[t].set(D(oi[t]._config, e)) : (null != (r = pi(t)) && (n = r._config), e = D(n, e), null == r && (e.abbr = t), (i = new L(e)).parentLocale = oi[t], oi[t] = i), fi(t)
                    } else null != oi[t] && (null != oi[t].parentLocale ? (oi[t] = oi[t].parentLocale, t === fi() && fi(t)) : null != oi[t] && delete oi[t]);
                    return oi[t]
                }

                function vi(t) {
                    var e;
                    if (t && t._locale && t._locale._abbr && (t = t._locale._abbr), !t) return ai;
                    if (!a(t)) {
                        if (e = pi(t)) return e;
                        t = [t]
                    }
                    return hi(t)
                }

                function yi() {
                    return T(oi)
                }

                function bi(t) {
                    var e, i = t._a;
                    return i && -2 === g(t).overflow && (e = i[Gt] < 0 || i[Gt] > 11 ? Gt : i[Ht] < 1 || i[Ht] > Qt(i[jt], i[Gt]) ? Ht : i[Wt] < 0 || i[Wt] > 24 || 24 === i[Wt] && (0 !== i[Zt] || 0 !== i[$t] || 0 !== i[Ut]) ? Wt : i[Zt] < 0 || i[Zt] > 59 ? Zt : i[$t] < 0 || i[$t] > 59 ? $t : i[Ut] < 0 || i[Ut] > 999 ? Ut : -1, g(t)._overflowDayOfYear && (e < jt || e > Ht) && (e = Ht), g(t)._overflowWeeks && -1 === e && (e = Xt), g(t)._overflowWeekday && -1 === e && (e = Kt), g(t).overflow = e), t
                }
                var _i = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/,
                    wi = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d|))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/,
                    Ai = /Z|[+-]\d\d(?::?\d\d)?/,
                    Si = [
                        ["YYYYYY-MM-DD", /[+-]\d{6}-\d\d-\d\d/],
                        ["YYYY-MM-DD", /\d{4}-\d\d-\d\d/],
                        ["GGGG-[W]WW-E", /\d{4}-W\d\d-\d/],
                        ["GGGG-[W]WW", /\d{4}-W\d\d/, !1],
                        ["YYYY-DDD", /\d{4}-\d{3}/],
                        ["YYYY-MM", /\d{4}-\d\d/, !1],
                        ["YYYYYYMMDD", /[+-]\d{10}/],
                        ["YYYYMMDD", /\d{8}/],
                        ["GGGG[W]WWE", /\d{4}W\d{3}/],
                        ["GGGG[W]WW", /\d{4}W\d{2}/, !1],
                        ["YYYYDDD", /\d{7}/],
                        ["YYYYMM", /\d{6}/, !1],
                        ["YYYY", /\d{4}/, !1]
                    ],
                    ki = [
                        ["HH:mm:ss.SSSS", /\d\d:\d\d:\d\d\.\d+/],
                        ["HH:mm:ss,SSSS", /\d\d:\d\d:\d\d,\d+/],
                        ["HH:mm:ss", /\d\d:\d\d:\d\d/],
                        ["HH:mm", /\d\d:\d\d/],
                        ["HHmmss.SSSS", /\d\d\d\d\d\d\.\d+/],
                        ["HHmmss,SSSS", /\d\d\d\d\d\d,\d+/],
                        ["HHmmss", /\d\d\d\d\d\d/],
                        ["HHmm", /\d\d\d\d/],
                        ["HH", /\d\d/]
                    ],
                    xi = /^\/?Date\((-?\d+)/i,
                    Ti = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/,
                    Ei = {
                        UT: 0,
                        GMT: 0,
                        EDT: -240,
                        EST: -300,
                        CDT: -300,
                        CST: -360,
                        MDT: -360,
                        MST: -420,
                        PDT: -420,
                        PST: -480
                    };

                function Mi(t) {
                    var e, i, r, n, a, s, o = t._i,
                        l = _i.exec(o) || wi.exec(o),
                        c = Si.length,
                        u = ki.length;
                    if (l) {
                        for (g(t).iso = !0, e = 0, i = c; e < i; e++)
                            if (Si[e][1].exec(l[1])) {
                                n = Si[e][0], r = !1 !== Si[e][2];
                                break
                            } if (null == n) return void (t._isValid = !1);
                        if (l[3]) {
                            for (e = 0, i = u; e < i; e++)
                                if (ki[e][1].exec(l[3])) {
                                    a = (l[2] || " ") + ki[e][0];
                                    break
                                } if (null == a) return void (t._isValid = !1)
                        }
                        if (!r && null != a) return void (t._isValid = !1);
                        if (l[4]) {
                            if (!Ai.exec(l[4])) return void (t._isValid = !1);
                            s = "Z"
                        }
                        t._f = n + (a || "") + (s || ""), qi(t)
                    } else t._isValid = !1
                }

                function Ci(t, e, i, r, n, a) {
                    var s = [Pi(t), ee.indexOf(e), parseInt(i, 10), parseInt(r, 10), parseInt(n, 10)];
                    return a && s.push(parseInt(a, 10)), s
                }

                function Pi(t) {
                    var e = parseInt(t, 10);
                    return e <= 49 ? 2e3 + e : e <= 999 ? 1900 + e : e
                }

                function Di(t) {
                    return t.replace(/\([^()]*\)|[\n\t]/g, " ").replace(/(\s\s+)/g, " ").replace(/^\s\s*/, "").replace(/\s\s*$/, "")
                }

                function Li(t, e, i) {
                    return !t || Ie.indexOf(t) === new Date(e[0], e[1], e[2]).getDay() || (g(i).weekdayMismatch = !0, i._isValid = !1, !1)
                }

                function Oi(t, e, i) {
                    if (t) return Ei[t];
                    if (e) return 0;
                    var r = parseInt(i, 10),
                        n = r % 100;
                    return (r - n) / 100 * 60 + n
                }

                function Ii(t) {
                    var e, i = Ti.exec(Di(t._i));
                    if (i) {
                        if (e = Ci(i[4], i[3], i[2], i[5], i[6], i[7]), !Li(i[1], e, t)) return;
                        t._a = e, t._tzm = Oi(i[8], i[9], i[10]), t._d = be.apply(null, t._a), t._d.setUTCMinutes(t._d.getUTCMinutes() - t._tzm), g(t).rfc2822 = !0
                    } else t._isValid = !1
                }

                function Ri(t) {
                    var e = xi.exec(t._i);
                    null === e ? (Mi(t), !1 === t._isValid && (delete t._isValid, Ii(t), !1 === t._isValid && (delete t._isValid, t._strict ? t._isValid = !1 : r.createFromInputFallback(t)))) : t._d = new Date(+e[1])
                }

                function Fi(t, e, i) {
                    return null != t ? t : null != e ? e : i
                }

                function Ni(t) {
                    var e = new Date(r.now());
                    return t._useUTC ? [e.getUTCFullYear(), e.getUTCMonth(), e.getUTCDate()] : [e.getFullYear(), e.getMonth(), e.getDate()]
                }

                function Bi(t) {
                    var e, i, r, n, a, s = [];
                    if (!t._d) {
                        for (r = Ni(t), t._w && null == t._a[Ht] && null == t._a[Gt] && zi(t), null != t._dayOfYear && (a = Fi(t._a[jt], r[jt]), (t._dayOfYear > me(a) || 0 === t._dayOfYear) && (g(t)._overflowDayOfYear = !0), i = be(a, 0, t._dayOfYear), t._a[Gt] = i.getUTCMonth(), t._a[Ht] = i.getUTCDate()), e = 0; e < 3 && null == t._a[e]; ++e) t._a[e] = s[e] = r[e];
                        for (; e < 7; e++) t._a[e] = s[e] = null == t._a[e] ? 2 === e ? 1 : 0 : t._a[e];
                        24 === t._a[Wt] && 0 === t._a[Zt] && 0 === t._a[$t] && 0 === t._a[Ut] && (t._nextDay = !0, t._a[Wt] = 0), t._d = (t._useUTC ? be : ye).apply(null, s), n = t._useUTC ? t._d.getUTCDay() : t._d.getDay(), null != t._tzm && t._d.setUTCMinutes(t._d.getUTCMinutes() - t._tzm), t._nextDay && (t._a[Wt] = 24), t._w && void 0 !== t._w.d && t._w.d !== n && (g(t).weekdayMismatch = !0)
                    }
                }

                function zi(t) {
                    var e, i, r, n, a, s, o, l, c;
                    null != (e = t._w).GG || null != e.W || null != e.E ? (a = 1, s = 4, i = Fi(e.GG, t._a[jt], Ae($i(), 1, 4).year), r = Fi(e.W, 1), ((n = Fi(e.E, 1)) < 1 || n > 7) && (l = !0)) : (a = t._locale._week.dow, s = t._locale._week.doy, c = Ae($i(), a, s), i = Fi(e.gg, t._a[jt], c.year), r = Fi(e.w, c.week), null != e.d ? ((n = e.d) < 0 || n > 6) && (l = !0) : null != e.e ? (n = e.e + a, (e.e < 0 || e.e > 6) && (l = !0)) : n = a), r < 1 || r > Se(i, a, s) ? g(t)._overflowWeeks = !0 : null != l ? g(t)._overflowWeekday = !0 : (o = we(i, r, n, a, s), t._a[jt] = o.year, t._dayOfYear = o.dayOfYear)
                }

                function qi(t) {
                    if (t._f !== r.ISO_8601)
                        if (t._f !== r.RFC_2822) {
                            t._a = [], g(t).empty = !0;
                            var e, i, n, a, s, o, l, c = "" + t._i,
                                u = c.length,
                                h = 0;
                            for (l = (n = G(t._f, t._locale).match(F) || []).length, e = 0; e < l; e++) a = n[e], (i = (c.match(Rt(a, t)) || [])[0]) && ((s = c.substr(0, c.indexOf(i))).length > 0 && g(t).unusedInput.push(s), c = c.slice(c.indexOf(i) + i.length), h += i.length), z[a] ? (i ? g(t).empty = !1 : g(t).unusedTokens.push(a), Vt(a, i, t)) : t._strict && !i && g(t).unusedTokens.push(a);
                            g(t).charsLeftOver = u - h, c.length > 0 && g(t).unusedInput.push(c), t._a[Wt] <= 12 && !0 === g(t).bigHour && t._a[Wt] > 0 && (g(t).bigHour = void 0), g(t).parsedDateParts = t._a.slice(0), g(t).meridiem = t._meridiem, t._a[Wt] = Vi(t._locale, t._a[Wt], t._meridiem), null !== (o = g(t).era) && (t._a[jt] = t._locale.erasConvertYear(o, t._a[jt])), Bi(t), bi(t)
                        } else Ii(t);
                    else Mi(t)
                }

                function Vi(t, e, i) {
                    var r;
                    return null == i ? e : null != t.meridiemHour ? t.meridiemHour(e, i) : null != t.isPM ? ((r = t.isPM(i)) && e < 12 && (e += 12), r || 12 !== e || (e = 0), e) : e
                }

                function Yi(t) {
                    var e, i, r, n, a, s, o = !1,
                        l = t._f.length;
                    if (0 === l) return g(t).invalidFormat = !0, void (t._d = new Date(NaN));
                    for (n = 0; n < l; n++) a = 0, s = !1, e = w({}, t), null != t._useUTC && (e._useUTC = t._useUTC), e._f = t._f[n], qi(e), v(e) && (s = !0), a += g(e).charsLeftOver, a += 10 * g(e).unusedTokens.length, g(e).score = a, o ? a < r && (r = a, i = e) : (null == r || a < r || s) && (r = a, i = e, s && (o = !0));
                    p(t, i || e)
                }

                function ji(t) {
                    if (!t._d) {
                        var e = nt(t._i),
                            i = void 0 === e.day ? e.date : e.day;
                        t._a = d([e.year, e.month, i, e.hour, e.minute, e.second, e.millisecond], (function (t) {
                            return t && parseInt(t, 10)
                        })), Bi(t)
                    }
                }

                function Gi(t) {
                    var e = new A(bi(Hi(t)));
                    return e._nextDay && (e.add(1, "d"), e._nextDay = void 0), e
                }

                function Hi(t) {
                    var e = t._i,
                        i = t._f;
                    return t._locale = t._locale || vi(t._l), null === e || void 0 === i && "" === e ? y({
                        nullInput: !0
                    }) : ("string" == typeof e && (t._i = e = t._locale.preparse(e)), S(e) ? new A(bi(e)) : (h(e) ? t._d = e : a(i) ? Yi(t) : i ? qi(t) : Wi(t), v(t) || (t._d = null), t))
                }

                function Wi(t) {
                    var e = t._i;
                    c(e) ? t._d = new Date(r.now()) : h(e) ? t._d = new Date(e.valueOf()) : "string" == typeof e ? Ri(t) : a(e) ? (t._a = d(e.slice(0), (function (t) {
                        return parseInt(t, 10)
                    })), Bi(t)) : s(e) ? ji(t) : u(e) ? t._d = new Date(e) : r.createFromInputFallback(t)
                }

                function Zi(t, e, i, r, n) {
                    var o = {};
                    return !0 !== e && !1 !== e || (r = e, e = void 0), !0 !== i && !1 !== i || (r = i, i = void 0), (s(t) && l(t) || a(t) && 0 === t.length) && (t = void 0), o._isAMomentObject = !0, o._useUTC = o._isUTC = n, o._l = i, o._i = t, o._f = e, o._strict = r, Gi(o)
                }

                function $i(t, e, i, r) {
                    return Zi(t, e, i, r, !1)
                }
                r.createFromInputFallback = x("value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are discouraged. Please refer to http://momentjs.com/guides/#/warnings/js-date/ for more info.", (function (t) {
                    t._d = new Date(t._i + (t._useUTC ? " UTC" : ""))
                })), r.ISO_8601 = function () { }, r.RFC_2822 = function () { };
                var Ui = x("moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/", (function () {
                    var t = $i.apply(null, arguments);
                    return this.isValid() && t.isValid() ? t < this ? this : t : y()
                })),
                    Xi = x("moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/", (function () {
                        var t = $i.apply(null, arguments);
                        return this.isValid() && t.isValid() ? t > this ? this : t : y()
                    }));

                function Ki(t, e) {
                    var i, r;
                    if (1 === e.length && a(e[0]) && (e = e[0]), !e.length) return $i();
                    for (i = e[0], r = 1; r < e.length; ++r) e[r].isValid() && !e[r][t](i) || (i = e[r]);
                    return i
                }

                function Ji() {
                    return Ki("isBefore", [].slice.call(arguments, 0))
                }

                function Qi() {
                    return Ki("isAfter", [].slice.call(arguments, 0))
                }
                var tr = function () {
                    return Date.now ? Date.now() : +new Date
                },
                    er = ["year", "quarter", "month", "week", "day", "hour", "minute", "second", "millisecond"];

                function ir(t) {
                    var e, i, r = !1,
                        n = er.length;
                    for (e in t)
                        if (o(t, e) && (-1 === Yt.call(er, e) || null != t[e] && isNaN(t[e]))) return !1;
                    for (i = 0; i < n; ++i)
                        if (t[er[i]]) {
                            if (r) return !1;
                            parseFloat(t[er[i]]) !== ut(t[er[i]]) && (r = !0)
                        } return !0
                }

                function rr() {
                    return this._isValid
                }

                function nr() {
                    return Er(NaN)
                }

                function ar(t) {
                    var e = nt(t),
                        i = e.year || 0,
                        r = e.quarter || 0,
                        n = e.month || 0,
                        a = e.week || e.isoWeek || 0,
                        s = e.day || 0,
                        o = e.hour || 0,
                        l = e.minute || 0,
                        c = e.second || 0,
                        u = e.millisecond || 0;
                    this._isValid = ir(e), this._milliseconds = +u + 1e3 * c + 6e4 * l + 1e3 * o * 60 * 60, this._days = +s + 7 * a, this._months = +n + 3 * r + 12 * i, this._data = {}, this._locale = vi(), this._bubble()
                }

                function sr(t) {
                    return t instanceof ar
                }

                function or(t) {
                    return t < 0 ? -1 * Math.round(-1 * t) : Math.round(t)
                }

                function lr(t, e, i) {
                    var r, n = Math.min(t.length, e.length),
                        a = Math.abs(t.length - e.length),
                        s = 0;
                    for (r = 0; r < n; r++)(i && t[r] !== e[r] || !i && ut(t[r]) !== ut(e[r])) && s++;
                    return s + a
                }

                function cr(t, e) {
                    q(t, 0, 0, (function () {
                        var t = this.utcOffset(),
                            i = "+";
                        return t < 0 && (t = -t, i = "-"), i + R(~~(t / 60), 2) + e + R(~~t % 60, 2)
                    }))
                }
                cr("Z", ":"), cr("ZZ", ""), It("Z", Dt), It("ZZ", Dt), zt(["Z", "ZZ"], (function (t, e, i) {
                    i._useUTC = !0, i._tzm = hr(Dt, t)
                }));
                var ur = /([\+\-]|\d\d)/gi;

                function hr(t, e) {
                    var i, r, n = (e || "").match(t);
                    return null === n ? null : 0 === (r = 60 * (i = ((n[n.length - 1] || []) + "").match(ur) || ["-", 0, 0])[1] + ut(i[2])) ? 0 : "+" === i[0] ? r : -r
                }

                function dr(t, e) {
                    var i, n;
                    return e._isUTC ? (i = e.clone(), n = (S(t) || h(t) ? t.valueOf() : $i(t).valueOf()) - i.valueOf(), i._d.setTime(i._d.valueOf() + n), r.updateOffset(i, !1), i) : $i(t).local()
                }

                function pr(t) {
                    return -Math.round(t._d.getTimezoneOffset())
                }

                function fr(t, e, i) {
                    var n, a = this._offset || 0;
                    if (!this.isValid()) return null != t ? this : NaN;
                    if (null != t) {
                        if ("string" == typeof t) {
                            if (null === (t = hr(Dt, t))) return this
                        } else Math.abs(t) < 16 && !i && (t *= 60);
                        return !this._isUTC && e && (n = pr(this)), this._offset = t, this._isUTC = !0, null != n && this.add(n, "m"), a !== t && (!e || this._changeInProgress ? Lr(this, Er(t - a, "m"), 1, !1) : this._changeInProgress || (this._changeInProgress = !0, r.updateOffset(this, !0), this._changeInProgress = null)), this
                    }
                    return this._isUTC ? a : pr(this)
                }

                function mr(t, e) {
                    return null != t ? ("string" != typeof t && (t = -t), this.utcOffset(t, e), this) : -this.utcOffset()
                }

                function gr(t) {
                    return this.utcOffset(0, t)
                }

                function vr(t) {
                    return this._isUTC && (this.utcOffset(0, t), this._isUTC = !1, t && this.subtract(pr(this), "m")), this
                }

                function yr() {
                    if (null != this._tzm) this.utcOffset(this._tzm, !1, !0);
                    else if ("string" == typeof this._i) {
                        var t = hr(Pt, this._i);
                        null != t ? this.utcOffset(t) : this.utcOffset(0, !0)
                    }
                    return this
                }

                function br(t) {
                    return !!this.isValid() && (t = t ? $i(t).utcOffset() : 0, (this.utcOffset() - t) % 60 == 0)
                }

                function _r() {
                    return this.utcOffset() > this.clone().month(0).utcOffset() || this.utcOffset() > this.clone().month(5).utcOffset()
                }

                function wr() {
                    if (!c(this._isDSTShifted)) return this._isDSTShifted;
                    var t, e = {};
                    return w(e, this), (e = Hi(e))._a ? (t = e._isUTC ? f(e._a) : $i(e._a), this._isDSTShifted = this.isValid() && lr(e._a, t.toArray()) > 0) : this._isDSTShifted = !1, this._isDSTShifted
                }

                function Ar() {
                    return !!this.isValid() && !this._isUTC
                }

                function Sr() {
                    return !!this.isValid() && this._isUTC
                }

                function kr() {
                    return !!this.isValid() && this._isUTC && 0 === this._offset
                }
                r.updateOffset = function () { };
                var xr = /^(-|\+)?(?:(\d*)[. ])?(\d+):(\d+)(?::(\d+)(\.\d*)?)?$/,
                    Tr = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;

                function Er(t, e) {
                    var i, r, n, a = t,
                        s = null;
                    return sr(t) ? a = {
                        ms: t._milliseconds,
                        d: t._days,
                        M: t._months
                    } : u(t) || !isNaN(+t) ? (a = {}, e ? a[e] = +t : a.milliseconds = +t) : (s = xr.exec(t)) ? (i = "-" === s[1] ? -1 : 1, a = {
                        y: 0,
                        d: ut(s[Ht]) * i,
                        h: ut(s[Wt]) * i,
                        m: ut(s[Zt]) * i,
                        s: ut(s[$t]) * i,
                        ms: ut(or(1e3 * s[Ut])) * i
                    }) : (s = Tr.exec(t)) ? (i = "-" === s[1] ? -1 : 1, a = {
                        y: Mr(s[2], i),
                        M: Mr(s[3], i),
                        w: Mr(s[4], i),
                        d: Mr(s[5], i),
                        h: Mr(s[6], i),
                        m: Mr(s[7], i),
                        s: Mr(s[8], i)
                    }) : null == a ? a = {} : "object" == typeof a && ("from" in a || "to" in a) && (n = Pr($i(a.from), $i(a.to)), (a = {}).ms = n.milliseconds, a.M = n.months), r = new ar(a), sr(t) && o(t, "_locale") && (r._locale = t._locale), sr(t) && o(t, "_isValid") && (r._isValid = t._isValid), r
                }

                function Mr(t, e) {
                    var i = t && parseFloat(t.replace(",", "."));
                    return (isNaN(i) ? 0 : i) * e
                }

                function Cr(t, e) {
                    var i = {};
                    return i.months = e.month() - t.month() + 12 * (e.year() - t.year()), t.clone().add(i.months, "M").isAfter(e) && --i.months, i.milliseconds = +e - +t.clone().add(i.months, "M"), i
                }

                function Pr(t, e) {
                    var i;
                    return t.isValid() && e.isValid() ? (e = dr(e, t), t.isBefore(e) ? i = Cr(t, e) : ((i = Cr(e, t)).milliseconds = -i.milliseconds, i.months = -i.months), i) : {
                        milliseconds: 0,
                        months: 0
                    }
                }

                function Dr(t, e) {
                    return function (i, r) {
                        var n;
                        return null === r || isNaN(+r) || (M(e, "moment()." + e + "(period, number) is deprecated. Please use moment()." + e + "(number, period). See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info."), n = i, i = r, r = n), Lr(this, Er(i, r), t), this
                    }
                }

                function Lr(t, e, i, n) {
                    var a = e._milliseconds,
                        s = or(e._days),
                        o = or(e._months);
                    t.isValid() && (n = null == n || n, o && ce(t, dt(t, "Month") + o * i), s && pt(t, "Date", dt(t, "Date") + s * i), a && t._d.setTime(t._d.valueOf() + a * i), n && r.updateOffset(t, s || o))
                }
                Er.fn = ar.prototype, Er.invalid = nr;
                var Or = Dr(1, "add"),
                    Ir = Dr(-1, "subtract");

                function Rr(t) {
                    return "string" == typeof t || t instanceof String
                }

                function Fr(t) {
                    return S(t) || h(t) || Rr(t) || u(t) || Br(t) || Nr(t) || null == t
                }

                function Nr(t) {
                    var e, i, r = s(t) && !l(t),
                        n = !1,
                        a = ["years", "year", "y", "months", "month", "M", "days", "day", "d", "dates", "date", "D", "hours", "hour", "h", "minutes", "minute", "m", "seconds", "second", "s", "milliseconds", "millisecond", "ms"],
                        c = a.length;
                    for (e = 0; e < c; e += 1) i = a[e], n = n || o(t, i);
                    return r && n
                }

                function Br(t) {
                    var e = a(t),
                        i = !1;
                    return e && (i = 0 === t.filter((function (e) {
                        return !u(e) && Rr(t)
                    })).length), e && i
                }

                function zr(t) {
                    var e, i, r = s(t) && !l(t),
                        n = !1,
                        a = ["sameDay", "nextDay", "lastDay", "nextWeek", "lastWeek", "sameElse"];
                    for (e = 0; e < a.length; e += 1) i = a[e], n = n || o(t, i);
                    return r && n
                }

                function qr(t, e) {
                    var i = t.diff(e, "days", !0);
                    return i < -6 ? "sameElse" : i < -1 ? "lastWeek" : i < 0 ? "lastDay" : i < 1 ? "sameDay" : i < 2 ? "nextDay" : i < 7 ? "nextWeek" : "sameElse"
                }

                function Vr(t, e) {
                    1 === arguments.length && (arguments[0] ? Fr(arguments[0]) ? (t = arguments[0], e = void 0) : zr(arguments[0]) && (e = arguments[0], t = void 0) : (t = void 0, e = void 0));
                    var i = t || $i(),
                        n = dr(i, this).startOf("day"),
                        a = r.calendarFormat(this, n) || "sameElse",
                        s = e && (C(e[a]) ? e[a].call(this, i) : e[a]);
                    return this.format(s || this.localeData().calendar(a, this, $i(i)))
                }

                function Yr() {
                    return new A(this)
                }

                function jr(t, e) {
                    var i = S(t) ? t : $i(t);
                    return !(!this.isValid() || !i.isValid()) && ("millisecond" === (e = rt(e) || "millisecond") ? this.valueOf() > i.valueOf() : i.valueOf() < this.clone().startOf(e).valueOf())
                }

                function Gr(t, e) {
                    var i = S(t) ? t : $i(t);
                    return !(!this.isValid() || !i.isValid()) && ("millisecond" === (e = rt(e) || "millisecond") ? this.valueOf() < i.valueOf() : this.clone().endOf(e).valueOf() < i.valueOf())
                }

                function Hr(t, e, i, r) {
                    var n = S(t) ? t : $i(t),
                        a = S(e) ? e : $i(e);
                    return !!(this.isValid() && n.isValid() && a.isValid()) && ("(" === (r = r || "()")[0] ? this.isAfter(n, i) : !this.isBefore(n, i)) && (")" === r[1] ? this.isBefore(a, i) : !this.isAfter(a, i))
                }

                function Wr(t, e) {
                    var i, r = S(t) ? t : $i(t);
                    return !(!this.isValid() || !r.isValid()) && ("millisecond" === (e = rt(e) || "millisecond") ? this.valueOf() === r.valueOf() : (i = r.valueOf(), this.clone().startOf(e).valueOf() <= i && i <= this.clone().endOf(e).valueOf()))
                }

                function Zr(t, e) {
                    return this.isSame(t, e) || this.isAfter(t, e)
                }

                function $r(t, e) {
                    return this.isSame(t, e) || this.isBefore(t, e)
                }

                function Ur(t, e, i) {
                    var r, n, a;
                    if (!this.isValid()) return NaN;
                    if (!(r = dr(t, this)).isValid()) return NaN;
                    switch (n = 6e4 * (r.utcOffset() - this.utcOffset()), e = rt(e)) {
                        case "year":
                            a = Xr(this, r) / 12;
                            break;
                        case "month":
                            a = Xr(this, r);
                            break;
                        case "quarter":
                            a = Xr(this, r) / 3;
                            break;
                        case "second":
                            a = (this - r) / 1e3;
                            break;
                        case "minute":
                            a = (this - r) / 6e4;
                            break;
                        case "hour":
                            a = (this - r) / 36e5;
                            break;
                        case "day":
                            a = (this - r - n) / 864e5;
                            break;
                        case "week":
                            a = (this - r - n) / 6048e5;
                            break;
                        default:
                            a = this - r
                    }
                    return i ? a : ct(a)
                }

                function Xr(t, e) {
                    if (t.date() < e.date()) return -Xr(e, t);
                    var i = 12 * (e.year() - t.year()) + (e.month() - t.month()),
                        r = t.clone().add(i, "months");
                    return -(i + (e - r < 0 ? (e - r) / (r - t.clone().add(i - 1, "months")) : (e - r) / (t.clone().add(i + 1, "months") - r))) || 0
                }

                function Kr() {
                    return this.clone().locale("en").format("ddd MMM DD YYYY HH:mm:ss [GMT]ZZ")
                }

                function Jr(t) {
                    if (!this.isValid()) return null;
                    var e = !0 !== t,
                        i = e ? this.clone().utc() : this;
                    return i.year() < 0 || i.year() > 9999 ? j(i, e ? "YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]" : "YYYYYY-MM-DD[T]HH:mm:ss.SSSZ") : C(Date.prototype.toISOString) ? e ? this.toDate().toISOString() : new Date(this.valueOf() + 60 * this.utcOffset() * 1e3).toISOString().replace("Z", j(i, "Z")) : j(i, e ? "YYYY-MM-DD[T]HH:mm:ss.SSS[Z]" : "YYYY-MM-DD[T]HH:mm:ss.SSSZ")
                }

                function Qr() {
                    if (!this.isValid()) return "moment.invalid(/* " + this._i + " */)";
                    var t, e, i, r, n = "moment",
                        a = "";
                    return this.isLocal() || (n = 0 === this.utcOffset() ? "moment.utc" : "moment.parseZone", a = "Z"), t = "[" + n + '("]', e = 0 <= this.year() && this.year() <= 9999 ? "YYYY" : "YYYYYY", i = "-MM-DD[T]HH:mm:ss.SSS", r = a + '[")]', this.format(t + e + i + r)
                }

                function tn(t) {
                    t || (t = this.isUtc() ? r.defaultFormatUtc : r.defaultFormat);
                    var e = j(this, t);
                    return this.localeData().postformat(e)
                }

                function en(t, e) {
                    return this.isValid() && (S(t) && t.isValid() || $i(t).isValid()) ? Er({
                        to: this,
                        from: t
                    }).locale(this.locale()).humanize(!e) : this.localeData().invalidDate()
                }

                function rn(t) {
                    return this.from($i(), t)
                }

                function nn(t, e) {
                    return this.isValid() && (S(t) && t.isValid() || $i(t).isValid()) ? Er({
                        from: this,
                        to: t
                    }).locale(this.locale()).humanize(!e) : this.localeData().invalidDate()
                }

                function an(t) {
                    return this.to($i(), t)
                }

                function sn(t) {
                    var e;
                    return void 0 === t ? this._locale._abbr : (null != (e = vi(t)) && (this._locale = e), this)
                }
                r.defaultFormat = "YYYY-MM-DDTHH:mm:ssZ", r.defaultFormatUtc = "YYYY-MM-DDTHH:mm:ss[Z]";
                var on = x("moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.", (function (t) {
                    return void 0 === t ? this.localeData() : this.locale(t)
                }));

                function ln() {
                    return this._locale
                }
                var cn = 1e3,
                    un = 60 * cn,
                    hn = 60 * un,
                    dn = 3506328 * hn;

                function pn(t, e) {
                    return (t % e + e) % e
                }

                function fn(t, e, i) {
                    return t < 100 && t >= 0 ? new Date(t + 400, e, i) - dn : new Date(t, e, i).valueOf()
                }

                function mn(t, e, i) {
                    return t < 100 && t >= 0 ? Date.UTC(t + 400, e, i) - dn : Date.UTC(t, e, i)
                }

                function gn(t) {
                    var e, i;
                    if (void 0 === (t = rt(t)) || "millisecond" === t || !this.isValid()) return this;
                    switch (i = this._isUTC ? mn : fn, t) {
                        case "year":
                            e = i(this.year(), 0, 1);
                            break;
                        case "quarter":
                            e = i(this.year(), this.month() - this.month() % 3, 1);
                            break;
                        case "month":
                            e = i(this.year(), this.month(), 1);
                            break;
                        case "week":
                            e = i(this.year(), this.month(), this.date() - this.weekday());
                            break;
                        case "isoWeek":
                            e = i(this.year(), this.month(), this.date() - (this.isoWeekday() - 1));
                            break;
                        case "day":
                        case "date":
                            e = i(this.year(), this.month(), this.date());
                            break;
                        case "hour":
                            e = this._d.valueOf(), e -= pn(e + (this._isUTC ? 0 : this.utcOffset() * un), hn);
                            break;
                        case "minute":
                            e = this._d.valueOf(), e -= pn(e, un);
                            break;
                        case "second":
                            e = this._d.valueOf(), e -= pn(e, cn)
                    }
                    return this._d.setTime(e), r.updateOffset(this, !0), this
                }

                function vn(t) {
                    var e, i;
                    if (void 0 === (t = rt(t)) || "millisecond" === t || !this.isValid()) return this;
                    switch (i = this._isUTC ? mn : fn, t) {
                        case "year":
                            e = i(this.year() + 1, 0, 1) - 1;
                            break;
                        case "quarter":
                            e = i(this.year(), this.month() - this.month() % 3 + 3, 1) - 1;
                            break;
                        case "month":
                            e = i(this.year(), this.month() + 1, 1) - 1;
                            break;
                        case "week":
                            e = i(this.year(), this.month(), this.date() - this.weekday() + 7) - 1;
                            break;
                        case "isoWeek":
                            e = i(this.year(), this.month(), this.date() - (this.isoWeekday() - 1) + 7) - 1;
                            break;
                        case "day":
                        case "date":
                            e = i(this.year(), this.month(), this.date() + 1) - 1;
                            break;
                        case "hour":
                            e = this._d.valueOf(), e += hn - pn(e + (this._isUTC ? 0 : this.utcOffset() * un), hn) - 1;
                            break;
                        case "minute":
                            e = this._d.valueOf(), e += un - pn(e, un) - 1;
                            break;
                        case "second":
                            e = this._d.valueOf(), e += cn - pn(e, cn) - 1
                    }
                    return this._d.setTime(e), r.updateOffset(this, !0), this
                }

                function yn() {
                    return this._d.valueOf() - 6e4 * (this._offset || 0)
                }

                function bn() {
                    return Math.floor(this.valueOf() / 1e3)
                }

                function _n() {
                    return new Date(this.valueOf())
                }

                function wn() {
                    var t = this;
                    return [t.year(), t.month(), t.date(), t.hour(), t.minute(), t.second(), t.millisecond()]
                }

                function An() {
                    var t = this;
                    return {
                        years: t.year(),
                        months: t.month(),
                        date: t.date(),
                        hours: t.hours(),
                        minutes: t.minutes(),
                        seconds: t.seconds(),
                        milliseconds: t.milliseconds()
                    }
                }

                function Sn() {
                    return this.isValid() ? this.toISOString() : null
                }

                function kn() {
                    return v(this)
                }

                function xn() {
                    return p({}, g(this))
                }

                function Tn() {
                    return g(this).overflow
                }

                function En() {
                    return {
                        input: this._i,
                        format: this._f,
                        locale: this._locale,
                        isUTC: this._isUTC,
                        strict: this._strict
                    }
                }

                function Mn(t, e) {
                    var i, n, a, s = this._eras || vi("en")._eras;
                    for (i = 0, n = s.length; i < n; ++i) switch ("string" == typeof s[i].since && (a = r(s[i].since).startOf("day"), s[i].since = a.valueOf()), typeof s[i].until) {
                        case "undefined":
                            s[i].until = 1 / 0;
                            break;
                        case "string":
                            a = r(s[i].until).startOf("day").valueOf(), s[i].until = a.valueOf()
                    }
                    return s
                }

                function Cn(t, e, i) {
                    var r, n, a, s, o, l = this.eras();
                    for (t = t.toUpperCase(), r = 0, n = l.length; r < n; ++r)
                        if (a = l[r].name.toUpperCase(), s = l[r].abbr.toUpperCase(), o = l[r].narrow.toUpperCase(), i) switch (e) {
                            case "N":
                            case "NN":
                            case "NNN":
                                if (s === t) return l[r];
                                break;
                            case "NNNN":
                                if (a === t) return l[r];
                                break;
                            case "NNNNN":
                                if (o === t) return l[r]
                        } else if ([a, s, o].indexOf(t) >= 0) return l[r]
                }

                function Pn(t, e) {
                    var i = t.since <= t.until ? 1 : -1;
                    return void 0 === e ? r(t.since).year() : r(t.since).year() + (e - t.offset) * i
                }

                function Dn() {
                    var t, e, i, r = this.localeData().eras();
                    for (t = 0, e = r.length; t < e; ++t) {
                        if (i = this.clone().startOf("day").valueOf(), r[t].since <= i && i <= r[t].until) return r[t].name;
                        if (r[t].until <= i && i <= r[t].since) return r[t].name
                    }
                    return ""
                }

                function Ln() {
                    var t, e, i, r = this.localeData().eras();
                    for (t = 0, e = r.length; t < e; ++t) {
                        if (i = this.clone().startOf("day").valueOf(), r[t].since <= i && i <= r[t].until) return r[t].narrow;
                        if (r[t].until <= i && i <= r[t].since) return r[t].narrow
                    }
                    return ""
                }

                function On() {
                    var t, e, i, r = this.localeData().eras();
                    for (t = 0, e = r.length; t < e; ++t) {
                        if (i = this.clone().startOf("day").valueOf(), r[t].since <= i && i <= r[t].until) return r[t].abbr;
                        if (r[t].until <= i && i <= r[t].since) return r[t].abbr
                    }
                    return ""
                }

                function In() {
                    var t, e, i, n, a = this.localeData().eras();
                    for (t = 0, e = a.length; t < e; ++t)
                        if (i = a[t].since <= a[t].until ? 1 : -1, n = this.clone().startOf("day").valueOf(), a[t].since <= n && n <= a[t].until || a[t].until <= n && n <= a[t].since) return (this.year() - r(a[t].since).year()) * i + a[t].offset;
                    return this.year()
                }

                function Rn(t) {
                    return o(this, "_erasNameRegex") || Yn.call(this), t ? this._erasNameRegex : this._erasRegex
                }

                function Fn(t) {
                    return o(this, "_erasAbbrRegex") || Yn.call(this), t ? this._erasAbbrRegex : this._erasRegex
                }

                function Nn(t) {
                    return o(this, "_erasNarrowRegex") || Yn.call(this), t ? this._erasNarrowRegex : this._erasRegex
                }

                function Bn(t, e) {
                    return e.erasAbbrRegex(t)
                }

                function zn(t, e) {
                    return e.erasNameRegex(t)
                }

                function qn(t, e) {
                    return e.erasNarrowRegex(t)
                }

                function Vn(t, e) {
                    return e._eraYearOrdinalRegex || Mt
                }

                function Yn() {
                    var t, e, i = [],
                        r = [],
                        n = [],
                        a = [],
                        s = this.eras();
                    for (t = 0, e = s.length; t < e; ++t) r.push(Nt(s[t].name)), i.push(Nt(s[t].abbr)), n.push(Nt(s[t].narrow)), a.push(Nt(s[t].name)), a.push(Nt(s[t].abbr)), a.push(Nt(s[t].narrow));
                    this._erasRegex = new RegExp("^(" + a.join("|") + ")", "i"), this._erasNameRegex = new RegExp("^(" + r.join("|") + ")", "i"), this._erasAbbrRegex = new RegExp("^(" + i.join("|") + ")", "i"), this._erasNarrowRegex = new RegExp("^(" + n.join("|") + ")", "i")
                }

                function jn(t, e) {
                    q(0, [t, t.length], 0, e)
                }

                function Gn(t) {
                    return Xn.call(this, t, this.week(), this.weekday(), this.localeData()._week.dow, this.localeData()._week.doy)
                }

                function Hn(t) {
                    return Xn.call(this, t, this.isoWeek(), this.isoWeekday(), 1, 4)
                }

                function Wn() {
                    return Se(this.year(), 1, 4)
                }

                function Zn() {
                    return Se(this.isoWeekYear(), 1, 4)
                }

                function $n() {
                    var t = this.localeData()._week;
                    return Se(this.year(), t.dow, t.doy)
                }

                function Un() {
                    var t = this.localeData()._week;
                    return Se(this.weekYear(), t.dow, t.doy)
                }

                function Xn(t, e, i, r, n) {
                    var a;
                    return null == t ? Ae(this, r, n).year : (e > (a = Se(t, r, n)) && (e = a), Kn.call(this, t, e, i, r, n))
                }

                function Kn(t, e, i, r, n) {
                    var a = we(t, e, i, r, n),
                        s = be(a.year, 0, a.dayOfYear);
                    return this.year(s.getUTCFullYear()), this.month(s.getUTCMonth()), this.date(s.getUTCDate()), this
                }

                function Jn(t) {
                    return null == t ? Math.ceil((this.month() + 1) / 3) : this.month(3 * (t - 1) + this.month() % 3)
                }
                q("N", 0, 0, "eraAbbr"), q("NN", 0, 0, "eraAbbr"), q("NNN", 0, 0, "eraAbbr"), q("NNNN", 0, 0, "eraName"), q("NNNNN", 0, 0, "eraNarrow"), q("y", ["y", 1], "yo", "eraYear"), q("y", ["yy", 2], 0, "eraYear"), q("y", ["yyy", 3], 0, "eraYear"), q("y", ["yyyy", 4], 0, "eraYear"), It("N", Bn), It("NN", Bn), It("NNN", Bn), It("NNNN", zn), It("NNNNN", qn), zt(["N", "NN", "NNN", "NNNN", "NNNNN"], (function (t, e, i, r) {
                    var n = i._locale.erasParse(t, r, i._strict);
                    n ? g(i).era = n : g(i).invalidEra = t
                })), It("y", Mt), It("yy", Mt), It("yyy", Mt), It("yyyy", Mt), It("yo", Vn), zt(["y", "yy", "yyy", "yyyy"], jt), zt(["yo"], (function (t, e, i, r) {
                    var n;
                    i._locale._eraYearOrdinalRegex && (n = t.match(i._locale._eraYearOrdinalRegex)), i._locale.eraYearOrdinalParse ? e[jt] = i._locale.eraYearOrdinalParse(t, n) : e[jt] = parseInt(t, 10)
                })), q(0, ["gg", 2], 0, (function () {
                    return this.weekYear() % 100
                })), q(0, ["GG", 2], 0, (function () {
                    return this.isoWeekYear() % 100
                })), jn("gggg", "weekYear"), jn("ggggg", "weekYear"), jn("GGGG", "isoWeekYear"), jn("GGGGG", "isoWeekYear"), it("weekYear", "gg"), it("isoWeekYear", "GG"), st("weekYear", 1), st("isoWeekYear", 1), It("G", Ct), It("g", Ct), It("GG", At, yt), It("gg", At, yt), It("GGGG", Tt, _t), It("gggg", Tt, _t), It("GGGGG", Et, wt), It("ggggg", Et, wt), qt(["gggg", "ggggg", "GGGG", "GGGGG"], (function (t, e, i, r) {
                    e[r.substr(0, 2)] = ut(t)
                })), qt(["gg", "GG"], (function (t, e, i, n) {
                    e[n] = r.parseTwoDigitYear(t)
                })), q("Q", 0, "Qo", "quarter"), it("quarter", "Q"), st("quarter", 7), It("Q", vt), zt("Q", (function (t, e) {
                    e[Gt] = 3 * (ut(t) - 1)
                })), q("D", ["DD", 2], "Do", "date"), it("date", "D"), st("date", 9), It("D", At), It("DD", At, yt), It("Do", (function (t, e) {
                    return t ? e._dayOfMonthOrdinalParse || e._ordinalParse : e._dayOfMonthOrdinalParseLenient
                })), zt(["D", "DD"], Ht), zt("Do", (function (t, e) {
                    e[Ht] = ut(t.match(At)[0])
                }));
                var Qn = ht("Date", !0);

                function ta(t) {
                    var e = Math.round((this.clone().startOf("day") - this.clone().startOf("year")) / 864e5) + 1;
                    return null == t ? e : this.add(t - e, "d")
                }
                q("DDD", ["DDDD", 3], "DDDo", "dayOfYear"), it("dayOfYear", "DDD"), st("dayOfYear", 4), It("DDD", xt), It("DDDD", bt), zt(["DDD", "DDDD"], (function (t, e, i) {
                    i._dayOfYear = ut(t)
                })), q("m", ["mm", 2], 0, "minute"), it("minute", "m"), st("minute", 14), It("m", At), It("mm", At, yt), zt(["m", "mm"], Zt);
                var ea = ht("Minutes", !1);
                q("s", ["ss", 2], 0, "second"), it("second", "s"), st("second", 15), It("s", At), It("ss", At, yt), zt(["s", "ss"], $t);
                var ia, ra, na = ht("Seconds", !1);
                for (q("S", 0, 0, (function () {
                    return ~~(this.millisecond() / 100)
                })), q(0, ["SS", 2], 0, (function () {
                    return ~~(this.millisecond() / 10)
                })), q(0, ["SSS", 3], 0, "millisecond"), q(0, ["SSSS", 4], 0, (function () {
                    return 10 * this.millisecond()
                })), q(0, ["SSSSS", 5], 0, (function () {
                    return 100 * this.millisecond()
                })), q(0, ["SSSSSS", 6], 0, (function () {
                    return 1e3 * this.millisecond()
                })), q(0, ["SSSSSSS", 7], 0, (function () {
                    return 1e4 * this.millisecond()
                })), q(0, ["SSSSSSSS", 8], 0, (function () {
                    return 1e5 * this.millisecond()
                })), q(0, ["SSSSSSSSS", 9], 0, (function () {
                    return 1e6 * this.millisecond()
                })), it("millisecond", "ms"), st("millisecond", 16), It("S", xt, vt), It("SS", xt, yt), It("SSS", xt, bt), ia = "SSSS"; ia.length <= 9; ia += "S") It(ia, Mt);

                function aa(t, e) {
                    e[Ut] = ut(1e3 * ("0." + t))
                }
                for (ia = "S"; ia.length <= 9; ia += "S") zt(ia, aa);

                function sa() {
                    return this._isUTC ? "UTC" : ""
                }

                function oa() {
                    return this._isUTC ? "Coordinated Universal Time" : ""
                }
                ra = ht("Milliseconds", !1), q("z", 0, 0, "zoneAbbr"), q("zz", 0, 0, "zoneName");
                var la = A.prototype;

                function ca(t) {
                    return $i(1e3 * t)
                }

                function ua() {
                    return $i.apply(null, arguments).parseZone()
                }

                function ha(t) {
                    return t
                }
                la.add = Or, la.calendar = Vr, la.clone = Yr, la.diff = Ur, la.endOf = vn, la.format = tn, la.from = en, la.fromNow = rn, la.to = nn, la.toNow = an, la.get = ft, la.invalidAt = Tn, la.isAfter = jr, la.isBefore = Gr, la.isBetween = Hr, la.isSame = Wr, la.isSameOrAfter = Zr, la.isSameOrBefore = $r, la.isValid = kn, la.lang = on, la.locale = sn, la.localeData = ln, la.max = Xi, la.min = Ui, la.parsingFlags = xn, la.set = mt, la.startOf = gn, la.subtract = Ir, la.toArray = wn, la.toObject = An, la.toDate = _n, la.toISOString = Jr, la.inspect = Qr, "undefined" != typeof Symbol && null != Symbol.for && (la[Symbol.for("nodejs.util.inspect.custom")] = function () {
                    return "Moment<" + this.format() + ">"
                }), la.toJSON = Sn, la.toString = Kr, la.unix = bn, la.valueOf = yn, la.creationData = En, la.eraName = Dn, la.eraNarrow = Ln, la.eraAbbr = On, la.eraYear = In, la.year = ge, la.isLeapYear = ve, la.weekYear = Gn, la.isoWeekYear = Hn, la.quarter = la.quarters = Jn, la.month = ue, la.daysInMonth = he, la.week = la.weeks = Me, la.isoWeek = la.isoWeeks = Ce, la.weeksInYear = $n, la.weeksInWeekYear = Un, la.isoWeeksInYear = Wn, la.isoWeeksInISOWeekYear = Zn, la.date = Qn, la.day = la.days = Ge, la.weekday = He, la.isoWeekday = We, la.dayOfYear = ta, la.hour = la.hours = ri, la.minute = la.minutes = ea, la.second = la.seconds = na, la.millisecond = la.milliseconds = ra, la.utcOffset = fr, la.utc = gr, la.local = vr, la.parseZone = yr, la.hasAlignedHourOffset = br, la.isDST = _r, la.isLocal = Ar, la.isUtcOffset = Sr, la.isUtc = kr, la.isUTC = kr, la.zoneAbbr = sa, la.zoneName = oa, la.dates = x("dates accessor is deprecated. Use date instead.", Qn), la.months = x("months accessor is deprecated. Use month instead", ue), la.years = x("years accessor is deprecated. Use year instead", ge), la.zone = x("moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/", mr), la.isDSTShifted = x("isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information", wr);
                var da = L.prototype;

                function pa(t, e, i, r) {
                    var n = vi(),
                        a = f().set(r, e);
                    return n[i](a, t)
                }

                function fa(t, e, i) {
                    if (u(t) && (e = t, t = void 0), t = t || "", null != e) return pa(t, e, i, "month");
                    var r, n = [];
                    for (r = 0; r < 12; r++) n[r] = pa(t, r, i, "month");
                    return n
                }

                function ma(t, e, i, r) {
                    "boolean" == typeof t ? (u(e) && (i = e, e = void 0), e = e || "") : (i = e = t, t = !1, u(e) && (i = e, e = void 0), e = e || "");
                    var n, a = vi(),
                        s = t ? a._week.dow : 0,
                        o = [];
                    if (null != i) return pa(e, (i + s) % 7, r, "day");
                    for (n = 0; n < 7; n++) o[n] = pa(e, (n + s) % 7, r, "day");
                    return o
                }

                function ga(t, e) {
                    return fa(t, e, "months")
                }

                function va(t, e) {
                    return fa(t, e, "monthsShort")
                }

                function ya(t, e, i) {
                    return ma(t, e, i, "weekdays")
                }

                function ba(t, e, i) {
                    return ma(t, e, i, "weekdaysShort")
                }

                function _a(t, e, i) {
                    return ma(t, e, i, "weekdaysMin")
                }
                da.calendar = I, da.longDateFormat = W, da.invalidDate = $, da.ordinal = K, da.preparse = ha, da.postformat = ha, da.relativeTime = Q, da.pastFuture = tt, da.set = P, da.eras = Mn, da.erasParse = Cn, da.erasConvertYear = Pn, da.erasAbbrRegex = Fn, da.erasNameRegex = Rn, da.erasNarrowRegex = Nn, da.months = ae, da.monthsShort = se, da.monthsParse = le, da.monthsRegex = pe, da.monthsShortRegex = de, da.week = ke, da.firstDayOfYear = Ee, da.firstDayOfWeek = Te, da.weekdays = ze, da.weekdaysMin = Ve, da.weekdaysShort = qe, da.weekdaysParse = je, da.weekdaysRegex = Ze, da.weekdaysShortRegex = $e, da.weekdaysMinRegex = Ue, da.isPM = ei, da.meridiem = ni, fi("en", {
                    eras: [{
                        since: "0001-01-01",
                        until: 1 / 0,
                        offset: 1,
                        name: "Anno Domini",
                        narrow: "AD",
                        abbr: "AD"
                    }, {
                        since: "0000-12-31",
                        until: -1 / 0,
                        offset: 1,
                        name: "Before Christ",
                        narrow: "BC",
                        abbr: "BC"
                    }],
                    dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
                    ordinal: function (t) {
                        var e = t % 10;
                        return t + (1 === ut(t % 100 / 10) ? "th" : 1 === e ? "st" : 2 === e ? "nd" : 3 === e ? "rd" : "th")
                    }
                }), r.lang = x("moment.lang is deprecated. Use moment.locale instead.", fi), r.langData = x("moment.langData is deprecated. Use moment.localeData instead.", vi);
                var wa = Math.abs;

                function Aa() {
                    var t = this._data;
                    return this._milliseconds = wa(this._milliseconds), this._days = wa(this._days), this._months = wa(this._months), t.milliseconds = wa(t.milliseconds), t.seconds = wa(t.seconds), t.minutes = wa(t.minutes), t.hours = wa(t.hours), t.months = wa(t.months), t.years = wa(t.years), this
                }

                function Sa(t, e, i, r) {
                    var n = Er(e, i);
                    return t._milliseconds += r * n._milliseconds, t._days += r * n._days, t._months += r * n._months, t._bubble()
                }

                function ka(t, e) {
                    return Sa(this, t, e, 1)
                }

                function xa(t, e) {
                    return Sa(this, t, e, -1)
                }

                function Ta(t) {
                    return t < 0 ? Math.floor(t) : Math.ceil(t)
                }

                function Ea() {
                    var t, e, i, r, n, a = this._milliseconds,
                        s = this._days,
                        o = this._months,
                        l = this._data;
                    return a >= 0 && s >= 0 && o >= 0 || a <= 0 && s <= 0 && o <= 0 || (a += 864e5 * Ta(Ca(o) + s), s = 0, o = 0), l.milliseconds = a % 1e3, t = ct(a / 1e3), l.seconds = t % 60, e = ct(t / 60), l.minutes = e % 60, i = ct(e / 60), l.hours = i % 24, s += ct(i / 24), o += n = ct(Ma(s)), s -= Ta(Ca(n)), r = ct(o / 12), o %= 12, l.days = s, l.months = o, l.years = r, this
                }

                function Ma(t) {
                    return 4800 * t / 146097
                }

                function Ca(t) {
                    return 146097 * t / 4800
                }

                function Pa(t) {
                    if (!this.isValid()) return NaN;
                    var e, i, r = this._milliseconds;
                    if ("month" === (t = rt(t)) || "quarter" === t || "year" === t) switch (e = this._days + r / 864e5, i = this._months + Ma(e), t) {
                        case "month":
                            return i;
                        case "quarter":
                            return i / 3;
                        case "year":
                            return i / 12
                    } else switch (e = this._days + Math.round(Ca(this._months)), t) {
                        case "week":
                            return e / 7 + r / 6048e5;
                        case "day":
                            return e + r / 864e5;
                        case "hour":
                            return 24 * e + r / 36e5;
                        case "minute":
                            return 1440 * e + r / 6e4;
                        case "second":
                            return 86400 * e + r / 1e3;
                        case "millisecond":
                            return Math.floor(864e5 * e) + r;
                        default:
                            throw new Error("Unknown unit " + t)
                    }
                }

                function Da() {
                    return this.isValid() ? this._milliseconds + 864e5 * this._days + this._months % 12 * 2592e6 + 31536e6 * ut(this._months / 12) : NaN
                }

                function La(t) {
                    return function () {
                        return this.as(t)
                    }
                }
                var Oa = La("ms"),
                    Ia = La("s"),
                    Ra = La("m"),
                    Fa = La("h"),
                    Na = La("d"),
                    Ba = La("w"),
                    za = La("M"),
                    qa = La("Q"),
                    Va = La("y");

                function Ya() {
                    return Er(this)
                }

                function ja(t) {
                    return t = rt(t), this.isValid() ? this[t + "s"]() : NaN
                }

                function Ga(t) {
                    return function () {
                        return this.isValid() ? this._data[t] : NaN
                    }
                }
                var Ha = Ga("milliseconds"),
                    Wa = Ga("seconds"),
                    Za = Ga("minutes"),
                    $a = Ga("hours"),
                    Ua = Ga("days"),
                    Xa = Ga("months"),
                    Ka = Ga("years");

                function Ja() {
                    return ct(this.days() / 7)
                }
                var Qa = Math.round,
                    ts = {
                        ss: 44,
                        s: 45,
                        m: 45,
                        h: 22,
                        d: 26,
                        w: null,
                        M: 11
                    };

                function es(t, e, i, r, n) {
                    return n.relativeTime(e || 1, !!i, t, r)
                }

                function is(t, e, i, r) {
                    var n = Er(t).abs(),
                        a = Qa(n.as("s")),
                        s = Qa(n.as("m")),
                        o = Qa(n.as("h")),
                        l = Qa(n.as("d")),
                        c = Qa(n.as("M")),
                        u = Qa(n.as("w")),
                        h = Qa(n.as("y")),
                        d = a <= i.ss && ["s", a] || a < i.s && ["ss", a] || s <= 1 && ["m"] || s < i.m && ["mm", s] || o <= 1 && ["h"] || o < i.h && ["hh", o] || l <= 1 && ["d"] || l < i.d && ["dd", l];
                    return null != i.w && (d = d || u <= 1 && ["w"] || u < i.w && ["ww", u]), (d = d || c <= 1 && ["M"] || c < i.M && ["MM", c] || h <= 1 && ["y"] || ["yy", h])[2] = e, d[3] = +t > 0, d[4] = r, es.apply(null, d)
                }

                function rs(t) {
                    return void 0 === t ? Qa : "function" == typeof t && (Qa = t, !0)
                }

                function ns(t, e) {
                    return void 0 !== ts[t] && (void 0 === e ? ts[t] : (ts[t] = e, "s" === t && (ts.ss = e - 1), !0))
                }

                function as(t, e) {
                    if (!this.isValid()) return this.localeData().invalidDate();
                    var i, r, n = !1,
                        a = ts;
                    return "object" == typeof t && (e = t, t = !1), "boolean" == typeof t && (n = t), "object" == typeof e && (a = Object.assign({}, ts, e), null != e.s && null == e.ss && (a.ss = e.s - 1)), r = is(this, !n, a, i = this.localeData()), n && (r = i.pastFuture(+this, r)), i.postformat(r)
                }
                var ss = Math.abs;

                function os(t) {
                    return (t > 0) - (t < 0) || +t
                }

                function ls() {
                    if (!this.isValid()) return this.localeData().invalidDate();
                    var t, e, i, r, n, a, s, o, l = ss(this._milliseconds) / 1e3,
                        c = ss(this._days),
                        u = ss(this._months),
                        h = this.asSeconds();
                    return h ? (t = ct(l / 60), e = ct(t / 60), l %= 60, t %= 60, i = ct(u / 12), u %= 12, r = l ? l.toFixed(3).replace(/\.?0+$/, "") : "", n = h < 0 ? "-" : "", a = os(this._months) !== os(h) ? "-" : "", s = os(this._days) !== os(h) ? "-" : "", o = os(this._milliseconds) !== os(h) ? "-" : "", n + "P" + (i ? a + i + "Y" : "") + (u ? a + u + "M" : "") + (c ? s + c + "D" : "") + (e || t || l ? "T" : "") + (e ? o + e + "H" : "") + (t ? o + t + "M" : "") + (l ? o + r + "S" : "")) : "P0D"
                }
                var cs = ar.prototype;
                return cs.isValid = rr, cs.abs = Aa, cs.add = ka, cs.subtract = xa, cs.as = Pa, cs.asMilliseconds = Oa, cs.asSeconds = Ia, cs.asMinutes = Ra, cs.asHours = Fa, cs.asDays = Na, cs.asWeeks = Ba, cs.asMonths = za, cs.asQuarters = qa, cs.asYears = Va, cs.valueOf = Da, cs._bubble = Ea, cs.clone = Ya, cs.get = ja, cs.milliseconds = Ha, cs.seconds = Wa, cs.minutes = Za, cs.hours = $a, cs.days = Ua, cs.weeks = Ja, cs.months = Xa, cs.years = Ka, cs.humanize = as, cs.toISOString = ls, cs.toString = ls, cs.toJSON = ls, cs.locale = sn, cs.localeData = ln, cs.toIsoString = x("toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)", ls), cs.lang = on, q("X", 0, 0, "unix"), q("x", 0, 0, "valueOf"), It("x", Ct), It("X", Lt), zt("X", (function (t, e, i) {
                    i._d = new Date(1e3 * parseFloat(t))
                })), zt("x", (function (t, e, i) {
                    i._d = new Date(ut(t))
                })), r.version = "2.29.4", n($i), r.fn = la, r.min = Ji, r.max = Qi, r.now = tr, r.utc = f, r.unix = ca, r.months = ga, r.isDate = h, r.locale = fi, r.invalid = y, r.duration = Er, r.isMoment = S, r.weekdays = ya, r.parseZone = ua, r.localeData = vi, r.isDuration = sr, r.monthsShort = va, r.weekdaysMin = _a, r.defineLocale = mi, r.updateLocale = gi, r.locales = yi, r.weekdaysShort = ba, r.normalizeUnits = rt, r.relativeTimeRounding = rs, r.relativeTimeThreshold = ns, r.calendarFormat = qr, r.prototype = la, r.HTML5_FMT = {
                    DATETIME_LOCAL: "YYYY-MM-DDTHH:mm",
                    DATETIME_LOCAL_SECONDS: "YYYY-MM-DDTHH:mm:ss",
                    DATETIME_LOCAL_MS: "YYYY-MM-DDTHH:mm:ss.SSS",
                    DATE: "YYYY-MM-DD",
                    TIME: "HH:mm",
                    TIME_SECONDS: "HH:mm:ss",
                    TIME_MS: "HH:mm:ss.SSS",
                    WEEK: "GGGG-[W]WW",
                    MONTH: "YYYY-MM"
                }, r
            }()
        },
        732: function (t) {
            t.exports = function () {
                "use strict";

                function t() {
                    return t = Object.assign || function (t) {
                        for (var e = 1; e < arguments.length; e++) {
                            var i = arguments[e];
                            for (var r in i) Object.prototype.hasOwnProperty.call(i, r) && (t[r] = i[r])
                        }
                        return t
                    }, t.apply(this, arguments)
                }
                var e = "undefined" != typeof window,
                    i = e && !("onscroll" in window) || "undefined" != typeof navigator && /(gle|ing|ro)bot|crawl|spider/i.test(navigator.userAgent),
                    r = e && "IntersectionObserver" in window,
                    n = e && "classList" in document.createElement("p"),
                    a = e && window.devicePixelRatio > 1,
                    s = {
                        elements_selector: ".lazy",
                        container: i || e ? document : null,
                        threshold: 300,
                        thresholds: null,
                        data_src: "src",
                        data_srcset: "srcset",
                        data_sizes: "sizes",
                        data_bg: "bg",
                        data_bg_hidpi: "bg-hidpi",
                        data_bg_multi: "bg-multi",
                        data_bg_multi_hidpi: "bg-multi-hidpi",
                        data_bg_set: "bg-set",
                        data_poster: "poster",
                        class_applied: "applied",
                        class_loading: "loading",
                        class_loaded: "loaded",
                        class_error: "error",
                        class_entered: "entered",
                        class_exited: "exited",
                        unobserve_completed: !0,
                        unobserve_entered: !1,
                        cancel_on_exit: !0,
                        callback_enter: null,
                        callback_exit: null,
                        callback_applied: null,
                        callback_loading: null,
                        callback_loaded: null,
                        callback_error: null,
                        callback_finish: null,
                        callback_cancel: null,
                        use_native: !1,
                        restore_on_error: !1
                    },
                    o = function (e) {
                        return t({}, s, e)
                    },
                    l = function (t, e) {
                        var i, r = "LazyLoad::Initialized",
                            n = new t(e);
                        try {
                            i = new CustomEvent(r, {
                                detail: {
                                    instance: n
                                }
                            })
                        } catch (t) {
                            (i = document.createEvent("CustomEvent")).initCustomEvent(r, !1, !1, {
                                instance: n
                            })
                        }
                        window.dispatchEvent(i)
                    },
                    c = "src",
                    u = "srcset",
                    h = "sizes",
                    d = "poster",
                    p = "llOriginalAttrs",
                    f = "data",
                    m = "loading",
                    g = "loaded",
                    v = "applied",
                    y = "error",
                    b = "native",
                    _ = "data-",
                    w = "ll-status",
                    A = function (t, e) {
                        return t.getAttribute(_ + e)
                    },
                    S = function (t) {
                        return A(t, w)
                    },
                    k = function (t, e) {
                        return function (t, e, i) {
                            var r = "data-ll-status";
                            null !== i ? t.setAttribute(r, i) : t.removeAttribute(r)
                        }(t, 0, e)
                    },
                    x = function (t) {
                        return k(t, null)
                    },
                    T = function (t) {
                        return null === S(t)
                    },
                    E = function (t) {
                        return S(t) === b
                    },
                    M = [m, g, v, y],
                    C = function (t, e, i, r) {
                        t && (void 0 === r ? void 0 === i ? t(e) : t(e, i) : t(e, i, r))
                    },
                    P = function (t, e) {
                        n ? t.classList.add(e) : t.className += (t.className ? " " : "") + e
                    },
                    D = function (t, e) {
                        n ? t.classList.remove(e) : t.className = t.className.replace(new RegExp("(^|\\s+)" + e + "(\\s+|$)"), " ").replace(/^\s+/, "").replace(/\s+$/, "")
                    },
                    L = function (t) {
                        return t.llTempImage
                    },
                    O = function (t, e) {
                        if (e) {
                            var i = e._observer;
                            i && i.unobserve(t)
                        }
                    },
                    I = function (t, e) {
                        t && (t.loadingCount += e)
                    },
                    R = function (t, e) {
                        t && (t.toLoadCount = e)
                    },
                    F = function (t) {
                        for (var e, i = [], r = 0; e = t.children[r]; r += 1) "SOURCE" === e.tagName && i.push(e);
                        return i
                    },
                    N = function (t, e) {
                        var i = t.parentNode;
                        i && "PICTURE" === i.tagName && F(i).forEach(e)
                    },
                    B = function (t, e) {
                        F(t).forEach(e)
                    },
                    z = [c],
                    q = [c, d],
                    V = [c, u, h],
                    Y = [f],
                    j = function (t) {
                        return !!t[p]
                    },
                    G = function (t) {
                        return t[p]
                    },
                    H = function (t) {
                        return delete t[p]
                    },
                    W = function (t, e) {
                        if (!j(t)) {
                            var i = {};
                            e.forEach((function (e) {
                                i[e] = t.getAttribute(e)
                            })), t[p] = i
                        }
                    },
                    Z = function (t, e) {
                        if (j(t)) {
                            var i = G(t);
                            e.forEach((function (e) {
                                ! function (t, e, i) {
                                    i ? t.setAttribute(e, i) : t.removeAttribute(e)
                                }(t, e, i[e])
                            }))
                        }
                    },
                    $ = function (t, e, i) {
                        P(t, e.class_applied), k(t, v), i && (e.unobserve_completed && O(t, e), C(e.callback_applied, t, i))
                    },
                    U = function (t, e, i) {
                        P(t, e.class_loading), k(t, m), i && (I(i, 1), C(e.callback_loading, t, i))
                    },
                    X = function (t, e, i) {
                        i && t.setAttribute(e, i)
                    },
                    K = function (t, e) {
                        X(t, h, A(t, e.data_sizes)), X(t, u, A(t, e.data_srcset)), X(t, c, A(t, e.data_src))
                    },
                    J = {
                        IMG: function (t, e) {
                            N(t, (function (t) {
                                W(t, V), K(t, e)
                            })), W(t, V), K(t, e)
                        },
                        IFRAME: function (t, e) {
                            W(t, z), X(t, c, A(t, e.data_src))
                        },
                        VIDEO: function (t, e) {
                            B(t, (function (t) {
                                W(t, z), X(t, c, A(t, e.data_src))
                            })), W(t, q), X(t, d, A(t, e.data_poster)), X(t, c, A(t, e.data_src)), t.load()
                        },
                        OBJECT: function (t, e) {
                            W(t, Y), X(t, f, A(t, e.data_src))
                        }
                    },
                    Q = ["IMG", "IFRAME", "VIDEO", "OBJECT"],
                    tt = function (t, e) {
                        !e || function (t) {
                            return t.loadingCount > 0
                        }(e) || function (t) {
                            return t.toLoadCount > 0
                        }(e) || C(t.callback_finish, e)
                    },
                    et = function (t, e, i) {
                        t.addEventListener(e, i), t.llEvLisnrs[e] = i
                    },
                    it = function (t, e, i) {
                        t.removeEventListener(e, i)
                    },
                    rt = function (t) {
                        return !!t.llEvLisnrs
                    },
                    nt = function (t) {
                        if (rt(t)) {
                            var e = t.llEvLisnrs;
                            for (var i in e) {
                                var r = e[i];
                                it(t, i, r)
                            }
                            delete t.llEvLisnrs
                        }
                    },
                    at = function (t, e, i) {
                        ! function (t) {
                            delete t.llTempImage
                        }(t), I(i, -1),
                            function (t) {
                                t && (t.toLoadCount -= 1)
                            }(i), D(t, e.class_loading), e.unobserve_completed && O(t, i)
                    },
                    st = function (t, e, i) {
                        var r = L(t) || t;
                        rt(r) || function (t, e, i) {
                            rt(t) || (t.llEvLisnrs = {});
                            var r = "VIDEO" === t.tagName ? "loadeddata" : "load";
                            et(t, r, e), et(t, "error", i)
                        }(r, (function (n) {
                            ! function (t, e, i, r) {
                                var n = E(e);
                                at(e, i, r), P(e, i.class_loaded), k(e, g), C(i.callback_loaded, e, r), n || tt(i, r)
                            }(0, t, e, i), nt(r)
                        }), (function (n) {
                            ! function (t, e, i, r) {
                                var n = E(e);
                                at(e, i, r), P(e, i.class_error), k(e, y), C(i.callback_error, e, r), i.restore_on_error && Z(e, V), n || tt(i, r)
                            }(0, t, e, i), nt(r)
                        }))
                    },
                    ot = function (t, e, i) {
                        ! function (t) {
                            return Q.indexOf(t.tagName) > -1
                        }(t) ? function (t, e, i) {
                            ! function (t) {
                                t.llTempImage = document.createElement("IMG")
                            }(t), st(t, e, i),
                                function (t) {
                                    j(t) || (t[p] = {
                                        backgroundImage: t.style.backgroundImage
                                    })
                                }(t),
                                function (t, e, i) {
                                    var r = A(t, e.data_bg),
                                        n = A(t, e.data_bg_hidpi),
                                        s = a && n ? n : r;
                                    s && (t.style.backgroundImage = 'url("'.concat(s, '")'), L(t).setAttribute(c, s), U(t, e, i))
                                }(t, e, i),
                                function (t, e, i) {
                                    var r = A(t, e.data_bg_multi),
                                        n = A(t, e.data_bg_multi_hidpi),
                                        s = a && n ? n : r;
                                    s && (t.style.backgroundImage = s, $(t, e, i))
                                }(t, e, i),
                                function (t, e, i) {
                                    var r = A(t, e.data_bg_set);
                                    if (r) {
                                        var n = r.split("|"),
                                            a = n.map((function (t) {
                                                return "image-set(".concat(t, ")")
                                            }));
                                        t.style.backgroundImage = a.join(), "" === t.style.backgroundImage && (a = n.map((function (t) {
                                            return "-webkit-image-set(".concat(t, ")")
                                        })), t.style.backgroundImage = a.join()), $(t, e, i)
                                    }
                                }(t, e, i)
                        }(t, e, i) : function (t, e, i) {
                            st(t, e, i),
                                function (t, e, i) {
                                    var r = J[t.tagName];
                                    r && (r(t, e), U(t, e, i))
                                }(t, e, i)
                        }(t, e, i)
                    },
                    lt = function (t) {
                        t.removeAttribute(c), t.removeAttribute(u), t.removeAttribute(h)
                    },
                    ct = function (t) {
                        N(t, (function (t) {
                            Z(t, V)
                        })), Z(t, V)
                    },
                    ut = {
                        IMG: ct,
                        IFRAME: function (t) {
                            Z(t, z)
                        },
                        VIDEO: function (t) {
                            B(t, (function (t) {
                                Z(t, z)
                            })), Z(t, q), t.load()
                        },
                        OBJECT: function (t) {
                            Z(t, Y)
                        }
                    },
                    ht = function (t, e) {
                        (function (t) {
                            var e = ut[t.tagName];
                            e ? e(t) : function (t) {
                                if (j(t)) {
                                    var e = G(t);
                                    t.style.backgroundImage = e.backgroundImage
                                }
                            }(t)
                        })(t),
                            function (t, e) {
                                T(t) || E(t) || (D(t, e.class_entered), D(t, e.class_exited), D(t, e.class_applied), D(t, e.class_loading), D(t, e.class_loaded), D(t, e.class_error))
                            }(t, e), x(t), H(t)
                    },
                    dt = ["IMG", "IFRAME", "VIDEO"],
                    pt = function (t) {
                        return t.use_native && "loading" in HTMLImageElement.prototype
                    },
                    ft = function (t, e, i) {
                        t.forEach((function (t) {
                            return function (t) {
                                return t.isIntersecting || t.intersectionRatio > 0
                            }(t) ? function (t, e, i, r) {
                                var n = function (t) {
                                    return M.indexOf(S(t)) >= 0
                                }(t);
                                k(t, "entered"), P(t, i.class_entered), D(t, i.class_exited),
                                    function (t, e, i) {
                                        e.unobserve_entered && O(t, i)
                                    }(t, i, r), C(i.callback_enter, t, e, r), n || ot(t, i, r)
                            }(t.target, t, e, i) : function (t, e, i, r) {
                                T(t) || (P(t, i.class_exited), function (t, e, i, r) {
                                    i.cancel_on_exit && function (t) {
                                        return S(t) === m
                                    }(t) && "IMG" === t.tagName && (nt(t), function (t) {
                                        N(t, (function (t) {
                                            lt(t)
                                        })), lt(t)
                                    }(t), ct(t), D(t, i.class_loading), I(r, -1), x(t), C(i.callback_cancel, t, e, r))
                                }(t, e, i, r), C(i.callback_exit, t, e, r))
                            }(t.target, t, e, i)
                        }))
                    },
                    mt = function (t) {
                        return Array.prototype.slice.call(t)
                    },
                    gt = function (t) {
                        return t.container.querySelectorAll(t.elements_selector)
                    },
                    vt = function (t) {
                        return function (t) {
                            return S(t) === y
                        }(t)
                    },
                    yt = function (t, e) {
                        return function (t) {
                            return mt(t).filter(T)
                        }(t || gt(e))
                    },
                    bt = function (t, i) {
                        var n = o(t);
                        this._settings = n, this.loadingCount = 0,
                            function (t, e) {
                                r && !pt(t) && (e._observer = new IntersectionObserver((function (i) {
                                    ft(i, t, e)
                                }), function (t) {
                                    return {
                                        root: t.container === document ? null : t.container,
                                        rootMargin: t.thresholds || t.threshold + "px"
                                    }
                                }(t)))
                            }(n, this),
                            function (t, i) {
                                e && (i._onlineHandler = function () {
                                    ! function (t, e) {
                                        var i;
                                        (i = gt(t), mt(i).filter(vt)).forEach((function (e) {
                                            D(e, t.class_error), x(e)
                                        })), e.update()
                                    }(t, i)
                                }, window.addEventListener("online", i._onlineHandler))
                            }(n, this), this.update(i)
                    };
                return bt.prototype = {
                    update: function (t) {
                        var e, n, a = this._settings,
                            s = yt(t, a);
                        R(this, s.length), !i && r ? pt(a) ? function (t, e, i) {
                            t.forEach((function (t) {
                                -1 !== dt.indexOf(t.tagName) && function (t, e, i) {
                                    t.setAttribute("loading", "lazy"), st(t, e, i),
                                        function (t, e) {
                                            var i = J[t.tagName];
                                            i && i(t, e)
                                        }(t, e), k(t, b)
                                }(t, e, i)
                            })), R(i, 0)
                        }(s, a, this) : (n = s, function (t) {
                            t.disconnect()
                        }(e = this._observer), function (t, e) {
                            e.forEach((function (e) {
                                t.observe(e)
                            }))
                        }(e, n)) : this.loadAll(s)
                    },
                    destroy: function () {
                        this._observer && this._observer.disconnect(), e && window.removeEventListener("online", this._onlineHandler), gt(this._settings).forEach((function (t) {
                            H(t)
                        })), delete this._observer, delete this._settings, delete this._onlineHandler, delete this.loadingCount, delete this.toLoadCount
                    },
                    loadAll: function (t) {
                        var e = this,
                            i = this._settings;
                        yt(t, i).forEach((function (t) {
                            O(t, e), ot(t, i, e)
                        }))
                    },
                    restoreAll: function () {
                        var t = this._settings;
                        gt(t).forEach((function (e) {
                            ht(e, t)
                        }))
                    }
                }, bt.load = function (t, e) {
                    var i = o(e);
                    ot(t, i)
                }, bt.resetStatus = function (t) {
                    x(t)
                }, e && function (t, e) {
                    if (e)
                        if (e.length)
                            for (var i, r = 0; i = e[r]; r += 1) l(t, i);
                        else l(t, e)
                }(bt, window.lazyLoadOptions), bt
            }()
        },
        61: (t, e, i) => {
            var r = i(698).default;

            function n() {
                "use strict";
                t.exports = n = function () {
                    return e
                }, t.exports.__esModule = !0, t.exports.default = t.exports;
                var e = {},
                    i = Object.prototype,
                    a = i.hasOwnProperty,
                    s = Object.defineProperty || function (t, e, i) {
                        t[e] = i.value
                    },
                    o = "function" == typeof Symbol ? Symbol : {},
                    l = o.iterator || "@@iterator",
                    c = o.asyncIterator || "@@asyncIterator",
                    u = o.toStringTag || "@@toStringTag";

                function h(t, e, i) {
                    return Object.defineProperty(t, e, {
                        value: i,
                        enumerable: !0,
                        configurable: !0,
                        writable: !0
                    }), t[e]
                }
                try {
                    h({}, "")
                } catch (t) {
                    h = function (t, e, i) {
                        return t[e] = i
                    }
                }

                function d(t, e, i, r) {
                    var n = e && e.prototype instanceof m ? e : m,
                        a = Object.create(n.prototype),
                        o = new M(r || []);
                    return s(a, "_invoke", {
                        value: k(t, i, o)
                    }), a
                }

                function p(t, e, i) {
                    try {
                        return {
                            type: "normal",
                            arg: t.call(e, i)
                        }
                    } catch (t) {
                        return {
                            type: "throw",
                            arg: t
                        }
                    }
                }
                e.wrap = d;
                var f = {};

                function m() { }

                function g() { }

                function v() { }
                var y = {};
                h(y, l, (function () {
                    return this
                }));
                var b = Object.getPrototypeOf,
                    _ = b && b(b(C([])));
                _ && _ !== i && a.call(_, l) && (y = _);
                var w = v.prototype = m.prototype = Object.create(y);

                function A(t) {
                    ["next", "throw", "return"].forEach((function (e) {
                        h(t, e, (function (t) {
                            return this._invoke(e, t)
                        }))
                    }))
                }

                function S(t, e) {
                    function i(n, s, o, l) {
                        var c = p(t[n], t, s);
                        if ("throw" !== c.type) {
                            var u = c.arg,
                                h = u.value;
                            return h && "object" == r(h) && a.call(h, "__await") ? e.resolve(h.__await).then((function (t) {
                                i("next", t, o, l)
                            }), (function (t) {
                                i("throw", t, o, l)
                            })) : e.resolve(h).then((function (t) {
                                u.value = t, o(u)
                            }), (function (t) {
                                return i("throw", t, o, l)
                            }))
                        }
                        l(c.arg)
                    }
                    var n;
                    s(this, "_invoke", {
                        value: function (t, r) {
                            function a() {
                                return new e((function (e, n) {
                                    i(t, r, e, n)
                                }))
                            }
                            return n = n ? n.then(a, a) : a()
                        }
                    })
                }

                function k(t, e, i) {
                    var r = "suspendedStart";
                    return function (n, a) {
                        if ("executing" === r) throw new Error("Generator is already running");
                        if ("completed" === r) {
                            if ("throw" === n) throw a;
                            return P()
                        }
                        for (i.method = n, i.arg = a; ;) {
                            var s = i.delegate;
                            if (s) {
                                var o = x(s, i);
                                if (o) {
                                    if (o === f) continue;
                                    return o
                                }
                            }
                            if ("next" === i.method) i.sent = i._sent = i.arg;
                            else if ("throw" === i.method) {
                                if ("suspendedStart" === r) throw r = "completed", i.arg;
                                i.dispatchException(i.arg)
                            } else "return" === i.method && i.abrupt("return", i.arg);
                            r = "executing";
                            var l = p(t, e, i);
                            if ("normal" === l.type) {
                                if (r = i.done ? "completed" : "suspendedYield", l.arg === f) continue;
                                return {
                                    value: l.arg,
                                    done: i.done
                                }
                            }
                            "throw" === l.type && (r = "completed", i.method = "throw", i.arg = l.arg)
                        }
                    }
                }

                function x(t, e) {
                    var i = e.method,
                        r = t.iterator[i];
                    if (void 0 === r) return e.delegate = null, "throw" === i && t.iterator.return && (e.method = "return", e.arg = void 0, x(t, e), "throw" === e.method) || "return" !== i && (e.method = "throw", e.arg = new TypeError("The iterator does not provide a '" + i + "' method")), f;
                    var n = p(r, t.iterator, e.arg);
                    if ("throw" === n.type) return e.method = "throw", e.arg = n.arg, e.delegate = null, f;
                    var a = n.arg;
                    return a ? a.done ? (e[t.resultName] = a.value, e.next = t.nextLoc, "return" !== e.method && (e.method = "next", e.arg = void 0), e.delegate = null, f) : a : (e.method = "throw", e.arg = new TypeError("iterator result is not an object"), e.delegate = null, f)
                }

                function T(t) {
                    var e = {
                        tryLoc: t[0]
                    };
                    1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e)
                }

                function E(t) {
                    var e = t.completion || {};
                    e.type = "normal", delete e.arg, t.completion = e
                }

                function M(t) {
                    this.tryEntries = [{
                        tryLoc: "root"
                    }], t.forEach(T, this), this.reset(!0)
                }

                function C(t) {
                    if (t) {
                        var e = t[l];
                        if (e) return e.call(t);
                        if ("function" == typeof t.next) return t;
                        if (!isNaN(t.length)) {
                            var i = -1,
                                r = function e() {
                                    for (; ++i < t.length;)
                                        if (a.call(t, i)) return e.value = t[i], e.done = !1, e;
                                    return e.value = void 0, e.done = !0, e
                                };
                            return r.next = r
                        }
                    }
                    return {
                        next: P
                    }
                }

                function P() {
                    return {
                        value: void 0,
                        done: !0
                    }
                }
                return g.prototype = v, s(w, "constructor", {
                    value: v,
                    configurable: !0
                }), s(v, "constructor", {
                    value: g,
                    configurable: !0
                }), g.displayName = h(v, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) {
                    var e = "function" == typeof t && t.constructor;
                    return !!e && (e === g || "GeneratorFunction" === (e.displayName || e.name))
                }, e.mark = function (t) {
                    return Object.setPrototypeOf ? Object.setPrototypeOf(t, v) : (t.__proto__ = v, h(t, u, "GeneratorFunction")), t.prototype = Object.create(w), t
                }, e.awrap = function (t) {
                    return {
                        __await: t
                    }
                }, A(S.prototype), h(S.prototype, c, (function () {
                    return this
                })), e.AsyncIterator = S, e.async = function (t, i, r, n, a) {
                    void 0 === a && (a = Promise);
                    var s = new S(d(t, i, r, n), a);
                    return e.isGeneratorFunction(i) ? s : s.next().then((function (t) {
                        return t.done ? t.value : s.next()
                    }))
                }, A(w), h(w, u, "Generator"), h(w, l, (function () {
                    return this
                })), h(w, "toString", (function () {
                    return "[object Generator]"
                })), e.keys = function (t) {
                    var e = Object(t),
                        i = [];
                    for (var r in e) i.push(r);
                    return i.reverse(),
                        function t() {
                            for (; i.length;) {
                                var r = i.pop();
                                if (r in e) return t.value = r, t.done = !1, t
                            }
                            return t.done = !0, t
                        }
                }, e.values = C, M.prototype = {
                    constructor: M,
                    reset: function (t) {
                        if (this.prev = 0, this.next = 0, this.sent = this._sent = void 0, this.done = !1, this.delegate = null, this.method = "next", this.arg = void 0, this.tryEntries.forEach(E), !t)
                            for (var e in this) "t" === e.charAt(0) && a.call(this, e) && !isNaN(+e.slice(1)) && (this[e] = void 0)
                    },
                    stop: function () {
                        this.done = !0;
                        var t = this.tryEntries[0].completion;
                        if ("throw" === t.type) throw t.arg;
                        return this.rval
                    },
                    dispatchException: function (t) {
                        if (this.done) throw t;
                        var e = this;

                        function i(i, r) {
                            return s.type = "throw", s.arg = t, e.next = i, r && (e.method = "next", e.arg = void 0), !!r
                        }
                        for (var r = this.tryEntries.length - 1; r >= 0; --r) {
                            var n = this.tryEntries[r],
                                s = n.completion;
                            if ("root" === n.tryLoc) return i("end");
                            if (n.tryLoc <= this.prev) {
                                var o = a.call(n, "catchLoc"),
                                    l = a.call(n, "finallyLoc");
                                if (o && l) {
                                    if (this.prev < n.catchLoc) return i(n.catchLoc, !0);
                                    if (this.prev < n.finallyLoc) return i(n.finallyLoc)
                                } else if (o) {
                                    if (this.prev < n.catchLoc) return i(n.catchLoc, !0)
                                } else {
                                    if (!l) throw new Error("try statement without catch or finally");
                                    if (this.prev < n.finallyLoc) return i(n.finallyLoc)
                                }
                            }
                        }
                    },
                    abrupt: function (t, e) {
                        for (var i = this.tryEntries.length - 1; i >= 0; --i) {
                            var r = this.tryEntries[i];
                            if (r.tryLoc <= this.prev && a.call(r, "finallyLoc") && this.prev < r.finallyLoc) {
                                var n = r;
                                break
                            }
                        }
                        n && ("break" === t || "continue" === t) && n.tryLoc <= e && e <= n.finallyLoc && (n = null);
                        var s = n ? n.completion : {};
                        return s.type = t, s.arg = e, n ? (this.method = "next", this.next = n.finallyLoc, f) : this.complete(s)
                    },
                    complete: function (t, e) {
                        if ("throw" === t.type) throw t.arg;
                        return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), f
                    },
                    finish: function (t) {
                        for (var e = this.tryEntries.length - 1; e >= 0; --e) {
                            var i = this.tryEntries[e];
                            if (i.finallyLoc === t) return this.complete(i.completion, i.afterLoc), E(i), f
                        }
                    },
                    catch: function (t) {
                        for (var e = this.tryEntries.length - 1; e >= 0; --e) {
                            var i = this.tryEntries[e];
                            if (i.tryLoc === t) {
                                var r = i.completion;
                                if ("throw" === r.type) {
                                    var n = r.arg;
                                    E(i)
                                }
                                return n
                            }
                        }
                        throw new Error("illegal catch attempt")
                    },
                    delegateYield: function (t, e, i) {
                        return this.delegate = {
                            iterator: C(t),
                            resultName: e,
                            nextLoc: i
                        }, "next" === this.method && (this.arg = void 0), f
                    }
                }, e
            }
            t.exports = n, t.exports.__esModule = !0, t.exports.default = t.exports
        },
        698: t => {
            function e(i) {
                return t.exports = e = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
                    return typeof t
                } : function (t) {
                    return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t
                }, t.exports.__esModule = !0, t.exports.default = t.exports, e(i)
            }
            t.exports = e, t.exports.__esModule = !0, t.exports.default = t.exports
        },
        687: (t, e, i) => {
            var r = i(61)();
            t.exports = r;
            try {
                regeneratorRuntime = r
            } catch (t) {
                "object" == typeof globalThis ? globalThis.regeneratorRuntime = r : Function("r", "regeneratorRuntime = r")(r)
            }
        },
        544: t => {
            "use strict";
            t.exports = JSON.parse('{"version":"2022g","zones":["Africa/Abidjan|GMT|0|0||48e5","Africa/Nairobi|EAT|-30|0||47e5","Africa/Algiers|CET|-10|0||26e5","Africa/Lagos|WAT|-10|0||17e6","Africa/Khartoum|CAT|-20|0||51e5","Africa/Cairo|EET|-20|0||15e6","Africa/Casablanca|+01 +00|-10 0|0101010101010101010101010|29y20 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00|32e5","Europe/Paris|CET CEST|-10 -20|01010101010101010101010|29AN0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0|11e6","Africa/Johannesburg|SAST|-20|0||84e5","America/Adak|HST HDT|a0 90|01010101010101010101010|29vo0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0|326","America/Anchorage|AKST AKDT|90 80|01010101010101010101010|29vn0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0|30e4","America/Santo_Domingo|AST|40|0||29e5","America/Sao_Paulo|-03|30|0||20e6","America/Asuncion|-03 -04|30 40|01010101010101010101010|29AP0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0|28e5","America/Panama|EST|50|0||15e5","America/Mexico_City|CST|60|0||20e6","America/Caracas|-04|40|0||29e5","America/Lima|-05|50|0||11e6","America/Denver|MST MDT|70 60|01010101010101010101010|29vl0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0|26e5","America/Chicago|CST CDT|60 50|01010101010101010101010|29vk0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0|92e5","America/Phoenix|MST|70|0||42e5","America/New_York|EST EDT|50 40|01010101010101010101010|29vj0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0|21e6","America/Los_Angeles|PST PDT|80 70|01010101010101010101010|29vm0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0|15e6","America/Halifax|AST ADT|40 30|01010101010101010101010|29vi0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0|39e4","America/Godthab|-03 -02|30 20|01|29AN0|17e3","America/Havana|CST CDT|50 40|01010101010101010101010|29vh0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0|21e5","America/Miquelon|-03 -02|30 20|01010101010101010101010|29vh0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0|61e2","America/Noronha|-02|20|0||30e2","America/Santiago|-03 -04|30 40|01010101010101010101010|29DD0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0|62e5","Atlantic/Azores|-01 +00|10 0|01010101010101010101010|29AN0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0|25e4","America/St_Johns|NST NDT|3u 2u|01010101010101010101010|29vhu 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0|11e4","Asia/Sakhalin|+11|-b0|0||58e4","Asia/Bangkok|+07|-70|0||15e6","Asia/Vladivostok|+10|-a0|0||60e4","Australia/Sydney|AEDT AEST|-b0 -a0|01010101010101010101010|29Ds0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0|40e5","Asia/Tashkent|+05|-50|0||23e5","Pacific/Auckland|NZDT NZST|-d0 -c0|01010101010101010101010|29Dq0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00|14e5","Europe/Istanbul|+03|-30|0||13e6","Antarctica/Troll|+00 +02|0 -20|01010101010101010101010|29AN0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0|40","Asia/Dhaka|+06|-60|0||16e6","Pacific/Fiji|+12|-c0|0||88e4","Asia/Dubai|+04|-40|0||39e5","Asia/Beirut|EET EEST|-20 -30|01010101010101010101010|29AK0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0|22e5","Asia/Kuala_Lumpur|+08|-80|0||71e5","Asia/Kolkata|IST|-5u|0||15e6","Asia/Chita|+09|-90|0||33e4","Asia/Shanghai|CST|-80|0||23e6","Asia/Colombo|+0530|-5u|0||22e5","Europe/Athens|EET EEST|-20 -30|01010101010101010101010|29AN0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0|35e5","Asia/Gaza|EET EEST|-20 -30|01010101010101010101010|29Ao0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0|18e5","Asia/Hong_Kong|HKT|-80|0||73e5","Asia/Jakarta|WIB|-70|0||31e6","Asia/Jayapura|WIT|-90|0||26e4","Asia/Jerusalem|IST IDT|-20 -30|01010101010101010101010|29A00 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0|81e4","Asia/Kabul|+0430|-4u|0||46e5","Asia/Karachi|PKT|-50|0||24e6","Asia/Kathmandu|+0545|-5J|0||12e5","Asia/Makassar|WITA|-80|0||15e5","Asia/Manila|PST|-80|0||24e6","Asia/Seoul|KST|-90|0||23e6","Asia/Rangoon|+0630|-6u|0||48e5","Asia/Tehran|+0330|-3u|0||14e6","Asia/Tokyo|JST|-90|0||38e6","Europe/Lisbon|WET WEST|0 -10|01010101010101010101010|29AN0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0|27e5","Atlantic/Cape_Verde|-01|10|0||50e4","Australia/Adelaide|ACDT ACST|-au -9u|01010101010101010101010|29Dsu 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0|11e5","Australia/Brisbane|AEST|-a0|0||20e5","Australia/Darwin|ACST|-9u|0||12e4","Australia/Eucla|+0845|-8J|0||368","Australia/Lord_Howe|+11 +1030|-b0 -au|01010101010101010101010|29Dr0 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu|347","Australia/Perth|AWST|-80|0||18e5","Pacific/Easter|-05 -06|50 60|01010101010101010101010|29DD0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0|30e2","Europe/Dublin|GMT IST|0 -10|01010101010101010101010|29AN0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0|12e5","Etc/GMT-1|+01|-10|0||","Pacific/Tongatapu|+13|-d0|0||75e3","Pacific/Kiritimati|+14|-e0|0||51e2","Etc/GMT-2|+02|-20|0||","Pacific/Tahiti|-10|a0|0||18e4","Pacific/Niue|-11|b0|0||12e2","Etc/GMT+12|-12|c0|0||","Pacific/Galapagos|-06|60|0||25e3","Etc/GMT+7|-07|70|0||","Pacific/Pitcairn|-08|80|0||56","Pacific/Gambier|-09|90|0||125","Etc/UTC|UTC|0|0||","Europe/London|GMT BST|0 -10|01010101010101010101010|29AN0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0|10e6","Europe/Chisinau|EET EEST|-20 -30|01010101010101010101010|29AM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0|67e4","Europe/Moscow|MSK|-30|0||16e6","Pacific/Honolulu|HST|a0|0||37e4","MET|MET MEST|-10 -20|01010101010101010101010|29AN0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0|","Pacific/Chatham|+1345 +1245|-dJ -cJ|01010101010101010101010|29Dq0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00|600","Pacific/Guam|ChST|-a0|0||17e4","Pacific/Marquesas|-0930|9u|0||86e2","Pacific/Pago_Pago|SST|b0|0||37e2","Pacific/Norfolk|+12 +11|-c0 -b0|01010101010101010101010|29Dr0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0|25e4"],"links":["Africa/Abidjan|Africa/Accra","Africa/Abidjan|Africa/Bamako","Africa/Abidjan|Africa/Banjul","Africa/Abidjan|Africa/Bissau","Africa/Abidjan|Africa/Conakry","Africa/Abidjan|Africa/Dakar","Africa/Abidjan|Africa/Freetown","Africa/Abidjan|Africa/Lome","Africa/Abidjan|Africa/Monrovia","Africa/Abidjan|Africa/Nouakchott","Africa/Abidjan|Africa/Ouagadougou","Africa/Abidjan|Africa/Sao_Tome","Africa/Abidjan|Africa/Timbuktu","Africa/Abidjan|America/Danmarkshavn","Africa/Abidjan|Atlantic/Reykjavik","Africa/Abidjan|Atlantic/St_Helena","Africa/Abidjan|Etc/GMT","Africa/Abidjan|Etc/GMT+0","Africa/Abidjan|Etc/GMT-0","Africa/Abidjan|Etc/GMT0","Africa/Abidjan|Etc/Greenwich","Africa/Abidjan|GMT","Africa/Abidjan|GMT+0","Africa/Abidjan|GMT-0","Africa/Abidjan|GMT0","Africa/Abidjan|Greenwich","Africa/Abidjan|Iceland","Africa/Algiers|Africa/Tunis","Africa/Cairo|Africa/Tripoli","Africa/Cairo|Egypt","Africa/Cairo|Europe/Kaliningrad","Africa/Cairo|Libya","Africa/Casablanca|Africa/El_Aaiun","Africa/Johannesburg|Africa/Maseru","Africa/Johannesburg|Africa/Mbabane","Africa/Khartoum|Africa/Blantyre","Africa/Khartoum|Africa/Bujumbura","Africa/Khartoum|Africa/Gaborone","Africa/Khartoum|Africa/Harare","Africa/Khartoum|Africa/Juba","Africa/Khartoum|Africa/Kigali","Africa/Khartoum|Africa/Lubumbashi","Africa/Khartoum|Africa/Lusaka","Africa/Khartoum|Africa/Maputo","Africa/Khartoum|Africa/Windhoek","Africa/Lagos|Africa/Bangui","Africa/Lagos|Africa/Brazzaville","Africa/Lagos|Africa/Douala","Africa/Lagos|Africa/Kinshasa","Africa/Lagos|Africa/Libreville","Africa/Lagos|Africa/Luanda","Africa/Lagos|Africa/Malabo","Africa/Lagos|Africa/Ndjamena","Africa/Lagos|Africa/Niamey","Africa/Lagos|Africa/Porto-Novo","Africa/Nairobi|Africa/Addis_Ababa","Africa/Nairobi|Africa/Asmara","Africa/Nairobi|Africa/Asmera","Africa/Nairobi|Africa/Dar_es_Salaam","Africa/Nairobi|Africa/Djibouti","Africa/Nairobi|Africa/Kampala","Africa/Nairobi|Africa/Mogadishu","Africa/Nairobi|Indian/Antananarivo","Africa/Nairobi|Indian/Comoro","Africa/Nairobi|Indian/Mayotte","America/Adak|America/Atka","America/Adak|US/Aleutian","America/Anchorage|America/Juneau","America/Anchorage|America/Metlakatla","America/Anchorage|America/Nome","America/Anchorage|America/Sitka","America/Anchorage|America/Yakutat","America/Anchorage|US/Alaska","America/Caracas|America/Boa_Vista","America/Caracas|America/Campo_Grande","America/Caracas|America/Cuiaba","America/Caracas|America/Guyana","America/Caracas|America/La_Paz","America/Caracas|America/Manaus","America/Caracas|America/Porto_Velho","America/Caracas|Brazil/West","America/Caracas|Etc/GMT+4","America/Chicago|America/Indiana/Knox","America/Chicago|America/Indiana/Tell_City","America/Chicago|America/Knox_IN","America/Chicago|America/Matamoros","America/Chicago|America/Menominee","America/Chicago|America/North_Dakota/Beulah","America/Chicago|America/North_Dakota/Center","America/Chicago|America/North_Dakota/New_Salem","America/Chicago|America/Ojinaga","America/Chicago|America/Rainy_River","America/Chicago|America/Rankin_Inlet","America/Chicago|America/Resolute","America/Chicago|America/Winnipeg","America/Chicago|CST6CDT","America/Chicago|Canada/Central","America/Chicago|US/Central","America/Chicago|US/Indiana-Starke","America/Denver|America/Boise","America/Denver|America/Cambridge_Bay","America/Denver|America/Ciudad_Juarez","America/Denver|America/Edmonton","America/Denver|America/Inuvik","America/Denver|America/Shiprock","America/Denver|America/Yellowknife","America/Denver|Canada/Mountain","America/Denver|MST7MDT","America/Denver|Navajo","America/Denver|US/Mountain","America/Godthab|America/Nuuk","America/Halifax|America/Glace_Bay","America/Halifax|America/Goose_Bay","America/Halifax|America/Moncton","America/Halifax|America/Thule","America/Halifax|Atlantic/Bermuda","America/Halifax|Canada/Atlantic","America/Havana|Cuba","America/Lima|America/Bogota","America/Lima|America/Eirunepe","America/Lima|America/Guayaquil","America/Lima|America/Porto_Acre","America/Lima|America/Rio_Branco","America/Lima|Brazil/Acre","America/Lima|Etc/GMT+5","America/Los_Angeles|America/Ensenada","America/Los_Angeles|America/Santa_Isabel","America/Los_Angeles|America/Tijuana","America/Los_Angeles|America/Vancouver","America/Los_Angeles|Canada/Pacific","America/Los_Angeles|Mexico/BajaNorte","America/Los_Angeles|PST8PDT","America/Los_Angeles|US/Pacific","America/Mexico_City|America/Bahia_Banderas","America/Mexico_City|America/Belize","America/Mexico_City|America/Chihuahua","America/Mexico_City|America/Costa_Rica","America/Mexico_City|America/El_Salvador","America/Mexico_City|America/Guatemala","America/Mexico_City|America/Managua","America/Mexico_City|America/Merida","America/Mexico_City|America/Monterrey","America/Mexico_City|America/Regina","America/Mexico_City|America/Swift_Current","America/Mexico_City|America/Tegucigalpa","America/Mexico_City|Canada/Saskatchewan","America/Mexico_City|Mexico/General","America/New_York|America/Detroit","America/New_York|America/Fort_Wayne","America/New_York|America/Grand_Turk","America/New_York|America/Indiana/Indianapolis","America/New_York|America/Indiana/Marengo","America/New_York|America/Indiana/Petersburg","America/New_York|America/Indiana/Vevay","America/New_York|America/Indiana/Vincennes","America/New_York|America/Indiana/Winamac","America/New_York|America/Indianapolis","America/New_York|America/Iqaluit","America/New_York|America/Kentucky/Louisville","America/New_York|America/Kentucky/Monticello","America/New_York|America/Louisville","America/New_York|America/Montreal","America/New_York|America/Nassau","America/New_York|America/Nipigon","America/New_York|America/Pangnirtung","America/New_York|America/Port-au-Prince","America/New_York|America/Thunder_Bay","America/New_York|America/Toronto","America/New_York|Canada/Eastern","America/New_York|EST5EDT","America/New_York|US/East-Indiana","America/New_York|US/Eastern","America/New_York|US/Michigan","America/Noronha|Atlantic/South_Georgia","America/Noronha|Brazil/DeNoronha","America/Noronha|Etc/GMT+2","America/Panama|America/Atikokan","America/Panama|America/Cancun","America/Panama|America/Cayman","America/Panama|America/Coral_Harbour","America/Panama|America/Jamaica","America/Panama|EST","America/Panama|Jamaica","America/Phoenix|America/Creston","America/Phoenix|America/Dawson","America/Phoenix|America/Dawson_Creek","America/Phoenix|America/Fort_Nelson","America/Phoenix|America/Hermosillo","America/Phoenix|America/Mazatlan","America/Phoenix|America/Whitehorse","America/Phoenix|Canada/Yukon","America/Phoenix|MST","America/Phoenix|Mexico/BajaSur","America/Phoenix|US/Arizona","America/Santiago|Chile/Continental","America/Santo_Domingo|America/Anguilla","America/Santo_Domingo|America/Antigua","America/Santo_Domingo|America/Aruba","America/Santo_Domingo|America/Barbados","America/Santo_Domingo|America/Blanc-Sablon","America/Santo_Domingo|America/Curacao","America/Santo_Domingo|America/Dominica","America/Santo_Domingo|America/Grenada","America/Santo_Domingo|America/Guadeloupe","America/Santo_Domingo|America/Kralendijk","America/Santo_Domingo|America/Lower_Princes","America/Santo_Domingo|America/Marigot","America/Santo_Domingo|America/Martinique","America/Santo_Domingo|America/Montserrat","America/Santo_Domingo|America/Port_of_Spain","America/Santo_Domingo|America/Puerto_Rico","America/Santo_Domingo|America/St_Barthelemy","America/Santo_Domingo|America/St_Kitts","America/Santo_Domingo|America/St_Lucia","America/Santo_Domingo|America/St_Thomas","America/Santo_Domingo|America/St_Vincent","America/Santo_Domingo|America/Tortola","America/Santo_Domingo|America/Virgin","America/Sao_Paulo|America/Araguaina","America/Sao_Paulo|America/Argentina/Buenos_Aires","America/Sao_Paulo|America/Argentina/Catamarca","America/Sao_Paulo|America/Argentina/ComodRivadavia","America/Sao_Paulo|America/Argentina/Cordoba","America/Sao_Paulo|America/Argentina/Jujuy","America/Sao_Paulo|America/Argentina/La_Rioja","America/Sao_Paulo|America/Argentina/Mendoza","America/Sao_Paulo|America/Argentina/Rio_Gallegos","America/Sao_Paulo|America/Argentina/Salta","America/Sao_Paulo|America/Argentina/San_Juan","America/Sao_Paulo|America/Argentina/San_Luis","America/Sao_Paulo|America/Argentina/Tucuman","America/Sao_Paulo|America/Argentina/Ushuaia","America/Sao_Paulo|America/Bahia","America/Sao_Paulo|America/Belem","America/Sao_Paulo|America/Buenos_Aires","America/Sao_Paulo|America/Catamarca","America/Sao_Paulo|America/Cayenne","America/Sao_Paulo|America/Cordoba","America/Sao_Paulo|America/Fortaleza","America/Sao_Paulo|America/Jujuy","America/Sao_Paulo|America/Maceio","America/Sao_Paulo|America/Mendoza","America/Sao_Paulo|America/Montevideo","America/Sao_Paulo|America/Paramaribo","America/Sao_Paulo|America/Punta_Arenas","America/Sao_Paulo|America/Recife","America/Sao_Paulo|America/Rosario","America/Sao_Paulo|America/Santarem","America/Sao_Paulo|Antarctica/Palmer","America/Sao_Paulo|Antarctica/Rothera","America/Sao_Paulo|Atlantic/Stanley","America/Sao_Paulo|Brazil/East","America/Sao_Paulo|Etc/GMT+3","America/St_Johns|Canada/Newfoundland","Asia/Bangkok|Antarctica/Davis","Asia/Bangkok|Asia/Barnaul","Asia/Bangkok|Asia/Ho_Chi_Minh","Asia/Bangkok|Asia/Hovd","Asia/Bangkok|Asia/Krasnoyarsk","Asia/Bangkok|Asia/Novokuznetsk","Asia/Bangkok|Asia/Novosibirsk","Asia/Bangkok|Asia/Phnom_Penh","Asia/Bangkok|Asia/Saigon","Asia/Bangkok|Asia/Tomsk","Asia/Bangkok|Asia/Vientiane","Asia/Bangkok|Etc/GMT-7","Asia/Bangkok|Indian/Christmas","Asia/Chita|Asia/Dili","Asia/Chita|Asia/Khandyga","Asia/Chita|Asia/Yakutsk","Asia/Chita|Etc/GMT-9","Asia/Chita|Pacific/Palau","Asia/Dhaka|Antarctica/Vostok","Asia/Dhaka|Asia/Almaty","Asia/Dhaka|Asia/Bishkek","Asia/Dhaka|Asia/Dacca","Asia/Dhaka|Asia/Kashgar","Asia/Dhaka|Asia/Omsk","Asia/Dhaka|Asia/Qostanay","Asia/Dhaka|Asia/Thimbu","Asia/Dhaka|Asia/Thimphu","Asia/Dhaka|Asia/Urumqi","Asia/Dhaka|Etc/GMT-6","Asia/Dhaka|Indian/Chagos","Asia/Dubai|Asia/Baku","Asia/Dubai|Asia/Muscat","Asia/Dubai|Asia/Tbilisi","Asia/Dubai|Asia/Yerevan","Asia/Dubai|Etc/GMT-4","Asia/Dubai|Europe/Astrakhan","Asia/Dubai|Europe/Samara","Asia/Dubai|Europe/Saratov","Asia/Dubai|Europe/Ulyanovsk","Asia/Dubai|Indian/Mahe","Asia/Dubai|Indian/Mauritius","Asia/Dubai|Indian/Reunion","Asia/Gaza|Asia/Hebron","Asia/Hong_Kong|Hongkong","Asia/Jakarta|Asia/Pontianak","Asia/Jerusalem|Asia/Tel_Aviv","Asia/Jerusalem|Israel","Asia/Kathmandu|Asia/Katmandu","Asia/Kolkata|Asia/Calcutta","Asia/Kuala_Lumpur|Asia/Brunei","Asia/Kuala_Lumpur|Asia/Choibalsan","Asia/Kuala_Lumpur|Asia/Irkutsk","Asia/Kuala_Lumpur|Asia/Kuching","Asia/Kuala_Lumpur|Asia/Singapore","Asia/Kuala_Lumpur|Asia/Ulaanbaatar","Asia/Kuala_Lumpur|Asia/Ulan_Bator","Asia/Kuala_Lumpur|Etc/GMT-8","Asia/Kuala_Lumpur|Singapore","Asia/Makassar|Asia/Ujung_Pandang","Asia/Rangoon|Asia/Yangon","Asia/Rangoon|Indian/Cocos","Asia/Sakhalin|Antarctica/Casey","Asia/Sakhalin|Asia/Magadan","Asia/Sakhalin|Asia/Srednekolymsk","Asia/Sakhalin|Etc/GMT-11","Asia/Sakhalin|Pacific/Bougainville","Asia/Sakhalin|Pacific/Efate","Asia/Sakhalin|Pacific/Guadalcanal","Asia/Sakhalin|Pacific/Kosrae","Asia/Sakhalin|Pacific/Noumea","Asia/Sakhalin|Pacific/Pohnpei","Asia/Sakhalin|Pacific/Ponape","Asia/Seoul|Asia/Pyongyang","Asia/Seoul|ROK","Asia/Shanghai|Asia/Chongqing","Asia/Shanghai|Asia/Chungking","Asia/Shanghai|Asia/Harbin","Asia/Shanghai|Asia/Macao","Asia/Shanghai|Asia/Macau","Asia/Shanghai|Asia/Taipei","Asia/Shanghai|PRC","Asia/Shanghai|ROC","Asia/Tashkent|Antarctica/Mawson","Asia/Tashkent|Asia/Aqtau","Asia/Tashkent|Asia/Aqtobe","Asia/Tashkent|Asia/Ashgabat","Asia/Tashkent|Asia/Ashkhabad","Asia/Tashkent|Asia/Atyrau","Asia/Tashkent|Asia/Dushanbe","Asia/Tashkent|Asia/Oral","Asia/Tashkent|Asia/Qyzylorda","Asia/Tashkent|Asia/Samarkand","Asia/Tashkent|Asia/Yekaterinburg","Asia/Tashkent|Etc/GMT-5","Asia/Tashkent|Indian/Kerguelen","Asia/Tashkent|Indian/Maldives","Asia/Tehran|Iran","Asia/Tokyo|Japan","Asia/Vladivostok|Antarctica/DumontDUrville","Asia/Vladivostok|Asia/Ust-Nera","Asia/Vladivostok|Etc/GMT-10","Asia/Vladivostok|Pacific/Chuuk","Asia/Vladivostok|Pacific/Port_Moresby","Asia/Vladivostok|Pacific/Truk","Asia/Vladivostok|Pacific/Yap","Atlantic/Azores|America/Scoresbysund","Atlantic/Cape_Verde|Etc/GMT+1","Australia/Adelaide|Australia/Broken_Hill","Australia/Adelaide|Australia/South","Australia/Adelaide|Australia/Yancowinna","Australia/Brisbane|Australia/Lindeman","Australia/Brisbane|Australia/Queensland","Australia/Darwin|Australia/North","Australia/Lord_Howe|Australia/LHI","Australia/Perth|Australia/West","Australia/Sydney|Antarctica/Macquarie","Australia/Sydney|Australia/ACT","Australia/Sydney|Australia/Canberra","Australia/Sydney|Australia/Currie","Australia/Sydney|Australia/Hobart","Australia/Sydney|Australia/Melbourne","Australia/Sydney|Australia/NSW","Australia/Sydney|Australia/Tasmania","Australia/Sydney|Australia/Victoria","Etc/UTC|Etc/UCT","Etc/UTC|Etc/Universal","Etc/UTC|Etc/Zulu","Etc/UTC|UCT","Etc/UTC|UTC","Etc/UTC|Universal","Etc/UTC|Zulu","Europe/Athens|Asia/Famagusta","Europe/Athens|Asia/Nicosia","Europe/Athens|EET","Europe/Athens|Europe/Bucharest","Europe/Athens|Europe/Helsinki","Europe/Athens|Europe/Kiev","Europe/Athens|Europe/Kyiv","Europe/Athens|Europe/Mariehamn","Europe/Athens|Europe/Nicosia","Europe/Athens|Europe/Riga","Europe/Athens|Europe/Sofia","Europe/Athens|Europe/Tallinn","Europe/Athens|Europe/Uzhgorod","Europe/Athens|Europe/Vilnius","Europe/Athens|Europe/Zaporozhye","Europe/Chisinau|Europe/Tiraspol","Europe/Dublin|Eire","Europe/Istanbul|Antarctica/Syowa","Europe/Istanbul|Asia/Aden","Europe/Istanbul|Asia/Amman","Europe/Istanbul|Asia/Baghdad","Europe/Istanbul|Asia/Bahrain","Europe/Istanbul|Asia/Damascus","Europe/Istanbul|Asia/Istanbul","Europe/Istanbul|Asia/Kuwait","Europe/Istanbul|Asia/Qatar","Europe/Istanbul|Asia/Riyadh","Europe/Istanbul|Etc/GMT-3","Europe/Istanbul|Europe/Kirov","Europe/Istanbul|Europe/Minsk","Europe/Istanbul|Europe/Volgograd","Europe/Istanbul|Turkey","Europe/Lisbon|Atlantic/Canary","Europe/Lisbon|Atlantic/Faeroe","Europe/Lisbon|Atlantic/Faroe","Europe/Lisbon|Atlantic/Madeira","Europe/Lisbon|Portugal","Europe/Lisbon|WET","Europe/London|Europe/Belfast","Europe/London|Europe/Guernsey","Europe/London|Europe/Isle_of_Man","Europe/London|Europe/Jersey","Europe/London|GB","Europe/London|GB-Eire","Europe/Moscow|Europe/Simferopol","Europe/Moscow|W-SU","Europe/Paris|Africa/Ceuta","Europe/Paris|Arctic/Longyearbyen","Europe/Paris|Atlantic/Jan_Mayen","Europe/Paris|CET","Europe/Paris|Europe/Amsterdam","Europe/Paris|Europe/Andorra","Europe/Paris|Europe/Belgrade","Europe/Paris|Europe/Berlin","Europe/Paris|Europe/Bratislava","Europe/Paris|Europe/Brussels","Europe/Paris|Europe/Budapest","Europe/Paris|Europe/Busingen","Europe/Paris|Europe/Copenhagen","Europe/Paris|Europe/Gibraltar","Europe/Paris|Europe/Ljubljana","Europe/Paris|Europe/Luxembourg","Europe/Paris|Europe/Madrid","Europe/Paris|Europe/Malta","Europe/Paris|Europe/Monaco","Europe/Paris|Europe/Oslo","Europe/Paris|Europe/Podgorica","Europe/Paris|Europe/Prague","Europe/Paris|Europe/Rome","Europe/Paris|Europe/San_Marino","Europe/Paris|Europe/Sarajevo","Europe/Paris|Europe/Skopje","Europe/Paris|Europe/Stockholm","Europe/Paris|Europe/Tirane","Europe/Paris|Europe/Vaduz","Europe/Paris|Europe/Vatican","Europe/Paris|Europe/Vienna","Europe/Paris|Europe/Warsaw","Europe/Paris|Europe/Zagreb","Europe/Paris|Europe/Zurich","Europe/Paris|Poland","Pacific/Auckland|Antarctica/McMurdo","Pacific/Auckland|Antarctica/South_Pole","Pacific/Auckland|NZ","Pacific/Chatham|NZ-CHAT","Pacific/Easter|Chile/EasterIsland","Pacific/Fiji|Asia/Anadyr","Pacific/Fiji|Asia/Kamchatka","Pacific/Fiji|Etc/GMT-12","Pacific/Fiji|Kwajalein","Pacific/Fiji|Pacific/Funafuti","Pacific/Fiji|Pacific/Kwajalein","Pacific/Fiji|Pacific/Majuro","Pacific/Fiji|Pacific/Nauru","Pacific/Fiji|Pacific/Tarawa","Pacific/Fiji|Pacific/Wake","Pacific/Fiji|Pacific/Wallis","Pacific/Galapagos|Etc/GMT+6","Pacific/Gambier|Etc/GMT+9","Pacific/Guam|Pacific/Saipan","Pacific/Honolulu|HST","Pacific/Honolulu|Pacific/Johnston","Pacific/Honolulu|US/Hawaii","Pacific/Kiritimati|Etc/GMT-14","Pacific/Niue|Etc/GMT+11","Pacific/Pago_Pago|Pacific/Midway","Pacific/Pago_Pago|Pacific/Samoa","Pacific/Pago_Pago|US/Samoa","Pacific/Pitcairn|Etc/GMT+8","Pacific/Tahiti|Etc/GMT+10","Pacific/Tahiti|Pacific/Rarotonga","Pacific/Tongatapu|Etc/GMT-13","Pacific/Tongatapu|Pacific/Apia","Pacific/Tongatapu|Pacific/Enderbury","Pacific/Tongatapu|Pacific/Fakaofo","Pacific/Tongatapu|Pacific/Kanton"],"countries":["AD|Europe/Andorra","AE|Asia/Dubai","AF|Asia/Kabul","AG|America/Puerto_Rico America/Antigua","AI|America/Puerto_Rico America/Anguilla","AL|Europe/Tirane","AM|Asia/Yerevan","AO|Africa/Lagos Africa/Luanda","AQ|Antarctica/Casey Antarctica/Davis Antarctica/Mawson Antarctica/Palmer Antarctica/Rothera Antarctica/Troll Asia/Urumqi Pacific/Auckland Pacific/Port_Moresby Asia/Riyadh Antarctica/McMurdo Antarctica/DumontDUrville Antarctica/Syowa Antarctica/Vostok","AR|America/Argentina/Buenos_Aires America/Argentina/Cordoba America/Argentina/Salta America/Argentina/Jujuy America/Argentina/Tucuman America/Argentina/Catamarca America/Argentina/La_Rioja America/Argentina/San_Juan America/Argentina/Mendoza America/Argentina/San_Luis America/Argentina/Rio_Gallegos America/Argentina/Ushuaia","AS|Pacific/Pago_Pago","AT|Europe/Vienna","AU|Australia/Lord_Howe Antarctica/Macquarie Australia/Hobart Australia/Melbourne Australia/Sydney Australia/Broken_Hill Australia/Brisbane Australia/Lindeman Australia/Adelaide Australia/Darwin Australia/Perth Australia/Eucla","AW|America/Puerto_Rico America/Aruba","AX|Europe/Helsinki Europe/Mariehamn","AZ|Asia/Baku","BA|Europe/Belgrade Europe/Sarajevo","BB|America/Barbados","BD|Asia/Dhaka","BE|Europe/Brussels","BF|Africa/Abidjan Africa/Ouagadougou","BG|Europe/Sofia","BH|Asia/Qatar Asia/Bahrain","BI|Africa/Maputo Africa/Bujumbura","BJ|Africa/Lagos Africa/Porto-Novo","BL|America/Puerto_Rico America/St_Barthelemy","BM|Atlantic/Bermuda","BN|Asia/Kuching Asia/Brunei","BO|America/La_Paz","BQ|America/Puerto_Rico America/Kralendijk","BR|America/Noronha America/Belem America/Fortaleza America/Recife America/Araguaina America/Maceio America/Bahia America/Sao_Paulo America/Campo_Grande America/Cuiaba America/Santarem America/Porto_Velho America/Boa_Vista America/Manaus America/Eirunepe America/Rio_Branco","BS|America/Toronto America/Nassau","BT|Asia/Thimphu","BW|Africa/Maputo Africa/Gaborone","BY|Europe/Minsk","BZ|America/Belize","CA|America/St_Johns America/Halifax America/Glace_Bay America/Moncton America/Goose_Bay America/Toronto America/Iqaluit America/Winnipeg America/Resolute America/Rankin_Inlet America/Regina America/Swift_Current America/Edmonton America/Cambridge_Bay America/Yellowknife America/Inuvik America/Dawson_Creek America/Fort_Nelson America/Whitehorse America/Dawson America/Vancouver America/Panama America/Puerto_Rico America/Phoenix America/Blanc-Sablon America/Atikokan America/Creston","CC|Asia/Yangon Indian/Cocos","CD|Africa/Maputo Africa/Lagos Africa/Kinshasa Africa/Lubumbashi","CF|Africa/Lagos Africa/Bangui","CG|Africa/Lagos Africa/Brazzaville","CH|Europe/Zurich","CI|Africa/Abidjan","CK|Pacific/Rarotonga","CL|America/Santiago America/Punta_Arenas Pacific/Easter","CM|Africa/Lagos Africa/Douala","CN|Asia/Shanghai Asia/Urumqi","CO|America/Bogota","CR|America/Costa_Rica","CU|America/Havana","CV|Atlantic/Cape_Verde","CW|America/Puerto_Rico America/Curacao","CX|Asia/Bangkok Indian/Christmas","CY|Asia/Nicosia Asia/Famagusta","CZ|Europe/Prague","DE|Europe/Zurich Europe/Berlin Europe/Busingen","DJ|Africa/Nairobi Africa/Djibouti","DK|Europe/Berlin Europe/Copenhagen","DM|America/Puerto_Rico America/Dominica","DO|America/Santo_Domingo","DZ|Africa/Algiers","EC|America/Guayaquil Pacific/Galapagos","EE|Europe/Tallinn","EG|Africa/Cairo","EH|Africa/El_Aaiun","ER|Africa/Nairobi Africa/Asmara","ES|Europe/Madrid Africa/Ceuta Atlantic/Canary","ET|Africa/Nairobi Africa/Addis_Ababa","FI|Europe/Helsinki","FJ|Pacific/Fiji","FK|Atlantic/Stanley","FM|Pacific/Kosrae Pacific/Port_Moresby Pacific/Guadalcanal Pacific/Chuuk Pacific/Pohnpei","FO|Atlantic/Faroe","FR|Europe/Paris","GA|Africa/Lagos Africa/Libreville","GB|Europe/London","GD|America/Puerto_Rico America/Grenada","GE|Asia/Tbilisi","GF|America/Cayenne","GG|Europe/London Europe/Guernsey","GH|Africa/Abidjan Africa/Accra","GI|Europe/Gibraltar","GL|America/Nuuk America/Danmarkshavn America/Scoresbysund America/Thule","GM|Africa/Abidjan Africa/Banjul","GN|Africa/Abidjan Africa/Conakry","GP|America/Puerto_Rico America/Guadeloupe","GQ|Africa/Lagos Africa/Malabo","GR|Europe/Athens","GS|Atlantic/South_Georgia","GT|America/Guatemala","GU|Pacific/Guam","GW|Africa/Bissau","GY|America/Guyana","HK|Asia/Hong_Kong","HN|America/Tegucigalpa","HR|Europe/Belgrade Europe/Zagreb","HT|America/Port-au-Prince","HU|Europe/Budapest","ID|Asia/Jakarta Asia/Pontianak Asia/Makassar Asia/Jayapura","IE|Europe/Dublin","IL|Asia/Jerusalem","IM|Europe/London Europe/Isle_of_Man","IN|Asia/Kolkata","IO|Indian/Chagos","IQ|Asia/Baghdad","IR|Asia/Tehran","IS|Africa/Abidjan Atlantic/Reykjavik","IT|Europe/Rome","JE|Europe/London Europe/Jersey","JM|America/Jamaica","JO|Asia/Amman","JP|Asia/Tokyo","KE|Africa/Nairobi","KG|Asia/Bishkek","KH|Asia/Bangkok Asia/Phnom_Penh","KI|Pacific/Tarawa Pacific/Kanton Pacific/Kiritimati","KM|Africa/Nairobi Indian/Comoro","KN|America/Puerto_Rico America/St_Kitts","KP|Asia/Pyongyang","KR|Asia/Seoul","KW|Asia/Riyadh Asia/Kuwait","KY|America/Panama America/Cayman","KZ|Asia/Almaty Asia/Qyzylorda Asia/Qostanay Asia/Aqtobe Asia/Aqtau Asia/Atyrau Asia/Oral","LA|Asia/Bangkok Asia/Vientiane","LB|Asia/Beirut","LC|America/Puerto_Rico America/St_Lucia","LI|Europe/Zurich Europe/Vaduz","LK|Asia/Colombo","LR|Africa/Monrovia","LS|Africa/Johannesburg Africa/Maseru","LT|Europe/Vilnius","LU|Europe/Brussels Europe/Luxembourg","LV|Europe/Riga","LY|Africa/Tripoli","MA|Africa/Casablanca","MC|Europe/Paris Europe/Monaco","MD|Europe/Chisinau","ME|Europe/Belgrade Europe/Podgorica","MF|America/Puerto_Rico America/Marigot","MG|Africa/Nairobi Indian/Antananarivo","MH|Pacific/Tarawa Pacific/Kwajalein Pacific/Majuro","MK|Europe/Belgrade Europe/Skopje","ML|Africa/Abidjan Africa/Bamako","MM|Asia/Yangon","MN|Asia/Ulaanbaatar Asia/Hovd Asia/Choibalsan","MO|Asia/Macau","MP|Pacific/Guam Pacific/Saipan","MQ|America/Martinique","MR|Africa/Abidjan Africa/Nouakchott","MS|America/Puerto_Rico America/Montserrat","MT|Europe/Malta","MU|Indian/Mauritius","MV|Indian/Maldives","MW|Africa/Maputo Africa/Blantyre","MX|America/Mexico_City America/Cancun America/Merida America/Monterrey America/Matamoros America/Chihuahua America/Ciudad_Juarez America/Ojinaga America/Mazatlan America/Bahia_Banderas America/Hermosillo America/Tijuana","MY|Asia/Kuching Asia/Singapore Asia/Kuala_Lumpur","MZ|Africa/Maputo","NA|Africa/Windhoek","NC|Pacific/Noumea","NE|Africa/Lagos Africa/Niamey","NF|Pacific/Norfolk","NG|Africa/Lagos","NI|America/Managua","NL|Europe/Brussels Europe/Amsterdam","NO|Europe/Berlin Europe/Oslo","NP|Asia/Kathmandu","NR|Pacific/Nauru","NU|Pacific/Niue","NZ|Pacific/Auckland Pacific/Chatham","OM|Asia/Dubai Asia/Muscat","PA|America/Panama","PE|America/Lima","PF|Pacific/Tahiti Pacific/Marquesas Pacific/Gambier","PG|Pacific/Port_Moresby Pacific/Bougainville","PH|Asia/Manila","PK|Asia/Karachi","PL|Europe/Warsaw","PM|America/Miquelon","PN|Pacific/Pitcairn","PR|America/Puerto_Rico","PS|Asia/Gaza Asia/Hebron","PT|Europe/Lisbon Atlantic/Madeira Atlantic/Azores","PW|Pacific/Palau","PY|America/Asuncion","QA|Asia/Qatar","RE|Asia/Dubai Indian/Reunion","RO|Europe/Bucharest","RS|Europe/Belgrade","RU|Europe/Kaliningrad Europe/Moscow Europe/Simferopol Europe/Kirov Europe/Volgograd Europe/Astrakhan Europe/Saratov Europe/Ulyanovsk Europe/Samara Asia/Yekaterinburg Asia/Omsk Asia/Novosibirsk Asia/Barnaul Asia/Tomsk Asia/Novokuznetsk Asia/Krasnoyarsk Asia/Irkutsk Asia/Chita Asia/Yakutsk Asia/Khandyga Asia/Vladivostok Asia/Ust-Nera Asia/Magadan Asia/Sakhalin Asia/Srednekolymsk Asia/Kamchatka Asia/Anadyr","RW|Africa/Maputo Africa/Kigali","SA|Asia/Riyadh","SB|Pacific/Guadalcanal","SC|Asia/Dubai Indian/Mahe","SD|Africa/Khartoum","SE|Europe/Berlin Europe/Stockholm","SG|Asia/Singapore","SH|Africa/Abidjan Atlantic/St_Helena","SI|Europe/Belgrade Europe/Ljubljana","SJ|Europe/Berlin Arctic/Longyearbyen","SK|Europe/Prague Europe/Bratislava","SL|Africa/Abidjan Africa/Freetown","SM|Europe/Rome Europe/San_Marino","SN|Africa/Abidjan Africa/Dakar","SO|Africa/Nairobi Africa/Mogadishu","SR|America/Paramaribo","SS|Africa/Juba","ST|Africa/Sao_Tome","SV|America/El_Salvador","SX|America/Puerto_Rico America/Lower_Princes","SY|Asia/Damascus","SZ|Africa/Johannesburg Africa/Mbabane","TC|America/Grand_Turk","TD|Africa/Ndjamena","TF|Asia/Dubai Indian/Maldives Indian/Kerguelen","TG|Africa/Abidjan Africa/Lome","TH|Asia/Bangkok","TJ|Asia/Dushanbe","TK|Pacific/Fakaofo","TL|Asia/Dili","TM|Asia/Ashgabat","TN|Africa/Tunis","TO|Pacific/Tongatapu","TR|Europe/Istanbul","TT|America/Puerto_Rico America/Port_of_Spain","TV|Pacific/Tarawa Pacific/Funafuti","TW|Asia/Taipei","TZ|Africa/Nairobi Africa/Dar_es_Salaam","UA|Europe/Simferopol Europe/Kyiv","UG|Africa/Nairobi Africa/Kampala","UM|Pacific/Pago_Pago Pacific/Tarawa Pacific/Honolulu Pacific/Midway Pacific/Wake","US|America/New_York America/Detroit America/Kentucky/Louisville America/Kentucky/Monticello America/Indiana/Indianapolis America/Indiana/Vincennes America/Indiana/Winamac America/Indiana/Marengo America/Indiana/Petersburg America/Indiana/Vevay America/Chicago America/Indiana/Tell_City America/Indiana/Knox America/Menominee America/North_Dakota/Center America/North_Dakota/New_Salem America/North_Dakota/Beulah America/Denver America/Boise America/Phoenix America/Los_Angeles America/Anchorage America/Juneau America/Sitka America/Metlakatla America/Yakutat America/Nome America/Adak Pacific/Honolulu","UY|America/Montevideo","UZ|Asia/Samarkand Asia/Tashkent","VA|Europe/Rome Europe/Vatican","VC|America/Puerto_Rico America/St_Vincent","VE|America/Caracas","VG|America/Puerto_Rico America/Tortola","VI|America/Puerto_Rico America/St_Thomas","VN|Asia/Bangkok Asia/Ho_Chi_Minh","VU|Pacific/Efate","WF|Pacific/Tarawa Pacific/Wallis","WS|Pacific/Apia","YE|Asia/Riyadh Asia/Aden","YT|Africa/Nairobi Indian/Mayotte","ZA|Africa/Johannesburg","ZM|Africa/Maputo Africa/Lusaka","ZW|Africa/Maputo Africa/Harare"]}')
        }
    },
        e = {};

    function i(r) {
        var n = e[r];
        if (void 0 !== n) return n.exports;
        var a = e[r] = {
            id: r,
            loaded: !1,
            exports: {}
        };
        return t[r].call(a.exports, a, a.exports, i), a.loaded = !0, a.exports
    }
    i.amdO = {}, i.n = t => {
        var e = t && t.__esModule ? () => t.default : () => t;
        return i.d(e, {
            a: e
        }), e
    }, i.d = (t, e) => {
        for (var r in e) i.o(e, r) && !i.o(t, r) && Object.defineProperty(t, r, {
            enumerable: !0,
            get: e[r]
        })
    }, i.o = (t, e) => Object.prototype.hasOwnProperty.call(t, e), i.r = t => {
        "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(t, Symbol.toStringTag, {
            value: "Module"
        }), Object.defineProperty(t, "__esModule", {
            value: !0
        })
    }, i.nmd = t => (t.paths = [], t.children || (t.children = []), t), (() => {
        "use strict";
        var t = {};

        function e(t, e) {
            (null == e || e > t.length) && (e = t.length);
            for (var i = 0, r = new Array(e); i < e; i++) r[i] = t[i];
            return r
        }

        function r(t) {
            return function (t) {
                if (Array.isArray(t)) return e(t)
            }(t) || function (t) {
                if ("undefined" != typeof Symbol && null != t[Symbol.iterator] || null != t["@@iterator"]) return Array.from(t)
            }(t) || function (t, i) {
                if (t) {
                    if ("string" == typeof t) return e(t, i);
                    var r = Object.prototype.toString.call(t).slice(8, -1);
                    return "Object" === r && t.constructor && (r = t.constructor.name), "Map" === r || "Set" === r ? Array.from(t) : "Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? e(t, i) : void 0
                }
            }(t) || function () {
                throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")
            }()
        }

        function n(t, e) {
            if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function")
        }

        function a(t) {
            return a = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
                return typeof t
            } : function (t) {
                return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t
            }, a(t)
        }

        function s(t) {
            var e = function (t, e) {
                if ("object" !== a(t) || null === t) return t;
                var i = t[Symbol.toPrimitive];
                if (void 0 !== i) {
                    var r = i.call(t, e || "default");
                    if ("object" !== a(r)) return r;
                    throw new TypeError("@@toPrimitive must return a primitive value.")
                }
                return ("string" === e ? String : Number)(t)
            }(t, "string");
            return "symbol" === a(e) ? e : String(e)
        }

        function o(t, e) {
            for (var i = 0; i < e.length; i++) {
                var r = e[i];
                r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, s(r.key), r)
            }
        }

        function l(t, e, i) {
            return e && o(t.prototype, e), i && o(t, i), Object.defineProperty(t, "prototype", {
                writable: !1
            }), t
        }
        i.r(t), i.d(t, {
            Fade: () => Dn,
            FixedAddToCartEntrance: () => On,
            FixedAddToCartExit: () => In,
            Global: () => zn,
            ImagesOnBoundary: () => Nn,
            StaggerFade: () => Vn
        });
        const c = function () {
            function t() {
                n(this, t), this.linkParse(), document.addEventListener("keydown", this.focusElements)
            }
            return l(t, [{
                key: "addTabbing",
                value: function () { }
            }, {
                key: "focusElements",
                value: function (t) {
                    "Tab" == t.key && console.log("might not need to measure tabbing")
                }
            }, {
                key: "linkParse",
                value: function () {
                    r(document.getElementsByTagName("a")).forEach((function (t) {
                        if (!(t.href.indexOf(window.location.hostname) > -1)) {
                            var e = (t.getAttribute("rel") || "").split(" ");
                            e.push("noopener", "noreferrer"), t.setAttribute("rel", r(new Set(e)).join(" ")), "_blank" != t.target && (t.target = "_blank"), t.insertAdjacentHTML("beforeend", '<span class="visually-hidden hidden">(opens in a new tab)</span>')
                        }
                    }))
                }
            }]), t
        }();

        function u(t, e) {
            return u = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) {
                return t.__proto__ = e, t
            }, u(t, e)
        }

        function h(t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
            t.prototype = Object.create(e && e.prototype, {
                constructor: {
                    value: t,
                    writable: !0,
                    configurable: !0
                }
            }), Object.defineProperty(t, "prototype", {
                writable: !1
            }), e && u(t, e)
        }

        function d(t) {
            if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return t
        }

        function p(t, e) {
            if (e && ("object" === a(e) || "function" == typeof e)) return e;
            if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
            return d(t)
        }

        function f(t) {
            return f = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) {
                return t.__proto__ || Object.getPrototypeOf(t)
            }, f(t)
        }

        function m(t, e, i, r, n, a, s) {
            try {
                var o = t[a](s),
                    l = o.value
            } catch (t) {
                return void i(t)
            }
            o.done ? e(l) : Promise.resolve(l).then(r, n)
        }

        function g(t) {
            return function () {
                var e = this,
                    i = arguments;
                return new Promise((function (r, n) {
                    var a = t.apply(e, i);

                    function s(t) {
                        m(a, r, n, s, o, "next", t)
                    }

                    function o(t) {
                        m(a, r, n, s, o, "throw", t)
                    }
                    s(void 0)
                }))
            }
        }
        var v = i(687),
            y = i.n(v);

        function b() {
            return _.apply(this, arguments)
        }

        function _() {
            return _ = g(y().mark((function t() {
                return y().wrap((function (t) {
                    for (; ;) switch (t.prev = t.next) {
                        case 0:
                            fetch("/cart.json", {
                                method: "get"
                            }).then((function (t) {
                                return t.json()
                            })).then((function (t) {
                                var e = {
                                    count: t.item_count,
                                    discount: t.total_discount,
                                    subtotal: t.items_subtotal_price,
                                    total: t.total_price,
                                    shipping: t.total_price
                                };
                                return window.Zero.Cart.stats.count !== e.count && (window.Zero.Cart.stats.count = e.count), window.Zero.Cart.stats.discount !== e.discount && (window.Zero.Cart.stats.discount = e.discount), window.Zero.Cart.stats.subtotal !== e.subtotal && (window.Zero.Cart.stats.subtotal = e.subtotal), window.Zero.Cart.stats.total !== e.total && (window.Zero.Cart.stats.total = e.total), window.Zero.Cart.stats.shipping !== e.shipping && (window.Zero.Cart.stats.shipping = e.shipping), t
                            })).catch((function (t) {
                                console.error(t)
                            }));
                        case 1:
                        case "end":
                            return t.stop()
                    }
                }), t)
            }))), _.apply(this, arguments)
        }
        var w, A = function (t) {
            k("[data-display-quantity]", t, !0)
        },
            S = function (t) {
                var e = document.getElementById("shipping-tracker-bar");
                e.dataset.total = t;
                var i = parseInt(e.dataset.threshold, 10),
                    r = i - t;
                if (r <= 0) {
                    document.querySelector("shipping-tracker .amount-tracker").classList.add("hidden"), document.querySelector("shipping-tracker .success-state").classList.remove("hidden"), document.querySelector("#shipping-total").style.display = "flex";
                    var n = "".concat(Math.min(t / i * 100, 100.1), "%");
                    e.style.width = n
                } else {
                    document.querySelector("shipping-tracker .amount-tracker").classList.remove("hidden"), document.querySelector("shipping-tracker .success-state").classList.add("hidden"), document.querySelector("shipping-tracker .display-difference").innerHTML = "$".concat((r / 100).toFixed(2));
                    var a = "".concat(t / i * 100, "%");
                    e.style.width = a
                }
            },
            k = function (t, e) {
                var i = arguments.length > 2 && void 0 !== arguments[2] && arguments[2];
                Array.prototype.slice.call(document.querySelectorAll(t)).forEach((function (t) {
                    "little-cart-heart" !== t.id && (i && e > 0 && t.classList.remove("hidden"), i && 0 === e && "undefined" === t.getAttribute("data-display-quantity") && t.classList.add("hidden"), void 0 === t.dataset.noTrailing ? t.dataset.sup && "true" == t.dataset.sup ? t.innerHTML = "".concat(e.slice(0, -2), "<sup>").concat(e.slice(-2), "</sup> ").concat(t.dataset.currency ? t.dataset.currency : "") : t.textContent = e : t.innerHTML = e.slice(0, -3))
                }))
            },
            x = void 0,
            T = function (t) {
                var e, i = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 300;
                return function () {
                    for (var r = arguments.length, n = new Array(r), a = 0; a < r; a++) n[a] = arguments[a];
                    clearTimeout(e), e = setTimeout((function () {
                        return t.apply(x, n)
                    }), i)
                }
            },
            E = function (t) {
                if ("escape" === t.code.toLowerCase()) {
                    var e = t.target.closest("details");
                    if (e) {
                        var i = e.querySelector("summary");
                        try {
                            e.parentElement.toggleDrawer(!1)
                        } catch (t) {
                            console.log(t), e.removeAttribute("open")
                        }
                        i.setAttribute("aria-expanded", !1), i.focus()
                    }
                }
            },
            M = document.querySelector("body");
        const C = function () {
            w = D(), document.documentElement.style.setProperty("--scrollbar", "".concat(w.offsetWidth - w.clientWidth, "px")), M.classList.add("locked")
        },
            P = function () {
                document.documentElement.style.setProperty("--scrollbar", "0px"), M.classList.remove("locked"), w.remove()
            };
        var D = function () {
            var t = document.createElement("textarea");
            return Object.assign(t.style, {
                "overflow-y": "scroll",
                "overflow-x": "hidden",
                border: "none",
                outline: "none",
                resize: "none",
                position: "fixed",
                "pointer-events": "none",
                background: "none",
                top: "0",
                bottom: "0",
                right: "0",
                "z-index": "99999999999",
                width: "0px"
            }), document.body.appendChild(t), t
        },
            L = {
                threshold: [0, .3]
            },
            O = L.threshold[1] ? L.threshold[1] : L.threshold[0],
            I = function (t, e) {
                t.forEach((function (t) {
                    t.intersectionRatio >= O && t.isIntersecting && (!1 !== t.target.hasEntered && t.target.hasEntered || t.target.dispatchEvent(window.Zero.dispatches.enter), t.target.hasEntered = !0), t.isIntersecting || !0 !== t.target.hasEntered || (!0 === t.target.resetOnExit && (t.target.hasEntered = !1), t.target.dispatchEvent(window.Zero.dispatches.exit))
                }))
            },
            R = function () {
                return new IntersectionObserver(I, L)
            };
        const F = function (t) {
            var e = document.createElement("template");
            return t = t.trim(), e.innerHTML = t, e.content.firstChild
        };
        var N = function () {
            function t(e) {
                n(this, t), this.element = e, this.element.resetOnExit = !1, this.type = this.element.dataset.animation ? this.element.dataset.animation : "default", this.trigger = this.element.dataset.trigger ? this.element.dataset.trigger : "observe", window.Zero.observer = window.Zero.observer || R(), window.Zero.events = window.Zero.events || {}, window.Zero.events.observed = window.Zero.events.observed || [], this.bindings(this.element), this.setDefault && this.setDefault()
            }
            return l(t, [{
                key: "bindings",
                value: function () {
                    (this.onViewportEnter || this.onViewportExit) && (window.Zero.events.observed.push(this.element), window.Zero.observer.observe(this.element)), this.onViewportEnter && this.element.addEventListener("viewportEnter", this.onViewportEnter.bind(this)), this.onViewportExit && this.element.addEventListener("viewportExit", this.onViewportExit.bind(this))
                }
            }, {
                key: "run",
                value: function () {
                    var t = this,
                        e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : null;
                    this.promise = new Promise((function (e) {
                        t.animate && t.animate({
                            done: e
                        })
                    })), e && this.promise.then(e)
                }
            }]), t
        }();

        function B(t) {
            if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return t
        }

        function z(t, e) {
            t.prototype = Object.create(e.prototype), t.prototype.constructor = t, t.__proto__ = e
        }
        var q, V, Y, j, G, H, W, Z, $, U, X, K, J, Q, tt, et = {
            autoSleep: 120,
            force3D: "auto",
            nullTargetWarn: 1,
            units: {
                lineHeight: ""
            }
        },
            it = {
                duration: .5,
                overwrite: !1,
                delay: 0
            },
            rt = 1e8,
            nt = 1e-8,
            at = 2 * Math.PI,
            st = at / 4,
            ot = 0,
            lt = Math.sqrt,
            ct = Math.cos,
            ut = Math.sin,
            ht = function (t) {
                return "string" == typeof t
            },
            dt = function (t) {
                return "function" == typeof t
            },
            pt = function (t) {
                return "number" == typeof t
            },
            ft = function (t) {
                return void 0 === t
            },
            mt = function (t) {
                return "object" == typeof t
            },
            gt = function (t) {
                return !1 !== t
            },
            vt = function () {
                return "undefined" != typeof window
            },
            yt = function (t) {
                return dt(t) || ht(t)
            },
            bt = "function" == typeof ArrayBuffer && ArrayBuffer.isView || function () { },
            _t = Array.isArray,
            wt = /(?:-?\.?\d|\.)+/gi,
            At = /[-+=.]*\d+[.e\-+]*\d*[e\-+]*\d*/g,
            St = /[-+=.]*\d+[.e-]*\d*[a-z%]*/g,
            kt = /[-+=.]*\d+\.?\d*(?:e-|e\+)?\d*/gi,
            xt = /[+-]=-?[.\d]+/,
            Tt = /[^,'"\[\]\s]+/gi,
            Et = /^[+\-=e\s\d]*\d+[.\d]*([a-z]*|%)\s*$/i,
            Mt = {},
            Ct = {},
            Pt = function (t) {
                return (Ct = ae(t, Mt)) && ar
            },
            Dt = function (t, e) {
                return console.warn("Invalid property", t, "set to", e, "Missing plugin? gsap.registerPlugin()")
            },
            Lt = function (t, e) {
                return !e && console.warn(t)
            },
            Ot = function (t, e) {
                return t && (Mt[t] = e) && Ct && (Ct[t] = e) || Mt
            },
            It = function () {
                return 0
            },
            Rt = {
                suppressEvents: !0,
                isStart: !0,
                kill: !1
            },
            Ft = {
                suppressEvents: !0,
                kill: !1
            },
            Nt = {
                suppressEvents: !0
            },
            Bt = {},
            zt = [],
            qt = {},
            Vt = {},
            Yt = {},
            jt = 30,
            Gt = [],
            Ht = "",
            Wt = function (t) {
                var e, i, r = t[0];
                if (mt(r) || dt(r) || (t = [t]), !(e = (r._gsap || {}).harness)) {
                    for (i = Gt.length; i-- && !Gt[i].targetTest(r););
                    e = Gt[i]
                }
                for (i = t.length; i--;) t[i] && (t[i]._gsap || (t[i]._gsap = new _i(t[i], e))) || t.splice(i, 1);
                return t
            },
            Zt = function (t) {
                return t._gsap || Wt(Be(t))[0]._gsap
            },
            $t = function (t, e, i) {
                return (i = t[e]) && dt(i) ? t[e]() : ft(i) && t.getAttribute && t.getAttribute(e) || i
            },
            Ut = function (t, e) {
                return (t = t.split(",")).forEach(e) || t
            },
            Xt = function (t) {
                return Math.round(1e5 * t) / 1e5 || 0
            },
            Kt = function (t) {
                return Math.round(1e7 * t) / 1e7 || 0
            },
            Jt = function (t, e) {
                var i = e.charAt(0),
                    r = parseFloat(e.substr(2));
                return t = parseFloat(t), "+" === i ? t + r : "-" === i ? t - r : "*" === i ? t * r : t / r
            },
            Qt = function (t, e) {
                for (var i = e.length, r = 0; t.indexOf(e[r]) < 0 && ++r < i;);
                return r < i
            },
            te = function () {
                var t, e, i = zt.length,
                    r = zt.slice(0);
                for (qt = {}, zt.length = 0, t = 0; t < i; t++)(e = r[t]) && e._lazy && (e.render(e._lazy[0], e._lazy[1], !0)._lazy = 0)
            },
            ee = function (t, e, i, r) {
                zt.length && !V && te(), t.render(e, i, r || V && e < 0 && (t._initted || t._startAt)), zt.length && !V && te()
            },
            ie = function (t) {
                var e = parseFloat(t);
                return (e || 0 === e) && (t + "").match(Tt).length < 2 ? e : ht(t) ? t.trim() : t
            },
            re = function (t) {
                return t
            },
            ne = function (t, e) {
                for (var i in e) i in t || (t[i] = e[i]);
                return t
            },
            ae = function (t, e) {
                for (var i in e) t[i] = e[i];
                return t
            },
            se = function t(e, i) {
                for (var r in i) "__proto__" !== r && "constructor" !== r && "prototype" !== r && (e[r] = mt(i[r]) ? t(e[r] || (e[r] = {}), i[r]) : i[r]);
                return e
            },
            oe = function (t, e) {
                var i, r = {};
                for (i in t) i in e || (r[i] = t[i]);
                return r
            },
            le = function (t) {
                var e, i = t.parent || j,
                    r = t.keyframes ? (e = _t(t.keyframes), function (t, i) {
                        for (var r in i) r in t || "duration" === r && e || "ease" === r || (t[r] = i[r])
                    }) : ne;
                if (gt(t.inherit))
                    for (; i;) r(t, i.vars.defaults), i = i.parent || i._dp;
                return t
            },
            ce = function (t, e, i, r, n) {
                void 0 === i && (i = "_first"), void 0 === r && (r = "_last");
                var a, s = t[r];
                if (n)
                    for (a = e[n]; s && s[n] > a;) s = s._prev;
                return s ? (e._next = s._next, s._next = e) : (e._next = t[i], t[i] = e), e._next ? e._next._prev = e : t[r] = e, e._prev = s, e.parent = e._dp = t, e
            },
            ue = function (t, e, i, r) {
                void 0 === i && (i = "_first"), void 0 === r && (r = "_last");
                var n = e._prev,
                    a = e._next;
                n ? n._next = a : t[i] === e && (t[i] = a), a ? a._prev = n : t[r] === e && (t[r] = n), e._next = e._prev = e.parent = null
            },
            he = function (t, e) {
                t.parent && (!e || t.parent.autoRemoveChildren) && t.parent.remove(t), t._act = 0
            },
            de = function (t, e) {
                if (t && (!e || e._end > t._dur || e._start < 0))
                    for (var i = t; i;) i._dirty = 1, i = i.parent;
                return t
            },
            pe = function (t) {
                for (var e = t.parent; e && e.parent;) e._dirty = 1, e.totalDuration(), e = e.parent;
                return t
            },
            fe = function (t, e, i, r) {
                return t._startAt && (V ? t._startAt.revert(Ft) : t.vars.immediateRender && !t.vars.autoRevert || t._startAt.render(e, !0, r))
            },
            me = function t(e) {
                return !e || e._ts && t(e.parent)
            },
            ge = function (t) {
                return t._repeat ? ve(t._tTime, t = t.duration() + t._rDelay) * t : 0
            },
            ve = function (t, e) {
                var i = Math.floor(t /= e);
                return t && i === t ? i - 1 : i
            },
            ye = function (t, e) {
                return (t - e._start) * e._ts + (e._ts >= 0 ? 0 : e._dirty ? e.totalDuration() : e._tDur)
            },
            be = function (t) {
                return t._end = Kt(t._start + (t._tDur / Math.abs(t._ts || t._rts || nt) || 0))
            },
            _e = function (t, e) {
                var i = t._dp;
                return i && i.smoothChildTiming && t._ts && (t._start = Kt(i._time - (t._ts > 0 ? e / t._ts : ((t._dirty ? t.totalDuration() : t._tDur) - e) / -t._ts)), be(t), i._dirty || de(i, t)), t
            },
            we = function (t, e) {
                var i;
                if ((e._time || e._initted && !e._dur) && (i = ye(t.rawTime(), e), (!e._dur || Oe(0, e.totalDuration(), i) - e._tTime > nt) && e.render(i, !0)), de(t, e)._dp && t._initted && t._time >= t._dur && t._ts) {
                    if (t._dur < t.duration())
                        for (i = t; i._dp;) i.rawTime() >= 0 && i.totalTime(i._tTime), i = i._dp;
                    t._zTime = -1e-8
                }
            },
            Ae = function (t, e, i, r) {
                return e.parent && he(e), e._start = Kt((pt(i) ? i : i || t !== j ? Pe(t, i, e) : t._time) + e._delay), e._end = Kt(e._start + (e.totalDuration() / Math.abs(e.timeScale()) || 0)), ce(t, e, "_first", "_last", t._sort ? "_start" : 0), Te(e) || (t._recent = e), r || we(t, e), t._ts < 0 && _e(t, t._tTime), t
            },
            Se = function (t, e) {
                return (Mt.ScrollTrigger || Dt("scrollTrigger", e)) && Mt.ScrollTrigger.create(e, t)
            },
            ke = function (t, e, i, r, n) {
                return Mi(t, e, n), t._initted ? !i && t._pt && !V && (t._dur && !1 !== t.vars.lazy || !t._dur && t.vars.lazy) && $ !== oi.frame ? (zt.push(t), t._lazy = [n, r], 1) : void 0 : 1
            },
            xe = function t(e) {
                var i = e.parent;
                return i && i._ts && i._initted && !i._lock && (i.rawTime() < 0 || t(i))
            },
            Te = function (t) {
                var e = t.data;
                return "isFromStart" === e || "isStart" === e
            },
            Ee = function (t, e, i, r) {
                var n = t._repeat,
                    a = Kt(e) || 0,
                    s = t._tTime / t._tDur;
                return s && !r && (t._time *= a / t._dur), t._dur = a, t._tDur = n ? n < 0 ? 1e10 : Kt(a * (n + 1) + t._rDelay * n) : a, s > 0 && !r && _e(t, t._tTime = t._tDur * s), t.parent && be(t), i || de(t.parent, t), t
            },
            Me = function (t) {
                return t instanceof Ai ? de(t) : Ee(t, t._dur)
            },
            Ce = {
                _start: 0,
                endTime: It,
                totalDuration: It
            },
            Pe = function t(e, i, r) {
                var n, a, s, o = e.labels,
                    l = e._recent || Ce,
                    c = e.duration() >= rt ? l.endTime(!1) : e._dur;
                return ht(i) && (isNaN(i) || i in o) ? (a = i.charAt(0), s = "%" === i.substr(-1), n = i.indexOf("="), "<" === a || ">" === a ? (n >= 0 && (i = i.replace(/=/, "")), ("<" === a ? l._start : l.endTime(l._repeat >= 0)) + (parseFloat(i.substr(1)) || 0) * (s ? (n < 0 ? l : r).totalDuration() / 100 : 1)) : n < 0 ? (i in o || (o[i] = c), o[i]) : (a = parseFloat(i.charAt(n - 1) + i.substr(n + 1)), s && r && (a = a / 100 * (_t(r) ? r[0] : r).totalDuration()), n > 1 ? t(e, i.substr(0, n - 1), r) + a : c + a)) : null == i ? c : +i
            },
            De = function (t, e, i) {
                var r, n, a = pt(e[1]),
                    s = (a ? 2 : 1) + (t < 2 ? 0 : 1),
                    o = e[s];
                if (a && (o.duration = e[1]), o.parent = i, t) {
                    for (r = o, n = i; n && !("immediateRender" in r);) r = n.vars.defaults || {}, n = gt(n.vars.inherit) && n.parent;
                    o.immediateRender = gt(r.immediateRender), t < 2 ? o.runBackwards = 1 : o.startAt = e[s - 1]
                }
                return new Oi(e[0], o, e[s + 1])
            },
            Le = function (t, e) {
                return t || 0 === t ? e(t) : e
            },
            Oe = function (t, e, i) {
                return i < t ? t : i > e ? e : i
            },
            Ie = function (t, e) {
                return ht(t) && (e = Et.exec(t)) ? e[1] : ""
            },
            Re = [].slice,
            Fe = function (t, e) {
                return t && mt(t) && "length" in t && (!e && !t.length || t.length - 1 in t && mt(t[0])) && !t.nodeType && t !== G
            },
            Ne = function (t, e, i) {
                return void 0 === i && (i = []), t.forEach((function (t) {
                    var r;
                    return ht(t) && !e || Fe(t, 1) ? (r = i).push.apply(r, Be(t)) : i.push(t)
                })) || i
            },
            Be = function (t, e, i) {
                return Y && !e && Y.selector ? Y.selector(t) : !ht(t) || i || !H && li() ? _t(t) ? Ne(t, i) : Fe(t) ? Re.call(t, 0) : t ? [t] : [] : Re.call((e || W).querySelectorAll(t), 0)
            },
            ze = function (t) {
                return t = Be(t)[0] || Lt("Invalid scope") || {},
                    function (e) {
                        var i = t.current || t.nativeElement || t;
                        return Be(e, i.querySelectorAll ? i : i === t ? Lt("Invalid scope") || W.createElement("div") : t)
                    }
            },
            qe = function (t) {
                return t.sort((function () {
                    return .5 - Math.random()
                }))
            },
            Ve = function (t) {
                if (dt(t)) return t;
                var e = mt(t) ? t : {
                    each: t
                },
                    i = mi(e.ease),
                    r = e.from || 0,
                    n = parseFloat(e.base) || 0,
                    a = {},
                    s = r > 0 && r < 1,
                    o = isNaN(r) || s,
                    l = e.axis,
                    c = r,
                    u = r;
                return ht(r) ? c = u = {
                    center: .5,
                    edges: .5,
                    end: 1
                }[r] || 0 : !s && o && (c = r[0], u = r[1]),
                    function (t, s, h) {
                        var d, p, f, m, g, v, y, b, _, w = (h || e).length,
                            A = a[w];
                        if (!A) {
                            if (!(_ = "auto" === e.grid ? 0 : (e.grid || [1, rt])[1])) {
                                for (y = -rt; y < (y = h[_++].getBoundingClientRect().left) && _ < w;);
                                _--
                            }
                            for (A = a[w] = [], d = o ? Math.min(_, w) * c - .5 : r % _, p = _ === rt ? 0 : o ? w * u / _ - .5 : r / _ | 0, y = 0, b = rt, v = 0; v < w; v++) f = v % _ - d, m = p - (v / _ | 0), A[v] = g = l ? Math.abs("y" === l ? m : f) : lt(f * f + m * m), g > y && (y = g), g < b && (b = g);
                            "random" === r && qe(A), A.max = y - b, A.min = b, A.v = w = (parseFloat(e.amount) || parseFloat(e.each) * (_ > w ? w - 1 : l ? "y" === l ? w / _ : _ : Math.max(_, w / _)) || 0) * ("edges" === r ? -1 : 1), A.b = w < 0 ? n - w : n, A.u = Ie(e.amount || e.each) || 0, i = i && w < 0 ? pi(i) : i
                        }
                        return w = (A[t] - A.min) / A.max || 0, Kt(A.b + (i ? i(w) : w) * A.v) + A.u
                    }
            },
            Ye = function (t) {
                var e = Math.pow(10, ((t + "").split(".")[1] || "").length);
                return function (i) {
                    var r = Kt(Math.round(parseFloat(i) / t) * t * e);
                    return (r - r % 1) / e + (pt(i) ? 0 : Ie(i))
                }
            },
            je = function (t, e) {
                var i, r, n = _t(t);
                return !n && mt(t) && (i = n = t.radius || rt, t.values ? (t = Be(t.values), (r = !pt(t[0])) && (i *= i)) : t = Ye(t.increment)), Le(e, n ? dt(t) ? function (e) {
                    return r = t(e), Math.abs(r - e) <= i ? r : e
                } : function (e) {
                    for (var n, a, s = parseFloat(r ? e.x : e), o = parseFloat(r ? e.y : 0), l = rt, c = 0, u = t.length; u--;)(n = r ? (n = t[u].x - s) * n + (a = t[u].y - o) * a : Math.abs(t[u] - s)) < l && (l = n, c = u);
                    return c = !i || l <= i ? t[c] : e, r || c === e || pt(e) ? c : c + Ie(e)
                } : Ye(t))
            },
            Ge = function (t, e, i, r) {
                return Le(_t(t) ? !e : !0 === i ? !!(i = 0) : !r, (function () {
                    return _t(t) ? t[~~(Math.random() * t.length)] : (i = i || 1e-5) && (r = i < 1 ? Math.pow(10, (i + "").length - 2) : 1) && Math.floor(Math.round((t - i / 2 + Math.random() * (e - t + .99 * i)) / i) * i * r) / r
                }))
            },
            He = function (t, e, i) {
                return Le(i, (function (i) {
                    return t[~~e(i)]
                }))
            },
            We = function (t) {
                for (var e, i, r, n, a = 0, s = ""; ~(e = t.indexOf("random(", a));) r = t.indexOf(")", e), n = "[" === t.charAt(e + 7), i = t.substr(e + 7, r - e - 7).match(n ? Tt : wt), s += t.substr(a, e - a) + Ge(n ? i : +i[0], n ? 0 : +i[1], +i[2] || 1e-5), a = r + 1;
                return s + t.substr(a, t.length - a)
            },
            Ze = function (t, e, i, r, n) {
                var a = e - t,
                    s = r - i;
                return Le(n, (function (e) {
                    return i + ((e - t) / a * s || 0)
                }))
            },
            $e = function (t, e, i) {
                var r, n, a, s = t.labels,
                    o = rt;
                for (r in s) (n = s[r] - e) < 0 == !!i && n && o > (n = Math.abs(n)) && (a = r, o = n);
                return a
            },
            Ue = function (t, e, i) {
                var r, n, a, s = t.vars,
                    o = s[e],
                    l = Y,
                    c = t._ctx;
                if (o) return r = s[e + "Params"], n = s.callbackScope || t, i && zt.length && te(), c && (Y = c), a = r ? o.apply(n, r) : o.call(n), Y = l, a
            },
            Xe = function (t) {
                return he(t), t.scrollTrigger && t.scrollTrigger.kill(!!V), t.progress() < 1 && Ue(t, "onInterrupt"), t
            },
            Ke = function (t) {
                var e = (t = !t.name && t.default || t).name,
                    i = dt(t),
                    r = e && !i && t.init ? function () {
                        this._props = []
                    } : t,
                    n = {
                        init: It,
                        render: Yi,
                        add: Ti,
                        kill: Gi,
                        modifier: ji,
                        rawVars: 0
                    },
                    a = {
                        targetTest: 0,
                        get: 0,
                        getSetter: Bi,
                        aliases: {},
                        register: 0
                    };
                if (li(), t !== r) {
                    if (Vt[e]) return;
                    ne(r, ne(oe(t, n), a)), ae(r.prototype, ae(n, oe(t, a))), Vt[r.prop = e] = r, t.targetTest && (Gt.push(r), Bt[e] = 1), e = ("css" === e ? "CSS" : e.charAt(0).toUpperCase() + e.substr(1)) + "Plugin"
                }
                Ot(e, r), t.register && t.register(ar, r, Zi)
            },
            Je = 255,
            Qe = {
                aqua: [0, Je, Je],
                lime: [0, Je, 0],
                silver: [192, 192, 192],
                black: [0, 0, 0],
                maroon: [128, 0, 0],
                teal: [0, 128, 128],
                blue: [0, 0, Je],
                navy: [0, 0, 128],
                white: [Je, Je, Je],
                olive: [128, 128, 0],
                yellow: [Je, Je, 0],
                orange: [Je, 165, 0],
                gray: [128, 128, 128],
                purple: [128, 0, 128],
                green: [0, 128, 0],
                red: [Je, 0, 0],
                pink: [Je, 192, 203],
                cyan: [0, Je, Je],
                transparent: [Je, Je, Je, 0]
            },
            ti = function (t, e, i) {
                return (6 * (t += t < 0 ? 1 : t > 1 ? -1 : 0) < 1 ? e + (i - e) * t * 6 : t < .5 ? i : 3 * t < 2 ? e + (i - e) * (2 / 3 - t) * 6 : e) * Je + .5 | 0
            },
            ei = function (t, e, i) {
                var r, n, a, s, o, l, c, u, h, d, p = t ? pt(t) ? [t >> 16, t >> 8 & Je, t & Je] : 0 : Qe.black;
                if (!p) {
                    if ("," === t.substr(-1) && (t = t.substr(0, t.length - 1)), Qe[t]) p = Qe[t];
                    else if ("#" === t.charAt(0)) {
                        if (t.length < 6 && (r = t.charAt(1), n = t.charAt(2), a = t.charAt(3), t = "#" + r + r + n + n + a + a + (5 === t.length ? t.charAt(4) + t.charAt(4) : "")), 9 === t.length) return [(p = parseInt(t.substr(1, 6), 16)) >> 16, p >> 8 & Je, p & Je, parseInt(t.substr(7), 16) / 255];
                        p = [(t = parseInt(t.substr(1), 16)) >> 16, t >> 8 & Je, t & Je]
                    } else if ("hsl" === t.substr(0, 3))
                        if (p = d = t.match(wt), e) {
                            if (~t.indexOf("=")) return p = t.match(At), i && p.length < 4 && (p[3] = 1), p
                        } else s = +p[0] % 360 / 360, o = +p[1] / 100, r = 2 * (l = +p[2] / 100) - (n = l <= .5 ? l * (o + 1) : l + o - l * o), p.length > 3 && (p[3] *= 1), p[0] = ti(s + 1 / 3, r, n), p[1] = ti(s, r, n), p[2] = ti(s - 1 / 3, r, n);
                    else p = t.match(wt) || Qe.transparent;
                    p = p.map(Number)
                }
                return e && !d && (r = p[0] / Je, n = p[1] / Je, a = p[2] / Je, l = ((c = Math.max(r, n, a)) + (u = Math.min(r, n, a))) / 2, c === u ? s = o = 0 : (h = c - u, o = l > .5 ? h / (2 - c - u) : h / (c + u), s = c === r ? (n - a) / h + (n < a ? 6 : 0) : c === n ? (a - r) / h + 2 : (r - n) / h + 4, s *= 60), p[0] = ~~(s + .5), p[1] = ~~(100 * o + .5), p[2] = ~~(100 * l + .5)), i && p.length < 4 && (p[3] = 1), p
            },
            ii = function (t) {
                var e = [],
                    i = [],
                    r = -1;
                return t.split(ni).forEach((function (t) {
                    var n = t.match(St) || [];
                    e.push.apply(e, n), i.push(r += n.length + 1)
                })), e.c = i, e
            },
            ri = function (t, e, i) {
                var r, n, a, s, o = "",
                    l = (t + o).match(ni),
                    c = e ? "hsla(" : "rgba(",
                    u = 0;
                if (!l) return t;
                if (l = l.map((function (t) {
                    return (t = ei(t, e, 1)) && c + (e ? t[0] + "," + t[1] + "%," + t[2] + "%," + t[3] : t.join(",")) + ")"
                })), i && (a = ii(t), (r = i.c).join(o) !== a.c.join(o)))
                    for (s = (n = t.replace(ni, "1").split(St)).length - 1; u < s; u++) o += n[u] + (~r.indexOf(u) ? l.shift() || c + "0,0,0,0)" : (a.length ? a : l.length ? l : i).shift());
                if (!n)
                    for (s = (n = t.split(ni)).length - 1; u < s; u++) o += n[u] + l[u];
                return o + n[s]
            },
            ni = function () {
                var t, e = "(?:\\b(?:(?:rgb|rgba|hsl|hsla)\\(.+?\\))|\\B#(?:[0-9a-f]{3,4}){1,2}\\b";
                for (t in Qe) e += "|" + t + "\\b";
                return new RegExp(e + ")", "gi")
            }(),
            ai = /hsl[a]?\(/,
            si = function (t) {
                var e, i = t.join(" ");
                if (ni.lastIndex = 0, ni.test(i)) return e = ai.test(i), t[1] = ri(t[1], e), t[0] = ri(t[0], e, ii(t[1])), !0
            },
            oi = function () {
                var t, e, i, r, n, a, s = Date.now,
                    o = 500,
                    l = 33,
                    c = s(),
                    u = c,
                    h = 1e3 / 240,
                    d = h,
                    p = [],
                    f = function i(f) {
                        var m, g, v, y, b = s() - u,
                            _ = !0 === f;
                        if (b > o && (c += b - l), ((m = (v = (u += b) - c) - d) > 0 || _) && (y = ++r.frame, n = v - 1e3 * r.time, r.time = v /= 1e3, d += m + (m >= h ? 4 : h - m), g = 1), _ || (t = e(i)), g)
                            for (a = 0; a < p.length; a++) p[a](v, n, y, f)
                    };
                return r = {
                    time: 0,
                    frame: 0,
                    tick: function () {
                        f(!0)
                    },
                    deltaRatio: function (t) {
                        return n / (1e3 / (t || 60))
                    },
                    wake: function () {
                        Z && (!H && vt() && (G = H = window, W = G.document || {}, Mt.gsap = ar, (G.gsapVersions || (G.gsapVersions = [])).push(ar.version), Pt(Ct || G.GreenSockGlobals || !G.gsap && G || {}), i = G.requestAnimationFrame), t && r.sleep(), e = i || function (t) {
                            return setTimeout(t, d - 1e3 * r.time + 1 | 0)
                        }, X = 1, f(2))
                    },
                    sleep: function () {
                        (i ? G.cancelAnimationFrame : clearTimeout)(t), X = 0, e = It
                    },
                    lagSmoothing: function (t, e) {
                        o = t || 1 / 0, l = Math.min(e || 33, o)
                    },
                    fps: function (t) {
                        h = 1e3 / (t || 240), d = 1e3 * r.time + h
                    },
                    add: function (t, e, i) {
                        var n = e ? function (e, i, a, s) {
                            t(e, i, a, s), r.remove(n)
                        } : t;
                        return r.remove(t), p[i ? "unshift" : "push"](n), li(), n
                    },
                    remove: function (t, e) {
                        ~(e = p.indexOf(t)) && p.splice(e, 1) && a >= e && a--
                    },
                    _listeners: p
                }, r
            }(),
            li = function () {
                return !X && oi.wake()
            },
            ci = {},
            ui = /^[\d.\-M][\d.\-,\s]/,
            hi = /["']/g,
            di = function (t) {
                for (var e, i, r, n = {}, a = t.substr(1, t.length - 3).split(":"), s = a[0], o = 1, l = a.length; o < l; o++) i = a[o], e = o !== l - 1 ? i.lastIndexOf(",") : i.length, r = i.substr(0, e), n[s] = isNaN(r) ? r.replace(hi, "").trim() : +r, s = i.substr(e + 1).trim();
                return n
            },
            pi = function (t) {
                return function (e) {
                    return 1 - t(1 - e)
                }
            },
            fi = function t(e, i) {
                for (var r, n = e._first; n;) n instanceof Ai ? t(n, i) : !n.vars.yoyoEase || n._yoyo && n._repeat || n._yoyo === i || (n.timeline ? t(n.timeline, i) : (r = n._ease, n._ease = n._yEase, n._yEase = r, n._yoyo = i)), n = n._next
            },
            mi = function (t, e) {
                return t && (dt(t) ? t : ci[t] || function (t) {
                    var e = (t + "").split("("),
                        i = ci[e[0]];
                    return i && e.length > 1 && i.config ? i.config.apply(null, ~t.indexOf("{") ? [di(e[1])] : function (t) {
                        var e = t.indexOf("(") + 1,
                            i = t.indexOf(")"),
                            r = t.indexOf("(", e);
                        return t.substring(e, ~r && r < i ? t.indexOf(")", i + 1) : i)
                    }(t).split(",").map(ie)) : ci._CE && ui.test(t) ? ci._CE("", t) : i
                }(t)) || e
            },
            gi = function (t, e, i, r) {
                void 0 === i && (i = function (t) {
                    return 1 - e(1 - t)
                }), void 0 === r && (r = function (t) {
                    return t < .5 ? e(2 * t) / 2 : 1 - e(2 * (1 - t)) / 2
                });
                var n, a = {
                    easeIn: e,
                    easeOut: i,
                    easeInOut: r
                };
                return Ut(t, (function (t) {
                    for (var e in ci[t] = Mt[t] = a, ci[n = t.toLowerCase()] = i, a) ci[n + ("easeIn" === e ? ".in" : "easeOut" === e ? ".out" : ".inOut")] = ci[t + "." + e] = a[e]
                })), a
            },
            vi = function (t) {
                return function (e) {
                    return e < .5 ? (1 - t(1 - 2 * e)) / 2 : .5 + t(2 * (e - .5)) / 2
                }
            },
            yi = function t(e, i, r) {
                var n = i >= 1 ? i : 1,
                    a = (r || (e ? .3 : .45)) / (i < 1 ? i : 1),
                    s = a / at * (Math.asin(1 / n) || 0),
                    o = function (t) {
                        return 1 === t ? 1 : n * Math.pow(2, -10 * t) * ut((t - s) * a) + 1
                    },
                    l = "out" === e ? o : "in" === e ? function (t) {
                        return 1 - o(1 - t)
                    } : vi(o);
                return a = at / a, l.config = function (i, r) {
                    return t(e, i, r)
                }, l
            },
            bi = function t(e, i) {
                void 0 === i && (i = 1.70158);
                var r = function (t) {
                    return t ? --t * t * ((i + 1) * t + i) + 1 : 0
                },
                    n = "out" === e ? r : "in" === e ? function (t) {
                        return 1 - r(1 - t)
                    } : vi(r);
                return n.config = function (i) {
                    return t(e, i)
                }, n
            };
        Ut("Linear,Quad,Cubic,Quart,Quint,Strong", (function (t, e) {
            var i = e < 5 ? e + 1 : e;
            gi(t + ",Power" + (i - 1), e ? function (t) {
                return Math.pow(t, i)
            } : function (t) {
                return t
            }, (function (t) {
                return 1 - Math.pow(1 - t, i)
            }), (function (t) {
                return t < .5 ? Math.pow(2 * t, i) / 2 : 1 - Math.pow(2 * (1 - t), i) / 2
            }))
        })), ci.Linear.easeNone = ci.none = ci.Linear.easeIn, gi("Elastic", yi("in"), yi("out"), yi()), K = 7.5625, Q = 1 / (J = 2.75), gi("Bounce", (function (t) {
            return 1 - tt(1 - t)
        }), tt = function (t) {
            return t < Q ? K * t * t : t < .7272727272727273 ? K * Math.pow(t - 1.5 / J, 2) + .75 : t < .9090909090909092 ? K * (t -= 2.25 / J) * t + .9375 : K * Math.pow(t - 2.625 / J, 2) + .984375
        }), gi("Expo", (function (t) {
            return t ? Math.pow(2, 10 * (t - 1)) : 0
        })), gi("Circ", (function (t) {
            return -(lt(1 - t * t) - 1)
        })), gi("Sine", (function (t) {
            return 1 === t ? 1 : 1 - ct(t * st)
        })), gi("Back", bi("in"), bi("out"), bi()), ci.SteppedEase = ci.steps = Mt.SteppedEase = {
            config: function (t, e) {
                void 0 === t && (t = 1);
                var i = 1 / t,
                    r = t + (e ? 0 : 1),
                    n = e ? 1 : 0;
                return function (t) {
                    return ((r * Oe(0, .99999999, t) | 0) + n) * i
                }
            }
        }, it.ease = ci["quad.out"], Ut("onComplete,onUpdate,onStart,onRepeat,onReverseComplete,onInterrupt", (function (t) {
            return Ht += t + "," + t + "Params,"
        }));
        var _i = function (t, e) {
            this.id = ot++, t._gsap = this, this.target = t, this.harness = e, this.get = e ? e.get : $t, this.set = e ? e.getSetter : Bi
        },
            wi = function () {
                function t(t) {
                    this.vars = t, this._delay = +t.delay || 0, (this._repeat = t.repeat === 1 / 0 ? -2 : t.repeat || 0) && (this._rDelay = t.repeatDelay || 0, this._yoyo = !!t.yoyo || !!t.yoyoEase), this._ts = 1, Ee(this, +t.duration, 1, 1), this.data = t.data, Y && (this._ctx = Y, Y.data.push(this)), X || oi.wake()
                }
                var e = t.prototype;
                return e.delay = function (t) {
                    return t || 0 === t ? (this.parent && this.parent.smoothChildTiming && this.startTime(this._start + t - this._delay), this._delay = t, this) : this._delay
                }, e.duration = function (t) {
                    return arguments.length ? this.totalDuration(this._repeat > 0 ? t + (t + this._rDelay) * this._repeat : t) : this.totalDuration() && this._dur
                }, e.totalDuration = function (t) {
                    return arguments.length ? (this._dirty = 0, Ee(this, this._repeat < 0 ? t : (t - this._repeat * this._rDelay) / (this._repeat + 1))) : this._tDur
                }, e.totalTime = function (t, e) {
                    if (li(), !arguments.length) return this._tTime;
                    var i = this._dp;
                    if (i && i.smoothChildTiming && this._ts) {
                        for (_e(this, t), !i._dp || i.parent || we(i, this); i && i.parent;) i.parent._time !== i._start + (i._ts >= 0 ? i._tTime / i._ts : (i.totalDuration() - i._tTime) / -i._ts) && i.totalTime(i._tTime, !0), i = i.parent;
                        !this.parent && this._dp.autoRemoveChildren && (this._ts > 0 && t < this._tDur || this._ts < 0 && t > 0 || !this._tDur && !t) && Ae(this._dp, this, this._start - this._delay)
                    }
                    return (this._tTime !== t || !this._dur && !e || this._initted && Math.abs(this._zTime) === nt || !t && !this._initted && (this.add || this._ptLookup)) && (this._ts || (this._pTime = t), ee(this, t, e)), this
                }, e.time = function (t, e) {
                    return arguments.length ? this.totalTime(Math.min(this.totalDuration(), t + ge(this)) % (this._dur + this._rDelay) || (t ? this._dur : 0), e) : this._time
                }, e.totalProgress = function (t, e) {
                    return arguments.length ? this.totalTime(this.totalDuration() * t, e) : this.totalDuration() ? Math.min(1, this._tTime / this._tDur) : this.ratio
                }, e.progress = function (t, e) {
                    return arguments.length ? this.totalTime(this.duration() * (!this._yoyo || 1 & this.iteration() ? t : 1 - t) + ge(this), e) : this.duration() ? Math.min(1, this._time / this._dur) : this.ratio
                }, e.iteration = function (t, e) {
                    var i = this.duration() + this._rDelay;
                    return arguments.length ? this.totalTime(this._time + (t - 1) * i, e) : this._repeat ? ve(this._tTime, i) + 1 : 1
                }, e.timeScale = function (t) {
                    if (!arguments.length) return -1e-8 === this._rts ? 0 : this._rts;
                    if (this._rts === t) return this;
                    var e = this.parent && this._ts ? ye(this.parent._time, this) : this._tTime;
                    return this._rts = +t || 0, this._ts = this._ps || -1e-8 === t ? 0 : this._rts, this.totalTime(Oe(-this._delay, this._tDur, e), !0), be(this), pe(this)
                }, e.paused = function (t) {
                    return arguments.length ? (this._ps !== t && (this._ps = t, t ? (this._pTime = this._tTime || Math.max(-this._delay, this.rawTime()), this._ts = this._act = 0) : (li(), this._ts = this._rts, this.totalTime(this.parent && !this.parent.smoothChildTiming ? this.rawTime() : this._tTime || this._pTime, 1 === this.progress() && Math.abs(this._zTime) !== nt && (this._tTime -= nt)))), this) : this._ps
                }, e.startTime = function (t) {
                    if (arguments.length) {
                        this._start = t;
                        var e = this.parent || this._dp;
                        return e && (e._sort || !this.parent) && Ae(e, this, t - this._delay), this
                    }
                    return this._start
                }, e.endTime = function (t) {
                    return this._start + (gt(t) ? this.totalDuration() : this.duration()) / Math.abs(this._ts || 1)
                }, e.rawTime = function (t) {
                    var e = this.parent || this._dp;
                    return e ? t && (!this._ts || this._repeat && this._time && this.totalProgress() < 1) ? this._tTime % (this._dur + this._rDelay) : this._ts ? ye(e.rawTime(t), this) : this._tTime : this._tTime
                }, e.revert = function (t) {
                    void 0 === t && (t = Nt);
                    var e = V;
                    return V = t, (this._initted || this._startAt) && (this.timeline && this.timeline.revert(t), this.totalTime(-.01, t.suppressEvents)), "nested" !== this.data && !1 !== t.kill && this.kill(), V = e, this
                }, e.globalTime = function (t) {
                    for (var e = this, i = arguments.length ? t : e.rawTime(); e;) i = e._start + i / (e._ts || 1), e = e._dp;
                    return !this.parent && this._sat ? this._sat.vars.immediateRender ? -1 : this._sat.globalTime(t) : i
                }, e.repeat = function (t) {
                    return arguments.length ? (this._repeat = t === 1 / 0 ? -2 : t, Me(this)) : -2 === this._repeat ? 1 / 0 : this._repeat
                }, e.repeatDelay = function (t) {
                    if (arguments.length) {
                        var e = this._time;
                        return this._rDelay = t, Me(this), e ? this.time(e) : this
                    }
                    return this._rDelay
                }, e.yoyo = function (t) {
                    return arguments.length ? (this._yoyo = t, this) : this._yoyo
                }, e.seek = function (t, e) {
                    return this.totalTime(Pe(this, t), gt(e))
                }, e.restart = function (t, e) {
                    return this.play().totalTime(t ? -this._delay : 0, gt(e))
                }, e.play = function (t, e) {
                    return null != t && this.seek(t, e), this.reversed(!1).paused(!1)
                }, e.reverse = function (t, e) {
                    return null != t && this.seek(t || this.totalDuration(), e), this.reversed(!0).paused(!1)
                }, e.pause = function (t, e) {
                    return null != t && this.seek(t, e), this.paused(!0)
                }, e.resume = function () {
                    return this.paused(!1)
                }, e.reversed = function (t) {
                    return arguments.length ? (!!t !== this.reversed() && this.timeScale(-this._rts || (t ? -1e-8 : 0)), this) : this._rts < 0
                }, e.invalidate = function () {
                    return this._initted = this._act = 0, this._zTime = -1e-8, this
                }, e.isActive = function () {
                    var t, e = this.parent || this._dp,
                        i = this._start;
                    return !(e && !(this._ts && this._initted && e.isActive() && (t = e.rawTime(!0)) >= i && t < this.endTime(!0) - nt))
                }, e.eventCallback = function (t, e, i) {
                    var r = this.vars;
                    return arguments.length > 1 ? (e ? (r[t] = e, i && (r[t + "Params"] = i), "onUpdate" === t && (this._onUpdate = e)) : delete r[t], this) : r[t]
                }, e.then = function (t) {
                    var e = this;
                    return new Promise((function (i) {
                        var r = dt(t) ? t : re,
                            n = function () {
                                var t = e.then;
                                e.then = null, dt(r) && (r = r(e)) && (r.then || r === e) && (e.then = t), i(r), e.then = t
                            };
                        e._initted && 1 === e.totalProgress() && e._ts >= 0 || !e._tTime && e._ts < 0 ? n() : e._prom = n
                    }))
                }, e.kill = function () {
                    Xe(this)
                }, t
            }();
        ne(wi.prototype, {
            _time: 0,
            _start: 0,
            _end: 0,
            _tTime: 0,
            _tDur: 0,
            _dirty: 0,
            _repeat: 0,
            _yoyo: !1,
            parent: null,
            _initted: !1,
            _rDelay: 0,
            _ts: 1,
            _dp: 0,
            ratio: 0,
            _zTime: -1e-8,
            _prom: 0,
            _ps: !1,
            _rts: 1
        });
        var Ai = function (t) {
            function e(e, i) {
                var r;
                return void 0 === e && (e = {}), (r = t.call(this, e) || this).labels = {}, r.smoothChildTiming = !!e.smoothChildTiming, r.autoRemoveChildren = !!e.autoRemoveChildren, r._sort = gt(e.sortChildren), j && Ae(e.parent || j, B(r), i), e.reversed && r.reverse(), e.paused && r.paused(!0), e.scrollTrigger && Se(B(r), e.scrollTrigger), r
            }
            z(e, t);
            var i = e.prototype;
            return i.to = function (t, e, i) {
                return De(0, arguments, this), this
            }, i.from = function (t, e, i) {
                return De(1, arguments, this), this
            }, i.fromTo = function (t, e, i, r) {
                return De(2, arguments, this), this
            }, i.set = function (t, e, i) {
                return e.duration = 0, e.parent = this, le(e).repeatDelay || (e.repeat = 0), e.immediateRender = !!e.immediateRender, new Oi(t, e, Pe(this, i), 1), this
            }, i.call = function (t, e, i) {
                return Ae(this, Oi.delayedCall(0, t, e), i)
            }, i.staggerTo = function (t, e, i, r, n, a, s) {
                return i.duration = e, i.stagger = i.stagger || r, i.onComplete = a, i.onCompleteParams = s, i.parent = this, new Oi(t, i, Pe(this, n)), this
            }, i.staggerFrom = function (t, e, i, r, n, a, s) {
                return i.runBackwards = 1, le(i).immediateRender = gt(i.immediateRender), this.staggerTo(t, e, i, r, n, a, s)
            }, i.staggerFromTo = function (t, e, i, r, n, a, s, o) {
                return r.startAt = i, le(r).immediateRender = gt(r.immediateRender), this.staggerTo(t, e, r, n, a, s, o)
            }, i.render = function (t, e, i) {
                var r, n, a, s, o, l, c, u, h, d, p, f, m = this._time,
                    g = this._dirty ? this.totalDuration() : this._tDur,
                    v = this._dur,
                    y = t <= 0 ? 0 : Kt(t),
                    b = this._zTime < 0 != t < 0 && (this._initted || !v);
                if (this !== j && y > g && t >= 0 && (y = g), y !== this._tTime || i || b) {
                    if (m !== this._time && v && (y += this._time - m, t += this._time - m), r = y, h = this._start, l = !(u = this._ts), b && (v || (m = this._zTime), (t || !e) && (this._zTime = t)), this._repeat) {
                        if (p = this._yoyo, o = v + this._rDelay, this._repeat < -1 && t < 0) return this.totalTime(100 * o + t, e, i);
                        if (r = Kt(y % o), y === g ? (s = this._repeat, r = v) : ((s = ~~(y / o)) && s === y / o && (r = v, s--), r > v && (r = v)), d = ve(this._tTime, o), !m && this._tTime && d !== s && (d = s), p && 1 & s && (r = v - r, f = 1), s !== d && !this._lock) {
                            var _ = p && 1 & d,
                                w = _ === (p && 1 & s);
                            if (s < d && (_ = !_), m = _ ? 0 : v, this._lock = 1, this.render(m || (f ? 0 : Kt(s * o)), e, !v)._lock = 0, this._tTime = y, !e && this.parent && Ue(this, "onRepeat"), this.vars.repeatRefresh && !f && (this.invalidate()._lock = 1), m && m !== this._time || l !== !this._ts || this.vars.onRepeat && !this.parent && !this._act) return this;
                            if (v = this._dur, g = this._tDur, w && (this._lock = 2, m = _ ? v : -1e-4, this.render(m, !0), this.vars.repeatRefresh && !f && this.invalidate()), this._lock = 0, !this._ts && !l) return this;
                            fi(this, f)
                        }
                    }
                    if (this._hasPause && !this._forcing && this._lock < 2 && (c = function (t, e, i) {
                        var r;
                        if (i > e)
                            for (r = t._first; r && r._start <= i;) {
                                if ("isPause" === r.data && r._start > e) return r;
                                r = r._next
                            } else
                            for (r = t._last; r && r._start >= i;) {
                                if ("isPause" === r.data && r._start < e) return r;
                                r = r._prev
                            }
                    }(this, Kt(m), Kt(r)), c && (y -= r - (r = c._start))), this._tTime = y, this._time = r, this._act = !u, this._initted || (this._onUpdate = this.vars.onUpdate, this._initted = 1, this._zTime = t, m = 0), !m && r && !e && (Ue(this, "onStart"), this._tTime !== y)) return this;
                    if (r >= m && t >= 0)
                        for (n = this._first; n;) {
                            if (a = n._next, (n._act || r >= n._start) && n._ts && c !== n) {
                                if (n.parent !== this) return this.render(t, e, i);
                                if (n.render(n._ts > 0 ? (r - n._start) * n._ts : (n._dirty ? n.totalDuration() : n._tDur) + (r - n._start) * n._ts, e, i), r !== this._time || !this._ts && !l) {
                                    c = 0, a && (y += this._zTime = -1e-8);
                                    break
                                }
                            }
                            n = a
                        } else {
                        n = this._last;
                        for (var A = t < 0 ? t : r; n;) {
                            if (a = n._prev, (n._act || A <= n._end) && n._ts && c !== n) {
                                if (n.parent !== this) return this.render(t, e, i);
                                if (n.render(n._ts > 0 ? (A - n._start) * n._ts : (n._dirty ? n.totalDuration() : n._tDur) + (A - n._start) * n._ts, e, i || V && (n._initted || n._startAt)), r !== this._time || !this._ts && !l) {
                                    c = 0, a && (y += this._zTime = A ? -1e-8 : nt);
                                    break
                                }
                            }
                            n = a
                        }
                    }
                    if (c && !e && (this.pause(), c.render(r >= m ? 0 : -1e-8)._zTime = r >= m ? 1 : -1, this._ts)) return this._start = h, be(this), this.render(t, e, i);
                    this._onUpdate && !e && Ue(this, "onUpdate", !0), (y === g && this._tTime >= this.totalDuration() || !y && m) && (h !== this._start && Math.abs(u) === Math.abs(this._ts) || this._lock || ((t || !v) && (y === g && this._ts > 0 || !y && this._ts < 0) && he(this, 1), e || t < 0 && !m || !y && !m && g || (Ue(this, y === g && t >= 0 ? "onComplete" : "onReverseComplete", !0), this._prom && !(y < g && this.timeScale() > 0) && this._prom())))
                }
                return this
            }, i.add = function (t, e) {
                var i = this;
                if (pt(e) || (e = Pe(this, e, t)), !(t instanceof wi)) {
                    if (_t(t)) return t.forEach((function (t) {
                        return i.add(t, e)
                    })), this;
                    if (ht(t)) return this.addLabel(t, e);
                    if (!dt(t)) return this;
                    t = Oi.delayedCall(0, t)
                }
                return this !== t ? Ae(this, t, e) : this
            }, i.getChildren = function (t, e, i, r) {
                void 0 === t && (t = !0), void 0 === e && (e = !0), void 0 === i && (i = !0), void 0 === r && (r = -rt);
                for (var n = [], a = this._first; a;) a._start >= r && (a instanceof Oi ? e && n.push(a) : (i && n.push(a), t && n.push.apply(n, a.getChildren(!0, e, i)))), a = a._next;
                return n
            }, i.getById = function (t) {
                for (var e = this.getChildren(1, 1, 1), i = e.length; i--;)
                    if (e[i].vars.id === t) return e[i]
            }, i.remove = function (t) {
                return ht(t) ? this.removeLabel(t) : dt(t) ? this.killTweensOf(t) : (ue(this, t), t === this._recent && (this._recent = this._last), de(this))
            }, i.totalTime = function (e, i) {
                return arguments.length ? (this._forcing = 1, !this._dp && this._ts && (this._start = Kt(oi.time - (this._ts > 0 ? e / this._ts : (this.totalDuration() - e) / -this._ts))), t.prototype.totalTime.call(this, e, i), this._forcing = 0, this) : this._tTime
            }, i.addLabel = function (t, e) {
                return this.labels[t] = Pe(this, e), this
            }, i.removeLabel = function (t) {
                return delete this.labels[t], this
            }, i.addPause = function (t, e, i) {
                var r = Oi.delayedCall(0, e || It, i);
                return r.data = "isPause", this._hasPause = 1, Ae(this, r, Pe(this, t))
            }, i.removePause = function (t) {
                var e = this._first;
                for (t = Pe(this, t); e;) e._start === t && "isPause" === e.data && he(e), e = e._next
            }, i.killTweensOf = function (t, e, i) {
                for (var r = this.getTweensOf(t, i), n = r.length; n--;) Si !== r[n] && r[n].kill(t, e);
                return this
            }, i.getTweensOf = function (t, e) {
                for (var i, r = [], n = Be(t), a = this._first, s = pt(e); a;) a instanceof Oi ? Qt(a._targets, n) && (s ? (!Si || a._initted && a._ts) && a.globalTime(0) <= e && a.globalTime(a.totalDuration()) > e : !e || a.isActive()) && r.push(a) : (i = a.getTweensOf(n, e)).length && r.push.apply(r, i), a = a._next;
                return r
            }, i.tweenTo = function (t, e) {
                e = e || {};
                var i, r = this,
                    n = Pe(r, t),
                    a = e,
                    s = a.startAt,
                    o = a.onStart,
                    l = a.onStartParams,
                    c = a.immediateRender,
                    u = Oi.to(r, ne({
                        ease: e.ease || "none",
                        lazy: !1,
                        immediateRender: !1,
                        time: n,
                        overwrite: "auto",
                        duration: e.duration || Math.abs((n - (s && "time" in s ? s.time : r._time)) / r.timeScale()) || nt,
                        onStart: function () {
                            if (r.pause(), !i) {
                                var t = e.duration || Math.abs((n - (s && "time" in s ? s.time : r._time)) / r.timeScale());
                                u._dur !== t && Ee(u, t, 0, 1).render(u._time, !0, !0), i = 1
                            }
                            o && o.apply(u, l || [])
                        }
                    }, e));
                return c ? u.render(0) : u
            }, i.tweenFromTo = function (t, e, i) {
                return this.tweenTo(e, ne({
                    startAt: {
                        time: Pe(this, t)
                    }
                }, i))
            }, i.recent = function () {
                return this._recent
            }, i.nextLabel = function (t) {
                return void 0 === t && (t = this._time), $e(this, Pe(this, t))
            }, i.previousLabel = function (t) {
                return void 0 === t && (t = this._time), $e(this, Pe(this, t), 1)
            }, i.currentLabel = function (t) {
                return arguments.length ? this.seek(t, !0) : this.previousLabel(this._time + nt)
            }, i.shiftChildren = function (t, e, i) {
                void 0 === i && (i = 0);
                for (var r, n = this._first, a = this.labels; n;) n._start >= i && (n._start += t, n._end += t), n = n._next;
                if (e)
                    for (r in a) a[r] >= i && (a[r] += t);
                return de(this)
            }, i.invalidate = function (e) {
                var i = this._first;
                for (this._lock = 0; i;) i.invalidate(e), i = i._next;
                return t.prototype.invalidate.call(this, e)
            }, i.clear = function (t) {
                void 0 === t && (t = !0);
                for (var e, i = this._first; i;) e = i._next, this.remove(i), i = e;
                return this._dp && (this._time = this._tTime = this._pTime = 0), t && (this.labels = {}), de(this)
            }, i.totalDuration = function (t) {
                var e, i, r, n = 0,
                    a = this,
                    s = a._last,
                    o = rt;
                if (arguments.length) return a.timeScale((a._repeat < 0 ? a.duration() : a.totalDuration()) / (a.reversed() ? -t : t));
                if (a._dirty) {
                    for (r = a.parent; s;) e = s._prev, s._dirty && s.totalDuration(), (i = s._start) > o && a._sort && s._ts && !a._lock ? (a._lock = 1, Ae(a, s, i - s._delay, 1)._lock = 0) : o = i, i < 0 && s._ts && (n -= i, (!r && !a._dp || r && r.smoothChildTiming) && (a._start += i / a._ts, a._time -= i, a._tTime -= i), a.shiftChildren(-i, !1, -Infinity), o = 0), s._end > n && s._ts && (n = s._end), s = e;
                    Ee(a, a === j && a._time > n ? a._time : n, 1, 1), a._dirty = 0
                }
                return a._tDur
            }, e.updateRoot = function (t) {
                if (j._ts && (ee(j, ye(t, j)), $ = oi.frame), oi.frame >= jt) {
                    jt += et.autoSleep || 120;
                    var e = j._first;
                    if ((!e || !e._ts) && et.autoSleep && oi._listeners.length < 2) {
                        for (; e && !e._ts;) e = e._next;
                        e || oi.sleep()
                    }
                }
            }, e
        }(wi);
        ne(Ai.prototype, {
            _lock: 0,
            _hasPause: 0,
            _forcing: 0
        });
        var Si, ki, xi = function (t, e, i, r, n, a, s) {
            var o, l, c, u, h, d, p, f, m = new Zi(this._pt, t, e, 0, 1, Vi, null, n),
                g = 0,
                v = 0;
            for (m.b = i, m.e = r, i += "", (p = ~(r += "").indexOf("random(")) && (r = We(r)), a && (a(f = [i, r], t, e), i = f[0], r = f[1]), l = i.match(kt) || []; o = kt.exec(r);) u = o[0], h = r.substring(g, o.index), c ? c = (c + 1) % 5 : "rgba(" === h.substr(-5) && (c = 1), u !== l[v++] && (d = parseFloat(l[v - 1]) || 0, m._pt = {
                _next: m._pt,
                p: h || 1 === v ? h : ",",
                s: d,
                c: "=" === u.charAt(1) ? Jt(d, u) - d : parseFloat(u) - d,
                m: c && c < 4 ? Math.round : 0
            }, g = kt.lastIndex);
            return m.c = g < r.length ? r.substring(g, r.length) : "", m.fp = s, (xt.test(r) || p) && (m.e = 0), this._pt = m, m
        },
            Ti = function (t, e, i, r, n, a, s, o, l, c) {
                dt(r) && (r = r(n || 0, t, a));
                var u, h = t[e],
                    d = "get" !== i ? i : dt(h) ? l ? t[e.indexOf("set") || !dt(t["get" + e.substr(3)]) ? e : "get" + e.substr(3)](l) : t[e]() : h,
                    p = dt(h) ? l ? Fi : Ri : Ii;
                if (ht(r) && (~r.indexOf("random(") && (r = We(r)), "=" === r.charAt(1) && ((u = Jt(d, r) + (Ie(d) || 0)) || 0 === u) && (r = u)), !c || d !== r || ki) return isNaN(d * r) || "" === r ? (!h && !(e in t) && Dt(e, r), xi.call(this, t, e, d, r, p, o || et.stringFilter, l)) : (u = new Zi(this._pt, t, e, +d || 0, r - (d || 0), "boolean" == typeof h ? qi : zi, 0, p), l && (u.fp = l), s && u.modifier(s, this, t), this._pt = u)
            },
            Ei = function (t, e, i, r, n, a) {
                var s, o, l, c;
                if (Vt[t] && !1 !== (s = new Vt[t]).init(n, s.rawVars ? e[t] : function (t, e, i, r, n) {
                    if (dt(t) && (t = Pi(t, n, e, i, r)), !mt(t) || t.style && t.nodeType || _t(t) || bt(t)) return ht(t) ? Pi(t, n, e, i, r) : t;
                    var a, s = {};
                    for (a in t) s[a] = Pi(t[a], n, e, i, r);
                    return s
                }(e[t], r, n, a, i), i, r, a) && (i._pt = o = new Zi(i._pt, n, t, 0, 1, s.render, s, 0, s.priority), i !== U))
                    for (l = i._ptLookup[i._targets.indexOf(n)], c = s._props.length; c--;) l[s._props[c]] = o;
                return s
            },
            Mi = function t(e, i, r) {
                var n, a, s, o, l, c, u, h, d, p, f, m, g, v = e.vars,
                    y = v.ease,
                    b = v.startAt,
                    _ = v.immediateRender,
                    w = v.lazy,
                    A = v.onUpdate,
                    S = v.onUpdateParams,
                    k = v.callbackScope,
                    x = v.runBackwards,
                    T = v.yoyoEase,
                    E = v.keyframes,
                    M = v.autoRevert,
                    C = e._dur,
                    P = e._startAt,
                    D = e._targets,
                    L = e.parent,
                    O = L && "nested" === L.data ? L.vars.targets : D,
                    I = "auto" === e._overwrite && !q,
                    R = e.timeline;
                if (R && (!E || !y) && (y = "none"), e._ease = mi(y, it.ease), e._yEase = T ? pi(mi(!0 === T ? y : T, it.ease)) : 0, T && e._yoyo && !e._repeat && (T = e._yEase, e._yEase = e._ease, e._ease = T), e._from = !R && !!v.runBackwards, !R || E && !v.stagger) {
                    if (m = (h = D[0] ? Zt(D[0]).harness : 0) && v[h.prop], n = oe(v, Bt), P && (P._zTime < 0 && P.progress(1), i < 0 && x && _ && !M ? P.render(-1, !0) : P.revert(x && C ? Ft : Rt), P._lazy = 0), b) {
                        if (he(e._startAt = Oi.set(D, ne({
                            data: "isStart",
                            overwrite: !1,
                            parent: L,
                            immediateRender: !0,
                            lazy: !P && gt(w),
                            startAt: null,
                            delay: 0,
                            onUpdate: A,
                            onUpdateParams: S,
                            callbackScope: k,
                            stagger: 0
                        }, b))), e._startAt._dp = 0, e._startAt._sat = e, i < 0 && (V || !_ && !M) && e._startAt.revert(Ft), _ && C && i <= 0 && r <= 0) return void (i && (e._zTime = i))
                    } else if (x && C && !P)
                        if (i && (_ = !1), s = ne({
                            overwrite: !1,
                            data: "isFromStart",
                            lazy: _ && !P && gt(w),
                            immediateRender: _,
                            stagger: 0,
                            parent: L
                        }, n), m && (s[h.prop] = m), he(e._startAt = Oi.set(D, s)), e._startAt._dp = 0, e._startAt._sat = e, i < 0 && (V ? e._startAt.revert(Ft) : e._startAt.render(-1, !0)), e._zTime = i, _) {
                            if (!i) return
                        } else t(e._startAt, nt, nt);
                    for (e._pt = e._ptCache = 0, w = C && gt(w) || w && !C, a = 0; a < D.length; a++) {
                        if (u = (l = D[a])._gsap || Wt(D)[a]._gsap, e._ptLookup[a] = p = {}, qt[u.id] && zt.length && te(), f = O === D ? a : O.indexOf(l), h && !1 !== (d = new h).init(l, m || n, e, f, O) && (e._pt = o = new Zi(e._pt, l, d.name, 0, 1, d.render, d, 0, d.priority), d._props.forEach((function (t) {
                            p[t] = o
                        })), d.priority && (c = 1)), !h || m)
                            for (s in n) Vt[s] && (d = Ei(s, n, e, f, l, O)) ? d.priority && (c = 1) : p[s] = o = Ti.call(e, l, s, "get", n[s], f, O, 0, v.stringFilter);
                        e._op && e._op[a] && e.kill(l, e._op[a]), I && e._pt && (Si = e, j.killTweensOf(l, p, e.globalTime(i)), g = !e.parent, Si = 0), e._pt && w && (qt[u.id] = 1)
                    }
                    c && Wi(e), e._onInit && e._onInit(e)
                }
                e._onUpdate = A, e._initted = (!e._op || e._pt) && !g, E && i <= 0 && R.render(rt, !0, !0)
            },
            Ci = function (t, e, i, r) {
                var n, a, s = e.ease || r || "power1.inOut";
                if (_t(e)) a = i[t] || (i[t] = []), e.forEach((function (t, i) {
                    return a.push({
                        t: i / (e.length - 1) * 100,
                        v: t,
                        e: s
                    })
                }));
                else
                    for (n in e) a = i[n] || (i[n] = []), "ease" === n || a.push({
                        t: parseFloat(t),
                        v: e[n],
                        e: s
                    })
            },
            Pi = function (t, e, i, r, n) {
                return dt(t) ? t.call(e, i, r, n) : ht(t) && ~t.indexOf("random(") ? We(t) : t
            },
            Di = Ht + "repeat,repeatDelay,yoyo,repeatRefresh,yoyoEase,autoRevert",
            Li = {};
        Ut(Di + ",id,stagger,delay,duration,paused,scrollTrigger", (function (t) {
            return Li[t] = 1
        }));
        var Oi = function (t) {
            function e(e, i, r, n) {
                var a;
                "number" == typeof i && (r.duration = i, i = r, r = null);
                var s, o, l, c, u, h, d, p, f = (a = t.call(this, n ? i : le(i)) || this).vars,
                    m = f.duration,
                    g = f.delay,
                    v = f.immediateRender,
                    y = f.stagger,
                    b = f.overwrite,
                    _ = f.keyframes,
                    w = f.defaults,
                    A = f.scrollTrigger,
                    S = f.yoyoEase,
                    k = i.parent || j,
                    x = (_t(e) || bt(e) ? pt(e[0]) : "length" in i) ? [e] : Be(e);
                if (a._targets = x.length ? Wt(x) : Lt("GSAP target " + e + " not found. https://greensock.com", !et.nullTargetWarn) || [], a._ptLookup = [], a._overwrite = b, _ || y || yt(m) || yt(g)) {
                    if (i = a.vars, (s = a.timeline = new Ai({
                        data: "nested",
                        defaults: w || {},
                        targets: k && "nested" === k.data ? k.vars.targets : x
                    })).kill(), s.parent = s._dp = B(a), s._start = 0, y || yt(m) || yt(g)) {
                        if (c = x.length, d = y && Ve(y), mt(y))
                            for (u in y) ~Di.indexOf(u) && (p || (p = {}), p[u] = y[u]);
                        for (o = 0; o < c; o++)(l = oe(i, Li)).stagger = 0, S && (l.yoyoEase = S), p && ae(l, p), h = x[o], l.duration = +Pi(m, B(a), o, h, x), l.delay = (+Pi(g, B(a), o, h, x) || 0) - a._delay, !y && 1 === c && l.delay && (a._delay = g = l.delay, a._start += g, l.delay = 0), s.to(h, l, d ? d(o, h, x) : 0), s._ease = ci.none;
                        s.duration() ? m = g = 0 : a.timeline = 0
                    } else if (_) {
                        le(ne(s.vars.defaults, {
                            ease: "none"
                        })), s._ease = mi(_.ease || i.ease || "none");
                        var T, E, M, C = 0;
                        if (_t(_)) _.forEach((function (t) {
                            return s.to(x, t, ">")
                        })), s.duration();
                        else {
                            for (u in l = {}, _) "ease" === u || "easeEach" === u || Ci(u, _[u], l, _.easeEach);
                            for (u in l)
                                for (T = l[u].sort((function (t, e) {
                                    return t.t - e.t
                                })), C = 0, o = 0; o < T.length; o++)(M = {
                                    ease: (E = T[o]).e,
                                    duration: (E.t - (o ? T[o - 1].t : 0)) / 100 * m
                                })[u] = E.v, s.to(x, M, C), C += M.duration;
                            s.duration() < m && s.to({}, {
                                duration: m - s.duration()
                            })
                        }
                    }
                    m || a.duration(m = s.duration())
                } else a.timeline = 0;
                return !0 !== b || q || (Si = B(a), j.killTweensOf(x), Si = 0), Ae(k, B(a), r), i.reversed && a.reverse(), i.paused && a.paused(!0), (v || !m && !_ && a._start === Kt(k._time) && gt(v) && me(B(a)) && "nested" !== k.data) && (a._tTime = -1e-8, a.render(Math.max(0, -g) || 0)), A && Se(B(a), A), a
            }
            z(e, t);
            var i = e.prototype;
            return i.render = function (t, e, i) {
                var r, n, a, s, o, l, c, u, h, d = this._time,
                    p = this._tDur,
                    f = this._dur,
                    m = t < 0,
                    g = t > p - nt && !m ? p : t < nt ? 0 : t;
                if (f) {
                    if (g !== this._tTime || !t || i || !this._initted && this._tTime || this._startAt && this._zTime < 0 !== m) {
                        if (r = g, u = this.timeline, this._repeat) {
                            if (s = f + this._rDelay, this._repeat < -1 && m) return this.totalTime(100 * s + t, e, i);
                            if (r = Kt(g % s), g === p ? (a = this._repeat, r = f) : ((a = ~~(g / s)) && a === g / s && (r = f, a--), r > f && (r = f)), (l = this._yoyo && 1 & a) && (h = this._yEase, r = f - r), o = ve(this._tTime, s), r === d && !i && this._initted) return this._tTime = g, this;
                            a !== o && (u && this._yEase && fi(u, l), !this.vars.repeatRefresh || l || this._lock || (this._lock = i = 1, this.render(Kt(s * a), !0).invalidate()._lock = 0))
                        }
                        if (!this._initted) {
                            if (ke(this, m ? t : r, i, e, g)) return this._tTime = 0, this;
                            if (d !== this._time) return this;
                            if (f !== this._dur) return this.render(t, e, i)
                        }
                        if (this._tTime = g, this._time = r, !this._act && this._ts && (this._act = 1, this._lazy = 0), this.ratio = c = (h || this._ease)(r / f), this._from && (this.ratio = c = 1 - c), r && !d && !e && (Ue(this, "onStart"), this._tTime !== g)) return this;
                        for (n = this._pt; n;) n.r(c, n.d), n = n._next;
                        u && u.render(t < 0 ? t : !r && l ? -1e-8 : u._dur * u._ease(r / this._dur), e, i) || this._startAt && (this._zTime = t), this._onUpdate && !e && (m && fe(this, t, 0, i), Ue(this, "onUpdate")), this._repeat && a !== o && this.vars.onRepeat && !e && this.parent && Ue(this, "onRepeat"), g !== this._tDur && g || this._tTime !== g || (m && !this._onUpdate && fe(this, t, 0, !0), (t || !f) && (g === this._tDur && this._ts > 0 || !g && this._ts < 0) && he(this, 1), e || m && !d || !(g || d || l) || (Ue(this, g === p ? "onComplete" : "onReverseComplete", !0), this._prom && !(g < p && this.timeScale() > 0) && this._prom()))
                    }
                } else ! function (t, e, i, r) {
                    var n, a, s, o = t.ratio,
                        l = e < 0 || !e && (!t._start && xe(t) && (t._initted || !Te(t)) || (t._ts < 0 || t._dp._ts < 0) && !Te(t)) ? 0 : 1,
                        c = t._rDelay,
                        u = 0;
                    if (c && t._repeat && (u = Oe(0, t._tDur, e), a = ve(u, c), t._yoyo && 1 & a && (l = 1 - l), a !== ve(t._tTime, c) && (o = 1 - l, t.vars.repeatRefresh && t._initted && t.invalidate())), l !== o || V || r || t._zTime === nt || !e && t._zTime) {
                        if (!t._initted && ke(t, e, r, i, u)) return;
                        for (s = t._zTime, t._zTime = e || (i ? nt : 0), i || (i = e && !s), t.ratio = l, t._from && (l = 1 - l), t._time = 0, t._tTime = u, n = t._pt; n;) n.r(l, n.d), n = n._next;
                        e < 0 && fe(t, e, 0, !0), t._onUpdate && !i && Ue(t, "onUpdate"), u && t._repeat && !i && t.parent && Ue(t, "onRepeat"), (e >= t._tDur || e < 0) && t.ratio === l && (l && he(t, 1), i || V || (Ue(t, l ? "onComplete" : "onReverseComplete", !0), t._prom && t._prom()))
                    } else t._zTime || (t._zTime = e)
                }(this, t, e, i);
                return this
            }, i.targets = function () {
                return this._targets
            }, i.invalidate = function (e) {
                return (!e || !this.vars.runBackwards) && (this._startAt = 0), this._pt = this._op = this._onUpdate = this._lazy = this.ratio = 0, this._ptLookup = [], this.timeline && this.timeline.invalidate(e), t.prototype.invalidate.call(this, e)
            }, i.resetTo = function (t, e, i, r) {
                X || oi.wake(), this._ts || this.play();
                var n = Math.min(this._dur, (this._dp._time - this._start) * this._ts);
                return this._initted || Mi(this, n),
                    function (t, e, i, r, n, a, s) {
                        var o, l, c, u, h = (t._pt && t._ptCache || (t._ptCache = {}))[e];
                        if (!h)
                            for (h = t._ptCache[e] = [], c = t._ptLookup, u = t._targets.length; u--;) {
                                if ((o = c[u][e]) && o.d && o.d._pt)
                                    for (o = o.d._pt; o && o.p !== e && o.fp !== e;) o = o._next;
                                if (!o) return ki = 1, t.vars[e] = "+=0", Mi(t, s), ki = 0, 1;
                                h.push(o)
                            }
                        for (u = h.length; u--;)(o = (l = h[u])._pt || l).s = !r && 0 !== r || n ? o.s + (r || 0) + a * o.c : r, o.c = i - o.s, l.e && (l.e = Xt(i) + Ie(l.e)), l.b && (l.b = o.s + Ie(l.b))
                    }(this, t, e, i, r, this._ease(n / this._dur), n) ? this.resetTo(t, e, i, r) : (_e(this, 0), this.parent || ce(this._dp, this, "_first", "_last", this._dp._sort ? "_start" : 0), this.render(0))
            }, i.kill = function (t, e) {
                if (void 0 === e && (e = "all"), !(t || e && "all" !== e)) return this._lazy = this._pt = 0, this.parent ? Xe(this) : this;
                if (this.timeline) {
                    var i = this.timeline.totalDuration();
                    return this.timeline.killTweensOf(t, e, Si && !0 !== Si.vars.overwrite)._first || Xe(this), this.parent && i !== this.timeline.totalDuration() && Ee(this, this._dur * this.timeline._tDur / i, 0, 1), this
                }
                var r, n, a, s, o, l, c, u = this._targets,
                    h = t ? Be(t) : u,
                    d = this._ptLookup,
                    p = this._pt;
                if ((!e || "all" === e) && function (t, e) {
                    for (var i = t.length, r = i === e.length; r && i-- && t[i] === e[i];);
                    return i < 0
                }(u, h)) return "all" === e && (this._pt = 0), Xe(this);
                for (r = this._op = this._op || [], "all" !== e && (ht(e) && (o = {}, Ut(e, (function (t) {
                    return o[t] = 1
                })), e = o), e = function (t, e) {
                    var i, r, n, a, s = t[0] ? Zt(t[0]).harness : 0,
                        o = s && s.aliases;
                    if (!o) return e;
                    for (r in i = ae({}, e), o)
                        if (r in i)
                            for (n = (a = o[r].split(",")).length; n--;) i[a[n]] = i[r];
                    return i
                }(u, e)), c = u.length; c--;)
                    if (~h.indexOf(u[c]))
                        for (o in n = d[c], "all" === e ? (r[c] = e, s = n, a = {}) : (a = r[c] = r[c] || {}, s = e), s) (l = n && n[o]) && ("kill" in l.d && !0 !== l.d.kill(o) || ue(this, l, "_pt"), delete n[o]), "all" !== a && (a[o] = 1);
                return this._initted && !this._pt && p && Xe(this), this
            }, e.to = function (t, i) {
                return new e(t, i, arguments[2])
            }, e.from = function (t, e) {
                return De(1, arguments)
            }, e.delayedCall = function (t, i, r, n) {
                return new e(i, 0, {
                    immediateRender: !1,
                    lazy: !1,
                    overwrite: !1,
                    delay: t,
                    onComplete: i,
                    onReverseComplete: i,
                    onCompleteParams: r,
                    onReverseCompleteParams: r,
                    callbackScope: n
                })
            }, e.fromTo = function (t, e, i) {
                return De(2, arguments)
            }, e.set = function (t, i) {
                return i.duration = 0, i.repeatDelay || (i.repeat = 0), new e(t, i)
            }, e.killTweensOf = function (t, e, i) {
                return j.killTweensOf(t, e, i)
            }, e
        }(wi);
        ne(Oi.prototype, {
            _targets: [],
            _lazy: 0,
            _startAt: 0,
            _op: 0,
            _onInit: 0
        }), Ut("staggerTo,staggerFrom,staggerFromTo", (function (t) {
            Oi[t] = function () {
                var e = new Ai,
                    i = Re.call(arguments, 0);
                return i.splice("staggerFromTo" === t ? 5 : 4, 0, 0), e[t].apply(e, i)
            }
        }));
        var Ii = function (t, e, i) {
            return t[e] = i
        },
            Ri = function (t, e, i) {
                return t[e](i)
            },
            Fi = function (t, e, i, r) {
                return t[e](r.fp, i)
            },
            Ni = function (t, e, i) {
                return t.setAttribute(e, i)
            },
            Bi = function (t, e) {
                return dt(t[e]) ? Ri : ft(t[e]) && t.setAttribute ? Ni : Ii
            },
            zi = function (t, e) {
                return e.set(e.t, e.p, Math.round(1e6 * (e.s + e.c * t)) / 1e6, e)
            },
            qi = function (t, e) {
                return e.set(e.t, e.p, !!(e.s + e.c * t), e)
            },
            Vi = function (t, e) {
                var i = e._pt,
                    r = "";
                if (!t && e.b) r = e.b;
                else if (1 === t && e.e) r = e.e;
                else {
                    for (; i;) r = i.p + (i.m ? i.m(i.s + i.c * t) : Math.round(1e4 * (i.s + i.c * t)) / 1e4) + r, i = i._next;
                    r += e.c
                }
                e.set(e.t, e.p, r, e)
            },
            Yi = function (t, e) {
                for (var i = e._pt; i;) i.r(t, i.d), i = i._next
            },
            ji = function (t, e, i, r) {
                for (var n, a = this._pt; a;) n = a._next, a.p === r && a.modifier(t, e, i), a = n
            },
            Gi = function (t) {
                for (var e, i, r = this._pt; r;) i = r._next, r.p === t && !r.op || r.op === t ? ue(this, r, "_pt") : r.dep || (e = 1), r = i;
                return !e
            },
            Hi = function (t, e, i, r) {
                r.mSet(t, e, r.m.call(r.tween, i, r.mt), r)
            },
            Wi = function (t) {
                for (var e, i, r, n, a = t._pt; a;) {
                    for (e = a._next, i = r; i && i.pr > a.pr;) i = i._next;
                    (a._prev = i ? i._prev : n) ? a._prev._next = a : r = a, (a._next = i) ? i._prev = a : n = a, a = e
                }
                t._pt = r
            },
            Zi = function () {
                function t(t, e, i, r, n, a, s, o, l) {
                    this.t = e, this.s = r, this.c = n, this.p = i, this.r = a || zi, this.d = s || this, this.set = o || Ii, this.pr = l || 0, this._next = t, t && (t._prev = this)
                }
                return t.prototype.modifier = function (t, e, i) {
                    this.mSet = this.mSet || this.set, this.set = Hi, this.m = t, this.mt = i, this.tween = e
                }, t
            }();
        Ut(Ht + "parent,duration,ease,delay,overwrite,runBackwards,startAt,yoyo,immediateRender,repeat,repeatDelay,data,paused,reversed,lazy,callbackScope,stringFilter,id,yoyoEase,stagger,inherit,repeatRefresh,keyframes,autoRevert,scrollTrigger", (function (t) {
            return Bt[t] = 1
        })), Mt.TweenMax = Mt.TweenLite = Oi, Mt.TimelineLite = Mt.TimelineMax = Ai, j = new Ai({
            sortChildren: !1,
            defaults: it,
            autoRemoveChildren: !0,
            id: "root",
            smoothChildTiming: !0
        }), et.stringFilter = si;
        var $i = [],
            Ui = {},
            Xi = [],
            Ki = 0,
            Ji = function (t) {
                return (Ui[t] || Xi).map((function (t) {
                    return t()
                }))
            },
            Qi = function () {
                var t = Date.now(),
                    e = [];
                t - Ki > 2 && (Ji("matchMediaInit"), $i.forEach((function (t) {
                    var i, r, n, a, s = t.queries,
                        o = t.conditions;
                    for (r in s) (i = G.matchMedia(s[r]).matches) && (n = 1), i !== o[r] && (o[r] = i, a = 1);
                    a && (t.revert(), n && e.push(t))
                })), Ji("matchMediaRevert"), e.forEach((function (t) {
                    return t.onMatch(t)
                })), Ki = t, Ji("matchMedia"))
            },
            tr = function () {
                function t(t, e) {
                    this.selector = e && ze(e), this.data = [], this._r = [], this.isReverted = !1, t && this.add(t)
                }
                var e = t.prototype;
                return e.add = function (t, e, i) {
                    dt(t) && (i = e, e = t, t = dt);
                    var r = this,
                        n = function () {
                            var t, n = Y,
                                a = r.selector;
                            return n && n !== r && n.data.push(r), i && (r.selector = ze(i)), Y = r, t = e.apply(r, arguments), dt(t) && r._r.push(t), Y = n, r.selector = a, r.isReverted = !1, t
                        };
                    return r.last = n, t === dt ? n(r) : t ? r[t] = n : n
                }, e.ignore = function (t) {
                    var e = Y;
                    Y = null, t(this), Y = e
                }, e.getTweens = function () {
                    var e = [];
                    return this.data.forEach((function (i) {
                        return i instanceof t ? e.push.apply(e, i.getTweens()) : i instanceof Oi && !(i.parent && "nested" === i.parent.data) && e.push(i)
                    })), e
                }, e.clear = function () {
                    this._r.length = this.data.length = 0
                }, e.kill = function (t, e) {
                    var i = this;
                    if (t) {
                        var r = this.getTweens();
                        this.data.forEach((function (t) {
                            "isFlip" === t.data && (t.revert(), t.getChildren(!0, !0, !1).forEach((function (t) {
                                return r.splice(r.indexOf(t), 1)
                            })))
                        })), r.map((function (t) {
                            return {
                                g: t.globalTime(0),
                                t
                            }
                        })).sort((function (t, e) {
                            return e.g - t.g || -1
                        })).forEach((function (e) {
                            return e.t.revert(t)
                        })), this.data.forEach((function (e) {
                            return !(e instanceof wi) && e.revert && e.revert(t)
                        })), this._r.forEach((function (e) {
                            return e(t, i)
                        })), this.isReverted = !0
                    } else this.data.forEach((function (t) {
                        return t.kill && t.kill()
                    }));
                    if (this.clear(), e) {
                        var n = $i.indexOf(this);
                        ~n && $i.splice(n, 1)
                    }
                }, e.revert = function (t) {
                    this.kill(t || {})
                }, t
            }(),
            er = function () {
                function t(t) {
                    this.contexts = [], this.scope = t
                }
                var e = t.prototype;
                return e.add = function (t, e, i) {
                    mt(t) || (t = {
                        matches: t
                    });
                    var r, n, a, s = new tr(0, i || this.scope),
                        o = s.conditions = {};
                    for (n in this.contexts.push(s), e = s.add("onMatch", e), s.queries = t, t) "all" === n ? a = 1 : (r = G.matchMedia(t[n])) && ($i.indexOf(s) < 0 && $i.push(s), (o[n] = r.matches) && (a = 1), r.addListener ? r.addListener(Qi) : r.addEventListener("change", Qi));
                    return a && e(s), this
                }, e.revert = function (t) {
                    this.kill(t || {})
                }, e.kill = function (t) {
                    this.contexts.forEach((function (e) {
                        return e.kill(t, !0)
                    }))
                }, t
            }(),
            ir = {
                registerPlugin: function () {
                    for (var t = arguments.length, e = new Array(t), i = 0; i < t; i++) e[i] = arguments[i];
                    e.forEach((function (t) {
                        return Ke(t)
                    }))
                },
                timeline: function (t) {
                    return new Ai(t)
                },
                getTweensOf: function (t, e) {
                    return j.getTweensOf(t, e)
                },
                getProperty: function (t, e, i, r) {
                    ht(t) && (t = Be(t)[0]);
                    var n = Zt(t || {}).get,
                        a = i ? re : ie;
                    return "native" === i && (i = ""), t ? e ? a((Vt[e] && Vt[e].get || n)(t, e, i, r)) : function (e, i, r) {
                        return a((Vt[e] && Vt[e].get || n)(t, e, i, r))
                    } : t
                },
                quickSetter: function (t, e, i) {
                    if ((t = Be(t)).length > 1) {
                        var r = t.map((function (t) {
                            return ar.quickSetter(t, e, i)
                        })),
                            n = r.length;
                        return function (t) {
                            for (var e = n; e--;) r[e](t)
                        }
                    }
                    t = t[0] || {};
                    var a = Vt[e],
                        s = Zt(t),
                        o = s.harness && (s.harness.aliases || {})[e] || e,
                        l = a ? function (e) {
                            var r = new a;
                            U._pt = 0, r.init(t, i ? e + i : e, U, 0, [t]), r.render(1, r), U._pt && Yi(1, U)
                        } : s.set(t, o);
                    return a ? l : function (e) {
                        return l(t, o, i ? e + i : e, s, 1)
                    }
                },
                quickTo: function (t, e, i) {
                    var r, n = ar.to(t, ae(((r = {})[e] = "+=0.1", r.paused = !0, r), i || {})),
                        a = function (t, i, r) {
                            return n.resetTo(e, t, i, r)
                        };
                    return a.tween = n, a
                },
                isTweening: function (t) {
                    return j.getTweensOf(t, !0).length > 0
                },
                defaults: function (t) {
                    return t && t.ease && (t.ease = mi(t.ease, it.ease)), se(it, t || {})
                },
                config: function (t) {
                    return se(et, t || {})
                },
                registerEffect: function (t) {
                    var e = t.name,
                        i = t.effect,
                        r = t.plugins,
                        n = t.defaults,
                        a = t.extendTimeline;
                    (r || "").split(",").forEach((function (t) {
                        return t && !Vt[t] && !Mt[t] && Lt(e + " effect requires " + t + " plugin.")
                    })), Yt[e] = function (t, e, r) {
                        return i(Be(t), ne(e || {}, n), r)
                    }, a && (Ai.prototype[e] = function (t, i, r) {
                        return this.add(Yt[e](t, mt(i) ? i : (r = i) && {}, this), r)
                    })
                },
                registerEase: function (t, e) {
                    ci[t] = mi(e)
                },
                parseEase: function (t, e) {
                    return arguments.length ? mi(t, e) : ci
                },
                getById: function (t) {
                    return j.getById(t)
                },
                exportRoot: function (t, e) {
                    void 0 === t && (t = {});
                    var i, r, n = new Ai(t);
                    for (n.smoothChildTiming = gt(t.smoothChildTiming), j.remove(n), n._dp = 0, n._time = n._tTime = j._time, i = j._first; i;) r = i._next, !e && !i._dur && i instanceof Oi && i.vars.onComplete === i._targets[0] || Ae(n, i, i._start - i._delay), i = r;
                    return Ae(j, n, 0), n
                },
                context: function (t, e) {
                    return t ? new tr(t, e) : Y
                },
                matchMedia: function (t) {
                    return new er(t)
                },
                matchMediaRefresh: function () {
                    return $i.forEach((function (t) {
                        var e, i, r = t.conditions;
                        for (i in r) r[i] && (r[i] = !1, e = 1);
                        e && t.revert()
                    })) || Qi()
                },
                addEventListener: function (t, e) {
                    var i = Ui[t] || (Ui[t] = []);
                    ~i.indexOf(e) || i.push(e)
                },
                removeEventListener: function (t, e) {
                    var i = Ui[t],
                        r = i && i.indexOf(e);
                    r >= 0 && i.splice(r, 1)
                },
                utils: {
                    wrap: function t(e, i, r) {
                        var n = i - e;
                        return _t(e) ? He(e, t(0, e.length), i) : Le(r, (function (t) {
                            return (n + (t - e) % n) % n + e
                        }))
                    },
                    wrapYoyo: function t(e, i, r) {
                        var n = i - e,
                            a = 2 * n;
                        return _t(e) ? He(e, t(0, e.length - 1), i) : Le(r, (function (t) {
                            return e + ((t = (a + (t - e) % a) % a || 0) > n ? a - t : t)
                        }))
                    },
                    distribute: Ve,
                    random: Ge,
                    snap: je,
                    normalize: function (t, e, i) {
                        return Ze(t, e, 0, 1, i)
                    },
                    getUnit: Ie,
                    clamp: function (t, e, i) {
                        return Le(i, (function (i) {
                            return Oe(t, e, i)
                        }))
                    },
                    splitColor: ei,
                    toArray: Be,
                    selector: ze,
                    mapRange: Ze,
                    pipe: function () {
                        for (var t = arguments.length, e = new Array(t), i = 0; i < t; i++) e[i] = arguments[i];
                        return function (t) {
                            return e.reduce((function (t, e) {
                                return e(t)
                            }), t)
                        }
                    },
                    unitize: function (t, e) {
                        return function (i) {
                            return t(parseFloat(i)) + (e || Ie(i))
                        }
                    },
                    interpolate: function t(e, i, r, n) {
                        var a = isNaN(e + i) ? 0 : function (t) {
                            return (1 - t) * e + t * i
                        };
                        if (!a) {
                            var s, o, l, c, u, h = ht(e),
                                d = {};
                            if (!0 === r && (n = 1) && (r = null), h) e = {
                                p: e
                            }, i = {
                                p: i
                            };
                            else if (_t(e) && !_t(i)) {
                                for (l = [], c = e.length, u = c - 2, o = 1; o < c; o++) l.push(t(e[o - 1], e[o]));
                                c--, a = function (t) {
                                    t *= c;
                                    var e = Math.min(u, ~~t);
                                    return l[e](t - e)
                                }, r = i
                            } else n || (e = ae(_t(e) ? [] : {}, e));
                            if (!l) {
                                for (s in i) Ti.call(d, e, s, "get", i[s]);
                                a = function (t) {
                                    return Yi(t, d) || (h ? e.p : e)
                                }
                            }
                        }
                        return Le(r, a)
                    },
                    shuffle: qe
                },
                install: Pt,
                effects: Yt,
                ticker: oi,
                updateRoot: Ai.updateRoot,
                plugins: Vt,
                globalTimeline: j,
                core: {
                    PropTween: Zi,
                    globals: Ot,
                    Tween: Oi,
                    Timeline: Ai,
                    Animation: wi,
                    getCache: Zt,
                    _removeLinkedListItem: ue,
                    reverting: function () {
                        return V
                    },
                    context: function (t) {
                        return t && Y && (Y.data.push(t), t._ctx = Y), Y
                    },
                    suppressOverwrites: function (t) {
                        return q = t
                    }
                }
            };
        Ut("to,from,fromTo,delayedCall,set,killTweensOf", (function (t) {
            return ir[t] = Oi[t]
        })), oi.add(Ai.updateRoot), U = ir.to({}, {
            duration: 0
        });
        var rr = function (t, e) {
            for (var i = t._pt; i && i.p !== e && i.op !== e && i.fp !== e;) i = i._next;
            return i
        },
            nr = function (t, e) {
                return {
                    name: t,
                    rawVars: 1,
                    init: function (t, i, r) {
                        r._onInit = function (t) {
                            var r, n;
                            if (ht(i) && (r = {}, Ut(i, (function (t) {
                                return r[t] = 1
                            })), i = r), e) {
                                for (n in r = {}, i) r[n] = e(i[n]);
                                i = r
                            } ! function (t, e) {
                                var i, r, n, a = t._targets;
                                for (i in e)
                                    for (r = a.length; r--;)(n = t._ptLookup[r][i]) && (n = n.d) && (n._pt && (n = rr(n, i)), n && n.modifier && n.modifier(e[i], t, a[r], i))
                            }(t, i)
                        }
                    }
                }
            },
            ar = ir.registerPlugin({
                name: "attr",
                init: function (t, e, i, r, n) {
                    var a, s, o;
                    for (a in this.tween = i, e) o = t.getAttribute(a) || "", (s = this.add(t, "setAttribute", (o || 0) + "", e[a], r, n, 0, 0, a)).op = a, s.b = o, this._props.push(a)
                },
                render: function (t, e) {
                    for (var i = e._pt; i;) V ? i.set(i.t, i.p, i.b, i) : i.r(t, i.d), i = i._next
                }
            }, {
                name: "endArray",
                init: function (t, e) {
                    for (var i = e.length; i--;) this.add(t, i, t[i] || 0, e[i], 0, 0, 0, 0, 0, 1)
                }
            }, nr("roundProps", Ye), nr("modifiers"), nr("snap", je)) || ir;
        Oi.version = Ai.version = ar.version = "3.11.4", Z = 1, vt() && li();
        ci.Power0, ci.Power1, ci.Power2, ci.Power3, ci.Power4, ci.Linear, ci.Quad, ci.Cubic, ci.Quart, ci.Quint, ci.Strong, ci.Elastic, ci.Back, ci.SteppedEase, ci.Bounce, ci.Sine, ci.Expo, ci.Circ;
        var sr, or, lr, cr, ur, hr, dr, pr, fr = {},
            mr = 180 / Math.PI,
            gr = Math.PI / 180,
            vr = Math.atan2,
            yr = /([A-Z])/g,
            br = /(left|right|width|margin|padding|x)/i,
            _r = /[\s,\(]\S/,
            wr = {
                autoAlpha: "opacity,visibility",
                scale: "scaleX,scaleY",
                alpha: "opacity"
            },
            Ar = function (t, e) {
                return e.set(e.t, e.p, Math.round(1e4 * (e.s + e.c * t)) / 1e4 + e.u, e)
            },
            Sr = function (t, e) {
                return e.set(e.t, e.p, 1 === t ? e.e : Math.round(1e4 * (e.s + e.c * t)) / 1e4 + e.u, e)
            },
            kr = function (t, e) {
                return e.set(e.t, e.p, t ? Math.round(1e4 * (e.s + e.c * t)) / 1e4 + e.u : e.b, e)
            },
            xr = function (t, e) {
                var i = e.s + e.c * t;
                e.set(e.t, e.p, ~~(i + (i < 0 ? -.5 : .5)) + e.u, e)
            },
            Tr = function (t, e) {
                return e.set(e.t, e.p, t ? e.e : e.b, e)
            },
            Er = function (t, e) {
                return e.set(e.t, e.p, 1 !== t ? e.b : e.e, e)
            },
            Mr = function (t, e, i) {
                return t.style[e] = i
            },
            Cr = function (t, e, i) {
                return t.style.setProperty(e, i)
            },
            Pr = function (t, e, i) {
                return t._gsap[e] = i
            },
            Dr = function (t, e, i) {
                return t._gsap.scaleX = t._gsap.scaleY = i
            },
            Lr = function (t, e, i, r, n) {
                var a = t._gsap;
                a.scaleX = a.scaleY = i, a.renderTransform(n, a)
            },
            Or = function (t, e, i, r, n) {
                var a = t._gsap;
                a[e] = i, a.renderTransform(n, a)
            },
            Ir = "transform",
            Rr = Ir + "Origin",
            Fr = function (t, e) {
                var i = this,
                    r = this.target,
                    n = r.style;
                if (t in fr) {
                    if (this.tfm = this.tfm || {}, "transform" !== t && (~(t = wr[t] || t).indexOf(",") ? t.split(",").forEach((function (t) {
                        return i.tfm[t] = tn(r, t)
                    })) : this.tfm[t] = r._gsap.x ? r._gsap[t] : tn(r, t)), this.props.indexOf(Ir) >= 0) return;
                    r._gsap.svg && (this.svgo = r.getAttribute("data-svg-origin"), this.props.push(Rr, e, "")), t = Ir
                } (n || e) && this.props.push(t, e, n[t])
            },
            Nr = function (t) {
                t.translate && (t.removeProperty("translate"), t.removeProperty("scale"), t.removeProperty("rotate"))
            },
            Br = function () {
                var t, e, i = this.props,
                    r = this.target,
                    n = r.style,
                    a = r._gsap;
                for (t = 0; t < i.length; t += 3) i[t + 1] ? r[i[t]] = i[t + 2] : i[t + 2] ? n[i[t]] = i[t + 2] : n.removeProperty(i[t].replace(yr, "-$1").toLowerCase());
                if (this.tfm) {
                    for (e in this.tfm) a[e] = this.tfm[e];
                    a.svg && (a.renderTransform(), r.setAttribute("data-svg-origin", this.svgo || "")), !(t = dr()) || t.isStart || n[Ir] || (Nr(n), a.uncache = 1)
                }
            },
            zr = function (t, e) {
                var i = {
                    target: t,
                    props: [],
                    revert: Br,
                    save: Fr
                };
                return e && e.split(",").forEach((function (t) {
                    return i.save(t)
                })), i
            },
            qr = function (t, e) {
                var i = or.createElementNS ? or.createElementNS((e || "http://www.w3.org/1999/xhtml").replace(/^https/, "http"), t) : or.createElement(t);
                return i.style ? i : or.createElement(t)
            },
            Vr = function t(e, i, r) {
                var n = getComputedStyle(e);
                return n[i] || n.getPropertyValue(i.replace(yr, "-$1").toLowerCase()) || n.getPropertyValue(i) || !r && t(e, jr(i) || i, 1) || ""
            },
            Yr = "O,Moz,ms,Ms,Webkit".split(","),
            jr = function (t, e, i) {
                var r = (e || ur).style,
                    n = 5;
                if (t in r && !i) return t;
                for (t = t.charAt(0).toUpperCase() + t.substr(1); n-- && !(Yr[n] + t in r););
                return n < 0 ? null : (3 === n ? "ms" : n >= 0 ? Yr[n] : "") + t
            },
            Gr = function () {
                "undefined" != typeof window && window.document && (sr = window, or = sr.document, lr = or.documentElement, ur = qr("div") || {
                    style: {}
                }, qr("div"), Ir = jr(Ir), Rr = Ir + "Origin", ur.style.cssText = "border-width:0;line-height:0;position:absolute;padding:0", pr = !!jr("perspective"), dr = ar.core.reverting, cr = 1)
            },
            Hr = function t(e) {
                var i, r = qr("svg", this.ownerSVGElement && this.ownerSVGElement.getAttribute("xmlns") || "http://www.w3.org/2000/svg"),
                    n = this.parentNode,
                    a = this.nextSibling,
                    s = this.style.cssText;
                if (lr.appendChild(r), r.appendChild(this), this.style.display = "block", e) try {
                    i = this.getBBox(), this._gsapBBox = this.getBBox, this.getBBox = t
                } catch (t) { } else this._gsapBBox && (i = this._gsapBBox());
                return n && (a ? n.insertBefore(this, a) : n.appendChild(this)), lr.removeChild(r), this.style.cssText = s, i
            },
            Wr = function (t, e) {
                for (var i = e.length; i--;)
                    if (t.hasAttribute(e[i])) return t.getAttribute(e[i])
            },
            Zr = function (t) {
                var e;
                try {
                    e = t.getBBox()
                } catch (i) {
                    e = Hr.call(t, !0)
                }
                return e && (e.width || e.height) || t.getBBox === Hr || (e = Hr.call(t, !0)), !e || e.width || e.x || e.y ? e : {
                    x: +Wr(t, ["x", "cx", "x1"]) || 0,
                    y: +Wr(t, ["y", "cy", "y1"]) || 0,
                    width: 0,
                    height: 0
                }
            },
            $r = function (t) {
                return !(!t.getCTM || t.parentNode && !t.ownerSVGElement || !Zr(t))
            },
            Ur = function (t, e) {
                if (e) {
                    var i = t.style;
                    e in fr && e !== Rr && (e = Ir), i.removeProperty ? ("ms" !== e.substr(0, 2) && "webkit" !== e.substr(0, 6) || (e = "-" + e), i.removeProperty(e.replace(yr, "-$1").toLowerCase())) : i.removeAttribute(e)
                }
            },
            Xr = function (t, e, i, r, n, a) {
                var s = new Zi(t._pt, e, i, 0, 1, a ? Er : Tr);
                return t._pt = s, s.b = r, s.e = n, t._props.push(i), s
            },
            Kr = {
                deg: 1,
                rad: 1,
                turn: 1
            },
            Jr = {
                grid: 1,
                flex: 1
            },
            Qr = function t(e, i, r, n) {
                var a, s, o, l, c = parseFloat(r) || 0,
                    u = (r + "").trim().substr((c + "").length) || "px",
                    h = ur.style,
                    d = br.test(i),
                    p = "svg" === e.tagName.toLowerCase(),
                    f = (p ? "client" : "offset") + (d ? "Width" : "Height"),
                    m = 100,
                    g = "px" === n,
                    v = "%" === n;
                return n === u || !c || Kr[n] || Kr[u] ? c : ("px" !== u && !g && (c = t(e, i, r, "px")), l = e.getCTM && $r(e), !v && "%" !== u || !fr[i] && !~i.indexOf("adius") ? (h[d ? "width" : "height"] = m + (g ? u : n), s = ~i.indexOf("adius") || "em" === n && e.appendChild && !p ? e : e.parentNode, l && (s = (e.ownerSVGElement || {}).parentNode), s && s !== or && s.appendChild || (s = or.body), (o = s._gsap) && v && o.width && d && o.time === oi.time && !o.uncache ? Xt(c / o.width * m) : ((v || "%" === u) && !Jr[Vr(s, "display")] && (h.position = Vr(e, "position")), s === e && (h.position = "static"), s.appendChild(ur), a = ur[f], s.removeChild(ur), h.position = "absolute", d && v && ((o = Zt(s)).time = oi.time, o.width = s[f]), Xt(g ? a * c / m : a && c ? m / a * c : 0))) : (a = l ? e.getBBox()[d ? "width" : "height"] : e[f], Xt(v ? c / a * m : c / 100 * a)))
            },
            tn = function (t, e, i, r) {
                var n;
                return cr || Gr(), e in wr && "transform" !== e && ~(e = wr[e]).indexOf(",") && (e = e.split(",")[0]), fr[e] && "transform" !== e ? (n = pn(t, r), n = "transformOrigin" !== e ? n[e] : n.svg ? n.origin : fn(Vr(t, Rr)) + " " + n.zOrigin + "px") : (!(n = t.style[e]) || "auto" === n || r || ~(n + "").indexOf("calc(")) && (n = sn[e] && sn[e](t, e, i) || Vr(t, e) || $t(t, e) || ("opacity" === e ? 1 : 0)), i && !~(n + "").trim().indexOf(" ") ? Qr(t, e, n, i) + i : n
            },
            en = function (t, e, i, r) {
                if (!i || "none" === i) {
                    var n = jr(e, t, 1),
                        a = n && Vr(t, n, 1);
                    a && a !== i ? (e = n, i = a) : "borderColor" === e && (i = Vr(t, "borderTopColor"))
                }
                var s, o, l, c, u, h, d, p, f, m, g, v = new Zi(this._pt, t.style, e, 0, 1, Vi),
                    y = 0,
                    b = 0;
                if (v.b = i, v.e = r, i += "", "auto" === (r += "") && (t.style[e] = r, r = Vr(t, e) || r, t.style[e] = i), si(s = [i, r]), r = s[1], l = (i = s[0]).match(St) || [], (r.match(St) || []).length) {
                    for (; o = St.exec(r);) d = o[0], f = r.substring(y, o.index), u ? u = (u + 1) % 5 : "rgba(" !== f.substr(-5) && "hsla(" !== f.substr(-5) || (u = 1), d !== (h = l[b++] || "") && (c = parseFloat(h) || 0, g = h.substr((c + "").length), "=" === d.charAt(1) && (d = Jt(c, d) + g), p = parseFloat(d), m = d.substr((p + "").length), y = St.lastIndex - m.length, m || (m = m || et.units[e] || g, y === r.length && (r += m, v.e += m)), g !== m && (c = Qr(t, e, h, m) || 0), v._pt = {
                        _next: v._pt,
                        p: f || 1 === b ? f : ",",
                        s: c,
                        c: p - c,
                        m: u && u < 4 || "zIndex" === e ? Math.round : 0
                    });
                    v.c = y < r.length ? r.substring(y, r.length) : ""
                } else v.r = "display" === e && "none" === r ? Er : Tr;
                return xt.test(r) && (v.e = 0), this._pt = v, v
            },
            rn = {
                top: "0%",
                bottom: "100%",
                left: "0%",
                right: "100%",
                center: "50%"
            },
            nn = function (t) {
                var e = t.split(" "),
                    i = e[0],
                    r = e[1] || "50%";
                return "top" !== i && "bottom" !== i && "left" !== r && "right" !== r || (t = i, i = r, r = t), e[0] = rn[i] || i, e[1] = rn[r] || r, e.join(" ")
            },
            an = function (t, e) {
                if (e.tween && e.tween._time === e.tween._dur) {
                    var i, r, n, a = e.t,
                        s = a.style,
                        o = e.u,
                        l = a._gsap;
                    if ("all" === o || !0 === o) s.cssText = "", r = 1;
                    else
                        for (n = (o = o.split(",")).length; --n > -1;) i = o[n], fr[i] && (r = 1, i = "transformOrigin" === i ? Rr : Ir), Ur(a, i);
                    r && (Ur(a, Ir), l && (l.svg && a.removeAttribute("transform"), pn(a, 1), l.uncache = 1, Nr(s)))
                }
            },
            sn = {
                clearProps: function (t, e, i, r, n) {
                    if ("isFromStart" !== n.data) {
                        var a = t._pt = new Zi(t._pt, e, i, 0, 0, an);
                        return a.u = r, a.pr = -10, a.tween = n, t._props.push(i), 1
                    }
                }
            },
            on = [1, 0, 0, 1, 0, 0],
            ln = {},
            cn = function (t) {
                return "matrix(1, 0, 0, 1, 0, 0)" === t || "none" === t || !t
            },
            un = function (t) {
                var e = Vr(t, Ir);
                return cn(e) ? on : e.substr(7).match(At).map(Xt)
            },
            hn = function (t, e) {
                var i, r, n, a, s = t._gsap || Zt(t),
                    o = t.style,
                    l = un(t);
                return s.svg && t.getAttribute("transform") ? "1,0,0,1,0,0" === (l = [(n = t.transform.baseVal.consolidate().matrix).a, n.b, n.c, n.d, n.e, n.f]).join(",") ? on : l : (l !== on || t.offsetParent || t === lr || s.svg || (n = o.display, o.display = "block", (i = t.parentNode) && t.offsetParent || (a = 1, r = t.nextElementSibling, lr.appendChild(t)), l = un(t), n ? o.display = n : Ur(t, "display"), a && (r ? i.insertBefore(t, r) : i ? i.appendChild(t) : lr.removeChild(t))), e && l.length > 6 ? [l[0], l[1], l[4], l[5], l[12], l[13]] : l)
            },
            dn = function (t, e, i, r, n, a) {
                var s, o, l, c = t._gsap,
                    u = n || hn(t, !0),
                    h = c.xOrigin || 0,
                    d = c.yOrigin || 0,
                    p = c.xOffset || 0,
                    f = c.yOffset || 0,
                    m = u[0],
                    g = u[1],
                    v = u[2],
                    y = u[3],
                    b = u[4],
                    _ = u[5],
                    w = e.split(" "),
                    A = parseFloat(w[0]) || 0,
                    S = parseFloat(w[1]) || 0;
                i ? u !== on && (o = m * y - g * v) && (l = A * (-g / o) + S * (m / o) - (m * _ - g * b) / o, A = A * (y / o) + S * (-v / o) + (v * _ - y * b) / o, S = l) : (A = (s = Zr(t)).x + (~w[0].indexOf("%") ? A / 100 * s.width : A), S = s.y + (~(w[1] || w[0]).indexOf("%") ? S / 100 * s.height : S)), r || !1 !== r && c.smooth ? (b = A - h, _ = S - d, c.xOffset = p + (b * m + _ * v) - b, c.yOffset = f + (b * g + _ * y) - _) : c.xOffset = c.yOffset = 0, c.xOrigin = A, c.yOrigin = S, c.smooth = !!r, c.origin = e, c.originIsAbsolute = !!i, t.style[Rr] = "0px 0px", a && (Xr(a, c, "xOrigin", h, A), Xr(a, c, "yOrigin", d, S), Xr(a, c, "xOffset", p, c.xOffset), Xr(a, c, "yOffset", f, c.yOffset)), t.setAttribute("data-svg-origin", A + " " + S)
            },
            pn = function (t, e) {
                var i = t._gsap || new _i(t);
                if ("x" in i && !e && !i.uncache) return i;
                var r, n, a, s, o, l, c, u, h, d, p, f, m, g, v, y, b, _, w, A, S, k, x, T, E, M, C, P, D, L, O, I, R = t.style,
                    F = i.scaleX < 0,
                    N = "px",
                    B = "deg",
                    z = getComputedStyle(t),
                    q = Vr(t, Rr) || "0";
                return r = n = a = l = c = u = h = d = p = 0, s = o = 1, i.svg = !(!t.getCTM || !$r(t)), z.translate && ("none" === z.translate && "none" === z.scale && "none" === z.rotate || (R[Ir] = ("none" !== z.translate ? "translate3d(" + (z.translate + " 0 0").split(" ").slice(0, 3).join(", ") + ") " : "") + ("none" !== z.rotate ? "rotate(" + z.rotate + ") " : "") + ("none" !== z.scale ? "scale(" + z.scale.split(" ").join(",") + ") " : "") + ("none" !== z[Ir] ? z[Ir] : "")), R.scale = R.rotate = R.translate = "none"), g = hn(t, i.svg), i.svg && (i.uncache ? (E = t.getBBox(), q = i.xOrigin - E.x + "px " + (i.yOrigin - E.y) + "px", T = "") : T = !e && t.getAttribute("data-svg-origin"), dn(t, T || q, !!T || i.originIsAbsolute, !1 !== i.smooth, g)), f = i.xOrigin || 0, m = i.yOrigin || 0, g !== on && (_ = g[0], w = g[1], A = g[2], S = g[3], r = k = g[4], n = x = g[5], 6 === g.length ? (s = Math.sqrt(_ * _ + w * w), o = Math.sqrt(S * S + A * A), l = _ || w ? vr(w, _) * mr : 0, (h = A || S ? vr(A, S) * mr + l : 0) && (o *= Math.abs(Math.cos(h * gr))), i.svg && (r -= f - (f * _ + m * A), n -= m - (f * w + m * S))) : (I = g[6], L = g[7], C = g[8], P = g[9], D = g[10], O = g[11], r = g[12], n = g[13], a = g[14], c = (v = vr(I, D)) * mr, v && (T = k * (y = Math.cos(-v)) + C * (b = Math.sin(-v)), E = x * y + P * b, M = I * y + D * b, C = k * -b + C * y, P = x * -b + P * y, D = I * -b + D * y, O = L * -b + O * y, k = T, x = E, I = M), u = (v = vr(-A, D)) * mr, v && (y = Math.cos(-v), O = S * (b = Math.sin(-v)) + O * y, _ = T = _ * y - C * b, w = E = w * y - P * b, A = M = A * y - D * b), l = (v = vr(w, _)) * mr, v && (T = _ * (y = Math.cos(v)) + w * (b = Math.sin(v)), E = k * y + x * b, w = w * y - _ * b, x = x * y - k * b, _ = T, k = E), c && Math.abs(c) + Math.abs(l) > 359.9 && (c = l = 0, u = 180 - u), s = Xt(Math.sqrt(_ * _ + w * w + A * A)), o = Xt(Math.sqrt(x * x + I * I)), v = vr(k, x), h = Math.abs(v) > 2e-4 ? v * mr : 0, p = O ? 1 / (O < 0 ? -O : O) : 0), i.svg && (T = t.getAttribute("transform"), i.forceCSS = t.setAttribute("transform", "") || !cn(Vr(t, Ir)), T && t.setAttribute("transform", T))), Math.abs(h) > 90 && Math.abs(h) < 270 && (F ? (s *= -1, h += l <= 0 ? 180 : -180, l += l <= 0 ? 180 : -180) : (o *= -1, h += h <= 0 ? 180 : -180)), e = e || i.uncache, i.x = r - ((i.xPercent = r && (!e && i.xPercent || (Math.round(t.offsetWidth / 2) === Math.round(-r) ? -50 : 0))) ? t.offsetWidth * i.xPercent / 100 : 0) + N, i.y = n - ((i.yPercent = n && (!e && i.yPercent || (Math.round(t.offsetHeight / 2) === Math.round(-n) ? -50 : 0))) ? t.offsetHeight * i.yPercent / 100 : 0) + N, i.z = a + N, i.scaleX = Xt(s), i.scaleY = Xt(o), i.rotation = Xt(l) + B, i.rotationX = Xt(c) + B, i.rotationY = Xt(u) + B, i.skewX = h + B, i.skewY = d + B, i.transformPerspective = p + N, (i.zOrigin = parseFloat(q.split(" ")[2]) || 0) && (R[Rr] = fn(q)), i.xOffset = i.yOffset = 0, i.force3D = et.force3D, i.renderTransform = i.svg ? wn : pr ? _n : gn, i.uncache = 0, i
            },
            fn = function (t) {
                return (t = t.split(" "))[0] + " " + t[1]
            },
            mn = function (t, e, i) {
                var r = Ie(e);
                return Xt(parseFloat(e) + parseFloat(Qr(t, "x", i + "px", r))) + r
            },
            gn = function (t, e) {
                e.z = "0px", e.rotationY = e.rotationX = "0deg", e.force3D = 0, _n(t, e)
            },
            vn = "0deg",
            yn = "0px",
            bn = ") ",
            _n = function (t, e) {
                var i = e || this,
                    r = i.xPercent,
                    n = i.yPercent,
                    a = i.x,
                    s = i.y,
                    o = i.z,
                    l = i.rotation,
                    c = i.rotationY,
                    u = i.rotationX,
                    h = i.skewX,
                    d = i.skewY,
                    p = i.scaleX,
                    f = i.scaleY,
                    m = i.transformPerspective,
                    g = i.force3D,
                    v = i.target,
                    y = i.zOrigin,
                    b = "",
                    _ = "auto" === g && t && 1 !== t || !0 === g;
                if (y && (u !== vn || c !== vn)) {
                    var w, A = parseFloat(c) * gr,
                        S = Math.sin(A),
                        k = Math.cos(A);
                    A = parseFloat(u) * gr, w = Math.cos(A), a = mn(v, a, S * w * -y), s = mn(v, s, -Math.sin(A) * -y), o = mn(v, o, k * w * -y + y)
                }
                m !== yn && (b += "perspective(" + m + bn), (r || n) && (b += "translate(" + r + "%, " + n + "%) "), (_ || a !== yn || s !== yn || o !== yn) && (b += o !== yn || _ ? "translate3d(" + a + ", " + s + ", " + o + ") " : "translate(" + a + ", " + s + bn), l !== vn && (b += "rotate(" + l + bn), c !== vn && (b += "rotateY(" + c + bn), u !== vn && (b += "rotateX(" + u + bn), h === vn && d === vn || (b += "skew(" + h + ", " + d + bn), 1 === p && 1 === f || (b += "scale(" + p + ", " + f + bn), v.style[Ir] = b || "translate(0px, 0)"
            },
            wn = function (t, e) {
                var i, r, n, a, s, o = e || this,
                    l = o.xPercent,
                    c = o.yPercent,
                    u = o.x,
                    h = o.y,
                    d = o.rotation,
                    p = o.skewX,
                    f = o.skewY,
                    m = o.scaleX,
                    g = o.scaleY,
                    v = o.target,
                    y = o.xOrigin,
                    b = o.yOrigin,
                    _ = o.xOffset,
                    w = o.yOffset,
                    A = o.forceCSS,
                    S = parseFloat(u),
                    k = parseFloat(h);
                d = parseFloat(d), p = parseFloat(p), (f = parseFloat(f)) && (p += f = parseFloat(f), d += f), d || p ? (d *= gr, p *= gr, i = Math.cos(d) * m, r = Math.sin(d) * m, n = Math.sin(d - p) * -g, a = Math.cos(d - p) * g, p && (f *= gr, s = Math.tan(p - f), n *= s = Math.sqrt(1 + s * s), a *= s, f && (s = Math.tan(f), i *= s = Math.sqrt(1 + s * s), r *= s)), i = Xt(i), r = Xt(r), n = Xt(n), a = Xt(a)) : (i = m, a = g, r = n = 0), (S && !~(u + "").indexOf("px") || k && !~(h + "").indexOf("px")) && (S = Qr(v, "x", u, "px"), k = Qr(v, "y", h, "px")), (y || b || _ || w) && (S = Xt(S + y - (y * i + b * n) + _), k = Xt(k + b - (y * r + b * a) + w)), (l || c) && (s = v.getBBox(), S = Xt(S + l / 100 * s.width), k = Xt(k + c / 100 * s.height)), s = "matrix(" + i + "," + r + "," + n + "," + a + "," + S + "," + k + ")", v.setAttribute("transform", s), A && (v.style[Ir] = s)
            },
            An = function (t, e, i, r, n) {
                var a, s, o = 360,
                    l = ht(n),
                    c = parseFloat(n) * (l && ~n.indexOf("rad") ? mr : 1) - r,
                    u = r + c + "deg";
                return l && ("short" === (a = n.split("_")[1]) && (c %= o) !== c % 180 && (c += c < 0 ? o : -360), "cw" === a && c < 0 ? c = (c + 36e9) % o - ~~(c / o) * o : "ccw" === a && c > 0 && (c = (c - 36e9) % o - ~~(c / o) * o)), t._pt = s = new Zi(t._pt, e, i, r, c, Sr), s.e = u, s.u = "deg", t._props.push(i), s
            },
            Sn = function (t, e) {
                for (var i in e) t[i] = e[i];
                return t
            },
            kn = function (t, e, i) {
                var r, n, a, s, o, l, c, u = Sn({}, i._gsap),
                    h = i.style;
                for (n in u.svg ? (a = i.getAttribute("transform"), i.setAttribute("transform", ""), h[Ir] = e, r = pn(i, 1), Ur(i, Ir), i.setAttribute("transform", a)) : (a = getComputedStyle(i)[Ir], h[Ir] = e, r = pn(i, 1), h[Ir] = a), fr) (a = u[n]) !== (s = r[n]) && "perspective,force3D,transformOrigin,svgOrigin".indexOf(n) < 0 && (o = Ie(a) !== (c = Ie(s)) ? Qr(i, n, a, c) : parseFloat(a), l = parseFloat(s), t._pt = new Zi(t._pt, r, n, o, l - o, Ar), t._pt.u = c || 0, t._props.push(n));
                Sn(r, u)
            };
        Ut("padding,margin,Width,Radius", (function (t, e) {
            var i = "Top",
                r = "Right",
                n = "Bottom",
                a = "Left",
                s = (e < 3 ? [i, r, n, a] : [i + a, i + r, n + r, n + a]).map((function (i) {
                    return e < 2 ? t + i : "border" + i + t
                }));
            sn[e > 1 ? "border" + t : t] = function (t, e, i, r, n) {
                var a, o;
                if (arguments.length < 4) return a = s.map((function (e) {
                    return tn(t, e, i)
                })), 5 === (o = a.join(" ")).split(a[0]).length ? a[0] : o;
                a = (r + "").split(" "), o = {}, s.forEach((function (t, e) {
                    return o[t] = a[e] = a[e] || a[(e - 1) / 2 | 0]
                })), t.init(e, o, n)
            }
        }));
        var xn, Tn, En, Mn = {
            name: "css",
            register: Gr,
            targetTest: function (t) {
                return t.style && t.nodeType
            },
            init: function (t, e, i, r, n) {
                var a, s, o, l, c, u, h, d, p, f, m, g, v, y, b, _, w = this._props,
                    A = t.style,
                    S = i.vars.startAt;
                for (h in cr || Gr(), this.styles = this.styles || zr(t), _ = this.styles.props, this.tween = i, e)
                    if ("autoRound" !== h && (s = e[h], !Vt[h] || !Ei(h, e, i, r, t, n)))
                        if (c = typeof s, u = sn[h], "function" === c && (c = typeof (s = s.call(i, r, t, n))), "string" === c && ~s.indexOf("random(") && (s = We(s)), u) u(this, t, h, s, i) && (b = 1);
                        else if ("--" === h.substr(0, 2)) a = (getComputedStyle(t).getPropertyValue(h) + "").trim(), s += "", ni.lastIndex = 0, ni.test(a) || (d = Ie(a), p = Ie(s)), p ? d !== p && (a = Qr(t, h, a, p) + p) : d && (s += d), this.add(A, "setProperty", a, s, r, n, 0, 0, h), w.push(h), _.push(h, 0, A[h]);
                        else if ("undefined" !== c) {
                            if (S && h in S ? (a = "function" == typeof S[h] ? S[h].call(i, r, t, n) : S[h], ht(a) && ~a.indexOf("random(") && (a = We(a)), Ie(a + "") || (a += et.units[h] || Ie(tn(t, h)) || ""), "=" === (a + "").charAt(1) && (a = tn(t, h))) : a = tn(t, h), l = parseFloat(a), (f = "string" === c && "=" === s.charAt(1) && s.substr(0, 2)) && (s = s.substr(2)), o = parseFloat(s), h in wr && ("autoAlpha" === h && (1 === l && "hidden" === tn(t, "visibility") && o && (l = 0), _.push("visibility", 0, A.visibility), Xr(this, A, "visibility", l ? "inherit" : "hidden", o ? "inherit" : "hidden", !o)), "scale" !== h && "transform" !== h && ~(h = wr[h]).indexOf(",") && (h = h.split(",")[0])), m = h in fr)
                                if (this.styles.save(h), g || ((v = t._gsap).renderTransform && !e.parseTransform || pn(t, e.parseTransform), y = !1 !== e.smoothOrigin && v.smooth, (g = this._pt = new Zi(this._pt, A, Ir, 0, 1, v.renderTransform, v, 0, -1)).dep = 1), "scale" === h) this._pt = new Zi(this._pt, v, "scaleY", v.scaleY, (f ? Jt(v.scaleY, f + o) : o) - v.scaleY || 0, Ar), this._pt.u = 0, w.push("scaleY", h), h += "X";
                                else {
                                    if ("transformOrigin" === h) {
                                        _.push(Rr, 0, A[Rr]), s = nn(s), v.svg ? dn(t, s, 0, y, 0, this) : ((p = parseFloat(s.split(" ")[2]) || 0) !== v.zOrigin && Xr(this, v, "zOrigin", v.zOrigin, p), Xr(this, A, h, fn(a), fn(s)));
                                        continue
                                    }
                                    if ("svgOrigin" === h) {
                                        dn(t, s, 1, y, 0, this);
                                        continue
                                    }
                                    if (h in ln) {
                                        An(this, v, h, l, f ? Jt(l, f + s) : s);
                                        continue
                                    }
                                    if ("smoothOrigin" === h) {
                                        Xr(this, v, "smooth", v.smooth, s);
                                        continue
                                    }
                                    if ("force3D" === h) {
                                        v[h] = s;
                                        continue
                                    }
                                    if ("transform" === h) {
                                        kn(this, s, t);
                                        continue
                                    }
                                }
                            else h in A || (h = jr(h) || h);
                            if (m || (o || 0 === o) && (l || 0 === l) && !_r.test(s) && h in A) o || (o = 0), (d = (a + "").substr((l + "").length)) !== (p = Ie(s) || (h in et.units ? et.units[h] : d)) && (l = Qr(t, h, a, p)), this._pt = new Zi(this._pt, m ? v : A, h, l, (f ? Jt(l, f + o) : o) - l, m || "px" !== p && "zIndex" !== h || !1 === e.autoRound ? Ar : xr), this._pt.u = p || 0, d !== p && "%" !== p && (this._pt.b = a, this._pt.r = kr);
                            else if (h in A) en.call(this, t, h, a, f ? f + s : s);
                            else if (h in t) this.add(t, h, a || t[h], f ? f + s : s, r, n);
                            else if ("parseTransform" !== h) {
                                Dt(h, s);
                                continue
                            }
                            m || (h in A ? _.push(h, 0, A[h]) : _.push(h, 1, a || t[h])), w.push(h)
                        }
                b && Wi(this)
            },
            render: function (t, e) {
                if (e.tween._time || !dr())
                    for (var i = e._pt; i;) i.r(t, i.d), i = i._next;
                else e.styles.revert()
            },
            get: tn,
            aliases: wr,
            getSetter: function (t, e, i) {
                var r = wr[e];
                return r && r.indexOf(",") < 0 && (e = r), e in fr && e !== Rr && (t._gsap.x || tn(t, "x")) ? i && hr === i ? "scale" === e ? Dr : Pr : (hr = i || {}) && ("scale" === e ? Lr : Or) : t.style && !ft(t.style[e]) ? Mr : ~e.indexOf("-") ? Cr : Bi(t, e)
            },
            core: {
                _removeProperty: Ur,
                _getMatrix: hn
            }
        };
        ar.utils.checkPrefix = jr, ar.core.getStyleSaver = zr, En = Ut((xn = "x,y,z,scale,scaleX,scaleY,xPercent,yPercent") + "," + (Tn = "rotation,rotationX,rotationY,skewX,skewY") + ",transform,transformOrigin,svgOrigin,force3D,smoothOrigin,transformPerspective", (function (t) {
            fr[t] = 1
        })), Ut(Tn, (function (t) {
            et.units[t] = "deg", ln[t] = 1
        })), wr[En[13]] = xn + "," + Tn, Ut("0:translateX,1:translateY,2:translateZ,8:rotate,8:rotationZ,8:rotateZ,9:rotateX,10:rotateY", (function (t) {
            var e = t.split(":");
            wr[e[1]] = En[e[0]]
        })), Ut("x,y,z,top,right,bottom,left,width,height,fontSize,padding,margin,perspective", (function (t) {
            et.units[t] = "px"
        })), ar.registerPlugin(Mn);
        var Cn = ar.registerPlugin(Mn) || ar;
        Cn.core.Tween;

        function Pn(t) {
            var e = function () {
                if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                if (Reflect.construct.sham) return !1;
                if ("function" == typeof Proxy) return !0;
                try {
                    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], (function () { }))), !0
                } catch (t) {
                    return !1
                }
            }();
            return function () {
                var i, r = f(t);
                if (e) {
                    var n = f(this).constructor;
                    i = Reflect.construct(r, arguments, n)
                } else i = r.apply(this, arguments);
                return p(this, i)
            }
        }
        const Dn = function (t) {
            h(i, t);
            var e = Pn(i);

            function i() {
                return n(this, i), e.apply(this, arguments)
            }
            return l(i, [{
                key: "animate",
                value: function (t) {
                    var e = t.done;
                    Cn.fromTo(this.element, {
                        opacity: 0
                    }, {
                        opacity: 1,
                        duration: .5,
                        ease: "Power2.inOut",
                        onComplete: e
                    })
                }
            }, {
                key: "setDefault",
                value: function () {
                    Cn.set(this.element, {
                        opacity: 0
                    })
                }
            }, {
                key: "onViewportEnter",
                value: function () {
                    this.run((function () {
                        console.log("done")
                    }))
                }
            }]), i
        }(N);

        function Ln(t) {
            var e = function () {
                if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                if (Reflect.construct.sham) return !1;
                if ("function" == typeof Proxy) return !0;
                try {
                    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], (function () { }))), !0
                } catch (t) {
                    return !1
                }
            }();
            return function () {
                var i, r = f(t);
                if (e) {
                    var n = f(this).constructor;
                    i = Reflect.construct(r, arguments, n)
                } else i = r.apply(this, arguments);
                return p(this, i)
            }
        }
        var On = function (t) {
            h(i, t);
            var e = Ln(i);

            function i() {
                return n(this, i), e.apply(this, arguments)
            }
            return l(i, [{
                key: "setDefault",
                value: function () {
                    this.element.resetOnExit = !0
                }
            }, {
                key: "animate",
                value: function (t) {
                    var e = t.done,
                        i = this.element.dataset.scroll,
                        r = document.querySelector(".fixed-cta");
                    r && (window.Zero.scroll.direction.dir === i && (window.Zero.scroll.hasATC = !0, Cn.to(r, {
                        y: 0,
                        duration: .6
                    })), e())
                }
            }, {
                key: "onViewportEnter",
                value: function () { }
            }, {
                key: "onViewportExit",
                value: function () {
                    this.run((function () { }))
                }
            }]), i
        }(N),
            In = function (t) {
                h(i, t);
                var e = Ln(i);

                function i() {
                    return n(this, i), e.apply(this, arguments)
                }
                return l(i, [{
                    key: "setDefault",
                    value: function () {
                        this.element.resetOnExit = !0
                    }
                }, {
                    key: "animate",
                    value: function (t) {
                        t.done;
                        var e = this.element.dataset.scroll,
                            i = document.querySelector(".fixed-cta");
                        i && window.Zero.scroll.direction.dir === e && (window.Zero.scroll.hasATC = !1, Cn.to(i, {
                            y: "100%",
                            duration: .6
                        }))
                    }
                }, {
                    key: "onViewportEnter",
                    value: function () {
                        this.run((function () { }))
                    }
                }, {
                    key: "onViewportExit",
                    value: function () { }
                }]), i
            }(N);

        function Rn(t) {
            var e = function () {
                if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                if (Reflect.construct.sham) return !1;
                if ("function" == typeof Proxy) return !0;
                try {
                    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], (function () { }))), !0
                } catch (t) {
                    return !1
                }
            }();
            return function () {
                var i, r = f(t);
                if (e) {
                    var n = f(this).constructor;
                    i = Reflect.construct(r, arguments, n)
                } else i = r.apply(this, arguments);
                return p(this, i)
            }
        }
        var Fn = function (t) {
            h(i, t);
            var e = Rn(i);

            function i() {
                return n(this, i), e.apply(this, arguments)
            }
            return l(i, [{
                key: "animate",
                value: function (t) {
                    var e = t.done;
                    Cn.fromTo(this.animEls, {
                        opacity: 0,
                        top: "".concat(this.animTopShift, "px")
                    }, {
                        opacity: 1,
                        delay: .3,
                        duration: .6,
                        top: 0,
                        ease: "Power2.inOut",
                        stagger: .15,
                        onComplete: e
                    })
                }
            }, {
                key: "setDefault",
                value: function () {
                    this.enableAnim = !0, this.animTopShift = 30, this.parent = this.element.closest("section"), this.halfFrame = this.parent.id.indexOf("two-column") > -1, this.frame = this.parent.querySelector(".media"), this.frameIndex = this.frame ? Array.prototype.slice.call(this.frame.parentElement.children).indexOf(this.frame) : 0, this.scrollRunning = !1, this.imageThreshold = window.Zero.windowWidth > 768 ? 400 : 300, this.boundaryThreshold = window.Zero.windowWidth > 768 ? 60 : 30, this.boundaryMultiplier = .8, this.boundaryInset = window.Zero.windowWidth > 768 ? 40 : 20, this.maxScale = 1.15, this.minScale = .85, this.frame && window.Zero.windowWidth <= 768 && (this.imageThreshold = this.frame.clientWidth < 480 ? this.frame.clientWidth - this.boundaryThreshold : 300), this.bounding = {
                        height: this.frame ? this.frame.clientHeight : this.element.clientHeight,
                        width: !0 === this.halfFrame && window.Zero.windowWidth > 768 ? this.element.clientWidth / 2 : this.element.clientWidth
                    }, this.capacity = {
                        x: Math.floor(this.bounding.width / this.imageThreshold),
                        y: Math.floor(this.bounding.height / this.imageThreshold)
                    }, this.input = function (t) {
                        for (var e = t.length - 1; e > 0; e--) {
                            var i = Math.floor(Math.random() * (e + 1)),
                                r = [t[i], t[e]];
                            t[e] = r[0], t[i] = r[1]
                        }
                        return t
                    }(JSON.parse(this.element.dataset.images)), !this.input || this.input.length < 1 || (this.products = r(new Set(this.input.map((function (t) {
                        return t.product_id
                    })))), this.totalImages = 2 * this.capacity.x + 2 * this.capacity.y, this.imagesPerProduct = Math.ceil(this.totalImages / this.products.length), this.images = this.generateImageObject(this.input), this.writeImages(), this.imageWrap = this.element.querySelector(".image-frame-inner"), this.animEls = this.imageWrap.querySelectorAll("img"), window.Zero.lazyLoad.update())
                }
            }, {
                key: "generateImageObject",
                value: function (t) {
                    var e = [],
                        i = {
                            p: 0,
                            v: {},
                            i: {
                                t: 0,
                                r: 0,
                                b: 0,
                                l: 0
                            }
                        };
                    t: for (; e.length < this.totalImages;)
                        for (var r = 0; r < this.input.length; r++) {
                            var n = {},
                                a = this.input[r];
                            if (!i.v[a.id] || i.v[a.id] < this.imagesPerProduct) {
                                var s = this.imageThreshold - this.imageThreshold * this.boundaryMultiplier - this.boundaryThreshold,
                                    o = void 0,
                                    l = void 0,
                                    c = void 0,
                                    u = void 0,
                                    h = Math.ceil(i.p % 4);
                                if (0 == h && this.capacity.x > i.i.t ? (o = (this.imageThreshold + this.boundaryThreshold) * (i.i.t + 1), l = s + (i.i.t * this.imageThreshold + this.boundaryThreshold * (i.i.t + 1)), c = Math.floor(Math.random() * (o - l + 1)) + l, u = this.boundaryInset, ++i.i.t) : 1 == h && this.capacity.y > i.i.r ? (o = (this.imageThreshold + this.boundaryThreshold) * (i.i.r + 1), l = s + (i.i.r * this.imageThreshold + this.boundaryThreshold * (i.i.r + 1)), c = this.bounding.width - this.boundaryInset, u = Math.floor(Math.random() * (o - l + 1)) + l, ++i.i.r) : 2 == h && this.capacity.x > i.i.b ? (o = (this.imageThreshold + this.boundaryThreshold) * (i.i.b + 1), l = s + (i.i.b * this.imageThreshold + this.boundaryThreshold * (i.i.b + 1)), c = Math.floor(Math.random() * (o - l + 1)) + l, u = this.bounding.height - this.boundaryInset, ++i.i.b) : 3 == h && this.capacity.y > i.i.l && (o = (this.imageThreshold + this.boundaryThreshold) * (i.i.l + 1), l = s + (i.i.l * this.imageThreshold + this.boundaryThreshold * (i.i.l + 1)), c = this.boundaryInset, u = Math.floor(Math.random() * (o - l + 1)) + l, ++i.i.l), ++i.p, (c >= 0 || u >= 0) && (n.url = a.url, n.alt = a.alt, n.h = a.height, n.w = a.width, n.a = a.aspect_ratio, n.x = c, n.y = u, n.r = Math.floor(358 * Math.random()), n.s = Math.random() * (this.maxScale - this.minScale) + this.minScale, n.k = 0, e.push(n)), e.length >= this.totalImages) break t
                            }
                        }
                    return e
                }
            }, {
                key: "writeImages",
                value: function () {
                    var t = this,
                        e = document.createElement("div"),
                        i = document.createElement("div");
                    e.classList = "image-frame", i.classList = "image-frame-inner", this.halfFrame && this.frame && (i.classList.add("half"), i.style.height = this.frame.clientHeight + "px"), 1 === this.frameIndex && i.classList.add("right"), e.appendChild(i), this.element.prepend(e), r(this.images).forEach((function (e) {
                        var r = document.createElement("div"),
                            n = document.createElement("img"),
                            a = "--img-k: ".concat(e.k, "; --img-r: ").concat(e.r, "deg; --img-s: ").concat(e.s, ";");
                        r.classList = "image-object", r.style = "--img-x: ".concat(e.x, "px; --img-y: ").concat(e.y, "px;"), n.alt = e.alt, n.src = e.url.replace("width=400", "width=10"), !0 === t.enableAnim && (a += " opacity: 0; top: ".concat(t.animTopShift, "px;")), n.style = a, r.appendChild(n), i.appendChild(r)
                    }))
                }
            }, {
                key: "onViewportEnter",
                value: function () {
                    this.enableAnim && this.run((function () { }))
                }
            }, {
                key: "onViewportExit",
                value: function () { }
            }, {
                key: "onScroll",
                value: function (t) {
                    this.scrollRunning
                }
            }]), i
        }(N);
        const Nn = Fn;

        function Bn(t) {
            var e = function () {
                if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                if (Reflect.construct.sham) return !1;
                if ("function" == typeof Proxy) return !0;
                try {
                    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], (function () { }))), !0
                } catch (t) {
                    return !1
                }
            }();
            return function () {
                var i, r = f(t);
                if (e) {
                    var n = f(this).constructor;
                    i = Reflect.construct(r, arguments, n)
                } else i = r.apply(this, arguments);
                return p(this, i)
            }
        }
        const zn = function (t) {
            h(i, t);
            var e = Bn(i);

            function i() {
                return n(this, i), e.apply(this, arguments)
            }
            return l(i, [{
                key: "animate",
                value: function (t) {
                    var e = t.done;
                    Cn.to(this.element, {
                        duration: .4,
                        autoAlpha: 0,
                        onComplete: e
                    })
                }
            }, {
                key: "onViewportEnter",
                value: function () {
                    this.run((function () { }))
                }
            }]), i
        }(N);

        function qn(t) {
            var e = function () {
                if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                if (Reflect.construct.sham) return !1;
                if ("function" == typeof Proxy) return !0;
                try {
                    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], (function () { }))), !0
                } catch (t) {
                    return !1
                }
            }();
            return function () {
                var i, r = f(t);
                if (e) {
                    var n = f(this).constructor;
                    i = Reflect.construct(r, arguments, n)
                } else i = r.apply(this, arguments);
                return p(this, i)
            }
        }
        const Vn = function (t) {
            h(i, t);
            var e = qn(i);

            function i() {
                return n(this, i), e.apply(this, arguments)
            }
            return l(i, [{
                key: "animate",
                value: function (t) {
                    var e = t.done;
                    Cn.to(this.animEls, {
                        opacity: 1,
                        delay: .3,
                        duration: .5,
                        ease: "Power2.inOut",
                        stagger: .15,
                        onComplete: e
                    })
                }
            }, {
                key: "setDefault",
                value: function () {
                    this.animEls = this.element.querySelectorAll(".js-stagger"), Cn.set(this.animEls, {
                        opacity: 0
                    })
                }
            }, {
                key: "onViewportEnter",
                value: function () {
                    this.run((function () { }))
                }
            }]), i
        }(N);
        var Yn = function () {
            function e() {
                var i = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
                n(this, e), this.selector = i.selector || "[data-animation]", this.threshold = i.threshold || 0, this.elements = [], this.types = t
            }
            return l(e, [{
                key: "init",
                value: function () {
                    var t = this;
                    this.selected = document.querySelectorAll(this.selector), Array.prototype.slice.call(this.selected).forEach((function (e, i) {
                        var r = e.dataset.animation && "" != e.dataset.animation ? e.dataset.animation : null;
                        r && t.types[r] && (t.elements[i] = {}, t.elements[i].el = e, t.elements[i].anim = new t.types[r](e), e.dataset.idx = i)
                    }))
                }
            }]), e
        }();

        function jn() {
            if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
            if (Reflect.construct.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
                return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], (function () { }))), !0
            } catch (t) {
                return !1
            }
        }

        function Gn(t, e, i) {
            return Gn = jn() ? Reflect.construct.bind() : function (t, e, i) {
                var r = [null];
                r.push.apply(r, e);
                var n = new (Function.bind.apply(t, r));
                return i && u(n, i.prototype), n
            }, Gn.apply(null, arguments)
        }

        function Hn(t) {
            var e = "function" == typeof Map ? new Map : void 0;
            return Hn = function (t) {
                if (null === t || (i = t, -1 === Function.toString.call(i).indexOf("[native code]"))) return t;
                var i;
                if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function");
                if (void 0 !== e) {
                    if (e.has(t)) return e.get(t);
                    e.set(t, r)
                }

                function r() {
                    return Gn(t, arguments, f(this).constructor)
                }
                return r.prototype = Object.create(t.prototype, {
                    constructor: {
                        value: r,
                        enumerable: !1,
                        writable: !0,
                        configurable: !0
                    }
                }), u(r, t)
            }, Hn(t)
        }

        function Wn(t) {
            var e = function () {
                if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                if (Reflect.construct.sham) return !1;
                if ("function" == typeof Proxy) return !0;
                try {
                    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], (function () { }))), !0
                } catch (t) {
                    return !1
                }
            }();
            return function () {
                var i, r = f(t);
                if (e) {
                    var n = f(this).constructor;
                    i = Reflect.construct(r, arguments, n)
                } else i = r.apply(this, arguments);
                return p(this, i)
            }
        }
        var Zn = function (t) {
            h(i, t);
            var e = Wn(i);

            function i() {
                var t;
                return n(this, i), (t = e.call(this)).form = t.querySelector("form"), t.form ? (t.submitBtn = t.form.querySelector("[type='submit']"), t.submitBtnHtml = t.submitBtn.innerHTML, t.variant = t.form.querySelector("[name='id']"), t.processing = !1, t.processingHtml = '<span style="opacity:0;">Processing ...</span>', t.cartNotification = document.querySelector("cart-notification"), t.cartDrawer = document.querySelector("#cart-drawer"), t.productData = t.form.querySelector("[name='data']") ? JSON.parse(t.form.querySelector("[name='data']").value) : {}, t.variantData = t.form.querySelector("[name='variants']") ? JSON.parse(t.form.querySelector("[name='variants']").value) : {}, t.optionData = t.form.querySelector("[name='options']") ? JSON.parse(t.form.querySelector("[name='options']").value) : {}, t.variant.disabled = !1, t.form.addEventListener("submit", t.onSubmitHandler.bind(d(t))), t) : p(t)
            }
            return l(i, [{
                key: "onSubmitHandler",
                value: function (t) {
                    var e = this;
                    if (t.preventDefault(), !0 !== this.processing) {
                        this.handleErrorMessage(), this.cartNotification && this.cartNotification.setActiveElement(document.activeElement), this.submitBtn.setAttribute("aria-disabled", !0), this.processing = !0, this.runProcessingAnimation(!0), console.log("PRODUCT FORM"), console.log(this.form);
                        var i = new FormData(this.form);
                        this.cartDrawer && i.append("sections", "section--cart-items"), this.cartNotification && i.append("sections", this.cartNotification.getSectionsToRender().map((function (t) {
                            return t.id
                        }))), i.append("sections_url", window.location.pathname), console.log("frmdta"), console.log(i), !i.get("quantity") && this.form.querySelector("[name='quantity']") && i.append("quantity", this.form.querySelector("[name='quantity']").value), fetch(this.form.action, {
                            method: "POST",
                            headers: {
                                "X-Requested-With": "XMLHttpRequest",
                                Accept: "application/json"
                            },
                            body: i
                        }).then((function (t) {
                            return t.json()
                        })).then((function (t) {
                            if (t.status) e.handleErrorMessage(t.description);
                            else {
                                for (var i in e.cartNotification && e.cartNotification.renderContents(t), document.getElementById("cart-drawer").drawerOpen(), t.sections) {
                                    document.getElementById("shopify-section-".concat(i)).replaceWith(F(t.sections[i]))
                                }
                                window.Zero.lazyLoad.update(), b()
                            }
                        })).catch((function (t) {
                            console.error(t)
                        })).finally((function () {
                            e.submitBtn.removeAttribute("aria-disabled"), e.processing = !1, e.runProcessingAnimation()
                        }))
                    }
                }
            }, {
                key: "handleErrorMessage",
                value: function () {
                    var t = arguments.length > 0 && void 0 !== arguments[0] && arguments[0];
                    this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector(".error-message-wrapper"), this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector(".error-message"), this.errorMessageWrapper.toggleAttribute("hidden", !t), t && (this.errorMessage.textContent = t)
                }
            }, {
                key: "runProcessingAnimation",
                value: function () {
                    var t = this,
                        e = arguments.length > 0 && void 0 !== arguments[0] && arguments[0];
                    e ? Cn.to(this.submitBtn.children, {
                        opacity: 0,
                        duration: .1,
                        onComplete: function () {
                            t.submitBtn.innerHTML = t.processingHtml, Cn.to(t.submitBtn.children, {
                                opacity: 1,
                                duration: .1
                            })
                        }
                    }) : Cn.to(this.submitBtn.children, {
                        opacity: 0,
                        duration: .1,
                        onComplete: function () {
                            t.submitBtn.innerHTML = t.submitBtnHtml, Cn.set(t.submitBtn.children, {
                                opacity: 0
                            }), Cn.to(t.submitBtn.children, {
                                opacity: 1,
                                duration: .1
                            })
                        }
                    })
                }
            }]), i
        }(Hn(HTMLElement));

        function $n(t) {
            var e = function () {
                if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                if (Reflect.construct.sham) return !1;
                if ("function" == typeof Proxy) return !0;
                try {
                    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], (function () { }))), !0
                } catch (t) {
                    return !1
                }
            }();
            return function () {
                var i, r = f(t);
                if (e) {
                    var n = f(this).constructor;
                    i = Reflect.construct(r, arguments, n)
                } else i = r.apply(this, arguments);
                return p(this, i)
            }
        }
        var Un = function (t) {
            h(i, t);
            var e = $n(i);

            function i() {
                var t;
                return n(this, i), (t = e.call(this)).lineItems = t.querySelectorAll("[name='updates[]']"), t.form = t.querySelector(".cart"), t.empty = t.querySelector(".empty-state"), t
            }
            return l(i, [{
                key: "displayEmpty",
                value: function () {
                    document.querySelector("cart-wrapper").classList.add("hidden"), document.querySelector("#cart-empty-state").classList.remove("hidden")
                }
            }]), i
        }(Hn(HTMLElement)),
            Xn = function (t) {
                h(i, t);
                var e = $n(i);

                function i() {
                    var t;
                    return n(this, i), (t = e.call(this)).form = t.closest("cart-wrapper"), t.overlay = t.form.querySelector("#".concat(t.dataset.section, "_screen")), Cn.set(t.overlay, {
                        autoAlpha: 0
                    }), t.overlay.classList.remove("hidden"), t.addEventListener("change", T((function (e) {
                        return t.onChange(e)
                    })).bind(d(t))), t
                }
                return l(i, [{
                    key: "onChange",
                    value: function (t) {
                        this.updateQuantity(t.target.closest("[data-index]").dataset.index, t.target.value, t.target.name, t.target)
                    }
                }, {
                    key: "updateQuantity",
                    value: function (t, e) {
                        var i = this,
                            r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : null,
                            n = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : null;
                        if ("quantity" == r && parseInt(e) > parseInt(n.max)) n.value = n.max;
                        else {
                            var a = {},
                                s = !1;
                            if (a.line = t, "selling_plan_update" == r) {
                                var o = this.querySelector("[name='selling_plan']"),
                                    l = this.querySelector("[name='quantity']");
                                a.selling_plan = n.checked ? o.value : null, a.quantity = l.value, s = !0, Cn.to(this.overlay, {
                                    autoAlpha: 1,
                                    duration: .15
                                })
                            } else a[r] = parseInt(e);
                            a.sections = "section--cart-items";
                            var c = JSON.stringify(a);
                            "quantity" == r && e <= 0 && n && n.closest("cart-item") && n.closest("cart-item").remove(), Cn.to(this.overlay, {
                                autoAlpha: 1,
                                duration: .15
                            }), fetch("".concat(window.routes.cart_change_url), {
                                method: "POST",
                                headers: {
                                    "Content-Type": "application/json",
                                    Accept: "application/json"
                                },
                                body: c
                            }).then((function (t) {
                                return t.text()
                            })).then((function (t) {
                                var e = JSON.parse(t);
                                for (var r in e.sections) {
                                    document.getElementById("shopify-section-".concat(r)).replaceWith(F(e.sections[r]))
                                }
                                window.Zero.Cart.stats.count = e.item_count, window.Zero.Cart.stats.discount = e.total_discount, window.Zero.Cart.stats.subtotal = e.items_subtotal_price, window.Zero.Cart.stats.total = e.total_price, window.Zero.Cart.stats.shipping = e.total_price, e.item_count <= 0 ? i.form.displayEmpty() : (s && !0 === s && fetch("/cart?section_id=".concat(i.dataset.section), {
                                    method: "GET"
                                }).then((function (t) {
                                    return t.text()
                                })).then((function (t) {
                                    var e = (new DOMParser).parseFromString(t, "text/html").getElementById("".concat(i.dataset.section, "_lines"));
                                    i.form.querySelector("#".concat(i.dataset.section, "_lines")).innerHTML = e.innerHTML, window.Zero.lazyLoad.update(), Cn.to(i.overlay, {
                                        autoAlpha: 0,
                                        duration: .15
                                    })
                                })).catch((function (t) {
                                    console.error(t), Cn.to(i.overlay, {
                                        autoAlpha: 0,
                                        duration: .15
                                    })
                                })), window.Zero.lazyLoad.update())
                            })).catch((function (t) {
                                console.error(t), Cn.to(i.overlay, {
                                    autoAlpha: 0,
                                    duration: .15
                                })
                            }))
                        }
                    }
                }]), i
            }(Hn(HTMLElement));
        Xn.formAssociated = !0;
        var Kn = function (t) {
            h(i, t);
            var e = $n(i);

            function i() {
                var t;
                return n(this, i), (t = e.call(this)).form = t.closest("cart-wrapper"), t.item = t.closest("cart-item"), t.addEventListener("click", t.remove.bind(d(t))), t
            }
            return l(i, [{
                key: "remove",
                value: function (t) {
                    t.preventDefault(), t.stopPropagation(), this.item.updateQuantity(this.item.dataset.index, 0, "quantity", this.item)
                }
            }]), i
        }(Hn(HTMLElement));

        function Jn(t) {
            var e = function () {
                if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                if (Reflect.construct.sham) return !1;
                if ("function" == typeof Proxy) return !0;
                try {
                    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], (function () { }))), !0
                } catch (t) {
                    return !1
                }
            }();
            return function () {
                var i, r = f(t);
                if (e) {
                    var n = f(this).constructor;
                    i = Reflect.construct(r, arguments, n)
                } else i = r.apply(this, arguments);
                return p(this, i)
            }
        }
        var Qn = function (t) {
            h(i, t);
            var e = Jn(i);

            function i() {
                var t;
                return n(this, i), (t = e.call(this)).input = t.querySelector("input"), t.minus = t.input.previousElementSibling, t.plus = t.input.nextElementSibling, t.changeEvent = new Event("change", {
                    bubbles: !0
                }), t.querySelectorAll("button").forEach((function (e) {
                    return e.addEventListener("click", t.onButtonClick.bind(d(t)))
                })), t
            }
            return l(i, [{
                key: "onButtonClick",
                value: function (t) {
                    t.preventDefault();
                    var e = this.input.value;
                    "plus" === t.target.name ? this.input.stepUp() : this.input.stepDown(), this.minus.disabled = !1, e !== this.input.value || (this.input.value = 0), this.input.dispatchEvent(this.changeEvent)
                }
            }]), i
        }(Hn(HTMLElement));
        Qn.formAssociated = !0;
        HTMLElement;
        var ta = function (t) {
            h(i, t);
            var e = Jn(i);

            function i() {
                var t;
                return n(this, i), (t = e.call(this)).form = t.closest("form"), t.append = t.form.parentElement.dataset.append ? t.form.parentElement.dataset.append : "", t.update = !(!t.form.parentElement.dataset.update || "true" != t.form.parentElement.dataset.update), t.btn = t.form.querySelector("[name='add']"), t.btnText = t.btn.querySelector("span"), t.price = document.getElementById("".concat(t.dataset.section + t.append, "_form_price")), t.subscription = document.getElementById("".concat(t.dataset.section + t.append, "_form_subscription")), t.variantData = t.querySelector("[name='variants']") ? JSON.parse(t.querySelector("[name='variants']").value) : {}, t.addEventListener("change", t.onVariantChange), t.subscription && (t.subscriptionSelected = "", t.subscriptionIntervalSelected = "", t.bindSubscriptionEvents()), t
            }
            return l(i, [{
                key: "onVariantChange",
                value: function () {
                    this.updateOptions(), this.updateId(), this.toggleAddButton(!0, ""), this.updatePickupAvailability(), this.removeErrorMessage(), this.currentVariant ? (this.updateMedia(), this.updateUrl(), this.updateVariantInput(), this.renderProductInfo(), this.subscription && this.bindSubscriptionEvents(this.subscriptionSelected)) : this.setUnavailable()
                }
            }, {
                key: "onSubscriptionChange",
                value: function (t) {
                    this.subscriptionSelected = t.target.value
                }
            }, {
                key: "bindSubscriptionEvents",
                value: function () {
                    var t = this;
                    this.subscription && (this.subscriptionToggles = this.subscription.querySelectorAll("[type='radio']"), this.subscriptionIntervals = this.subscription.querySelector("select"), this.subscriptionToggles.forEach((function (e) {
                        e.addEventListener("click", t.onSubscriptionChange.bind(t))
                    })), this.subscriptionIntervals.addEventListener("change", (function (e) {
                        console.log(e), t.subscriptionIntervalSelected = e.target.value
                    })))
                }
            }, {
                key: "updateOptions",
                value: function () {
                    this.options = Array.from(this.querySelectorAll("select"), (function (t) {
                        return t.value
                    }))
                }
            }, {
                key: "updateId",
                value: function () {
                    var t = this;
                    this.currentVariant = this.variantData.find((function (e) {
                        return !e.options.map((function (e, i) {
                            return t.options[i] === e
                        })).includes(!1)
                    }))
                }
            }, {
                key: "updateMedia",
                value: function () { }
            }, {
                key: "updateUrl",
                value: function () {
                    this.currentVariant && !1 !== this.update && window.history.replaceState({}, "", "".concat(this.dataset.url).concat(this.dataset.url.includes("?") ? "&" : "?", "variant=").concat(this.currentVariant.id))
                }
            }, {
                key: "updateVariantInput",
                value: function () {
                    var t = this;
                    document.querySelectorAll("#".concat(this.dataset.section + this.append, "_form, #").concat(this.dataset.section + this.append, "_form_installment")).forEach((function (e) {
                        var i = e.querySelector("[name='id']");
                        i.value = t.currentVariant.id, i.dispatchEvent(new Event("change", {
                            bubbles: !0
                        }))
                    }))
                }
            }, {
                key: "updatePickupAvailability",
                value: function () {
                    var t = document.querySelector("pickup-availability");
                    t && (this.currentVariant && this.currentVariant.available ? t.fetchAvailability(this.currentVariant.id) : (t.removeAttribute("available"), t.innerHTML = ""))
                }
            }, {
                key: "removeErrorMessage",
                value: function () {
                    if (this.form) {
                        var t = this.form.closest("product-form");
                        t && t.handleErrorMessage()
                    }
                }
            }, {
                key: "renderProductInfo",
                value: function () {
                    var t = this;
                    fetch("".concat(this.dataset.url).concat(this.dataset.url.includes("?") ? "&" : "?", "variant=").concat(this.currentVariant.id, "&section_id=").concat(this.dataset.section)).then((function (t) {
                        return t.text()
                    })).then((function (e) {
                        var i = (new DOMParser).parseFromString(e, "text/html"),
                            r = i.getElementById("".concat(t.dataset.section + t.append, "_form_price")),
                            n = i.getElementById("".concat(t.dataset.section + t.append, "_form_subscription"));
                        t.price && r && (t.price.innerHTML = r.innerHTML), t.price && t.price.classList.remove("visibility-hidden"), t.subscription && n && (t.subscription.innerHTML = n.innerHTML), t.subscription && t.subscription.classList.remove("visibility-hidden"), window.Zero && window.Zero.applyInternationalValueProps && window.Zero.applyInternationalValueProps(), t.subscription && t.subscriptionToggles.forEach((function (e) {
                            console.log(a(e.value), a(t.subscriptionSelected)), console.log("set", e.value, t.subscriptionSelected, e.value == t.subscriptionSelected), e.value == t.subscriptionSelected && e.click()
                        })), t.toggleAddButton(!t.currentVariant.available, window.variantStrings.soldOut)
                    }))
                }
            }, {
                key: "toggleAddButton",
                value: function () {
                    var t = !(arguments.length > 0 && void 0 !== arguments[0]) || arguments[0],
                        e = arguments.length > 1 ? arguments[1] : void 0;
                    if (this.form && this.btn) {
                        if (t) return this.btn.setAttribute("disabled", "disabled"), void (e && (this.btnText.textContent = e));
                        this.btn.removeAttribute("disabled"), this.btnText.textContent = window.variantStrings.addToCart
                    }
                }
            }, {
                key: "setUnavailable",
                value: function () {
                    this.btn && (this.btnText.textContent = window.variantStrings.unavailable, this.price && this.price.classList.add("visibility-hidden"))
                }
            }]), i
        }(Hn(HTMLElement)),
            ea = function (t) {
                h(i, t);
                var e = Jn(i);

                function i() {
                    var t;
                    return n(this, i), (t = e.call(this)).addEventListener("change", t.onVariantChange), t
                }
                return l(i, [{
                    key: "updateOptions",
                    value: function () {
                        var t = Array.from(this.querySelectorAll("fieldset"));
                        this.options = t.map((function (t) {
                            return Array.from(t.querySelectorAll("input")).find((function (t) {
                                return t.checked
                            })).value
                        }))
                    }
                }]), i
            }(ta);

        function ia(t) {
            var e = function () {
                if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                if (Reflect.construct.sham) return !1;
                if ("function" == typeof Proxy) return !0;
                try {
                    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], (function () { }))), !0
                } catch (t) {
                    return !1
                }
            }();
            return function () {
                var i, r = f(t);
                if (e) {
                    var n = f(this).constructor;
                    i = Reflect.construct(r, arguments, n)
                } else i = r.apply(this, arguments);
                return p(this, i)
            }
        }
        var ra = function (t) {
            h(i, t);
            var e = ia(i);

            function i() {
                var t;
                return n(this, i), t = e.call(this), window.Zero = window.Zero || {}, window.Zero.Cart = window.Zero.Cart || {}, window.Zero.Cart.el = d(t), console.log("s"), console.log(window.Zero), t.triggers = document.querySelectorAll(t.dataset.trigger), t.getSelectors(), t.isOpen = !1, t.interactive = r(t.querySelectorAll("a, button, [tabindex]")), t.focusReturn = t.triggers[0], t.form && (console.log("yess"), t.mutationObserver = new MutationObserver(t.mutationCallback.bind(d(t))), t.mutationObserver.observe(t.form, {
                    childList: !0
                })), t.bindMethods(), t.init(), t
            }
            return l(i, [{
                key: "bindMethods",
                value: function () {
                    var t = this;
                    ["drawerOpen", "drawerClose", "handleKeyClose", "handleOpenComplete", "handleCloseComplete"].forEach((function (e) {
                        return t[e] = t[e].bind(t)
                    }))
                }
            }, {
                key: "getSelectors",
                value: function () {
                    this.drawer = this.querySelector(".drawer-c"), this.summary = this.querySelector(".cart-summary"), this.closeBtns = r(this.querySelectorAll(".close-drawer")), this.backdrop = this.querySelector(".backdrop"), this.overlay = this.querySelector("#section--cart-items_screen"), this.scrolling = this.querySelector("#cart"), this.form = this.querySelector("form")
                }
            }, {
                key: "bindCloseTrigger",
                value: function () {
                    var t = this;
                    this.backdrop.addEventListener("click", this.drawerClose), this.closeBtns.forEach((function (e) {
                        e.addEventListener("click", t.drawerClose)
                    })), document.addEventListener("keyup", this.handleKeyClose)
                }
            }, {
                key: "handleKeyClose",
                value: function (t) {
                    var e = t.key;
                    "Escape" !== e && "Esc" !== e || this.drawerClose()
                }
            }, {
                key: "bindOpenTrigger",
                value: function () {
                    var t = this;
                    r(this.triggers).forEach((function (e) {
                        e.addEventListener("click", t.drawerOpen.bind(t))
                    }))
                }
            }, {
                key: "bindFirstAndLast",
                value: function () {
                    var t, e, i = this;
                    if (this.interactive.length > 1) t = this.interactive[0], e = this.interactive[this.interactive.length - 1];
                    else {
                        if (1 != this.interactive.length) return;
                        t = this.interactive[0], e = this.interactive[0]
                    }
                    t.addEventListener("keydown", (function (t) {
                        t.shiftKey && "Tab" === t.key && (t.preventDefault(), i.drawerClose())
                    })), e.addEventListener("keydown", (function (t) {
                        t.shiftKey || "Tab" !== t.key || (t.preventDefault(), i.drawerClose())
                    }))
                }
            }, {
                key: "drawerOpen",
                value: function () {
                    this.isOpen || (this.isOpen = !0, C(), this.backdrop.style.pointerEvents = "all", this.calcHeight(), Cn.to(this.backdrop, {
                        opacity: .5,
                        duration: .3
                    }), Cn.to(this.drawer, {
                        x: 0,
                        duration: .3,
                        onComplete: this.handleOpenComplete
                    }))
                }
            }, {
                key: "drawerClose",
                value: function (t) {
                    t.preventDefault(), this.isOpen && (this.isOpen = !1, P(), this.backdrop.style.pointerEvents = "none", Cn.to(this.backdrop, {
                        opacity: 0,
                        duration: .3
                    }), Cn.to(this.drawer, {
                        x: "100%",
                        duration: .3,
                        onComplete: this.handleCloseComplete
                    }))
                }
            }, {
                key: "handleOpenComplete",
                value: function () {
                    this.interactive && this.interactive[0].focus()
                }
            }, {
                key: "handleCloseComplete",
                value: function () {
                    this.focusReturn && this.focusReturn.focus()
                }
            }, {
                key: "rebind",
                value: function () {
                    var t = this;
                    this.triggers = document.querySelectorAll(this.dataset.trigger), console.log("rebind"), console.log(this.triggers), r(this.triggers).forEach((function (e) {
                        e.addEventListener("click", t.drawerOpen.bind(t))
                    }))
                }
            }, {
                key: "mutationCallback",
                value: function (t) {
                    console.log("form mutate", t), this.rebind()
                }
            }, {
                key: "updateProgress",
                value: function () {
                    var t, e, i, r, n, a = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : null;
                    if (this.progressBar = this.querySelector(".progress"), this.progressBarText = this.querySelector(".progress-title"), this.progressBar && null !== (t = window.Zero) && void 0 !== t && null !== (e = t.Cart) && void 0 !== e && e.stats) {
                        var s = 5e3,
                            o = a || (null === (i = window.Zero) || void 0 === i || null === (r = i.Cart) || void 0 === r || null === (n = r.stats) || void 0 === n ? void 0 : n.subtotal);
                        if (this.diff = o ? Math.abs(o) - s : parseInt(this.progressBar.parentElement.dataset.diff), this.diff > 0) return this.progressBarText.textContent = "You are eligible for free shipping.", void (this.progressBar.children[0].style.width = "100%");
                        var l = Math.abs(this.diff / 100),
                            c = l.toString().split(".");
                        this.progressBarText.textContent = "You are $".concat(l).concat(c[1] && 1 == c[1].length ? "0" : "", " away from qualifying for free shipping"), this.progressBar.children[0].style.width = "".concat((s + this.diff) / s * 100, "%")
                    }
                }
            }, {
                key: "bindForm",
                value: function () {
                    this.form
                }
            }, {
                key: "calcHeight",
                value: function () {
                    this.body = this.querySelector(".cart-body"), this.head = this.querySelector(".cart-head"), this.body && this.head && (this.body.style.height = this.drawer.clientHeight - (this.head.clientHeight + this.summary.clientHeight) + "px")
                }
            }, {
                key: "init",
                value: function () {
                    this.bindOpenTrigger(), this.bindCloseTrigger(), this.bindFirstAndLast(), this.bindForm(), this.updateProgress()
                }
            }, {
                key: "cartChangeHandler",
                value: function (t) {
                    var e = this;
                    Cn.to(this.overlay, {
                        autoAlpha: 1,
                        duration: .15
                    }), fetch("/cart?section_id=section--cart-items", {
                        method: "GET"
                    }).then((function (t) {
                        return t.text()
                    })).then((function (t) {
                        var i = (new DOMParser).parseFromString(t, "text/html").querySelector("#section--cart-items_lines .cart-body");
                        e.body.innerHTML = i.innerHTML, window.Zero.lazyLoad.update(), b(), Cn.to(e.overlay, {
                            autoAlpha: 0,
                            duration: .15
                        })
                    })).catch((function (t) {
                        console.error(t), Cn.to(e.overlay, {
                            autoAlpha: 0,
                            duration: .15
                        })
                    }))
                }
            }]), i
        }(Hn(HTMLElement));

        function na(t) {
            var e = function () {
                if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                if (Reflect.construct.sham) return !1;
                if ("function" == typeof Proxy) return !0;
                try {
                    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], (function () { }))), !0
                } catch (t) {
                    return !1
                }
            }();
            return function () {
                var i, r = f(t);
                if (e) {
                    var n = f(this).constructor;
                    i = Reflect.construct(r, arguments, n)
                } else i = r.apply(this, arguments);
                return p(this, i)
            }
        }
        var aa = function (t) {
            h(i, t);
            var e = na(i);

            function i() {
                var t;
                return n(this, i), (t = e.call(this)).hasEntered = !1, t.resetOnExit = !1, window.Zero.observer = window.Zero.observer || R(), window.Zero.events.resized = window.Zero.events.resized || [], window.Zero.events.observed = window.Zero.events.observed || [], t.onAnimate && t.addEventListener("animate", t.onAnimate.bind(d(t))), t.onResized && (window.Zero.events.resized.push(d(t)), t.addEventListener("resized", t.onResized.bind(d(t)))), (t.onViewportEnter || t.onViewportExit) && (window.Zero.events.observed.push(d(t)), window.Zero.observer.observe(d(t))), t.onViewportEnter && t.addEventListener("viewportEnter", t.onViewportEnter.bind(d(t))), t.onViewportExit && t.addEventListener("viewportExit", t.onViewportExit.bind(d(t))), t
            }
            return l(i)
        }(Hn(HTMLElement));

        function sa(t) {
            var e = function () {
                if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                if (Reflect.construct.sham) return !1;
                if ("function" == typeof Proxy) return !0;
                try {
                    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], (function () { }))), !0
                } catch (t) {
                    return !1
                }
            }();
            return function () {
                var i, r = f(t);
                if (e) {
                    var n = f(this).constructor;
                    i = Reflect.construct(r, arguments, n)
                } else i = r.apply(this, arguments);
                return p(this, i)
            }
        }
        var oa = function (t) {
            h(i, t);
            var e = sa(i);

            function i() {
                var t;
                return n(this, i), (t = e.call(this)).tabBtns = t.querySelectorAll(".tab-btn"), t.tabObjects = [], t.activeTab, t.init(), t
            }
            return l(i, [{
                key: "init",
                value: function () {
                    var t = this;
                    this.tabBtns.forEach((function (e) {
                        var i = t.querySelector(".tab-content.tab-".concat(e.getAttribute("data-tab"))),
                            r = {
                                button: e,
                                content: i,
                                active: !!i.classList.contains("active"),
                                toggle: function () {
                                    r.active || (Cn.to(this.activeTab.content, {
                                        opacity: 0,
                                        pointerEvents: "none"
                                    }), Cn.to(this.activeTab.button, {
                                        opacity: .2,
                                        borderColor: "rgba(0,0,0,0)"
                                    }), this.activeTab.active = !1, Cn.to(r.content, {
                                        opacity: 1,
                                        pointerEvents: "all"
                                    }), Cn.to(r.button, {
                                        opacity: 1,
                                        borderColor: "#1E1E1E"
                                    }), r.active = !0, this.activeTab = r)
                                }
                            };
                        r.button.addEventListener("click", r.toggle.bind(t)), t.tabObjects.push(r), r.active && (t.activeTab = r)
                    }))
                }
            }]), i
        }(aa);

        function la(t) {
            var e = function () {
                if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                if (Reflect.construct.sham) return !1;
                if ("function" == typeof Proxy) return !0;
                try {
                    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], (function () { }))), !0
                } catch (t) {
                    return !1
                }
            }();
            return function () {
                var i, r = f(t);
                if (e) {
                    var n = f(this).constructor;
                    i = Reflect.construct(r, arguments, n)
                } else i = r.apply(this, arguments);
                return p(this, i)
            }
        }
        var ca = function (t) {
            h(i, t);
            var e = la(i);

            function i() {
                var t;
                return n(this, i), (t = e.call(this)).accordionTab = t.querySelector("details"), t.summary = t.querySelector("summary"), t.expand = t.querySelector(".response"), t.isOpen = !!t.accordionTab.open, t.isAnimating = !1, t.setTimeline(), !0 === t.isOpen && t.open(!0), t.bindEvents(), t
            }
            return l(i, [{
                key: "bindEvents",
                value: function () {
                    this.accordionTab.addEventListener("keyup", E), this.summary.addEventListener("click", this.toggleDrawer.bind(this))
                }
            }, {
                key: "setTimeline",
                value: function () {
                    var t = this;
                    this.timeline = Cn.timeline(), this.timeline.fromTo(this.accordionTab, {
                        height: this.summary.clientHeight
                    }, {
                        height: this.summary.clientHeight + this.expand.clientHeight,
                        duration: .6,
                        ease: "Power3.inOut",
                        onComplete: function () {
                            return t.reset(!0)
                        },
                        onReverseComplete: function () {
                            return t.reset(!1)
                        }
                    }), this.timeline.pause()
                }
            }, {
                key: "toggleDrawer",
                value: function (t) {
                    console.log("click", t), t && t.preventDefault(), this.accordionTab.style.overflow = "hidden", this.dispatchEvent(window.Zero.dispatches.animate)
                }
            }, {
                key: "onAnimate",
                value: function () {
                    !1 === this.isOpen ? this.open() : this.close()
                }
            }, {
                key: "open",
                value: function () {
                    var t = arguments.length > 0 && void 0 !== arguments[0] && arguments[0];
                    this.accordionTab.style.height = "".concat(this.accordionTab.clientHeight, "px"), this.isOpen = !0, this.accordionTab.open = !0;
                    var e = this.querySelector(".plus-vertical");
                    Cn.to(e, {
                        rotate: 90,
                        transformOrigin: "center",
                        duration: .2
                    }), !0 !== t ? this.timeline.play() : this.timeline.progress(1).pause()
                }
            }, {
                key: "close",
                value: function () {
                    this.isOpen = !1;
                    var t = this.querySelector(".plus-vertical");
                    Cn.to(t, {
                        rotate: 0,
                        transformOrigin: "center",
                        duration: .2
                    }), this.timeline.reverse()
                }
            }, {
                key: "reset",
                value: function (t) {
                    this.accordionTab.open = t, this.isOpen = t, this.isAnimating = !1, this.accordionTab.style.height = this.accordionTab.style.overflow = ""
                }
            }]), i
        }(aa),
            ua = function (t) {
                h(i, t);
                var e = la(i);

                function i() {
                    var t;
                    return n(this, i), t = e.call(this), window.Zero = window.Zero || {}, window.Zero.AccordionGroups = window.Zero.AccordionGroups || [], window.Zero.AccordionGroups.push({
                        el: d(t),
                        category: t.dataset.category,
                        label: t.dataset.label
                    }), t
                }
                return l(i)
            }(aa),
            ha = function (t) {
                h(i, t);
                var e = la(i);

                function i() {
                    var t;
                    return n(this, i), t = e.call(this), window.Zero = window.Zero || {}, window.Zero.AccordionGroups = window.Zero.AccordionGroups || [], window.Zero.AccordionGroups.length > 1 && t.buildNavigation(), t
                }
                return l(i, [{
                    key: "buildNavigation",
                    value: function () {
                        var t = "<ul>";
                        r(window.Zero.AccordionGroups).forEach((function (e) {
                            t += '<li><a href="#'.concat(e.category, '" data-scrollto="').concat(e.category, '">').concat(e.label, "></li>")
                        })), t += "</ul>", this.innerHTML = t, this.bindNavigation()
                    }
                }, {
                    key: "bindNavigation",
                    value: function () {
                        this.els = this.querySelectorAll("a"), console.log(this.els)
                    }
                }, {
                    key: "scrollToGroup",
                    value: function (t) { }
                }]), i
            }(aa);

        function da(t) {
            var e = function () {
                if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                if (Reflect.construct.sham) return !1;
                if ("function" == typeof Proxy) return !0;
                try {
                    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], (function () { }))), !0
                } catch (t) {
                    return !1
                }
            }();
            return function () {
                var i, r = f(t);
                if (e) {
                    var n = f(this).constructor;
                    i = Reflect.construct(r, arguments, n)
                } else i = r.apply(this, arguments);
                return p(this, i)
            }
        }
        var pa = function (t) {
            h(i, t);
            var e = da(i);

            function i() {
                var t;
                return n(this, i), (t = e.call(this)).header = t.closest("header"), t.closeBtn = t.querySelector(".close"), t.el = t.children[0], t.spacer = t.querySelector(".spacer"), t.height = t.el.clientHeight, t.nav = document.querySelector("#shopify-section-navigation"), t.messagesLength = t.querySelectorAll(".announcement-text").length, t.active = t.querySelectorAll(".announcement-text")[0], "true" === t.dataset.autoNext && setInterval((function () {
                    return t.next.bind(d(t))()
                }), 1e3 * parseInt(t.dataset.speed)), t.closeBtn && t.closeBtn.addEventListener("click", t.close.bind(d(t))), t.querySelector(".announcement-prev") && t.querySelector(".announcement-prev").addEventListener("click", t.previous.bind(d(t))), t.querySelector(".announcement-next") && t.querySelector(".announcement-next").addEventListener("click", t.next.bind(d(t))), t
            }
            return l(i, [{
                key: "close",
                value: function (t) {
                    t.preventDefault(), this.el.style.overflow = "hidden", Cn.to([this.el, this.spacer], {
                        height: 0
                    }), Cn.to(this.nav, {
                        top: 0
                    })
                }
            }, {
                key: "next",
                value: function () {
                    Cn.set(this.active, {
                        opacity: 0,
                        display: "none"
                    });
                    var t = parseInt(this.active.dataset.index) === this.messagesLength ? 0 : parseInt(this.active.dataset.index);
                    this.active = this.querySelectorAll(".announcement-text")[t], Cn.set(this.active, {
                        display: "inline-block"
                    }), Cn.to(this.active, {
                        opacity: 1
                    })
                }
            }, {
                key: "previous",
                value: function () {
                    Cn.set(this.active, {
                        opacity: 0,
                        display: "none"
                    });
                    var t = 1 === parseInt(this.active.dataset.index) ? this.messagesLength - 1 : parseInt(this.active.dataset.index) - 2;
                    this.active = this.querySelectorAll(".announcement-text")[t], Cn.set(this.active, {
                        display: "inline-block"
                    }), Cn.to(this.active, {
                        opacity: 1
                    })
                }
            }]), i
        }(aa);

        function fa(t) {
            return null !== t && "object" == typeof t && "constructor" in t && t.constructor === Object
        }

        function ma(t = {}, e = {}) {
            Object.keys(e).forEach((i => {
                void 0 === t[i] ? t[i] = e[i] : fa(e[i]) && fa(t[i]) && Object.keys(e[i]).length > 0 && ma(t[i], e[i])
            }))
        }
        const ga = {
            body: {},
            addEventListener() { },
            removeEventListener() { },
            activeElement: {
                blur() { },
                nodeName: ""
            },
            querySelector: () => null,
            querySelectorAll: () => [],
            getElementById: () => null,
            createEvent: () => ({
                initEvent() { }
            }),
            createElement: () => ({
                children: [],
                childNodes: [],
                style: {},
                setAttribute() { },
                getElementsByTagName: () => []
            }),
            createElementNS: () => ({}),
            importNode: () => null,
            location: {
                hash: "",
                host: "",
                hostname: "",
                href: "",
                origin: "",
                pathname: "",
                protocol: "",
                search: ""
            }
        };

        function va() {
            const t = "undefined" != typeof document ? document : {};
            return ma(t, ga), t
        }
        const ya = {
            document: ga,
            navigator: {
                userAgent: ""
            },
            location: {
                hash: "",
                host: "",
                hostname: "",
                href: "",
                origin: "",
                pathname: "",
                protocol: "",
                search: ""
            },
            history: {
                replaceState() { },
                pushState() { },
                go() { },
                back() { }
            },
            CustomEvent: function () {
                return this
            },
            addEventListener() { },
            removeEventListener() { },
            getComputedStyle: () => ({
                getPropertyValue: () => ""
            }),
            Image() { },
            Date() { },
            screen: {},
            setTimeout() { },
            clearTimeout() { },
            matchMedia: () => ({}),
            requestAnimationFrame: t => "undefined" == typeof setTimeout ? (t(), null) : setTimeout(t, 0),
            cancelAnimationFrame(t) {
                "undefined" != typeof setTimeout && clearTimeout(t)
            }
        };

        function ba() {
            const t = "undefined" != typeof window ? window : {};
            return ma(t, ya), t
        }
        class _a extends Array {
            constructor(t) {
                "number" == typeof t ? super(t) : (super(...t || []), function (t) {
                    const e = t.__proto__;
                    Object.defineProperty(t, "__proto__", {
                        get: () => e,
                        set(t) {
                            e.__proto__ = t
                        }
                    })
                }(this))
            }
        }

        function wa(t = []) {
            const e = [];
            return t.forEach((t => {
                Array.isArray(t) ? e.push(...wa(t)) : e.push(t)
            })), e
        }

        function Aa(t, e) {
            return Array.prototype.filter.call(t, e)
        }

        function Sa(t, e) {
            const i = ba(),
                r = va();
            let n = [];
            if (!e && t instanceof _a) return t;
            if (!t) return new _a(n);
            if ("string" == typeof t) {
                const i = t.trim();
                if (i.indexOf("<") >= 0 && i.indexOf(">") >= 0) {
                    let t = "div";
                    0 === i.indexOf("<li") && (t = "ul"), 0 === i.indexOf("<tr") && (t = "tbody"), 0 !== i.indexOf("<td") && 0 !== i.indexOf("<th") || (t = "tr"), 0 === i.indexOf("<tbody") && (t = "table"), 0 === i.indexOf("<option") && (t = "select");
                    const e = r.createElement(t);
                    e.innerHTML = i;
                    for (let t = 0; t < e.childNodes.length; t += 1) n.push(e.childNodes[t])
                } else n = function (t, e) {
                    if ("string" != typeof t) return [t];
                    const i = [],
                        r = e.querySelectorAll(t);
                    for (let t = 0; t < r.length; t += 1) i.push(r[t]);
                    return i
                }(t.trim(), e || r)
            } else if (t.nodeType || t === i || t === r) n.push(t);
            else if (Array.isArray(t)) {
                if (t instanceof _a) return t;
                n = t
            }
            return new _a(function (t) {
                const e = [];
                for (let i = 0; i < t.length; i += 1) - 1 === e.indexOf(t[i]) && e.push(t[i]);
                return e
            }(n))
        }
        Sa.fn = _a.prototype;
        const ka = "resize scroll".split(" ");

        function xa(t) {
            return function (...e) {
                if (void 0 === e[0]) {
                    for (let e = 0; e < this.length; e += 1) ka.indexOf(t) < 0 && (t in this[e] ? this[e][t]() : Sa(this[e]).trigger(t));
                    return this
                }
                return this.on(t, ...e)
            }
        }
        xa("click"), xa("blur"), xa("focus"), xa("focusin"), xa("focusout"), xa("keyup"), xa("keydown"), xa("keypress"), xa("submit"), xa("change"), xa("mousedown"), xa("mousemove"), xa("mouseup"), xa("mouseenter"), xa("mouseleave"), xa("mouseout"), xa("mouseover"), xa("touchstart"), xa("touchend"), xa("touchmove"), xa("resize"), xa("scroll");
        const Ta = {
            addClass: function (...t) {
                const e = wa(t.map((t => t.split(" "))));
                return this.forEach((t => {
                    t.classList.add(...e)
                })), this
            },
            removeClass: function (...t) {
                const e = wa(t.map((t => t.split(" "))));
                return this.forEach((t => {
                    t.classList.remove(...e)
                })), this
            },
            hasClass: function (...t) {
                const e = wa(t.map((t => t.split(" "))));
                return Aa(this, (t => e.filter((e => t.classList.contains(e))).length > 0)).length > 0
            },
            toggleClass: function (...t) {
                const e = wa(t.map((t => t.split(" "))));
                this.forEach((t => {
                    e.forEach((e => {
                        t.classList.toggle(e)
                    }))
                }))
            },
            attr: function (t, e) {
                if (1 === arguments.length && "string" == typeof t) return this[0] ? this[0].getAttribute(t) : void 0;
                for (let i = 0; i < this.length; i += 1)
                    if (2 === arguments.length) this[i].setAttribute(t, e);
                    else
                        for (const e in t) this[i][e] = t[e], this[i].setAttribute(e, t[e]);
                return this
            },
            removeAttr: function (t) {
                for (let e = 0; e < this.length; e += 1) this[e].removeAttribute(t);
                return this
            },
            transform: function (t) {
                for (let e = 0; e < this.length; e += 1) this[e].style.transform = t;
                return this
            },
            transition: function (t) {
                for (let e = 0; e < this.length; e += 1) this[e].style.transitionDuration = "string" != typeof t ? `${t}ms` : t;
                return this
            },
            on: function (...t) {
                let [e, i, r, n] = t;

                function a(t) {
                    const e = t.target;
                    if (!e) return;
                    const n = t.target.dom7EventData || [];
                    if (n.indexOf(t) < 0 && n.unshift(t), Sa(e).is(i)) r.apply(e, n);
                    else {
                        const t = Sa(e).parents();
                        for (let e = 0; e < t.length; e += 1) Sa(t[e]).is(i) && r.apply(t[e], n)
                    }
                }

                function s(t) {
                    const e = t && t.target && t.target.dom7EventData || [];
                    e.indexOf(t) < 0 && e.unshift(t), r.apply(this, e)
                }
                "function" == typeof t[1] && ([e, r, n] = t, i = void 0), n || (n = !1);
                const o = e.split(" ");
                let l;
                for (let t = 0; t < this.length; t += 1) {
                    const e = this[t];
                    if (i)
                        for (l = 0; l < o.length; l += 1) {
                            const t = o[l];
                            e.dom7LiveListeners || (e.dom7LiveListeners = {}), e.dom7LiveListeners[t] || (e.dom7LiveListeners[t] = []), e.dom7LiveListeners[t].push({
                                listener: r,
                                proxyListener: a
                            }), e.addEventListener(t, a, n)
                        } else
                        for (l = 0; l < o.length; l += 1) {
                            const t = o[l];
                            e.dom7Listeners || (e.dom7Listeners = {}), e.dom7Listeners[t] || (e.dom7Listeners[t] = []), e.dom7Listeners[t].push({
                                listener: r,
                                proxyListener: s
                            }), e.addEventListener(t, s, n)
                        }
                }
                return this
            },
            off: function (...t) {
                let [e, i, r, n] = t;
                "function" == typeof t[1] && ([e, r, n] = t, i = void 0), n || (n = !1);
                const a = e.split(" ");
                for (let t = 0; t < a.length; t += 1) {
                    const e = a[t];
                    for (let t = 0; t < this.length; t += 1) {
                        const a = this[t];
                        let s;
                        if (!i && a.dom7Listeners ? s = a.dom7Listeners[e] : i && a.dom7LiveListeners && (s = a.dom7LiveListeners[e]), s && s.length)
                            for (let t = s.length - 1; t >= 0; t -= 1) {
                                const i = s[t];
                                r && i.listener === r || r && i.listener && i.listener.dom7proxy && i.listener.dom7proxy === r ? (a.removeEventListener(e, i.proxyListener, n), s.splice(t, 1)) : r || (a.removeEventListener(e, i.proxyListener, n), s.splice(t, 1))
                            }
                    }
                }
                return this
            },
            trigger: function (...t) {
                const e = ba(),
                    i = t[0].split(" "),
                    r = t[1];
                for (let n = 0; n < i.length; n += 1) {
                    const a = i[n];
                    for (let i = 0; i < this.length; i += 1) {
                        const n = this[i];
                        if (e.CustomEvent) {
                            const i = new e.CustomEvent(a, {
                                detail: r,
                                bubbles: !0,
                                cancelable: !0
                            });
                            n.dom7EventData = t.filter(((t, e) => e > 0)), n.dispatchEvent(i), n.dom7EventData = [], delete n.dom7EventData
                        }
                    }
                }
                return this
            },
            transitionEnd: function (t) {
                const e = this;
                return t && e.on("transitionend", (function i(r) {
                    r.target === this && (t.call(this, r), e.off("transitionend", i))
                })), this
            },
            outerWidth: function (t) {
                if (this.length > 0) {
                    if (t) {
                        const t = this.styles();
                        return this[0].offsetWidth + parseFloat(t.getPropertyValue("margin-right")) + parseFloat(t.getPropertyValue("margin-left"))
                    }
                    return this[0].offsetWidth
                }
                return null
            },
            outerHeight: function (t) {
                if (this.length > 0) {
                    if (t) {
                        const t = this.styles();
                        return this[0].offsetHeight + parseFloat(t.getPropertyValue("margin-top")) + parseFloat(t.getPropertyValue("margin-bottom"))
                    }
                    return this[0].offsetHeight
                }
                return null
            },
            styles: function () {
                const t = ba();
                return this[0] ? t.getComputedStyle(this[0], null) : {}
            },
            offset: function () {
                if (this.length > 0) {
                    const t = ba(),
                        e = va(),
                        i = this[0],
                        r = i.getBoundingClientRect(),
                        n = e.body,
                        a = i.clientTop || n.clientTop || 0,
                        s = i.clientLeft || n.clientLeft || 0,
                        o = i === t ? t.scrollY : i.scrollTop,
                        l = i === t ? t.scrollX : i.scrollLeft;
                    return {
                        top: r.top + o - a,
                        left: r.left + l - s
                    }
                }
                return null
            },
            css: function (t, e) {
                const i = ba();
                let r;
                if (1 === arguments.length) {
                    if ("string" != typeof t) {
                        for (r = 0; r < this.length; r += 1)
                            for (const e in t) this[r].style[e] = t[e];
                        return this
                    }
                    if (this[0]) return i.getComputedStyle(this[0], null).getPropertyValue(t)
                }
                if (2 === arguments.length && "string" == typeof t) {
                    for (r = 0; r < this.length; r += 1) this[r].style[t] = e;
                    return this
                }
                return this
            },
            each: function (t) {
                return t ? (this.forEach(((e, i) => {
                    t.apply(e, [e, i])
                })), this) : this
            },
            html: function (t) {
                if (void 0 === t) return this[0] ? this[0].innerHTML : null;
                for (let e = 0; e < this.length; e += 1) this[e].innerHTML = t;
                return this
            },
            text: function (t) {
                if (void 0 === t) return this[0] ? this[0].textContent.trim() : null;
                for (let e = 0; e < this.length; e += 1) this[e].textContent = t;
                return this
            },
            is: function (t) {
                const e = ba(),
                    i = va(),
                    r = this[0];
                let n, a;
                if (!r || void 0 === t) return !1;
                if ("string" == typeof t) {
                    if (r.matches) return r.matches(t);
                    if (r.webkitMatchesSelector) return r.webkitMatchesSelector(t);
                    if (r.msMatchesSelector) return r.msMatchesSelector(t);
                    for (n = Sa(t), a = 0; a < n.length; a += 1)
                        if (n[a] === r) return !0;
                    return !1
                }
                if (t === i) return r === i;
                if (t === e) return r === e;
                if (t.nodeType || t instanceof _a) {
                    for (n = t.nodeType ? [t] : t, a = 0; a < n.length; a += 1)
                        if (n[a] === r) return !0;
                    return !1
                }
                return !1
            },
            index: function () {
                let t, e = this[0];
                if (e) {
                    for (t = 0; null !== (e = e.previousSibling);) 1 === e.nodeType && (t += 1);
                    return t
                }
            },
            eq: function (t) {
                if (void 0 === t) return this;
                const e = this.length;
                if (t > e - 1) return Sa([]);
                if (t < 0) {
                    const i = e + t;
                    return Sa(i < 0 ? [] : [this[i]])
                }
                return Sa([this[t]])
            },
            append: function (...t) {
                let e;
                const i = va();
                for (let r = 0; r < t.length; r += 1) {
                    e = t[r];
                    for (let t = 0; t < this.length; t += 1)
                        if ("string" == typeof e) {
                            const r = i.createElement("div");
                            for (r.innerHTML = e; r.firstChild;) this[t].appendChild(r.firstChild)
                        } else if (e instanceof _a)
                            for (let i = 0; i < e.length; i += 1) this[t].appendChild(e[i]);
                        else this[t].appendChild(e)
                }
                return this
            },
            prepend: function (t) {
                const e = va();
                let i, r;
                for (i = 0; i < this.length; i += 1)
                    if ("string" == typeof t) {
                        const n = e.createElement("div");
                        for (n.innerHTML = t, r = n.childNodes.length - 1; r >= 0; r -= 1) this[i].insertBefore(n.childNodes[r], this[i].childNodes[0])
                    } else if (t instanceof _a)
                        for (r = 0; r < t.length; r += 1) this[i].insertBefore(t[r], this[i].childNodes[0]);
                    else this[i].insertBefore(t, this[i].childNodes[0]);
                return this
            },
            next: function (t) {
                return this.length > 0 ? t ? this[0].nextElementSibling && Sa(this[0].nextElementSibling).is(t) ? Sa([this[0].nextElementSibling]) : Sa([]) : this[0].nextElementSibling ? Sa([this[0].nextElementSibling]) : Sa([]) : Sa([])
            },
            nextAll: function (t) {
                const e = [];
                let i = this[0];
                if (!i) return Sa([]);
                for (; i.nextElementSibling;) {
                    const r = i.nextElementSibling;
                    t ? Sa(r).is(t) && e.push(r) : e.push(r), i = r
                }
                return Sa(e)
            },
            prev: function (t) {
                if (this.length > 0) {
                    const e = this[0];
                    return t ? e.previousElementSibling && Sa(e.previousElementSibling).is(t) ? Sa([e.previousElementSibling]) : Sa([]) : e.previousElementSibling ? Sa([e.previousElementSibling]) : Sa([])
                }
                return Sa([])
            },
            prevAll: function (t) {
                const e = [];
                let i = this[0];
                if (!i) return Sa([]);
                for (; i.previousElementSibling;) {
                    const r = i.previousElementSibling;
                    t ? Sa(r).is(t) && e.push(r) : e.push(r), i = r
                }
                return Sa(e)
            },
            parent: function (t) {
                const e = [];
                for (let i = 0; i < this.length; i += 1) null !== this[i].parentNode && (t ? Sa(this[i].parentNode).is(t) && e.push(this[i].parentNode) : e.push(this[i].parentNode));
                return Sa(e)
            },
            parents: function (t) {
                const e = [];
                for (let i = 0; i < this.length; i += 1) {
                    let r = this[i].parentNode;
                    for (; r;) t ? Sa(r).is(t) && e.push(r) : e.push(r), r = r.parentNode
                }
                return Sa(e)
            },
            closest: function (t) {
                let e = this;
                return void 0 === t ? Sa([]) : (e.is(t) || (e = e.parents(t).eq(0)), e)
            },
            find: function (t) {
                const e = [];
                for (let i = 0; i < this.length; i += 1) {
                    const r = this[i].querySelectorAll(t);
                    for (let t = 0; t < r.length; t += 1) e.push(r[t])
                }
                return Sa(e)
            },
            children: function (t) {
                const e = [];
                for (let i = 0; i < this.length; i += 1) {
                    const r = this[i].children;
                    for (let i = 0; i < r.length; i += 1) t && !Sa(r[i]).is(t) || e.push(r[i])
                }
                return Sa(e)
            },
            filter: function (t) {
                return Sa(Aa(this, t))
            },
            remove: function () {
                for (let t = 0; t < this.length; t += 1) this[t].parentNode && this[t].parentNode.removeChild(this[t]);
                return this
            }
        };
        Object.keys(Ta).forEach((t => {
            Object.defineProperty(Sa.fn, t, {
                value: Ta[t],
                writable: !0
            })
        }));
        const Ea = Sa;

        function Ma(t, e = 0) {
            return setTimeout(t, e)
        }

        function Ca() {
            return Date.now()
        }

        function Pa(t, e = "x") {
            const i = ba();
            let r, n, a;
            const s = function (t) {
                const e = ba();
                let i;
                return e.getComputedStyle && (i = e.getComputedStyle(t, null)), !i && t.currentStyle && (i = t.currentStyle), i || (i = t.style), i
            }(t);
            return i.WebKitCSSMatrix ? (n = s.transform || s.webkitTransform, n.split(",").length > 6 && (n = n.split(", ").map((t => t.replace(",", "."))).join(", ")), a = new i.WebKitCSSMatrix("none" === n ? "" : n)) : (a = s.MozTransform || s.OTransform || s.MsTransform || s.msTransform || s.transform || s.getPropertyValue("transform").replace("translate(", "matrix(1, 0, 0, 1,"), r = a.toString().split(",")), "x" === e && (n = i.WebKitCSSMatrix ? a.m41 : 16 === r.length ? parseFloat(r[12]) : parseFloat(r[4])), "y" === e && (n = i.WebKitCSSMatrix ? a.m42 : 16 === r.length ? parseFloat(r[13]) : parseFloat(r[5])), n || 0
        }

        function Da(t) {
            return "object" == typeof t && null !== t && t.constructor && "Object" === Object.prototype.toString.call(t).slice(8, -1)
        }

        function La(...t) {
            const e = Object(t[0]),
                i = ["__proto__", "constructor", "prototype"];
            for (let n = 1; n < t.length; n += 1) {
                const a = t[n];
                if (null != a && (r = a, !("undefined" != typeof window && void 0 !== window.HTMLElement ? r instanceof HTMLElement : r && (1 === r.nodeType || 11 === r.nodeType)))) {
                    const t = Object.keys(Object(a)).filter((t => i.indexOf(t) < 0));
                    for (let i = 0, r = t.length; i < r; i += 1) {
                        const r = t[i],
                            n = Object.getOwnPropertyDescriptor(a, r);
                        void 0 !== n && n.enumerable && (Da(e[r]) && Da(a[r]) ? a[r].__swiper__ ? e[r] = a[r] : La(e[r], a[r]) : !Da(e[r]) && Da(a[r]) ? (e[r] = {}, a[r].__swiper__ ? e[r] = a[r] : La(e[r], a[r])) : e[r] = a[r])
                    }
                }
            }
            var r;
            return e
        }

        function Oa(t, e, i) {
            t.style.setProperty(e, i)
        }

        function Ia({
            swiper: t,
            targetPosition: e,
            side: i
        }) {
            const r = ba(),
                n = -t.translate;
            let a, s = null;
            const o = t.params.speed;
            t.wrapperEl.style.scrollSnapType = "none", r.cancelAnimationFrame(t.cssModeFrameID);
            const l = e > n ? "next" : "prev",
                c = (t, e) => "next" === l && t >= e || "prev" === l && t <= e,
                u = () => {
                    a = (new Date).getTime(), null === s && (s = a);
                    const l = Math.max(Math.min((a - s) / o, 1), 0),
                        h = .5 - Math.cos(l * Math.PI) / 2;
                    let d = n + h * (e - n);
                    if (c(d, e) && (d = e), t.wrapperEl.scrollTo({
                        [i]: d
                    }), c(d, e)) return t.wrapperEl.style.overflow = "hidden", t.wrapperEl.style.scrollSnapType = "", setTimeout((() => {
                        t.wrapperEl.style.overflow = "", t.wrapperEl.scrollTo({
                            [i]: d
                        })
                    })), void r.cancelAnimationFrame(t.cssModeFrameID);
                    t.cssModeFrameID = r.requestAnimationFrame(u)
                };
            u()
        }
        let Ra, Fa, Na;

        function Ba() {
            return Ra || (Ra = function () {
                const t = ba(),
                    e = va();
                return {
                    smoothScroll: e.documentElement && "scrollBehavior" in e.documentElement.style,
                    touch: !!("ontouchstart" in t || t.DocumentTouch && e instanceof t.DocumentTouch),
                    passiveListener: function () {
                        let e = !1;
                        try {
                            const i = Object.defineProperty({}, "passive", {
                                get() {
                                    e = !0
                                }
                            });
                            t.addEventListener("testPassiveListener", null, i)
                        } catch (t) { }
                        return e
                    }(),
                    gestures: "ongesturestart" in t
                }
            }()), Ra
        }

        function za(t = {}) {
            return Fa || (Fa = function ({
                userAgent: t
            } = {}) {
                const e = Ba(),
                    i = ba(),
                    r = i.navigator.platform,
                    n = t || i.navigator.userAgent,
                    a = {
                        ios: !1,
                        android: !1
                    },
                    s = i.screen.width,
                    o = i.screen.height,
                    l = n.match(/(Android);?[\s\/]+([\d.]+)?/);
                let c = n.match(/(iPad).*OS\s([\d_]+)/);
                const u = n.match(/(iPod)(.*OS\s([\d_]+))?/),
                    h = !c && n.match(/(iPhone\sOS|iOS)\s([\d_]+)/),
                    d = "Win32" === r;
                let p = "MacIntel" === r;
                return !c && p && e.touch && ["1024x1366", "1366x1024", "834x1194", "1194x834", "834x1112", "1112x834", "768x1024", "1024x768", "820x1180", "1180x820", "810x1080", "1080x810"].indexOf(`${s}x${o}`) >= 0 && (c = n.match(/(Version)\/([\d.]+)/), c || (c = [0, 1, "13_0_0"]), p = !1), l && !d && (a.os = "android", a.android = !0), (c || h || u) && (a.os = "ios", a.ios = !0), a
            }(t)), Fa
        }

        function qa() {
            return Na || (Na = function () {
                const t = ba();
                return {
                    isSafari: function () {
                        const e = t.navigator.userAgent.toLowerCase();
                        return e.indexOf("safari") >= 0 && e.indexOf("chrome") < 0 && e.indexOf("android") < 0
                    }(),
                    isWebView: /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(t.navigator.userAgent)
                }
            }()), Na
        }
        const Va = {
            on(t, e, i) {
                const r = this;
                if (!r.eventsListeners || r.destroyed) return r;
                if ("function" != typeof e) return r;
                const n = i ? "unshift" : "push";
                return t.split(" ").forEach((t => {
                    r.eventsListeners[t] || (r.eventsListeners[t] = []), r.eventsListeners[t][n](e)
                })), r
            },
            once(t, e, i) {
                const r = this;
                if (!r.eventsListeners || r.destroyed) return r;
                if ("function" != typeof e) return r;

                function n(...i) {
                    r.off(t, n), n.__emitterProxy && delete n.__emitterProxy, e.apply(r, i)
                }
                return n.__emitterProxy = e, r.on(t, n, i)
            },
            onAny(t, e) {
                const i = this;
                if (!i.eventsListeners || i.destroyed) return i;
                if ("function" != typeof t) return i;
                const r = e ? "unshift" : "push";
                return i.eventsAnyListeners.indexOf(t) < 0 && i.eventsAnyListeners[r](t), i
            },
            offAny(t) {
                const e = this;
                if (!e.eventsListeners || e.destroyed) return e;
                if (!e.eventsAnyListeners) return e;
                const i = e.eventsAnyListeners.indexOf(t);
                return i >= 0 && e.eventsAnyListeners.splice(i, 1), e
            },
            off(t, e) {
                const i = this;
                return !i.eventsListeners || i.destroyed ? i : i.eventsListeners ? (t.split(" ").forEach((t => {
                    void 0 === e ? i.eventsListeners[t] = [] : i.eventsListeners[t] && i.eventsListeners[t].forEach(((r, n) => {
                        (r === e || r.__emitterProxy && r.__emitterProxy === e) && i.eventsListeners[t].splice(n, 1)
                    }))
                })), i) : i
            },
            emit(...t) {
                const e = this;
                if (!e.eventsListeners || e.destroyed) return e;
                if (!e.eventsListeners) return e;
                let i, r, n;
                "string" == typeof t[0] || Array.isArray(t[0]) ? (i = t[0], r = t.slice(1, t.length), n = e) : (i = t[0].events, r = t[0].data, n = t[0].context || e), r.unshift(n);
                return (Array.isArray(i) ? i : i.split(" ")).forEach((t => {
                    e.eventsAnyListeners && e.eventsAnyListeners.length && e.eventsAnyListeners.forEach((e => {
                        e.apply(n, [t, ...r])
                    })), e.eventsListeners && e.eventsListeners[t] && e.eventsListeners[t].forEach((t => {
                        t.apply(n, r)
                    }))
                })), e
            }
        };
        const Ya = {
            updateSize: function () {
                const t = this;
                let e, i;
                const r = t.$el;
                e = void 0 !== t.params.width && null !== t.params.width ? t.params.width : r[0].clientWidth, i = void 0 !== t.params.height && null !== t.params.height ? t.params.height : r[0].clientHeight, 0 === e && t.isHorizontal() || 0 === i && t.isVertical() || (e = e - parseInt(r.css("padding-left") || 0, 10) - parseInt(r.css("padding-right") || 0, 10), i = i - parseInt(r.css("padding-top") || 0, 10) - parseInt(r.css("padding-bottom") || 0, 10), Number.isNaN(e) && (e = 0), Number.isNaN(i) && (i = 0), Object.assign(t, {
                    width: e,
                    height: i,
                    size: t.isHorizontal() ? e : i
                }))
            },
            updateSlides: function () {
                const t = this;

                function e(e) {
                    return t.isHorizontal() ? e : {
                        width: "height",
                        "margin-top": "margin-left",
                        "margin-bottom ": "margin-right",
                        "margin-left": "margin-top",
                        "margin-right": "margin-bottom",
                        "padding-left": "padding-top",
                        "padding-right": "padding-bottom",
                        marginRight: "marginBottom"
                    }[e]
                }

                function i(t, i) {
                    return parseFloat(t.getPropertyValue(e(i)) || 0)
                }
                const r = t.params,
                    {
                        $wrapperEl: n,
                        size: a,
                        rtlTranslate: s,
                        wrongRTL: o
                    } = t,
                    l = t.virtual && r.virtual.enabled,
                    c = l ? t.virtual.slides.length : t.slides.length,
                    u = n.children(`.${t.params.slideClass}`),
                    h = l ? t.virtual.slides.length : u.length;
                let d = [];
                const p = [],
                    f = [];
                let m = r.slidesOffsetBefore;
                "function" == typeof m && (m = r.slidesOffsetBefore.call(t));
                let g = r.slidesOffsetAfter;
                "function" == typeof g && (g = r.slidesOffsetAfter.call(t));
                const v = t.snapGrid.length,
                    y = t.slidesGrid.length;
                let b = r.spaceBetween,
                    _ = -m,
                    w = 0,
                    A = 0;
                if (void 0 === a) return;
                "string" == typeof b && b.indexOf("%") >= 0 && (b = parseFloat(b.replace("%", "")) / 100 * a), t.virtualSize = -b, s ? u.css({
                    marginLeft: "",
                    marginBottom: "",
                    marginTop: ""
                }) : u.css({
                    marginRight: "",
                    marginBottom: "",
                    marginTop: ""
                }), r.centeredSlides && r.cssMode && (Oa(t.wrapperEl, "--swiper-centered-offset-before", ""), Oa(t.wrapperEl, "--swiper-centered-offset-after", ""));
                const S = r.grid && r.grid.rows > 1 && t.grid;
                let k;
                S && t.grid.initSlides(h);
                const x = "auto" === r.slidesPerView && r.breakpoints && Object.keys(r.breakpoints).filter((t => void 0 !== r.breakpoints[t].slidesPerView)).length > 0;
                for (let n = 0; n < h; n += 1) {
                    k = 0;
                    const s = u.eq(n);
                    if (S && t.grid.updateSlide(n, s, h, e), "none" !== s.css("display")) {
                        if ("auto" === r.slidesPerView) {
                            x && (u[n].style[e("width")] = "");
                            const a = getComputedStyle(s[0]),
                                o = s[0].style.transform,
                                l = s[0].style.webkitTransform;
                            if (o && (s[0].style.transform = "none"), l && (s[0].style.webkitTransform = "none"), r.roundLengths) k = t.isHorizontal() ? s.outerWidth(!0) : s.outerHeight(!0);
                            else {
                                const t = i(a, "width"),
                                    e = i(a, "padding-left"),
                                    r = i(a, "padding-right"),
                                    n = i(a, "margin-left"),
                                    o = i(a, "margin-right"),
                                    l = a.getPropertyValue("box-sizing");
                                if (l && "border-box" === l) k = t + n + o;
                                else {
                                    const {
                                        clientWidth: i,
                                        offsetWidth: a
                                    } = s[0];
                                    k = t + e + r + n + o + (a - i)
                                }
                            }
                            o && (s[0].style.transform = o), l && (s[0].style.webkitTransform = l), r.roundLengths && (k = Math.floor(k))
                        } else k = (a - (r.slidesPerView - 1) * b) / r.slidesPerView, r.roundLengths && (k = Math.floor(k)), u[n] && (u[n].style[e("width")] = `${k}px`);
                        u[n] && (u[n].swiperSlideSize = k), f.push(k), r.centeredSlides ? (_ = _ + k / 2 + w / 2 + b, 0 === w && 0 !== n && (_ = _ - a / 2 - b), 0 === n && (_ = _ - a / 2 - b), Math.abs(_) < .001 && (_ = 0), r.roundLengths && (_ = Math.floor(_)), A % r.slidesPerGroup == 0 && d.push(_), p.push(_)) : (r.roundLengths && (_ = Math.floor(_)), (A - Math.min(t.params.slidesPerGroupSkip, A)) % t.params.slidesPerGroup == 0 && d.push(_), p.push(_), _ = _ + k + b), t.virtualSize += k + b, w = k, A += 1
                    }
                }
                if (t.virtualSize = Math.max(t.virtualSize, a) + g, s && o && ("slide" === r.effect || "coverflow" === r.effect) && n.css({
                    width: `${t.virtualSize + r.spaceBetween}px`
                }), r.setWrapperSize && n.css({
                    [e("width")]: `${t.virtualSize + r.spaceBetween}px`
                }), S && t.grid.updateWrapperSize(k, d, e), !r.centeredSlides) {
                    const e = [];
                    for (let i = 0; i < d.length; i += 1) {
                        let n = d[i];
                        r.roundLengths && (n = Math.floor(n)), d[i] <= t.virtualSize - a && e.push(n)
                    }
                    d = e, Math.floor(t.virtualSize - a) - Math.floor(d[d.length - 1]) > 1 && d.push(t.virtualSize - a)
                }
                if (0 === d.length && (d = [0]), 0 !== r.spaceBetween) {
                    const i = t.isHorizontal() && s ? "marginLeft" : e("marginRight");
                    u.filter(((t, e) => !r.cssMode || e !== u.length - 1)).css({
                        [i]: `${b}px`
                    })
                }
                if (r.centeredSlides && r.centeredSlidesBounds) {
                    let t = 0;
                    f.forEach((e => {
                        t += e + (r.spaceBetween ? r.spaceBetween : 0)
                    })), t -= r.spaceBetween;
                    const e = t - a;
                    d = d.map((t => t < 0 ? -m : t > e ? e + g : t))
                }
                if (r.centerInsufficientSlides) {
                    let t = 0;
                    if (f.forEach((e => {
                        t += e + (r.spaceBetween ? r.spaceBetween : 0)
                    })), t -= r.spaceBetween, t < a) {
                        const e = (a - t) / 2;
                        d.forEach(((t, i) => {
                            d[i] = t - e
                        })), p.forEach(((t, i) => {
                            p[i] = t + e
                        }))
                    }
                }
                if (Object.assign(t, {
                    slides: u,
                    snapGrid: d,
                    slidesGrid: p,
                    slidesSizesGrid: f
                }), r.centeredSlides && r.cssMode && !r.centeredSlidesBounds) {
                    Oa(t.wrapperEl, "--swiper-centered-offset-before", -d[0] + "px"), Oa(t.wrapperEl, "--swiper-centered-offset-after", t.size / 2 - f[f.length - 1] / 2 + "px");
                    const e = -t.snapGrid[0],
                        i = -t.slidesGrid[0];
                    t.snapGrid = t.snapGrid.map((t => t + e)), t.slidesGrid = t.slidesGrid.map((t => t + i))
                }
                if (h !== c && t.emit("slidesLengthChange"), d.length !== v && (t.params.watchOverflow && t.checkOverflow(), t.emit("snapGridLengthChange")), p.length !== y && t.emit("slidesGridLengthChange"), r.watchSlidesProgress && t.updateSlidesOffset(), !(l || r.cssMode || "slide" !== r.effect && "fade" !== r.effect)) {
                    const e = `${r.containerModifierClass}backface-hidden`,
                        i = t.$el.hasClass(e);
                    h <= r.maxBackfaceHiddenSlides ? i || t.$el.addClass(e) : i && t.$el.removeClass(e)
                }
            },
            updateAutoHeight: function (t) {
                const e = this,
                    i = [],
                    r = e.virtual && e.params.virtual.enabled;
                let n, a = 0;
                "number" == typeof t ? e.setTransition(t) : !0 === t && e.setTransition(e.params.speed);
                const s = t => r ? e.slides.filter((e => parseInt(e.getAttribute("data-swiper-slide-index"), 10) === t))[0] : e.slides.eq(t)[0];
                if ("auto" !== e.params.slidesPerView && e.params.slidesPerView > 1)
                    if (e.params.centeredSlides) (e.visibleSlides || Ea([])).each((t => {
                        i.push(t)
                    }));
                    else
                        for (n = 0; n < Math.ceil(e.params.slidesPerView); n += 1) {
                            const t = e.activeIndex + n;
                            if (t > e.slides.length && !r) break;
                            i.push(s(t))
                        } else i.push(s(e.activeIndex));
                for (n = 0; n < i.length; n += 1)
                    if (void 0 !== i[n]) {
                        const t = i[n].offsetHeight;
                        a = t > a ? t : a
                    } (a || 0 === a) && e.$wrapperEl.css("height", `${a}px`)
            },
            updateSlidesOffset: function () {
                const t = this,
                    e = t.slides;
                for (let i = 0; i < e.length; i += 1) e[i].swiperSlideOffset = t.isHorizontal() ? e[i].offsetLeft : e[i].offsetTop
            },
            updateSlidesProgress: function (t = this && this.translate || 0) {
                const e = this,
                    i = e.params,
                    {
                        slides: r,
                        rtlTranslate: n,
                        snapGrid: a
                    } = e;
                if (0 === r.length) return;
                void 0 === r[0].swiperSlideOffset && e.updateSlidesOffset();
                let s = -t;
                n && (s = t), r.removeClass(i.slideVisibleClass), e.visibleSlidesIndexes = [], e.visibleSlides = [];
                for (let t = 0; t < r.length; t += 1) {
                    const o = r[t];
                    let l = o.swiperSlideOffset;
                    i.cssMode && i.centeredSlides && (l -= r[0].swiperSlideOffset);
                    const c = (s + (i.centeredSlides ? e.minTranslate() : 0) - l) / (o.swiperSlideSize + i.spaceBetween),
                        u = (s - a[0] + (i.centeredSlides ? e.minTranslate() : 0) - l) / (o.swiperSlideSize + i.spaceBetween),
                        h = -(s - l),
                        d = h + e.slidesSizesGrid[t];
                    (h >= 0 && h < e.size - 1 || d > 1 && d <= e.size || h <= 0 && d >= e.size) && (e.visibleSlides.push(o), e.visibleSlidesIndexes.push(t), r.eq(t).addClass(i.slideVisibleClass)), o.progress = n ? -c : c, o.originalProgress = n ? -u : u
                }
                e.visibleSlides = Ea(e.visibleSlides)
            },
            updateProgress: function (t) {
                const e = this;
                if (void 0 === t) {
                    const i = e.rtlTranslate ? -1 : 1;
                    t = e && e.translate && e.translate * i || 0
                }
                const i = e.params,
                    r = e.maxTranslate() - e.minTranslate();
                let {
                    progress: n,
                    isBeginning: a,
                    isEnd: s
                } = e;
                const o = a,
                    l = s;
                0 === r ? (n = 0, a = !0, s = !0) : (n = (t - e.minTranslate()) / r, a = n <= 0, s = n >= 1), Object.assign(e, {
                    progress: n,
                    isBeginning: a,
                    isEnd: s
                }), (i.watchSlidesProgress || i.centeredSlides && i.autoHeight) && e.updateSlidesProgress(t), a && !o && e.emit("reachBeginning toEdge"), s && !l && e.emit("reachEnd toEdge"), (o && !a || l && !s) && e.emit("fromEdge"), e.emit("progress", n)
            },
            updateSlidesClasses: function () {
                const t = this,
                    {
                        slides: e,
                        params: i,
                        $wrapperEl: r,
                        activeIndex: n,
                        realIndex: a
                    } = t,
                    s = t.virtual && i.virtual.enabled;
                let o;
                e.removeClass(`${i.slideActiveClass} ${i.slideNextClass} ${i.slidePrevClass} ${i.slideDuplicateActiveClass} ${i.slideDuplicateNextClass} ${i.slideDuplicatePrevClass}`), o = s ? t.$wrapperEl.find(`.${i.slideClass}[data-swiper-slide-index="${n}"]`) : e.eq(n), o.addClass(i.slideActiveClass), i.loop && (o.hasClass(i.slideDuplicateClass) ? r.children(`.${i.slideClass}:not(.${i.slideDuplicateClass})[data-swiper-slide-index="${a}"]`).addClass(i.slideDuplicateActiveClass) : r.children(`.${i.slideClass}.${i.slideDuplicateClass}[data-swiper-slide-index="${a}"]`).addClass(i.slideDuplicateActiveClass));
                let l = o.nextAll(`.${i.slideClass}`).eq(0).addClass(i.slideNextClass);
                i.loop && 0 === l.length && (l = e.eq(0), l.addClass(i.slideNextClass));
                let c = o.prevAll(`.${i.slideClass}`).eq(0).addClass(i.slidePrevClass);
                i.loop && 0 === c.length && (c = e.eq(-1), c.addClass(i.slidePrevClass)), i.loop && (l.hasClass(i.slideDuplicateClass) ? r.children(`.${i.slideClass}:not(.${i.slideDuplicateClass})[data-swiper-slide-index="${l.attr("data-swiper-slide-index")}"]`).addClass(i.slideDuplicateNextClass) : r.children(`.${i.slideClass}.${i.slideDuplicateClass}[data-swiper-slide-index="${l.attr("data-swiper-slide-index")}"]`).addClass(i.slideDuplicateNextClass), c.hasClass(i.slideDuplicateClass) ? r.children(`.${i.slideClass}:not(.${i.slideDuplicateClass})[data-swiper-slide-index="${c.attr("data-swiper-slide-index")}"]`).addClass(i.slideDuplicatePrevClass) : r.children(`.${i.slideClass}.${i.slideDuplicateClass}[data-swiper-slide-index="${c.attr("data-swiper-slide-index")}"]`).addClass(i.slideDuplicatePrevClass)), t.emitSlidesClasses()
            },
            updateActiveIndex: function (t) {
                const e = this,
                    i = e.rtlTranslate ? e.translate : -e.translate,
                    {
                        slidesGrid: r,
                        snapGrid: n,
                        params: a,
                        activeIndex: s,
                        realIndex: o,
                        snapIndex: l
                    } = e;
                let c, u = t;
                if (void 0 === u) {
                    for (let t = 0; t < r.length; t += 1) void 0 !== r[t + 1] ? i >= r[t] && i < r[t + 1] - (r[t + 1] - r[t]) / 2 ? u = t : i >= r[t] && i < r[t + 1] && (u = t + 1) : i >= r[t] && (u = t);
                    a.normalizeSlideIndex && (u < 0 || void 0 === u) && (u = 0)
                }
                if (n.indexOf(i) >= 0) c = n.indexOf(i);
                else {
                    const t = Math.min(a.slidesPerGroupSkip, u);
                    c = t + Math.floor((u - t) / a.slidesPerGroup)
                }
                if (c >= n.length && (c = n.length - 1), u === s) return void (c !== l && (e.snapIndex = c, e.emit("snapIndexChange")));
                const h = parseInt(e.slides.eq(u).attr("data-swiper-slide-index") || u, 10);
                Object.assign(e, {
                    snapIndex: c,
                    realIndex: h,
                    previousIndex: s,
                    activeIndex: u
                }), e.emit("activeIndexChange"), e.emit("snapIndexChange"), o !== h && e.emit("realIndexChange"), (e.initialized || e.params.runCallbacksOnInit) && e.emit("slideChange")
            },
            updateClickedSlide: function (t) {
                const e = this,
                    i = e.params,
                    r = Ea(t).closest(`.${i.slideClass}`)[0];
                let n, a = !1;
                if (r)
                    for (let t = 0; t < e.slides.length; t += 1)
                        if (e.slides[t] === r) {
                            a = !0, n = t;
                            break
                        } if (!r || !a) return e.clickedSlide = void 0, void (e.clickedIndex = void 0);
                e.clickedSlide = r, e.virtual && e.params.virtual.enabled ? e.clickedIndex = parseInt(Ea(r).attr("data-swiper-slide-index"), 10) : e.clickedIndex = n, i.slideToClickedSlide && void 0 !== e.clickedIndex && e.clickedIndex !== e.activeIndex && e.slideToClickedSlide()
            }
        };
        const ja = {
            getTranslate: function (t = (this.isHorizontal() ? "x" : "y")) {
                const {
                    params: e,
                    rtlTranslate: i,
                    translate: r,
                    $wrapperEl: n
                } = this;
                if (e.virtualTranslate) return i ? -r : r;
                if (e.cssMode) return r;
                let a = Pa(n[0], t);
                return i && (a = -a), a || 0
            },
            setTranslate: function (t, e) {
                const i = this,
                    {
                        rtlTranslate: r,
                        params: n,
                        $wrapperEl: a,
                        wrapperEl: s,
                        progress: o
                    } = i;
                let l, c = 0,
                    u = 0;
                i.isHorizontal() ? c = r ? -t : t : u = t, n.roundLengths && (c = Math.floor(c), u = Math.floor(u)), n.cssMode ? s[i.isHorizontal() ? "scrollLeft" : "scrollTop"] = i.isHorizontal() ? -c : -u : n.virtualTranslate || a.transform(`translate3d(${c}px, ${u}px, 0px)`), i.previousTranslate = i.translate, i.translate = i.isHorizontal() ? c : u;
                const h = i.maxTranslate() - i.minTranslate();
                l = 0 === h ? 0 : (t - i.minTranslate()) / h, l !== o && i.updateProgress(t), i.emit("setTranslate", i.translate, e)
            },
            minTranslate: function () {
                return -this.snapGrid[0]
            },
            maxTranslate: function () {
                return -this.snapGrid[this.snapGrid.length - 1]
            },
            translateTo: function (t = 0, e = this.params.speed, i = !0, r = !0, n) {
                const a = this,
                    {
                        params: s,
                        wrapperEl: o
                    } = a;
                if (a.animating && s.preventInteractionOnTransition) return !1;
                const l = a.minTranslate(),
                    c = a.maxTranslate();
                let u;
                if (u = r && t > l ? l : r && t < c ? c : t, a.updateProgress(u), s.cssMode) {
                    const t = a.isHorizontal();
                    if (0 === e) o[t ? "scrollLeft" : "scrollTop"] = -u;
                    else {
                        if (!a.support.smoothScroll) return Ia({
                            swiper: a,
                            targetPosition: -u,
                            side: t ? "left" : "top"
                        }), !0;
                        o.scrollTo({
                            [t ? "left" : "top"]: -u,
                            behavior: "smooth"
                        })
                    }
                    return !0
                }
                return 0 === e ? (a.setTransition(0), a.setTranslate(u), i && (a.emit("beforeTransitionStart", e, n), a.emit("transitionEnd"))) : (a.setTransition(e), a.setTranslate(u), i && (a.emit("beforeTransitionStart", e, n), a.emit("transitionStart")), a.animating || (a.animating = !0, a.onTranslateToWrapperTransitionEnd || (a.onTranslateToWrapperTransitionEnd = function (t) {
                    a && !a.destroyed && t.target === this && (a.$wrapperEl[0].removeEventListener("transitionend", a.onTranslateToWrapperTransitionEnd), a.$wrapperEl[0].removeEventListener("webkitTransitionEnd", a.onTranslateToWrapperTransitionEnd), a.onTranslateToWrapperTransitionEnd = null, delete a.onTranslateToWrapperTransitionEnd, i && a.emit("transitionEnd"))
                }), a.$wrapperEl[0].addEventListener("transitionend", a.onTranslateToWrapperTransitionEnd), a.$wrapperEl[0].addEventListener("webkitTransitionEnd", a.onTranslateToWrapperTransitionEnd))), !0
            }
        };

        function Ga({
            swiper: t,
            runCallbacks: e,
            direction: i,
            step: r
        }) {
            const {
                activeIndex: n,
                previousIndex: a
            } = t;
            let s = i;
            if (s || (s = n > a ? "next" : n < a ? "prev" : "reset"), t.emit(`transition${r}`), e && n !== a) {
                if ("reset" === s) return void t.emit(`slideResetTransition${r}`);
                t.emit(`slideChangeTransition${r}`), "next" === s ? t.emit(`slideNextTransition${r}`) : t.emit(`slidePrevTransition${r}`)
            }
        }
        const Ha = {
            slideTo: function (t = 0, e = this.params.speed, i = !0, r, n) {
                if ("number" != typeof t && "string" != typeof t) throw new Error(`The 'index' argument cannot have type other than 'number' or 'string'. [${typeof t}] given.`);
                if ("string" == typeof t) {
                    const e = parseInt(t, 10);
                    if (!isFinite(e)) throw new Error(`The passed-in 'index' (string) couldn't be converted to 'number'. [${t}] given.`);
                    t = e
                }
                const a = this;
                let s = t;
                s < 0 && (s = 0);
                const {
                    params: o,
                    snapGrid: l,
                    slidesGrid: c,
                    previousIndex: u,
                    activeIndex: h,
                    rtlTranslate: d,
                    wrapperEl: p,
                    enabled: f
                } = a;
                if (a.animating && o.preventInteractionOnTransition || !f && !r && !n) return !1;
                const m = Math.min(a.params.slidesPerGroupSkip, s);
                let g = m + Math.floor((s - m) / a.params.slidesPerGroup);
                g >= l.length && (g = l.length - 1);
                const v = -l[g];
                if (o.normalizeSlideIndex)
                    for (let t = 0; t < c.length; t += 1) {
                        const e = -Math.floor(100 * v),
                            i = Math.floor(100 * c[t]),
                            r = Math.floor(100 * c[t + 1]);
                        void 0 !== c[t + 1] ? e >= i && e < r - (r - i) / 2 ? s = t : e >= i && e < r && (s = t + 1) : e >= i && (s = t)
                    }
                if (a.initialized && s !== h) {
                    if (!a.allowSlideNext && v < a.translate && v < a.minTranslate()) return !1;
                    if (!a.allowSlidePrev && v > a.translate && v > a.maxTranslate() && (h || 0) !== s) return !1
                }
                let y;
                if (s !== (u || 0) && i && a.emit("beforeSlideChangeStart"), a.updateProgress(v), y = s > h ? "next" : s < h ? "prev" : "reset", d && -v === a.translate || !d && v === a.translate) return a.updateActiveIndex(s), o.autoHeight && a.updateAutoHeight(), a.updateSlidesClasses(), "slide" !== o.effect && a.setTranslate(v), "reset" !== y && (a.transitionStart(i, y), a.transitionEnd(i, y)), !1;
                if (o.cssMode) {
                    const t = a.isHorizontal(),
                        i = d ? v : -v;
                    if (0 === e) {
                        const e = a.virtual && a.params.virtual.enabled;
                        e && (a.wrapperEl.style.scrollSnapType = "none", a._immediateVirtual = !0), p[t ? "scrollLeft" : "scrollTop"] = i, e && requestAnimationFrame((() => {
                            a.wrapperEl.style.scrollSnapType = "", a._swiperImmediateVirtual = !1
                        }))
                    } else {
                        if (!a.support.smoothScroll) return Ia({
                            swiper: a,
                            targetPosition: i,
                            side: t ? "left" : "top"
                        }), !0;
                        p.scrollTo({
                            [t ? "left" : "top"]: i,
                            behavior: "smooth"
                        })
                    }
                    return !0
                }
                return a.setTransition(e), a.setTranslate(v), a.updateActiveIndex(s), a.updateSlidesClasses(), a.emit("beforeTransitionStart", e, r), a.transitionStart(i, y), 0 === e ? a.transitionEnd(i, y) : a.animating || (a.animating = !0, a.onSlideToWrapperTransitionEnd || (a.onSlideToWrapperTransitionEnd = function (t) {
                    a && !a.destroyed && t.target === this && (a.$wrapperEl[0].removeEventListener("transitionend", a.onSlideToWrapperTransitionEnd), a.$wrapperEl[0].removeEventListener("webkitTransitionEnd", a.onSlideToWrapperTransitionEnd), a.onSlideToWrapperTransitionEnd = null, delete a.onSlideToWrapperTransitionEnd, a.transitionEnd(i, y))
                }), a.$wrapperEl[0].addEventListener("transitionend", a.onSlideToWrapperTransitionEnd), a.$wrapperEl[0].addEventListener("webkitTransitionEnd", a.onSlideToWrapperTransitionEnd)), !0
            },
            slideToLoop: function (t = 0, e = this.params.speed, i = !0, r) {
                if ("string" == typeof t) {
                    const e = parseInt(t, 10);
                    if (!isFinite(e)) throw new Error(`The passed-in 'index' (string) couldn't be converted to 'number'. [${t}] given.`);
                    t = e
                }
                const n = this;
                let a = t;
                return n.params.loop && (a += n.loopedSlides), n.slideTo(a, e, i, r)
            },
            slideNext: function (t = this.params.speed, e = !0, i) {
                const r = this,
                    {
                        animating: n,
                        enabled: a,
                        params: s
                    } = r;
                if (!a) return r;
                let o = s.slidesPerGroup;
                "auto" === s.slidesPerView && 1 === s.slidesPerGroup && s.slidesPerGroupAuto && (o = Math.max(r.slidesPerViewDynamic("current", !0), 1));
                const l = r.activeIndex < s.slidesPerGroupSkip ? 1 : o;
                if (s.loop) {
                    if (n && s.loopPreventsSlide) return !1;
                    r.loopFix(), r._clientLeft = r.$wrapperEl[0].clientLeft
                }
                return s.rewind && r.isEnd ? r.slideTo(0, t, e, i) : r.slideTo(r.activeIndex + l, t, e, i)
            },
            slidePrev: function (t = this.params.speed, e = !0, i) {
                const r = this,
                    {
                        params: n,
                        animating: a,
                        snapGrid: s,
                        slidesGrid: o,
                        rtlTranslate: l,
                        enabled: c
                    } = r;
                if (!c) return r;
                if (n.loop) {
                    if (a && n.loopPreventsSlide) return !1;
                    r.loopFix(), r._clientLeft = r.$wrapperEl[0].clientLeft
                }

                function u(t) {
                    return t < 0 ? -Math.floor(Math.abs(t)) : Math.floor(t)
                }
                const h = u(l ? r.translate : -r.translate),
                    d = s.map((t => u(t)));
                let p = s[d.indexOf(h) - 1];
                if (void 0 === p && n.cssMode) {
                    let t;
                    s.forEach(((e, i) => {
                        h >= e && (t = i)
                    })), void 0 !== t && (p = s[t > 0 ? t - 1 : t])
                }
                let f = 0;
                if (void 0 !== p && (f = o.indexOf(p), f < 0 && (f = r.activeIndex - 1), "auto" === n.slidesPerView && 1 === n.slidesPerGroup && n.slidesPerGroupAuto && (f = f - r.slidesPerViewDynamic("previous", !0) + 1, f = Math.max(f, 0))), n.rewind && r.isBeginning) {
                    const n = r.params.virtual && r.params.virtual.enabled && r.virtual ? r.virtual.slides.length - 1 : r.slides.length - 1;
                    return r.slideTo(n, t, e, i)
                }
                return r.slideTo(f, t, e, i)
            },
            slideReset: function (t = this.params.speed, e = !0, i) {
                return this.slideTo(this.activeIndex, t, e, i)
            },
            slideToClosest: function (t = this.params.speed, e = !0, i, r = .5) {
                const n = this;
                let a = n.activeIndex;
                const s = Math.min(n.params.slidesPerGroupSkip, a),
                    o = s + Math.floor((a - s) / n.params.slidesPerGroup),
                    l = n.rtlTranslate ? n.translate : -n.translate;
                if (l >= n.snapGrid[o]) {
                    const t = n.snapGrid[o];
                    l - t > (n.snapGrid[o + 1] - t) * r && (a += n.params.slidesPerGroup)
                } else {
                    const t = n.snapGrid[o - 1];
                    l - t <= (n.snapGrid[o] - t) * r && (a -= n.params.slidesPerGroup)
                }
                return a = Math.max(a, 0), a = Math.min(a, n.slidesGrid.length - 1), n.slideTo(a, t, e, i)
            },
            slideToClickedSlide: function () {
                const t = this,
                    {
                        params: e,
                        $wrapperEl: i
                    } = t,
                    r = "auto" === e.slidesPerView ? t.slidesPerViewDynamic() : e.slidesPerView;
                let n, a = t.clickedIndex;
                if (e.loop) {
                    if (t.animating) return;
                    n = parseInt(Ea(t.clickedSlide).attr("data-swiper-slide-index"), 10), e.centeredSlides ? a < t.loopedSlides - r / 2 || a > t.slides.length - t.loopedSlides + r / 2 ? (t.loopFix(), a = i.children(`.${e.slideClass}[data-swiper-slide-index="${n}"]:not(.${e.slideDuplicateClass})`).eq(0).index(), Ma((() => {
                        t.slideTo(a)
                    }))) : t.slideTo(a) : a > t.slides.length - r ? (t.loopFix(), a = i.children(`.${e.slideClass}[data-swiper-slide-index="${n}"]:not(.${e.slideDuplicateClass})`).eq(0).index(), Ma((() => {
                        t.slideTo(a)
                    }))) : t.slideTo(a)
                } else t.slideTo(a)
            }
        };
        const Wa = {
            loopCreate: function () {
                const t = this,
                    e = va(),
                    {
                        params: i,
                        $wrapperEl: r
                    } = t,
                    n = r.children().length > 0 ? Ea(r.children()[0].parentNode) : r;
                n.children(`.${i.slideClass}.${i.slideDuplicateClass}`).remove();
                let a = n.children(`.${i.slideClass}`);
                if (i.loopFillGroupWithBlank) {
                    const t = i.slidesPerGroup - a.length % i.slidesPerGroup;
                    if (t !== i.slidesPerGroup) {
                        for (let r = 0; r < t; r += 1) {
                            const t = Ea(e.createElement("div")).addClass(`${i.slideClass} ${i.slideBlankClass}`);
                            n.append(t)
                        }
                        a = n.children(`.${i.slideClass}`)
                    }
                }
                "auto" !== i.slidesPerView || i.loopedSlides || (i.loopedSlides = a.length), t.loopedSlides = Math.ceil(parseFloat(i.loopedSlides || i.slidesPerView, 10)), t.loopedSlides += i.loopAdditionalSlides, t.loopedSlides > a.length && t.params.loopedSlidesLimit && (t.loopedSlides = a.length);
                const s = [],
                    o = [];
                a.each(((t, e) => {
                    Ea(t).attr("data-swiper-slide-index", e)
                }));
                for (let e = 0; e < t.loopedSlides; e += 1) {
                    const t = e - Math.floor(e / a.length) * a.length;
                    o.push(a.eq(t)[0]), s.unshift(a.eq(a.length - t - 1)[0])
                }
                for (let t = 0; t < o.length; t += 1) n.append(Ea(o[t].cloneNode(!0)).addClass(i.slideDuplicateClass));
                for (let t = s.length - 1; t >= 0; t -= 1) n.prepend(Ea(s[t].cloneNode(!0)).addClass(i.slideDuplicateClass))
            },
            loopFix: function () {
                const t = this;
                t.emit("beforeLoopFix");
                const {
                    activeIndex: e,
                    slides: i,
                    loopedSlides: r,
                    allowSlidePrev: n,
                    allowSlideNext: a,
                    snapGrid: s,
                    rtlTranslate: o
                } = t;
                let l;
                t.allowSlidePrev = !0, t.allowSlideNext = !0;
                const c = -s[e] - t.getTranslate();
                if (e < r) {
                    l = i.length - 3 * r + e, l += r;
                    t.slideTo(l, 0, !1, !0) && 0 !== c && t.setTranslate((o ? -t.translate : t.translate) - c)
                } else if (e >= i.length - r) {
                    l = -i.length + e + r, l += r;
                    t.slideTo(l, 0, !1, !0) && 0 !== c && t.setTranslate((o ? -t.translate : t.translate) - c)
                }
                t.allowSlidePrev = n, t.allowSlideNext = a, t.emit("loopFix")
            },
            loopDestroy: function () {
                const {
                    $wrapperEl: t,
                    params: e,
                    slides: i
                } = this;
                t.children(`.${e.slideClass}.${e.slideDuplicateClass},.${e.slideClass}.${e.slideBlankClass}`).remove(), i.removeAttr("data-swiper-slide-index")
            }
        };

        function Za(t) {
            const e = this,
                i = va(),
                r = ba(),
                n = e.touchEventsData,
                {
                    params: a,
                    touches: s,
                    enabled: o
                } = e;
            if (!o) return;
            if (e.animating && a.preventInteractionOnTransition) return;
            !e.animating && a.cssMode && a.loop && e.loopFix();
            let l = t;
            l.originalEvent && (l = l.originalEvent);
            let c = Ea(l.target);
            if ("wrapper" === a.touchEventsTarget && !c.closest(e.wrapperEl).length) return;
            if (n.isTouchEvent = "touchstart" === l.type, !n.isTouchEvent && "which" in l && 3 === l.which) return;
            if (!n.isTouchEvent && "button" in l && l.button > 0) return;
            if (n.isTouched && n.isMoved) return;
            const u = !!a.noSwipingClass && "" !== a.noSwipingClass,
                h = t.composedPath ? t.composedPath() : t.path;
            u && l.target && l.target.shadowRoot && h && (c = Ea(h[0]));
            const d = a.noSwipingSelector ? a.noSwipingSelector : `.${a.noSwipingClass}`,
                p = !(!l.target || !l.target.shadowRoot);
            if (a.noSwiping && (p ? function (t, e = this) {
                return function e(i) {
                    if (!i || i === va() || i === ba()) return null;
                    i.assignedSlot && (i = i.assignedSlot);
                    const r = i.closest(t);
                    return r || i.getRootNode ? r || e(i.getRootNode().host) : null
                }(e)
            }(d, c[0]) : c.closest(d)[0])) return void (e.allowClick = !0);
            if (a.swipeHandler && !c.closest(a.swipeHandler)[0]) return;
            s.currentX = "touchstart" === l.type ? l.targetTouches[0].pageX : l.pageX, s.currentY = "touchstart" === l.type ? l.targetTouches[0].pageY : l.pageY;
            const f = s.currentX,
                m = s.currentY,
                g = a.edgeSwipeDetection || a.iOSEdgeSwipeDetection,
                v = a.edgeSwipeThreshold || a.iOSEdgeSwipeThreshold;
            if (g && (f <= v || f >= r.innerWidth - v)) {
                if ("prevent" !== g) return;
                t.preventDefault()
            }
            if (Object.assign(n, {
                isTouched: !0,
                isMoved: !1,
                allowTouchCallbacks: !0,
                isScrolling: void 0,
                startMoving: void 0
            }), s.startX = f, s.startY = m, n.touchStartTime = Ca(), e.allowClick = !0, e.updateSize(), e.swipeDirection = void 0, a.threshold > 0 && (n.allowThresholdMove = !1), "touchstart" !== l.type) {
                let t = !0;
                c.is(n.focusableElements) && (t = !1, "SELECT" === c[0].nodeName && (n.isTouched = !1)), i.activeElement && Ea(i.activeElement).is(n.focusableElements) && i.activeElement !== c[0] && i.activeElement.blur();
                const r = t && e.allowTouchMove && a.touchStartPreventDefault;
                !a.touchStartForcePreventDefault && !r || c[0].isContentEditable || l.preventDefault()
            }
            e.params.freeMode && e.params.freeMode.enabled && e.freeMode && e.animating && !a.cssMode && e.freeMode.onTouchStart(), e.emit("touchStart", l)
        }

        function $a(t) {
            const e = va(),
                i = this,
                r = i.touchEventsData,
                {
                    params: n,
                    touches: a,
                    rtlTranslate: s,
                    enabled: o
                } = i;
            if (!o) return;
            let l = t;
            if (l.originalEvent && (l = l.originalEvent), !r.isTouched) return void (r.startMoving && r.isScrolling && i.emit("touchMoveOpposite", l));
            if (r.isTouchEvent && "touchmove" !== l.type) return;
            const c = "touchmove" === l.type && l.targetTouches && (l.targetTouches[0] || l.changedTouches[0]),
                u = "touchmove" === l.type ? c.pageX : l.pageX,
                h = "touchmove" === l.type ? c.pageY : l.pageY;
            if (l.preventedByNestedSwiper) return a.startX = u, void (a.startY = h);
            if (!i.allowTouchMove) return Ea(l.target).is(r.focusableElements) || (i.allowClick = !1), void (r.isTouched && (Object.assign(a, {
                startX: u,
                startY: h,
                currentX: u,
                currentY: h
            }), r.touchStartTime = Ca()));
            if (r.isTouchEvent && n.touchReleaseOnEdges && !n.loop)
                if (i.isVertical()) {
                    if (h < a.startY && i.translate <= i.maxTranslate() || h > a.startY && i.translate >= i.minTranslate()) return r.isTouched = !1, void (r.isMoved = !1)
                } else if (u < a.startX && i.translate <= i.maxTranslate() || u > a.startX && i.translate >= i.minTranslate()) return;
            if (r.isTouchEvent && e.activeElement && l.target === e.activeElement && Ea(l.target).is(r.focusableElements)) return r.isMoved = !0, void (i.allowClick = !1);
            if (r.allowTouchCallbacks && i.emit("touchMove", l), l.targetTouches && l.targetTouches.length > 1) return;
            a.currentX = u, a.currentY = h;
            const d = a.currentX - a.startX,
                p = a.currentY - a.startY;
            if (i.params.threshold && Math.sqrt(d ** 2 + p ** 2) < i.params.threshold) return;
            if (void 0 === r.isScrolling) {
                let t;
                i.isHorizontal() && a.currentY === a.startY || i.isVertical() && a.currentX === a.startX ? r.isScrolling = !1 : d * d + p * p >= 25 && (t = 180 * Math.atan2(Math.abs(p), Math.abs(d)) / Math.PI, r.isScrolling = i.isHorizontal() ? t > n.touchAngle : 90 - t > n.touchAngle)
            }
            if (r.isScrolling && i.emit("touchMoveOpposite", l), void 0 === r.startMoving && (a.currentX === a.startX && a.currentY === a.startY || (r.startMoving = !0)), r.isScrolling) return void (r.isTouched = !1);
            if (!r.startMoving) return;
            i.allowClick = !1, !n.cssMode && l.cancelable && l.preventDefault(), n.touchMoveStopPropagation && !n.nested && l.stopPropagation(), r.isMoved || (n.loop && !n.cssMode && i.loopFix(), r.startTranslate = i.getTranslate(), i.setTransition(0), i.animating && i.$wrapperEl.trigger("webkitTransitionEnd transitionend"), r.allowMomentumBounce = !1, !n.grabCursor || !0 !== i.allowSlideNext && !0 !== i.allowSlidePrev || i.setGrabCursor(!0), i.emit("sliderFirstMove", l)), i.emit("sliderMove", l), r.isMoved = !0;
            let f = i.isHorizontal() ? d : p;
            a.diff = f, f *= n.touchRatio, s && (f = -f), i.swipeDirection = f > 0 ? "prev" : "next", r.currentTranslate = f + r.startTranslate;
            let m = !0,
                g = n.resistanceRatio;
            if (n.touchReleaseOnEdges && (g = 0), f > 0 && r.currentTranslate > i.minTranslate() ? (m = !1, n.resistance && (r.currentTranslate = i.minTranslate() - 1 + (-i.minTranslate() + r.startTranslate + f) ** g)) : f < 0 && r.currentTranslate < i.maxTranslate() && (m = !1, n.resistance && (r.currentTranslate = i.maxTranslate() + 1 - (i.maxTranslate() - r.startTranslate - f) ** g)), m && (l.preventedByNestedSwiper = !0), !i.allowSlideNext && "next" === i.swipeDirection && r.currentTranslate < r.startTranslate && (r.currentTranslate = r.startTranslate), !i.allowSlidePrev && "prev" === i.swipeDirection && r.currentTranslate > r.startTranslate && (r.currentTranslate = r.startTranslate), i.allowSlidePrev || i.allowSlideNext || (r.currentTranslate = r.startTranslate), n.threshold > 0) {
                if (!(Math.abs(f) > n.threshold || r.allowThresholdMove)) return void (r.currentTranslate = r.startTranslate);
                if (!r.allowThresholdMove) return r.allowThresholdMove = !0, a.startX = a.currentX, a.startY = a.currentY, r.currentTranslate = r.startTranslate, void (a.diff = i.isHorizontal() ? a.currentX - a.startX : a.currentY - a.startY)
            }
            n.followFinger && !n.cssMode && ((n.freeMode && n.freeMode.enabled && i.freeMode || n.watchSlidesProgress) && (i.updateActiveIndex(), i.updateSlidesClasses()), i.params.freeMode && n.freeMode.enabled && i.freeMode && i.freeMode.onTouchMove(), i.updateProgress(r.currentTranslate), i.setTranslate(r.currentTranslate))
        }

        function Ua(t) {
            const e = this,
                i = e.touchEventsData,
                {
                    params: r,
                    touches: n,
                    rtlTranslate: a,
                    slidesGrid: s,
                    enabled: o
                } = e;
            if (!o) return;
            let l = t;
            if (l.originalEvent && (l = l.originalEvent), i.allowTouchCallbacks && e.emit("touchEnd", l), i.allowTouchCallbacks = !1, !i.isTouched) return i.isMoved && r.grabCursor && e.setGrabCursor(!1), i.isMoved = !1, void (i.startMoving = !1);
            r.grabCursor && i.isMoved && i.isTouched && (!0 === e.allowSlideNext || !0 === e.allowSlidePrev) && e.setGrabCursor(!1);
            const c = Ca(),
                u = c - i.touchStartTime;
            if (e.allowClick) {
                const t = l.path || l.composedPath && l.composedPath();
                e.updateClickedSlide(t && t[0] || l.target), e.emit("tap click", l), u < 300 && c - i.lastClickTime < 300 && e.emit("doubleTap doubleClick", l)
            }
            if (i.lastClickTime = Ca(), Ma((() => {
                e.destroyed || (e.allowClick = !0)
            })), !i.isTouched || !i.isMoved || !e.swipeDirection || 0 === n.diff || i.currentTranslate === i.startTranslate) return i.isTouched = !1, i.isMoved = !1, void (i.startMoving = !1);
            let h;
            if (i.isTouched = !1, i.isMoved = !1, i.startMoving = !1, h = r.followFinger ? a ? e.translate : -e.translate : -i.currentTranslate, r.cssMode) return;
            if (e.params.freeMode && r.freeMode.enabled) return void e.freeMode.onTouchEnd({
                currentPos: h
            });
            let d = 0,
                p = e.slidesSizesGrid[0];
            for (let t = 0; t < s.length; t += t < r.slidesPerGroupSkip ? 1 : r.slidesPerGroup) {
                const e = t < r.slidesPerGroupSkip - 1 ? 1 : r.slidesPerGroup;
                void 0 !== s[t + e] ? h >= s[t] && h < s[t + e] && (d = t, p = s[t + e] - s[t]) : h >= s[t] && (d = t, p = s[s.length - 1] - s[s.length - 2])
            }
            let f = null,
                m = null;
            r.rewind && (e.isBeginning ? m = e.params.virtual && e.params.virtual.enabled && e.virtual ? e.virtual.slides.length - 1 : e.slides.length - 1 : e.isEnd && (f = 0));
            const g = (h - s[d]) / p,
                v = d < r.slidesPerGroupSkip - 1 ? 1 : r.slidesPerGroup;
            if (u > r.longSwipesMs) {
                if (!r.longSwipes) return void e.slideTo(e.activeIndex);
                "next" === e.swipeDirection && (g >= r.longSwipesRatio ? e.slideTo(r.rewind && e.isEnd ? f : d + v) : e.slideTo(d)), "prev" === e.swipeDirection && (g > 1 - r.longSwipesRatio ? e.slideTo(d + v) : null !== m && g < 0 && Math.abs(g) > r.longSwipesRatio ? e.slideTo(m) : e.slideTo(d))
            } else {
                if (!r.shortSwipes) return void e.slideTo(e.activeIndex);
                e.navigation && (l.target === e.navigation.nextEl || l.target === e.navigation.prevEl) ? l.target === e.navigation.nextEl ? e.slideTo(d + v) : e.slideTo(d) : ("next" === e.swipeDirection && e.slideTo(null !== f ? f : d + v), "prev" === e.swipeDirection && e.slideTo(null !== m ? m : d))
            }
        }

        function Xa() {
            const t = this,
                {
                    params: e,
                    el: i
                } = t;
            if (i && 0 === i.offsetWidth) return;
            e.breakpoints && t.setBreakpoint();
            const {
                allowSlideNext: r,
                allowSlidePrev: n,
                snapGrid: a
            } = t;
            t.allowSlideNext = !0, t.allowSlidePrev = !0, t.updateSize(), t.updateSlides(), t.updateSlidesClasses(), ("auto" === e.slidesPerView || e.slidesPerView > 1) && t.isEnd && !t.isBeginning && !t.params.centeredSlides ? t.slideTo(t.slides.length - 1, 0, !1, !0) : t.slideTo(t.activeIndex, 0, !1, !0), t.autoplay && t.autoplay.running && t.autoplay.paused && t.autoplay.run(), t.allowSlidePrev = n, t.allowSlideNext = r, t.params.watchOverflow && a !== t.snapGrid && t.checkOverflow()
        }

        function Ka(t) {
            const e = this;
            e.enabled && (e.allowClick || (e.params.preventClicks && t.preventDefault(), e.params.preventClicksPropagation && e.animating && (t.stopPropagation(), t.stopImmediatePropagation())))
        }

        function Ja() {
            const t = this,
                {
                    wrapperEl: e,
                    rtlTranslate: i,
                    enabled: r
                } = t;
            if (!r) return;
            let n;
            t.previousTranslate = t.translate, t.isHorizontal() ? t.translate = -e.scrollLeft : t.translate = -e.scrollTop, 0 === t.translate && (t.translate = 0), t.updateActiveIndex(), t.updateSlidesClasses();
            const a = t.maxTranslate() - t.minTranslate();
            n = 0 === a ? 0 : (t.translate - t.minTranslate()) / a, n !== t.progress && t.updateProgress(i ? -t.translate : t.translate), t.emit("setTranslate", t.translate, !1)
        }
        let Qa = !1;

        function ts() { }
        const es = (t, e) => {
            const i = va(),
                {
                    params: r,
                    touchEvents: n,
                    el: a,
                    wrapperEl: s,
                    device: o,
                    support: l
                } = t,
                c = !!r.nested,
                u = "on" === e ? "addEventListener" : "removeEventListener",
                h = e;
            if (l.touch) {
                const e = !("touchstart" !== n.start || !l.passiveListener || !r.passiveListeners) && {
                    passive: !0,
                    capture: !1
                };
                a[u](n.start, t.onTouchStart, e), a[u](n.move, t.onTouchMove, l.passiveListener ? {
                    passive: !1,
                    capture: c
                } : c), a[u](n.end, t.onTouchEnd, e), n.cancel && a[u](n.cancel, t.onTouchEnd, e)
            } else a[u](n.start, t.onTouchStart, !1), i[u](n.move, t.onTouchMove, c), i[u](n.end, t.onTouchEnd, !1);
            (r.preventClicks || r.preventClicksPropagation) && a[u]("click", t.onClick, !0), r.cssMode && s[u]("scroll", t.onScroll), r.updateOnWindowResize ? t[h](o.ios || o.android ? "resize orientationchange observerUpdate" : "resize observerUpdate", Xa, !0) : t[h]("observerUpdate", Xa, !0)
        };
        const is = {
            attachEvents: function () {
                const t = this,
                    e = va(),
                    {
                        params: i,
                        support: r
                    } = t;
                t.onTouchStart = Za.bind(t), t.onTouchMove = $a.bind(t), t.onTouchEnd = Ua.bind(t), i.cssMode && (t.onScroll = Ja.bind(t)), t.onClick = Ka.bind(t), r.touch && !Qa && (e.addEventListener("touchstart", ts), Qa = !0), es(t, "on")
            },
            detachEvents: function () {
                es(this, "off")
            }
        },
            rs = (t, e) => t.grid && e.grid && e.grid.rows > 1;
        const ns = {
            setBreakpoint: function () {
                const t = this,
                    {
                        activeIndex: e,
                        initialized: i,
                        loopedSlides: r = 0,
                        params: n,
                        $el: a
                    } = t,
                    s = n.breakpoints;
                if (!s || s && 0 === Object.keys(s).length) return;
                const o = t.getBreakpoint(s, t.params.breakpointsBase, t.el);
                if (!o || t.currentBreakpoint === o) return;
                const l = (o in s ? s[o] : void 0) || t.originalParams,
                    c = rs(t, n),
                    u = rs(t, l),
                    h = n.enabled;
                c && !u ? (a.removeClass(`${n.containerModifierClass}grid ${n.containerModifierClass}grid-column`), t.emitContainerClasses()) : !c && u && (a.addClass(`${n.containerModifierClass}grid`), (l.grid.fill && "column" === l.grid.fill || !l.grid.fill && "column" === n.grid.fill) && a.addClass(`${n.containerModifierClass}grid-column`), t.emitContainerClasses()), ["navigation", "pagination", "scrollbar"].forEach((e => {
                    const i = n[e] && n[e].enabled,
                        r = l[e] && l[e].enabled;
                    i && !r && t[e].disable(), !i && r && t[e].enable()
                }));
                const d = l.direction && l.direction !== n.direction,
                    p = n.loop && (l.slidesPerView !== n.slidesPerView || d);
                d && i && t.changeDirection(), La(t.params, l);
                const f = t.params.enabled;
                Object.assign(t, {
                    allowTouchMove: t.params.allowTouchMove,
                    allowSlideNext: t.params.allowSlideNext,
                    allowSlidePrev: t.params.allowSlidePrev
                }), h && !f ? t.disable() : !h && f && t.enable(), t.currentBreakpoint = o, t.emit("_beforeBreakpoint", l), p && i && (t.loopDestroy(), t.loopCreate(), t.updateSlides(), t.slideTo(e - r + t.loopedSlides, 0, !1)), t.emit("breakpoint", l)
            },
            getBreakpoint: function (t, e = "window", i) {
                if (!t || "container" === e && !i) return;
                let r = !1;
                const n = ba(),
                    a = "window" === e ? n.innerHeight : i.clientHeight,
                    s = Object.keys(t).map((t => {
                        if ("string" == typeof t && 0 === t.indexOf("@")) {
                            const e = parseFloat(t.substr(1));
                            return {
                                value: a * e,
                                point: t
                            }
                        }
                        return {
                            value: t,
                            point: t
                        }
                    }));
                s.sort(((t, e) => parseInt(t.value, 10) - parseInt(e.value, 10)));
                for (let t = 0; t < s.length; t += 1) {
                    const {
                        point: a,
                        value: o
                    } = s[t];
                    "window" === e ? n.matchMedia(`(min-width: ${o}px)`).matches && (r = a) : o <= i.clientWidth && (r = a)
                }
                return r || "max"
            }
        };
        const as = {
            addClasses: function () {
                const t = this,
                    {
                        classNames: e,
                        params: i,
                        rtl: r,
                        $el: n,
                        device: a,
                        support: s
                    } = t,
                    o = function (t, e) {
                        const i = [];
                        return t.forEach((t => {
                            "object" == typeof t ? Object.keys(t).forEach((r => {
                                t[r] && i.push(e + r)
                            })) : "string" == typeof t && i.push(e + t)
                        })), i
                    }(["initialized", i.direction, {
                        "pointer-events": !s.touch
                    }, {
                            "free-mode": t.params.freeMode && i.freeMode.enabled
                        }, {
                            autoheight: i.autoHeight
                        }, {
                            rtl: r
                        }, {
                            grid: i.grid && i.grid.rows > 1
                        }, {
                            "grid-column": i.grid && i.grid.rows > 1 && "column" === i.grid.fill
                        }, {
                            android: a.android
                        }, {
                            ios: a.ios
                        }, {
                            "css-mode": i.cssMode
                        }, {
                            centered: i.cssMode && i.centeredSlides
                        }, {
                            "watch-progress": i.watchSlidesProgress
                        }], i.containerModifierClass);
                e.push(...o), n.addClass([...e].join(" ")), t.emitContainerClasses()
            },
            removeClasses: function () {
                const {
                    $el: t,
                    classNames: e
                } = this;
                t.removeClass(e.join(" ")), this.emitContainerClasses()
            }
        };
        const ss = {
            loadImage: function (t, e, i, r, n, a) {
                const s = ba();
                let o;

                function l() {
                    a && a()
                }
                Ea(t).parent("picture")[0] || t.complete && n ? l() : e ? (o = new s.Image, o.onload = l, o.onerror = l, r && (o.sizes = r), i && (o.srcset = i), e && (o.src = e)) : l()
            },
            preloadImages: function () {
                const t = this;

                function e() {
                    null != t && t && !t.destroyed && (void 0 !== t.imagesLoaded && (t.imagesLoaded += 1), t.imagesLoaded === t.imagesToLoad.length && (t.params.updateOnImagesReady && t.update(), t.emit("imagesReady")))
                }
                t.imagesToLoad = t.$el.find("img");
                for (let i = 0; i < t.imagesToLoad.length; i += 1) {
                    const r = t.imagesToLoad[i];
                    t.loadImage(r, r.currentSrc || r.getAttribute("src"), r.srcset || r.getAttribute("srcset"), r.sizes || r.getAttribute("sizes"), !0, e)
                }
            }
        };
        const os = {
            init: !0,
            direction: "horizontal",
            touchEventsTarget: "wrapper",
            initialSlide: 0,
            speed: 300,
            cssMode: !1,
            updateOnWindowResize: !0,
            resizeObserver: !0,
            nested: !1,
            createElements: !1,
            enabled: !0,
            focusableElements: "input, select, option, textarea, button, video, label",
            width: null,
            height: null,
            preventInteractionOnTransition: !1,
            userAgent: null,
            url: null,
            edgeSwipeDetection: !1,
            edgeSwipeThreshold: 20,
            autoHeight: !1,
            setWrapperSize: !1,
            virtualTranslate: !1,
            effect: "slide",
            breakpoints: void 0,
            breakpointsBase: "window",
            spaceBetween: 0,
            slidesPerView: 1,
            slidesPerGroup: 1,
            slidesPerGroupSkip: 0,
            slidesPerGroupAuto: !1,
            centeredSlides: !1,
            centeredSlidesBounds: !1,
            slidesOffsetBefore: 0,
            slidesOffsetAfter: 0,
            normalizeSlideIndex: !0,
            centerInsufficientSlides: !1,
            watchOverflow: !0,
            roundLengths: !1,
            touchRatio: 1,
            touchAngle: 45,
            simulateTouch: !0,
            shortSwipes: !0,
            longSwipes: !0,
            longSwipesRatio: .5,
            longSwipesMs: 300,
            followFinger: !0,
            allowTouchMove: !0,
            threshold: 0,
            touchMoveStopPropagation: !1,
            touchStartPreventDefault: !0,
            touchStartForcePreventDefault: !1,
            touchReleaseOnEdges: !1,
            uniqueNavElements: !0,
            resistance: !0,
            resistanceRatio: .85,
            watchSlidesProgress: !1,
            grabCursor: !1,
            preventClicks: !0,
            preventClicksPropagation: !0,
            slideToClickedSlide: !1,
            preloadImages: !0,
            updateOnImagesReady: !0,
            loop: !1,
            loopAdditionalSlides: 0,
            loopedSlides: null,
            loopedSlidesLimit: !0,
            loopFillGroupWithBlank: !1,
            loopPreventsSlide: !0,
            rewind: !1,
            allowSlidePrev: !0,
            allowSlideNext: !0,
            swipeHandler: null,
            noSwiping: !0,
            noSwipingClass: "swiper-no-swiping",
            noSwipingSelector: null,
            passiveListeners: !0,
            maxBackfaceHiddenSlides: 10,
            containerModifierClass: "swiper-",
            slideClass: "swiper-slide",
            slideBlankClass: "swiper-slide-invisible-blank",
            slideActiveClass: "swiper-slide-active",
            slideDuplicateActiveClass: "swiper-slide-duplicate-active",
            slideVisibleClass: "swiper-slide-visible",
            slideDuplicateClass: "swiper-slide-duplicate",
            slideNextClass: "swiper-slide-next",
            slideDuplicateNextClass: "swiper-slide-duplicate-next",
            slidePrevClass: "swiper-slide-prev",
            slideDuplicatePrevClass: "swiper-slide-duplicate-prev",
            wrapperClass: "swiper-wrapper",
            runCallbacksOnInit: !0,
            _emitClasses: !1
        };

        function ls(t, e) {
            return function (i = {}) {
                const r = Object.keys(i)[0],
                    n = i[r];
                "object" == typeof n && null !== n ? (["navigation", "pagination", "scrollbar"].indexOf(r) >= 0 && !0 === t[r] && (t[r] = {
                    auto: !0
                }), r in t && "enabled" in n ? (!0 === t[r] && (t[r] = {
                    enabled: !0
                }), "object" != typeof t[r] || "enabled" in t[r] || (t[r].enabled = !0), t[r] || (t[r] = {
                    enabled: !1
                }), La(e, i)) : La(e, i)) : La(e, i)
            }
        }
        const cs = {
            eventsEmitter: Va,
            update: Ya,
            translate: ja,
            transition: {
                setTransition: function (t, e) {
                    const i = this;
                    i.params.cssMode || i.$wrapperEl.transition(t), i.emit("setTransition", t, e)
                },
                transitionStart: function (t = !0, e) {
                    const i = this,
                        {
                            params: r
                        } = i;
                    r.cssMode || (r.autoHeight && i.updateAutoHeight(), Ga({
                        swiper: i,
                        runCallbacks: t,
                        direction: e,
                        step: "Start"
                    }))
                },
                transitionEnd: function (t = !0, e) {
                    const i = this,
                        {
                            params: r
                        } = i;
                    i.animating = !1, r.cssMode || (i.setTransition(0), Ga({
                        swiper: i,
                        runCallbacks: t,
                        direction: e,
                        step: "End"
                    }))
                }
            },
            slide: Ha,
            loop: Wa,
            grabCursor: {
                setGrabCursor: function (t) {
                    const e = this;
                    if (e.support.touch || !e.params.simulateTouch || e.params.watchOverflow && e.isLocked || e.params.cssMode) return;
                    const i = "container" === e.params.touchEventsTarget ? e.el : e.wrapperEl;
                    i.style.cursor = "move", i.style.cursor = t ? "grabbing" : "grab"
                },
                unsetGrabCursor: function () {
                    const t = this;
                    t.support.touch || t.params.watchOverflow && t.isLocked || t.params.cssMode || (t["container" === t.params.touchEventsTarget ? "el" : "wrapperEl"].style.cursor = "")
                }
            },
            events: is,
            breakpoints: ns,
            checkOverflow: {
                checkOverflow: function () {
                    const t = this,
                        {
                            isLocked: e,
                            params: i
                        } = t,
                        {
                            slidesOffsetBefore: r
                        } = i;
                    if (r) {
                        const e = t.slides.length - 1,
                            i = t.slidesGrid[e] + t.slidesSizesGrid[e] + 2 * r;
                        t.isLocked = t.size > i
                    } else t.isLocked = 1 === t.snapGrid.length;
                    !0 === i.allowSlideNext && (t.allowSlideNext = !t.isLocked), !0 === i.allowSlidePrev && (t.allowSlidePrev = !t.isLocked), e && e !== t.isLocked && (t.isEnd = !1), e !== t.isLocked && t.emit(t.isLocked ? "lock" : "unlock")
                }
            },
            classes: as,
            images: ss
        },
            us = {};
        class hs {
            constructor(...t) {
                let e, i;
                if (1 === t.length && t[0].constructor && "Object" === Object.prototype.toString.call(t[0]).slice(8, -1) ? i = t[0] : [e, i] = t, i || (i = {}), i = La({}, i), e && !i.el && (i.el = e), i.el && Ea(i.el).length > 1) {
                    const t = [];
                    return Ea(i.el).each((e => {
                        const r = La({}, i, {
                            el: e
                        });
                        t.push(new hs(r))
                    })), t
                }
                const r = this;
                r.__swiper__ = !0, r.support = Ba(), r.device = za({
                    userAgent: i.userAgent
                }), r.browser = qa(), r.eventsListeners = {}, r.eventsAnyListeners = [], r.modules = [...r.__modules__], i.modules && Array.isArray(i.modules) && r.modules.push(...i.modules);
                const n = {};
                r.modules.forEach((t => {
                    t({
                        swiper: r,
                        extendParams: ls(i, n),
                        on: r.on.bind(r),
                        once: r.once.bind(r),
                        off: r.off.bind(r),
                        emit: r.emit.bind(r)
                    })
                }));
                const a = La({}, os, n);
                return r.params = La({}, a, us, i), r.originalParams = La({}, r.params), r.passedParams = La({}, i), r.params && r.params.on && Object.keys(r.params.on).forEach((t => {
                    r.on(t, r.params.on[t])
                })), r.params && r.params.onAny && r.onAny(r.params.onAny), r.$ = Ea, Object.assign(r, {
                    enabled: r.params.enabled,
                    el: e,
                    classNames: [],
                    slides: Ea(),
                    slidesGrid: [],
                    snapGrid: [],
                    slidesSizesGrid: [],
                    isHorizontal: () => "horizontal" === r.params.direction,
                    isVertical: () => "vertical" === r.params.direction,
                    activeIndex: 0,
                    realIndex: 0,
                    isBeginning: !0,
                    isEnd: !1,
                    translate: 0,
                    previousTranslate: 0,
                    progress: 0,
                    velocity: 0,
                    animating: !1,
                    allowSlideNext: r.params.allowSlideNext,
                    allowSlidePrev: r.params.allowSlidePrev,
                    touchEvents: function () {
                        const t = ["touchstart", "touchmove", "touchend", "touchcancel"],
                            e = ["pointerdown", "pointermove", "pointerup"];
                        return r.touchEventsTouch = {
                            start: t[0],
                            move: t[1],
                            end: t[2],
                            cancel: t[3]
                        }, r.touchEventsDesktop = {
                            start: e[0],
                            move: e[1],
                            end: e[2]
                        }, r.support.touch || !r.params.simulateTouch ? r.touchEventsTouch : r.touchEventsDesktop
                    }(),
                    touchEventsData: {
                        isTouched: void 0,
                        isMoved: void 0,
                        allowTouchCallbacks: void 0,
                        touchStartTime: void 0,
                        isScrolling: void 0,
                        currentTranslate: void 0,
                        startTranslate: void 0,
                        allowThresholdMove: void 0,
                        focusableElements: r.params.focusableElements,
                        lastClickTime: Ca(),
                        clickTimeout: void 0,
                        velocities: [],
                        allowMomentumBounce: void 0,
                        isTouchEvent: void 0,
                        startMoving: void 0
                    },
                    allowClick: !0,
                    allowTouchMove: r.params.allowTouchMove,
                    touches: {
                        startX: 0,
                        startY: 0,
                        currentX: 0,
                        currentY: 0,
                        diff: 0
                    },
                    imagesToLoad: [],
                    imagesLoaded: 0
                }), r.emit("_swiper"), r.params.init && r.init(), r
            }
            enable() {
                const t = this;
                t.enabled || (t.enabled = !0, t.params.grabCursor && t.setGrabCursor(), t.emit("enable"))
            }
            disable() {
                const t = this;
                t.enabled && (t.enabled = !1, t.params.grabCursor && t.unsetGrabCursor(), t.emit("disable"))
            }
            setProgress(t, e) {
                const i = this;
                t = Math.min(Math.max(t, 0), 1);
                const r = i.minTranslate(),
                    n = (i.maxTranslate() - r) * t + r;
                i.translateTo(n, void 0 === e ? 0 : e), i.updateActiveIndex(), i.updateSlidesClasses()
            }
            emitContainerClasses() {
                const t = this;
                if (!t.params._emitClasses || !t.el) return;
                const e = t.el.className.split(" ").filter((e => 0 === e.indexOf("swiper") || 0 === e.indexOf(t.params.containerModifierClass)));
                t.emit("_containerClasses", e.join(" "))
            }
            getSlideClasses(t) {
                const e = this;
                return e.destroyed ? "" : t.className.split(" ").filter((t => 0 === t.indexOf("swiper-slide") || 0 === t.indexOf(e.params.slideClass))).join(" ")
            }
            emitSlidesClasses() {
                const t = this;
                if (!t.params._emitClasses || !t.el) return;
                const e = [];
                t.slides.each((i => {
                    const r = t.getSlideClasses(i);
                    e.push({
                        slideEl: i,
                        classNames: r
                    }), t.emit("_slideClass", i, r)
                })), t.emit("_slideClasses", e)
            }
            slidesPerViewDynamic(t = "current", e = !1) {
                const {
                    params: i,
                    slides: r,
                    slidesGrid: n,
                    slidesSizesGrid: a,
                    size: s,
                    activeIndex: o
                } = this;
                let l = 1;
                if (i.centeredSlides) {
                    let t, e = r[o].swiperSlideSize;
                    for (let i = o + 1; i < r.length; i += 1) r[i] && !t && (e += r[i].swiperSlideSize, l += 1, e > s && (t = !0));
                    for (let i = o - 1; i >= 0; i -= 1) r[i] && !t && (e += r[i].swiperSlideSize, l += 1, e > s && (t = !0))
                } else if ("current" === t)
                    for (let t = o + 1; t < r.length; t += 1) {
                        (e ? n[t] + a[t] - n[o] < s : n[t] - n[o] < s) && (l += 1)
                    } else
                    for (let t = o - 1; t >= 0; t -= 1) {
                        n[o] - n[t] < s && (l += 1)
                    }
                return l
            }
            update() {
                const t = this;
                if (!t || t.destroyed) return;
                const {
                    snapGrid: e,
                    params: i
                } = t;

                function r() {
                    const e = t.rtlTranslate ? -1 * t.translate : t.translate,
                        i = Math.min(Math.max(e, t.maxTranslate()), t.minTranslate());
                    t.setTranslate(i), t.updateActiveIndex(), t.updateSlidesClasses()
                }
                let n;
                i.breakpoints && t.setBreakpoint(), t.updateSize(), t.updateSlides(), t.updateProgress(), t.updateSlidesClasses(), t.params.freeMode && t.params.freeMode.enabled ? (r(), t.params.autoHeight && t.updateAutoHeight()) : (n = ("auto" === t.params.slidesPerView || t.params.slidesPerView > 1) && t.isEnd && !t.params.centeredSlides ? t.slideTo(t.slides.length - 1, 0, !1, !0) : t.slideTo(t.activeIndex, 0, !1, !0), n || r()), i.watchOverflow && e !== t.snapGrid && t.checkOverflow(), t.emit("update")
            }
            changeDirection(t, e = !0) {
                const i = this,
                    r = i.params.direction;
                return t || (t = "horizontal" === r ? "vertical" : "horizontal"), t === r || "horizontal" !== t && "vertical" !== t || (i.$el.removeClass(`${i.params.containerModifierClass}${r}`).addClass(`${i.params.containerModifierClass}${t}`), i.emitContainerClasses(), i.params.direction = t, i.slides.each((e => {
                    "vertical" === t ? e.style.width = "" : e.style.height = ""
                })), i.emit("changeDirection"), e && i.update()), i
            }
            changeLanguageDirection(t) {
                const e = this;
                e.rtl && "rtl" === t || !e.rtl && "ltr" === t || (e.rtl = "rtl" === t, e.rtlTranslate = "horizontal" === e.params.direction && e.rtl, e.rtl ? (e.$el.addClass(`${e.params.containerModifierClass}rtl`), e.el.dir = "rtl") : (e.$el.removeClass(`${e.params.containerModifierClass}rtl`), e.el.dir = "ltr"), e.update())
            }
            mount(t) {
                const e = this;
                if (e.mounted) return !0;
                const i = Ea(t || e.params.el);
                if (!(t = i[0])) return !1;
                t.swiper = e;
                const r = () => `.${(e.params.wrapperClass || "").trim().split(" ").join(".")}`;
                let n = (() => {
                    if (t && t.shadowRoot && t.shadowRoot.querySelector) {
                        const e = Ea(t.shadowRoot.querySelector(r()));
                        return e.children = t => i.children(t), e
                    }
                    return i.children ? i.children(r()) : Ea(i).children(r())
                })();
                if (0 === n.length && e.params.createElements) {
                    const t = va().createElement("div");
                    n = Ea(t), t.className = e.params.wrapperClass, i.append(t), i.children(`.${e.params.slideClass}`).each((t => {
                        n.append(t)
                    }))
                }
                return Object.assign(e, {
                    $el: i,
                    el: t,
                    $wrapperEl: n,
                    wrapperEl: n[0],
                    mounted: !0,
                    rtl: "rtl" === t.dir.toLowerCase() || "rtl" === i.css("direction"),
                    rtlTranslate: "horizontal" === e.params.direction && ("rtl" === t.dir.toLowerCase() || "rtl" === i.css("direction")),
                    wrongRTL: "-webkit-box" === n.css("display")
                }), !0
            }
            init(t) {
                const e = this;
                if (e.initialized) return e;
                return !1 === e.mount(t) || (e.emit("beforeInit"), e.params.breakpoints && e.setBreakpoint(), e.addClasses(), e.params.loop && e.loopCreate(), e.updateSize(), e.updateSlides(), e.params.watchOverflow && e.checkOverflow(), e.params.grabCursor && e.enabled && e.setGrabCursor(), e.params.preloadImages && e.preloadImages(), e.params.loop ? e.slideTo(e.params.initialSlide + e.loopedSlides, 0, e.params.runCallbacksOnInit, !1, !0) : e.slideTo(e.params.initialSlide, 0, e.params.runCallbacksOnInit, !1, !0), e.attachEvents(), e.initialized = !0, e.emit("init"), e.emit("afterInit")), e
            }
            destroy(t = !0, e = !0) {
                const i = this,
                    {
                        params: r,
                        $el: n,
                        $wrapperEl: a,
                        slides: s
                    } = i;
                return void 0 === i.params || i.destroyed || (i.emit("beforeDestroy"), i.initialized = !1, i.detachEvents(), r.loop && i.loopDestroy(), e && (i.removeClasses(), n.removeAttr("style"), a.removeAttr("style"), s && s.length && s.removeClass([r.slideVisibleClass, r.slideActiveClass, r.slideNextClass, r.slidePrevClass].join(" ")).removeAttr("style").removeAttr("data-swiper-slide-index")), i.emit("destroy"), Object.keys(i.eventsListeners).forEach((t => {
                    i.off(t)
                })), !1 !== t && (i.$el[0].swiper = null, function (t) {
                    const e = t;
                    Object.keys(e).forEach((t => {
                        try {
                            e[t] = null
                        } catch (t) { }
                        try {
                            delete e[t]
                        } catch (t) { }
                    }))
                }(i)), i.destroyed = !0), null
            }
            static extendDefaults(t) {
                La(us, t)
            }
            static get extendedDefaults() {
                return us
            }
            static get defaults() {
                return os
            }
            static installModule(t) {
                hs.prototype.__modules__ || (hs.prototype.__modules__ = []);
                const e = hs.prototype.__modules__;
                "function" == typeof t && e.indexOf(t) < 0 && e.push(t)
            }
            static use(t) {
                return Array.isArray(t) ? (t.forEach((t => hs.installModule(t))), hs) : (hs.installModule(t), hs)
            }
        }
        Object.keys(cs).forEach((t => {
            Object.keys(cs[t]).forEach((e => {
                hs.prototype[e] = cs[t][e]
            }))
        })), hs.use([function ({
            swiper: t,
            on: e,
            emit: i
        }) {
            const r = ba();
            let n = null,
                a = null;
            const s = () => {
                t && !t.destroyed && t.initialized && (i("beforeResize"), i("resize"))
            },
                o = () => {
                    t && !t.destroyed && t.initialized && i("orientationchange")
                };
            e("init", (() => {
                t.params.resizeObserver && void 0 !== r.ResizeObserver ? t && !t.destroyed && t.initialized && (n = new ResizeObserver((e => {
                    a = r.requestAnimationFrame((() => {
                        const {
                            width: i,
                            height: r
                        } = t;
                        let n = i,
                            a = r;
                        e.forEach((({
                            contentBoxSize: e,
                            contentRect: i,
                            target: r
                        }) => {
                            r && r !== t.el || (n = i ? i.width : (e[0] || e).inlineSize, a = i ? i.height : (e[0] || e).blockSize)
                        })), n === i && a === r || s()
                    }))
                })), n.observe(t.el)) : (r.addEventListener("resize", s), r.addEventListener("orientationchange", o))
            })), e("destroy", (() => {
                a && r.cancelAnimationFrame(a), n && n.unobserve && t.el && (n.unobserve(t.el), n = null), r.removeEventListener("resize", s), r.removeEventListener("orientationchange", o)
            }))
        }, function ({
            swiper: t,
            extendParams: e,
            on: i,
            emit: r
        }) {
            const n = [],
                a = ba(),
                s = (t, e = {}) => {
                    const i = new (a.MutationObserver || a.WebkitMutationObserver)((t => {
                        if (1 === t.length) return void r("observerUpdate", t[0]);
                        const e = function () {
                            r("observerUpdate", t[0])
                        };
                        a.requestAnimationFrame ? a.requestAnimationFrame(e) : a.setTimeout(e, 0)
                    }));
                    i.observe(t, {
                        attributes: void 0 === e.attributes || e.attributes,
                        childList: void 0 === e.childList || e.childList,
                        characterData: void 0 === e.characterData || e.characterData
                    }), n.push(i)
                };
            e({
                observer: !1,
                observeParents: !1,
                observeSlideChildren: !1
            }), i("init", (() => {
                if (t.params.observer) {
                    if (t.params.observeParents) {
                        const e = t.$el.parents();
                        for (let t = 0; t < e.length; t += 1) s(e[t])
                    }
                    s(t.$el[0], {
                        childList: t.params.observeSlideChildren
                    }), s(t.$wrapperEl[0], {
                        attributes: !1
                    })
                }
            })), i("destroy", (() => {
                n.forEach((t => {
                    t.disconnect()
                })), n.splice(0, n.length)
            }))
        }]);
        const ds = hs;

        function ps({
            swiper: t,
            extendParams: e,
            on: i,
            emit: r
        }) {
            const n = ba();
            let a;
            e({
                mousewheel: {
                    enabled: !1,
                    releaseOnEdges: !1,
                    invert: !1,
                    forceToAxis: !1,
                    sensitivity: 1,
                    eventsTarget: "container",
                    thresholdDelta: null,
                    thresholdTime: null
                }
            }), t.mousewheel = {
                enabled: !1
            };
            let s, o = Ca();
            const l = [];

            function c() {
                t.enabled && (t.mouseEntered = !0)
            }

            function u() {
                t.enabled && (t.mouseEntered = !1)
            }

            function h(e) {
                return !(t.params.mousewheel.thresholdDelta && e.delta < t.params.mousewheel.thresholdDelta) && (!(t.params.mousewheel.thresholdTime && Ca() - o < t.params.mousewheel.thresholdTime) && (e.delta >= 6 && Ca() - o < 60 || (e.direction < 0 ? t.isEnd && !t.params.loop || t.animating || (t.slideNext(), r("scroll", e.raw)) : t.isBeginning && !t.params.loop || t.animating || (t.slidePrev(), r("scroll", e.raw)), o = (new n.Date).getTime(), !1)))
            }

            function d(e) {
                let i = e,
                    n = !0;
                if (!t.enabled) return;
                const o = t.params.mousewheel;
                t.params.cssMode && i.preventDefault();
                let c = t.$el;
                if ("container" !== t.params.mousewheel.eventsTarget && (c = Ea(t.params.mousewheel.eventsTarget)), !t.mouseEntered && !c[0].contains(i.target) && !o.releaseOnEdges) return !0;
                i.originalEvent && (i = i.originalEvent);
                let u = 0;
                const d = t.rtlTranslate ? -1 : 1,
                    p = function (t) {
                        let e = 0,
                            i = 0,
                            r = 0,
                            n = 0;
                        return "detail" in t && (i = t.detail), "wheelDelta" in t && (i = -t.wheelDelta / 120), "wheelDeltaY" in t && (i = -t.wheelDeltaY / 120), "wheelDeltaX" in t && (e = -t.wheelDeltaX / 120), "axis" in t && t.axis === t.HORIZONTAL_AXIS && (e = i, i = 0), r = 10 * e, n = 10 * i, "deltaY" in t && (n = t.deltaY), "deltaX" in t && (r = t.deltaX), t.shiftKey && !r && (r = n, n = 0), (r || n) && t.deltaMode && (1 === t.deltaMode ? (r *= 40, n *= 40) : (r *= 800, n *= 800)), r && !e && (e = r < 1 ? -1 : 1), n && !i && (i = n < 1 ? -1 : 1), {
                            spinX: e,
                            spinY: i,
                            pixelX: r,
                            pixelY: n
                        }
                    }(i);
                if (o.forceToAxis)
                    if (t.isHorizontal()) {
                        if (!(Math.abs(p.pixelX) > Math.abs(p.pixelY))) return !0;
                        u = -p.pixelX * d
                    } else {
                        if (!(Math.abs(p.pixelY) > Math.abs(p.pixelX))) return !0;
                        u = -p.pixelY
                    }
                else u = Math.abs(p.pixelX) > Math.abs(p.pixelY) ? -p.pixelX * d : -p.pixelY;
                if (0 === u) return !0;
                o.invert && (u = -u);
                let f = t.getTranslate() + u * o.sensitivity;
                if (f >= t.minTranslate() && (f = t.minTranslate()), f <= t.maxTranslate() && (f = t.maxTranslate()), n = !!t.params.loop || !(f === t.minTranslate() || f === t.maxTranslate()), n && t.params.nested && i.stopPropagation(), t.params.freeMode && t.params.freeMode.enabled) {
                    const e = {
                        time: Ca(),
                        delta: Math.abs(u),
                        direction: Math.sign(u)
                    },
                        n = s && e.time < s.time + 500 && e.delta <= s.delta && e.direction === s.direction;
                    if (!n) {
                        s = void 0, t.params.loop && t.loopFix();
                        let c = t.getTranslate() + u * o.sensitivity;
                        const h = t.isBeginning,
                            d = t.isEnd;
                        if (c >= t.minTranslate() && (c = t.minTranslate()), c <= t.maxTranslate() && (c = t.maxTranslate()), t.setTransition(0), t.setTranslate(c), t.updateProgress(), t.updateActiveIndex(), t.updateSlidesClasses(), (!h && t.isBeginning || !d && t.isEnd) && t.updateSlidesClasses(), t.params.freeMode.sticky) {
                            clearTimeout(a), a = void 0, l.length >= 15 && l.shift();
                            const i = l.length ? l[l.length - 1] : void 0,
                                r = l[0];
                            if (l.push(e), i && (e.delta > i.delta || e.direction !== i.direction)) l.splice(0);
                            else if (l.length >= 15 && e.time - r.time < 500 && r.delta - e.delta >= 1 && e.delta <= 6) {
                                const i = u > 0 ? .8 : .2;
                                s = e, l.splice(0), a = Ma((() => {
                                    t.slideToClosest(t.params.speed, !0, void 0, i)
                                }), 0)
                            }
                            a || (a = Ma((() => {
                                s = e, l.splice(0), t.slideToClosest(t.params.speed, !0, void 0, .5)
                            }), 500))
                        }
                        if (n || r("scroll", i), t.params.autoplay && t.params.autoplayDisableOnInteraction && t.autoplay.stop(), c === t.minTranslate() || c === t.maxTranslate()) return !0
                    }
                } else {
                    const i = {
                        time: Ca(),
                        delta: Math.abs(u),
                        direction: Math.sign(u),
                        raw: e
                    };
                    l.length >= 2 && l.shift();
                    const r = l.length ? l[l.length - 1] : void 0;
                    if (l.push(i), r ? (i.direction !== r.direction || i.delta > r.delta || i.time > r.time + 150) && h(i) : h(i), function (e) {
                        const i = t.params.mousewheel;
                        if (e.direction < 0) {
                            if (t.isEnd && !t.params.loop && i.releaseOnEdges) return !0
                        } else if (t.isBeginning && !t.params.loop && i.releaseOnEdges) return !0;
                        return !1
                    }(i)) return !0
                }
                return i.preventDefault ? i.preventDefault() : i.returnValue = !1, !1
            }

            function p(e) {
                let i = t.$el;
                "container" !== t.params.mousewheel.eventsTarget && (i = Ea(t.params.mousewheel.eventsTarget)), i[e]("mouseenter", c), i[e]("mouseleave", u), i[e]("wheel", d)
            }

            function f() {
                return t.params.cssMode ? (t.wrapperEl.removeEventListener("wheel", d), !0) : !t.mousewheel.enabled && (p("on"), t.mousewheel.enabled = !0, !0)
            }

            function m() {
                return t.params.cssMode ? (t.wrapperEl.addEventListener(event, d), !0) : !!t.mousewheel.enabled && (p("off"), t.mousewheel.enabled = !1, !0)
            }
            i("init", (() => {
                !t.params.mousewheel.enabled && t.params.cssMode && m(), t.params.mousewheel.enabled && f()
            })), i("destroy", (() => {
                t.params.cssMode && f(), t.mousewheel.enabled && m()
            })), Object.assign(t.mousewheel, {
                enable: f,
                disable: m
            })
        }

        function fs(t, e, i, r) {
            const n = va();
            return t.params.createElements && Object.keys(r).forEach((a => {
                if (!i[a] && !0 === i.auto) {
                    let s = t.$el.children(`.${r[a]}`)[0];
                    s || (s = n.createElement("div"), s.className = r[a], t.$el.append(s)), i[a] = s, e[a] = s
                }
            })), i
        }

        function ms({
            swiper: t,
            extendParams: e,
            on: i,
            emit: r
        }) {
            function n(e) {
                let i;
                return e && (i = Ea(e), t.params.uniqueNavElements && "string" == typeof e && i.length > 1 && 1 === t.$el.find(e).length && (i = t.$el.find(e))), i
            }

            function a(e, i) {
                const r = t.params.navigation;
                e && e.length > 0 && (e[i ? "addClass" : "removeClass"](r.disabledClass), e[0] && "BUTTON" === e[0].tagName && (e[0].disabled = i), t.params.watchOverflow && t.enabled && e[t.isLocked ? "addClass" : "removeClass"](r.lockClass))
            }

            function s() {
                if (t.params.loop) return;
                const {
                    $nextEl: e,
                    $prevEl: i
                } = t.navigation;
                a(i, t.isBeginning && !t.params.rewind), a(e, t.isEnd && !t.params.rewind)
            }

            function o(e) {
                e.preventDefault(), (!t.isBeginning || t.params.loop || t.params.rewind) && (t.slidePrev(), r("navigationPrev"))
            }

            function l(e) {
                e.preventDefault(), (!t.isEnd || t.params.loop || t.params.rewind) && (t.slideNext(), r("navigationNext"))
            }

            function c() {
                const e = t.params.navigation;
                if (t.params.navigation = fs(t, t.originalParams.navigation, t.params.navigation, {
                    nextEl: "swiper-button-next",
                    prevEl: "swiper-button-prev"
                }), !e.nextEl && !e.prevEl) return;
                const i = n(e.nextEl),
                    r = n(e.prevEl);
                i && i.length > 0 && i.on("click", l), r && r.length > 0 && r.on("click", o), Object.assign(t.navigation, {
                    $nextEl: i,
                    nextEl: i && i[0],
                    $prevEl: r,
                    prevEl: r && r[0]
                }), t.enabled || (i && i.addClass(e.lockClass), r && r.addClass(e.lockClass))
            }

            function u() {
                const {
                    $nextEl: e,
                    $prevEl: i
                } = t.navigation;
                e && e.length && (e.off("click", l), e.removeClass(t.params.navigation.disabledClass)), i && i.length && (i.off("click", o), i.removeClass(t.params.navigation.disabledClass))
            }
            e({
                navigation: {
                    nextEl: null,
                    prevEl: null,
                    hideOnClick: !1,
                    disabledClass: "swiper-button-disabled",
                    hiddenClass: "swiper-button-hidden",
                    lockClass: "swiper-button-lock",
                    navigationDisabledClass: "swiper-navigation-disabled"
                }
            }), t.navigation = {
                nextEl: null,
                $nextEl: null,
                prevEl: null,
                $prevEl: null
            }, i("init", (() => {
                !1 === t.params.navigation.enabled ? h() : (c(), s())
            })), i("toEdge fromEdge lock unlock", (() => {
                s()
            })), i("destroy", (() => {
                u()
            })), i("enable disable", (() => {
                const {
                    $nextEl: e,
                    $prevEl: i
                } = t.navigation;
                e && e[t.enabled ? "removeClass" : "addClass"](t.params.navigation.lockClass), i && i[t.enabled ? "removeClass" : "addClass"](t.params.navigation.lockClass)
            })), i("click", ((e, i) => {
                const {
                    $nextEl: n,
                    $prevEl: a
                } = t.navigation, s = i.target;
                if (t.params.navigation.hideOnClick && !Ea(s).is(a) && !Ea(s).is(n)) {
                    if (t.pagination && t.params.pagination && t.params.pagination.clickable && (t.pagination.el === s || t.pagination.el.contains(s))) return;
                    let e;
                    n ? e = n.hasClass(t.params.navigation.hiddenClass) : a && (e = a.hasClass(t.params.navigation.hiddenClass)), r(!0 === e ? "navigationShow" : "navigationHide"), n && n.toggleClass(t.params.navigation.hiddenClass), a && a.toggleClass(t.params.navigation.hiddenClass)
                }
            }));
            const h = () => {
                t.$el.addClass(t.params.navigation.navigationDisabledClass), u()
            };
            Object.assign(t.navigation, {
                enable: () => {
                    t.$el.removeClass(t.params.navigation.navigationDisabledClass), c(), s()
                },
                disable: h,
                update: s,
                init: c,
                destroy: u
            })
        }

        function gs(t = "") {
            return `.${t.trim().replace(/([\.:!\/])/g, "\\$1").replace(/ /g, ".")}`
        }

        function vs({
            swiper: t,
            extendParams: e,
            on: i,
            emit: r
        }) {
            const n = "swiper-pagination";
            let a;
            e({
                pagination: {
                    el: null,
                    bulletElement: "span",
                    clickable: !1,
                    hideOnClick: !1,
                    renderBullet: null,
                    renderProgressbar: null,
                    renderFraction: null,
                    renderCustom: null,
                    progressbarOpposite: !1,
                    type: "bullets",
                    dynamicBullets: !1,
                    dynamicMainBullets: 1,
                    formatFractionCurrent: t => t,
                    formatFractionTotal: t => t,
                    bulletClass: `${n}-bullet`,
                    bulletActiveClass: `${n}-bullet-active`,
                    modifierClass: `${n}-`,
                    currentClass: `${n}-current`,
                    totalClass: `${n}-total`,
                    hiddenClass: `${n}-hidden`,
                    progressbarFillClass: `${n}-progressbar-fill`,
                    progressbarOppositeClass: `${n}-progressbar-opposite`,
                    clickableClass: `${n}-clickable`,
                    lockClass: `${n}-lock`,
                    horizontalClass: `${n}-horizontal`,
                    verticalClass: `${n}-vertical`,
                    paginationDisabledClass: `${n}-disabled`
                }
            }), t.pagination = {
                el: null,
                $el: null,
                bullets: []
            };
            let s = 0;

            function o() {
                return !t.params.pagination.el || !t.pagination.el || !t.pagination.$el || 0 === t.pagination.$el.length
            }

            function l(e, i) {
                const {
                    bulletActiveClass: r
                } = t.params.pagination;
                e[i]().addClass(`${r}-${i}`)[i]().addClass(`${r}-${i}-${i}`)
            }

            function c() {
                const e = t.rtl,
                    i = t.params.pagination;
                if (o()) return;
                const n = t.virtual && t.params.virtual.enabled ? t.virtual.slides.length : t.slides.length,
                    c = t.pagination.$el;
                let u;
                const h = t.params.loop ? Math.ceil((n - 2 * t.loopedSlides) / t.params.slidesPerGroup) : t.snapGrid.length;
                if (t.params.loop ? (u = Math.ceil((t.activeIndex - t.loopedSlides) / t.params.slidesPerGroup), u > n - 1 - 2 * t.loopedSlides && (u -= n - 2 * t.loopedSlides), u > h - 1 && (u -= h), u < 0 && "bullets" !== t.params.paginationType && (u = h + u)) : u = void 0 !== t.snapIndex ? t.snapIndex : t.activeIndex || 0, "bullets" === i.type && t.pagination.bullets && t.pagination.bullets.length > 0) {
                    const r = t.pagination.bullets;
                    let n, o, h;
                    if (i.dynamicBullets && (a = r.eq(0)[t.isHorizontal() ? "outerWidth" : "outerHeight"](!0), c.css(t.isHorizontal() ? "width" : "height", a * (i.dynamicMainBullets + 4) + "px"), i.dynamicMainBullets > 1 && void 0 !== t.previousIndex && (s += u - (t.previousIndex - t.loopedSlides || 0), s > i.dynamicMainBullets - 1 ? s = i.dynamicMainBullets - 1 : s < 0 && (s = 0)), n = Math.max(u - s, 0), o = n + (Math.min(r.length, i.dynamicMainBullets) - 1), h = (o + n) / 2), r.removeClass(["", "-next", "-next-next", "-prev", "-prev-prev", "-main"].map((t => `${i.bulletActiveClass}${t}`)).join(" ")), c.length > 1) r.each((t => {
                        const e = Ea(t),
                            r = e.index();
                        r === u && e.addClass(i.bulletActiveClass), i.dynamicBullets && (r >= n && r <= o && e.addClass(`${i.bulletActiveClass}-main`), r === n && l(e, "prev"), r === o && l(e, "next"))
                    }));
                    else {
                        const e = r.eq(u),
                            a = e.index();
                        if (e.addClass(i.bulletActiveClass), i.dynamicBullets) {
                            const e = r.eq(n),
                                s = r.eq(o);
                            for (let t = n; t <= o; t += 1) r.eq(t).addClass(`${i.bulletActiveClass}-main`);
                            if (t.params.loop)
                                if (a >= r.length) {
                                    for (let t = i.dynamicMainBullets; t >= 0; t -= 1) r.eq(r.length - t).addClass(`${i.bulletActiveClass}-main`);
                                    r.eq(r.length - i.dynamicMainBullets - 1).addClass(`${i.bulletActiveClass}-prev`)
                                } else l(e, "prev"), l(s, "next");
                            else l(e, "prev"), l(s, "next")
                        }
                    }
                    if (i.dynamicBullets) {
                        const n = Math.min(r.length, i.dynamicMainBullets + 4),
                            s = (a * n - a) / 2 - h * a,
                            o = e ? "right" : "left";
                        r.css(t.isHorizontal() ? o : "top", `${s}px`)
                    }
                }
                if ("fraction" === i.type && (c.find(gs(i.currentClass)).text(i.formatFractionCurrent(u + 1)), c.find(gs(i.totalClass)).text(i.formatFractionTotal(h))), "progressbar" === i.type) {
                    let e;
                    e = i.progressbarOpposite ? t.isHorizontal() ? "vertical" : "horizontal" : t.isHorizontal() ? "horizontal" : "vertical";
                    const r = (u + 1) / h;
                    let n = 1,
                        a = 1;
                    "horizontal" === e ? n = r : a = r, c.find(gs(i.progressbarFillClass)).transform(`translate3d(0,0,0) scaleX(${n}) scaleY(${a})`).transition(t.params.speed)
                }
                "custom" === i.type && i.renderCustom ? (c.html(i.renderCustom(t, u + 1, h)), r("paginationRender", c[0])) : r("paginationUpdate", c[0]), t.params.watchOverflow && t.enabled && c[t.isLocked ? "addClass" : "removeClass"](i.lockClass)
            }

            function u() {
                const e = t.params.pagination;
                if (o()) return;
                const i = t.virtual && t.params.virtual.enabled ? t.virtual.slides.length : t.slides.length,
                    n = t.pagination.$el;
                let a = "";
                if ("bullets" === e.type) {
                    let r = t.params.loop ? Math.ceil((i - 2 * t.loopedSlides) / t.params.slidesPerGroup) : t.snapGrid.length;
                    t.params.freeMode && t.params.freeMode.enabled && !t.params.loop && r > i && (r = i);
                    for (let i = 0; i < r; i += 1) e.renderBullet ? a += e.renderBullet.call(t, i, e.bulletClass) : a += `<${e.bulletElement} class="${e.bulletClass}"></${e.bulletElement}>`;
                    n.html(a), t.pagination.bullets = n.find(gs(e.bulletClass))
                }
                "fraction" === e.type && (a = e.renderFraction ? e.renderFraction.call(t, e.currentClass, e.totalClass) : `<span class="${e.currentClass}"></span> / <span class="${e.totalClass}"></span>`, n.html(a)), "progressbar" === e.type && (a = e.renderProgressbar ? e.renderProgressbar.call(t, e.progressbarFillClass) : `<span class="${e.progressbarFillClass}"></span>`, n.html(a)), "custom" !== e.type && r("paginationRender", t.pagination.$el[0])
            }

            function h() {
                t.params.pagination = fs(t, t.originalParams.pagination, t.params.pagination, {
                    el: "swiper-pagination"
                });
                const e = t.params.pagination;
                if (!e.el) return;
                let i = Ea(e.el);
                0 !== i.length && (t.params.uniqueNavElements && "string" == typeof e.el && i.length > 1 && (i = t.$el.find(e.el), i.length > 1 && (i = i.filter((e => Ea(e).parents(".swiper")[0] === t.el)))), "bullets" === e.type && e.clickable && i.addClass(e.clickableClass), i.addClass(e.modifierClass + e.type), i.addClass(t.isHorizontal() ? e.horizontalClass : e.verticalClass), "bullets" === e.type && e.dynamicBullets && (i.addClass(`${e.modifierClass}${e.type}-dynamic`), s = 0, e.dynamicMainBullets < 1 && (e.dynamicMainBullets = 1)), "progressbar" === e.type && e.progressbarOpposite && i.addClass(e.progressbarOppositeClass), e.clickable && i.on("click", gs(e.bulletClass), (function (e) {
                    e.preventDefault();
                    let i = Ea(this).index() * t.params.slidesPerGroup;
                    t.params.loop && (i += t.loopedSlides), t.slideTo(i)
                })), Object.assign(t.pagination, {
                    $el: i,
                    el: i[0]
                }), t.enabled || i.addClass(e.lockClass))
            }

            function d() {
                const e = t.params.pagination;
                if (o()) return;
                const i = t.pagination.$el;
                i.removeClass(e.hiddenClass), i.removeClass(e.modifierClass + e.type), i.removeClass(t.isHorizontal() ? e.horizontalClass : e.verticalClass), t.pagination.bullets && t.pagination.bullets.removeClass && t.pagination.bullets.removeClass(e.bulletActiveClass), e.clickable && i.off("click", gs(e.bulletClass))
            }
            i("init", (() => {
                !1 === t.params.pagination.enabled ? p() : (h(), u(), c())
            })), i("activeIndexChange", (() => {
                (t.params.loop || void 0 === t.snapIndex) && c()
            })), i("snapIndexChange", (() => {
                t.params.loop || c()
            })), i("slidesLengthChange", (() => {
                t.params.loop && (u(), c())
            })), i("snapGridLengthChange", (() => {
                t.params.loop || (u(), c())
            })), i("destroy", (() => {
                d()
            })), i("enable disable", (() => {
                const {
                    $el: e
                } = t.pagination;
                e && e[t.enabled ? "removeClass" : "addClass"](t.params.pagination.lockClass)
            })), i("lock unlock", (() => {
                c()
            })), i("click", ((e, i) => {
                const n = i.target,
                    {
                        $el: a
                    } = t.pagination;
                if (t.params.pagination.el && t.params.pagination.hideOnClick && a && a.length > 0 && !Ea(n).hasClass(t.params.pagination.bulletClass)) {
                    if (t.navigation && (t.navigation.nextEl && n === t.navigation.nextEl || t.navigation.prevEl && n === t.navigation.prevEl)) return;
                    const e = a.hasClass(t.params.pagination.hiddenClass);
                    r(!0 === e ? "paginationShow" : "paginationHide"), a.toggleClass(t.params.pagination.hiddenClass)
                }
            }));
            const p = () => {
                t.$el.addClass(t.params.pagination.paginationDisabledClass), t.pagination.$el && t.pagination.$el.addClass(t.params.pagination.paginationDisabledClass), d()
            };
            Object.assign(t.pagination, {
                enable: () => {
                    t.$el.removeClass(t.params.pagination.paginationDisabledClass), t.pagination.$el && t.pagination.$el.removeClass(t.params.pagination.paginationDisabledClass), h(), u(), c()
                },
                disable: p,
                render: u,
                update: c,
                init: h,
                destroy: d
            })
        }

        function ys({
            swiper: t,
            extendParams: e,
            on: i,
            emit: r
        }) {
            let n;

            function a() {
                if (!t.size) return t.autoplay.running = !1, void (t.autoplay.paused = !1);
                const e = t.slides.eq(t.activeIndex);
                let i = t.params.autoplay.delay;
                e.attr("data-swiper-autoplay") && (i = e.attr("data-swiper-autoplay") || t.params.autoplay.delay), clearTimeout(n), n = Ma((() => {
                    let e;
                    t.params.autoplay.reverseDirection ? t.params.loop ? (t.loopFix(), e = t.slidePrev(t.params.speed, !0, !0), r("autoplay")) : t.isBeginning ? t.params.autoplay.stopOnLastSlide ? o() : (e = t.slideTo(t.slides.length - 1, t.params.speed, !0, !0), r("autoplay")) : (e = t.slidePrev(t.params.speed, !0, !0), r("autoplay")) : t.params.loop ? (t.loopFix(), e = t.slideNext(t.params.speed, !0, !0), r("autoplay")) : t.isEnd ? t.params.autoplay.stopOnLastSlide ? o() : (e = t.slideTo(0, t.params.speed, !0, !0), r("autoplay")) : (e = t.slideNext(t.params.speed, !0, !0), r("autoplay")), (t.params.cssMode && t.autoplay.running || !1 === e) && a()
                }), i)
            }

            function s() {
                return void 0 === n && (!t.autoplay.running && (t.autoplay.running = !0, r("autoplayStart"), a(), !0))
            }

            function o() {
                return !!t.autoplay.running && (void 0 !== n && (n && (clearTimeout(n), n = void 0), t.autoplay.running = !1, r("autoplayStop"), !0))
            }

            function l(e) {
                t.autoplay.running && (t.autoplay.paused || (n && clearTimeout(n), t.autoplay.paused = !0, 0 !== e && t.params.autoplay.waitForTransition ? ["transitionend", "webkitTransitionEnd"].forEach((e => {
                    t.$wrapperEl[0].addEventListener(e, u)
                })) : (t.autoplay.paused = !1, a())))
            }

            function c() {
                const e = va();
                "hidden" === e.visibilityState && t.autoplay.running && l(), "visible" === e.visibilityState && t.autoplay.paused && (a(), t.autoplay.paused = !1)
            }

            function u(e) {
                t && !t.destroyed && t.$wrapperEl && e.target === t.$wrapperEl[0] && (["transitionend", "webkitTransitionEnd"].forEach((e => {
                    t.$wrapperEl[0].removeEventListener(e, u)
                })), t.autoplay.paused = !1, t.autoplay.running ? a() : o())
            }

            function h() {
                t.params.autoplay.disableOnInteraction ? o() : (r("autoplayPause"), l()), ["transitionend", "webkitTransitionEnd"].forEach((e => {
                    t.$wrapperEl[0].removeEventListener(e, u)
                }))
            }

            function d() {
                t.params.autoplay.disableOnInteraction || (t.autoplay.paused = !1, r("autoplayResume"), a())
            }
            t.autoplay = {
                running: !1,
                paused: !1
            }, e({
                autoplay: {
                    enabled: !1,
                    delay: 3e3,
                    waitForTransition: !0,
                    disableOnInteraction: !0,
                    stopOnLastSlide: !1,
                    reverseDirection: !1,
                    pauseOnMouseEnter: !1
                }
            }), i("init", (() => {
                if (t.params.autoplay.enabled) {
                    s();
                    va().addEventListener("visibilitychange", c), t.params.autoplay.pauseOnMouseEnter && (t.$el.on("mouseenter", h), t.$el.on("mouseleave", d))
                }
            })), i("beforeTransitionStart", ((e, i, r) => {
                t.autoplay.running && (r || !t.params.autoplay.disableOnInteraction ? t.autoplay.pause(i) : o())
            })), i("sliderFirstMove", (() => {
                t.autoplay.running && (t.params.autoplay.disableOnInteraction ? o() : l())
            })), i("touchEnd", (() => {
                t.params.cssMode && t.autoplay.paused && !t.params.autoplay.disableOnInteraction && a()
            })), i("destroy", (() => {
                t.$el.off("mouseenter", h), t.$el.off("mouseleave", d), t.autoplay.running && o();
                va().removeEventListener("visibilitychange", c)
            })), Object.assign(t.autoplay, {
                pause: l,
                run: a,
                start: s,
                stop: o
            })
        }

        function bs({
            swiper: t,
            extendParams: e,
            on: i
        }) {
            e({
                thumbs: {
                    swiper: null,
                    multipleActiveThumbs: !0,
                    autoScrollOffset: 0,
                    slideThumbActiveClass: "swiper-slide-thumb-active",
                    thumbsContainerClass: "swiper-thumbs"
                }
            });
            let r = !1,
                n = !1;

            function a() {
                const e = t.thumbs.swiper;
                if (!e || e.destroyed) return;
                const i = e.clickedIndex,
                    r = e.clickedSlide;
                if (r && Ea(r).hasClass(t.params.thumbs.slideThumbActiveClass)) return;
                if (null == i) return;
                let n;
                if (n = e.params.loop ? parseInt(Ea(e.clickedSlide).attr("data-swiper-slide-index"), 10) : i, t.params.loop) {
                    let e = t.activeIndex;
                    t.slides.eq(e).hasClass(t.params.slideDuplicateClass) && (t.loopFix(), t._clientLeft = t.$wrapperEl[0].clientLeft, e = t.activeIndex);
                    const i = t.slides.eq(e).prevAll(`[data-swiper-slide-index="${n}"]`).eq(0).index(),
                        r = t.slides.eq(e).nextAll(`[data-swiper-slide-index="${n}"]`).eq(0).index();
                    n = void 0 === i ? r : void 0 === r ? i : r - e < e - i ? r : i
                }
                t.slideTo(n)
            }

            function s() {
                const {
                    thumbs: e
                } = t.params;
                if (r) return !1;
                r = !0;
                const i = t.constructor;
                if (e.swiper instanceof i) t.thumbs.swiper = e.swiper, Object.assign(t.thumbs.swiper.originalParams, {
                    watchSlidesProgress: !0,
                    slideToClickedSlide: !1
                }), Object.assign(t.thumbs.swiper.params, {
                    watchSlidesProgress: !0,
                    slideToClickedSlide: !1
                });
                else if (Da(e.swiper)) {
                    const r = Object.assign({}, e.swiper);
                    Object.assign(r, {
                        watchSlidesProgress: !0,
                        slideToClickedSlide: !1
                    }), t.thumbs.swiper = new i(r), n = !0
                }
                return t.thumbs.swiper.$el.addClass(t.params.thumbs.thumbsContainerClass), t.thumbs.swiper.on("tap", a), !0
            }

            function o(e) {
                const i = t.thumbs.swiper;
                if (!i || i.destroyed) return;
                const r = "auto" === i.params.slidesPerView ? i.slidesPerViewDynamic() : i.params.slidesPerView;
                let n = 1;
                const a = t.params.thumbs.slideThumbActiveClass;
                if (t.params.slidesPerView > 1 && !t.params.centeredSlides && (n = t.params.slidesPerView), t.params.thumbs.multipleActiveThumbs || (n = 1), n = Math.floor(n), i.slides.removeClass(a), i.params.loop || i.params.virtual && i.params.virtual.enabled)
                    for (let e = 0; e < n; e += 1) i.$wrapperEl.children(`[data-swiper-slide-index="${t.realIndex + e}"]`).addClass(a);
                else
                    for (let e = 0; e < n; e += 1) i.slides.eq(t.realIndex + e).addClass(a);
                const s = t.params.thumbs.autoScrollOffset,
                    o = s && !i.params.loop;
                if (t.realIndex !== i.realIndex || o) {
                    let n, a, l = i.activeIndex;
                    if (i.params.loop) {
                        i.slides.eq(l).hasClass(i.params.slideDuplicateClass) && (i.loopFix(), i._clientLeft = i.$wrapperEl[0].clientLeft, l = i.activeIndex);
                        const e = i.slides.eq(l).prevAll(`[data-swiper-slide-index="${t.realIndex}"]`).eq(0).index(),
                            r = i.slides.eq(l).nextAll(`[data-swiper-slide-index="${t.realIndex}"]`).eq(0).index();
                        n = void 0 === e ? r : void 0 === r ? e : r - l == l - e ? i.params.slidesPerGroup > 1 ? r : l : r - l < l - e ? r : e, a = t.activeIndex > t.previousIndex ? "next" : "prev"
                    } else n = t.realIndex, a = n > t.previousIndex ? "next" : "prev";
                    o && (n += "next" === a ? s : -1 * s), i.visibleSlidesIndexes && i.visibleSlidesIndexes.indexOf(n) < 0 && (i.params.centeredSlides ? n = n > l ? n - Math.floor(r / 2) + 1 : n + Math.floor(r / 2) - 1 : n > l && i.params.slidesPerGroup, i.slideTo(n, e ? 0 : void 0))
                }
            }
            t.thumbs = {
                swiper: null
            }, i("beforeInit", (() => {
                const {
                    thumbs: e
                } = t.params;
                e && e.swiper && (s(), o(!0))
            })), i("slideChange update resize observerUpdate", (() => {
                o()
            })), i("setTransition", ((e, i) => {
                const r = t.thumbs.swiper;
                r && !r.destroyed && r.setTransition(i)
            })), i("beforeDestroy", (() => {
                const e = t.thumbs.swiper;
                e && !e.destroyed && n && e.destroy()
            })), Object.assign(t.thumbs, {
                init: s,
                update: o
            })
        }

        function _s({
            swiper: t,
            extendParams: e,
            emit: i,
            once: r
        }) {
            e({
                freeMode: {
                    enabled: !1,
                    momentum: !0,
                    momentumRatio: 1,
                    momentumBounce: !0,
                    momentumBounceRatio: 1,
                    momentumVelocityRatio: 1,
                    sticky: !1,
                    minimumVelocity: .02
                }
            }), Object.assign(t, {
                freeMode: {
                    onTouchStart: function () {
                        const e = t.getTranslate();
                        t.setTranslate(e), t.setTransition(0), t.touchEventsData.velocities.length = 0, t.freeMode.onTouchEnd({
                            currentPos: t.rtl ? t.translate : -t.translate
                        })
                    },
                    onTouchMove: function () {
                        const {
                            touchEventsData: e,
                            touches: i
                        } = t;
                        0 === e.velocities.length && e.velocities.push({
                            position: i[t.isHorizontal() ? "startX" : "startY"],
                            time: e.touchStartTime
                        }), e.velocities.push({
                            position: i[t.isHorizontal() ? "currentX" : "currentY"],
                            time: Ca()
                        })
                    },
                    onTouchEnd: function ({
                        currentPos: e
                    }) {
                        const {
                            params: n,
                            $wrapperEl: a,
                            rtlTranslate: s,
                            snapGrid: o,
                            touchEventsData: l
                        } = t, c = Ca() - l.touchStartTime;
                        if (e < -t.minTranslate()) t.slideTo(t.activeIndex);
                        else if (e > -t.maxTranslate()) t.slides.length < o.length ? t.slideTo(o.length - 1) : t.slideTo(t.slides.length - 1);
                        else {
                            if (n.freeMode.momentum) {
                                if (l.velocities.length > 1) {
                                    const e = l.velocities.pop(),
                                        i = l.velocities.pop(),
                                        r = e.position - i.position,
                                        a = e.time - i.time;
                                    t.velocity = r / a, t.velocity /= 2, Math.abs(t.velocity) < n.freeMode.minimumVelocity && (t.velocity = 0), (a > 150 || Ca() - e.time > 300) && (t.velocity = 0)
                                } else t.velocity = 0;
                                t.velocity *= n.freeMode.momentumVelocityRatio, l.velocities.length = 0;
                                let e = 1e3 * n.freeMode.momentumRatio;
                                const c = t.velocity * e;
                                let u = t.translate + c;
                                s && (u = -u);
                                let h, d = !1;
                                const p = 20 * Math.abs(t.velocity) * n.freeMode.momentumBounceRatio;
                                let f;
                                if (u < t.maxTranslate()) n.freeMode.momentumBounce ? (u + t.maxTranslate() < -p && (u = t.maxTranslate() - p), h = t.maxTranslate(), d = !0, l.allowMomentumBounce = !0) : u = t.maxTranslate(), n.loop && n.centeredSlides && (f = !0);
                                else if (u > t.minTranslate()) n.freeMode.momentumBounce ? (u - t.minTranslate() > p && (u = t.minTranslate() + p), h = t.minTranslate(), d = !0, l.allowMomentumBounce = !0) : u = t.minTranslate(), n.loop && n.centeredSlides && (f = !0);
                                else if (n.freeMode.sticky) {
                                    let e;
                                    for (let t = 0; t < o.length; t += 1)
                                        if (o[t] > -u) {
                                            e = t;
                                            break
                                        } u = Math.abs(o[e] - u) < Math.abs(o[e - 1] - u) || "next" === t.swipeDirection ? o[e] : o[e - 1], u = -u
                                }
                                if (f && r("transitionEnd", (() => {
                                    t.loopFix()
                                })), 0 !== t.velocity) {
                                    if (e = s ? Math.abs((-u - t.translate) / t.velocity) : Math.abs((u - t.translate) / t.velocity), n.freeMode.sticky) {
                                        const i = Math.abs((s ? -u : u) - t.translate),
                                            r = t.slidesSizesGrid[t.activeIndex];
                                        e = i < r ? n.speed : i < 2 * r ? 1.5 * n.speed : 2.5 * n.speed
                                    }
                                } else if (n.freeMode.sticky) return void t.slideToClosest();
                                n.freeMode.momentumBounce && d ? (t.updateProgress(h), t.setTransition(e), t.setTranslate(u), t.transitionStart(!0, t.swipeDirection), t.animating = !0, a.transitionEnd((() => {
                                    t && !t.destroyed && l.allowMomentumBounce && (i("momentumBounce"), t.setTransition(n.speed), setTimeout((() => {
                                        t.setTranslate(h), a.transitionEnd((() => {
                                            t && !t.destroyed && t.transitionEnd()
                                        }))
                                    }), 0))
                                }))) : t.velocity ? (i("_freeModeNoMomentumRelease"), t.updateProgress(u), t.setTransition(e), t.setTranslate(u), t.transitionStart(!0, t.swipeDirection), t.animating || (t.animating = !0, a.transitionEnd((() => {
                                    t && !t.destroyed && t.transitionEnd()
                                })))) : t.updateProgress(u), t.updateActiveIndex(), t.updateSlidesClasses()
                            } else {
                                if (n.freeMode.sticky) return void t.slideToClosest();
                                n.freeMode && i("_freeModeNoMomentumRelease")
                            } (!n.freeMode.momentum || c >= n.longSwipesMs) && (t.updateProgress(), t.updateActiveIndex(), t.updateSlidesClasses())
                        }
                    }
                }
            })
        }

        function ws(t, e) {
            return t.transformEl ? e.find(t.transformEl).css({
                "backface-visibility": "hidden",
                "-webkit-backface-visibility": "hidden"
            }) : e
        }

        function As({
            swiper: t,
            extendParams: e,
            on: i
        }) {
            e({
                fadeEffect: {
                    crossFade: !1,
                    transformEl: null
                }
            });
            ! function (t) {
                const {
                    effect: e,
                    swiper: i,
                    on: r,
                    setTranslate: n,
                    setTransition: a,
                    overwriteParams: s,
                    perspective: o,
                    recreateShadows: l,
                    getEffectParams: c
                } = t;
                let u;
                r("beforeInit", (() => {
                    if (i.params.effect !== e) return;
                    i.classNames.push(`${i.params.containerModifierClass}${e}`), o && o() && i.classNames.push(`${i.params.containerModifierClass}3d`);
                    const t = s ? s() : {};
                    Object.assign(i.params, t), Object.assign(i.originalParams, t)
                })), r("setTranslate", (() => {
                    i.params.effect === e && n()
                })), r("setTransition", ((t, r) => {
                    i.params.effect === e && a(r)
                })), r("transitionEnd", (() => {
                    if (i.params.effect === e && l) {
                        if (!c || !c().slideShadows) return;
                        i.slides.each((t => {
                            i.$(t).find(".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left").remove()
                        })), l()
                    }
                })), r("virtualUpdate", (() => {
                    i.params.effect === e && (i.slides.length || (u = !0), requestAnimationFrame((() => {
                        u && i.slides && i.slides.length && (n(), u = !1)
                    })))
                }))
            }({
                effect: "fade",
                swiper: t,
                on: i,
                setTranslate: () => {
                    const {
                        slides: e
                    } = t, i = t.params.fadeEffect;
                    for (let r = 0; r < e.length; r += 1) {
                        const e = t.slides.eq(r);
                        let n = -e[0].swiperSlideOffset;
                        t.params.virtualTranslate || (n -= t.translate);
                        let a = 0;
                        t.isHorizontal() || (a = n, n = 0);
                        const s = t.params.fadeEffect.crossFade ? Math.max(1 - Math.abs(e[0].progress), 0) : 1 + Math.min(Math.max(e[0].progress, -1), 0);
                        ws(i, e).css({
                            opacity: s
                        }).transform(`translate3d(${n}px, ${a}px, 0px)`)
                    }
                },
                setTransition: e => {
                    const {
                        transformEl: i
                    } = t.params.fadeEffect;
                    (i ? t.slides.find(i) : t.slides).transition(e),
                        function ({
                            swiper: t,
                            duration: e,
                            transformEl: i,
                            allSlides: r
                        }) {
                            const {
                                slides: n,
                                activeIndex: a,
                                $wrapperEl: s
                            } = t;
                            if (t.params.virtualTranslate && 0 !== e) {
                                let e, o = !1;
                                e = r ? i ? n.find(i) : n : i ? n.eq(a).find(i) : n.eq(a), e.transitionEnd((() => {
                                    if (o) return;
                                    if (!t || t.destroyed) return;
                                    o = !0, t.animating = !1;
                                    const e = ["webkitTransitionEnd", "transitionend"];
                                    for (let t = 0; t < e.length; t += 1) s.trigger(e[t])
                                }))
                            }
                        }({
                            swiper: t,
                            duration: e,
                            transformEl: i,
                            allSlides: !0
                        })
                },
                overwriteParams: () => ({
                    slidesPerView: 1,
                    slidesPerGroup: 1,
                    watchSlidesProgress: !0,
                    spaceBetween: 0,
                    virtualTranslate: !t.params.cssMode
                })
            })
        }
        var Ss = i(732),
            ks = i.n(Ss);

        function xs(t, e) {
            var i = "undefined" != typeof Symbol && t[Symbol.iterator] || t["@@iterator"];
            if (!i) {
                if (Array.isArray(t) || (i = function (t, e) {
                    if (!t) return;
                    if ("string" == typeof t) return Ts(t, e);
                    var i = Object.prototype.toString.call(t).slice(8, -1);
                    "Object" === i && t.constructor && (i = t.constructor.name);
                    if ("Map" === i || "Set" === i) return Array.from(t);
                    if ("Arguments" === i || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(i)) return Ts(t, e)
                }(t)) || e && t && "number" == typeof t.length) {
                    i && (t = i);
                    var r = 0,
                        n = function () { };
                    return {
                        s: n,
                        n: function () {
                            return r >= t.length ? {
                                done: !0
                            } : {
                                done: !1,
                                value: t[r++]
                            }
                        },
                        e: function (t) {
                            throw t
                        },
                        f: n
                    }
                }
                throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")
            }
            var a, s = !0,
                o = !1;
            return {
                s: function () {
                    i = i.call(t)
                },
                n: function () {
                    var t = i.next();
                    return s = t.done, t
                },
                e: function (t) {
                    o = !0, a = t
                },
                f: function () {
                    try {
                        s || null == i.return || i.return()
                    } finally {
                        if (o) throw a
                    }
                }
            }
        }

        function Ts(t, e) {
            (null == e || e > t.length) && (e = t.length);
            for (var i = 0, r = new Array(e); i < e; i++) r[i] = t[i];
            return r
        }

        function Es(t) {
            var e = function () {
                if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                if (Reflect.construct.sham) return !1;
                if ("function" == typeof Proxy) return !0;
                try {
                    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], (function () { }))), !0
                } catch (t) {
                    return !1
                }
            }();
            return function () {
                var i, r = f(t);
                if (e) {
                    var n = f(this).constructor;
                    i = Reflect.construct(r, arguments, n)
                } else i = r.apply(this, arguments);
                return p(this, i)
            }
        }
        var Ms = function (t) {
            h(i, t);
            var e = Es(i);

            function i() {
                var t;
                return n(this, i), (t = e.call(this)).carouselEl = t.querySelector(".slider"), t.slides = t.carouselEl.querySelectorAll(".slide"), t.pagination = t.querySelector(".slider-pagination"), t.paginationFraction = t.querySelector(".slider-pagination-fraction-".concat(t.carouselEl.dataset.section)), t.carouselType = !1, t.videoBehavior = !1, t.navigation = t.querySelector(".slider-button-next"), t.data = t.carouselEl.dataset, t.anim = t.data.animationType ? t.data.animationType.toLowerCase() : "slide", t.modules = [], void 0 !== t.data.thumbsSelector && (t.thumbnailsElSelector = t.data.thumbsSelector, t.thumbs = t.querySelector(t.thumbnailsElSelector), t.thumbsType = t.thumbs.tagName, "carousel" != t.thumbsType.toLowerCase() && (t.pagination && (t.pagination = {
                    el: t.thumbs,
                    type: "bullets"
                }), t.thumbs = !1)), t.init(), t
            }
            return l(i, [{
                key: "init",
                value: function () {
                    var t = this;
                    "fade" != this.anim && null == this.data.autoplay || (ds.use(ys, As), this.modules.push(As)), !1 !== this.thumbs && (ds.use(bs), this.modules.push(bs)), null != this.data.mouse && (ds.use(ps), this.modules.push(ps)), null != this.data.free && (ds.use(_s), this.modules.push(_s)), void 0 !== this.pagination && (ds.use(vs), this.modules.push(vs)), this.classList.contains("main-style") && (this.carouselType = "main-style"), this.classList.contains("play-video-on-entrance") && (this.videoBehavior = "play-video-on-entrance"), this.classList.contains("two-col-product") && (this.carouselType = "two-col-product"), "false" !== this.data.section && (this.section = document.getElementById("shopify-section-".concat(this.data.section))), this.classList.contains("has-psuedo-thumbs") && (this.materialTextEls = this.section.querySelectorAll(".psuedo-thumb"), this.bindFakeThumbNails()), void 0 !== this.navigation && this.modules.push(ms);
                    var e = this.data.gutter ? parseInt(this.data.gutter) : 60,
                        i = this.data.gutter ? parseInt(this.data.gutter) : 30;
                    if (a(this.data.centered), this.options = {
                        autoplay: null != this.data.autoplay && {
                            delay: parseFloat(this.data.timing),
                            disableOnInteraction: !1
                        },
                        a11y: !1,
                        breakpoints: {
                            769: {
                                spaceBetween: null != this.data.mobileOnly ? 1e3 : e,
                                slidesPerView: null != this.data.mobileOnly ? "auto" : this.data.slidesPerView
                            }
                        },
                        centeredSlides: null != this.data.centered,
                        containerModifierClass: "slider-",
                        direction: null != this.data.direction ? this.data.direction : "horizontal",
                        allowTouchMove: null != this.data.drag,
                        effect: this.anim,
                        freeMode: null != this.data.free && {
                            enabled: !0,
                            momentum: !1
                        },
                        height: this.data.height ? parseInt(this.data.height) : null,
                        initialSlide: this.data.initialSlide,
                        loop: null != this.data.loops,
                        loopedSlides: null != this.data.loops ? this.slides.length : null,
                        modules: this.modules,
                        mousewheel: null != this.data.mouse && {
                            forceToAxis: !0
                        },
                        pagination: (null != this.pagination || null != this.paginationFraction) && {
                            bulletActiveClass: "active",
                            bulletClass: "slider-pagination-bullet",
                            clickable: !0,
                            clickableClass: "slider-pagination-clickable",
                            currentClass: "slider-pagination-current",
                            el: this.paginationFraction ? ".slider-pagination-fraction-".concat(this.data.section) : ".slider-pagination",
                            type: this.paginationFraction ? "fraction" : "bullets"
                        },
                        shortSwipes: !0,
                        slideActiveClass: "slide-active",
                        slideClass: "slide",
                        slideDuplicateActiveClass: "slide-active-duplicate",
                        slideDuplicateClass: "slide-duplicate",
                        slideDuplicateNextClass: "slide-next-duplicate",
                        slideDuplicatePrevClass: "slide-prev-duplicate",
                        navigation: null != this.navigation && {
                            nextEl: this.querySelector(".slider-button-next"),
                            prevEl: this.querySelector(".slider-button-prev")
                        },
                        slideVisibleClass: "slide-visible",
                        slidesPerView: this.data.slidesPerViewMobile,
                        loadPrevNext: null != this.data.loadprevnext,
                        loadPrevNextAmount: null != this.data.loadprevnext ? 2 : 1,
                        spaceBetween: i,
                        speed: parseInt(this.data.speed),
                        thumbs: this.thumbs,
                        watchSlidesProgress: !0,
                        wrapperClass: "slider-slides",
                        on: {
                            init: function (e) {
                                if (window.Zero.lazyLoad.update(), window.Zero.animation.init(), "true" === t.data.loadNext) {
                                    var i = e.slides[e.activeIndex + 1];
                                    if (i) {
                                        var l = i.querySelector(".lazy");
                                        l && ks().load(l)
                                    }
                                }
                            },
                            breakpoint: function (t, e) {
                                e.spaceBetween >= 1e3 && t.destroy()
                            },
                            click: function (e, i) {
                                if (i.preventDefault(), "change-to" === t.data.click) {
                                    i.stopPropagation();
                                    var r = i.target.closest(".slide");
                                    r.classList.contains("slide-active") && r.dataset.link ? window.location = r.dataset.link : t.carousel.slideToLoop(r.dataset.swiperSlideIndex, parseInt(t.data.speed))
                                } else if ("change-next" === t.data.click) e.clickedIndex + 1 === t.slides.length ? t.carousel.slideTo(0) : t.carousel.slideTo(e.clickedIndex + 1);
                                else if ("change-prev-next" === t.data.click) {
                                    var n = i.target;
                                    n.offsetWidth / 2 > (i.clientX || (i.changedTouches ? i.changedTouches[0].pageX : null)) - n.getBoundingClientRect().left ? t.carousel.slidePrev() : t.carousel.slideNext()
                                }
                            },
                            paginationRender: function (t, e) { },
                            doubleClick: function (t, e) {
                                console.log("2clicked", e)
                            },
                            afterInit: function (e) {
                                t.materialTextEls && t.materialTextEls[e.activeIndex] && t.materialTextEls[e.activeIndex].classList.add("active")
                            },
                            touchstart: function (t, e) {
                                e.preventDefault()
                            },
                            slideChange: function (e, i) {
                                if ("main-style" === t.carouselType && t.togglePaginationStyle(e.slides[e.activeIndex], e.pagination.el), "two-col-product" === t.carouselType) {
                                    var r = e.slides[e.activeIndex].dataset.labelRef,
                                        n = t.closest(".two-col-product-wrapper").querySelector(".active-label"),
                                        a = t.closest(".two-col-product-wrapper").querySelector("[data-label='".concat(r, "']"));
                                    Cn.to(n, {
                                        opacity: 0,
                                        pointerEvents: "none"
                                    }), n.classList.remove("active-label"), Cn.to(a, {
                                        opacity: 1,
                                        pointerEvents: "auto"
                                    }), a.classList.add("active-label")
                                }
                                if (t.materialTextEls && (t.materialTextEls[e.previousIndex].classList.remove("active"), t.materialTextEls[e.activeIndex].classList.add("active")), "true" === t.data.loadNext) {
                                    var s = e.slides[e.activeIndex + 1];
                                    if (s) {
                                        var l = s.querySelector(".lazy");
                                        l && ks().load(l)
                                    }
                                }
                            },
                            slideChangeTransitionEnd: function (e, i) {
                                "play-video-on-entrance" === t.videoBehavior && t.updateVideos(e)
                            }
                        }
                    }, "crossfade" === this.dataset.effect) this.options.fadeEffect = {
                        crossFade: !0
                    };
                    (void 0 === this.data.mobileOnly || window.Zero.windowWidth <= 768) && (this.carousel = new ds(this.carouselEl, this.options), "main-style" === this.carouselType && this.togglePaginationStyle(this.carousel.slides[this.carousel.activeIndex], this.carousel.pagination.el), "play-video-on-entrance" === this.videoBehavior && this.carousel.slides[this.carousel.activeIndex].querySelector("video") && this.carousel.slides[this.carousel.activeIndex].querySelector("video").addEventListener("loadeddata", (function () {
                        t.carousel.slides[t.carousel.activeIndex].querySelector("video").play()
                    })))
                }
            }, {
                key: "togglePaginationStyle",
                value: function (t, e) {
                    t && (t.classList.contains("lifestyle-image") && e ? e.classList.add("light") : e && e.classList.remove("light"))
                }
            }, {
                key: "updateVideos",
                value: function (t) {
                    var e, i = xs(t.slides);
                    try {
                        var r = function () {
                            var t = e.value;
                            if (t.classList.contains("slide-active")) {
                                var i = t.querySelector("video");
                                i && i.classList.contains("loaded") ? i.play() : i && i.addEventListener("loadeddata", (function () {
                                    i.play()
                                }))
                            } else t.querySelector("video").pause(), t.querySelector("video").currentTime = 0
                        };
                        for (i.s(); !(e = i.n()).done;) r()
                    } catch (t) {
                        i.e(t)
                    } finally {
                        i.f()
                    }
                }
            }, {
                key: "bindFakeThumbNails",
                value: function () {
                    var t = this;
                    this.materialTextEls && this.materialTextEls.forEach((function (e) {
                        e.addEventListener("click", (function () {
                            t.carousel.slideTo(e.getAttribute("data-index"))
                        }))
                    }))
                }
            }, {
                key: "onResized",
                value: function (t) {
                    void 0 !== this.data.mobileOnly && window.Zero.windowWidth <= 768 && (this.carousel && !0 !== this.carousel.destroyed || (this.carousel = new ds(this.carouselEl, this.options)))
                }
            }]), i
        }(aa);

        function Cs(t) {
            var e = function () {
                if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                if (Reflect.construct.sham) return !1;
                if ("function" == typeof Proxy) return !0;
                try {
                    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], (function () { }))), !0
                } catch (t) {
                    return !1
                }
            }();
            return function () {
                var i, r = f(t);
                if (e) {
                    var n = f(this).constructor;
                    i = Reflect.construct(r, arguments, n)
                } else i = r.apply(this, arguments);
                return p(this, i)
            }
        }
        var Ps = function (t) {
            h(i, t);
            var e = Cs(i);

            function i() {
                var t;
                return n(this, i), t = e.call(this), console.log(d(t)), t
            }
            return l(i)
        }(Hn(HTMLElement));

        function Ds(t) {
            var e = function () {
                if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                if (Reflect.construct.sham) return !1;
                if ("function" == typeof Proxy) return !0;
                try {
                    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], (function () { }))), !0
                } catch (t) {
                    return !1
                }
            }();
            return function () {
                var i, r = f(t);
                if (e) {
                    var n = f(this).constructor;
                    i = Reflect.construct(r, arguments, n)
                } else i = r.apply(this, arguments);
                return p(this, i)
            }
        }
        var Ls = function (t) {
            h(i, t);
            var e = Ds(i);

            function i() {
                var t;
                return n(this, i), (t = e.call(this)).trigger = t.querySelector(".js-trigger"), t.el = t.querySelector(".drawer-2"), t.wrapper = t.querySelector(".drawer-wrapper"), t.inner = t.querySelector(".drawer-inner"), t.bg = t.querySelector(".drawer-bg"), t.form = t.querySelector("form"), t.close = t.querySelectorAll(".js-close"), t.context = t.closest("#header-content") || t.closest("#main-content"), t.externalTriggers = document.querySelectorAll(".js-trigger-".concat(t.getAttribute("data-external-trigger"))), t.trigger && t.trigger.addEventListener("click", T((function (e) {
                    t.openDrawer(e)
                })).bind(d(t))), t.externalTriggers.length > 0 && t.externalTriggers.forEach((function (e) {
                    return e.addEventListener("click", T((function (e) {
                        t.openDrawer(e)
                    })).bind(d(t)))
                })), t.close.forEach((function (e) {
                    e.addEventListener("click", T((function (e) {
                        t.closeDrawer(e)
                    })).bind(d(t)))
                })), t
            }
            return l(i, [{
                key: "openDrawer",
                value: function () {
                    C(), Cn.to(this.bg, {
                        autoAlpha: .5
                    }), this.bg.classList.remove("pointer-events-none"), Cn.to(this.el, {
                        x: "0%"
                    })
                }
            }, {
                key: "closeDrawer",
                value: function () {
                    var t = this;
                    P(), Cn.to(this.bg, {
                        autoAlpha: 0,
                        onComplete: function () {
                            t.bg.classList.add("pointer-events-none")
                        }
                    }), Cn.to(this.el, {
                        x: "100%"
                    })
                }
            }, {
                key: "fixDrawerPosition",
                value: function () { }
            }, {
                key: "fixContext",
                value: function () {
                    this.context.style.position = null, this.context.style.zIndex = null
                }
            }]), i
        }(aa);

        function Os(t) {
            for (var e = 1; e < arguments.length; e++) {
                var i = arguments[e];
                for (var r in i) t[r] = i[r]
            }
            return t
        }
        var Is = {
            read: function (t) {
                return '"' === t[0] && (t = t.slice(1, -1)), t.replace(/(%[\dA-F]{2})+/gi, decodeURIComponent)
            },
            write: function (t) {
                return encodeURIComponent(t).replace(/%(2[346BF]|3[AC-F]|40|5[BDE]|60|7[BCD])/g, decodeURIComponent)
            }
        };
        (function t(e, i) {
            function r(t, r, n) {
                if ("undefined" != typeof document) {
                    "number" == typeof (n = Os({}, i, n)).expires && (n.expires = new Date(Date.now() + 864e5 * n.expires)), n.expires && (n.expires = n.expires.toUTCString()), t = encodeURIComponent(t).replace(/%(2[346B]|5E|60|7C)/g, decodeURIComponent).replace(/[()]/g, escape);
                    var a = "";
                    for (var s in n) n[s] && (a += "; " + s, !0 !== n[s] && (a += "=" + n[s].split(";")[0]));
                    return document.cookie = t + "=" + e.write(r, t) + a
                }
            }
            return Object.create({
                set: r,
                get: function (t) {
                    if ("undefined" != typeof document && (!arguments.length || t)) {
                        for (var i = document.cookie ? document.cookie.split("; ") : [], r = {}, n = 0; n < i.length; n++) {
                            var a = i[n].split("="),
                                s = a.slice(1).join("=");
                            try {
                                var o = decodeURIComponent(a[0]);
                                if (r[o] = e.read(s, o), t === o) break
                            } catch (t) { }
                        }
                        return t ? r[t] : r
                    }
                },
                remove: function (t, e) {
                    r(t, "", Os({}, e, {
                        expires: -1
                    }))
                },
                withAttributes: function (e) {
                    return t(this.converter, Os({}, this.attributes, e))
                },
                withConverter: function (e) {
                    return t(Os({}, this.converter, e), this.attributes)
                }
            }, {
                attributes: {
                    value: Object.freeze(i)
                },
                converter: {
                    value: Object.freeze(e)
                }
            })
        })(Is, {
            path: "/"
        });
        i(422);
        var Rs = function (t) {
            var e;
            try {
                e = window[t];
                var i = "__storage_test__";
                return e.setItem(i, i), e.removeItem(i), !0
            } catch (t) {
                return t instanceof DOMException && (22 === t.code || 1014 === t.code || "QuotaExceededError" === t.name || "NS_ERROR_DOM_QUOTA_REACHED" === t.name) && e && 0 !== e.length
            }
        };

        function Fs(t) {
            var e = function () {
                if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                if (Reflect.construct.sham) return !1;
                if ("function" == typeof Proxy) return !0;
                try {
                    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], (function () { }))), !0
                } catch (t) {
                    return !1
                }
            }();
            return function () {
                var i, r = f(t);
                if (e) {
                    var n = f(this).constructor;
                    i = Reflect.construct(r, arguments, n)
                } else i = r.apply(this, arguments);
                return p(this, i)
            }
        }
        var Ns = function (t) {
            h(i, t);
            var e = Fs(i);

            function i() {
                var t;
                return n(this, i), (t = e.call(this)).button = t.querySelector("button"), t.customerId = t.button.dataset.customer, t.favorites = t.button.dataset.favorites, t.handle = t.button.dataset.handle, t.route = t.button.dataset.route, t.faveCard = t.querySelector(".fave-card"), t.gridsToRender = document.querySelectorAll("favorites-grid"), t.favesCount = document.getElementById("faves-count"), t.init(), t
            }
            return l(i, [{
                key: "parseFavorites",
                value: function () {
                    if (this.favorites && "" != this.favorites && (this.favorites = JSON.parse(this.favorites)), !this.customerId && (console.log("no customer!"), Rs("localStorage"))) {
                        var t = localStorage.getItem("lokaiCustomerFavorites");
                        t && t.includes(this.handle) && (!0, this.button.classList.add("is-favorite"))
                    }
                    this.favorites.includes(this.handle) && (!0, this.button.classList.add("is-favorite"))
                }
            }, {
                key: "updateFavorite",
                value: function () {
                    var t = this;
                    if (console.log("update favorite!!!", this.customerId, this.favorites, this.handle), this.customerId) {
                        if (this.button.classList.add("pointer-events-none"), console.log("customer!"), this.favorites && "" != this.favorites && "[]" != this.favorites && this.favorites != [])
                            if (this.favorites.includes(this.handle)) console.log("need to remove from array", this.favorites), this.favorites = this.favorites.filter((function (e) {
                                return e !== t.handle
                            })), this.gridsToRender.forEach((function (e) {
                                e.removeCustomerFavorite(t.handle)
                            })), this.favesCount.decrement(), document.querySelectorAll('.is-favorite[data-handle="'.concat(this.handle, '"]')).forEach((function (t) {
                                t.classList.remove("is-favorite")
                            }));
                            else this.favorites.push(this.handle), this.button.classList.add("is-favorite"), this.gridsToRender.forEach((function (e) {
                                e.appendCustomerFavorite(t.faveCard)
                            })), this.favesCount.increment();
                        else this.favorites = [this.handle], this.gridsToRender.forEach((function (e) {
                            e.appendCustomerFavorite(t.faveCard)
                        })), this.favesCount.increment(), this.button.classList.add("is-favorite");
                        fetch("https://ubu5cu4k92.execute-api.us-east-1.amazonaws.com/default/updateCustomer", {
                            method: "post",
                            body: JSON.stringify({
                                customer_id: this.customerId,
                                json: this.favorites
                            })
                        }).then((function (t) {
                            return t.json()
                        })).then((function (e) {
                            console.log(e), t.button.classList.remove("pointer-events-none")
                        }))
                    } else if (console.log("no customer!"), Rs("localStorage")) {
                        var e = localStorage.getItem("lokaiCustomerFavorites"),
                            i = localStorage.getItem("guestFavoritesMU"),
                            r = [];
                        if (console.log("localstorageFavs", e), e && "undefined" != e) {
                            var n = JSON.parse(e);
                            if (r = JSON.parse(i), Array.isArray(n))
                                if (n.includes(this.handle)) {
                                    console.log("item already stored"), console.log("favoritesMU", r);
                                    r.includes(this.handle);
                                    for (var a = 0; a < r.length; a++) {
                                        r[a].includes(this.handle) && (r.splice(a, 1), localStorage.setItem("guestFavoritesMU", JSON.stringify(r)))
                                    }
                                    var s = n.filter((function (e) {
                                        return e !== t.handle
                                    }));
                                    console.log("newFaves", s), localStorage.setItem("lokaiCustomerFavorites", JSON.stringify(s)), this.gridsToRender.forEach((function (e) {
                                        e.removeCustomerFavorite(t.handle)
                                    })), this.favesCount.render(), document.querySelectorAll('.is-favorite[data-handle="'.concat(this.handle, '"]')).forEach((function (t) {
                                        t.classList.remove("is-favorite")
                                    }))
                                } else {
                                    n.push(this.handle);
                                    var o = this.faveCard.innerHTML.trim();
                                    r.push(o), localStorage.setItem("guestFavoritesMU", JSON.stringify(r)), this.gridsToRender.forEach((function (t) {
                                        t.render()
                                    })), localStorage.setItem("lokaiCustomerFavorites", JSON.stringify(n)), this.favesCount.render()
                                } this.parseFavorites()
                        } else {
                            var l = this.faveCard.innerHTML.trim();
                            r.push(l), localStorage.setItem("lokaiCustomerFavorites", JSON.stringify([this.handle])), localStorage.setItem("guestFavoritesMU", JSON.stringify(r)), this.gridsToRender.forEach((function (t) {
                                t.render()
                            })), this.parseFavorites(), this.favesCount.render()
                        }
                    }
                }
            }, {
                key: "init",
                value: function () {
                    this.parseFavorites(), this.button.addEventListener("click", this.updateFavorite.bind(this))
                }
            }]), i
        }(aa),
            Bs = function (t) {
                h(i, t);
                var e = Fs(i);

                function i() {
                    var t;
                    return n(this, i), (t = e.call(this)).customerId = null, t.favorites = [], t.favoritesRef = t.querySelector("#customer-favorites-ref"), t.init(), t
                }
                return l(i, [{
                    key: "checkFavorites",
                    value: function () {
                        if (console.log("check favorites here"), Rs("localStorage")) {
                            var t = localStorage.getItem("lokaiCustomerFavorites");
                            if (console.log("localstorageFavs", t), t && "undefined" != t) {
                                var e = JSON.parse(t),
                                    i = Array.isArray(e);
                                if (console.log("parsed favorites", e, i), i) {
                                    var n = r(new Set([].concat(r(this.favorites), r(e))));
                                    fetch("https://ubu5cu4k92.execute-api.us-east-1.amazonaws.com/default/updateCustomer", {
                                        method: "post",
                                        body: JSON.stringify({
                                            customer_id: this.customerId,
                                            json: n
                                        })
                                    }).then((function (t) {
                                        return t.json()
                                    })).then((function (t) {
                                        localStorage.removeItem("lokaiCustomerFavorites")
                                    }))
                                }
                            }
                        }
                    }
                }, {
                    key: "init",
                    value: function () {
                        console.log(this), this.customerId = this.favoritesRef.dataset.customer;
                        var t = JSON.parse(this.favoritesRef.dataset.favorites);
                        Array.isArray(t) && (this.favorites = t), this.checkFavorites()
                    }
                }]), i
            }(aa),
            zs = function (t) {
                h(i, t);
                var e = Fs(i);

                function i() {
                    var t;
                    return n(this, i), (t = e.call(this)).grid = t.querySelector(".faves-grid"), t.noFavoritesEl = t.querySelector(".empty-state"), t.gridLimit = parseInt(t.dataset.limit), t.numberOfCards = t.querySelectorAll(".product-card").length, t.customerId = t.dataset.customer, t.render(), t
                }
                return l(i, [{
                    key: "render",
                    value: function () {
                        var t = this;
                        if (!this.customerId && localStorage.getItem("guestFavoritesMU")) {
                            var e = JSON.parse(localStorage.getItem("guestFavoritesMU"));
                            this.grid.innerHTML = "", e.forEach((function (e) {
                                var i = document.createElement("div");
                                i.innerHTML = e;
                                var r = i.querySelector(".product-card").getAttribute("data-handle");
                                i.classList.add("product-".concat(r)), t.grid.appendChild(i), t.numberOfCards++
                            })), this.numberOfCards > 0 && (this.noFavoritesEl.classList.add("hidden"), this.noFavoritesEl.classList.add("pointer-events-none"))
                        }
                    }
                }, {
                    key: "appendCustomerFavorite",
                    value: function (t) {
                        if (!(this.numberOfCards >= this.gridLimit)) {
                            var e = t.querySelector(".product-card"),
                                i = document.createElement("div");
                            i.innerHTML = e.innerHTML;
                            var r = e.getAttribute("data-handle");
                            i.classList.add("product-".concat(r)), this.grid.appendChild(i), this.numberOfCards++, this.noFavoritesEl && (this.noFavoritesEl.classList.add("hidden"), this.noFavoritesEl.classList.add("pointer-events-none"))
                        }
                    }
                }, {
                    key: "removeCustomerFavorite",
                    value: function (t) {
                        var e = this.grid.querySelector(".product-".concat(t));
                        console.log("cardToRemove", e), this.grid.removeChild(e), this.numberOfCards--, 0 === this.numberOfCards && (this.noFavoritesEl.classList.remove("hidden"), this.noFavoritesEl.classList.remove("pointer-events-none"))
                    }
                }]), i
            }(aa),
            qs = function (t) {
                h(i, t);
                var e = Fs(i);

                function i() {
                    var t;
                    return n(this, i), (t = e.call(this)).customerId = t.dataset.customer, t.favorites = t.dataset.favorites, t.cartHeart = document.querySelector("#little-cart-heart"), t.render(), t
                }
                return l(i, [{
                    key: "render",
                    value: function () {
                        var t = 0;
                        if (this.customerId) {
                            t = JSON.parse(this.favorites).length
                        } else {
                            var e = localStorage.getItem("lokaiCustomerFavorites"),
                                i = JSON.parse(e);
                            if (!i) return void (t = 0);
                            t = i.length
                        }
                        this.innerHTML = "".concat(t), t > 0 ? this.cartHeart.classList.remove("hidden") : this.cartHeart.classList.add("hidden")
                    }
                }, {
                    key: "increment",
                    value: function () {
                        var t = parseInt(this.innerHTML);
                        t++, this.innerHTML = "".concat(t), this.cartHeart.classList.remove("hidden")
                    }
                }, {
                    key: "decrement",
                    value: function () {
                        var t = parseInt(this.innerHTML);
                        t--, this.innerHTML = "".concat(t), 0 === t && this.cartHeart.classList.add("hidden")
                    }
                }]), i
            }(aa);

        function Vs(t) {
            var e = function () {
                if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                if (Reflect.construct.sham) return !1;
                if ("function" == typeof Proxy) return !0;
                try {
                    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], (function () { }))), !0
                } catch (t) {
                    return !1
                }
            }();
            return function () {
                var i, r = f(t);
                if (e) {
                    var n = f(this).constructor;
                    i = Reflect.construct(r, arguments, n)
                } else i = r.apply(this, arguments);
                return p(this, i)
            }
        }
        var Ys = function (t) {
            h(i, t);
            var e = Vs(i);

            function i() {
                var t;
                n(this, i);
                t = e.call(this);

                window.addEventListener("popstate", this.onHistoryChange.bind(this));

                return t;
            }

            return l(i)
        }(Hn(HTMLElement));
        const js = function () {
            let t = window,
                e = "inner";
            return "innerWidth" in window || (e = "client", t = document.documentElement || document.body), {
                width: t[e + "Width"],
                height: t[e + "Height"]
            }
        };

        function Gs(t) {
            var e = function () {
                if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                if (Reflect.construct.sham) return !1;
                if ("function" == typeof Proxy) return !0;
                try {
                    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], (function () { }))), !0
                } catch (t) {
                    return !1
                }
            }();
            return function () {
                var i, r = f(t);
                if (e) {
                    var n = f(this).constructor;
                    i = Reflect.construct(r, arguments, n)
                } else i = r.apply(this, arguments);
                return p(this, i)
            }
        }
        var Hs = function (t) {
            h(i, t);
            var e = Gs(i);

            function i() {
                var t;
                if (n(this, i), (t = e.call(this)).gridId = t.dataset.section, t.grid = document.querySelector('[data-id="'.concat(t.gridId, '"]')), t.form = t.closest("form") || t.querySelector("form"), t.filterWrapper = t.querySelector(".filters"), t.open = t.dataset.open || !1, t.sort = t.querySelector("select[name='sort_by']") || t.querySelectorAll("input[name='sort_by']"), t.sortTrigger = document.querySelector("[name='sort_by_trigger']"), t.matchMedia = Cn.matchMedia(), t.page = window.Zero.page, t.countEl = document.querySelector(".collection-count"), t.filterToggle = document.querySelector("toggle-filters"), t.filterToggle) {
                    t.setTimeline();
                    var r = t.filterToggle.querySelector("button span");
                    t.filterToggle.dataset.open = t.open, js().width <= 768 && (t.open = !1, r.textContent = r.textContent.replace("Hide", "Show")), "true" !== t.open && !0 !== t.open || (r.textContent = r.textContent.replace("Show", "Hide"), t.timeline.progress(1).pause())
                }
                return t.rangePrice = document.querySelector("range-price"), t.rangePrice && customElements.define("range-price", Ws), t.initialParams = window.location.search.slice(1), t.previousParams = t.initialParams, t.filterCache = [], t.bindEvents(), t
            }
            return l(i, [{
                key: "setTimeline",
                value: function () {
                    var t = this;
                    this.baseWidth = this.clientWidth, this.timeline = Cn.timeline({
                        paused: !0
                    }), this.matchMedia.add("(min-width: 1px)", (function () {
                        t.style.overflow = "hidden", t.timeline.fromTo(t, {
                            minWidth: 0,
                            width: 0
                        }, {
                            minWidth: t.baseWidth,
                            width: t.baseWidth,
                            duration: .3,
                            ease: "Power2.inOut"
                        })
                    })), this.timeline.progress(0).pause()
                }
            }, {
                key: "activateFilter",
                value: function (t) {
                    t.preventDefault();
                    var e = t.currentTarget.href,
                        i = e.indexOf("?") < 0 ? "" : e.slice(e.indexOf("?") + 1);
                    console.log(i), this.getData(i, t)
                }
            }, {
                key: "bindEvents",
                value: function () {
                    var t = this;
                    this.addEventListener("history", this.onHistoryChange), this.debounceSubmit = T((function (e) {
                        console.log("el", e.target.closest(".btn"));
                        var i, r = e.target.closest(".btn");
                        r && (i = "active", (" " + r.className + " ").indexOf(" " + i + " ") > -1 ? r.classList.remove("active") : r.classList.add("active")), t.onSubmit(e)
                    }), 500), this.form.addEventListener("input", this.debounceSubmit.bind(this)), this.sort && ("object" == a(this.sort) ? this.sort.forEach((function (e) {
                        return e.addEventListener("change", t.debounceSubmit.bind(t))
                    })) : this.sort.addEventListener("change", this.debounceSubmit.bind(this))), this.sortTrigger && this.sortTrigger.addEventListener("change", this.changeSort.bind(this))
                }
            }, {
                key: "changeSort",
                value: function (t) {
                    var e = t.target.value;
                    "object" == a(this.sort) && this.sort.forEach((function (t) {
                        t.value == e && (t.checked = "checked")
                    })), this.onSubmit(t)
                }
            }, {
                key: "getData",
                value: function (t, e) {
                    var i = !(arguments.length > 2 && void 0 !== arguments[2]) || arguments[2];
                    this.previousParams = t, this.grid.classList.add("loading");
                    var r = "".concat(window.location.pathname, "?section_id=").concat(this.gridId).concat("" !== t ? "&" + t : "");
                    this.loadData(r, e), i && this.updateHistory(t)
                }
            }, {
                key: "loadData",
                value: function (t, e) {
                    var i = this;
                    if (this.filterCache[t]) return this.renderFilters(this.filterCache[t].html, e), void this.renderGrid(this.filterCache[t].html);
                    fetch(t).then((function (t) {
                        if (!t.ok) throw new Error(t.status);
                        return t.text()
                    })).then((function (r) {
                        var n = r;
                        i.filterCache[t] = {
                            html: n
                        }, i.renderFilters(n, e), i.renderGrid(n), 1 == i.page.partyStatus && i.page.businessMode()
                    })).catch((function (t) {
                        throw t
                    }))
                }
            }, {
                key: "renderFilters",
                value: function (t, e) {
                    var i, r = (new DOMParser).parseFromString(t, "text/html"),
                        n = r.querySelectorAll("form .js-filter"),
                        a = e.target.closest("filter-remove") || null;
                    if (a) {
                        i = n;
                        var s = a.getAttribute("data-filter");
                        if ("all" === s) this.clearActiveInputs(this.filterWrapper.querySelectorAll("input[type='checkbox']:checked"));
                        else this.filterWrapper.querySelector('input[value="'.concat(s, '"]')).checked = !1
                    } else i = Array.from(n).filter((function (t) {
                        return ! function (t) {
                            var i = e ? e.target.closest(".js-filter") : void 0;
                            if (i && t.dataset.index === i.dataset.index) {
                                var r = i.querySelector(".js-clear"),
                                    n = i.querySelectorAll("input:checked"),
                                    a = i.querySelectorAll("input[type='number']"),
                                    s = a.length > 0 ? Array.from(a).filter((function (t) {
                                        return !!t.value
                                    })).length : 0;
                                return n.length > 0 || s > 0 ? r.classList.remove("hidden") : r.classList.add("hidden"), !0
                            }
                            return !1
                        }(t)
                    }));
                    i.forEach((function (t) {
                        document.querySelector('.js-filter[data-index="'.concat(t.dataset.index, '"]')).innerHTML = t.innerHTML
                    }));
                    this.form.querySelectorAll("input[type='checkbox']:checked");
                    this.renderActiveFilters(r)
                }
            }, {
                key: "renderActiveFilters",
                value: function (t) {
                    var e = t.querySelector(".active-filters");
                    e && (document.querySelector(".active-filters").innerHTML = e.innerHTML, this.toggleActive(!1))
                }
            }, {
                key: "renderAdditionalElements",
                value: function (t) { }
            }, {
                key: "renderGrid",
                value: function (t) {
                    var e = (new DOMParser).parseFromString(t, "text/html"),
                        i = e.querySelector(".collection-count").getAttribute("data-count");
                    this.countEl.innerHTML = "".concat(i, " Results"), this.grid.innerHTML = e.querySelector('[data-id="'.concat(this.gridId, '"]')).innerHTML, window.Zero.lazyLoad.update()
                }
            }, {
                key: "updateHistory",
                value: function (t) {
                    history.pushState({
                        params: t
                    }, "", "".concat(window.location.pathname).concat("" === t ? "" : "?".concat(t)))
                }
            }, {
                key: "toggleActive",
                value: function (t) { }
            }, {
                key: "clearActiveInputs",
                value: function (t) {
                    t && t.forEach((function (t) {
                        t.checked = !1
                    }))
                }
            }, {
                key: "toggleOpen",
                value: function () {
                    if (!0 === this.open || "true" === this.open) return this.open = !1, this.filterToggle.close(), void this.timeline.reverse();
                    this.open = !0, this.filterToggle.open(), this.timeline.play()
                }
            }, {
                key: "onSubmit",
                value: function (t) {
                    t.preventDefault();
                    var e = new FormData(this.form),
                        i = new URLSearchParams(e).toString();
                    this.getData(i, t)
                }
            }, {
                key: "onFilter",
                value: function (t) {
                    t.preventDefault(), this.toggleActive(t);
                    var e = t.currentTarget.href.indexOf("?"),
                        i = -1 == e ? "" : t.currentTarget.href.slice(e + 1);
                    this.getData(i, t)
                }
            }, {
                key: "onHistoryChange",
                value: function (t) {
                    var e = window.location.search.slice(1);
                    e !== this.previousParams && this.getData(e, null, !1)
                }
            }]), i
        }(Ys),
            Ws = function (t) {
                h(i, t);
                var e = Gs(i);

                function i() {
                    var t;
                    return n(this, i), (t = e.call(this)).inputs = t.querySelectorAll("input"), t.inputs.forEach((function (e) {
                        return e.addEventListener("change", t.onRangeChange.bind(d(t)))
                    })), t.setMinMax(), t
                }
                return l(i, [{
                    key: "onRangeChange",
                    value: function (t) {
                        this.adjustValidValues(t.currentTarget), this.setMinMax()
                    }
                }, {
                    key: "setMinMax",
                    value: function () {
                        var t = this.inputs[0],
                            e = this.inputs[1];
                        e.value && t.setAttribute("max", e.value), t.value && e.setAttribute("min", t.value), "" === t.value && e.setAttribute("min", 0), "" === e.value && t.setAttribute("max", e.getAttribute("max"))
                    }
                }, {
                    key: "adjustValidValues",
                    value: function (t) {
                        var e = Number(t.value),
                            i = Number(t.getAttribute("min")),
                            r = Number(t.getAttribute("max"));
                        e < i && (t.value = i), e > r && (t.value = r)
                    }
                }]), i
            }(Hn(HTMLElement)),
            Zs = function (t) {
                h(i, t);
                var e = Gs(i);

                function i() {
                    var t;
                    n(this, i);
                    var r = (t = e.call(this)).querySelector("a"),
                        a = t.closest("filter-form") || document.querySelector("filter-form");
                    return r.addEventListener("click", (function (t) {
                        t.preventDefault(), a.activateFilter(t)
                    })), t
                }
                return l(i)
            }(Hn(HTMLElement)),
            $s = function (t) {
                h(i, t);
                var e = Gs(i);

                function i() {
                    var t;
                    return n(this, i), (t = e.call(this)).section = t.closest(".shopify-section"), t.form = t.section.querySelector("filter-form"), t.isOpen = t.dataset.open || !1, t.btn = t.querySelector("button"), t.btnText = t.btn.querySelector("span"), t.btnCount = t.querySelector("small"), t
                }
                return l(i, [{
                    key: "resetCount",
                    value: function (t) {
                        this.btnCount.textContent = t <= 0 ? "" : "(".concat(t, ")")
                    }
                }]), i
            }(Hn(HTMLElement));

        function Us(t) {
            var e = function () {
                if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                if (Reflect.construct.sham) return !1;
                if ("function" == typeof Proxy) return !0;
                try {
                    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], (function () { }))), !0
                } catch (t) {
                    return !1
                }
            }();
            return function () {
                var i, r = f(t);
                if (e) {
                    var n = f(this).constructor;
                    i = Reflect.construct(r, arguments, n)
                } else i = r.apply(this, arguments);
                return p(this, i)
            }
        }
        var Xs = function (t) {
            h(i, t);
            var e = Us(i);

            function i() {
                var t;
                return n(this, i), (t = e.call(this)).internals_ = t.attachInternals(), console.log(d(t)), t
            }
            return l(i)
        }(aa),
            Ks = i(234),
            Js = i.n(Ks);

        function Qs(t) {
            var e = function () {
                if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                if (Reflect.construct.sham) return !1;
                if ("function" == typeof Proxy) return !0;
                try {
                    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], (function () { }))), !0
                } catch (t) {
                    return !1
                }
            }();
            return function () {
                var i, r = f(t);
                if (e) {
                    var n = f(this).constructor;
                    i = Reflect.construct(r, arguments, n)
                } else i = r.apply(this, arguments);
                return p(this, i)
            }
        }
        var to = function (t) {
            h(a, t);
            var e, i, r = Qs(a);

            function a() {
                var t;
                if (n(this, a), t = r.call(this), window.Zero.LottieFiles = window.Zero.LottieFiles || [], window.Zero.LottieFiles.files = window.Zero.LottieFiles.files || [], t.url = t.dataset.url, !t.url || "" === t.url) return console.log("no Lottie url for ", d(t)), p(t);
                t.autoplay = !0 === t.dataset.autoplay || "true" === t.dataset.autoplay, t.framerate = t.dataset.framerate && "" !== t.dataset.framerate ? t.dataset.framerate : 1, t.loop = !t.dataset.loop || "" === t.dataset.loop || t.dataset.loop, t.rendererSettings = {
                    progressiveLoad: !1,
                    hideOnTransparent: !0,
                    className: "",
                    id: ""
                };
                var e = t.url.split("?");
                return t.fileName = window.btoa(e[0]), window.Zero.LottieFiles.files[t.fileName] = window.Zero.LottieFiles.files[t.fileName] || {
                    el: d(t),
                    status: "init",
                    data: null
                }, t.dataset.fileName = t.fileName, t.init(), t
            }
            return l(a, [{
                key: "init",
                value: (i = g(y().mark((function t() {
                    var e, i;
                    return y().wrap((function (t) {
                        for (; ;) switch (t.prev = t.next) {
                            case 0:
                                return window.Zero.LottieFiles.files[this.fileName].status, t.next = 3, this.checkFile();
                            case 3:
                                t.sent, e = {
                                    rootMargin: "200px 0px 200px 0px",
                                    threshold: [0, .1]
                                }, i = function (t, e) {
                                    t.forEach((function (t) {
                                        var e = t.target.dataset.fileName;
                                        window.Zero.LottieFiles.files[e] && ((t.isIntersecting || t.isVisible) && window.Zero.LottieFiles.files[e].el.runFile(), !1 === t.isVisible && window.Zero.LottieFiles.files[e].el && window.Zero.LottieFiles.files[e].el.pauseOffScreen(), (t.isIntersecting || t.isVisible) && window.Zero.LottieFiles.files[e].el.playOnScreen())
                                    }))
                                }, window.Zero.LottieFiles.observer = window.Zero.LottieFiles.observer || new IntersectionObserver(i, e), window.Zero.LottieFiles.observer.observe(this);
                            case 8:
                            case "end":
                                return t.stop()
                        }
                    }), t, this)
                }))), function () {
                    return i.apply(this, arguments)
                })
            }, {
                key: "checkFile",
                value: (e = g(y().mark((function t() {
                    var e, i, r, n;
                    return y().wrap((function (t) {
                        for (; ;) switch (t.prev = t.next) {
                            case 0:
                                if (!window.Zero.LottieFiles.files[this.fileName] || "complete" !== window.Zero.LottieFiles.files[this.fileName].status) {
                                    t.next = 10;
                                    break
                                }
                                return t.prev = 1, e = JSON.parse(window.Zero.LottieFiles.files[this.fileName]), t.abrupt("return", e);
                            case 6:
                                t.prev = 6, t.t0 = t.catch(1), window.Zero.LottieFiles.files[this.fileName].status = "error", window.Zero.LottieFiles.files[this.fileName].data = {};
                            case 10:
                                return t.prev = 10, window.Zero.LottieFiles.files[this.fileName].status = "loading", t.next = 14, fetch(this.url);
                            case 14:
                                return i = t.sent, t.next = 17, i.json();
                            case 17:
                                return r = t.sent, n = JSON.stringify(r), window.Zero.LottieFiles.files[this.fileName].status = "complete", window.Zero.LottieFiles.files[this.fileName].data = r, t.abrupt("return", n);
                            case 24:
                                return t.prev = 24, t.t1 = t.catch(10), window.Zero.LottieFiles.files[this.fileName].status = "error", window.Zero.LottieFiles.files[this.fileName].data = {
                                    error: t.t1
                                }, t.abrupt("return", {});
                            case 29:
                            case "end":
                                return t.stop()
                        }
                    }), t, this, [
                        [1, 6],
                        [10, 24]
                    ])
                }))), function () {
                    return e.apply(this, arguments)
                })
            }, {
                key: "runFile",
                value: function () {
                    "complete" === window.Zero.LottieFiles.files[this.fileName].status && (this.animation = Js().loadAnimation({
                        container: this,
                        renderer: this.renderer,
                        loop: this.loop,
                        autoplay: this.autoplay,
                        setSpeed: this.framerate,
                        animationData: window.Zero.LottieFiles.files[this.fileName].data,
                        rendererSettings: this.rendererSettings
                    }), !0 === this.autoplay ? (this.playOnScreen(), window.Zero.LottieFiles.files[this.fileName].status = "running") : window.Zero.LottieFiles.files[this.fileName].status = "paused")
                }
            }, {
                key: "pauseOffScreen",
                value: function () {
                    this.animation && this.animation.pause()
                }
            }, {
                key: "playOnScreen",
                value: function () {
                    this.animation && !1 !== this.autoplay && this.animation.play()
                }
            }]), a
        }(Hn(HTMLElement));

        function eo(t) {
            var e = function () {
                if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                if (Reflect.construct.sham) return !1;
                if ("function" == typeof Proxy) return !0;
                try {
                    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], (function () { }))), !0
                } catch (t) {
                    return !1
                }
            }();
            return function () {
                var i, r = f(t);
                if (e) {
                    var n = f(this).constructor;
                    i = Reflect.construct(r, arguments, n)
                } else i = r.apply(this, arguments);
                return p(this, i)
            }
        }
        var io = function (t) {
            h(i, t);
            var e = eo(i);

            function i() {
                var t;
                return n(this, i), (t = e.call(this)).trigger = t.querySelector(".js-trigger"), t.wrapper = t.querySelector(".modal-wrapper"), t.form = t.querySelector("form"), t.close = t.querySelector(".js-close"), t.bg = t.querySelector(".modal-bg"), t.context = t.closest("#header-content") || t.closest("#main-content"), t.trigger.addEventListener("click", T((function (e) {
                    t.openModal(e)
                })).bind(d(t))), t.bg.addEventListener("click", T((function (e) {
                    t.closeModal(e)
                })).bind(d(t))), t.close.addEventListener("click", T((function (e) {
                    t.closeModal(e)
                })).bind(d(t))), t.fixModalPosition(), t
            }
            return l(i, [{
                key: "openModal",
                value: function () {
                    C(), this.wrapper.children[1].focus(), this.fixContext(!0), Cn.to(this.wrapper, {
                        autoAlpha: 1
                    })
                }
            }, {
                key: "closeModal",
                value: function () {
                    var t = this;
                    P(), this.trigger.focus(), Cn.to(this.wrapper, {
                        autoAlpha: 0,
                        onComplete: function () {
                            t.fixContext()
                        }
                    })
                }
            }, {
                key: "fixModalPosition",
                value: function () {
                    var t = this.wrapper.getBoundingClientRect();
                    this.wrapper.style.height = "".concat(window.innerHeight, "px"), this.wrapper.style.width = "".concat(window.innerWidth, "px"), t.y > 0 && (this.wrapper.style.top = "-".concat(t.y, "px")), t.x > 0 && (this.wrapper.style.left = "-".concat(t.x, "px"))
                }
            }, {
                key: "fixContext",
                value: function () {
                    var t = arguments.length > 0 && void 0 !== arguments[0] && arguments[0];
                    if (!0 === t) return this.context.style.position = "relative", void (this.context.style.zIndex = "100000");
                    this.context.style.position = null, this.context.style.zIndex = null
                }
            }]), i
        }(aa);

        function ro(t) {
            var e = function () {
                if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                if (Reflect.construct.sham) return !1;
                if ("function" == typeof Proxy) return !0;
                try {
                    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], (function () { }))), !0
                } catch (t) {
                    return !1
                }
            }();
            return function () {
                var i, r = f(t);
                if (e) {
                    var n = f(this).constructor;
                    i = Reflect.construct(r, arguments, n)
                } else i = r.apply(this, arguments);
                return p(this, i)
            }
        }
        var no = function (t) {
            h(i, t);
            var e = ro(i);

            function i() {
                var t;
                n(this, i), (t = e.call(this)).open = !1, t.active = null, t.section = t.closest("section"), t.header = t.closest("header"), t.bg = t.querySelector(".nav-background"), t.pseudoScrollbar = null, t.tabTriggers = t.querySelectorAll(".tab-trigger"), t.triggerContainer = t.querySelector(".nav-tab-triggers"), t.tabs = t.querySelectorAll(".tab"), document.addEventListener("scroll", t.onScroll.bind(d(t))), t.pencilBar = document.querySelector("#fixed-announcement-bar"), t.pencilBarHeight = t.pencilBar.offsetHeight, t.menuToggle = t.querySelector(".menu-toggle"), t.closeSearch = t.querySelector(".search-close"), t.tabTriggers.forEach((function (e) {
                    return e.addEventListener("click", t.tabOpen.bind(d(t)))
                })), t.menuToggle.addEventListener("click", (function (e) {
                    t.active ? t.closeAllTabs() : t.tabOpen({
                        target: {
                            dataset: {
                                trigger: "shop"
                            }
                        }
                    })
                })), t.closeSearch.addEventListener("click", t.closeAllTabs.bind(d(t))), t.bg.addEventListener("click", t.closeAllTabs.bind(d(t))), t.tabs.forEach((function (e) {
                    e.addEventListener("click", (function (e) {
                        e.target == e.currentTarget && t.closeAllTabs()
                    }))
                })), window.Zero.scroll = window.Zero.scroll || {}, window.Zero.scroll.direction = window.Zero.scroll.direction || {};
                var r = {
                    set: function (e, i, r) {
                        var n = window.Zero.scroll.current <= 0 ? "up" : r;
                        return e[i] = n, t.handleScrollDirection(n), !0
                    }
                };
                return window.Zero.scroll.direction = new Proxy(window.Zero.scroll.direction, r), t
            }
            return l(i, [{
                key: "handleScrollDirection",
                value: function (t) {
                    this.header.classList.contains("active") || ("down" === t && document.querySelector(".hide-nav-on-scroll") ? (document.querySelector(".hide-nav-on-scroll").classList.add("nav-is-hidden"), Cn.to(this.pencilBar, {
                        height: "0px",
                        ease: "none",
                        duration: .2
                    }), this.scrolled = !0) : "up" === t && this.scrolled && document.querySelector(".hide-nav-on-scroll") && document.querySelector(".hide-nav-on-scroll").classList.remove("nav-is-hidden"))
                }
            }, {
                key: "tabOpen",
                value: function (t) {
                    var e = this;
                    if (t.target.classList && t.target.classList.contains("active")) this.closeAllTabs();
                    else {
                        if (this.header.classList.add("active"), this.menuToggle.classList.add("menu-open"), Cn.to(this.bg, {
                            opacity: .5,
                            pointerEvents: "auto",
                            duration: .2
                        }), "search" === (t.target.dataset.trigger || t.target.closest(".tab-trigger").dataset.trigger)) {
                            this.triggerContainer.classList.remove("active");
                            var i = this.querySelector(".icon-account"),
                                r = this.querySelector("#cart-summary");
                            Cn.set(i, {
                                opacity: .3
                            }), Cn.set(r, {
                                opacity: .3
                            }), document.querySelector("#Search").focus()
                        } else this.triggerContainer.classList.add("active"), this.tabTriggers.forEach((function (e) {
                            e.dataset.trigger !== (t.target.dataset.trigger || t.target.closest(".tab-trigger").dataset.trigger) ? (e.classList.add("inactive"), e.classList.remove("active")) : (e.classList.add("active"), e.classList.remove("inactive"))
                        }));
                        this.active && Cn.set(this.active, {
                            opacity: 0,
                            pointerEvents: "none"
                        }), this.tabs.forEach((function (i) {
                            i.dataset.tab === (t.target.dataset.trigger || t.target.closest(".tab-trigger").dataset.trigger) ? (Cn.set(i, {
                                opacity: 1,
                                pointerEvents: "auto"
                            }), i.querySelector(".newsletter-snippet") && (console.log("Newsletter snippet to show", i.querySelector(".newsletter-snippet")), i.querySelector(".newsletter-snippet").style.display = "block"), e.active = i, C()) : i.querySelector(".newsletter-snippet") && (console.log("Newsletter snippet to hide", i.querySelector(".newsletter-snippet")), i.querySelector(".newsletter-snippet").style.display = "none")
                        }))
                    }
                }
            }, {
                key: "closeAllTabs",
                value: function (t) {
                    this.header.classList.remove("active"), P(), this.menuToggle.classList.remove("menu-open"), Cn.set(this.bg, {
                        opacity: 0,
                        pointerEvents: "none"
                    }), Cn.set(this.active, {
                        opacity: 0,
                        pointerEvents: "none"
                    }), this.active = null, this.triggerContainer.classList.remove("active"), this.tabTriggers.forEach((function (t) {
                        t.classList.remove("inactive"), t.classList.remove("active")
                    }));
                    var e = this.querySelector(".icon-account"),
                        i = this.querySelector("#cart-summary");
                    Cn.set(e, {
                        opacity: 1
                    }), Cn.set(i, {
                        opacity: 1
                    })
                }
            }, {
                key: "onScroll",
                value: function () {
                    window.pageYOffset <= 5 && Cn.to(this.pencilBar, {
                        height: "".concat(this.pencilBarHeight, "px"),
                        ease: "none",
                        duration: .2
                    })
                }
            }]), i
        }(aa);
        const ao = no;

        function so(t) {
            var e = function () {
                if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                if (Reflect.construct.sham) return !1;
                if ("function" == typeof Proxy) return !0;
                try {
                    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], (function () { }))), !0
                } catch (t) {
                    return !1
                }
            }();
            return function () {
                var i, r = f(t);
                if (e) {
                    var n = f(this).constructor;
                    i = Reflect.construct(r, arguments, n)
                } else i = r.apply(this, arguments);
                return p(this, i)
            }
        }
        var oo = function (t) {
            h(i, t);
            var e = so(i);

            function i() {
                var t;
                return n(this, i), (t = e.call(this)).input = t.querySelector('input[type="search"]'), t.predictiveSearchResults = t.querySelector("#predictive-search"), t.presetSearchTerms = t.querySelectorAll(".preset-search-term"), t.topSearches = t.querySelector("#top-searches"), t.input.addEventListener("input", t.debounce((function (e) {
                    t.onChange(e)
                }), 300).bind(d(t))), t.presetSearchTerms.forEach((function (e) {
                    return e.addEventListener("click", t.searchFromPresetTerm.bind(d(t)))
                })), t.input.value = "", t
            }
            return l(i, [{
                key: "onChange",
                value: function () {
                    var t = this.input.value.trim();
                    this.presetSearchTerms.forEach((function (t) {
                        t.classList.remove("active")
                    })), t.length ? this.getSearchResults(t) : this.close()
                }
            }, {
                key: "searchFromPresetTerm",
                value: function (t) {
                    var e = t.target.dataset.term;
                    this.presetSearchTerms.forEach((function (e) {
                        e == t.target ? e.classList.add("active") : e.classList.remove("active")
                    })), this.input.value = e, this.getSearchResults(e)
                }
            }, {
                key: "getSearchResults",
                value: function (t) {
                    var e = this;
                    fetch("/search/suggest?q=".concat(t, "&resources[type]=product&resources[limit]=8&section_id=endpoint--predictive-search")).then((function (t) {
                        if (!t.ok) {
                            var i = new Error(t.status);
                            throw e.close(), i
                        }
                        return t.text()
                    })).then((function (t) {
                        var i = (new DOMParser).parseFromString(t, "text/html").querySelector("#shopify-section-endpoint--predictive-search").innerHTML;
                        e.predictiveSearchResults.innerHTML = i, e.open()
                    })).catch((function (t) {
                        throw e.close(), t
                    }))
                }
            }, {
                key: "open",
                value: function () {
                    this.predictiveSearchResults.style.display = "block", window.Zero.lazyLoad.update(), this.topSearches.style.display = "none"
                }
            }, {
                key: "close",
                value: function () {
                    this.predictiveSearchResults.style.display = "none", this.topSearches.style.display = "block"
                }
            }, {
                key: "debounce",
                value: function (t, e) {
                    var i, r = this;
                    return function () {
                        for (var n = arguments.length, a = new Array(n), s = 0; s < n; s++) a[s] = arguments[s];
                        clearTimeout(i), i = setTimeout((function () {
                            return t.apply(r, a)
                        }), e)
                    }
                }
            }]), i
        }(aa);
        const lo = oo;

        function co(t) {
            var e = function () {
                if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                if (Reflect.construct.sham) return !1;
                if ("function" == typeof Proxy) return !0;
                try {
                    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], (function () { }))), !0
                } catch (t) {
                    return !1
                }
            }();
            return function () {
                var i, r = f(t);
                if (e) {
                    var n = f(this).constructor;
                    i = Reflect.construct(r, arguments, n)
                } else i = r.apply(this, arguments);
                return p(this, i)
            }
        }
        var uo, ho, po, fo, mo, go, vo, yo, bo, _o = function (t) {
            h(i, t);
            var e = co(i);

            function i() {
                var t;
                return n(this, i), (t = e.call(this)).section = t.dataset.section, t.type = t.dataset.type, t.grid = document.querySelector("#shopify-section-".concat(t.section, " .pagination-grid")), t.filters = document.querySelector("#shopify-section-".concat(t.section, " filter-form")), "load-more" != t.type && "infinite" != t.type || t.bindLoadMore(), t.resetOnExit = !0, t
            }
            return l(i, [{
                key: "onViewportEnter",
                value: function () {
                    "infinite" === this.type && (console.log("Fire on viewport enter"), this.loadData())
                }
            }, {
                key: "bindLoadMore",
                value: function () {
                    var t = this;
                    this.button = this.querySelector("a"), this.button.addEventListener("click", (function (e) {
                        e.preventDefault(), e.stopPropagation(), t.loadData(e)
                    }))
                }
            }, {
                key: "loadData",
                value: function () {
                    var t = this,
                        e = this.button && this.button.href,
                        i = "".concat(e, "&section_id=").concat(this.section);
                    this.filters && this.filters.filterCache[e] ? this.renderGridWithPagination(this.filters.filterCache[e].html) : (console.log("Inside loadData"), fetch(i).then((function (t) {
                        if (!t.ok) throw new Error(t.status);
                        return t.text()
                    })).then((function (i) {
                        var r = i;
                        t.filters && (t.filters.filterCache[e] = {
                            html: r
                        }), t.renderGridWithPagination(r)
                    })).catch((function (t) {
                        throw t
                    })))
                }
            }, {
                key: "renderGridWithPagination",
                value: function (t) {
                    var e = (new DOMParser).parseFromString(t, "text/html"),
                        i = document.createDocumentFragment(),
                        n = e.querySelectorAll(".pagination-result");
                    i.append.apply(i, r(n)), this.grid.appendChild(i), window.Zero.lazyLoad.update();
                    var a = e.querySelector("paginate-grid");
                    a.innerHTML ? (this.innerHTML = a.innerHTML, this.bindLoadMore()) : this.remove()
                }
            }]), i
        }(aa),
            wo = "transform",
            Ao = wo + "Origin",
            So = function (t) {
                var e = t.ownerDocument || t;
                !(wo in t.style) && "msTransform" in t.style && (Ao = (wo = "msTransform") + "Origin");
                for (; e.parentNode && (e = e.parentNode););
                if (ho = window, vo = new Io, e) {
                    uo = e, po = e.documentElement, fo = e.body, (yo = uo.createElementNS("http://www.w3.org/2000/svg", "g")).style.transform = "none";
                    var i = e.createElement("div"),
                        r = e.createElement("div");
                    fo.appendChild(i), i.appendChild(r), i.style.position = "static", i.style[wo] = "translate3d(0,0,1px)", bo = r.offsetParent !== i, fo.removeChild(i)
                }
                return e
            },
            ko = [],
            xo = [],
            To = function () {
                return ho.pageYOffset || uo.scrollTop || po.scrollTop || fo.scrollTop || 0
            },
            Eo = function () {
                return ho.pageXOffset || uo.scrollLeft || po.scrollLeft || fo.scrollLeft || 0
            },
            Mo = function (t) {
                return t.ownerSVGElement || ("svg" === (t.tagName + "").toLowerCase() ? t : null)
            },
            Co = function t(e) {
                return "fixed" === ho.getComputedStyle(e).position || ((e = e.parentNode) && 1 === e.nodeType ? t(e) : void 0)
            },
            Po = function t(e, i) {
                if (e.parentNode && (uo || So(e))) {
                    var r = Mo(e),
                        n = r ? r.getAttribute("xmlns") || "http://www.w3.org/2000/svg" : "http://www.w3.org/1999/xhtml",
                        a = r ? i ? "rect" : "g" : "div",
                        s = 2 !== i ? 0 : 100,
                        o = 3 === i ? 100 : 0,
                        l = "position:absolute;display:block;pointer-events:none;margin:0;padding:0;",
                        c = uo.createElementNS ? uo.createElementNS(n.replace(/^https/, "http"), a) : uo.createElement(a);
                    return i && (r ? (go || (go = t(e)), c.setAttribute("width", .01), c.setAttribute("height", .01), c.setAttribute("transform", "translate(" + s + "," + o + ")"), go.appendChild(c)) : (mo || ((mo = t(e)).style.cssText = l), c.style.cssText = l + "width:0.1px;height:0.1px;top:" + o + "px;left:" + s + "px", mo.appendChild(c))), c
                }
                throw "Need document and parent."
            },
            Do = function (t) {
                var e, i = t.getCTM();
                return i || (e = t.style[wo], t.style[wo] = "none", t.appendChild(yo), i = yo.getCTM(), t.removeChild(yo), e ? t.style[wo] = e : t.style.removeProperty(wo.replace(/([A-Z])/g, "-$1").toLowerCase())), i || vo.clone()
            },
            Lo = function (t, e) {
                var i, r, n, a, s, o, l = Mo(t),
                    c = t === l,
                    u = l ? ko : xo,
                    h = t.parentNode;
                if (t === ho) return t;
                if (u.length || u.push(Po(t, 1), Po(t, 2), Po(t, 3)), i = l ? go : mo, l) c ? (a = -(n = Do(t)).e / n.a, s = -n.f / n.d, r = vo) : t.getBBox ? (n = t.getBBox(), r = (r = t.transform ? t.transform.baseVal : {}).numberOfItems ? r.numberOfItems > 1 ? function (t) {
                    for (var e = new Io, i = 0; i < t.numberOfItems; i++) e.multiply(t.getItem(i).matrix);
                    return e
                }(r) : r.getItem(0).matrix : vo, a = r.a * n.x + r.c * n.y, s = r.b * n.x + r.d * n.y) : (r = new Io, a = s = 0), e && "g" === t.tagName.toLowerCase() && (a = s = 0), (c ? l : h).appendChild(i), i.setAttribute("transform", "matrix(" + r.a + "," + r.b + "," + r.c + "," + r.d + "," + (r.e + a) + "," + (r.f + s) + ")");
                else {
                    if (a = s = 0, bo)
                        for (r = t.offsetParent, n = t; n && (n = n.parentNode) && n !== r && n.parentNode;)(ho.getComputedStyle(n)[wo] + "").length > 4 && (a = n.offsetLeft, s = n.offsetTop, n = 0);
                    if ("absolute" !== (o = ho.getComputedStyle(t)).position && "fixed" !== o.position)
                        for (r = t.offsetParent; h && h !== r;) a += h.scrollLeft || 0, s += h.scrollTop || 0, h = h.parentNode;
                    (n = i.style).top = t.offsetTop - s + "px", n.left = t.offsetLeft - a + "px", n[wo] = o[wo], n[Ao] = o[Ao], n.position = "fixed" === o.position ? "fixed" : "absolute", t.parentNode.appendChild(i)
                }
                return i
            },
            Oo = function (t, e, i, r, n, a, s) {
                return t.a = e, t.b = i, t.c = r, t.d = n, t.e = a, t.f = s, t
            },
            Io = function () {
                function t(t, e, i, r, n, a) {
                    void 0 === t && (t = 1), void 0 === e && (e = 0), void 0 === i && (i = 0), void 0 === r && (r = 1), void 0 === n && (n = 0), void 0 === a && (a = 0), Oo(this, t, e, i, r, n, a)
                }
                var e = t.prototype;
                return e.inverse = function () {
                    var t = this.a,
                        e = this.b,
                        i = this.c,
                        r = this.d,
                        n = this.e,
                        a = this.f,
                        s = t * r - e * i || 1e-10;
                    return Oo(this, r / s, -e / s, -i / s, t / s, (i * a - r * n) / s, -(t * a - e * n) / s)
                }, e.multiply = function (t) {
                    var e = this.a,
                        i = this.b,
                        r = this.c,
                        n = this.d,
                        a = this.e,
                        s = this.f,
                        o = t.a,
                        l = t.c,
                        c = t.b,
                        u = t.d,
                        h = t.e,
                        d = t.f;
                    return Oo(this, o * e + c * r, o * i + c * n, l * e + u * r, l * i + u * n, a + h * e + d * r, s + h * i + d * n)
                }, e.clone = function () {
                    return new t(this.a, this.b, this.c, this.d, this.e, this.f)
                }, e.equals = function (t) {
                    var e = this.a,
                        i = this.b,
                        r = this.c,
                        n = this.d,
                        a = this.e,
                        s = this.f;
                    return e === t.a && i === t.b && r === t.c && n === t.d && a === t.e && s === t.f
                }, e.apply = function (t, e) {
                    void 0 === e && (e = {});
                    var i = t.x,
                        r = t.y,
                        n = this.a,
                        a = this.b,
                        s = this.c,
                        o = this.d,
                        l = this.e,
                        c = this.f;
                    return e.x = i * n + r * s + l || 0, e.y = i * a + r * o + c || 0, e
                }, t
            }();

        function Ro(t, e, i, r) {
            if (!t || !t.parentNode || (uo || So(t)).documentElement === t) return new Io;
            var n = function (t) {
                for (var e, i; t && t !== fo;)(i = t._gsap) && i.uncache && i.get(t, "x"), i && !i.scaleX && !i.scaleY && i.renderTransform && (i.scaleX = i.scaleY = 1e-4, i.renderTransform(1, i), e ? e.push(i) : e = [i]), t = t.parentNode;
                return e
            }(t),
                a = Mo(t) ? ko : xo,
                s = Lo(t, i),
                o = a[0].getBoundingClientRect(),
                l = a[1].getBoundingClientRect(),
                c = a[2].getBoundingClientRect(),
                u = s.parentNode,
                h = !r && Co(t),
                d = new Io((l.left - o.left) / 100, (l.top - o.top) / 100, (c.left - o.left) / 100, (c.top - o.top) / 100, o.left + (h ? 0 : Eo()), o.top + (h ? 0 : To()));
            if (u.removeChild(s), n)
                for (o = n.length; o--;)(l = n[o]).scaleX = l.scaleY = 0, l.renderTransform(1, l);
            return e ? d.inverse() : d
        }
        var Fo, No, Bo, zo, qo, Vo, Yo, jo = 1,
            Go = function (t, e) {
                return t.actions.forEach((function (t) {
                    return t.vars[e] && t.vars[e](t)
                }))
            },
            Ho = {},
            Wo = 180 / Math.PI,
            Zo = Math.PI / 180,
            $o = {},
            Uo = {},
            Xo = {},
            Ko = function (t) {
                return "string" == typeof t ? t.split(" ").join("").split(",") : t
            },
            Jo = Ko("onStart,onUpdate,onComplete,onReverseComplete,onInterrupt"),
            Qo = Ko("transform,transformOrigin,width,height,position,top,left,opacity,zIndex,maxWidth,maxHeight,minWidth,minHeight"),
            tl = function (t) {
                return Fo(t)[0] || console.warn("Element not found:", t)
            },
            el = function (t) {
                return Math.round(1e4 * t) / 1e4 || 0
            },
            il = function (t, e, i) {
                return t.forEach((function (t) {
                    return t.classList[i](e)
                }))
            },
            rl = {
                zIndex: 1,
                kill: 1,
                simple: 1,
                spin: 1,
                clearProps: 1,
                targets: 1,
                toggleClass: 1,
                onComplete: 1,
                onUpdate: 1,
                onInterrupt: 1,
                onStart: 1,
                delay: 1,
                repeat: 1,
                repeatDelay: 1,
                yoyo: 1,
                scale: 1,
                fade: 1,
                absolute: 1,
                props: 1,
                onEnter: 1,
                onLeave: 1,
                custom: 1,
                paused: 1,
                nested: 1,
                prune: 1,
                absoluteOnLeave: 1
            },
            nl = {
                zIndex: 1,
                simple: 1,
                clearProps: 1,
                scale: 1,
                absolute: 1,
                fitChild: 1,
                getVars: 1,
                props: 1
            },
            al = function (t) {
                return t.replace(/([A-Z])/g, "-$1").toLowerCase()
            },
            sl = function (t, e) {
                var i, r = {};
                for (i in t) e[i] || (r[i] = t[i]);
                return r
            },
            ol = {},
            ll = function (t) {
                var e = ol[t] = Ko(t);
                return Xo[t] = e.concat(Qo), e
            },
            cl = function t(e, i, r) {
                void 0 === r && (r = 0);
                for (var n = e.parentNode, a = 1e3 * Math.pow(10, r) * (i ? -1 : 1), s = i ? 900 * -a : 0; e;) s += a, e = e.previousSibling;
                return n ? s + t(n, i, r + 1) : s
            },
            ul = function (t, e, i) {
                return t.forEach((function (t) {
                    return t.d = cl(i ? t.element : t.t, e)
                })), t.sort((function (t, e) {
                    return t.d - e.d
                })), t
            },
            hl = function (t, e) {
                for (var i, r, n = t.element.style, a = t.css = t.css || [], s = e.length; s--;) r = n[i = e[s]] || n.getPropertyValue(i), a.push(r ? i : Uo[i] || (Uo[i] = al(i)), r);
                return n
            },
            dl = function (t) {
                var e = t.css,
                    i = t.element.style,
                    r = 0;
                for (t.cache.uncache = 1; r < e.length; r += 2) e[r + 1] ? i[e[r]] = e[r + 1] : i.removeProperty(e[r]);
                !e[e.indexOf("transform") + 1] && i.translate && (i.removeProperty("translate"), i.removeProperty("scale"), i.removeProperty("rotate"))
            },
            pl = function (t, e) {
                t.forEach((function (t) {
                    return t.a.cache.uncache = 1
                })), e || t.finalStates.forEach(dl)
            },
            fl = "paddingTop,paddingRight,paddingBottom,paddingLeft,gridArea,transition".split(","),
            ml = function (t, e, i) {
                var r, n, a, s = t.element,
                    o = t.width,
                    l = t.height,
                    c = t.uncache,
                    u = t.getProp,
                    h = s.style,
                    d = 4;
                if ("object" != typeof e && (e = t), Bo && 1 !== i) return Bo._abs.push({
                    t: s,
                    b: t,
                    a: t,
                    sd: 0
                }), Bo._final.push((function () {
                    return (t.cache.uncache = 1) && dl(t)
                })), s;
                for (n = "none" === u("display"), t.isVisible && !n || (n && (hl(t, ["display"]).display = e.display), t.matrix = e.matrix, t.width = o = t.width || e.width, t.height = l = t.height || e.height), hl(t, fl), a = window.getComputedStyle(s); d--;) h[fl[d]] = a[fl[d]];
                if (h.gridArea = "1 / 1 / 1 / 1", h.transition = "none", h.position = "absolute", h.width = o + "px", h.height = l + "px", h.top || (h.top = "0px"), h.left || (h.left = "0px"), c) r = new Il(s);
                else if ((r = sl(t, $o)).position = "absolute", t.simple) {
                    var p = s.getBoundingClientRect();
                    r.matrix = new Io(1, 0, 0, 1, p.left + Eo(), p.top + To())
                } else r.matrix = Ro(s, !1, !1, !0);
                return r = Sl(r, t, !0), t.x = Vo(r.x, .01), t.y = Vo(r.y, .01), s
            },
            gl = function (t, e) {
                return !0 !== e && (e = Fo(e), t = t.filter((function (t) {
                    if (-1 !== e.indexOf((t.sd < 0 ? t.b : t.a).element)) return !0;
                    t.t._gsap.renderTransform(1), t.b.isVisible && (t.t.style.width = t.b.width + "px", t.t.style.height = t.b.height + "px")
                }))), t
            },
            vl = function (t) {
                return ul(t, !0).forEach((function (t) {
                    return (t.a.isVisible || t.b.isVisible) && ml(t.sd < 0 ? t.b : t.a, t.b, 1)
                }))
            },
            yl = function (t, e) {
                return e && t.idLookup[bl(e).id] || t.elementStates[0]
            },
            bl = function (t, e, i, r) {
                return t instanceof Il ? t : t instanceof Ol ? yl(t, r) : new Il("string" == typeof t ? tl(t) || console.warn(t + " not found") : t, e, i)
            },
            _l = function (t, e) {
                var i, r = t.style || t;
                for (i in e) r[i] = e[i]
            },
            wl = function (t) {
                return t.map((function (t) {
                    return t.element
                }))
            },
            Al = function (t, e, i) {
                return t && e.length && i.add(t(wl(e), i, new Ol(e, 0, !0)), 0)
            },
            Sl = function (t, e, i, r, n, a) {
                var s, o, l, c, u, h, d, p = t.element,
                    f = t.cache,
                    m = t.parent,
                    g = t.x,
                    v = t.y,
                    y = e.width,
                    b = e.height,
                    _ = e.scaleX,
                    w = e.scaleY,
                    A = e.rotation,
                    S = e.bounds,
                    k = a && p.style.cssText,
                    x = a && p.getBBox && p.getAttribute("transform"),
                    T = t,
                    E = e.matrix,
                    M = E.e,
                    C = E.f,
                    P = t.bounds.width !== S.width || t.bounds.height !== S.height || t.scaleX !== _ || t.scaleY !== w || t.rotation !== A,
                    D = !P && t.simple && e.simple && !n;
                return D || !m ? (_ = w = 1, A = s = 0) : (u = function (t) {
                    var e = t._gsap || No.core.getCache(t);
                    return e.gmCache === No.ticker.frame ? e.gMatrix : (e.gmCache = No.ticker.frame, e.gMatrix = Ro(t, !0, !1, !0))
                }(m), h = u.clone().multiply(e.ctm ? e.matrix.clone().multiply(e.ctm) : e.matrix), A = el(Math.atan2(h.b, h.a) * Wo), s = el(Math.atan2(h.c, h.d) * Wo + A) % 360, _ = Math.sqrt(Math.pow(h.a, 2) + Math.pow(h.b, 2)), w = Math.sqrt(Math.pow(h.c, 2) + Math.pow(h.d, 2)) * Math.cos(s * Zo), n && (n = Fo(n)[0], c = No.getProperty(n), d = n.getBBox && "function" == typeof n.getBBox && n.getBBox(), T = {
                    scaleX: c("scaleX"),
                    scaleY: c("scaleY"),
                    width: d ? d.width : Math.ceil(parseFloat(c("width", "px"))),
                    height: d ? d.height : parseFloat(c("height", "px"))
                }), f.rotation = A + "deg", f.skewX = s + "deg"), i ? (_ *= y !== T.width && T.width ? y / T.width : 1, w *= b !== T.height && T.height ? b / T.height : 1, f.scaleX = _, f.scaleY = w) : (y = Vo(y * _ / T.scaleX, 0), b = Vo(b * w / T.scaleY, 0), p.style.width = y + "px", p.style.height = b + "px"), r && _l(p, e.props), D || !m ? (g += M - t.matrix.e, v += C - t.matrix.f) : P || m !== e.parent ? (f.renderTransform(1, f), h = Ro(n || p, !1, !1, !0), o = u.apply({
                    x: h.e,
                    y: h.f
                }), g += (l = u.apply({
                    x: M,
                    y: C
                })).x - o.x, v += l.y - o.y) : (u.e = u.f = 0, g += (l = u.apply({
                    x: M - t.matrix.e,
                    y: C - t.matrix.f
                })).x, v += l.y), g = Vo(g, .02), v = Vo(v, .02), !a || a instanceof Il ? (f.x = g + "px", f.y = v + "px", f.renderTransform(1, f)) : (p.style.cssText = k, p.getBBox && p.setAttribute("transform", x || ""), f.uncache = 1), a && (a.x = g, a.y = v, a.rotation = A, a.skewX = s, i ? (a.scaleX = _, a.scaleY = w) : (a.width = y, a.height = b)), a || f
            },
            kl = function (t, e) {
                return t instanceof Ol ? t : new Ol(t, e)
            },
            xl = function (t, e, i) {
                var r = t.idLookup[i],
                    n = t.alt[i];
                return !n.isVisible || (e.getElementState(n.element) || n).isVisible && r.isVisible ? r : n
            },
            Tl = [],
            El = "width,height,overflowX,overflowY".split(","),
            Ml = function (t) {
                if (t !== Yo) {
                    var e = qo.style,
                        i = qo.clientWidth === window.outerWidth,
                        r = qo.clientHeight === window.outerHeight,
                        n = 4;
                    if (t && (i || r)) {
                        for (; n--;) Tl[n] = e[El[n]];
                        i && (e.width = qo.clientWidth + "px", e.overflowY = "hidden"), r && (e.height = qo.clientHeight + "px", e.overflowX = "hidden"), Yo = t
                    } else if (Yo) {
                        for (; n--;) Tl[n] ? e[El[n]] = Tl[n] : e.removeProperty(al(El[n]));
                        Yo = t
                    }
                }
            },
            Cl = function (t, e, i, r) {
                t instanceof Ol && e instanceof Ol || console.warn("Not a valid state object.");
                var n, a, s, o, l, c, u, h, d, p, f, m, g, v, y, b = i = i || {},
                    _ = b.clearProps,
                    w = b.onEnter,
                    A = b.onLeave,
                    S = b.absolute,
                    k = b.absoluteOnLeave,
                    x = b.custom,
                    T = b.delay,
                    E = b.paused,
                    M = b.repeat,
                    C = b.repeatDelay,
                    P = b.yoyo,
                    D = b.toggleClass,
                    L = b.nested,
                    O = b.zIndex,
                    I = b.scale,
                    R = b.fade,
                    F = b.stagger,
                    N = b.spin,
                    B = b.prune,
                    z = ("props" in i ? i : t).props,
                    q = sl(i, rl),
                    V = No.timeline({
                        delay: T,
                        paused: E,
                        repeat: M,
                        repeatDelay: C,
                        yoyo: P,
                        data: "isFlip"
                    }),
                    Y = q,
                    j = [],
                    G = [],
                    H = [],
                    W = [],
                    Z = !0 === N ? 1 : N || 0,
                    $ = "function" == typeof N ? N : function () {
                        return Z
                    },
                    U = t.interrupted || e.interrupted,
                    X = V[1 !== r ? "to" : "from"];
                for (a in e.idLookup) f = e.alt[a] ? xl(e, t, a) : e.idLookup[a], l = f.element, p = t.idLookup[a], t.alt[a] && l === p.element && (t.alt[a].isVisible || !f.isVisible) && (p = t.alt[a]), p ? (c = {
                    t: l,
                    b: p,
                    a: f,
                    sd: p.element === l ? 0 : f.isVisible ? 1 : -1
                }, H.push(c), c.sd && (c.sd < 0 && (c.b = f, c.a = p), U && hl(c.b, z ? Xo[z] : Qo), R && H.push(c.swap = {
                    t: p.element,
                    b: c.b,
                    a: c.a,
                    sd: -c.sd,
                    swap: c
                })), l._flip = p.element._flip = Bo ? Bo.timeline : V) : f.isVisible && (H.push({
                    t: l,
                    b: sl(f, {
                        isVisible: 1
                    }),
                    a: f,
                    sd: 0,
                    entering: 1
                }), l._flip = Bo ? Bo.timeline : V);
                (z && (ol[z] || ll(z)).forEach((function (t) {
                    return q[t] = function (e) {
                        return H[e].a.props[t]
                    }
                })), H.finalStates = d = [], m = function () {
                    for (ul(H), Ml(!0), o = 0; o < H.length; o++) c = H[o], g = c.a, v = c.b, !B || g.isDifferent(v) || c.entering ? (l = c.t, L && !(c.sd < 0) && o && (g.matrix = Ro(l, !1, !1, !0)), v.isVisible && g.isVisible ? (c.sd < 0 ? (u = new Il(l, z, t.simple), Sl(u, g, I, 0, 0, u), u.matrix = Ro(l, !1, !1, !0), u.css = c.b.css, c.a = g = u, R && (l.style.opacity = U ? v.opacity : g.opacity), F && W.push(l)) : c.sd > 0 && R && (l.style.opacity = U ? g.opacity - v.opacity : "0"), Sl(g, v, I, z)) : v.isVisible !== g.isVisible && (v.isVisible ? g.isVisible || (v.css = g.css, G.push(v), H.splice(o--, 1), S && L && Sl(g, v, I, z)) : (g.isVisible && j.push(g), H.splice(o--, 1))), I || (l.style.maxWidth = Math.max(g.width, v.width) + "px", l.style.maxHeight = Math.max(g.height, v.height) + "px", l.style.minWidth = Math.min(g.width, v.width) + "px", l.style.minHeight = Math.min(g.height, v.height) + "px"), L && D && l.classList.add(D)) : H.splice(o--, 1), d.push(g);
                    var e;
                    if (D && (e = d.map((function (t) {
                        return t.element
                    })), L && e.forEach((function (t) {
                        return t.classList.remove(D)
                    }))), Ml(!1), I ? (q.scaleX = function (t) {
                        return H[t].a.scaleX
                    }, q.scaleY = function (t) {
                        return H[t].a.scaleY
                    }) : (q.width = function (t) {
                        return H[t].a.width + "px"
                    }, q.height = function (t) {
                        return H[t].a.height + "px"
                    }, q.autoRound = i.autoRound || !1), q.x = function (t) {
                        return H[t].a.x + "px"
                    }, q.y = function (t) {
                        return H[t].a.y + "px"
                    }, q.rotation = function (t) {
                        return H[t].a.rotation + (N ? 360 * $(t, h[t], h) : 0)
                    }, q.skewX = function (t) {
                        return H[t].a.skewX
                    }, h = H.map((function (t) {
                        return t.t
                    })), (O || 0 === O) && (q.modifiers = {
                        zIndex: function () {
                            return O
                        }
                    }, q.zIndex = O, q.immediateRender = !1 !== i.immediateRender), R && (q.opacity = function (t) {
                        return H[t].sd < 0 ? 0 : H[t].sd > 0 ? H[t].a.opacity : "+=0"
                    }), W.length) {
                        F = No.utils.distribute(F);
                        var r = h.slice(W.length);
                        q.stagger = function (t, e) {
                            return F(~W.indexOf(e) ? h.indexOf(H[t].swap.t) : t, e, r)
                        }
                    }
                    if (Jo.forEach((function (t) {
                        return i[t] && V.eventCallback(t, i[t], i[t + "Params"])
                    })), x && h.length)
                        for (a in Y = sl(q, rl), "scale" in x && (x.scaleX = x.scaleY = x.scale, delete x.scale), x) (n = sl(x[a], nl))[a] = q[a], !("duration" in n) && "duration" in q && (n.duration = q.duration), n.stagger = q.stagger, X.call(V, h, n, 0), delete Y[a];
                    (h.length || G.length || j.length) && (D && V.add((function () {
                        return il(e, D, V._zTime < 0 ? "remove" : "add")
                    }), 0) && !E && il(e, D, "add"), h.length && X.call(V, h, Y, 0)), Al(w, j, V), Al(A, G, V);
                    var p = Bo && Bo.timeline;
                    p && (p.add(V, 0), Bo._final.push((function () {
                        return pl(H, !_)
                    }))), s = V.duration(), V.call((function () {
                        var t = V.time() >= s;
                        t && !p && pl(H, !_), D && il(e, D, t ? "remove" : "add")
                    }))
                }, k && (S = H.filter((function (t) {
                    return !t.sd && !t.a.isVisible && t.b.isVisible
                })).map((function (t) {
                    return t.a.element
                }))), Bo) ? (S && (y = Bo._abs).push.apply(y, gl(H, S)), Bo._run.push(m)) : (S && vl(gl(H, S)), m());
                var K = Bo ? Bo.timeline : V;
                return K.revert = function () {
                    return Dl(K, 1)
                }, K
            },
            Pl = function t(e) {
                e.vars.onInterrupt && e.vars.onInterrupt.apply(e, e.vars.onInterruptParams || []), e.getChildren(!0, !1, !0).forEach(t)
            },
            Dl = function (t, e) {
                if (t && t.progress() < 1 && !t.paused()) return e && (Pl(t), e < 2 && t.progress(1), t.kill()), !0
            },
            Ll = function (t) {
                for (var e, i = t.idLookup = {}, r = t.alt = {}, n = t.elementStates, a = n.length; a--;) i[(e = n[a]).id] ? r[e.id] = e : i[e.id] = e
            },
            Ol = function () {
                function t(t, e, i) {
                    if (this.props = e && e.props, this.simple = !(!e || !e.simple), i) this.targets = wl(t), this.elementStates = t, Ll(this);
                    else {
                        this.targets = Fo(t);
                        var r = e && (!1 === e.kill || e.batch && !e.kill);
                        Bo && !r && Bo._kill.push(this), this.update(r || !!Bo)
                    }
                }
                var e = t.prototype;
                return e.update = function (t) {
                    var e = this;
                    return this.elementStates = this.targets.map((function (t) {
                        return new Il(t, e.props, e.simple)
                    })), Ll(this), this.interrupt(t), this.recordInlineStyles(), this
                }, e.clear = function () {
                    return this.targets.length = this.elementStates.length = 0, Ll(this), this
                }, e.fit = function (t, e, i) {
                    for (var r, n, a = ul(this.elementStates.slice(0), !1, !0), s = (t || this).idLookup, o = 0; o < a.length; o++) r = a[o], i && (r.matrix = Ro(r.element, !1, !1, !0)), (n = s[r.id]) && Sl(r, n, e, !0, 0, r), r.matrix = Ro(r.element, !1, !1, !0);
                    return this
                }, e.getProperty = function (t, e) {
                    var i = this.getElementState(t) || $o;
                    return (e in i ? i : i.props || $o)[e]
                }, e.add = function (t) {
                    for (var e, i, r, n = t.targets.length, a = this.idLookup, s = this.alt; n--;)(r = a[(i = t.elementStates[n]).id]) && (i.element === r.element || s[i.id] && s[i.id].element === i.element) ? (e = this.elementStates.indexOf(i.element === r.element ? r : s[i.id]), this.targets.splice(e, 1, t.targets[n]), this.elementStates.splice(e, 1, i)) : (this.targets.push(t.targets[n]), this.elementStates.push(i));
                    return t.interrupted && (this.interrupted = !0), t.simple || (this.simple = !1), Ll(this), this
                }, e.compare = function (t) {
                    var e, i, r, n, a, s, o, l, c = t.idLookup,
                        u = this.idLookup,
                        h = [],
                        d = [],
                        p = [],
                        f = [],
                        m = [],
                        g = t.alt,
                        v = this.alt,
                        y = function (t, e, i) {
                            return (t.isVisible !== e.isVisible ? t.isVisible ? p : f : t.isVisible ? d : h).push(i) && m.push(i)
                        },
                        b = function (t, e, i) {
                            return m.indexOf(i) < 0 && y(t, e, i)
                        };
                    for (r in c) a = g[r], s = v[r], n = (e = a ? xl(t, this, r) : c[r]).element, i = u[r], s ? (l = i.isVisible || !s.isVisible && n === i.element ? i : s, (o = !a || e.isVisible || a.isVisible || l.element !== a.element ? e : a).isVisible && l.isVisible && o.element !== l.element ? ((o.isDifferent(l) ? d : h).push(o.element, l.element), m.push(o.element, l.element)) : y(o, l, o.element), a && o.element === a.element && (a = c[r]), b(o.element !== i.element && a ? a : o, i, i.element), b(a && a.element === s.element ? a : o, s, s.element), a && b(a, s.element === a.element ? s : i, a.element)) : (i ? i.isDifferent(e) ? y(e, i, n) : h.push(n) : p.push(n), a && b(a, i, a.element));
                    for (r in u) c[r] || (f.push(u[r].element), v[r] && f.push(v[r].element));
                    return {
                        changed: d,
                        unchanged: h,
                        enter: p,
                        leave: f
                    }
                }, e.recordInlineStyles = function () {
                    for (var t = Xo[this.props] || Qo, e = this.elementStates.length; e--;) hl(this.elementStates[e], t)
                }, e.interrupt = function (t) {
                    var e = this,
                        i = [];
                    this.targets.forEach((function (r) {
                        var n = r._flip,
                            a = Dl(n, t ? 0 : 1);
                        t && a && i.indexOf(n) < 0 && n.add((function () {
                            return e.updateVisibility()
                        })), a && i.push(n)
                    })), !t && i.length && this.updateVisibility(), this.interrupted || (this.interrupted = !!i.length)
                }, e.updateVisibility = function () {
                    this.elementStates.forEach((function (t) {
                        var e = t.element.getBoundingClientRect();
                        t.isVisible = !!(e.width || e.height || e.top || e.left), t.uncache = 1
                    }))
                }, e.getElementState = function (t) {
                    return this.elementStates[this.targets.indexOf(tl(t))]
                }, e.makeAbsolute = function () {
                    return ul(this.elementStates.slice(0), !0, !0).map(ml)
                }, t
            }(),
            Il = function () {
                function t(t, e, i) {
                    this.element = t, this.update(e, i)
                }
                var e = t.prototype;
                return e.isDifferent = function (t) {
                    var e = this.bounds,
                        i = t.bounds;
                    return e.top !== i.top || e.left !== i.left || e.width !== i.width || e.height !== i.height || !this.matrix.equals(t.matrix) || this.opacity !== t.opacity || this.props && t.props && JSON.stringify(this.props) !== JSON.stringify(t.props)
                }, e.update = function (t, e) {
                    var i, r, n = this,
                        a = n.element,
                        s = No.getProperty(a),
                        o = No.core.getCache(a),
                        l = a.getBoundingClientRect(),
                        c = a.getBBox && "function" == typeof a.getBBox && "svg" !== a.nodeName.toLowerCase() && a.getBBox(),
                        u = e ? new Io(1, 0, 0, 1, l.left + Eo(), l.top + To()) : Ro(a, !1, !1, !0);
                    n.getProp = s, n.element = a, n.id = ((r = (i = a).getAttribute("data-flip-id")) || i.setAttribute("data-flip-id", r = "auto-" + jo++), r), n.matrix = u, n.cache = o, n.bounds = l, n.isVisible = !!(l.width || l.height || l.left || l.top), n.display = s("display"), n.position = s("position"), n.parent = a.parentNode, n.x = s("x"), n.y = s("y"), n.scaleX = o.scaleX, n.scaleY = o.scaleY, n.rotation = s("rotation"), n.skewX = s("skewX"), n.opacity = s("opacity"), n.width = c ? c.width : Vo(s("width", "px"), .04), n.height = c ? c.height : Vo(s("height", "px"), .04), t && function (t, e) {
                        for (var i = No.getProperty(t.element, null, "native"), r = t.props = {}, n = e.length; n--;) r[e[n]] = (i(e[n]) + "").trim();
                        r.zIndex && (r.zIndex = parseFloat(r.zIndex) || 0)
                    }(n, ol[t] || ll(t)), n.ctm = a.getCTM && "svg" === a.nodeName.toLowerCase() && Do(a).inverse(), n.simple = e || 1 === el(u.a) && !el(u.b) && !el(u.c) && 1 === el(u.d), n.uncache = 0
                }, t
            }(),
            Rl = function () {
                function t(t, e) {
                    this.vars = t, this.batch = e, this.states = [], this.timeline = e.timeline
                }
                var e = t.prototype;
                return e.getStateById = function (t) {
                    for (var e = this.states.length; e--;)
                        if (this.states[e].idLookup[t]) return this.states[e]
                }, e.kill = function () {
                    this.batch.remove(this)
                }, t
            }(),
            Fl = function () {
                function t(t) {
                    this.id = t, this.actions = [], this._kill = [], this._final = [], this._abs = [], this._run = [], this.data = {}, this.state = new Ol, this.timeline = No.timeline()
                }
                var e = t.prototype;
                return e.add = function (t) {
                    var e = this.actions.filter((function (e) {
                        return e.vars === t
                    }));
                    return e.length ? e[0] : (e = new Rl("function" == typeof t ? {
                        animate: t
                    } : t, this), this.actions.push(e), e)
                }, e.remove = function (t) {
                    var e = this.actions.indexOf(t);
                    return e >= 0 && this.actions.splice(e, 1), this
                }, e.getState = function (t) {
                    var e = this,
                        i = Bo,
                        r = zo;
                    return Bo = this, this.state.clear(), this._kill.length = 0, this.actions.forEach((function (i) {
                        i.vars.getState && (i.states.length = 0, zo = i, i.state = i.vars.getState(i)), t && i.states.forEach((function (t) {
                            return e.state.add(t)
                        }))
                    })), zo = r, Bo = i, this.killConflicts(), this
                }, e.animate = function () {
                    var t, e, i = this,
                        r = Bo,
                        n = this.timeline,
                        a = this.actions.length;
                    for (Bo = this, n.clear(), this._abs.length = this._final.length = this._run.length = 0, this.actions.forEach((function (t) {
                        t.vars.animate && t.vars.animate(t);
                        var e, i, r = t.vars.onEnter,
                            n = t.vars.onLeave,
                            a = t.targets;
                        a && a.length && (r || n) && (e = new Ol, t.states.forEach((function (t) {
                            return e.add(t)
                        })), (i = e.compare(Nl.getState(a))).enter.length && r && r(i.enter), i.leave.length && n && n(i.leave))
                    })), vl(this._abs), this._run.forEach((function (t) {
                        return t()
                    })), e = n.duration(), t = this._final.slice(0), n.add((function () {
                        e <= n.time() && (t.forEach((function (t) {
                            return t()
                        })), Go(i, "onComplete"))
                    })), Bo = r; a--;) this.actions[a].vars.once && this.actions[a].kill();
                    return Go(this, "onStart"), n.restart(), this
                }, e.loadState = function (t) {
                    t || (t = function () {
                        return 0
                    });
                    var e = [];
                    return this.actions.forEach((function (i) {
                        if (i.vars.loadState) {
                            var r, n = function n(a) {
                                a && (i.targets = a), ~(r = e.indexOf(n)) && (e.splice(r, 1), e.length || t())
                            };
                            e.push(n), i.vars.loadState(n)
                        }
                    })), e.length || t(), this
                }, e.setState = function () {
                    return this.actions.forEach((function (t) {
                        return t.targets = t.vars.setState && t.vars.setState(t)
                    })), this
                }, e.killConflicts = function (t) {
                    return this.state.interrupt(t), this._kill.forEach((function (e) {
                        return e.interrupt(t)
                    })), this
                }, e.run = function (t, e) {
                    var i = this;
                    return this !== Bo && (t || this.getState(e), this.loadState((function () {
                        i._killed || (i.setState(), i.animate())
                    }))), this
                }, e.clear = function (t) {
                    this.state.clear(), t || (this.actions.length = 0)
                }, e.getStateById = function (t) {
                    for (var e, i = this.actions.length; i--;)
                        if (e = this.actions[i].getStateById(t)) return e;
                    return this.state.idLookup[t] && this.state
                }, e.kill = function () {
                    this._killed = 1, this.clear(), delete Ho[this.id]
                }, t
            }(),
            Nl = function () {
                function t() { }
                return t.getState = function (e, i) {
                    var r = kl(e, i);
                    return zo && zo.states.push(r), i && i.batch && t.batch(i.batch).state.add(r), r
                }, t.from = function (t, e) {
                    return "clearProps" in (e = e || {}) || (e.clearProps = !0), Cl(t, kl(e.targets || t.targets, {
                        props: e.props || t.props,
                        simple: e.simple,
                        kill: !!e.kill
                    }), e, -1)
                }, t.to = function (t, e) {
                    return Cl(t, kl(e.targets || t.targets, {
                        props: e.props || t.props,
                        simple: e.simple,
                        kill: !!e.kill
                    }), e, 1)
                }, t.fromTo = function (t, e, i) {
                    return Cl(t, e, i)
                }, t.fit = function (t, e, i) {
                    var r = i ? sl(i, nl) : {},
                        n = i || r,
                        a = n.absolute,
                        s = n.scale,
                        o = n.getVars,
                        l = n.props,
                        c = n.runBackwards,
                        u = n.onComplete,
                        h = n.simple,
                        d = i && i.fitChild && tl(i.fitChild),
                        p = bl(e, l, h, t),
                        f = bl(t, 0, h, p),
                        m = l ? Xo[l] : Qo;
                    return l && _l(r, p.props), c && (hl(f, m), "immediateRender" in r || (r.immediateRender = !0), r.onComplete = function () {
                        dl(f), u && u.apply(this, arguments)
                    }), a && ml(f, p), r = Sl(f, p, s || d, l, d, r.duration || o ? r : 0), o ? r : r.duration ? No.to(f.element, r) : null
                }, t.makeAbsolute = function (t, e) {
                    return (t instanceof Ol ? t : new Ol(t, e)).makeAbsolute()
                }, t.batch = function (t) {
                    return t || (t = "default"), Ho[t] || (Ho[t] = new Fl(t))
                }, t.killFlipsOf = function (t, e) {
                    (t instanceof Ol ? t.targets : Fo(t)).forEach((function (t) {
                        return t && Dl(t._flip, !1 !== e ? 1 : 2)
                    }))
                }, t.isFlipping = function (e) {
                    var i = t.getByTarget(e);
                    return !!i && i.isActive()
                }, t.getByTarget = function (t) {
                    return (tl(t) || $o)._flip
                }, t.getElementState = function (t, e) {
                    return new Il(tl(t), e)
                }, t.convertCoordinates = function (t, e, i) {
                    var r = Ro(e, !0, !0).multiply(Ro(t));
                    return i ? r.apply(i) : r
                }, t.register = function (t) {
                    if (qo = "undefined" != typeof document && document.body) {
                        No = t, So(qo), Fo = No.utils.toArray;
                        var e = No.utils.snap(.1);
                        Vo = function (t, i) {
                            return e(parseFloat(t) + i)
                        }
                    }
                }, t
            }();

        function Bl(t) {
            var e = function () {
                if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                if (Reflect.construct.sham) return !1;
                if ("function" == typeof Proxy) return !0;
                try {
                    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], (function () { }))), !0
                } catch (t) {
                    return !1
                }
            }();
            return function () {
                var i, r = f(t);
                if (e) {
                    var n = f(this).constructor;
                    i = Reflect.construct(r, arguments, n)
                } else i = r.apply(this, arguments);
                return p(this, i)
            }
        }
        Nl.version = "3.11.4", "undefined" != typeof window && window.gsap && window.gsap.registerPlugin(Nl);
        var zl = function (t) {
            h(i, t);
            var e = Bl(i);

            function i() {
                var t;
                return n(this, i), (t = e.call(this)).thumbnail = t.querySelector(".thumbnail"), t.originalContainer = t.querySelector(".start"), t.open = !1, t.bg = t.querySelector(".bg"), t.productCard = t.querySelector(".product"), t.stage = t.querySelector(".stage"), t.thumbnail && t.init(), t
            }
            return l(i, [{
                key: "init",
                value: function () {
                    Cn.registerPlugin(Nl), this.thumbnail.addEventListener("click", this.toggleWindow.bind(this)), this.bg.addEventListener("click", this.toggleWindow.bind(this))
                }
            }, {
                key: "toggleWindow",
                value: function () {
                    var t = this;
                    this.start = Nl.getState(this.thumbnail), this.thumbnail.parentNode === this.originalContainer ? (this.stage.appendChild(this.thumbnail), this.parentElement.parentElement.style = "z-index: 11", this.style = "z-index: 99;", this.bg.classList.remove("pointer-events-none"), this.bg.style.zIndex = 3, this.fadeInBg(), this.open = !0) : (this.originalContainer.appendChild(this.thumbnail), this.parentElement.parentElement.style = "z-index: 10", this.style = "z-index: 1;", this.bg.classList.add("pointer-events-none"), this.bg.style.zIndex = 0, Cn.to(this.productCard, {
                        opacity: "0"
                    }), this.fadeOutBg(), this.open = !1), Nl.from(this.start, {
                        duration: .5,
                        onComplete: this.open ? function () {
                            Cn.to(t.productCard, {
                                opacity: "1"
                            })
                        } : function () { }
                    })
                }
            }, {
                key: "fadeInBg",
                value: function () {
                    Cn.to(this.bg, {
                        opacity: "1"
                    })
                }
            }, {
                key: "fadeOutBg",
                value: function () {
                    Cn.to(this.bg, {
                        opacity: "0"
                    })
                }
            }]), i
        }(Hn(HTMLElement));

        function ql(t) {
            var e = function () {
                if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                if (Reflect.construct.sham) return !1;
                if ("function" == typeof Proxy) return !0;
                try {
                    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], (function () { }))), !0
                } catch (t) {
                    return !1
                }
            }();
            return function () {
                var i, r = f(t);
                if (e) {
                    var n = f(this).constructor;
                    i = Reflect.construct(r, arguments, n)
                } else i = r.apply(this, arguments);
                return p(this, i)
            }
        }
        var Vl = function (t) {
            h(i, t);
            var e = ql(i);

            function i() {
                var t;
                return n(this, i), (t = e.call(this)).swap = !0, t.products = t.querySelectorAll("[data-product-id]"), t.section = document.getElementById("shopify-section-".concat(t.dataset.section)), t.sectionsToRender = document.querySelectorAll(".pdp-async"), t.swap && t.products.forEach((function (e) {
                    e.classList.contains("notify-reload") || t.bindSwap(e)
                })), t
            }
            return l(i, [{
                key: "bindSwap",
                value: function (t) {
                    t.addEventListener("click", this.swapEvent.bind(this), !1)
                }
            }, {
                key: "swapEvent",
                value: function (t) {
                    var e = this;
                    t.preventDefault();

                    var link = t.target.closest("a");
                    if (!link) return;

                    var url = link.href;
                    var isSpecial = link.getAttribute("data-history-state") === "true";
                    var saveUrl = link.getAttribute("data-history-save-url") === "true";

                    var hasVisitedSpecial = sessionStorage.getItem("hasVisitedSpecial") === "true";

                    if (isSpecial) {
                        sessionStorage.setItem("hasVisitedSpecial", "true");
                        sessionStorage.setItem("currentIsSpecial", "true");
                    } else {
                        sessionStorage.setItem("currentIsSpecial", "false");
                    }

                    if (!isSpecial && !saveUrl) {
                        sessionStorage.setItem("PreviusPDPUrl", url);
                    }

                    this.sectionsToRender.forEach(function (section) {
                        var id = section.id.replace("shopify-section-", "");

                        fetch(url + "?section_id=" + id)
                            .then(function (res) { return res.text(); })
                            .then(function (html) {
                                var parsed = new DOMParser()
                                    .parseFromString(html, "text/html")
                                    .getElementById(section.id);

                                if (parsed) {
                                    section.innerHTML = parsed.innerHTML;
                                    window.Zero && window.Zero.applyInternationalValueProps && window.Zero.applyInternationalValueProps();
                                }
                            });
                    });

                    var usePushState = isSpecial || hasVisitedSpecial;
                    this.updateUrl(url, isSpecial, usePushState);

                    window.Zero.lazyLoad.update();
                }
            },
            {
                key: "updateUrl",
                value: function (url, isSpecial, usePushState) {
                    if (usePushState) {
                        window.history.pushState({ spa: true, isSpecial: isSpecial }, "", url);
                    } else {
                        window.history.replaceState({ spa: true, isSpecial: false }, "", url);
                    }
                }
            },
            {
                key: "onHistoryChange",
                value: function (event) {
                    console.log("POPSTATE →", event);

                    var PreviusPage = sessionStorage.getItem("PreviusPage");
                    var PreviusPDPUrl = sessionStorage.getItem("PreviusPDPUrl");
                    var currentIsSpecial = sessionStorage.getItem("currentIsSpecial") === "true";

                    if (currentIsSpecial) {
                        window.location.href = PreviusPDPUrl || "/";
                    } else {
                        window.location.href = PreviusPage || "/";
                    }
                }
            },
            {
                key: "disconnectedCallback",
                value: function () {
                    if (this._onHistoryChange) {
                        window.removeEventListener("popstate", this._onHistoryChange);
                    }
                }
            }


            ]), i
        }(Ys);

        function Yl(t) {
            var e = function () {
                if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                if (Reflect.construct.sham) return !1;
                if ("function" == typeof Proxy) return !0;
                try {
                    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], (function () { }))), !0
                } catch (t) {
                    return !1
                }
            }();
            return function () {
                var i, r = f(t);
                if (e) {
                    var n = f(this).constructor;
                    i = Reflect.construct(r, arguments, n)
                } else i = r.apply(this, arguments);
                return p(this, i)
            }
        }
        var jl = function (t) {
            h(i, t);
            var e = Yl(i);

            function i() {
                var t;
                return n(this, i), (t = e.call(this)).targetId = t.dataset.target, t.button = t.querySelector("button"), t.overlay = document.getElementById(t.targetId), t.open = !1, t.overlay ? (t.close = t.overlay.querySelectorAll("[data-close]"), t.button.addEventListener("click", t.toggleOpen.bind(d(t))), t.overlay.addEventListener("click", t.toggleOpen.bind(d(t))), t.fadeEl = t.overlay.querySelector(".fade-el"), t.slideEl = t.overlay.querySelector(".slide-el"), t) : p(t)
            }
            return l(i, [{
                key: "toggleOpen",
                value: function (t) {
                    var e = t.target;
                    if (e == this || e.parentElement == this || null != e.dataset.close) {
                        if (t.stopPropagation(), !1 === this.open) return Cn.to(this.fadeEl, {
                            duration: .3,
                            autoAlpha: 1
                        }), Cn.to(this.slideEl, {
                            duration: .3,
                            x: 0
                        }), void (this.open = !0);
                        Cn.to(this.fadeEl, {
                            duration: .3,
                            autoAlpha: 0
                        }), Cn.to(this.slideEl, {
                            duration: .3,
                            x: "100%"
                        }), this.open = !1
                    }
                }
            }]), i
        }(Hn(HTMLElement));

        function Gl(t) {
            var e = function () {
                if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                if (Reflect.construct.sham) return !1;
                if ("function" == typeof Proxy) return !0;
                try {
                    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], (function () { }))), !0
                } catch (t) {
                    return !1
                }
            }();
            return function () {
                var i, r = f(t);
                if (e) {
                    var n = f(this).constructor;
                    i = Reflect.construct(r, arguments, n)
                } else i = r.apply(this, arguments);
                return p(this, i)
            }
        }
        var Hl = function (t) {
            h(i, t);
            var e = Gl(i);

            function i() {
                var t;
                return n(this, i), (t = e.call(this)).trigger = t.querySelector(".hover-trigger"), t.tooltip = t.querySelector(".tooltip-el"), t.init(), t
            }
            return l(i, [{
                key: "init",
                value: function () {
                    this.trigger.addEventListener("mouseenter", this.showTooltip.bind(this)), this.addEventListener("mouseleave", this.hideTooltip.bind(this))
                }
            }, {
                key: "showTooltip",
                value: function () {
                    Cn.to(this.tooltip, {
                        y: "1rem",
                        autoAlpha: 1,
                        duration: .25,
                        pointerEvents: "auto"
                    })
                }
            }, {
                key: "hideTooltip",
                value: function (t) {
                    console.log(t.target, t.relatedTarget), Cn.to(this.tooltip, {
                        y: "0",
                        autoAlpha: 0,
                        duration: .25,
                        pointerEvents: "none"
                    })
                }
            }]), i
        }(aa);

        function Wl(t) {
            var e = function () {
                if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                if (Reflect.construct.sham) return !1;
                if ("function" == typeof Proxy) return !0;
                try {
                    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], (function () { }))), !0
                } catch (t) {
                    return !1
                }
            }();
            return function () {
                var i, r = f(t);
                if (e) {
                    var n = f(this).constructor;
                    i = Reflect.construct(r, arguments, n)
                } else i = r.apply(this, arguments);
                return p(this, i)
            }
        }
        var Zl = function (t) {
            h(i, t);
            var e = Wl(i);

            function i() {
                var t;
                return n(this, i), (t = e.call(this)).playBtn = t.querySelector(".play-btn"), t.videoEl = t.querySelector("video"), t.init(), t
            }
            return l(i, [{
                key: "init",
                value: function () {
                    this.playBtn.addEventListener("click", this.play.bind(this)), this.videoEl.addEventListener("click", this.pause.bind(this))
                }
            }, {
                key: "play",
                value: function () {
                    console.log(this.videoEl.paused), this.videoEl.play(), Cn.to(this.playBtn, {
                        opacity: 0
                    }), this.playBtn.classList.add("pointer-events-none")
                }
            }, {
                key: "pause",
                value: function () {
                    this.videoEl.pause(), Cn.to(this.playBtn, {
                        opacity: 1
                    }), this.playBtn.classList.remove("pointer-events-none")
                }
            }]), i
        }(aa);

        function $l(t) {
            var e = function () {
                if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                if (Reflect.construct.sham) return !1;
                if ("function" == typeof Proxy) return !0;
                try {
                    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], (function () { }))), !0
                } catch (t) {
                    return !1
                }
            }();
            return function () {
                var i, r = f(t);
                if (e) {
                    var n = f(this).constructor;
                    i = Reflect.construct(r, arguments, n)
                } else i = r.apply(this, arguments);
                return p(this, i)
            }
        }
        var Ul = function (t) {
            h(i, t);
            var e = $l(i);

            function i() {
                var t;
                return n(this, i), (t = e.call(this)).hoverEl = t.querySelector(".main-img-video"), t.videoWrap = t.querySelector(".video"), t.video = t.videoWrap.querySelector("video"), t.init(), t
            }
            return l(i, [{
                key: "init",
                value: function () {
                    this.hoverEl.addEventListener("mouseenter", this.play.bind(this)), this.hoverEl.addEventListener("mouseleave", this.pause.bind(this))
                }
            }, {
                key: "play",
                value: function () {
                    console.log("play"), Cn.to(this.videoWrap, {
                        opacity: 1
                    }), this.video.play()
                }
            }, {
                key: "pause",
                value: function () {
                    console.log("pause"), Cn.to(this.videoWrap, {
                        opacity: 0
                    }), this.video.pause()
                }
            }]), i
        }(aa);

        function Xl(t) {
            var e = function () {
                if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                if (Reflect.construct.sham) return !1;
                if ("function" == typeof Proxy) return !0;
                try {
                    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], (function () { }))), !0
                } catch (t) {
                    return !1
                }
            }();
            return function () {
                var i, r = f(t);
                if (e) {
                    var n = f(this).constructor;
                    i = Reflect.construct(r, arguments, n)
                } else i = r.apply(this, arguments);
                return p(this, i)
            }
        }
        var Kl = function (t) {
            h(i, t);
            var e = Xl(i);

            function i() {
                var t;
                return n(this, i), (t = e.call(this)).btn = t.querySelector('[data-widget="btn"'), t.card = t.querySelector('[data-widget="card"'), t.text = t.querySelector('[data-widget="text"'), t.plus = t.querySelector('[data-widget="plus"'), t.svg = t.querySelector('[data-widget="svg"]'), t.hoverState = t.getAttribute("data-hover"), t.init(), t
            }
            return l(i, [{
                key: "init",
                value: function () {
                    Cn.registerPlugin(Nl), "true" === this.hoverState && (this.btn.addEventListener("mouseenter", this.hoverBtn.bind(this)), this.btn.addEventListener("mouseleave", this.hoverBtn.bind(this))), this.btn.addEventListener("click", this.toggleCard.bind(this))
                }
            }, {
                key: "hoverBtn",
                value: function () {
                    var t = this;
                    this.start = Nl.getState(this.btn), this.btn.classList.contains("active") && !this.card.classList.contains("active") ? (this.btn.classList.remove("active"), this.text.style = "display: none;") : this.card.classList.contains("active") || (this.text.style = "display: inline;", this.btn.classList.add("active")), Nl.from(this.start, {
                        duration: .3,
                        onComplete: this.btn.classList.contains("active") && !this.card.classList.contains("active") ? function () {
                            Cn.to(t.text, {
                                opacity: "1"
                            })
                        } : function () { }
                    })
                }
            }, {
                key: "toggleCard",
                value: function () {
                    this.card.classList.contains("active") ? (Cn.to(this.card, {
                        height: 0,
                        pointerEvents: "none"
                    }), this.card.classList.remove("active"), Cn.to(this.plus, {
                        rotate: "0deg",
                        transformOrigin: "center"
                    })) : (Cn.to(this.card, {
                        height: this.card.firstElementChild.offsetHeight,
                        pointerEvents: "auto"
                    }), Cn.to(this.plus, {
                        rotate: "45deg",
                        transformOrigin: "center"
                    }), this.card.classList.add("active"))
                }
            }]), i
        }(Hn(HTMLElement));

        function Jl(t) {
            var e = function () {
                if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                if (Reflect.construct.sham) return !1;
                if ("function" == typeof Proxy) return !0;
                try {
                    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], (function () { }))), !0
                } catch (t) {
                    return !1
                }
            }();
            return function () {
                var i, r = f(t);
                if (e) {
                    var n = f(this).constructor;
                    i = Reflect.construct(r, arguments, n)
                } else i = r.apply(this, arguments);
                return p(this, i)
            }
        }
        var Ql = function (t) {
            h(i, t);
            var e = Jl(i);

            function i() {
                var t;
                return n(this, i), (t = e.call(this)).marqueeWrapper = t.querySelector(".marquee-wrapper"), t.marqueeText = t.querySelector(".marquee-text"), t.init(), t
            }
            return l(i, [{
                key: "init",
                value: function () {
                    var t = this,
                        e = 0;
                    this.getAttribute("data-loop") && (e = this.marqueeText.offsetWidth), console.log("Offset for marquee", e);
                    const duplications = 20;
                    this.marqueeWrapper.innerHTML = "";
                    for (let j = 0; j < duplications; j++) {
                        const textClone = this.marqueeText.cloneNode(!0);
                        this.marqueeWrapper.appendChild(textClone)
                    }
                    window.Zero && window.Zero.lazyLoad && window.Zero.lazyLoad.update(), this.marqueeWrapper.classList.add("marquee-translate"), this.marqueeWrapper.addEventListener("transitionend", (function () {
                        var e = t.marqueeWrapper;
                        window.requestAnimationFrame((function () {
                            e.classList.remove("marquee-translate"), window.requestAnimationFrame((function () {
                                e.classList.add("marquee-translate")
                            }))
                        }))
                    }))
                }
            }]), i
        }(Hn(HTMLElement)),
            tc = i(8),
            ec = i.n(tc);

        function ic(t) {
            var e = function () {
                if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                if (Reflect.construct.sham) return !1;
                if ("function" == typeof Proxy) return !0;
                try {
                    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], (function () { }))), !0
                } catch (t) {
                    return !1
                }
            }();
            return function () {
                var i, r = f(t);
                if (e) {
                    var n = f(this).constructor;
                    i = Reflect.construct(r, arguments, n)
                } else i = r.apply(this, arguments);
                return p(this, i)
            }
        }
        var rc = function (t) {
            h(i, t);
            var e = ic(i);

            function i() {
                var t;
                return n(this, i), t = e.call(this), ec().tz.setDefault("America/Los_Angeles"), t.currentDate = (new (ec())).valueOf(), t.targetHour = parseInt(t.dataset.targetHour, 10), t.targetDate = new (ec())(t.dataset.targetDate).add(t.targetHour, "hours").valueOf(), t.currentDate > t.targetDate ? p(t) : (t.days = null, t.hours = null, t.minutes = null, t.seconds = null, document.querySelector("#global-announcements").remove(), t.style.display = "block", document.querySelector("#pencil-wrapper").classList.add("has-countdown-clock"), Cn.set("#shopify-section-navigation", {
                    top: "60px"
                }), Cn.set("#fixed-announcement-bar", {
                    height: "60px"
                }), Cn.set(".countdown-richtext", {
                    display: "block"
                }), t.container = document.createElement("div"), t.container.id = "countdown", t.tiles = document.createElement("div"), t.tiles.id = "tiles", t.container.appendChild(t.tiles), t.labels = document.createElement("div"), t.labels.classList.add("labels"), t.daysLabel = document.createElement("li"), t.daysLabel.innerHTML = "Days", t.labels.appendChild(t.daysLabel), t.hoursLabel = document.createElement("li"), t.hoursLabel.innerHTML = "Hr", t.labels.appendChild(t.hoursLabel), t.minLabel = document.createElement("li"), t.minLabel.innerHTML = "Min", t.labels.appendChild(t.minLabel), t.secLabel = document.createElement("li"), t.secLabel.innerHTML = "Sec", t.labels.appendChild(t.secLabel), t.container.appendChild(t.labels), t.appendChild(t.container), t.init(), t)
            }
            return l(i, [{
                key: "init",
                value: function () {
                    var t = this;
                    this.getCountdown(), setInterval((function () {
                        return t.getCountdown()
                    }), 1e3)
                }
            }, {
                key: "getCountdown",
                value: function () {
                    this.currentDate = (new (ec())).tz("America/Los_Angeles").valueOf();
                    var t = (this.targetDate - this.currentDate) / 1e3;
                    this.days = this.pad(parseInt(t / 86400)), t %= 86400, this.hours = this.pad(parseInt(t / 3600)), t %= 3600, this.minutes = this.pad(parseInt(t / 60)), this.seconds = this.pad(parseInt(t % 60)), this.tiles.innerHTML = "<span>" + this.days + "</span><span>" + this.hours + "</span><span>" + this.minutes + "</span><span>" + this.seconds + "</span>"
                }
            }, {
                key: "pad",
                value: function (t) {
                    return (t < 10 ? "0" : "") + t
                }
            }]), i
        }(Hn(HTMLElement));

        function nc(t) {
            var e = function () {
                if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                if (Reflect.construct.sham) return !1;
                if ("function" == typeof Proxy) return !0;
                try {
                    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], (function () { }))), !0
                } catch (t) {
                    return !1
                }
            }();
            return function () {
                var i, r = f(t);
                if (e) {
                    var n = f(this).constructor;
                    i = Reflect.construct(r, arguments, n)
                } else i = r.apply(this, arguments);
                return p(this, i)
            }
        }
        var ac = function (t) {
            h(i, t);
            var e = nc(i);

            function i() {
                var t;
                return n(this, i), (t = e.call(this)).usaBtn = t.querySelector('[data-on-click="usa"]'), t.intlBtn = t.querySelector('[data-on-click="intl"]'), t.bar = t.querySelector("#shipping-tracker-bar"), t.usaThreshold = t.dataset.usa, t.intlThreshold = t.dataset.intl, t.usaBtn.addEventListener("click", t.toggleUSA.bind(d(t))), t.intlBtn.addEventListener("click", t.toggleIntl.bind(d(t))), t.diffDisplay = t.querySelector(".display-difference"), t
            }
            return l(i, [{
                key: "toggleIntl",
                value: function () {
                    Cn.set(this.intlBtn, {
                        color: "white",
                        background: "#1e1e1e"
                    }), Cn.set(this.usaBtn, {
                        color: "#1e1e1e",
                        background: "white"
                    }), this.bar.dataset.threshold = this.intlThreshold;
                    var t = parseInt(this.bar.dataset.threshold, 10),
                        e = parseInt(this.bar.dataset.total, 10),
                        i = t - e;
                    i <= 0 ? this.showSuccessState() : (this.querySelector(".amount-tracker").classList.remove("hidden"), this.querySelector(".success-state").classList.add("hidden"), this.diffDisplay.innerHTML = "$".concat((i / 100).toFixed(2)), this.bar.style.width = "".concat(e / t * 100, "%"))
                }
            }, {
                key: "toggleUSA",
                value: function () {
                    Cn.set(this.usaBtn, {
                        color: "white",
                        background: "#1e1e1e"
                    }), Cn.set(this.intlBtn, {
                        color: "#1e1e1e",
                        background: "white"
                    }), this.bar.dataset.threshold = this.usaThreshold;
                    var t = parseInt(this.bar.dataset.threshold, 10),
                        e = parseInt(this.bar.dataset.total, 10),
                        i = t - e;
                    i <= 0 ? this.showSuccessState() : (this.querySelector(".amount-tracker").classList.remove("hidden"), this.querySelector(".success-state").classList.add("hidden"), this.diffDisplay.innerHTML = "$".concat((i / 100).toFixed(2)), this.bar.style.width = "".concat(e / t * 100, "%"))
                }
            }, {
                key: "showSuccessState",
                value: function () {
                    this.querySelector(".amount-tracker").classList.add("hidden"), this.querySelector(".success-state").classList.remove("hidden")
                }
            }]), i
        }(Hn(HTMLElement));

        function sc(t) {
            var e = function () {
                if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                if (Reflect.construct.sham) return !1;
                if ("function" == typeof Proxy) return !0;
                try {
                    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], (function () { }))), !0
                } catch (t) {
                    return !1
                }
            }();
            return function () {
                var i, r = f(t);
                if (e) {
                    var n = f(this).constructor;
                    i = Reflect.construct(r, arguments, n)
                } else i = r.apply(this, arguments);
                return p(this, i)
            }
        }
        var oc = function (t) {
            t.preventDefault()
        },
            lc = function (t) {
                h(i, t);
                var e = sc(i);

                function i() {
                    var t;
                    return n(this, i), (t = e.call(this)).thumbnail = t.querySelector(".thumbnail"), t.originalContainer = t.querySelector(".start"), t.open = !1, t.bg = t.querySelector(".bg"), t.productCard = t.querySelector(".product"), t.closeBtn = t.querySelector(".close-btn"), t.stage = t.querySelector(".stage"), document.body.appendChild(t.bg), t.thumbnail && t.init(), t
                }
                return l(i, [{
                    key: "init",
                    value: function () {
                        Cn.registerPlugin(Nl), this.thumbnail.addEventListener("click", this.toggleWindow.bind(this)), this.bg.addEventListener("click", this.toggleWindow.bind(this)), this.bg.addEventListener("pointermove", oc), this.bg.addEventListener("touchmove", oc), this.closeBtn && this.closeBtn.addEventListener("click", this.toggleWindow.bind(this))
                    }
                }, {
                    key: "toggleWindow",
                    value: function (t) {
                        var e = this;
                        console.log(t.target, t.target.tagName), (!this.open || "VIDEO" != t.target.tagName && "IMG" != t.target.tagName) && (this.start = Nl.getState(this.thumbnail), this.thumbnail.parentNode === this.originalContainer && 0 == this.open ? (this.stage.appendChild(this.thumbnail), this.bg.classList.remove("pointer-events-none"), this.fadeInBg(), this.open = !0) : (this.originalContainer.appendChild(this.thumbnail), this.bg.classList.add("pointer-events-none"), Cn.to(this.productCard, {
                            opacity: "0"
                        }), this.closeBtn && Cn.to(this.closeBtn, {
                            opacity: "0",
                            pointerEvents: "none"
                        }), this.fadeOutBg(), this.open = !1), Nl.from(this.start, {
                            duration: .5,
                            onComplete: this.open ? function () {
                                Cn.to(e.productCard, {
                                    opacity: "1"
                                }), e.closeBtn && Cn.to(e.closeBtn, {
                                    opacity: "1",
                                    pointerEvents: "auto"
                                })
                            } : function () { }
                        }))
                    }
                }, {
                    key: "fadeInBg",
                    value: function () {
                        Cn.to(this.bg, {
                            opacity: "1"
                        })
                    }
                }, {
                    key: "fadeOutBg",
                    value: function () {
                        Cn.to(this.bg, {
                            opacity: "0"
                        })
                    }
                }]), i
            }(Hn(HTMLElement));

        function cc(t) {
            var e = function () {
                if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                if (Reflect.construct.sham) return !1;
                if ("function" == typeof Proxy) return !0;
                try {
                    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], (function () { }))), !0
                } catch (t) {
                    return !1
                }
            }();
            return function () {
                var i, r = f(t);
                if (e) {
                    var n = f(this).constructor;
                    i = Reflect.construct(r, arguments, n)
                } else i = r.apply(this, arguments);
                return p(this, i)
            }
        }
        var uc = function (t) {
            h(i, t);
            var e = cc(i);

            function i() {
                var t;
                return n(this, i), (t = e.call(this)).length = 4, t.store = JSON.parse(localStorage.getItem("recentlyViewed")) || [], t.targetEl = t.querySelector('[data-id="cards-container"]'), t.emptyState = t.querySelector('[data-id="empty-state"]'), t.cardWrapper = t.querySelector('[data-id="card-setter"]'), t.currentProductId = t.dataset.currentProduct, t.init(), t
            }
            return l(i, [{
                key: "addProduct",
                value: function () {
                    this.store.unshift({
                        id: this.currentProductId,
                        card: this.cardWrapper.innerHTML
                    }), this.store.length > this.length && this.store.pop(), localStorage.setItem("recentlyViewed", JSON.stringify(this.store))
                }
            }, {
                key: "init",
                value: function () {
                    var t = this;
                    if (null === this.store || 0 === this.store.length) this.emptyState.style.display = "flex", "" !== this.currentProductId && this.addProduct();
                    else if (this.store && this.store.length > 0) {
                        for (var e = 0; e < (window.Zero.windowWidth <= 768 ? this.dataset.show : this.length); e++) this.store[e] && this.store[e].id !== this.currentProductId && (this.targetEl.innerHTML += '<div class="col-span-6 dk:col-span-3">'.concat(this.store[e].card, "</div>"));
                        "" === this.targetEl.innerHTML ? this.emptyState.style.display = "flex" : this.targetEl.style.display = "grid", window.Zero.lazyLoad.update(), "" === this.currentProductId || this.store.find((function (e) {
                            return e.id === t.currentProductId
                        })) || this.addProduct()
                    }
                }
            }]), i
        }(aa);
        const hc = uc;
        var dc = function () {
            function t() {
                n(this, t)
            }
            return l(t, [{
                key: "init",
                value: function () {
                    window.Zero = window.Zero || {}, window.Zero.Currency = {
                        rate: window.Shopify && window.Shopify.currency ? window.Shopify.currency.rate : 1,
                        locale: window.Shopify && window.Shopify.currency ? window.Shopify.currency.active : "USD"
                    }, window.Zero.Intl = new Intl.NumberFormat(void 0, {
                        style: "currency",
                        currency: window.Zero.Currency.locale
                    }), customElements.define("carousel-wrapper", Ms), customElements.define("nav-menu", ao), customElements.define("predictive-search", lo), customElements.define("announcement-bar", pa), customElements.define("slot-minicart", ra), customElements.define("cart-wrapper", Un), customElements.define("cart-item", Xn), customElements.define("cart-remove", Kn), customElements.define("variant-selects", ta), customElements.define("variant-radios", ea), customElements.define("quantity-input", Qn), customElements.define("product-form", Zn), customElements.define("product-types", Vl), customElements.define("tabs-wrap", oa), customElements.define("accordion-tab", ca), customElements.define("accordion-group", ua), customElements.define("accordion-navigation", ha), customElements.define("localization-form", Xs), customElements.define("favorite-button", Ns), customElements.define("favorites-check", Bs), customElements.define("favorites-count", qs), customElements.define("favorites-grid", zs), customElements.define("filter-form", Hs), customElements.define("filter-remove", Zs), customElements.define("toggle-filters", $s), customElements.define("lottie-file", to), customElements.define("modal-overlay", io), customElements.define("drawer-overlay", Ls), customElements.define("quickshop-trigger", jl), customElements.define("paginate-grid", _o), customElements.define("picture-in-picture", zl), customElements.define("two-col-pip", lc), customElements.define("product-widget", Kl), customElements.define("clipboard-copy", Ps), customElements.define("tool-tip", Hl), customElements.define("video-wrapper", Zl), customElements.define("video-card", Ul), customElements.define("simple-marquee", Ql), customElements.define("countdown-clock", rc), customElements.define("shipping-tracker", ac), customElements.define("recently-viewed", hc),
                        function () {
                            window.Zero = window.Zero || {}, window.Zero.Cart = window.Zero.Cart || {};
                            var t = {
                                set: function (t, e, i) {
                                    return t[e] = i, "count" === e && A(i), "discount" === e && k("[data-display-discount]", window.Zero.Intl.format(i * window.Zero.Currency.rate / 100)), "subtotal" === e && k("[data-display-subtotal]", window.Zero.Intl.format(i * window.Zero.Currency.rate / 100)), "total" === e && k("[data-display-total]", window.Zero.Intl.format(i * window.Zero.Currency.rate / 100)), "shipping" === e && S(i), !0
                                }
                            };
                            window.Zero.Cart.stats = {
                                count: 0,
                                discount: 0,
                                subtotal: 0,
                                total: 0,
                                shipping: 0
                            }, window.Zero.Cart.stats = new Proxy(window.Zero.Cart.stats, t), b()
                        }()
                }
            }]), t
        }(),
            pc = /iPhone/i,
            fc = /iPod/i,
            mc = /iPad/i,
            gc = /\biOS-universal(?:.+)Mac\b/i,
            vc = /\bAndroid(?:.+)Mobile\b/i,
            yc = /Android/i,
            bc = /(?:SD4930UR|\bSilk(?:.+)Mobile\b)/i,
            _c = /Silk/i,
            wc = /Windows Phone/i,
            Ac = /\bWindows(?:.+)ARM\b/i,
            Sc = /BlackBerry/i,
            kc = /BB10/i,
            xc = /Opera Mini/i,
            Tc = /\b(CriOS|Chrome)(?:.+)Mobile/i,
            Ec = /Mobile(?:.+)Firefox\b/i,
            Mc = function (t) {
                return void 0 !== t && "MacIntel" === t.platform && "number" == typeof t.maxTouchPoints && t.maxTouchPoints > 1 && "undefined" == typeof MSStream
            };
        var Cc;
        document.addEventListener("DOMContentLoaded", (function () {
            window.Zero = window.Zero || {}, window.Zero.lazyLoad.update();
            try {
                window.Zero.queryParams = (() => {
                    if (window.location.search && "" != window.location.search) return JSON.parse('{"' + decodeURI(window.location.search.substring(1)).replace(/"/g, '\\"').replace(/&/g, '","').replace(/=/g, '":"') + '"}')
                })()
            } catch (t) {
                window.Zero.queryParams = void 0
            }
            window.Zero.windowHeight = js().height, window.Zero.windowWidth = js().width;
            var t = .01 * js().height;
            document.body.style.setProperty("--vh", "".concat(t, "px")), window.Zero.animation.init(), window.Zero.components.init(), window.Zero.page.init(), window.Zero.dispatches = {
                animate: new Event("animate"),
                history: new Event("history"),
                resized: new Event("resized"),
                enter: new Event("viewportEnter"),
                exit: new Event("viewportExit")
            }, window.Zero.events.animate = window.Zero.events.animate || [], window.Zero.events.history = window.Zero.events.history || [], window.Zero.events.resized = window.Zero.events.resized || [], window.Zero.events.observed = window.Zero.events.observed || [];
            var e = (new (ec())).tz("America/Los_Angeles").hour();
            window.Zero = window.Zero || {}, window.Zero.applyInternationalValueProps = window.Zero.applyInternationalValueProps || function (t) {
                t && (window.Zero.customerCountryCode = t);
                if ("US" !== window.Zero.customerCountryCode) {
                    document.querySelector("#in-store-pickup") && (document.querySelector("#in-store-pickup").style.display = "none");
                    var e = document.querySelectorAll(".us-content");
                    e.length > 0 && e.forEach((function (t) {
                        t.style.display = "none"
                    }));
                    var i = document.querySelectorAll(".intl-content");
                    i.length > 0 && i.forEach((function (t) {
                        var e = t.querySelector(".value-prop-tooltip-inline"),
                            i = t.querySelector("p:last-of-type");
                        e && i && i.appendChild(e), t.classList.contains("value-prop-copy-inner--two-lines-intl") ? (t.style.display = "inline-block", t.classList.add("value-prop-copy-inner--intl-two-lines-active"), t.closest(".value-prop-copy-wrap") && t.closest(".value-prop-copy-wrap").classList.add("value-prop-copy-wrap--intl-two-lines-active")) : t.style.display = "block"
                    }));
                    var r = document.querySelectorAll(".us-only");
                    r.length > 0 && r.forEach((function (t) {
                        t.style.display = "none"
                    }))
                }
            };
            e >= 11 && e <= 17 && (document.querySelector("#live-chat").classList.add("active"), document.querySelector("#live-chat").addEventListener("click", (function () {
                window.GorgiasChat.open()
            }))), fetch("https://pro.ip-api.com/json/?key=EFQeVib4xuH3gn0", {
                method: "GET"
            }).then((function (t) {
                return t.json()
            })).then((function (t) {
                window.Zero.customerCountryCode = t.countryCode, "US" == t.countryCode ? console.log("United States") : window.Zero.applyInternationalValueProps(t.countryCode)
            }))
        })), window.addEventListener("load", function () {
            window.Zero = window.Zero || {}, window.Zero.scroll = window.Zero.scroll || {}, window.Zero.scroll.current = window.scrollY, window.Zero.scroll.last = null
        }.bind(void 0)), window.addEventListener("resize", function () {
            clearTimeout(Cc), Cc = setTimeout((function () {
                window.Zero = window.Zero || {}, window.Zero.windowHeight = js().height, window.Zero.windowWidth = js().width;
                var t = .01 * js().height;
                document.body.style.setProperty("--vh", "".concat(t, "px")), window.Zero.events.resized.forEach((function (t) {
                    return t.dispatchEvent(window.Zero.dispatches.resized)
                }))
            }), 300)
        }.bind(void 0)), window.addEventListener("scroll", function () {
            window.Zero = window.Zero || {}, window.Zero.scroll = window.Zero.scroll || {}, window.Zero.scroll.current = window.scrollY, null !== window.Zero.scroll.last ? window.Zero.scroll.current !== window.Zero.scroll.last ? (window.Zero.scroll.current > window.Zero.scroll.last && "down" != window.Zero.scroll.direction.dir && (window.Zero.scroll.direction.dir = "down"), window.Zero.scroll.current < window.Zero.scroll.last && "up" != window.Zero.scroll.direction.dir && (window.Zero.scroll.direction.dir = "up"), window.Zero.scroll.last = window.Zero.scroll.current) : window.Zero.scroll.direction.dir = "idle" : window.Zero.scroll.last = window.Zero.scroll.current
        }.bind(void 0)), window.addEventListener("popstate", function () {
            window.Zero.events.history.forEach((function (t) {
                return t.dispatchEvent(window.Zero.dispatches.history)
            }))
        }.bind(void 0)), window.Zero = window.Zero || {}, window.Zero.scroll = window.Zero.scroll || {}, window.Zero.scroll.direction = window.Zero.scroll.direction || {}, window.Zero.lazyLoad = new (ks())({
            threshold: 600,
            callback_enter: function (t) { }
        }), window.Zero.a11y = new c, window.Zero.animation = new Yn({
            threshold: .3
        }), window.Zero.components = new dc, window.Zero.events = {}, window.Zero.isMobile = function (t) {
            var e = {
                userAgent: "",
                platform: "",
                maxTouchPoints: 0
            };
            t || "undefined" == typeof navigator ? "string" == typeof t ? e.userAgent = t : t && t.userAgent && (e = {
                userAgent: t.userAgent,
                platform: t.platform,
                maxTouchPoints: t.maxTouchPoints || 0
            }) : e = {
                userAgent: navigator.userAgent,
                platform: navigator.platform,
                maxTouchPoints: navigator.maxTouchPoints || 0
            };
            var i = e.userAgent,
                r = i.split("[FBAN");
            void 0 !== r[1] && (i = r[0]), void 0 !== (r = i.split("Twitter"))[1] && (i = r[0]);
            var n = function (t) {
                return function (e) {
                    return e.test(t)
                }
            }(i),
                a = {
                    apple: {
                        phone: n(pc) && !n(wc),
                        ipod: n(fc),
                        tablet: !n(pc) && (n(mc) || Mc(e)) && !n(wc),
                        universal: n(gc),
                        device: (n(pc) || n(fc) || n(mc) || n(gc) || Mc(e)) && !n(wc)
                    },
                    amazon: {
                        phone: n(bc),
                        tablet: !n(bc) && n(_c),
                        device: n(bc) || n(_c)
                    },
                    android: {
                        phone: !n(wc) && n(bc) || !n(wc) && n(vc),
                        tablet: !n(wc) && !n(bc) && !n(vc) && (n(_c) || n(yc)),
                        device: !n(wc) && (n(bc) || n(_c) || n(vc) || n(yc)) || n(/\bokhttp\b/i)
                    },
                    windows: {
                        phone: n(wc),
                        tablet: n(Ac),
                        device: n(wc) || n(Ac)
                    },
                    other: {
                        blackberry: n(Sc),
                        blackberry10: n(kc),
                        opera: n(xc),
                        firefox: n(Ec),
                        chrome: n(Tc),
                        device: n(Sc) || n(kc) || n(xc) || n(Ec) || n(Tc)
                    },
                    any: !1,
                    phone: !1,
                    tablet: !1
                };
            return a.any = a.apple.device || a.android.device || a.windows.device || a.other.device, a.phone = a.apple.phone || a.android.phone || a.windows.phone, a.tablet = a.apple.tablet || a.android.tablet || a.windows.tablet, a
        }(window.navigator).any, window.Zero.reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches
    })()
})();
